var VE = Object.defineProperty;
var GE = (t, e, r) => e in t ? VE(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var st = (t, e, r) => GE(t, typeof e != "symbol" ? e + "" : e, r);
var Ba = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : {};
function f0(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function m0(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function s() {
      return this instanceof s ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(s) {
    var n = Object.getOwnPropertyDescriptor(t, s);
    Object.defineProperty(r, s, n.get ? n : {
      enumerable: !0,
      get: function() {
        return t[s];
      }
    });
  }), r;
}
var Nd = { exports: {} }, ri = typeof Reflect == "object" ? Reflect : null, Gp = ri && typeof ri.apply == "function" ? ri.apply : function(e, r, s) {
  return Function.prototype.apply.call(e, r, s);
}, Bc;
ri && typeof ri.ownKeys == "function" ? Bc = ri.ownKeys : Object.getOwnPropertySymbols ? Bc = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Bc = function(e) {
  return Object.getOwnPropertyNames(e);
};
function WE(t) {
  console && console.warn && console.warn(t);
}
var b0 = Number.isNaN || function(e) {
  return e !== e;
};
function Se() {
  Se.init.call(this);
}
Nd.exports = Se;
Nd.exports.once = YE;
Se.EventEmitter = Se;
Se.prototype._events = void 0;
Se.prototype._eventsCount = 0;
Se.prototype._maxListeners = void 0;
var Wp = 10;
function bl(t) {
  if (typeof t != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
}
Object.defineProperty(Se, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return Wp;
  },
  set: function(t) {
    if (typeof t != "number" || t < 0 || b0(t))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
    Wp = t;
  }
});
Se.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
Se.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || b0(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function y0(t) {
  return t._maxListeners === void 0 ? Se.defaultMaxListeners : t._maxListeners;
}
Se.prototype.getMaxListeners = function() {
  return y0(this);
};
Se.prototype.emit = function(e) {
  for (var r = [], s = 1; s < arguments.length; s++) r.push(arguments[s]);
  var n = e === "error", i = this._events;
  if (i !== void 0)
    n = n && i.error === void 0;
  else if (!n)
    return !1;
  if (n) {
    var o;
    if (r.length > 0 && (o = r[0]), o instanceof Error)
      throw o;
    var a = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
    throw a.context = o, a;
  }
  var c = i[e];
  if (c === void 0)
    return !1;
  if (typeof c == "function")
    Gp(c, this, r);
  else
    for (var l = c.length, u = v0(c, l), s = 0; s < l; ++s)
      Gp(u[s], this, r);
  return !0;
};
function g0(t, e, r, s) {
  var n, i, o;
  if (bl(r), i = t._events, i === void 0 ? (i = t._events = /* @__PURE__ */ Object.create(null), t._eventsCount = 0) : (i.newListener !== void 0 && (t.emit(
    "newListener",
    e,
    r.listener ? r.listener : r
  ), i = t._events), o = i[e]), o === void 0)
    o = i[e] = r, ++t._eventsCount;
  else if (typeof o == "function" ? o = i[e] = s ? [r, o] : [o, r] : s ? o.unshift(r) : o.push(r), n = y0(t), n > 0 && o.length > n && !o.warned) {
    o.warned = !0;
    var a = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    a.name = "MaxListenersExceededWarning", a.emitter = t, a.type = e, a.count = o.length, WE(a);
  }
  return t;
}
Se.prototype.addListener = function(e, r) {
  return g0(this, e, r, !1);
};
Se.prototype.on = Se.prototype.addListener;
Se.prototype.prependListener = function(e, r) {
  return g0(this, e, r, !0);
};
function ZE() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function w0(t, e, r) {
  var s = { fired: !1, wrapFn: void 0, target: t, type: e, listener: r }, n = ZE.bind(s);
  return n.listener = r, s.wrapFn = n, n;
}
Se.prototype.once = function(e, r) {
  return bl(r), this.on(e, w0(this, e, r)), this;
};
Se.prototype.prependOnceListener = function(e, r) {
  return bl(r), this.prependListener(e, w0(this, e, r)), this;
};
Se.prototype.removeListener = function(e, r) {
  var s, n, i, o, a;
  if (bl(r), n = this._events, n === void 0)
    return this;
  if (s = n[e], s === void 0)
    return this;
  if (s === r || s.listener === r)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete n[e], n.removeListener && this.emit("removeListener", e, s.listener || r));
  else if (typeof s != "function") {
    for (i = -1, o = s.length - 1; o >= 0; o--)
      if (s[o] === r || s[o].listener === r) {
        a = s[o].listener, i = o;
        break;
      }
    if (i < 0)
      return this;
    i === 0 ? s.shift() : JE(s, i), s.length === 1 && (n[e] = s[0]), n.removeListener !== void 0 && this.emit("removeListener", e, a || r);
  }
  return this;
};
Se.prototype.off = Se.prototype.removeListener;
Se.prototype.removeAllListeners = function(e) {
  var r, s, n;
  if (s = this._events, s === void 0)
    return this;
  if (s.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : s[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete s[e]), this;
  if (arguments.length === 0) {
    var i = Object.keys(s), o;
    for (n = 0; n < i.length; ++n)
      o = i[n], o !== "removeListener" && this.removeAllListeners(o);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (r = s[e], typeof r == "function")
    this.removeListener(e, r);
  else if (r !== void 0)
    for (n = r.length - 1; n >= 0; n--)
      this.removeListener(e, r[n]);
  return this;
};
function E0(t, e, r) {
  var s = t._events;
  if (s === void 0)
    return [];
  var n = s[e];
  return n === void 0 ? [] : typeof n == "function" ? r ? [n.listener || n] : [n] : r ? XE(n) : v0(n, n.length);
}
Se.prototype.listeners = function(e) {
  return E0(this, e, !0);
};
Se.prototype.rawListeners = function(e) {
  return E0(this, e, !1);
};
Se.listenerCount = function(t, e) {
  return typeof t.listenerCount == "function" ? t.listenerCount(e) : x0.call(t, e);
};
Se.prototype.listenerCount = x0;
function x0(t) {
  var e = this._events;
  if (e !== void 0) {
    var r = e[t];
    if (typeof r == "function")
      return 1;
    if (r !== void 0)
      return r.length;
  }
  return 0;
}
Se.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Bc(this._events) : [];
};
function v0(t, e) {
  for (var r = new Array(e), s = 0; s < e; ++s)
    r[s] = t[s];
  return r;
}
function JE(t, e) {
  for (; e + 1 < t.length; e++)
    t[e] = t[e + 1];
  t.pop();
}
function XE(t) {
  for (var e = new Array(t.length), r = 0; r < e.length; ++r)
    e[r] = t[r].listener || t[r];
  return e;
}
function YE(t, e) {
  return new Promise(function(r, s) {
    function n(o) {
      t.removeListener(e, i), s(o);
    }
    function i() {
      typeof t.removeListener == "function" && t.removeListener("error", n), r([].slice.call(arguments));
    }
    k0(t, e, i, { once: !0 }), e !== "error" && QE(t, n, { once: !0 });
  });
}
function QE(t, e, r) {
  typeof t.on == "function" && k0(t, "error", e, r);
}
function k0(t, e, r, s) {
  if (typeof t.on == "function")
    s.once ? t.once(e, r) : t.on(e, r);
  else if (typeof t.addEventListener == "function")
    t.addEventListener(e, function n(i) {
      s.once && t.removeEventListener(e, n), r(i);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof t);
}
var dt = Nd.exports;
const Ld = /* @__PURE__ */ f0(dt);
var V = {};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var uh = function(t, e) {
  return uh = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, s) {
    r.__proto__ = s;
  } || function(r, s) {
    for (var n in s) s.hasOwnProperty(n) && (r[n] = s[n]);
  }, uh(t, e);
};
function ex(t, e) {
  uh(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var hh = function() {
  return hh = Object.assign || function(e) {
    for (var r, s = 1, n = arguments.length; s < n; s++) {
      r = arguments[s];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, hh.apply(this, arguments);
};
function tx(t, e) {
  var r = {};
  for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && e.indexOf(s) < 0 && (r[s] = t[s]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, s = Object.getOwnPropertySymbols(t); n < s.length; n++)
      e.indexOf(s[n]) < 0 && Object.prototype.propertyIsEnumerable.call(t, s[n]) && (r[s[n]] = t[s[n]]);
  return r;
}
function rx(t, e, r, s) {
  var n = arguments.length, i = n < 3 ? e : s === null ? s = Object.getOwnPropertyDescriptor(e, r) : s, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(t, e, r, s);
  else for (var a = t.length - 1; a >= 0; a--) (o = t[a]) && (i = (n < 3 ? o(i) : n > 3 ? o(e, r, i) : o(e, r)) || i);
  return n > 3 && i && Object.defineProperty(e, r, i), i;
}
function sx(t, e) {
  return function(r, s) {
    e(r, s, t);
  };
}
function nx(t, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(t, e);
}
function ix(t, e, r, s) {
  function n(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function a(u) {
      try {
        l(s.next(u));
      } catch (h) {
        o(h);
      }
    }
    function c(u) {
      try {
        l(s.throw(u));
      } catch (h) {
        o(h);
      }
    }
    function l(u) {
      u.done ? i(u.value) : n(u.value).then(a, c);
    }
    l((s = s.apply(t, e || [])).next());
  });
}
function ox(t, e) {
  var r = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, s, n, i, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (s) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (s = 1, n && (i = l[0] & 2 ? n.return : l[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, l[1])).done) return i;
      switch (n = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return r.label++, { value: l[1], done: !1 };
        case 5:
          r.label++, n = l[1], l = [0];
          continue;
        case 7:
          l = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (i = r.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            r = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            r.label = l[1];
            break;
          }
          if (l[0] === 6 && r.label < i[1]) {
            r.label = i[1], i = l;
            break;
          }
          if (i && r.label < i[2]) {
            r.label = i[2], r.ops.push(l);
            break;
          }
          i[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      l = e.call(t, r);
    } catch (u) {
      l = [6, u], n = 0;
    } finally {
      s = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function ax(t, e, r, s) {
  s === void 0 && (s = r), t[s] = e[r];
}
function cx(t, e) {
  for (var r in t) r !== "default" && !e.hasOwnProperty(r) && (e[r] = t[r]);
}
function dh(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], s = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && s >= t.length && (t = void 0), { value: t && t[s++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function C0(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var s = r.call(t), n, i = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(n = s.next()).done; ) i.push(n.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      n && !n.done && (r = s.return) && r.call(s);
    } finally {
      if (o) throw o.error;
    }
  }
  return i;
}
function lx() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t = t.concat(C0(arguments[e]));
  return t;
}
function ux() {
  for (var t = 0, e = 0, r = arguments.length; e < r; e++) t += arguments[e].length;
  for (var s = Array(t), n = 0, e = 0; e < r; e++)
    for (var i = arguments[e], o = 0, a = i.length; o < a; o++, n++)
      s[n] = i[o];
  return s;
}
function Ko(t) {
  return this instanceof Ko ? (this.v = t, this) : new Ko(t);
}
function hx(t, e, r) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var s = r.apply(t, e || []), n, i = [];
  return n = {}, o("next"), o("throw"), o("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n;
  function o(p) {
    s[p] && (n[p] = function(y) {
      return new Promise(function(b, g) {
        i.push([p, y, b, g]) > 1 || a(p, y);
      });
    });
  }
  function a(p, y) {
    try {
      c(s[p](y));
    } catch (b) {
      h(i[0][3], b);
    }
  }
  function c(p) {
    p.value instanceof Ko ? Promise.resolve(p.value.v).then(l, u) : h(i[0][2], p);
  }
  function l(p) {
    a("next", p);
  }
  function u(p) {
    a("throw", p);
  }
  function h(p, y) {
    p(y), i.shift(), i.length && a(i[0][0], i[0][1]);
  }
}
function dx(t) {
  var e, r;
  return e = {}, s("next"), s("throw", function(n) {
    throw n;
  }), s("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function s(n, i) {
    e[n] = t[n] ? function(o) {
      return (r = !r) ? { value: Ko(t[n](o)), done: n === "return" } : i ? i(o) : o;
    } : i;
  }
}
function px(t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], r;
  return e ? e.call(t) : (t = typeof dh == "function" ? dh(t) : t[Symbol.iterator](), r = {}, s("next"), s("throw"), s("return"), r[Symbol.asyncIterator] = function() {
    return this;
  }, r);
  function s(i) {
    r[i] = t[i] && function(o) {
      return new Promise(function(a, c) {
        o = t[i](o), n(a, c, o.done, o.value);
      });
    };
  }
  function n(i, o, a, c) {
    Promise.resolve(c).then(function(l) {
      i({ value: l, done: a });
    }, o);
  }
}
function fx(t, e) {
  return Object.defineProperty ? Object.defineProperty(t, "raw", { value: e }) : t.raw = e, t;
}
function mx(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (t != null)
    for (var r in t) Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  return e.default = t, e;
}
function bx(t) {
  return t && t.__esModule ? t : { default: t };
}
function yx(t, e) {
  if (!e.has(t))
    throw new TypeError("attempted to get private field on non-instance");
  return e.get(t);
}
function gx(t, e, r) {
  if (!e.has(t))
    throw new TypeError("attempted to set private field on non-instance");
  return e.set(t, r), r;
}
const wx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get __assign() {
    return hh;
  },
  __asyncDelegator: dx,
  __asyncGenerator: hx,
  __asyncValues: px,
  __await: Ko,
  __awaiter: ix,
  __classPrivateFieldGet: yx,
  __classPrivateFieldSet: gx,
  __createBinding: ax,
  __decorate: rx,
  __exportStar: cx,
  __extends: ex,
  __generator: ox,
  __importDefault: bx,
  __importStar: mx,
  __makeTemplateObject: fx,
  __metadata: nx,
  __param: sx,
  __read: C0,
  __rest: tx,
  __spread: lx,
  __spreadArrays: ux,
  __values: dh
}, Symbol.toStringTag, { value: "Module" })), oa = /* @__PURE__ */ m0(wx);
var Zl = {}, Oi = {}, Zp;
function Ex() {
  if (Zp) return Oi;
  Zp = 1, Object.defineProperty(Oi, "__esModule", { value: !0 }), Oi.delay = void 0;
  function t(e) {
    return new Promise((r) => {
      setTimeout(() => {
        r(!0);
      }, e);
    });
  }
  return Oi.delay = t, Oi;
}
var dn = {}, Jl = {}, pn = {}, Jp;
function xx() {
  return Jp || (Jp = 1, Object.defineProperty(pn, "__esModule", { value: !0 }), pn.ONE_THOUSAND = pn.ONE_HUNDRED = void 0, pn.ONE_HUNDRED = 100, pn.ONE_THOUSAND = 1e3), pn;
}
var Xl = {}, Xp;
function vx() {
  return Xp || (Xp = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.ONE_YEAR = t.FOUR_WEEKS = t.THREE_WEEKS = t.TWO_WEEKS = t.ONE_WEEK = t.THIRTY_DAYS = t.SEVEN_DAYS = t.FIVE_DAYS = t.THREE_DAYS = t.ONE_DAY = t.TWENTY_FOUR_HOURS = t.TWELVE_HOURS = t.SIX_HOURS = t.THREE_HOURS = t.ONE_HOUR = t.SIXTY_MINUTES = t.THIRTY_MINUTES = t.TEN_MINUTES = t.FIVE_MINUTES = t.ONE_MINUTE = t.SIXTY_SECONDS = t.THIRTY_SECONDS = t.TEN_SECONDS = t.FIVE_SECONDS = t.ONE_SECOND = void 0, t.ONE_SECOND = 1, t.FIVE_SECONDS = 5, t.TEN_SECONDS = 10, t.THIRTY_SECONDS = 30, t.SIXTY_SECONDS = 60, t.ONE_MINUTE = t.SIXTY_SECONDS, t.FIVE_MINUTES = t.ONE_MINUTE * 5, t.TEN_MINUTES = t.ONE_MINUTE * 10, t.THIRTY_MINUTES = t.ONE_MINUTE * 30, t.SIXTY_MINUTES = t.ONE_MINUTE * 60, t.ONE_HOUR = t.SIXTY_MINUTES, t.THREE_HOURS = t.ONE_HOUR * 3, t.SIX_HOURS = t.ONE_HOUR * 6, t.TWELVE_HOURS = t.ONE_HOUR * 12, t.TWENTY_FOUR_HOURS = t.ONE_HOUR * 24, t.ONE_DAY = t.TWENTY_FOUR_HOURS, t.THREE_DAYS = t.ONE_DAY * 3, t.FIVE_DAYS = t.ONE_DAY * 5, t.SEVEN_DAYS = t.ONE_DAY * 7, t.THIRTY_DAYS = t.ONE_DAY * 30, t.ONE_WEEK = t.SEVEN_DAYS, t.TWO_WEEKS = t.ONE_WEEK * 2, t.THREE_WEEKS = t.ONE_WEEK * 3, t.FOUR_WEEKS = t.ONE_WEEK * 4, t.ONE_YEAR = t.ONE_DAY * 365;
  }(Xl)), Xl;
}
var Yp;
function S0() {
  return Yp || (Yp = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    const e = oa;
    e.__exportStar(xx(), t), e.__exportStar(vx(), t);
  }(Jl)), Jl;
}
var Qp;
function kx() {
  if (Qp) return dn;
  Qp = 1, Object.defineProperty(dn, "__esModule", { value: !0 }), dn.fromMiliseconds = dn.toMiliseconds = void 0;
  const t = S0();
  function e(s) {
    return s * t.ONE_THOUSAND;
  }
  dn.toMiliseconds = e;
  function r(s) {
    return Math.floor(s / t.ONE_THOUSAND);
  }
  return dn.fromMiliseconds = r, dn;
}
var ef;
function Cx() {
  return ef || (ef = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    const e = oa;
    e.__exportStar(Ex(), t), e.__exportStar(kx(), t);
  }(Zl)), Zl;
}
var Mn = {}, tf;
function Sx() {
  if (tf) return Mn;
  tf = 1, Object.defineProperty(Mn, "__esModule", { value: !0 }), Mn.Watch = void 0;
  class t {
    constructor() {
      this.timestamps = /* @__PURE__ */ new Map();
    }
    start(r) {
      if (this.timestamps.has(r))
        throw new Error(`Watch already started for label: ${r}`);
      this.timestamps.set(r, { started: Date.now() });
    }
    stop(r) {
      const s = this.get(r);
      if (typeof s.elapsed < "u")
        throw new Error(`Watch already stopped for label: ${r}`);
      const n = Date.now() - s.started;
      this.timestamps.set(r, { started: s.started, elapsed: n });
    }
    get(r) {
      const s = this.timestamps.get(r);
      if (typeof s > "u")
        throw new Error(`No timestamp found for label: ${r}`);
      return s;
    }
    elapsed(r) {
      const s = this.get(r);
      return s.elapsed || Date.now() - s.started;
    }
  }
  return Mn.Watch = t, Mn.default = t, Mn;
}
var Yl = {}, Pi = {}, rf;
function Ix() {
  if (rf) return Pi;
  rf = 1, Object.defineProperty(Pi, "__esModule", { value: !0 }), Pi.IWatch = void 0;
  class t {
  }
  return Pi.IWatch = t, Pi;
}
var sf;
function Ax() {
  return sf || (sf = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), oa.__exportStar(Ix(), t);
  }(Yl)), Yl;
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  const e = oa;
  e.__exportStar(Cx(), t), e.__exportStar(Sx(), t), e.__exportStar(Ax(), t), e.__exportStar(S0(), t);
})(V);
class nr {
}
let _x = class extends nr {
  constructor(e) {
    super();
  }
};
const nf = V.FIVE_SECONDS, ir = { pulse: "heartbeat_pulse" };
let I0 = class A0 extends _x {
  constructor(e) {
    super(e), this.events = new dt.EventEmitter(), this.interval = nf, this.interval = (e == null ? void 0 : e.interval) || nf;
  }
  static async init(e) {
    const r = new A0(e);
    return await r.init(), r;
  }
  async init() {
    await this.initialize();
  }
  stop() {
    clearInterval(this.intervalRef);
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  async initialize() {
    this.intervalRef = setInterval(() => this.pulse(), V.toMiliseconds(this.interval));
  }
  pulse() {
    this.events.emit(ir.pulse);
  }
};
const Tx = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/, Ux = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/, $x = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function Bx(t, e) {
  if (t === "__proto__" || t === "constructor" && e && typeof e == "object" && "prototype" in e) {
    Dx(t);
    return;
  }
  return e;
}
function Dx(t) {
  console.warn(`[destr] Dropping "${t}" key to prevent prototype pollution.`);
}
function Da(t, e = {}) {
  if (typeof t != "string")
    return t;
  if (t[0] === '"' && t[t.length - 1] === '"' && t.indexOf("\\") === -1)
    return t.slice(1, -1);
  const r = t.trim();
  if (r.length <= 9)
    switch (r.toLowerCase()) {
      case "true":
        return !0;
      case "false":
        return !1;
      case "undefined":
        return;
      case "null":
        return null;
      case "nan":
        return Number.NaN;
      case "infinity":
        return Number.POSITIVE_INFINITY;
      case "-infinity":
        return Number.NEGATIVE_INFINITY;
    }
  if (!$x.test(t)) {
    if (e.strict)
      throw new SyntaxError("[destr] Invalid JSON");
    return t;
  }
  try {
    if (Tx.test(t) || Ux.test(t)) {
      if (e.strict)
        throw new Error("[destr] Possible prototype pollution");
      return JSON.parse(t, Bx);
    }
    return JSON.parse(t);
  } catch (s) {
    if (e.strict)
      throw s;
    return t;
  }
}
function Ox(t) {
  return !t || typeof t.then != "function" ? Promise.resolve(t) : t;
}
function et(t, ...e) {
  try {
    return Ox(t(...e));
  } catch (r) {
    return Promise.reject(r);
  }
}
function Px(t) {
  const e = typeof t;
  return t === null || e !== "object" && e !== "function";
}
function Rx(t) {
  const e = Object.getPrototypeOf(t);
  return !e || e.isPrototypeOf(Object);
}
function Dc(t) {
  if (Px(t))
    return String(t);
  if (Rx(t) || Array.isArray(t))
    return JSON.stringify(t);
  if (typeof t.toJSON == "function")
    return Dc(t.toJSON());
  throw new Error("[unstorage] Cannot stringify value!");
}
const ph = "base64:";
function Nx(t) {
  return typeof t == "string" ? t : ph + Fx(t);
}
function Lx(t) {
  return typeof t != "string" || !t.startsWith(ph) ? t : Mx(t.slice(ph.length));
}
function Mx(t) {
  return globalThis.Buffer ? Buffer.from(t, "base64") : Uint8Array.from(
    globalThis.atob(t),
    (e) => e.codePointAt(0)
  );
}
function Fx(t) {
  return globalThis.Buffer ? Buffer.from(t).toString("base64") : globalThis.btoa(String.fromCodePoint(...t));
}
function Lt(t) {
  var e;
  return t && ((e = t.split("?")[0]) == null ? void 0 : e.replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "")) || "";
}
function zx(...t) {
  return Lt(t.join(":"));
}
function Oa(t) {
  return t = Lt(t), t ? t + ":" : "";
}
function jx(t, e) {
  if (e === void 0)
    return !0;
  let r = 0, s = t.indexOf(":");
  for (; s > -1; )
    r++, s = t.indexOf(":", s + 1);
  return r <= e;
}
function Hx(t, e) {
  return e ? t.startsWith(e) && t[t.length - 1] !== "$" : t[t.length - 1] !== "$";
}
const qx = "memory", Kx = () => {
  const t = /* @__PURE__ */ new Map();
  return {
    name: qx,
    getInstance: () => t,
    hasItem(e) {
      return t.has(e);
    },
    getItem(e) {
      return t.get(e) ?? null;
    },
    getItemRaw(e) {
      return t.get(e) ?? null;
    },
    setItem(e, r) {
      t.set(e, r);
    },
    setItemRaw(e, r) {
      t.set(e, r);
    },
    removeItem(e) {
      t.delete(e);
    },
    getKeys() {
      return [...t.keys()];
    },
    clear() {
      t.clear();
    },
    dispose() {
      t.clear();
    }
  };
};
function Vx(t = {}) {
  const e = {
    mounts: { "": t.driver || Kx() },
    mountpoints: [""],
    watching: !1,
    watchListeners: [],
    unwatch: {}
  }, r = (l) => {
    for (const u of e.mountpoints)
      if (l.startsWith(u))
        return {
          base: u,
          relativeKey: l.slice(u.length),
          driver: e.mounts[u]
        };
    return {
      base: "",
      relativeKey: l,
      driver: e.mounts[""]
    };
  }, s = (l, u) => e.mountpoints.filter(
    (h) => h.startsWith(l) || u && l.startsWith(h)
  ).map((h) => ({
    relativeBase: l.length > h.length ? l.slice(h.length) : void 0,
    mountpoint: h,
    driver: e.mounts[h]
  })), n = (l, u) => {
    if (e.watching) {
      u = Lt(u);
      for (const h of e.watchListeners)
        h(l, u);
    }
  }, i = async () => {
    if (!e.watching) {
      e.watching = !0;
      for (const l in e.mounts)
        e.unwatch[l] = await of(
          e.mounts[l],
          n,
          l
        );
    }
  }, o = async () => {
    if (e.watching) {
      for (const l in e.unwatch)
        await e.unwatch[l]();
      e.unwatch = {}, e.watching = !1;
    }
  }, a = (l, u, h) => {
    const p = /* @__PURE__ */ new Map(), y = (b) => {
      let g = p.get(b.base);
      return g || (g = {
        driver: b.driver,
        base: b.base,
        items: []
      }, p.set(b.base, g)), g;
    };
    for (const b of l) {
      const g = typeof b == "string", x = Lt(g ? b : b.key), I = g ? void 0 : b.value, U = g || !b.options ? u : { ...u, ...b.options }, A = r(x);
      y(A).items.push({
        key: x,
        value: I,
        relativeKey: A.relativeKey,
        options: U
      });
    }
    return Promise.all([...p.values()].map((b) => h(b))).then(
      (b) => b.flat()
    );
  }, c = {
    // Item
    hasItem(l, u = {}) {
      l = Lt(l);
      const { relativeKey: h, driver: p } = r(l);
      return et(p.hasItem, h, u);
    },
    getItem(l, u = {}) {
      l = Lt(l);
      const { relativeKey: h, driver: p } = r(l);
      return et(p.getItem, h, u).then(
        (y) => Da(y)
      );
    },
    getItems(l, u = {}) {
      return a(l, u, (h) => h.driver.getItems ? et(
        h.driver.getItems,
        h.items.map((p) => ({
          key: p.relativeKey,
          options: p.options
        })),
        u
      ).then(
        (p) => p.map((y) => ({
          key: zx(h.base, y.key),
          value: Da(y.value)
        }))
      ) : Promise.all(
        h.items.map((p) => et(
          h.driver.getItem,
          p.relativeKey,
          p.options
        ).then((y) => ({
          key: p.key,
          value: Da(y)
        })))
      ));
    },
    getItemRaw(l, u = {}) {
      l = Lt(l);
      const { relativeKey: h, driver: p } = r(l);
      return p.getItemRaw ? et(p.getItemRaw, h, u) : et(p.getItem, h, u).then(
        (y) => Lx(y)
      );
    },
    async setItem(l, u, h = {}) {
      if (u === void 0)
        return c.removeItem(l);
      l = Lt(l);
      const { relativeKey: p, driver: y } = r(l);
      y.setItem && (await et(y.setItem, p, Dc(u), h), y.watch || n("update", l));
    },
    async setItems(l, u) {
      await a(l, u, async (h) => {
        if (h.driver.setItems)
          return et(
            h.driver.setItems,
            h.items.map((p) => ({
              key: p.relativeKey,
              value: Dc(p.value),
              options: p.options
            })),
            u
          );
        h.driver.setItem && await Promise.all(
          h.items.map((p) => et(
            h.driver.setItem,
            p.relativeKey,
            Dc(p.value),
            p.options
          ))
        );
      });
    },
    async setItemRaw(l, u, h = {}) {
      if (u === void 0)
        return c.removeItem(l, h);
      l = Lt(l);
      const { relativeKey: p, driver: y } = r(l);
      if (y.setItemRaw)
        await et(y.setItemRaw, p, u, h);
      else if (y.setItem)
        await et(y.setItem, p, Nx(u), h);
      else
        return;
      y.watch || n("update", l);
    },
    async removeItem(l, u = {}) {
      typeof u == "boolean" && (u = { removeMeta: u }), l = Lt(l);
      const { relativeKey: h, driver: p } = r(l);
      p.removeItem && (await et(p.removeItem, h, u), (u.removeMeta || u.removeMata) && await et(p.removeItem, h + "$", u), p.watch || n("remove", l));
    },
    // Meta
    async getMeta(l, u = {}) {
      typeof u == "boolean" && (u = { nativeOnly: u }), l = Lt(l);
      const { relativeKey: h, driver: p } = r(l), y = /* @__PURE__ */ Object.create(null);
      if (p.getMeta && Object.assign(y, await et(p.getMeta, h, u)), !u.nativeOnly) {
        const b = await et(
          p.getItem,
          h + "$",
          u
        ).then((g) => Da(g));
        b && typeof b == "object" && (typeof b.atime == "string" && (b.atime = new Date(b.atime)), typeof b.mtime == "string" && (b.mtime = new Date(b.mtime)), Object.assign(y, b));
      }
      return y;
    },
    setMeta(l, u, h = {}) {
      return this.setItem(l + "$", u, h);
    },
    removeMeta(l, u = {}) {
      return this.removeItem(l + "$", u);
    },
    // Keys
    async getKeys(l, u = {}) {
      var x;
      l = Oa(l);
      const h = s(l, !0);
      let p = [];
      const y = [];
      let b = !0;
      for (const I of h) {
        (x = I.driver.flags) != null && x.maxDepth || (b = !1);
        const U = await et(
          I.driver.getKeys,
          I.relativeBase,
          u
        );
        for (const A of U) {
          const M = I.mountpoint + Lt(A);
          p.some((B) => M.startsWith(B)) || y.push(M);
        }
        p = [
          I.mountpoint,
          ...p.filter((A) => !A.startsWith(I.mountpoint))
        ];
      }
      const g = u.maxDepth !== void 0 && !b;
      return y.filter(
        (I) => (!g || jx(I, u.maxDepth)) && Hx(I, l)
      );
    },
    // Utils
    async clear(l, u = {}) {
      l = Oa(l), await Promise.all(
        s(l, !1).map(async (h) => {
          if (h.driver.clear)
            return et(h.driver.clear, h.relativeBase, u);
          if (h.driver.removeItem) {
            const p = await h.driver.getKeys(h.relativeBase || "", u);
            return Promise.all(
              p.map((y) => h.driver.removeItem(y, u))
            );
          }
        })
      );
    },
    async dispose() {
      await Promise.all(
        Object.values(e.mounts).map((l) => af(l))
      );
    },
    async watch(l) {
      return await i(), e.watchListeners.push(l), async () => {
        e.watchListeners = e.watchListeners.filter(
          (u) => u !== l
        ), e.watchListeners.length === 0 && await o();
      };
    },
    async unwatch() {
      e.watchListeners = [], await o();
    },
    // Mount
    mount(l, u) {
      if (l = Oa(l), l && e.mounts[l])
        throw new Error(`already mounted at ${l}`);
      return l && (e.mountpoints.push(l), e.mountpoints.sort((h, p) => p.length - h.length)), e.mounts[l] = u, e.watching && Promise.resolve(of(u, n, l)).then((h) => {
        e.unwatch[l] = h;
      }).catch(console.error), c;
    },
    async unmount(l, u = !0) {
      var h, p;
      l = Oa(l), !(!l || !e.mounts[l]) && (e.watching && l in e.unwatch && ((p = (h = e.unwatch)[l]) == null || p.call(h), delete e.unwatch[l]), u && await af(e.mounts[l]), e.mountpoints = e.mountpoints.filter((y) => y !== l), delete e.mounts[l]);
    },
    getMount(l = "") {
      l = Lt(l) + ":";
      const u = r(l);
      return {
        driver: u.driver,
        base: u.base
      };
    },
    getMounts(l = "", u = {}) {
      return l = Lt(l), s(l, u.parents).map((p) => ({
        driver: p.driver,
        base: p.mountpoint
      }));
    },
    // Aliases
    keys: (l, u = {}) => c.getKeys(l, u),
    get: (l, u = {}) => c.getItem(l, u),
    set: (l, u, h = {}) => c.setItem(l, u, h),
    has: (l, u = {}) => c.hasItem(l, u),
    del: (l, u = {}) => c.removeItem(l, u),
    remove: (l, u = {}) => c.removeItem(l, u)
  };
  return c;
}
function of(t, e, r) {
  return t.watch ? t.watch((s, n) => e(s, r + n)) : () => {
  };
}
async function af(t) {
  typeof t.dispose == "function" && await et(t.dispose);
}
function Bn(t) {
  return new Promise((e, r) => {
    t.oncomplete = t.onsuccess = () => e(t.result), t.onabort = t.onerror = () => r(t.error);
  });
}
function _0(t, e) {
  let r;
  const s = () => {
    if (r)
      return r;
    const n = indexedDB.open(t);
    return n.onupgradeneeded = () => n.result.createObjectStore(e), r = Bn(n), r.then((i) => {
      i.onclose = () => r = void 0;
    }, () => {
    }), r;
  };
  return (n, i) => s().then((o) => i(o.transaction(e, n).objectStore(e)));
}
let Ql;
function aa() {
  return Ql || (Ql = _0("keyval-store", "keyval")), Ql;
}
function cf(t, e = aa()) {
  return e("readonly", (r) => Bn(r.get(t)));
}
function Gx(t, e, r = aa()) {
  return r("readwrite", (s) => (s.put(e, t), Bn(s.transaction)));
}
function Wx(t, e = aa()) {
  return e("readwrite", (r) => (r.delete(t), Bn(r.transaction)));
}
function Zx(t = aa()) {
  return t("readwrite", (e) => (e.clear(), Bn(e.transaction)));
}
function Jx(t, e) {
  return t.openCursor().onsuccess = function() {
    this.result && (e(this.result), this.result.continue());
  }, Bn(t.transaction);
}
function Xx(t = aa()) {
  return t("readonly", (e) => {
    if (e.getAllKeys)
      return Bn(e.getAllKeys());
    const r = [];
    return Jx(e, (s) => r.push(s.key)).then(() => r);
  });
}
const Yx = (t) => JSON.stringify(t, (e, r) => typeof r == "bigint" ? r.toString() + "n" : r), Qx = (t) => {
  const e = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g, r = t.replace(e, '$1"$2n"$3');
  return JSON.parse(r, (s, n) => typeof n == "string" && n.match(/^\d+n$/) ? BigInt(n.substring(0, n.length - 1)) : n);
};
function on(t) {
  if (typeof t != "string")
    throw new Error(`Cannot safe json parse value of type ${typeof t}`);
  try {
    return Qx(t);
  } catch {
    return t;
  }
}
function an(t) {
  return typeof t == "string" ? t : Yx(t) || "";
}
const ev = "idb-keyval";
var tv = (t = {}) => {
  const e = t.base && t.base.length > 0 ? `${t.base}:` : "", r = (n) => e + n;
  let s;
  return t.dbName && t.storeName && (s = _0(t.dbName, t.storeName)), { name: ev, options: t, async hasItem(n) {
    return !(typeof await cf(r(n), s) > "u");
  }, async getItem(n) {
    return await cf(r(n), s) ?? null;
  }, setItem(n, i) {
    return Gx(r(n), i, s);
  }, removeItem(n) {
    return Wx(r(n), s);
  }, getKeys() {
    return Xx(s);
  }, clear() {
    return Zx(s);
  } };
};
const rv = "WALLET_CONNECT_V2_INDEXED_DB", sv = "keyvaluestorage";
let nv = class {
  constructor() {
    this.indexedDb = Vx({ driver: tv({ dbName: rv, storeName: sv }) });
  }
  async getKeys() {
    return this.indexedDb.getKeys();
  }
  async getEntries() {
    return (await this.indexedDb.getItems(await this.indexedDb.getKeys())).map((e) => [e.key, e.value]);
  }
  async getItem(e) {
    const r = await this.indexedDb.getItem(e);
    if (r !== null) return r;
  }
  async setItem(e, r) {
    await this.indexedDb.setItem(e, an(r));
  }
  async removeItem(e) {
    await this.indexedDb.removeItem(e);
  }
};
var eu = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : {}, Oc = { exports: {} };
(function() {
  let t;
  function e() {
  }
  t = e, t.prototype.getItem = function(r) {
    return this.hasOwnProperty(r) ? String(this[r]) : null;
  }, t.prototype.setItem = function(r, s) {
    this[r] = String(s);
  }, t.prototype.removeItem = function(r) {
    delete this[r];
  }, t.prototype.clear = function() {
    const r = this;
    Object.keys(r).forEach(function(s) {
      r[s] = void 0, delete r[s];
    });
  }, t.prototype.key = function(r) {
    return r = r || 0, Object.keys(this)[r];
  }, t.prototype.__defineGetter__("length", function() {
    return Object.keys(this).length;
  }), typeof eu < "u" && eu.localStorage ? Oc.exports = eu.localStorage : typeof window < "u" && window.localStorage ? Oc.exports = window.localStorage : Oc.exports = new e();
})();
function iv(t) {
  var e;
  return [t[0], on((e = t[1]) != null ? e : "")];
}
let ov = class {
  constructor() {
    this.localStorage = Oc.exports;
  }
  async getKeys() {
    return Object.keys(this.localStorage);
  }
  async getEntries() {
    return Object.entries(this.localStorage).map(iv);
  }
  async getItem(e) {
    const r = this.localStorage.getItem(e);
    if (r !== null) return on(r);
  }
  async setItem(e, r) {
    this.localStorage.setItem(e, an(r));
  }
  async removeItem(e) {
    this.localStorage.removeItem(e);
  }
};
const av = "wc_storage_version", lf = 1, cv = async (t, e, r) => {
  const s = av, n = await e.getItem(s);
  if (n && n >= lf) {
    r(e);
    return;
  }
  const i = await t.getKeys();
  if (!i.length) {
    r(e);
    return;
  }
  const o = [];
  for (; i.length; ) {
    const a = i.shift();
    if (!a) continue;
    const c = a.toLowerCase();
    if (c.includes("wc@") || c.includes("walletconnect") || c.includes("wc_") || c.includes("wallet_connect")) {
      const l = await t.getItem(a);
      await e.setItem(a, l), o.push(a);
    }
  }
  await e.setItem(s, lf), r(e), lv(t, o);
}, lv = async (t, e) => {
  e.length && e.forEach(async (r) => {
    await t.removeItem(r);
  });
};
let T0 = class {
  constructor() {
    this.initialized = !1, this.setInitialized = (r) => {
      this.storage = r, this.initialized = !0;
    };
    const e = new ov();
    this.storage = e;
    try {
      const r = new nv();
      cv(e, r, this.setInitialized);
    } catch {
      this.initialized = !0;
    }
  }
  async getKeys() {
    return await this.initialize(), this.storage.getKeys();
  }
  async getEntries() {
    return await this.initialize(), this.storage.getEntries();
  }
  async getItem(e) {
    return await this.initialize(), this.storage.getItem(e);
  }
  async setItem(e, r) {
    return await this.initialize(), this.storage.setItem(e, r);
  }
  async removeItem(e) {
    return await this.initialize(), this.storage.removeItem(e);
  }
  async initialize() {
    this.initialized || await new Promise((e) => {
      const r = setInterval(() => {
        this.initialized && (clearInterval(r), e());
      }, 20);
    });
  }
};
function uv(t) {
  try {
    return JSON.stringify(t);
  } catch {
    return '"[Circular]"';
  }
}
var hv = dv;
function dv(t, e, r) {
  var s = r && r.stringify || uv, n = 1;
  if (typeof t == "object" && t !== null) {
    var i = e.length + n;
    if (i === 1) return t;
    var o = new Array(i);
    o[0] = s(t);
    for (var a = 1; a < i; a++)
      o[a] = s(e[a]);
    return o.join(" ");
  }
  if (typeof t != "string")
    return t;
  var c = e.length;
  if (c === 0) return t;
  for (var l = "", u = 1 - n, h = -1, p = t && t.length || 0, y = 0; y < p; ) {
    if (t.charCodeAt(y) === 37 && y + 1 < p) {
      switch (h = h > -1 ? h : 0, t.charCodeAt(y + 1)) {
        case 100:
        // 'd'
        case 102:
          if (u >= c || e[u] == null) break;
          h < y && (l += t.slice(h, y)), l += Number(e[u]), h = y + 2, y++;
          break;
        case 105:
          if (u >= c || e[u] == null) break;
          h < y && (l += t.slice(h, y)), l += Math.floor(Number(e[u])), h = y + 2, y++;
          break;
        case 79:
        // 'O'
        case 111:
        // 'o'
        case 106:
          if (u >= c || e[u] === void 0) break;
          h < y && (l += t.slice(h, y));
          var b = typeof e[u];
          if (b === "string") {
            l += "'" + e[u] + "'", h = y + 2, y++;
            break;
          }
          if (b === "function") {
            l += e[u].name || "<anonymous>", h = y + 2, y++;
            break;
          }
          l += s(e[u]), h = y + 2, y++;
          break;
        case 115:
          if (u >= c)
            break;
          h < y && (l += t.slice(h, y)), l += String(e[u]), h = y + 2, y++;
          break;
        case 37:
          h < y && (l += t.slice(h, y)), l += "%", h = y + 2, y++, u--;
          break;
      }
      ++u;
    }
    ++y;
  }
  return h === -1 ? t : (h < p && (l += t.slice(h)), l);
}
const uf = hv;
var ei = Jr;
const Vo = vv().console || {}, pv = {
  mapHttpRequest: Pa,
  mapHttpResponse: Pa,
  wrapRequestSerializer: tu,
  wrapResponseSerializer: tu,
  wrapErrorSerializer: tu,
  req: Pa,
  res: Pa,
  err: gv
};
function fv(t, e) {
  return Array.isArray(t) ? t.filter(function(s) {
    return s !== "!stdSerializers.err";
  }) : t === !0 ? Object.keys(e) : !1;
}
function Jr(t) {
  t = t || {}, t.browser = t.browser || {};
  const e = t.browser.transmit;
  if (e && typeof e.send != "function")
    throw Error("pino: transmit option must have a send function");
  const r = t.browser.write || Vo;
  t.browser.write && (t.browser.asObject = !0);
  const s = t.serializers || {}, n = fv(t.browser.serialize, s);
  let i = t.browser.serialize;
  Array.isArray(t.browser.serialize) && t.browser.serialize.indexOf("!stdSerializers.err") > -1 && (i = !1);
  const o = ["error", "fatal", "warn", "info", "debug", "trace"];
  typeof r == "function" && (r.error = r.fatal = r.warn = r.info = r.debug = r.trace = r), t.enabled === !1 && (t.level = "silent");
  const a = t.level || "info", c = Object.create(r);
  c.log || (c.log = Go), Object.defineProperty(c, "levelVal", {
    get: u
  }), Object.defineProperty(c, "level", {
    get: h,
    set: p
  });
  const l = {
    transmit: e,
    serialize: n,
    asObject: t.browser.asObject,
    levels: o,
    timestamp: wv(t)
  };
  c.levels = Jr.levels, c.level = a, c.setMaxListeners = c.getMaxListeners = c.emit = c.addListener = c.on = c.prependListener = c.once = c.prependOnceListener = c.removeListener = c.removeAllListeners = c.listeners = c.listenerCount = c.eventNames = c.write = c.flush = Go, c.serializers = s, c._serialize = n, c._stdErrSerialize = i, c.child = y, e && (c._logEvent = fh());
  function u() {
    return this.level === "silent" ? 1 / 0 : this.levels.values[this.level];
  }
  function h() {
    return this._level;
  }
  function p(b) {
    if (b !== "silent" && !this.levels.values[b])
      throw Error("unknown level " + b);
    this._level = b, Fn(l, c, "error", "log"), Fn(l, c, "fatal", "error"), Fn(l, c, "warn", "error"), Fn(l, c, "info", "log"), Fn(l, c, "debug", "log"), Fn(l, c, "trace", "log");
  }
  function y(b, g) {
    if (!b)
      throw new Error("missing bindings for child Pino");
    g = g || {}, n && b.serializers && (g.serializers = b.serializers);
    const x = g.serializers;
    if (n && x) {
      var I = Object.assign({}, s, x), U = t.browser.serialize === !0 ? Object.keys(I) : n;
      delete b.serializers, yl([b], U, I, this._stdErrSerialize);
    }
    function A(M) {
      this._childLevel = (M._childLevel | 0) + 1, this.error = zn(M, b, "error"), this.fatal = zn(M, b, "fatal"), this.warn = zn(M, b, "warn"), this.info = zn(M, b, "info"), this.debug = zn(M, b, "debug"), this.trace = zn(M, b, "trace"), I && (this.serializers = I, this._serialize = U), e && (this._logEvent = fh(
        [].concat(M._logEvent.bindings, b)
      ));
    }
    return A.prototype = this, new A(this);
  }
  return c;
}
Jr.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: "trace",
    20: "debug",
    30: "info",
    40: "warn",
    50: "error",
    60: "fatal"
  }
};
Jr.stdSerializers = pv;
Jr.stdTimeFunctions = Object.assign({}, { nullTime: U0, epochTime: $0, unixTime: Ev, isoTime: xv });
function Fn(t, e, r, s) {
  const n = Object.getPrototypeOf(e);
  e[r] = e.levelVal > e.levels.values[r] ? Go : n[r] ? n[r] : Vo[r] || Vo[s] || Go, mv(t, e, r);
}
function mv(t, e, r) {
  !t.transmit && e[r] === Go || (e[r] = /* @__PURE__ */ function(s) {
    return function() {
      const i = t.timestamp(), o = new Array(arguments.length), a = Object.getPrototypeOf && Object.getPrototypeOf(this) === Vo ? Vo : this;
      for (var c = 0; c < o.length; c++) o[c] = arguments[c];
      if (t.serialize && !t.asObject && yl(o, this._serialize, this.serializers, this._stdErrSerialize), t.asObject ? s.call(a, bv(this, r, o, i)) : s.apply(a, o), t.transmit) {
        const l = t.transmit.level || e.level, u = Jr.levels.values[l], h = Jr.levels.values[r];
        if (h < u) return;
        yv(this, {
          ts: i,
          methodLevel: r,
          methodValue: h,
          transmitValue: Jr.levels.values[t.transmit.level || e.level],
          send: t.transmit.send,
          val: e.levelVal
        }, o);
      }
    };
  }(e[r]));
}
function bv(t, e, r, s) {
  t._serialize && yl(r, t._serialize, t.serializers, t._stdErrSerialize);
  const n = r.slice();
  let i = n[0];
  const o = {};
  s && (o.time = s), o.level = Jr.levels.values[e];
  let a = (t._childLevel | 0) + 1;
  if (a < 1 && (a = 1), i !== null && typeof i == "object") {
    for (; a-- && typeof n[0] == "object"; )
      Object.assign(o, n.shift());
    i = n.length ? uf(n.shift(), n) : void 0;
  } else typeof i == "string" && (i = uf(n.shift(), n));
  return i !== void 0 && (o.msg = i), o;
}
function yl(t, e, r, s) {
  for (const n in t)
    if (s && t[n] instanceof Error)
      t[n] = Jr.stdSerializers.err(t[n]);
    else if (typeof t[n] == "object" && !Array.isArray(t[n]))
      for (const i in t[n])
        e && e.indexOf(i) > -1 && i in r && (t[n][i] = r[i](t[n][i]));
}
function zn(t, e, r) {
  return function() {
    const s = new Array(1 + arguments.length);
    s[0] = e;
    for (var n = 1; n < s.length; n++)
      s[n] = arguments[n - 1];
    return t[r].apply(this, s);
  };
}
function yv(t, e, r) {
  const s = e.send, n = e.ts, i = e.methodLevel, o = e.methodValue, a = e.val, c = t._logEvent.bindings;
  yl(
    r,
    t._serialize || Object.keys(t.serializers),
    t.serializers,
    t._stdErrSerialize === void 0 ? !0 : t._stdErrSerialize
  ), t._logEvent.ts = n, t._logEvent.messages = r.filter(function(l) {
    return c.indexOf(l) === -1;
  }), t._logEvent.level.label = i, t._logEvent.level.value = o, s(i, t._logEvent, a), t._logEvent = fh(c);
}
function fh(t) {
  return {
    ts: 0,
    messages: [],
    bindings: t || [],
    level: { label: "", value: 0 }
  };
}
function gv(t) {
  const e = {
    type: t.constructor.name,
    msg: t.message,
    stack: t.stack
  };
  for (const r in t)
    e[r] === void 0 && (e[r] = t[r]);
  return e;
}
function wv(t) {
  return typeof t.timestamp == "function" ? t.timestamp : t.timestamp === !1 ? U0 : $0;
}
function Pa() {
  return {};
}
function tu(t) {
  return t;
}
function Go() {
}
function U0() {
  return !1;
}
function $0() {
  return Date.now();
}
function Ev() {
  return Math.round(Date.now() / 1e3);
}
function xv() {
  return new Date(Date.now()).toISOString();
}
function vv() {
  function t(e) {
    return typeof e < "u" && e;
  }
  try {
    return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
      get: function() {
        return delete Object.prototype.globalThis, this.globalThis = this;
      },
      configurable: !0
    }), globalThis;
  } catch {
    return t(self) || t(window) || t(this) || {};
  }
}
const ca = /* @__PURE__ */ f0(ei), kv = { level: "info" }, la = "custom_context", Md = 1e3 * 1024;
let Cv = class {
  constructor(e) {
    this.nodeValue = e, this.sizeInBytes = new TextEncoder().encode(this.nodeValue).length, this.next = null;
  }
  get value() {
    return this.nodeValue;
  }
  get size() {
    return this.sizeInBytes;
  }
}, hf = class {
  constructor(e) {
    this.head = null, this.tail = null, this.lengthInNodes = 0, this.maxSizeInBytes = e, this.sizeInBytes = 0;
  }
  append(e) {
    const r = new Cv(e);
    if (r.size > this.maxSizeInBytes) throw new Error(`[LinkedList] Value too big to insert into list: ${e} with size ${r.size}`);
    for (; this.size + r.size > this.maxSizeInBytes; ) this.shift();
    this.head ? (this.tail && (this.tail.next = r), this.tail = r) : (this.head = r, this.tail = r), this.lengthInNodes++, this.sizeInBytes += r.size;
  }
  shift() {
    if (!this.head) return;
    const e = this.head;
    this.head = this.head.next, this.head || (this.tail = null), this.lengthInNodes--, this.sizeInBytes -= e.size;
  }
  toArray() {
    const e = [];
    let r = this.head;
    for (; r !== null; ) e.push(r.value), r = r.next;
    return e;
  }
  get length() {
    return this.lengthInNodes;
  }
  get size() {
    return this.sizeInBytes;
  }
  toOrderedArray() {
    return Array.from(this);
  }
  [Symbol.iterator]() {
    let e = this.head;
    return { next: () => {
      if (!e) return { done: !0, value: null };
      const r = e.value;
      return e = e.next, { done: !1, value: r };
    } };
  }
}, B0 = class {
  constructor(e, r = Md) {
    this.level = e ?? "error", this.levelValue = ei.levels.values[this.level], this.MAX_LOG_SIZE_IN_BYTES = r, this.logs = new hf(this.MAX_LOG_SIZE_IN_BYTES);
  }
  forwardToConsole(e, r) {
    r === ei.levels.values.error ? console.error(e) : r === ei.levels.values.warn ? console.warn(e) : r === ei.levels.values.debug ? console.debug(e) : r === ei.levels.values.trace ? console.trace(e) : console.log(e);
  }
  appendToLogs(e) {
    this.logs.append(an({ timestamp: (/* @__PURE__ */ new Date()).toISOString(), log: e }));
    const r = typeof e == "string" ? JSON.parse(e).level : e.level;
    r >= this.levelValue && this.forwardToConsole(e, r);
  }
  getLogs() {
    return this.logs;
  }
  clearLogs() {
    this.logs = new hf(this.MAX_LOG_SIZE_IN_BYTES);
  }
  getLogArray() {
    return Array.from(this.logs);
  }
  logsToBlob(e) {
    const r = this.getLogArray();
    return r.push(an({ extraMetadata: e })), new Blob(r, { type: "application/json" });
  }
}, Sv = class {
  constructor(e, r = Md) {
    this.baseChunkLogger = new B0(e, r);
  }
  write(e) {
    this.baseChunkLogger.appendToLogs(e);
  }
  getLogs() {
    return this.baseChunkLogger.getLogs();
  }
  clearLogs() {
    this.baseChunkLogger.clearLogs();
  }
  getLogArray() {
    return this.baseChunkLogger.getLogArray();
  }
  logsToBlob(e) {
    return this.baseChunkLogger.logsToBlob(e);
  }
  downloadLogsBlobInBrowser(e) {
    const r = URL.createObjectURL(this.logsToBlob(e)), s = document.createElement("a");
    s.href = r, s.download = `walletconnect-logs-${(/* @__PURE__ */ new Date()).toISOString()}.txt`, document.body.appendChild(s), s.click(), document.body.removeChild(s), URL.revokeObjectURL(r);
  }
}, Iv = class {
  constructor(e, r = Md) {
    this.baseChunkLogger = new B0(e, r);
  }
  write(e) {
    this.baseChunkLogger.appendToLogs(e);
  }
  getLogs() {
    return this.baseChunkLogger.getLogs();
  }
  clearLogs() {
    this.baseChunkLogger.clearLogs();
  }
  getLogArray() {
    return this.baseChunkLogger.getLogArray();
  }
  logsToBlob(e) {
    return this.baseChunkLogger.logsToBlob(e);
  }
};
var Av = Object.defineProperty, _v = Object.defineProperties, Tv = Object.getOwnPropertyDescriptors, df = Object.getOwnPropertySymbols, Uv = Object.prototype.hasOwnProperty, $v = Object.prototype.propertyIsEnumerable, pf = (t, e, r) => e in t ? Av(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Gc = (t, e) => {
  for (var r in e || (e = {})) Uv.call(e, r) && pf(t, r, e[r]);
  if (df) for (var r of df(e)) $v.call(e, r) && pf(t, r, e[r]);
  return t;
}, Wc = (t, e) => _v(t, Tv(e));
function ua(t) {
  return Wc(Gc({}, t), { level: (t == null ? void 0 : t.level) || kv.level });
}
function Bv(t, e = la) {
  return t[e] || "";
}
function Dv(t, e, r = la) {
  return t[r] = e, t;
}
function De(t, e = la) {
  let r = "";
  return typeof t.bindings > "u" ? r = Bv(t, e) : r = t.bindings().context || "", r;
}
function Ov(t, e, r = la) {
  const s = De(t, r);
  return s.trim() ? `${s}/${e}` : e;
}
function ve(t, e, r = la) {
  const s = Ov(t, e, r), n = t.child({ context: s });
  return Dv(n, s, r);
}
function Pv(t) {
  var e, r;
  const s = new Sv((e = t.opts) == null ? void 0 : e.level, t.maxSizeInBytes);
  return { logger: ca(Wc(Gc({}, t.opts), { level: "trace", browser: Wc(Gc({}, (r = t.opts) == null ? void 0 : r.browser), { write: (n) => s.write(n) }) })), chunkLoggerController: s };
}
function Rv(t) {
  var e;
  const r = new Iv((e = t.opts) == null ? void 0 : e.level, t.maxSizeInBytes);
  return { logger: ca(Wc(Gc({}, t.opts), { level: "trace" }), r), chunkLoggerController: r };
}
function D0(t) {
  return typeof t.loggerOverride < "u" && typeof t.loggerOverride != "string" ? { logger: t.loggerOverride, chunkLoggerController: null } : typeof window < "u" ? Pv(t) : Rv(t);
}
var Nv = Object.defineProperty, Lv = (t, e, r) => e in t ? Nv(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ff = (t, e, r) => Lv(t, typeof e != "symbol" ? e + "" : e, r);
let Mv = class extends nr {
  constructor(e) {
    super(), this.opts = e, ff(this, "protocol", "wc"), ff(this, "version", 2);
  }
};
var Fv = Object.defineProperty, zv = (t, e, r) => e in t ? Fv(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, jv = (t, e, r) => zv(t, e + "", r);
let Hv = class extends nr {
  constructor(e, r) {
    super(), this.core = e, this.logger = r, jv(this, "records", /* @__PURE__ */ new Map());
  }
}, qv = class {
  constructor(e, r) {
    this.logger = e, this.core = r;
  }
}, Kv = class extends nr {
  constructor(e, r) {
    super(), this.relayer = e, this.logger = r;
  }
}, Vv = class extends nr {
  constructor(e) {
    super();
  }
}, Gv = class {
  constructor(e, r, s, n) {
    this.core = e, this.logger = r, this.name = s;
  }
}, Wv = class extends nr {
  constructor(e, r) {
    super(), this.relayer = e, this.logger = r;
  }
}, Zv = class extends nr {
  constructor(e, r) {
    super(), this.core = e, this.logger = r;
  }
}, Jv = class {
  constructor(e, r, s) {
    this.core = e, this.logger = r, this.store = s;
  }
}, Xv = class {
  constructor(e, r) {
    this.projectId = e, this.logger = r;
  }
}, Yv = class {
  constructor(e, r, s) {
    this.core = e, this.logger = r, this.telemetryEnabled = s;
  }
};
function Qv(t) {
  return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function O0(t, ...e) {
  if (!Qv(t)) throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(t.length)) throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function mf(t, e = !0) {
  if (t.destroyed) throw new Error("Hash instance has been destroyed");
  if (e && t.finished) throw new Error("Hash#digest() has already been called");
}
function e3(t, e) {
  O0(t);
  const r = e.outputLen;
  if (t.length < r) throw new Error("digestInto() expects output buffer of length at least " + r);
}
const jn = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const ru = (t) => new DataView(t.buffer, t.byteOffset, t.byteLength);
function t3(t) {
  if (typeof t != "string") throw new Error("utf8ToBytes expected string, got " + typeof t);
  return new Uint8Array(new TextEncoder().encode(t));
}
function P0(t) {
  return typeof t == "string" && (t = t3(t)), O0(t), t;
}
let r3 = class {
  clone() {
    return this._cloneInto();
  }
};
function s3(t) {
  const e = (s) => t().update(P0(s)).digest(), r = t();
  return e.outputLen = r.outputLen, e.blockLen = r.blockLen, e.create = () => t(), e;
}
function R0(t = 32) {
  if (jn && typeof jn.getRandomValues == "function") return jn.getRandomValues(new Uint8Array(t));
  if (jn && typeof jn.randomBytes == "function") return jn.randomBytes(t);
  throw new Error("crypto.getRandomValues must be defined");
}
function n3(t, e, r, s) {
  if (typeof t.setBigUint64 == "function") return t.setBigUint64(e, r, s);
  const n = BigInt(32), i = BigInt(4294967295), o = Number(r >> n & i), a = Number(r & i), c = s ? 4 : 0, l = s ? 0 : 4;
  t.setUint32(e + c, o, s), t.setUint32(e + l, a, s);
}
let i3 = class extends r3 {
  constructor(e, r, s, n) {
    super(), this.blockLen = e, this.outputLen = r, this.padOffset = s, this.isLE = n, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = ru(this.buffer);
  }
  update(e) {
    mf(this);
    const { view: r, buffer: s, blockLen: n } = this;
    e = P0(e);
    const i = e.length;
    for (let o = 0; o < i; ) {
      const a = Math.min(n - this.pos, i - o);
      if (a === n) {
        const c = ru(e);
        for (; n <= i - o; o += n) this.process(c, o);
        continue;
      }
      s.set(e.subarray(o, o + a), this.pos), this.pos += a, o += a, this.pos === n && (this.process(r, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    mf(this), e3(e, this), this.finished = !0;
    const { buffer: r, view: s, blockLen: n, isLE: i } = this;
    let { pos: o } = this;
    r[o++] = 128, this.buffer.subarray(o).fill(0), this.padOffset > n - o && (this.process(s, 0), o = 0);
    for (let h = o; h < n; h++) r[h] = 0;
    n3(s, n - 8, BigInt(this.length * 8), i), this.process(s, 0);
    const a = ru(e), c = this.outputLen;
    if (c % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
    const l = c / 4, u = this.get();
    if (l > u.length) throw new Error("_sha2: outputLen bigger than state");
    for (let h = 0; h < l; h++) a.setUint32(4 * h, u[h], i);
  }
  digest() {
    const { buffer: e, outputLen: r } = this;
    this.digestInto(e);
    const s = e.slice(0, r);
    return this.destroy(), s;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: r, buffer: s, length: n, finished: i, destroyed: o, pos: a } = this;
    return e.length = n, e.pos = a, e.finished = i, e.destroyed = o, n % r && e.buffer.set(s), e;
  }
};
const Ra = BigInt(2 ** 32 - 1), mh = BigInt(32);
function N0(t, e = !1) {
  return e ? { h: Number(t & Ra), l: Number(t >> mh & Ra) } : { h: Number(t >> mh & Ra) | 0, l: Number(t & Ra) | 0 };
}
function o3(t, e = !1) {
  let r = new Uint32Array(t.length), s = new Uint32Array(t.length);
  for (let n = 0; n < t.length; n++) {
    const { h: i, l: o } = N0(t[n], e);
    [r[n], s[n]] = [i, o];
  }
  return [r, s];
}
const a3 = (t, e) => BigInt(t >>> 0) << mh | BigInt(e >>> 0), c3 = (t, e, r) => t >>> r, l3 = (t, e, r) => t << 32 - r | e >>> r, u3 = (t, e, r) => t >>> r | e << 32 - r, h3 = (t, e, r) => t << 32 - r | e >>> r, d3 = (t, e, r) => t << 64 - r | e >>> r - 32, p3 = (t, e, r) => t >>> r - 32 | e << 64 - r, f3 = (t, e) => e, m3 = (t, e) => t, b3 = (t, e, r) => t << r | e >>> 32 - r, y3 = (t, e, r) => e << r | t >>> 32 - r, g3 = (t, e, r) => e << r - 32 | t >>> 64 - r, w3 = (t, e, r) => t << r - 32 | e >>> 64 - r;
function E3(t, e, r, s) {
  const n = (e >>> 0) + (s >>> 0);
  return { h: t + r + (n / 2 ** 32 | 0) | 0, l: n | 0 };
}
const x3 = (t, e, r) => (t >>> 0) + (e >>> 0) + (r >>> 0), v3 = (t, e, r, s) => e + r + s + (t / 2 ** 32 | 0) | 0, k3 = (t, e, r, s) => (t >>> 0) + (e >>> 0) + (r >>> 0) + (s >>> 0), C3 = (t, e, r, s, n) => e + r + s + n + (t / 2 ** 32 | 0) | 0, S3 = (t, e, r, s, n) => (t >>> 0) + (e >>> 0) + (r >>> 0) + (s >>> 0) + (n >>> 0), I3 = (t, e, r, s, n, i) => e + r + s + n + i + (t / 2 ** 32 | 0) | 0, le = { fromBig: N0, split: o3, toBig: a3, shrSH: c3, shrSL: l3, rotrSH: u3, rotrSL: h3, rotrBH: d3, rotrBL: p3, rotr32H: f3, rotr32L: m3, rotlSH: b3, rotlSL: y3, rotlBH: g3, rotlBL: w3, add: E3, add3L: x3, add3H: v3, add4L: k3, add4H: C3, add5H: I3, add5L: S3 }, [A3, _3] = le.split(["0x428a2f98d728ae22", "0x7137449123ef65cd", "0xb5c0fbcfec4d3b2f", "0xe9b5dba58189dbbc", "0x3956c25bf348b538", "0x59f111f1b605d019", "0x923f82a4af194f9b", "0xab1c5ed5da6d8118", "0xd807aa98a3030242", "0x12835b0145706fbe", "0x243185be4ee4b28c", "0x550c7dc3d5ffb4e2", "0x72be5d74f27b896f", "0x80deb1fe3b1696b1", "0x9bdc06a725c71235", "0xc19bf174cf692694", "0xe49b69c19ef14ad2", "0xefbe4786384f25e3", "0x0fc19dc68b8cd5b5", "0x240ca1cc77ac9c65", "0x2de92c6f592b0275", "0x4a7484aa6ea6e483", "0x5cb0a9dcbd41fbd4", "0x76f988da831153b5", "0x983e5152ee66dfab", "0xa831c66d2db43210", "0xb00327c898fb213f", "0xbf597fc7beef0ee4", "0xc6e00bf33da88fc2", "0xd5a79147930aa725", "0x06ca6351e003826f", "0x142929670a0e6e70", "0x27b70a8546d22ffc", "0x2e1b21385c26c926", "0x4d2c6dfc5ac42aed", "0x53380d139d95b3df", "0x650a73548baf63de", "0x766a0abb3c77b2a8", "0x81c2c92e47edaee6", "0x92722c851482353b", "0xa2bfe8a14cf10364", "0xa81a664bbc423001", "0xc24b8b70d0f89791", "0xc76c51a30654be30", "0xd192e819d6ef5218", "0xd69906245565a910", "0xf40e35855771202a", "0x106aa07032bbd1b8", "0x19a4c116b8d2d0c8", "0x1e376c085141ab53", "0x2748774cdf8eeb99", "0x34b0bcb5e19b48a8", "0x391c0cb3c5c95a63", "0x4ed8aa4ae3418acb", "0x5b9cca4f7763e373", "0x682e6ff3d6b2b8a3", "0x748f82ee5defb2fc", "0x78a5636f43172f60", "0x84c87814a1f0ab72", "0x8cc702081a6439ec", "0x90befffa23631e28", "0xa4506cebde82bde9", "0xbef9a3f7b2c67915", "0xc67178f2e372532b", "0xca273eceea26619c", "0xd186b8c721c0c207", "0xeada7dd6cde0eb1e", "0xf57d4f7fee6ed178", "0x06f067aa72176fba", "0x0a637dc5a2c898a6", "0x113f9804bef90dae", "0x1b710b35131c471b", "0x28db77f523047d84", "0x32caab7b40c72493", "0x3c9ebe0a15c9bebc", "0x431d67c49c100d4c", "0x4cc5d4becb3e42b6", "0x597f299cfc657e2a", "0x5fcb6fab3ad6faec", "0x6c44198c4a475817"].map((t) => BigInt(t))), As = new Uint32Array(80), _s = new Uint32Array(80);
let T3 = class extends i3 {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  get() {
    const { Ah: e, Al: r, Bh: s, Bl: n, Ch: i, Cl: o, Dh: a, Dl: c, Eh: l, El: u, Fh: h, Fl: p, Gh: y, Gl: b, Hh: g, Hl: x } = this;
    return [e, r, s, n, i, o, a, c, l, u, h, p, y, b, g, x];
  }
  set(e, r, s, n, i, o, a, c, l, u, h, p, y, b, g, x) {
    this.Ah = e | 0, this.Al = r | 0, this.Bh = s | 0, this.Bl = n | 0, this.Ch = i | 0, this.Cl = o | 0, this.Dh = a | 0, this.Dl = c | 0, this.Eh = l | 0, this.El = u | 0, this.Fh = h | 0, this.Fl = p | 0, this.Gh = y | 0, this.Gl = b | 0, this.Hh = g | 0, this.Hl = x | 0;
  }
  process(e, r) {
    for (let A = 0; A < 16; A++, r += 4) As[A] = e.getUint32(r), _s[A] = e.getUint32(r += 4);
    for (let A = 16; A < 80; A++) {
      const M = As[A - 15] | 0, B = _s[A - 15] | 0, q = le.rotrSH(M, B, 1) ^ le.rotrSH(M, B, 8) ^ le.shrSH(M, B, 7), H = le.rotrSL(M, B, 1) ^ le.rotrSL(M, B, 8) ^ le.shrSL(M, B, 7), F = As[A - 2] | 0, w = _s[A - 2] | 0, T = le.rotrSH(F, w, 19) ^ le.rotrBH(F, w, 61) ^ le.shrSH(F, w, 6), k = le.rotrSL(F, w, 19) ^ le.rotrBL(F, w, 61) ^ le.shrSL(F, w, 6), S = le.add4L(H, k, _s[A - 7], _s[A - 16]), O = le.add4H(S, q, T, As[A - 7], As[A - 16]);
      As[A] = O | 0, _s[A] = S | 0;
    }
    let { Ah: s, Al: n, Bh: i, Bl: o, Ch: a, Cl: c, Dh: l, Dl: u, Eh: h, El: p, Fh: y, Fl: b, Gh: g, Gl: x, Hh: I, Hl: U } = this;
    for (let A = 0; A < 80; A++) {
      const M = le.rotrSH(h, p, 14) ^ le.rotrSH(h, p, 18) ^ le.rotrBH(h, p, 41), B = le.rotrSL(h, p, 14) ^ le.rotrSL(h, p, 18) ^ le.rotrBL(h, p, 41), q = h & y ^ ~h & g, H = p & b ^ ~p & x, F = le.add5L(U, B, H, _3[A], _s[A]), w = le.add5H(F, I, M, q, A3[A], As[A]), T = F | 0, k = le.rotrSH(s, n, 28) ^ le.rotrBH(s, n, 34) ^ le.rotrBH(s, n, 39), S = le.rotrSL(s, n, 28) ^ le.rotrBL(s, n, 34) ^ le.rotrBL(s, n, 39), O = s & i ^ s & a ^ i & a, N = n & o ^ n & c ^ o & c;
      I = g | 0, U = x | 0, g = y | 0, x = b | 0, y = h | 0, b = p | 0, { h, l: p } = le.add(l | 0, u | 0, w | 0, T | 0), l = a | 0, u = c | 0, a = i | 0, c = o | 0, i = s | 0, o = n | 0;
      const _ = le.add3L(T, S, N);
      s = le.add3H(_, w, k, O), n = _ | 0;
    }
    ({ h: s, l: n } = le.add(this.Ah | 0, this.Al | 0, s | 0, n | 0)), { h: i, l: o } = le.add(this.Bh | 0, this.Bl | 0, i | 0, o | 0), { h: a, l: c } = le.add(this.Ch | 0, this.Cl | 0, a | 0, c | 0), { h: l, l: u } = le.add(this.Dh | 0, this.Dl | 0, l | 0, u | 0), { h, l: p } = le.add(this.Eh | 0, this.El | 0, h | 0, p | 0), { h: y, l: b } = le.add(this.Fh | 0, this.Fl | 0, y | 0, b | 0), { h: g, l: x } = le.add(this.Gh | 0, this.Gl | 0, g | 0, x | 0), { h: I, l: U } = le.add(this.Hh | 0, this.Hl | 0, I | 0, U | 0), this.set(s, n, i, o, a, c, l, u, h, p, y, b, g, x, I, U);
  }
  roundClean() {
    As.fill(0), _s.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
};
const U3 = s3(() => new T3());
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Fd = BigInt(0), L0 = BigInt(1), $3 = BigInt(2);
function zd(t) {
  return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function jd(t) {
  if (!zd(t)) throw new Error("Uint8Array expected");
}
function su(t, e) {
  if (typeof e != "boolean") throw new Error(t + " boolean expected, got " + e);
}
const B3 = Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function Hd(t) {
  jd(t);
  let e = "";
  for (let r = 0; r < t.length; r++) e += B3[t[r]];
  return e;
}
function M0(t) {
  if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
  return t === "" ? Fd : BigInt("0x" + t);
}
const ts = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function bf(t) {
  if (t >= ts._0 && t <= ts._9) return t - ts._0;
  if (t >= ts.A && t <= ts.F) return t - (ts.A - 10);
  if (t >= ts.a && t <= ts.f) return t - (ts.a - 10);
}
function F0(t) {
  if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
  const e = t.length, r = e / 2;
  if (e % 2) throw new Error("hex string expected, got unpadded hex of length " + e);
  const s = new Uint8Array(r);
  for (let n = 0, i = 0; n < r; n++, i += 2) {
    const o = bf(t.charCodeAt(i)), a = bf(t.charCodeAt(i + 1));
    if (o === void 0 || a === void 0) {
      const c = t[i] + t[i + 1];
      throw new Error('hex string expected, got non-hex character "' + c + '" at index ' + i);
    }
    s[n] = o * 16 + a;
  }
  return s;
}
function D3(t) {
  return M0(Hd(t));
}
function Pc(t) {
  return jd(t), M0(Hd(Uint8Array.from(t).reverse()));
}
function z0(t, e) {
  return F0(t.toString(16).padStart(e * 2, "0"));
}
function bh(t, e) {
  return z0(t, e).reverse();
}
function rs(t, e, r) {
  let s;
  if (typeof e == "string") try {
    s = F0(e);
  } catch (i) {
    throw new Error(t + " must be hex string or Uint8Array, cause: " + i);
  }
  else if (zd(e)) s = Uint8Array.from(e);
  else throw new Error(t + " must be hex string or Uint8Array");
  const n = s.length;
  if (typeof r == "number" && n !== r) throw new Error(t + " of length " + r + " expected, got " + n);
  return s;
}
function yf(...t) {
  let e = 0;
  for (let s = 0; s < t.length; s++) {
    const n = t[s];
    jd(n), e += n.length;
  }
  const r = new Uint8Array(e);
  for (let s = 0, n = 0; s < t.length; s++) {
    const i = t[s];
    r.set(i, n), n += i.length;
  }
  return r;
}
const nu = (t) => typeof t == "bigint" && Fd <= t;
function O3(t, e, r) {
  return nu(t) && nu(e) && nu(r) && e <= t && t < r;
}
function Ri(t, e, r, s) {
  if (!O3(e, r, s)) throw new Error("expected valid " + t + ": " + r + " <= n < " + s + ", got " + e);
}
function P3(t) {
  let e;
  for (e = 0; t > Fd; t >>= L0, e += 1) ;
  return e;
}
const R3 = (t) => ($3 << BigInt(t - 1)) - L0, N3 = { bigint: (t) => typeof t == "bigint", function: (t) => typeof t == "function", boolean: (t) => typeof t == "boolean", string: (t) => typeof t == "string", stringOrUint8Array: (t) => typeof t == "string" || zd(t), isSafeInteger: (t) => Number.isSafeInteger(t), array: (t) => Array.isArray(t), field: (t, e) => e.Fp.isValid(t), hash: (t) => typeof t == "function" && Number.isSafeInteger(t.outputLen) };
function qd(t, e, r = {}) {
  const s = (n, i, o) => {
    const a = N3[i];
    if (typeof a != "function") throw new Error("invalid validator function");
    const c = t[n];
    if (!(o && c === void 0) && !a(c, t)) throw new Error("param " + String(n) + " is invalid. Expected " + i + ", got " + c);
  };
  for (const [n, i] of Object.entries(e)) s(n, i, !1);
  for (const [n, i] of Object.entries(r)) s(n, i, !0);
  return t;
}
function gf(t) {
  const e = /* @__PURE__ */ new WeakMap();
  return (r, ...s) => {
    const n = e.get(r);
    if (n !== void 0) return n;
    const i = t(r, ...s);
    return e.set(r, i), i;
  };
}
const rt = BigInt(0), He = BigInt(1), yn = BigInt(2), L3 = BigInt(3), yh = BigInt(4), wf = BigInt(5), Ef = BigInt(8);
function Je(t, e) {
  const r = t % e;
  return r >= rt ? r : e + r;
}
function M3(t, e, r) {
  if (e < rt) throw new Error("invalid exponent, negatives unsupported");
  if (r <= rt) throw new Error("invalid modulus");
  if (r === He) return rt;
  let s = He;
  for (; e > rt; ) e & He && (s = s * t % r), t = t * t % r, e >>= He;
  return s;
}
function Mr(t, e, r) {
  let s = t;
  for (; e-- > rt; ) s *= s, s %= r;
  return s;
}
function xf(t, e) {
  if (t === rt) throw new Error("invert: expected non-zero number");
  if (e <= rt) throw new Error("invert: expected positive modulus, got " + e);
  let r = Je(t, e), s = e, n = rt, i = He;
  for (; r !== rt; ) {
    const o = s / r, a = s % r, c = n - i * o;
    s = r, r = a, n = i, i = c;
  }
  if (s !== He) throw new Error("invert: does not exist");
  return Je(n, e);
}
function F3(t) {
  const e = (t - He) / yn;
  let r, s, n;
  for (r = t - He, s = 0; r % yn === rt; r /= yn, s++) ;
  for (n = yn; n < t && M3(n, e, t) !== t - He; n++) if (n > 1e3) throw new Error("Cannot find square root: likely non-prime P");
  if (s === 1) {
    const o = (t + He) / yh;
    return function(a, c) {
      const l = a.pow(c, o);
      if (!a.eql(a.sqr(l), c)) throw new Error("Cannot find square root");
      return l;
    };
  }
  const i = (r + He) / yn;
  return function(o, a) {
    if (o.pow(a, e) === o.neg(o.ONE)) throw new Error("Cannot find square root");
    let c = s, l = o.pow(o.mul(o.ONE, n), r), u = o.pow(a, i), h = o.pow(a, r);
    for (; !o.eql(h, o.ONE); ) {
      if (o.eql(h, o.ZERO)) return o.ZERO;
      let p = 1;
      for (let b = o.sqr(h); p < c && !o.eql(b, o.ONE); p++) b = o.sqr(b);
      const y = o.pow(l, He << BigInt(c - p - 1));
      l = o.sqr(y), u = o.mul(u, y), h = o.mul(h, l), c = p;
    }
    return u;
  };
}
function z3(t) {
  if (t % yh === L3) {
    const e = (t + He) / yh;
    return function(r, s) {
      const n = r.pow(s, e);
      if (!r.eql(r.sqr(n), s)) throw new Error("Cannot find square root");
      return n;
    };
  }
  if (t % Ef === wf) {
    const e = (t - wf) / Ef;
    return function(r, s) {
      const n = r.mul(s, yn), i = r.pow(n, e), o = r.mul(s, i), a = r.mul(r.mul(o, yn), i), c = r.mul(o, r.sub(a, r.ONE));
      if (!r.eql(r.sqr(c), s)) throw new Error("Cannot find square root");
      return c;
    };
  }
  return F3(t);
}
const j3 = (t, e) => (Je(t, e) & He) === He, H3 = ["create", "isValid", "is0", "neg", "inv", "sqrt", "sqr", "eql", "add", "sub", "mul", "pow", "div", "addN", "subN", "mulN", "sqrN"];
function q3(t) {
  const e = { ORDER: "bigint", MASK: "bigint", BYTES: "isSafeInteger", BITS: "isSafeInteger" }, r = H3.reduce((s, n) => (s[n] = "function", s), e);
  return qd(t, r);
}
function K3(t, e, r) {
  if (r < rt) throw new Error("invalid exponent, negatives unsupported");
  if (r === rt) return t.ONE;
  if (r === He) return e;
  let s = t.ONE, n = e;
  for (; r > rt; ) r & He && (s = t.mul(s, n)), n = t.sqr(n), r >>= He;
  return s;
}
function V3(t, e) {
  const r = new Array(e.length), s = e.reduce((i, o, a) => t.is0(o) ? i : (r[a] = i, t.mul(i, o)), t.ONE), n = t.inv(s);
  return e.reduceRight((i, o, a) => t.is0(o) ? i : (r[a] = t.mul(i, r[a]), t.mul(i, o)), n), r;
}
function j0(t, e) {
  const r = e !== void 0 ? e : t.toString(2).length, s = Math.ceil(r / 8);
  return { nBitLength: r, nByteLength: s };
}
function H0(t, e, r = !1, s = {}) {
  if (t <= rt) throw new Error("invalid field: expected ORDER > 0, got " + t);
  const { nBitLength: n, nByteLength: i } = j0(t, e);
  if (i > 2048) throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let o;
  const a = Object.freeze({ ORDER: t, isLE: r, BITS: n, BYTES: i, MASK: R3(n), ZERO: rt, ONE: He, create: (c) => Je(c, t), isValid: (c) => {
    if (typeof c != "bigint") throw new Error("invalid field element: expected bigint, got " + typeof c);
    return rt <= c && c < t;
  }, is0: (c) => c === rt, isOdd: (c) => (c & He) === He, neg: (c) => Je(-c, t), eql: (c, l) => c === l, sqr: (c) => Je(c * c, t), add: (c, l) => Je(c + l, t), sub: (c, l) => Je(c - l, t), mul: (c, l) => Je(c * l, t), pow: (c, l) => K3(a, c, l), div: (c, l) => Je(c * xf(l, t), t), sqrN: (c) => c * c, addN: (c, l) => c + l, subN: (c, l) => c - l, mulN: (c, l) => c * l, inv: (c) => xf(c, t), sqrt: s.sqrt || ((c) => (o || (o = z3(t)), o(a, c))), invertBatch: (c) => V3(a, c), cmov: (c, l, u) => u ? l : c, toBytes: (c) => r ? bh(c, i) : z0(c, i), fromBytes: (c) => {
    if (c.length !== i) throw new Error("Field.fromBytes: expected " + i + " bytes, got " + c.length);
    return r ? Pc(c) : D3(c);
  } });
  return Object.freeze(a);
}
const vf = BigInt(0), Na = BigInt(1);
function iu(t, e) {
  const r = e.negate();
  return t ? r : e;
}
function q0(t, e) {
  if (!Number.isSafeInteger(t) || t <= 0 || t > e) throw new Error("invalid window size, expected [1.." + e + "], got W=" + t);
}
function ou(t, e) {
  q0(t, e);
  const r = Math.ceil(e / t) + 1, s = 2 ** (t - 1);
  return { windows: r, windowSize: s };
}
function G3(t, e) {
  if (!Array.isArray(t)) throw new Error("array expected");
  t.forEach((r, s) => {
    if (!(r instanceof e)) throw new Error("invalid point at index " + s);
  });
}
function W3(t, e) {
  if (!Array.isArray(t)) throw new Error("array of scalars expected");
  t.forEach((r, s) => {
    if (!e.isValid(r)) throw new Error("invalid scalar at index " + s);
  });
}
const au = /* @__PURE__ */ new WeakMap(), K0 = /* @__PURE__ */ new WeakMap();
function cu(t) {
  return K0.get(t) || 1;
}
function Z3(t, e) {
  return { constTimeNegate: iu, hasPrecomputes(r) {
    return cu(r) !== 1;
  }, unsafeLadder(r, s, n = t.ZERO) {
    let i = r;
    for (; s > vf; ) s & Na && (n = n.add(i)), i = i.double(), s >>= Na;
    return n;
  }, precomputeWindow(r, s) {
    const { windows: n, windowSize: i } = ou(s, e), o = [];
    let a = r, c = a;
    for (let l = 0; l < n; l++) {
      c = a, o.push(c);
      for (let u = 1; u < i; u++) c = c.add(a), o.push(c);
      a = c.double();
    }
    return o;
  }, wNAF(r, s, n) {
    const { windows: i, windowSize: o } = ou(r, e);
    let a = t.ZERO, c = t.BASE;
    const l = BigInt(2 ** r - 1), u = 2 ** r, h = BigInt(r);
    for (let p = 0; p < i; p++) {
      const y = p * o;
      let b = Number(n & l);
      n >>= h, b > o && (b -= u, n += Na);
      const g = y, x = y + Math.abs(b) - 1, I = p % 2 !== 0, U = b < 0;
      b === 0 ? c = c.add(iu(I, s[g])) : a = a.add(iu(U, s[x]));
    }
    return { p: a, f: c };
  }, wNAFUnsafe(r, s, n, i = t.ZERO) {
    const { windows: o, windowSize: a } = ou(r, e), c = BigInt(2 ** r - 1), l = 2 ** r, u = BigInt(r);
    for (let h = 0; h < o; h++) {
      const p = h * a;
      if (n === vf) break;
      let y = Number(n & c);
      if (n >>= u, y > a && (y -= l, n += Na), y === 0) continue;
      let b = s[p + Math.abs(y) - 1];
      y < 0 && (b = b.negate()), i = i.add(b);
    }
    return i;
  }, getPrecomputes(r, s, n) {
    let i = au.get(s);
    return i || (i = this.precomputeWindow(s, r), r !== 1 && au.set(s, n(i))), i;
  }, wNAFCached(r, s, n) {
    const i = cu(r);
    return this.wNAF(i, this.getPrecomputes(i, r, n), s);
  }, wNAFCachedUnsafe(r, s, n, i) {
    const o = cu(r);
    return o === 1 ? this.unsafeLadder(r, s, i) : this.wNAFUnsafe(o, this.getPrecomputes(o, r, n), s, i);
  }, setWindowSize(r, s) {
    q0(s, e), K0.set(r, s), au.delete(r);
  } };
}
function J3(t, e, r, s) {
  if (G3(r, t), W3(s, e), r.length !== s.length) throw new Error("arrays of points and scalars must have equal length");
  const n = t.ZERO, i = P3(BigInt(r.length)), o = i > 12 ? i - 3 : i > 4 ? i - 2 : i ? 2 : 1, a = (1 << o) - 1, c = new Array(a + 1).fill(n), l = Math.floor((e.BITS - 1) / o) * o;
  let u = n;
  for (let h = l; h >= 0; h -= o) {
    c.fill(n);
    for (let y = 0; y < s.length; y++) {
      const b = s[y], g = Number(b >> BigInt(h) & BigInt(a));
      c[g] = c[g].add(r[y]);
    }
    let p = n;
    for (let y = c.length - 1, b = n; y > 0; y--) b = b.add(c[y]), p = p.add(b);
    if (u = u.add(p), h !== 0) for (let y = 0; y < o; y++) u = u.double();
  }
  return u;
}
function X3(t) {
  return q3(t.Fp), qd(t, { n: "bigint", h: "bigint", Gx: "field", Gy: "field" }, { nBitLength: "isSafeInteger", nByteLength: "isSafeInteger" }), Object.freeze({ ...j0(t.n, t.nBitLength), ...t, p: t.Fp.ORDER });
}
const xr = BigInt(0), Ot = BigInt(1), La = BigInt(2), Y3 = BigInt(8), Q3 = { zip215: !0 };
function e8(t) {
  const e = X3(t);
  return qd(t, { hash: "function", a: "bigint", d: "bigint", randomBytes: "function" }, { adjustScalarBytes: "function", domain: "function", uvRatio: "function", mapToCurve: "function" }), Object.freeze({ ...e });
}
function t8(t) {
  const e = e8(t), { Fp: r, n: s, prehash: n, hash: i, randomBytes: o, nByteLength: a, h: c } = e, l = La << BigInt(a * 8) - Ot, u = r.create, h = H0(e.n, e.nBitLength), p = e.uvRatio || ((_, C) => {
    try {
      return { isValid: !0, value: r.sqrt(_ * r.inv(C)) };
    } catch {
      return { isValid: !1, value: xr };
    }
  }), y = e.adjustScalarBytes || ((_) => _), b = e.domain || ((_, C, $) => {
    if (su("phflag", $), C.length || $) throw new Error("Contexts/pre-hash are not supported");
    return _;
  });
  function g(_, C) {
    Ri("coordinate " + _, C, xr, l);
  }
  function x(_) {
    if (!(_ instanceof A)) throw new Error("ExtendedPoint expected");
  }
  const I = gf((_, C) => {
    const { ex: $, ey: P, ez: D } = _, z = _.is0();
    C == null && (C = z ? Y3 : r.inv(D));
    const L = u($ * C), K = u(P * C), J = u(D * C);
    if (z) return { x: xr, y: Ot };
    if (J !== Ot) throw new Error("invZ was invalid");
    return { x: L, y: K };
  }), U = gf((_) => {
    const { a: C, d: $ } = e;
    if (_.is0()) throw new Error("bad point: ZERO");
    const { ex: P, ey: D, ez: z, et: L } = _, K = u(P * P), J = u(D * D), X = u(z * z), Y = u(X * X), re = u(K * C), ae = u(X * u(re + J)), ne = u(Y + u($ * u(K * J)));
    if (ae !== ne) throw new Error("bad point: equation left != right (1)");
    const se = u(P * D), fe = u(z * L);
    if (se !== fe) throw new Error("bad point: equation left != right (2)");
    return !0;
  });
  class A {
    constructor(C, $, P, D) {
      this.ex = C, this.ey = $, this.ez = P, this.et = D, g("x", C), g("y", $), g("z", P), g("t", D), Object.freeze(this);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static fromAffine(C) {
      if (C instanceof A) throw new Error("extended point not allowed");
      const { x: $, y: P } = C || {};
      return g("x", $), g("y", P), new A($, P, Ot, u($ * P));
    }
    static normalizeZ(C) {
      const $ = r.invertBatch(C.map((P) => P.ez));
      return C.map((P, D) => P.toAffine($[D])).map(A.fromAffine);
    }
    static msm(C, $) {
      return J3(A, h, C, $);
    }
    _setWindowSize(C) {
      q.setWindowSize(this, C);
    }
    assertValidity() {
      U(this);
    }
    equals(C) {
      x(C);
      const { ex: $, ey: P, ez: D } = this, { ex: z, ey: L, ez: K } = C, J = u($ * K), X = u(z * D), Y = u(P * K), re = u(L * D);
      return J === X && Y === re;
    }
    is0() {
      return this.equals(A.ZERO);
    }
    negate() {
      return new A(u(-this.ex), this.ey, this.ez, u(-this.et));
    }
    double() {
      const { a: C } = e, { ex: $, ey: P, ez: D } = this, z = u($ * $), L = u(P * P), K = u(La * u(D * D)), J = u(C * z), X = $ + P, Y = u(u(X * X) - z - L), re = J + L, ae = re - K, ne = J - L, se = u(Y * ae), fe = u(re * ne), Oe = u(Y * ne), Lr = u(ae * re);
      return new A(se, fe, Lr, Oe);
    }
    add(C) {
      x(C);
      const { a: $, d: P } = e, { ex: D, ey: z, ez: L, et: K } = this, { ex: J, ey: X, ez: Y, et: re } = C;
      if ($ === BigInt(-1)) {
        const Ta = u((z - D) * (X + J)), Di = u((z + D) * (X - J)), Is = u(Di - Ta);
        if (Is === xr) return this.double();
        const Wt = u(L * La * re), Ln = u(K * La * Y), Ua = Ln + Wt, Er = Di + Ta, $a = Ln - Wt, E = u(Ua * Is), f = u(Er * $a), m = u(Ua * $a), v = u(Is * Er);
        return new A(E, f, v, m);
      }
      const ae = u(D * J), ne = u(z * X), se = u(K * P * re), fe = u(L * Y), Oe = u((D + z) * (J + X) - ae - ne), Lr = fe - se, wr = fe + se, ar = u(ne - $ * ae), $i = u(Oe * Lr), Gl = u(wr * ar), Bi = u(Oe * ar), Wl = u(Lr * wr);
      return new A($i, Gl, Wl, Bi);
    }
    subtract(C) {
      return this.add(C.negate());
    }
    wNAF(C) {
      return q.wNAFCached(this, C, A.normalizeZ);
    }
    multiply(C) {
      const $ = C;
      Ri("scalar", $, Ot, s);
      const { p: P, f: D } = this.wNAF($);
      return A.normalizeZ([P, D])[0];
    }
    multiplyUnsafe(C, $ = A.ZERO) {
      const P = C;
      return Ri("scalar", P, xr, s), P === xr ? B : this.is0() || P === Ot ? this : q.wNAFCachedUnsafe(this, P, A.normalizeZ, $);
    }
    isSmallOrder() {
      return this.multiplyUnsafe(c).is0();
    }
    isTorsionFree() {
      return q.unsafeLadder(this, s).is0();
    }
    toAffine(C) {
      return I(this, C);
    }
    clearCofactor() {
      const { h: C } = e;
      return C === Ot ? this : this.multiplyUnsafe(C);
    }
    static fromHex(C, $ = !1) {
      const { d: P, a: D } = e, z = r.BYTES;
      C = rs("pointHex", C, z), su("zip215", $);
      const L = C.slice(), K = C[z - 1];
      L[z - 1] = K & -129;
      const J = Pc(L), X = $ ? l : r.ORDER;
      Ri("pointHex.y", J, xr, X);
      const Y = u(J * J), re = u(Y - Ot), ae = u(P * Y - D);
      let { isValid: ne, value: se } = p(re, ae);
      if (!ne) throw new Error("Point.fromHex: invalid y coordinate");
      const fe = (se & Ot) === Ot, Oe = (K & 128) !== 0;
      if (!$ && se === xr && Oe) throw new Error("Point.fromHex: x=0 and x_0=1");
      return Oe !== fe && (se = u(-se)), A.fromAffine({ x: se, y: J });
    }
    static fromPrivateKey(C) {
      return w(C).point;
    }
    toRawBytes() {
      const { x: C, y: $ } = this.toAffine(), P = bh($, r.BYTES);
      return P[P.length - 1] |= C & Ot ? 128 : 0, P;
    }
    toHex() {
      return Hd(this.toRawBytes());
    }
  }
  A.BASE = new A(e.Gx, e.Gy, Ot, u(e.Gx * e.Gy)), A.ZERO = new A(xr, Ot, Ot, xr);
  const { BASE: M, ZERO: B } = A, q = Z3(A, a * 8);
  function H(_) {
    return Je(_, s);
  }
  function F(_) {
    return H(Pc(_));
  }
  function w(_) {
    const C = r.BYTES;
    _ = rs("private key", _, C);
    const $ = rs("hashed private key", i(_), 2 * C), P = y($.slice(0, C)), D = $.slice(C, 2 * C), z = F(P), L = M.multiply(z), K = L.toRawBytes();
    return { head: P, prefix: D, scalar: z, point: L, pointBytes: K };
  }
  function T(_) {
    return w(_).pointBytes;
  }
  function k(_ = new Uint8Array(), ...C) {
    const $ = yf(...C);
    return F(i(b($, rs("context", _), !!n)));
  }
  function S(_, C, $ = {}) {
    _ = rs("message", _), n && (_ = n(_));
    const { prefix: P, scalar: D, pointBytes: z } = w(C), L = k($.context, P, _), K = M.multiply(L).toRawBytes(), J = k($.context, K, z, _), X = H(L + J * D);
    Ri("signature.s", X, xr, s);
    const Y = yf(K, bh(X, r.BYTES));
    return rs("result", Y, r.BYTES * 2);
  }
  const O = Q3;
  function N(_, C, $, P = O) {
    const { context: D, zip215: z } = P, L = r.BYTES;
    _ = rs("signature", _, 2 * L), C = rs("message", C), $ = rs("publicKey", $, L), z !== void 0 && su("zip215", z), n && (C = n(C));
    const K = Pc(_.slice(L, 2 * L));
    let J, X, Y;
    try {
      J = A.fromHex($, z), X = A.fromHex(_.slice(0, L), z), Y = M.multiplyUnsafe(K);
    } catch {
      return !1;
    }
    if (!z && J.isSmallOrder()) return !1;
    const re = k(D, X.toRawBytes(), J.toRawBytes(), C);
    return X.add(J.multiplyUnsafe(re)).subtract(Y).clearCofactor().equals(A.ZERO);
  }
  return M._setWindowSize(8), { CURVE: e, getPublicKey: T, sign: S, verify: N, ExtendedPoint: A, utils: { getExtendedPublicKey: w, randomPrivateKey: () => o(r.BYTES), precompute(_ = 8, C = A.BASE) {
    return C._setWindowSize(_), C.multiply(BigInt(3)), C;
  } } };
}
BigInt(0), BigInt(1);
const Kd = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"), kf = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
BigInt(0);
const r8 = BigInt(1), Cf = BigInt(2);
BigInt(3);
const s8 = BigInt(5), n8 = BigInt(8);
function i8(t) {
  const e = BigInt(10), r = BigInt(20), s = BigInt(40), n = BigInt(80), i = Kd, o = t * t % i * t % i, a = Mr(o, Cf, i) * o % i, c = Mr(a, r8, i) * t % i, l = Mr(c, s8, i) * c % i, u = Mr(l, e, i) * l % i, h = Mr(u, r, i) * u % i, p = Mr(h, s, i) * h % i, y = Mr(p, n, i) * p % i, b = Mr(y, n, i) * p % i, g = Mr(b, e, i) * l % i;
  return { pow_p_5_8: Mr(g, Cf, i) * t % i, b2: o };
}
function o8(t) {
  return t[0] &= 248, t[31] &= 127, t[31] |= 64, t;
}
function a8(t, e) {
  const r = Kd, s = Je(e * e * e, r), n = Je(s * s * e, r), i = i8(t * n).pow_p_5_8;
  let o = Je(t * s * i, r);
  const a = Je(e * o * o, r), c = o, l = Je(o * kf, r), u = a === t, h = a === Je(-t, r), p = a === Je(-t * kf, r);
  return u && (o = c), (h || p) && (o = l), j3(o, r) && (o = Je(-o, r)), { isValid: u || h, value: o };
}
const c8 = H0(Kd, void 0, !0), l8 = { a: BigInt(-1), d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"), Fp: c8, n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"), h: n8, Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"), Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"), hash: U3, randomBytes: R0, adjustScalarBytes: o8, uvRatio: a8 }, V0 = t8(l8), u8 = "EdDSA", h8 = "JWT", Zc = ".", gl = "base64url", G0 = "utf8", W0 = "utf8", d8 = ":", p8 = "did", f8 = "key", Sf = "base58btc", m8 = "z", b8 = "K36", y8 = 32;
function Vd(t) {
  return globalThis.Buffer != null ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : t;
}
function Z0(t = 0) {
  return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? Vd(globalThis.Buffer.allocUnsafe(t)) : new Uint8Array(t);
}
function J0(t, e) {
  e || (e = t.reduce((n, i) => n + i.length, 0));
  const r = Z0(e);
  let s = 0;
  for (const n of t) r.set(n, s), s += n.length;
  return Vd(r);
}
function g8(t, e) {
  if (t.length >= 255) throw new TypeError("Alphabet too long");
  for (var r = new Uint8Array(256), s = 0; s < r.length; s++) r[s] = 255;
  for (var n = 0; n < t.length; n++) {
    var i = t.charAt(n), o = i.charCodeAt(0);
    if (r[o] !== 255) throw new TypeError(i + " is ambiguous");
    r[o] = n;
  }
  var a = t.length, c = t.charAt(0), l = Math.log(a) / Math.log(256), u = Math.log(256) / Math.log(a);
  function h(b) {
    if (b instanceof Uint8Array || (ArrayBuffer.isView(b) ? b = new Uint8Array(b.buffer, b.byteOffset, b.byteLength) : Array.isArray(b) && (b = Uint8Array.from(b))), !(b instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
    if (b.length === 0) return "";
    for (var g = 0, x = 0, I = 0, U = b.length; I !== U && b[I] === 0; ) I++, g++;
    for (var A = (U - I) * u + 1 >>> 0, M = new Uint8Array(A); I !== U; ) {
      for (var B = b[I], q = 0, H = A - 1; (B !== 0 || q < x) && H !== -1; H--, q++) B += 256 * M[H] >>> 0, M[H] = B % a >>> 0, B = B / a >>> 0;
      if (B !== 0) throw new Error("Non-zero carry");
      x = q, I++;
    }
    for (var F = A - x; F !== A && M[F] === 0; ) F++;
    for (var w = c.repeat(g); F < A; ++F) w += t.charAt(M[F]);
    return w;
  }
  function p(b) {
    if (typeof b != "string") throw new TypeError("Expected String");
    if (b.length === 0) return new Uint8Array();
    var g = 0;
    if (b[g] !== " ") {
      for (var x = 0, I = 0; b[g] === c; ) x++, g++;
      for (var U = (b.length - g) * l + 1 >>> 0, A = new Uint8Array(U); b[g]; ) {
        var M = r[b.charCodeAt(g)];
        if (M === 255) return;
        for (var B = 0, q = U - 1; (M !== 0 || B < I) && q !== -1; q--, B++) M += a * A[q] >>> 0, A[q] = M % 256 >>> 0, M = M / 256 >>> 0;
        if (M !== 0) throw new Error("Non-zero carry");
        I = B, g++;
      }
      if (b[g] !== " ") {
        for (var H = U - I; H !== U && A[H] === 0; ) H++;
        for (var F = new Uint8Array(x + (U - H)), w = x; H !== U; ) F[w++] = A[H++];
        return F;
      }
    }
  }
  function y(b) {
    var g = p(b);
    if (g) return g;
    throw new Error(`Non-${e} character`);
  }
  return { encode: h, decodeUnsafe: p, decode: y };
}
var w8 = g8, E8 = w8;
const X0 = (t) => {
  if (t instanceof Uint8Array && t.constructor.name === "Uint8Array") return t;
  if (t instanceof ArrayBuffer) return new Uint8Array(t);
  if (ArrayBuffer.isView(t)) return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  throw new Error("Unknown type, must be binary type");
}, x8 = (t) => new TextEncoder().encode(t), v8 = (t) => new TextDecoder().decode(t);
let k8 = class {
  constructor(e, r, s) {
    this.name = e, this.prefix = r, this.baseEncode = s;
  }
  encode(e) {
    if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
    throw Error("Unknown type, must be binary type");
  }
}, C8 = class {
  constructor(e, r, s) {
    if (this.name = e, this.prefix = r, r.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
    this.prefixCodePoint = r.codePointAt(0), this.baseDecode = s;
  }
  decode(e) {
    if (typeof e == "string") {
      if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
      return this.baseDecode(e.slice(this.prefix.length));
    } else throw Error("Can only multibase decode strings");
  }
  or(e) {
    return Y0(this, e);
  }
}, S8 = class {
  constructor(e) {
    this.decoders = e;
  }
  or(e) {
    return Y0(this, e);
  }
  decode(e) {
    const r = e[0], s = this.decoders[r];
    if (s) return s.decode(e);
    throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
  }
};
const Y0 = (t, e) => new S8({ ...t.decoders || { [t.prefix]: t }, ...e.decoders || { [e.prefix]: e } });
let I8 = class {
  constructor(e, r, s, n) {
    this.name = e, this.prefix = r, this.baseEncode = s, this.baseDecode = n, this.encoder = new k8(e, r, s), this.decoder = new C8(e, r, n);
  }
  encode(e) {
    return this.encoder.encode(e);
  }
  decode(e) {
    return this.decoder.decode(e);
  }
};
const wl = ({ name: t, prefix: e, encode: r, decode: s }) => new I8(t, e, r, s), ha = ({ prefix: t, name: e, alphabet: r }) => {
  const { encode: s, decode: n } = E8(r, e);
  return wl({ prefix: t, name: e, encode: s, decode: (i) => X0(n(i)) });
}, A8 = (t, e, r, s) => {
  const n = {};
  for (let u = 0; u < e.length; ++u) n[e[u]] = u;
  let i = t.length;
  for (; t[i - 1] === "="; ) --i;
  const o = new Uint8Array(i * r / 8 | 0);
  let a = 0, c = 0, l = 0;
  for (let u = 0; u < i; ++u) {
    const h = n[t[u]];
    if (h === void 0) throw new SyntaxError(`Non-${s} character`);
    c = c << r | h, a += r, a >= 8 && (a -= 8, o[l++] = 255 & c >> a);
  }
  if (a >= r || 255 & c << 8 - a) throw new SyntaxError("Unexpected end of data");
  return o;
}, _8 = (t, e, r) => {
  const s = e[e.length - 1] === "=", n = (1 << r) - 1;
  let i = "", o = 0, a = 0;
  for (let c = 0; c < t.length; ++c) for (a = a << 8 | t[c], o += 8; o > r; ) o -= r, i += e[n & a >> o];
  if (o && (i += e[n & a << r - o]), s) for (; i.length * r & 7; ) i += "=";
  return i;
}, pt = ({ name: t, prefix: e, bitsPerChar: r, alphabet: s }) => wl({ prefix: e, name: t, encode(n) {
  return _8(n, s, r);
}, decode(n) {
  return A8(n, s, r, t);
} }), T8 = wl({ prefix: "\0", name: "identity", encode: (t) => v8(t), decode: (t) => x8(t) });
var U8 = Object.freeze({ __proto__: null, identity: T8 });
const $8 = pt({ prefix: "0", name: "base2", alphabet: "01", bitsPerChar: 1 });
var B8 = Object.freeze({ __proto__: null, base2: $8 });
const D8 = pt({ prefix: "7", name: "base8", alphabet: "01234567", bitsPerChar: 3 });
var O8 = Object.freeze({ __proto__: null, base8: D8 });
const P8 = ha({ prefix: "9", name: "base10", alphabet: "0123456789" });
var R8 = Object.freeze({ __proto__: null, base10: P8 });
const N8 = pt({ prefix: "f", name: "base16", alphabet: "0123456789abcdef", bitsPerChar: 4 }), L8 = pt({ prefix: "F", name: "base16upper", alphabet: "0123456789ABCDEF", bitsPerChar: 4 });
var M8 = Object.freeze({ __proto__: null, base16: N8, base16upper: L8 });
const F8 = pt({ prefix: "b", name: "base32", alphabet: "abcdefghijklmnopqrstuvwxyz234567", bitsPerChar: 5 }), z8 = pt({ prefix: "B", name: "base32upper", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567", bitsPerChar: 5 }), j8 = pt({ prefix: "c", name: "base32pad", alphabet: "abcdefghijklmnopqrstuvwxyz234567=", bitsPerChar: 5 }), H8 = pt({ prefix: "C", name: "base32padupper", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=", bitsPerChar: 5 }), q8 = pt({ prefix: "v", name: "base32hex", alphabet: "0123456789abcdefghijklmnopqrstuv", bitsPerChar: 5 }), K8 = pt({ prefix: "V", name: "base32hexupper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV", bitsPerChar: 5 }), V8 = pt({ prefix: "t", name: "base32hexpad", alphabet: "0123456789abcdefghijklmnopqrstuv=", bitsPerChar: 5 }), G8 = pt({ prefix: "T", name: "base32hexpadupper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=", bitsPerChar: 5 }), W8 = pt({ prefix: "h", name: "base32z", alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769", bitsPerChar: 5 });
var Z8 = Object.freeze({ __proto__: null, base32: F8, base32upper: z8, base32pad: j8, base32padupper: H8, base32hex: q8, base32hexupper: K8, base32hexpad: V8, base32hexpadupper: G8, base32z: W8 });
const J8 = ha({ prefix: "k", name: "base36", alphabet: "0123456789abcdefghijklmnopqrstuvwxyz" }), X8 = ha({ prefix: "K", name: "base36upper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ" });
var Y8 = Object.freeze({ __proto__: null, base36: J8, base36upper: X8 });
const Q8 = ha({ name: "base58btc", prefix: "z", alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz" }), e6 = ha({ name: "base58flickr", prefix: "Z", alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ" });
var t6 = Object.freeze({ __proto__: null, base58btc: Q8, base58flickr: e6 });
const r6 = pt({ prefix: "m", name: "base64", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", bitsPerChar: 6 }), s6 = pt({ prefix: "M", name: "base64pad", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", bitsPerChar: 6 }), n6 = pt({ prefix: "u", name: "base64url", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", bitsPerChar: 6 }), i6 = pt({ prefix: "U", name: "base64urlpad", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=", bitsPerChar: 6 });
var o6 = Object.freeze({ __proto__: null, base64: r6, base64pad: s6, base64url: n6, base64urlpad: i6 });
const Q0 = Array.from("🚀🪐☄🛰🌌🌑🌒🌓🌔🌕🌖🌗🌘🌍🌏🌎🐉☀💻🖥💾💿😂❤😍🤣😊🙏💕😭😘👍😅👏😁🔥🥰💔💖💙😢🤔😆🙄💪😉☺👌🤗💜😔😎😇🌹🤦🎉💞✌✨🤷😱😌🌸🙌😋💗💚😏💛🙂💓🤩😄😀🖤😃💯🙈👇🎶😒🤭❣😜💋👀😪😑💥🙋😞😩😡🤪👊🥳😥🤤👉💃😳✋😚😝😴🌟😬🙃🍀🌷😻😓⭐✅🥺🌈😈🤘💦✔😣🏃💐☹🎊💘😠☝😕🌺🎂🌻😐🖕💝🙊😹🗣💫💀👑🎵🤞😛🔴😤🌼😫⚽🤙☕🏆🤫👈😮🙆🍻🍃🐶💁😲🌿🧡🎁⚡🌞🎈❌✊👋😰🤨😶🤝🚶💰🍓💢🤟🙁🚨💨🤬✈🎀🍺🤓😙💟🌱😖👶🥴▶➡❓💎💸⬇😨🌚🦋😷🕺⚠🙅😟😵👎🤲🤠🤧📌🔵💅🧐🐾🍒😗🤑🌊🤯🐷☎💧😯💆👆🎤🙇🍑❄🌴💣🐸💌📍🥀🤢👅💡💩👐📸👻🤐🤮🎼🥵🚩🍎🍊👼💍📣🥂"), a6 = Q0.reduce((t, e, r) => (t[r] = e, t), []), c6 = Q0.reduce((t, e, r) => (t[e.codePointAt(0)] = r, t), []);
function l6(t) {
  return t.reduce((e, r) => (e += a6[r], e), "");
}
function u6(t) {
  const e = [];
  for (const r of t) {
    const s = c6[r.codePointAt(0)];
    if (s === void 0) throw new Error(`Non-base256emoji character: ${r}`);
    e.push(s);
  }
  return new Uint8Array(e);
}
const h6 = wl({ prefix: "🚀", name: "base256emoji", encode: l6, decode: u6 });
var d6 = Object.freeze({ __proto__: null, base256emoji: h6 }), p6 = ey, If = 128, f6 = -128, m6 = Math.pow(2, 31);
function ey(t, e, r) {
  e = e || [], r = r || 0;
  for (var s = r; t >= m6; ) e[r++] = t & 255 | If, t /= 128;
  for (; t & f6; ) e[r++] = t & 255 | If, t >>>= 7;
  return e[r] = t | 0, ey.bytes = r - s + 1, e;
}
var b6 = gh, y6 = 128, Af = 127;
function gh(t, s) {
  var r = 0, s = s || 0, n = 0, i = s, o, a = t.length;
  do {
    if (i >= a) throw gh.bytes = 0, new RangeError("Could not decode varint");
    o = t[i++], r += n < 28 ? (o & Af) << n : (o & Af) * Math.pow(2, n), n += 7;
  } while (o >= y6);
  return gh.bytes = i - s, r;
}
var g6 = Math.pow(2, 7), w6 = Math.pow(2, 14), E6 = Math.pow(2, 21), x6 = Math.pow(2, 28), v6 = Math.pow(2, 35), k6 = Math.pow(2, 42), C6 = Math.pow(2, 49), S6 = Math.pow(2, 56), I6 = Math.pow(2, 63), A6 = function(t) {
  return t < g6 ? 1 : t < w6 ? 2 : t < E6 ? 3 : t < x6 ? 4 : t < v6 ? 5 : t < k6 ? 6 : t < C6 ? 7 : t < S6 ? 8 : t < I6 ? 9 : 10;
}, _6 = { encode: p6, decode: b6, encodingLength: A6 }, ty = _6;
const _f = (t, e, r = 0) => (ty.encode(t, e, r), e), Tf = (t) => ty.encodingLength(t), wh = (t, e) => {
  const r = e.byteLength, s = Tf(t), n = s + Tf(r), i = new Uint8Array(n + r);
  return _f(t, i, 0), _f(r, i, s), i.set(e, n), new T6(t, r, e, i);
};
let T6 = class {
  constructor(e, r, s, n) {
    this.code = e, this.size = r, this.digest = s, this.bytes = n;
  }
};
const ry = ({ name: t, code: e, encode: r }) => new U6(t, e, r);
let U6 = class {
  constructor(e, r, s) {
    this.name = e, this.code = r, this.encode = s;
  }
  digest(e) {
    if (e instanceof Uint8Array) {
      const r = this.encode(e);
      return r instanceof Uint8Array ? wh(this.code, r) : r.then((s) => wh(this.code, s));
    } else throw Error("Unknown type, must be binary type");
  }
};
const sy = (t) => async (e) => new Uint8Array(await crypto.subtle.digest(t, e)), $6 = ry({ name: "sha2-256", code: 18, encode: sy("SHA-256") }), B6 = ry({ name: "sha2-512", code: 19, encode: sy("SHA-512") });
var D6 = Object.freeze({ __proto__: null, sha256: $6, sha512: B6 });
const ny = 0, O6 = "identity", iy = X0, P6 = (t) => wh(ny, iy(t)), R6 = { code: ny, name: O6, encode: iy, digest: P6 };
var N6 = Object.freeze({ __proto__: null, identity: R6 });
new TextEncoder(), new TextDecoder();
const Uf = { ...U8, ...B8, ...O8, ...R8, ...M8, ...Z8, ...Y8, ...t6, ...o6, ...d6 };
({ ...D6, ...N6 });
function oy(t, e, r, s) {
  return { name: t, prefix: e, encoder: { name: t, prefix: e, encode: r }, decoder: { decode: s } };
}
const $f = oy("utf8", "u", (t) => "u" + new TextDecoder("utf8").decode(t), (t) => new TextEncoder().encode(t.substring(1))), lu = oy("ascii", "a", (t) => {
  let e = "a";
  for (let r = 0; r < t.length; r++) e += String.fromCharCode(t[r]);
  return e;
}, (t) => {
  t = t.substring(1);
  const e = Z0(t.length);
  for (let r = 0; r < t.length; r++) e[r] = t.charCodeAt(r);
  return e;
}), ay = { utf8: $f, "utf-8": $f, hex: Uf.base16, latin1: lu, ascii: lu, binary: lu, ...Uf };
function El(t, e = "utf8") {
  const r = ay[e];
  if (!r) throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(t.buffer, t.byteOffset, t.byteLength).toString("utf8") : r.encoder.encode(t).substring(1);
}
function bi(t, e = "utf8") {
  const r = ay[e];
  if (!r) throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? Vd(globalThis.Buffer.from(t, "utf-8")) : r.decoder.decode(`${r.prefix}${t}`);
}
function Bf(t) {
  return on(El(bi(t, gl), G0));
}
function Jc(t) {
  return El(bi(an(t), G0), gl);
}
function Gd(t) {
  const e = bi(b8, Sf), r = m8 + El(J0([e, t]), Sf);
  return [p8, f8, r].join(d8);
}
function L6(t) {
  return El(t, gl);
}
function M6(t) {
  return bi(t, gl);
}
function F6(t) {
  return bi([Jc(t.header), Jc(t.payload)].join(Zc), W0);
}
function z6(t) {
  return [Jc(t.header), Jc(t.payload), L6(t.signature)].join(Zc);
}
function ni(t) {
  const e = t.split(Zc), r = Bf(e[0]), s = Bf(e[1]), n = M6(e[2]), i = bi(e.slice(0, 2).join(Zc), W0);
  return { header: r, payload: s, signature: n, data: i };
}
function Xc(t = R0(y8)) {
  const e = V0.getPublicKey(t);
  return { secretKey: J0([t, e]), publicKey: e };
}
async function cy(t, e, r, s, n = V.fromMiliseconds(Date.now())) {
  const i = { alg: u8, typ: h8 }, o = Gd(s.publicKey), a = n + r, c = { iss: o, sub: t, aud: e, iat: n, exp: a }, l = F6({ header: i, payload: c }), u = V0.sign(l, s.secretKey.slice(0, 32));
  return z6({ header: i, payload: c, signature: u });
}
var Df = function(t, e, r) {
  if (r || arguments.length === 2) for (var s = 0, n = e.length, i; s < n; s++)
    (i || !(s in e)) && (i || (i = Array.prototype.slice.call(e, 0, s)), i[s] = e[s]);
  return t.concat(i || Array.prototype.slice.call(e));
}, j6 = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e, r, s) {
      this.name = e, this.version = r, this.os = s, this.type = "browser";
    }
    return t;
  }()
), H6 = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      this.version = e, this.type = "node", this.name = "node", this.os = process.platform;
    }
    return t;
  }()
), q6 = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e, r, s, n) {
      this.name = e, this.version = r, this.os = s, this.bot = n, this.type = "bot-device";
    }
    return t;
  }()
), K6 = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.type = "bot", this.bot = !0, this.name = "bot", this.version = null, this.os = null;
    }
    return t;
  }()
), V6 = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.type = "react-native", this.name = "react-native", this.version = null, this.os = null;
    }
    return t;
  }()
), G6 = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/, W6 = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/, Of = 3, Z6 = [
  ["aol", /AOLShield\/([0-9\._]+)/],
  ["edge", /Edge\/([0-9\._]+)/],
  ["edge-ios", /EdgiOS\/([0-9\._]+)/],
  ["yandexbrowser", /YaBrowser\/([0-9\._]+)/],
  ["kakaotalk", /KAKAOTALK\s([0-9\.]+)/],
  ["samsung", /SamsungBrowser\/([0-9\.]+)/],
  ["silk", /\bSilk\/([0-9._-]+)\b/],
  ["miui", /MiuiBrowser\/([0-9\.]+)$/],
  ["beaker", /BeakerBrowser\/([0-9\.]+)/],
  ["edge-chromium", /EdgA?\/([0-9\.]+)/],
  [
    "chromium-webview",
    /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
  ],
  ["chrome", /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
  ["phantomjs", /PhantomJS\/([0-9\.]+)(:?\s|$)/],
  ["crios", /CriOS\/([0-9\.]+)(:?\s|$)/],
  ["firefox", /Firefox\/([0-9\.]+)(?:\s|$)/],
  ["fxios", /FxiOS\/([0-9\.]+)/],
  ["opera-mini", /Opera Mini.*Version\/([0-9\.]+)/],
  ["opera", /Opera\/([0-9\.]+)(?:\s|$)/],
  ["opera", /OPR\/([0-9\.]+)(:?\s|$)/],
  ["pie", /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/],
  ["pie", /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/],
  ["netfront", /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/],
  ["ie", /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
  ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
  ["ie", /MSIE\s(7\.0)/],
  ["bb10", /BB10;\sTouch.*Version\/([0-9\.]+)/],
  ["android", /Android\s([0-9\.]+)/],
  ["ios", /Version\/([0-9\._]+).*Mobile.*Safari.*/],
  ["safari", /Version\/([0-9\._]+).*Safari/],
  ["facebook", /FB[AS]V\/([0-9\.]+)/],
  ["instagram", /Instagram\s([0-9\.]+)/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Mobile/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
  ["curl", /^curl\/([0-9\.]+)$/],
  ["searchbot", G6]
], Pf = [
  ["iOS", /iP(hone|od|ad)/],
  ["Android OS", /Android/],
  ["BlackBerry OS", /BlackBerry|BB10/],
  ["Windows Mobile", /IEMobile/],
  ["Amazon OS", /Kindle/],
  ["Windows 3.11", /Win16/],
  ["Windows 95", /(Windows 95)|(Win95)|(Windows_95)/],
  ["Windows 98", /(Windows 98)|(Win98)/],
  ["Windows 2000", /(Windows NT 5.0)|(Windows 2000)/],
  ["Windows XP", /(Windows NT 5.1)|(Windows XP)/],
  ["Windows Server 2003", /(Windows NT 5.2)/],
  ["Windows Vista", /(Windows NT 6.0)/],
  ["Windows 7", /(Windows NT 6.1)/],
  ["Windows 8", /(Windows NT 6.2)/],
  ["Windows 8.1", /(Windows NT 6.3)/],
  ["Windows 10", /(Windows NT 10.0)/],
  ["Windows ME", /Windows ME/],
  ["Windows CE", /Windows CE|WinCE|Microsoft Pocket Internet Explorer/],
  ["Open BSD", /OpenBSD/],
  ["Sun OS", /SunOS/],
  ["Chrome OS", /CrOS/],
  ["Linux", /(Linux)|(X11)/],
  ["Mac OS", /(Mac_PowerPC)|(Macintosh)/],
  ["QNX", /QNX/],
  ["BeOS", /BeOS/],
  ["OS/2", /OS\/2/]
];
function ly(t) {
  return typeof document > "u" && typeof navigator < "u" && navigator.product === "ReactNative" ? new V6() : typeof navigator < "u" ? X6(navigator.userAgent) : Q6();
}
function J6(t) {
  return t !== "" && Z6.reduce(function(e, r) {
    var s = r[0], n = r[1];
    if (e)
      return e;
    var i = n.exec(t);
    return !!i && [s, i];
  }, !1);
}
function X6(t) {
  var e = J6(t);
  if (!e)
    return null;
  var r = e[0], s = e[1];
  if (r === "searchbot")
    return new K6();
  var n = s[1] && s[1].split(".").join("_").split("_").slice(0, 3);
  n ? n.length < Of && (n = Df(Df([], n, !0), e7(Of - n.length), !0)) : n = [];
  var i = n.join("."), o = Y6(t), a = W6.exec(t);
  return a && a[1] ? new q6(r, i, o, a[1]) : new j6(r, i, o);
}
function Y6(t) {
  for (var e = 0, r = Pf.length; e < r; e++) {
    var s = Pf[e], n = s[0], i = s[1], o = i.exec(t);
    if (o)
      return n;
  }
  return null;
}
function Q6() {
  var t = typeof process < "u" && process.version;
  return t ? new H6(process.version.slice(1)) : null;
}
function e7(t) {
  for (var e = [], r = 0; r < t; r++)
    e.push("0");
  return e;
}
var Be = {};
Object.defineProperty(Be, "__esModule", { value: !0 });
Be.getLocalStorage = Be.getLocalStorageOrThrow = Be.getCrypto = Be.getCryptoOrThrow = Wd = Be.getLocation = Be.getLocationOrThrow = da = Be.getNavigator = Be.getNavigatorOrThrow = fr = Be.getDocument = Be.getDocumentOrThrow = Be.getFromWindowOrThrow = Be.getFromWindow = void 0;
function Dn(t) {
  let e;
  return typeof window < "u" && typeof window[t] < "u" && (e = window[t]), e;
}
Be.getFromWindow = Dn;
function yi(t) {
  const e = Dn(t);
  if (!e)
    throw new Error(`${t} is not defined in Window`);
  return e;
}
Be.getFromWindowOrThrow = yi;
function t7() {
  return yi("document");
}
Be.getDocumentOrThrow = t7;
function r7() {
  return Dn("document");
}
var fr = Be.getDocument = r7;
function s7() {
  return yi("navigator");
}
Be.getNavigatorOrThrow = s7;
function n7() {
  return Dn("navigator");
}
var da = Be.getNavigator = n7;
function i7() {
  return yi("location");
}
Be.getLocationOrThrow = i7;
function o7() {
  return Dn("location");
}
var Wd = Be.getLocation = o7;
function a7() {
  return yi("crypto");
}
Be.getCryptoOrThrow = a7;
function c7() {
  return Dn("crypto");
}
Be.getCrypto = c7;
function l7() {
  return yi("localStorage");
}
Be.getLocalStorageOrThrow = l7;
function u7() {
  return Dn("localStorage");
}
Be.getLocalStorage = u7;
var Zd = {};
Object.defineProperty(Zd, "__esModule", { value: !0 });
var Jd = Zd.getWindowMetadata = void 0;
const Rf = Be;
function h7() {
  let t, e;
  try {
    t = Rf.getDocumentOrThrow(), e = Rf.getLocationOrThrow();
  } catch {
    return null;
  }
  function r() {
    const h = t.getElementsByTagName("link"), p = [];
    for (let y = 0; y < h.length; y++) {
      const b = h[y], g = b.getAttribute("rel");
      if (g && g.toLowerCase().indexOf("icon") > -1) {
        const x = b.getAttribute("href");
        if (x)
          if (x.toLowerCase().indexOf("https:") === -1 && x.toLowerCase().indexOf("http:") === -1 && x.indexOf("//") !== 0) {
            let I = e.protocol + "//" + e.host;
            if (x.indexOf("/") === 0)
              I += x;
            else {
              const U = e.pathname.split("/");
              U.pop();
              const A = U.join("/");
              I += A + "/" + x;
            }
            p.push(I);
          } else if (x.indexOf("//") === 0) {
            const I = e.protocol + x;
            p.push(I);
          } else
            p.push(x);
      }
    }
    return p;
  }
  function s(...h) {
    const p = t.getElementsByTagName("meta");
    for (let y = 0; y < p.length; y++) {
      const b = p[y], g = ["itemprop", "property", "name"].map((x) => b.getAttribute(x)).filter((x) => x ? h.includes(x) : !1);
      if (g.length && g) {
        const x = b.getAttribute("content");
        if (x)
          return x;
      }
    }
    return "";
  }
  function n() {
    let h = s("name", "og:site_name", "og:title", "twitter:title");
    return h || (h = t.title), h;
  }
  function i() {
    return s("description", "og:description", "twitter:description", "keywords");
  }
  const o = n(), a = i(), c = e.origin, l = r();
  return {
    description: a,
    url: c,
    icons: l,
    name: o
  };
}
Jd = Zd.getWindowMetadata = h7;
function Wo(t, { strict: e = !0 } = {}) {
  return !t || typeof t != "string" ? !1 : e ? /^0x[0-9a-fA-F]*$/.test(t) : t.startsWith("0x");
}
function Eh(t) {
  return Wo(t, { strict: !1 }) ? Math.ceil((t.length - 2) / 2) : t.length;
}
const uy = "2.31.0";
let Ni = {
  getDocsUrl: ({ docsBaseUrl: t, docsPath: e = "", docsSlug: r }) => e ? `${t ?? "https://viem.sh"}${e}${r ? `#${r}` : ""}` : void 0,
  version: `viem@${uy}`
}, xl = class xh extends Error {
  constructor(e, r = {}) {
    var a;
    const s = (() => {
      var c;
      return r.cause instanceof xh ? r.cause.details : (c = r.cause) != null && c.message ? r.cause.message : r.details;
    })(), n = r.cause instanceof xh && r.cause.docsPath || r.docsPath, i = (a = Ni.getDocsUrl) == null ? void 0 : a.call(Ni, { ...r, docsPath: n }), o = [
      e || "An error occurred.",
      "",
      ...r.metaMessages ? [...r.metaMessages, ""] : [],
      ...i ? [`Docs: ${i}`] : [],
      ...s ? [`Details: ${s}`] : [],
      ...Ni.version ? [`Version: ${Ni.version}`] : []
    ].join(`
`);
    super(o, r.cause ? { cause: r.cause } : void 0), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseError"
    }), this.details = s, this.docsPath = n, this.metaMessages = r.metaMessages, this.name = r.name ?? this.name, this.shortMessage = e, this.version = uy;
  }
  walk(e) {
    return hy(this, e);
  }
};
function hy(t, e) {
  return e != null && e(t) ? t : t && typeof t == "object" && "cause" in t && t.cause !== void 0 ? hy(t.cause, e) : e ? null : t;
}
let dy = class extends xl {
  constructor({ size: e, targetSize: r, type: s }) {
    super(`${s.charAt(0).toUpperCase()}${s.slice(1).toLowerCase()} size (${e}) exceeds padding size (${r}).`, { name: "SizeExceedsPaddingSizeError" });
  }
};
function gi(t, { dir: e, size: r = 32 } = {}) {
  return typeof t == "string" ? d7(t, { dir: e, size: r }) : p7(t, { dir: e, size: r });
}
function d7(t, { dir: e, size: r = 32 } = {}) {
  if (r === null)
    return t;
  const s = t.replace("0x", "");
  if (s.length > r * 2)
    throw new dy({
      size: Math.ceil(s.length / 2),
      targetSize: r,
      type: "hex"
    });
  return `0x${s[e === "right" ? "padEnd" : "padStart"](r * 2, "0")}`;
}
function p7(t, { dir: e, size: r = 32 } = {}) {
  if (r === null)
    return t;
  if (t.length > r)
    throw new dy({
      size: t.length,
      targetSize: r,
      type: "bytes"
    });
  const s = new Uint8Array(r);
  for (let n = 0; n < r; n++) {
    const i = e === "right";
    s[i ? n : r - n - 1] = t[i ? n : t.length - n - 1];
  }
  return s;
}
let f7 = class extends xl {
  constructor({ max: e, min: r, signed: s, size: n, value: i }) {
    super(`Number "${i}" is not in safe ${n ? `${n * 8}-bit ${s ? "signed" : "unsigned"} ` : ""}integer range ${e ? `(${r} to ${e})` : `(above ${r})`}`, { name: "IntegerOutOfRangeError" });
  }
}, m7 = class extends xl {
  constructor({ givenSize: e, maxSize: r }) {
    super(`Size cannot exceed ${r} bytes. Given size: ${e} bytes.`, { name: "SizeOverflowError" });
  }
};
function wi(t, { size: e }) {
  if (Eh(t) > e)
    throw new m7({
      givenSize: Eh(t),
      maxSize: e
    });
}
function vh(t, e = {}) {
  const { signed: r } = e;
  e.size && wi(t, { size: e.size });
  const s = BigInt(t);
  if (!r)
    return s;
  const n = (t.length - 2) / 2, i = (1n << BigInt(n) * 8n - 1n) - 1n;
  return s <= i ? s : s - BigInt(`0x${"f".padStart(n * 2, "f")}`) - 1n;
}
function b7(t, e = {}) {
  return Number(vh(t, e));
}
const y7 = /* @__PURE__ */ Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function kh(t, e = {}) {
  return typeof t == "number" || typeof t == "bigint" ? fy(t, e) : typeof t == "string" ? E7(t, e) : typeof t == "boolean" ? g7(t, e) : py(t, e);
}
function g7(t, e = {}) {
  const r = `0x${Number(t)}`;
  return typeof e.size == "number" ? (wi(r, { size: e.size }), gi(r, { size: e.size })) : r;
}
function py(t, e = {}) {
  let r = "";
  for (let n = 0; n < t.length; n++)
    r += y7[t[n]];
  const s = `0x${r}`;
  return typeof e.size == "number" ? (wi(s, { size: e.size }), gi(s, { dir: "right", size: e.size })) : s;
}
function fy(t, e = {}) {
  const { signed: r, size: s } = e, n = BigInt(t);
  let i;
  s ? r ? i = (1n << BigInt(s) * 8n - 1n) - 1n : i = 2n ** (BigInt(s) * 8n) - 1n : typeof t == "number" && (i = BigInt(Number.MAX_SAFE_INTEGER));
  const o = typeof i == "bigint" && r ? -i - 1n : 0;
  if (i && n > i || n < o) {
    const c = typeof t == "bigint" ? "n" : "";
    throw new f7({
      max: i ? `${i}${c}` : void 0,
      min: `${o}${c}`,
      signed: r,
      size: s,
      value: `${t}${c}`
    });
  }
  const a = `0x${(r && n < 0 ? (1n << BigInt(s * 8)) + BigInt(n) : n).toString(16)}`;
  return s ? gi(a, { size: s }) : a;
}
const w7 = /* @__PURE__ */ new TextEncoder();
function E7(t, e = {}) {
  const r = w7.encode(t);
  return py(r, e);
}
const x7 = /* @__PURE__ */ new TextEncoder();
function v7(t, e = {}) {
  return typeof t == "number" || typeof t == "bigint" ? C7(t, e) : typeof t == "boolean" ? k7(t, e) : Wo(t) ? my(t, e) : by(t, e);
}
function k7(t, e = {}) {
  const r = new Uint8Array(1);
  return r[0] = Number(t), typeof e.size == "number" ? (wi(r, { size: e.size }), gi(r, { size: e.size })) : r;
}
const ss = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function Nf(t) {
  if (t >= ss.zero && t <= ss.nine)
    return t - ss.zero;
  if (t >= ss.A && t <= ss.F)
    return t - (ss.A - 10);
  if (t >= ss.a && t <= ss.f)
    return t - (ss.a - 10);
}
function my(t, e = {}) {
  let r = t;
  e.size && (wi(r, { size: e.size }), r = gi(r, { dir: "right", size: e.size }));
  let s = r.slice(2);
  s.length % 2 && (s = `0${s}`);
  const n = s.length / 2, i = new Uint8Array(n);
  for (let o = 0, a = 0; o < n; o++) {
    const c = Nf(s.charCodeAt(a++)), l = Nf(s.charCodeAt(a++));
    if (c === void 0 || l === void 0)
      throw new xl(`Invalid byte sequence ("${s[a - 2]}${s[a - 1]}" in "${s}").`);
    i[o] = c * 16 + l;
  }
  return i;
}
function C7(t, e) {
  const r = fy(t, e);
  return my(r);
}
function by(t, e = {}) {
  const r = x7.encode(t);
  return typeof e.size == "number" ? (wi(r, { size: e.size }), gi(r, { dir: "right", size: e.size })) : r;
}
const Ma = /* @__PURE__ */ BigInt(2 ** 32 - 1), Lf = /* @__PURE__ */ BigInt(32);
function S7(t, e = !1) {
  return e ? { h: Number(t & Ma), l: Number(t >> Lf & Ma) } : { h: Number(t >> Lf & Ma) | 0, l: Number(t & Ma) | 0 };
}
function I7(t, e = !1) {
  const r = t.length;
  let s = new Uint32Array(r), n = new Uint32Array(r);
  for (let i = 0; i < r; i++) {
    const { h: o, l: a } = S7(t[i], e);
    [s[i], n[i]] = [o, a];
  }
  return [s, n];
}
const A7 = (t, e, r) => t << r | e >>> 32 - r, _7 = (t, e, r) => e << r | t >>> 32 - r, T7 = (t, e, r) => e << r - 32 | t >>> 64 - r, U7 = (t, e, r) => t << r - 32 | e >>> 64 - r, Hn = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function $7(t) {
  return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function Yc(t) {
  if (!Number.isSafeInteger(t) || t < 0)
    throw new Error("positive integer expected, got " + t);
}
function ii(t, ...e) {
  if (!$7(t))
    throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(t.length))
    throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function YY(t) {
  if (typeof t != "function" || typeof t.create != "function")
    throw new Error("Hash should be wrapped by utils.createHasher");
  Yc(t.outputLen), Yc(t.blockLen);
}
function Qc(t, e = !0) {
  if (t.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && t.finished)
    throw new Error("Hash#digest() has already been called");
}
function yy(t, e) {
  ii(t);
  const r = e.outputLen;
  if (t.length < r)
    throw new Error("digestInto() expects output buffer of length at least " + r);
}
function B7(t) {
  return new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4));
}
function Zo(...t) {
  for (let e = 0; e < t.length; e++)
    t[e].fill(0);
}
function uu(t) {
  return new DataView(t.buffer, t.byteOffset, t.byteLength);
}
function Fr(t, e) {
  return t << 32 - e | t >>> e;
}
const D7 = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
function O7(t) {
  return t << 24 & 4278190080 | t << 8 & 16711680 | t >>> 8 & 65280 | t >>> 24 & 255;
}
function P7(t) {
  for (let e = 0; e < t.length; e++)
    t[e] = O7(t[e]);
  return t;
}
const Mf = D7 ? (t) => t : P7;
function R7(t) {
  if (typeof t != "string")
    throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(t));
}
function Xd(t) {
  return typeof t == "string" && (t = R7(t)), ii(t), t;
}
function QY(...t) {
  let e = 0;
  for (let s = 0; s < t.length; s++) {
    const n = t[s];
    ii(n), e += n.length;
  }
  const r = new Uint8Array(e);
  for (let s = 0, n = 0; s < t.length; s++) {
    const i = t[s];
    r.set(i, n), n += i.length;
  }
  return r;
}
class gy {
}
function wy(t) {
  const e = (s) => t().update(Xd(s)).digest(), r = t();
  return e.outputLen = r.outputLen, e.blockLen = r.blockLen, e.create = () => t(), e;
}
function eQ(t = 32) {
  if (Hn && typeof Hn.getRandomValues == "function")
    return Hn.getRandomValues(new Uint8Array(t));
  if (Hn && typeof Hn.randomBytes == "function")
    return Uint8Array.from(Hn.randomBytes(t));
  throw new Error("crypto.getRandomValues must be defined");
}
const N7 = BigInt(0), Li = BigInt(1), L7 = BigInt(2), M7 = BigInt(7), F7 = BigInt(256), z7 = BigInt(113), Ey = [], xy = [], vy = [];
for (let t = 0, e = Li, r = 1, s = 0; t < 24; t++) {
  [r, s] = [s, (2 * r + 3 * s) % 5], Ey.push(2 * (5 * s + r)), xy.push((t + 1) * (t + 2) / 2 % 64);
  let n = N7;
  for (let i = 0; i < 7; i++)
    e = (e << Li ^ (e >> M7) * z7) % F7, e & L7 && (n ^= Li << (Li << /* @__PURE__ */ BigInt(i)) - Li);
  vy.push(n);
}
const ky = I7(vy, !0), j7 = ky[0], H7 = ky[1], Ff = (t, e, r) => r > 32 ? T7(t, e, r) : A7(t, e, r), zf = (t, e, r) => r > 32 ? U7(t, e, r) : _7(t, e, r);
function q7(t, e = 24) {
  const r = new Uint32Array(10);
  for (let s = 24 - e; s < 24; s++) {
    for (let o = 0; o < 10; o++)
      r[o] = t[o] ^ t[o + 10] ^ t[o + 20] ^ t[o + 30] ^ t[o + 40];
    for (let o = 0; o < 10; o += 2) {
      const a = (o + 8) % 10, c = (o + 2) % 10, l = r[c], u = r[c + 1], h = Ff(l, u, 1) ^ r[a], p = zf(l, u, 1) ^ r[a + 1];
      for (let y = 0; y < 50; y += 10)
        t[o + y] ^= h, t[o + y + 1] ^= p;
    }
    let n = t[2], i = t[3];
    for (let o = 0; o < 24; o++) {
      const a = xy[o], c = Ff(n, i, a), l = zf(n, i, a), u = Ey[o];
      n = t[u], i = t[u + 1], t[u] = c, t[u + 1] = l;
    }
    for (let o = 0; o < 50; o += 10) {
      for (let a = 0; a < 10; a++)
        r[a] = t[o + a];
      for (let a = 0; a < 10; a++)
        t[o + a] ^= ~r[(a + 2) % 10] & r[(a + 4) % 10];
    }
    t[0] ^= j7[s], t[1] ^= H7[s];
  }
  Zo(r);
}
class Yd extends gy {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(e, r, s, n = !1, i = 24) {
    if (super(), this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, this.enableXOF = !1, this.blockLen = e, this.suffix = r, this.outputLen = s, this.enableXOF = n, this.rounds = i, Yc(s), !(0 < e && e < 200))
      throw new Error("only keccak-f1600 function is supported");
    this.state = new Uint8Array(200), this.state32 = B7(this.state);
  }
  clone() {
    return this._cloneInto();
  }
  keccak() {
    Mf(this.state32), q7(this.state32, this.rounds), Mf(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(e) {
    Qc(this), e = Xd(e), ii(e);
    const { blockLen: r, state: s } = this, n = e.length;
    for (let i = 0; i < n; ) {
      const o = Math.min(r - this.pos, n - i);
      for (let a = 0; a < o; a++)
        s[this.pos++] ^= e[i++];
      this.pos === r && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: e, suffix: r, pos: s, blockLen: n } = this;
    e[s] ^= r, (r & 128) !== 0 && s === n - 1 && this.keccak(), e[n - 1] ^= 128, this.keccak();
  }
  writeInto(e) {
    Qc(this, !1), ii(e), this.finish();
    const r = this.state, { blockLen: s } = this;
    for (let n = 0, i = e.length; n < i; ) {
      this.posOut >= s && this.keccak();
      const o = Math.min(s - this.posOut, i - n);
      e.set(r.subarray(this.posOut, this.posOut + o), n), this.posOut += o, n += o;
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return Yc(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if (yy(e, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, Zo(this.state);
  }
  _cloneInto(e) {
    const { blockLen: r, suffix: s, outputLen: n, rounds: i, enableXOF: o } = this;
    return e || (e = new Yd(r, s, n, o, i)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = i, e.suffix = s, e.outputLen = n, e.enableXOF = o, e.destroyed = this.destroyed, e;
  }
}
const K7 = (t, e, r) => wy(() => new Yd(e, t, r)), Cy = K7(1, 136, 256 / 8);
function Sy(t, e) {
  const r = e || "hex", s = Cy(Wo(t, { strict: !1 }) ? v7(t) : t);
  return r === "bytes" ? s : kh(s);
}
let V7 = class extends Map {
  constructor(e) {
    super(), Object.defineProperty(this, "maxSize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxSize = e;
  }
  get(e) {
    const r = super.get(e);
    return super.has(e) && r !== void 0 && (this.delete(e), super.set(e, r)), r;
  }
  set(e, r) {
    if (super.set(e, r), this.maxSize && this.size > this.maxSize) {
      const s = this.keys().next().value;
      s && this.delete(s);
    }
    return this;
  }
};
const hu = /* @__PURE__ */ new V7(8192);
function G7(t, e) {
  if (hu.has(`${t}.${e}`))
    return hu.get(`${t}.${e}`);
  const r = t.substring(2).toLowerCase(), s = Sy(by(r), "bytes"), n = r.split("");
  for (let o = 0; o < 40; o += 2)
    s[o >> 1] >> 4 >= 8 && n[o] && (n[o] = n[o].toUpperCase()), (s[o >> 1] & 15) >= 8 && n[o + 1] && (n[o + 1] = n[o + 1].toUpperCase());
  const i = `0x${n.join("")}`;
  return hu.set(`${t}.${e}`, i), i;
}
function W7(t) {
  const e = Sy(`0x${t.substring(4)}`).substring(26);
  return G7(`0x${e}`);
}
async function Z7({ hash: t, signature: e }) {
  const r = Wo(t) ? t : kh(t), { secp256k1: s } = await import("./secp256k1-C0LZ1qRA.mjs");
  return `0x${(() => {
    if (typeof e == "object" && "r" in e && "s" in e) {
      const { r: l, s: u, v: h, yParity: p } = e, y = Number(p ?? h), b = jf(y);
      return new s.Signature(vh(l), vh(u)).addRecoveryBit(b);
    }
    const o = Wo(e) ? e : kh(e);
    if (Eh(o) !== 65)
      throw new Error("invalid signature length");
    const a = b7(`0x${o.slice(130)}`), c = jf(a);
    return s.Signature.fromCompact(o.substring(2, 130)).addRecoveryBit(c);
  })().recoverPublicKey(r.substring(2)).toHex(!1)}`;
}
function jf(t) {
  if (t === 0 || t === 1)
    return t;
  if (t === 27)
    return 0;
  if (t === 28)
    return 1;
  throw new Error("Invalid yParityOrV value");
}
async function J7({ hash: t, signature: e }) {
  return W7(await Z7({ hash: t, signature: e }));
}
function X7(t, e, r, s) {
  if (typeof t.setBigUint64 == "function")
    return t.setBigUint64(e, r, s);
  const n = BigInt(32), i = BigInt(4294967295), o = Number(r >> n & i), a = Number(r & i), c = s ? 4 : 0, l = s ? 0 : 4;
  t.setUint32(e + c, o, s), t.setUint32(e + l, a, s);
}
function Y7(t, e, r) {
  return t & e ^ ~t & r;
}
function Q7(t, e, r) {
  return t & e ^ t & r ^ e & r;
}
class ek extends gy {
  constructor(e, r, s, n) {
    super(), this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.blockLen = e, this.outputLen = r, this.padOffset = s, this.isLE = n, this.buffer = new Uint8Array(e), this.view = uu(this.buffer);
  }
  update(e) {
    Qc(this), e = Xd(e), ii(e);
    const { view: r, buffer: s, blockLen: n } = this, i = e.length;
    for (let o = 0; o < i; ) {
      const a = Math.min(n - this.pos, i - o);
      if (a === n) {
        const c = uu(e);
        for (; n <= i - o; o += n)
          this.process(c, o);
        continue;
      }
      s.set(e.subarray(o, o + a), this.pos), this.pos += a, o += a, this.pos === n && (this.process(r, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    Qc(this), yy(e, this), this.finished = !0;
    const { buffer: r, view: s, blockLen: n, isLE: i } = this;
    let { pos: o } = this;
    r[o++] = 128, Zo(this.buffer.subarray(o)), this.padOffset > n - o && (this.process(s, 0), o = 0);
    for (let h = o; h < n; h++)
      r[h] = 0;
    X7(s, n - 8, BigInt(this.length * 8), i), this.process(s, 0);
    const a = uu(e), c = this.outputLen;
    if (c % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const l = c / 4, u = this.get();
    if (l > u.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let h = 0; h < l; h++)
      a.setUint32(4 * h, u[h], i);
  }
  digest() {
    const { buffer: e, outputLen: r } = this;
    this.digestInto(e);
    const s = e.slice(0, r);
    return this.destroy(), s;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: r, buffer: s, length: n, finished: i, destroyed: o, pos: a } = this;
    return e.destroyed = o, e.finished = i, e.length = n, e.pos = a, n % r && e.buffer.set(s), e;
  }
  clone() {
    return this._cloneInto();
  }
}
const Ts = /* @__PURE__ */ Uint32Array.from([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), tk = /* @__PURE__ */ Uint32Array.from([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Us = /* @__PURE__ */ new Uint32Array(64);
class rk extends ek {
  constructor(e = 32) {
    super(64, e, 8, !1), this.A = Ts[0] | 0, this.B = Ts[1] | 0, this.C = Ts[2] | 0, this.D = Ts[3] | 0, this.E = Ts[4] | 0, this.F = Ts[5] | 0, this.G = Ts[6] | 0, this.H = Ts[7] | 0;
  }
  get() {
    const { A: e, B: r, C: s, D: n, E: i, F: o, G: a, H: c } = this;
    return [e, r, s, n, i, o, a, c];
  }
  // prettier-ignore
  set(e, r, s, n, i, o, a, c) {
    this.A = e | 0, this.B = r | 0, this.C = s | 0, this.D = n | 0, this.E = i | 0, this.F = o | 0, this.G = a | 0, this.H = c | 0;
  }
  process(e, r) {
    for (let h = 0; h < 16; h++, r += 4)
      Us[h] = e.getUint32(r, !1);
    for (let h = 16; h < 64; h++) {
      const p = Us[h - 15], y = Us[h - 2], b = Fr(p, 7) ^ Fr(p, 18) ^ p >>> 3, g = Fr(y, 17) ^ Fr(y, 19) ^ y >>> 10;
      Us[h] = g + Us[h - 7] + b + Us[h - 16] | 0;
    }
    let { A: s, B: n, C: i, D: o, E: a, F: c, G: l, H: u } = this;
    for (let h = 0; h < 64; h++) {
      const p = Fr(a, 6) ^ Fr(a, 11) ^ Fr(a, 25), y = u + p + Y7(a, c, l) + tk[h] + Us[h] | 0, g = (Fr(s, 2) ^ Fr(s, 13) ^ Fr(s, 22)) + Q7(s, n, i) | 0;
      u = l, l = c, c = a, a = o + y | 0, o = i, i = n, n = s, s = y + g | 0;
    }
    s = s + this.A | 0, n = n + this.B | 0, i = i + this.C | 0, o = o + this.D | 0, a = a + this.E | 0, c = c + this.F | 0, l = l + this.G | 0, u = u + this.H | 0, this.set(s, n, i, o, a, c, l, u);
  }
  roundClean() {
    Zo(Us);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), Zo(this.buffer);
  }
}
const sk = /* @__PURE__ */ wy(() => new rk()), nk = sk;
function ik(t) {
  if (t.length >= 255)
    throw new TypeError("Alphabet too long");
  const e = new Uint8Array(256);
  for (let l = 0; l < e.length; l++)
    e[l] = 255;
  for (let l = 0; l < t.length; l++) {
    const u = t.charAt(l), h = u.charCodeAt(0);
    if (e[h] !== 255)
      throw new TypeError(u + " is ambiguous");
    e[h] = l;
  }
  const r = t.length, s = t.charAt(0), n = Math.log(r) / Math.log(256), i = Math.log(256) / Math.log(r);
  function o(l) {
    if (l instanceof Uint8Array || (ArrayBuffer.isView(l) ? l = new Uint8Array(l.buffer, l.byteOffset, l.byteLength) : Array.isArray(l) && (l = Uint8Array.from(l))), !(l instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (l.length === 0)
      return "";
    let u = 0, h = 0, p = 0;
    const y = l.length;
    for (; p !== y && l[p] === 0; )
      p++, u++;
    const b = (y - p) * i + 1 >>> 0, g = new Uint8Array(b);
    for (; p !== y; ) {
      let U = l[p], A = 0;
      for (let M = b - 1; (U !== 0 || A < h) && M !== -1; M--, A++)
        U += 256 * g[M] >>> 0, g[M] = U % r >>> 0, U = U / r >>> 0;
      if (U !== 0)
        throw new Error("Non-zero carry");
      h = A, p++;
    }
    let x = b - h;
    for (; x !== b && g[x] === 0; )
      x++;
    let I = s.repeat(u);
    for (; x < b; ++x)
      I += t.charAt(g[x]);
    return I;
  }
  function a(l) {
    if (typeof l != "string")
      throw new TypeError("Expected String");
    if (l.length === 0)
      return new Uint8Array();
    let u = 0, h = 0, p = 0;
    for (; l[u] === s; )
      h++, u++;
    const y = (l.length - u) * n + 1 >>> 0, b = new Uint8Array(y);
    for (; u < l.length; ) {
      const U = l.charCodeAt(u);
      if (U > 255)
        return;
      let A = e[U];
      if (A === 255)
        return;
      let M = 0;
      for (let B = y - 1; (A !== 0 || M < p) && B !== -1; B--, M++)
        A += r * b[B] >>> 0, b[B] = A % 256 >>> 0, A = A / 256 >>> 0;
      if (A !== 0)
        throw new Error("Non-zero carry");
      p = M, u++;
    }
    let g = y - p;
    for (; g !== y && b[g] === 0; )
      g++;
    const x = new Uint8Array(h + (y - g));
    let I = h;
    for (; g !== y; )
      x[I++] = b[g++];
    return x;
  }
  function c(l) {
    const u = a(l);
    if (u)
      return u;
    throw new Error("Non-base" + r + " character");
  }
  return {
    encode: o,
    decodeUnsafe: a,
    decode: c
  };
}
var ok = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
const pa = ik(ok);
function ak(t) {
  const e = t.length;
  let r = 0, s = 0;
  for (; s < e; ) {
    let n = t.charCodeAt(s++);
    if ((n & 4294967168) === 0) {
      r++;
      continue;
    } else if ((n & 4294965248) === 0)
      r += 2;
    else {
      if (n >= 55296 && n <= 56319 && s < e) {
        const i = t.charCodeAt(s);
        (i & 64512) === 56320 && (++s, n = ((n & 1023) << 10) + (i & 1023) + 65536);
      }
      (n & 4294901760) === 0 ? r += 3 : r += 4;
    }
  }
  return r;
}
function ck(t, e, r) {
  const s = t.length;
  let n = r, i = 0;
  for (; i < s; ) {
    let o = t.charCodeAt(i++);
    if ((o & 4294967168) === 0) {
      e[n++] = o;
      continue;
    } else if ((o & 4294965248) === 0)
      e[n++] = o >> 6 & 31 | 192;
    else {
      if (o >= 55296 && o <= 56319 && i < s) {
        const a = t.charCodeAt(i);
        (a & 64512) === 56320 && (++i, o = ((o & 1023) << 10) + (a & 1023) + 65536);
      }
      (o & 4294901760) === 0 ? (e[n++] = o >> 12 & 15 | 224, e[n++] = o >> 6 & 63 | 128) : (e[n++] = o >> 18 & 7 | 240, e[n++] = o >> 12 & 63 | 128, e[n++] = o >> 6 & 63 | 128);
    }
    e[n++] = o & 63 | 128;
  }
}
const lk = new TextEncoder(), uk = 50;
function hk(t, e, r) {
  lk.encodeInto(t, e.subarray(r));
}
function dk(t, e, r) {
  t.length > uk ? hk(t, e, r) : ck(t, e, r);
}
const pk = 4096;
function Iy(t, e, r) {
  let s = e;
  const n = s + r, i = [];
  let o = "";
  for (; s < n; ) {
    const a = t[s++];
    if ((a & 128) === 0)
      i.push(a);
    else if ((a & 224) === 192) {
      const c = t[s++] & 63;
      i.push((a & 31) << 6 | c);
    } else if ((a & 240) === 224) {
      const c = t[s++] & 63, l = t[s++] & 63;
      i.push((a & 31) << 12 | c << 6 | l);
    } else if ((a & 248) === 240) {
      const c = t[s++] & 63, l = t[s++] & 63, u = t[s++] & 63;
      let h = (a & 7) << 18 | c << 12 | l << 6 | u;
      h > 65535 && (h -= 65536, i.push(h >>> 10 & 1023 | 55296), h = 56320 | h & 1023), i.push(h);
    } else
      i.push(a);
    i.length >= pk && (o += String.fromCharCode(...i), i.length = 0);
  }
  return i.length > 0 && (o += String.fromCharCode(...i)), o;
}
const fk = new TextDecoder(), mk = 200;
function bk(t, e, r) {
  const s = t.subarray(e, e + r);
  return fk.decode(s);
}
function yk(t, e, r) {
  return r > mk ? bk(t, e, r) : Iy(t, e, r);
}
class Fa {
  constructor(e, r) {
    this.type = e, this.data = r;
  }
}
class tr extends Error {
  constructor(e) {
    super(e);
    const r = Object.create(tr.prototype);
    Object.setPrototypeOf(this, r), Object.defineProperty(this, "name", {
      configurable: !0,
      enumerable: !1,
      value: tr.name
    });
  }
}
const Mi = 4294967295;
function gk(t, e, r) {
  const s = r / 4294967296, n = r;
  t.setUint32(e, s), t.setUint32(e + 4, n);
}
function Ay(t, e, r) {
  const s = Math.floor(r / 4294967296), n = r;
  t.setUint32(e, s), t.setUint32(e + 4, n);
}
function _y(t, e) {
  const r = t.getInt32(e), s = t.getUint32(e + 4);
  return r * 4294967296 + s;
}
function wk(t, e) {
  const r = t.getUint32(e), s = t.getUint32(e + 4);
  return r * 4294967296 + s;
}
const Ek = -1, xk = 4294967296 - 1, vk = 17179869184 - 1;
function kk({ sec: t, nsec: e }) {
  if (t >= 0 && e >= 0 && t <= vk)
    if (e === 0 && t <= xk) {
      const r = new Uint8Array(4);
      return new DataView(r.buffer).setUint32(0, t), r;
    } else {
      const r = t / 4294967296, s = t & 4294967295, n = new Uint8Array(8), i = new DataView(n.buffer);
      return i.setUint32(0, e << 2 | r & 3), i.setUint32(4, s), n;
    }
  else {
    const r = new Uint8Array(12), s = new DataView(r.buffer);
    return s.setUint32(0, e), Ay(s, 4, t), r;
  }
}
function Ck(t) {
  const e = t.getTime(), r = Math.floor(e / 1e3), s = (e - r * 1e3) * 1e6, n = Math.floor(s / 1e9);
  return {
    sec: r + n,
    nsec: s - n * 1e9
  };
}
function Sk(t) {
  if (t instanceof Date) {
    const e = Ck(t);
    return kk(e);
  } else
    return null;
}
function Ik(t) {
  const e = new DataView(t.buffer, t.byteOffset, t.byteLength);
  switch (t.byteLength) {
    case 4:
      return { sec: e.getUint32(0), nsec: 0 };
    case 8: {
      const r = e.getUint32(0), s = e.getUint32(4), n = (r & 3) * 4294967296 + s, i = r >>> 2;
      return { sec: n, nsec: i };
    }
    case 12: {
      const r = _y(e, 4), s = e.getUint32(0);
      return { sec: r, nsec: s };
    }
    default:
      throw new tr(`Unrecognized data size for timestamp (expected 4, 8, or 12): ${t.length}`);
  }
}
function Ak(t) {
  const e = Ik(t);
  return new Date(e.sec * 1e3 + e.nsec / 1e6);
}
const _k = {
  type: Ek,
  encode: Sk,
  decode: Ak
};
class el {
  constructor() {
    this.builtInEncoders = [], this.builtInDecoders = [], this.encoders = [], this.decoders = [], this.register(_k);
  }
  register({ type: e, encode: r, decode: s }) {
    if (e >= 0)
      this.encoders[e] = r, this.decoders[e] = s;
    else {
      const n = -1 - e;
      this.builtInEncoders[n] = r, this.builtInDecoders[n] = s;
    }
  }
  tryToEncode(e, r) {
    for (let s = 0; s < this.builtInEncoders.length; s++) {
      const n = this.builtInEncoders[s];
      if (n != null) {
        const i = n(e, r);
        if (i != null) {
          const o = -1 - s;
          return new Fa(o, i);
        }
      }
    }
    for (let s = 0; s < this.encoders.length; s++) {
      const n = this.encoders[s];
      if (n != null) {
        const i = n(e, r);
        if (i != null) {
          const o = s;
          return new Fa(o, i);
        }
      }
    }
    return e instanceof Fa ? e : null;
  }
  decode(e, r, s) {
    const n = r < 0 ? this.builtInDecoders[-1 - r] : this.decoders[r];
    return n ? n(e, r, s) : new Fa(r, e);
  }
}
el.defaultCodec = new el();
function Tk(t) {
  return t instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && t instanceof SharedArrayBuffer;
}
function Ch(t) {
  return t instanceof Uint8Array ? t : ArrayBuffer.isView(t) ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : Tk(t) ? new Uint8Array(t) : Uint8Array.from(t);
}
const Uk = 100, $k = 2048;
let Bk = class Ty {
  constructor(e) {
    this.entered = !1, this.extensionCodec = (e == null ? void 0 : e.extensionCodec) ?? el.defaultCodec, this.context = e == null ? void 0 : e.context, this.useBigInt64 = (e == null ? void 0 : e.useBigInt64) ?? !1, this.maxDepth = (e == null ? void 0 : e.maxDepth) ?? Uk, this.initialBufferSize = (e == null ? void 0 : e.initialBufferSize) ?? $k, this.sortKeys = (e == null ? void 0 : e.sortKeys) ?? !1, this.forceFloat32 = (e == null ? void 0 : e.forceFloat32) ?? !1, this.ignoreUndefined = (e == null ? void 0 : e.ignoreUndefined) ?? !1, this.forceIntegerToFloat = (e == null ? void 0 : e.forceIntegerToFloat) ?? !1, this.pos = 0, this.view = new DataView(new ArrayBuffer(this.initialBufferSize)), this.bytes = new Uint8Array(this.view.buffer);
  }
  clone() {
    return new Ty({
      extensionCodec: this.extensionCodec,
      context: this.context,
      useBigInt64: this.useBigInt64,
      maxDepth: this.maxDepth,
      initialBufferSize: this.initialBufferSize,
      sortKeys: this.sortKeys,
      forceFloat32: this.forceFloat32,
      ignoreUndefined: this.ignoreUndefined,
      forceIntegerToFloat: this.forceIntegerToFloat
    });
  }
  reinitializeState() {
    this.pos = 0;
  }
  /**
   * This is almost equivalent to {@link Encoder#encode}, but it returns an reference of the encoder's internal buffer and thus much faster than {@link Encoder#encode}.
   *
   * @returns Encodes the object and returns a shared reference the encoder's internal buffer.
   */
  encodeSharedRef(e) {
    if (this.entered)
      return this.clone().encodeSharedRef(e);
    try {
      return this.entered = !0, this.reinitializeState(), this.doEncode(e, 1), this.bytes.subarray(0, this.pos);
    } finally {
      this.entered = !1;
    }
  }
  /**
   * @returns Encodes the object and returns a copy of the encoder's internal buffer.
   */
  encode(e) {
    if (this.entered)
      return this.clone().encode(e);
    try {
      return this.entered = !0, this.reinitializeState(), this.doEncode(e, 1), this.bytes.slice(0, this.pos);
    } finally {
      this.entered = !1;
    }
  }
  doEncode(e, r) {
    if (r > this.maxDepth)
      throw new Error(`Too deep objects in depth ${r}`);
    e == null ? this.encodeNil() : typeof e == "boolean" ? this.encodeBoolean(e) : typeof e == "number" ? this.forceIntegerToFloat ? this.encodeNumberAsFloat(e) : this.encodeNumber(e) : typeof e == "string" ? this.encodeString(e) : this.useBigInt64 && typeof e == "bigint" ? this.encodeBigInt64(e) : this.encodeObject(e, r);
  }
  ensureBufferSizeToWrite(e) {
    const r = this.pos + e;
    this.view.byteLength < r && this.resizeBuffer(r * 2);
  }
  resizeBuffer(e) {
    const r = new ArrayBuffer(e), s = new Uint8Array(r), n = new DataView(r);
    s.set(this.bytes), this.view = n, this.bytes = s;
  }
  encodeNil() {
    this.writeU8(192);
  }
  encodeBoolean(e) {
    e === !1 ? this.writeU8(194) : this.writeU8(195);
  }
  encodeNumber(e) {
    !this.forceIntegerToFloat && Number.isSafeInteger(e) ? e >= 0 ? e < 128 ? this.writeU8(e) : e < 256 ? (this.writeU8(204), this.writeU8(e)) : e < 65536 ? (this.writeU8(205), this.writeU16(e)) : e < 4294967296 ? (this.writeU8(206), this.writeU32(e)) : this.useBigInt64 ? this.encodeNumberAsFloat(e) : (this.writeU8(207), this.writeU64(e)) : e >= -32 ? this.writeU8(224 | e + 32) : e >= -128 ? (this.writeU8(208), this.writeI8(e)) : e >= -32768 ? (this.writeU8(209), this.writeI16(e)) : e >= -2147483648 ? (this.writeU8(210), this.writeI32(e)) : this.useBigInt64 ? this.encodeNumberAsFloat(e) : (this.writeU8(211), this.writeI64(e)) : this.encodeNumberAsFloat(e);
  }
  encodeNumberAsFloat(e) {
    this.forceFloat32 ? (this.writeU8(202), this.writeF32(e)) : (this.writeU8(203), this.writeF64(e));
  }
  encodeBigInt64(e) {
    e >= BigInt(0) ? (this.writeU8(207), this.writeBigUint64(e)) : (this.writeU8(211), this.writeBigInt64(e));
  }
  writeStringHeader(e) {
    if (e < 32)
      this.writeU8(160 + e);
    else if (e < 256)
      this.writeU8(217), this.writeU8(e);
    else if (e < 65536)
      this.writeU8(218), this.writeU16(e);
    else if (e < 4294967296)
      this.writeU8(219), this.writeU32(e);
    else
      throw new Error(`Too long string: ${e} bytes in UTF-8`);
  }
  encodeString(e) {
    const s = ak(e);
    this.ensureBufferSizeToWrite(5 + s), this.writeStringHeader(s), dk(e, this.bytes, this.pos), this.pos += s;
  }
  encodeObject(e, r) {
    const s = this.extensionCodec.tryToEncode(e, this.context);
    if (s != null)
      this.encodeExtension(s);
    else if (Array.isArray(e))
      this.encodeArray(e, r);
    else if (ArrayBuffer.isView(e))
      this.encodeBinary(e);
    else if (typeof e == "object")
      this.encodeMap(e, r);
    else
      throw new Error(`Unrecognized object: ${Object.prototype.toString.apply(e)}`);
  }
  encodeBinary(e) {
    const r = e.byteLength;
    if (r < 256)
      this.writeU8(196), this.writeU8(r);
    else if (r < 65536)
      this.writeU8(197), this.writeU16(r);
    else if (r < 4294967296)
      this.writeU8(198), this.writeU32(r);
    else
      throw new Error(`Too large binary: ${r}`);
    const s = Ch(e);
    this.writeU8a(s);
  }
  encodeArray(e, r) {
    const s = e.length;
    if (s < 16)
      this.writeU8(144 + s);
    else if (s < 65536)
      this.writeU8(220), this.writeU16(s);
    else if (s < 4294967296)
      this.writeU8(221), this.writeU32(s);
    else
      throw new Error(`Too large array: ${s}`);
    for (const n of e)
      this.doEncode(n, r + 1);
  }
  countWithoutUndefined(e, r) {
    let s = 0;
    for (const n of r)
      e[n] !== void 0 && s++;
    return s;
  }
  encodeMap(e, r) {
    const s = Object.keys(e);
    this.sortKeys && s.sort();
    const n = this.ignoreUndefined ? this.countWithoutUndefined(e, s) : s.length;
    if (n < 16)
      this.writeU8(128 + n);
    else if (n < 65536)
      this.writeU8(222), this.writeU16(n);
    else if (n < 4294967296)
      this.writeU8(223), this.writeU32(n);
    else
      throw new Error(`Too large map object: ${n}`);
    for (const i of s) {
      const o = e[i];
      this.ignoreUndefined && o === void 0 || (this.encodeString(i), this.doEncode(o, r + 1));
    }
  }
  encodeExtension(e) {
    if (typeof e.data == "function") {
      const s = e.data(this.pos + 6), n = s.length;
      if (n >= 4294967296)
        throw new Error(`Too large extension object: ${n}`);
      this.writeU8(201), this.writeU32(n), this.writeI8(e.type), this.writeU8a(s);
      return;
    }
    const r = e.data.length;
    if (r === 1)
      this.writeU8(212);
    else if (r === 2)
      this.writeU8(213);
    else if (r === 4)
      this.writeU8(214);
    else if (r === 8)
      this.writeU8(215);
    else if (r === 16)
      this.writeU8(216);
    else if (r < 256)
      this.writeU8(199), this.writeU8(r);
    else if (r < 65536)
      this.writeU8(200), this.writeU16(r);
    else if (r < 4294967296)
      this.writeU8(201), this.writeU32(r);
    else
      throw new Error(`Too large extension object: ${r}`);
    this.writeI8(e.type), this.writeU8a(e.data);
  }
  writeU8(e) {
    this.ensureBufferSizeToWrite(1), this.view.setUint8(this.pos, e), this.pos++;
  }
  writeU8a(e) {
    const r = e.length;
    this.ensureBufferSizeToWrite(r), this.bytes.set(e, this.pos), this.pos += r;
  }
  writeI8(e) {
    this.ensureBufferSizeToWrite(1), this.view.setInt8(this.pos, e), this.pos++;
  }
  writeU16(e) {
    this.ensureBufferSizeToWrite(2), this.view.setUint16(this.pos, e), this.pos += 2;
  }
  writeI16(e) {
    this.ensureBufferSizeToWrite(2), this.view.setInt16(this.pos, e), this.pos += 2;
  }
  writeU32(e) {
    this.ensureBufferSizeToWrite(4), this.view.setUint32(this.pos, e), this.pos += 4;
  }
  writeI32(e) {
    this.ensureBufferSizeToWrite(4), this.view.setInt32(this.pos, e), this.pos += 4;
  }
  writeF32(e) {
    this.ensureBufferSizeToWrite(4), this.view.setFloat32(this.pos, e), this.pos += 4;
  }
  writeF64(e) {
    this.ensureBufferSizeToWrite(8), this.view.setFloat64(this.pos, e), this.pos += 8;
  }
  writeU64(e) {
    this.ensureBufferSizeToWrite(8), gk(this.view, this.pos, e), this.pos += 8;
  }
  writeI64(e) {
    this.ensureBufferSizeToWrite(8), Ay(this.view, this.pos, e), this.pos += 8;
  }
  writeBigUint64(e) {
    this.ensureBufferSizeToWrite(8), this.view.setBigUint64(this.pos, e), this.pos += 8;
  }
  writeBigInt64(e) {
    this.ensureBufferSizeToWrite(8), this.view.setBigInt64(this.pos, e), this.pos += 8;
  }
};
function Dk(t, e) {
  return new Bk(e).encodeSharedRef(t);
}
function du(t) {
  return `${t < 0 ? "-" : ""}0x${Math.abs(t).toString(16).padStart(2, "0")}`;
}
const Ok = 16, Pk = 16;
class Rk {
  constructor(e = Ok, r = Pk) {
    this.hit = 0, this.miss = 0, this.maxKeyLength = e, this.maxLengthPerKey = r, this.caches = [];
    for (let s = 0; s < this.maxKeyLength; s++)
      this.caches.push([]);
  }
  canBeCached(e) {
    return e > 0 && e <= this.maxKeyLength;
  }
  find(e, r, s) {
    const n = this.caches[s - 1];
    e: for (const i of n) {
      const o = i.bytes;
      for (let a = 0; a < s; a++)
        if (o[a] !== e[r + a])
          continue e;
      return i.str;
    }
    return null;
  }
  store(e, r) {
    const s = this.caches[e.length - 1], n = { bytes: e, str: r };
    s.length >= this.maxLengthPerKey ? s[Math.random() * s.length | 0] = n : s.push(n);
  }
  decode(e, r, s) {
    const n = this.find(e, r, s);
    if (n != null)
      return this.hit++, n;
    this.miss++;
    const i = Iy(e, r, s), o = Uint8Array.prototype.slice.call(e, r, r + s);
    return this.store(o, i), i;
  }
}
const Sh = "array", Uo = "map_key", Uy = "map_value", Nk = (t) => {
  if (typeof t == "string" || typeof t == "number")
    return t;
  throw new tr("The type of key must be string or number but " + typeof t);
};
class Lk {
  constructor() {
    this.stack = [], this.stackHeadPosition = -1;
  }
  get length() {
    return this.stackHeadPosition + 1;
  }
  top() {
    return this.stack[this.stackHeadPosition];
  }
  pushArrayState(e) {
    const r = this.getUninitializedStateFromPool();
    r.type = Sh, r.position = 0, r.size = e, r.array = new Array(e);
  }
  pushMapState(e) {
    const r = this.getUninitializedStateFromPool();
    r.type = Uo, r.readCount = 0, r.size = e, r.map = {};
  }
  getUninitializedStateFromPool() {
    if (this.stackHeadPosition++, this.stackHeadPosition === this.stack.length) {
      const e = {
        type: void 0,
        size: 0,
        array: void 0,
        position: 0,
        readCount: 0,
        map: void 0,
        key: null
      };
      this.stack.push(e);
    }
    return this.stack[this.stackHeadPosition];
  }
  release(e) {
    if (this.stack[this.stackHeadPosition] !== e)
      throw new Error("Invalid stack state. Released state is not on top of the stack.");
    if (e.type === Sh) {
      const s = e;
      s.size = 0, s.array = void 0, s.position = 0, s.type = void 0;
    }
    if (e.type === Uo || e.type === Uy) {
      const s = e;
      s.size = 0, s.map = void 0, s.readCount = 0, s.type = void 0;
    }
    this.stackHeadPosition--;
  }
  reset() {
    this.stack.length = 0, this.stackHeadPosition = -1;
  }
}
const Fi = -1, Qd = new DataView(new ArrayBuffer(0)), Mk = new Uint8Array(Qd.buffer);
try {
  Qd.getInt8(0);
} catch (t) {
  if (!(t instanceof RangeError))
    throw new Error("This module is not supported in the current JavaScript engine because DataView does not throw RangeError on out-of-bounds access");
}
const Hf = new RangeError("Insufficient data"), Fk = new Rk();
let zk = class $y {
  constructor(e) {
    this.totalPos = 0, this.pos = 0, this.view = Qd, this.bytes = Mk, this.headByte = Fi, this.stack = new Lk(), this.entered = !1, this.extensionCodec = (e == null ? void 0 : e.extensionCodec) ?? el.defaultCodec, this.context = e == null ? void 0 : e.context, this.useBigInt64 = (e == null ? void 0 : e.useBigInt64) ?? !1, this.rawStrings = (e == null ? void 0 : e.rawStrings) ?? !1, this.maxStrLength = (e == null ? void 0 : e.maxStrLength) ?? Mi, this.maxBinLength = (e == null ? void 0 : e.maxBinLength) ?? Mi, this.maxArrayLength = (e == null ? void 0 : e.maxArrayLength) ?? Mi, this.maxMapLength = (e == null ? void 0 : e.maxMapLength) ?? Mi, this.maxExtLength = (e == null ? void 0 : e.maxExtLength) ?? Mi, this.keyDecoder = (e == null ? void 0 : e.keyDecoder) !== void 0 ? e.keyDecoder : Fk, this.mapKeyConverter = (e == null ? void 0 : e.mapKeyConverter) ?? Nk;
  }
  clone() {
    return new $y({
      extensionCodec: this.extensionCodec,
      context: this.context,
      useBigInt64: this.useBigInt64,
      rawStrings: this.rawStrings,
      maxStrLength: this.maxStrLength,
      maxBinLength: this.maxBinLength,
      maxArrayLength: this.maxArrayLength,
      maxMapLength: this.maxMapLength,
      maxExtLength: this.maxExtLength,
      keyDecoder: this.keyDecoder
    });
  }
  reinitializeState() {
    this.totalPos = 0, this.headByte = Fi, this.stack.reset();
  }
  setBuffer(e) {
    const r = Ch(e);
    this.bytes = r, this.view = new DataView(r.buffer, r.byteOffset, r.byteLength), this.pos = 0;
  }
  appendBuffer(e) {
    if (this.headByte === Fi && !this.hasRemaining(1))
      this.setBuffer(e);
    else {
      const r = this.bytes.subarray(this.pos), s = Ch(e), n = new Uint8Array(r.length + s.length);
      n.set(r), n.set(s, r.length), this.setBuffer(n);
    }
  }
  hasRemaining(e) {
    return this.view.byteLength - this.pos >= e;
  }
  createExtraByteError(e) {
    const { view: r, pos: s } = this;
    return new RangeError(`Extra ${r.byteLength - s} of ${r.byteLength} byte(s) found at buffer[${e}]`);
  }
  /**
   * @throws {@link DecodeError}
   * @throws {@link RangeError}
   */
  decode(e) {
    if (this.entered)
      return this.clone().decode(e);
    try {
      this.entered = !0, this.reinitializeState(), this.setBuffer(e);
      const r = this.doDecodeSync();
      if (this.hasRemaining(1))
        throw this.createExtraByteError(this.pos);
      return r;
    } finally {
      this.entered = !1;
    }
  }
  *decodeMulti(e) {
    if (this.entered) {
      yield* this.clone().decodeMulti(e);
      return;
    }
    try {
      for (this.entered = !0, this.reinitializeState(), this.setBuffer(e); this.hasRemaining(1); )
        yield this.doDecodeSync();
    } finally {
      this.entered = !1;
    }
  }
  async decodeAsync(e) {
    if (this.entered)
      return this.clone().decodeAsync(e);
    try {
      this.entered = !0;
      let r = !1, s;
      for await (const a of e) {
        if (r)
          throw this.entered = !1, this.createExtraByteError(this.totalPos);
        this.appendBuffer(a);
        try {
          s = this.doDecodeSync(), r = !0;
        } catch (c) {
          if (!(c instanceof RangeError))
            throw c;
        }
        this.totalPos += this.pos;
      }
      if (r) {
        if (this.hasRemaining(1))
          throw this.createExtraByteError(this.totalPos);
        return s;
      }
      const { headByte: n, pos: i, totalPos: o } = this;
      throw new RangeError(`Insufficient data in parsing ${du(n)} at ${o} (${i} in the current buffer)`);
    } finally {
      this.entered = !1;
    }
  }
  decodeArrayStream(e) {
    return this.decodeMultiAsync(e, !0);
  }
  decodeStream(e) {
    return this.decodeMultiAsync(e, !1);
  }
  async *decodeMultiAsync(e, r) {
    if (this.entered) {
      yield* this.clone().decodeMultiAsync(e, r);
      return;
    }
    try {
      this.entered = !0;
      let s = r, n = -1;
      for await (const i of e) {
        if (r && n === 0)
          throw this.createExtraByteError(this.totalPos);
        this.appendBuffer(i), s && (n = this.readArraySize(), s = !1, this.complete());
        try {
          for (; yield this.doDecodeSync(), --n !== 0; )
            ;
        } catch (o) {
          if (!(o instanceof RangeError))
            throw o;
        }
        this.totalPos += this.pos;
      }
    } finally {
      this.entered = !1;
    }
  }
  doDecodeSync() {
    e: for (; ; ) {
      const e = this.readHeadByte();
      let r;
      if (e >= 224)
        r = e - 256;
      else if (e < 192)
        if (e < 128)
          r = e;
        else if (e < 144) {
          const n = e - 128;
          if (n !== 0) {
            this.pushMapState(n), this.complete();
            continue e;
          } else
            r = {};
        } else if (e < 160) {
          const n = e - 144;
          if (n !== 0) {
            this.pushArrayState(n), this.complete();
            continue e;
          } else
            r = [];
        } else {
          const n = e - 160;
          r = this.decodeString(n, 0);
        }
      else if (e === 192)
        r = null;
      else if (e === 194)
        r = !1;
      else if (e === 195)
        r = !0;
      else if (e === 202)
        r = this.readF32();
      else if (e === 203)
        r = this.readF64();
      else if (e === 204)
        r = this.readU8();
      else if (e === 205)
        r = this.readU16();
      else if (e === 206)
        r = this.readU32();
      else if (e === 207)
        this.useBigInt64 ? r = this.readU64AsBigInt() : r = this.readU64();
      else if (e === 208)
        r = this.readI8();
      else if (e === 209)
        r = this.readI16();
      else if (e === 210)
        r = this.readI32();
      else if (e === 211)
        this.useBigInt64 ? r = this.readI64AsBigInt() : r = this.readI64();
      else if (e === 217) {
        const n = this.lookU8();
        r = this.decodeString(n, 1);
      } else if (e === 218) {
        const n = this.lookU16();
        r = this.decodeString(n, 2);
      } else if (e === 219) {
        const n = this.lookU32();
        r = this.decodeString(n, 4);
      } else if (e === 220) {
        const n = this.readU16();
        if (n !== 0) {
          this.pushArrayState(n), this.complete();
          continue e;
        } else
          r = [];
      } else if (e === 221) {
        const n = this.readU32();
        if (n !== 0) {
          this.pushArrayState(n), this.complete();
          continue e;
        } else
          r = [];
      } else if (e === 222) {
        const n = this.readU16();
        if (n !== 0) {
          this.pushMapState(n), this.complete();
          continue e;
        } else
          r = {};
      } else if (e === 223) {
        const n = this.readU32();
        if (n !== 0) {
          this.pushMapState(n), this.complete();
          continue e;
        } else
          r = {};
      } else if (e === 196) {
        const n = this.lookU8();
        r = this.decodeBinary(n, 1);
      } else if (e === 197) {
        const n = this.lookU16();
        r = this.decodeBinary(n, 2);
      } else if (e === 198) {
        const n = this.lookU32();
        r = this.decodeBinary(n, 4);
      } else if (e === 212)
        r = this.decodeExtension(1, 0);
      else if (e === 213)
        r = this.decodeExtension(2, 0);
      else if (e === 214)
        r = this.decodeExtension(4, 0);
      else if (e === 215)
        r = this.decodeExtension(8, 0);
      else if (e === 216)
        r = this.decodeExtension(16, 0);
      else if (e === 199) {
        const n = this.lookU8();
        r = this.decodeExtension(n, 1);
      } else if (e === 200) {
        const n = this.lookU16();
        r = this.decodeExtension(n, 2);
      } else if (e === 201) {
        const n = this.lookU32();
        r = this.decodeExtension(n, 4);
      } else
        throw new tr(`Unrecognized type byte: ${du(e)}`);
      this.complete();
      const s = this.stack;
      for (; s.length > 0; ) {
        const n = s.top();
        if (n.type === Sh)
          if (n.array[n.position] = r, n.position++, n.position === n.size)
            r = n.array, s.release(n);
          else
            continue e;
        else if (n.type === Uo) {
          if (r === "__proto__")
            throw new tr("The key __proto__ is not allowed");
          n.key = this.mapKeyConverter(r), n.type = Uy;
          continue e;
        } else if (n.map[n.key] = r, n.readCount++, n.readCount === n.size)
          r = n.map, s.release(n);
        else {
          n.key = null, n.type = Uo;
          continue e;
        }
      }
      return r;
    }
  }
  readHeadByte() {
    return this.headByte === Fi && (this.headByte = this.readU8()), this.headByte;
  }
  complete() {
    this.headByte = Fi;
  }
  readArraySize() {
    const e = this.readHeadByte();
    switch (e) {
      case 220:
        return this.readU16();
      case 221:
        return this.readU32();
      default: {
        if (e < 160)
          return e - 144;
        throw new tr(`Unrecognized array type byte: ${du(e)}`);
      }
    }
  }
  pushMapState(e) {
    if (e > this.maxMapLength)
      throw new tr(`Max length exceeded: map length (${e}) > maxMapLengthLength (${this.maxMapLength})`);
    this.stack.pushMapState(e);
  }
  pushArrayState(e) {
    if (e > this.maxArrayLength)
      throw new tr(`Max length exceeded: array length (${e}) > maxArrayLength (${this.maxArrayLength})`);
    this.stack.pushArrayState(e);
  }
  decodeString(e, r) {
    return !this.rawStrings || this.stateIsMapKey() ? this.decodeUtf8String(e, r) : this.decodeBinary(e, r);
  }
  /**
   * @throws {@link RangeError}
   */
  decodeUtf8String(e, r) {
    var i;
    if (e > this.maxStrLength)
      throw new tr(`Max length exceeded: UTF-8 byte length (${e}) > maxStrLength (${this.maxStrLength})`);
    if (this.bytes.byteLength < this.pos + r + e)
      throw Hf;
    const s = this.pos + r;
    let n;
    return this.stateIsMapKey() && ((i = this.keyDecoder) != null && i.canBeCached(e)) ? n = this.keyDecoder.decode(this.bytes, s, e) : n = yk(this.bytes, s, e), this.pos += r + e, n;
  }
  stateIsMapKey() {
    return this.stack.length > 0 ? this.stack.top().type === Uo : !1;
  }
  /**
   * @throws {@link RangeError}
   */
  decodeBinary(e, r) {
    if (e > this.maxBinLength)
      throw new tr(`Max length exceeded: bin length (${e}) > maxBinLength (${this.maxBinLength})`);
    if (!this.hasRemaining(e + r))
      throw Hf;
    const s = this.pos + r, n = this.bytes.subarray(s, s + e);
    return this.pos += r + e, n;
  }
  decodeExtension(e, r) {
    if (e > this.maxExtLength)
      throw new tr(`Max length exceeded: ext length (${e}) > maxExtLength (${this.maxExtLength})`);
    const s = this.view.getInt8(this.pos + r), n = this.decodeBinary(
      e,
      r + 1
      /* extType */
    );
    return this.extensionCodec.decode(n, s, this.context);
  }
  lookU8() {
    return this.view.getUint8(this.pos);
  }
  lookU16() {
    return this.view.getUint16(this.pos);
  }
  lookU32() {
    return this.view.getUint32(this.pos);
  }
  readU8() {
    const e = this.view.getUint8(this.pos);
    return this.pos++, e;
  }
  readI8() {
    const e = this.view.getInt8(this.pos);
    return this.pos++, e;
  }
  readU16() {
    const e = this.view.getUint16(this.pos);
    return this.pos += 2, e;
  }
  readI16() {
    const e = this.view.getInt16(this.pos);
    return this.pos += 2, e;
  }
  readU32() {
    const e = this.view.getUint32(this.pos);
    return this.pos += 4, e;
  }
  readI32() {
    const e = this.view.getInt32(this.pos);
    return this.pos += 4, e;
  }
  readU64() {
    const e = wk(this.view, this.pos);
    return this.pos += 8, e;
  }
  readI64() {
    const e = _y(this.view, this.pos);
    return this.pos += 8, e;
  }
  readU64AsBigInt() {
    const e = this.view.getBigUint64(this.pos);
    return this.pos += 8, e;
  }
  readI64AsBigInt() {
    const e = this.view.getBigInt64(this.pos);
    return this.pos += 8, e;
  }
  readF32() {
    const e = this.view.getFloat32(this.pos);
    return this.pos += 4, e;
  }
  readF64() {
    const e = this.view.getFloat64(this.pos);
    return this.pos += 8, e;
  }
};
function jk(t, e) {
  return new zk(e).decode(t);
}
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function Hk(t) {
  return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function By(t, e) {
  return Array.isArray(e) ? e.length === 0 ? !0 : t ? e.every((r) => typeof r == "string") : e.every((r) => Number.isSafeInteger(r)) : !1;
}
function tl(t, e) {
  if (typeof e != "string")
    throw new Error(`${t}: string expected`);
  return !0;
}
function ep(t) {
  if (!Number.isSafeInteger(t))
    throw new Error(`invalid integer: ${t}`);
}
function Ih(t) {
  if (!Array.isArray(t))
    throw new Error("array expected");
}
function rl(t, e) {
  if (!By(!0, e))
    throw new Error(`${t}: array of strings expected`);
}
function qk(t, e) {
  if (!By(!1, e))
    throw new Error(`${t}: array of numbers expected`);
}
// @__NO_SIDE_EFFECTS__
function Kk(...t) {
  const e = (i) => i, r = (i, o) => (a) => i(o(a)), s = t.map((i) => i.encode).reduceRight(r, e), n = t.map((i) => i.decode).reduce(r, e);
  return { encode: s, decode: n };
}
// @__NO_SIDE_EFFECTS__
function Vk(t) {
  const e = typeof t == "string" ? t.split("") : t, r = e.length;
  rl("alphabet", e);
  const s = new Map(e.map((n, i) => [n, i]));
  return {
    encode: (n) => (Ih(n), n.map((i) => {
      if (!Number.isSafeInteger(i) || i < 0 || i >= r)
        throw new Error(`alphabet.encode: digit index outside alphabet "${i}". Allowed: ${t}`);
      return e[i];
    })),
    decode: (n) => (Ih(n), n.map((i) => {
      tl("alphabet.decode", i);
      const o = s.get(i);
      if (o === void 0)
        throw new Error(`Unknown letter: "${i}". Allowed: ${t}`);
      return o;
    }))
  };
}
// @__NO_SIDE_EFFECTS__
function Gk(t = "") {
  return tl("join", t), {
    encode: (e) => (rl("join.decode", e), e.join(t)),
    decode: (e) => (tl("join.decode", e), e.split(t))
  };
}
// @__NO_SIDE_EFFECTS__
function Wk(t, e = "=") {
  return ep(t), tl("padding", e), {
    encode(r) {
      for (rl("padding.encode", r); r.length * t % 8; )
        r.push(e);
      return r;
    },
    decode(r) {
      rl("padding.decode", r);
      let s = r.length;
      if (s * t % 8)
        throw new Error("padding: invalid, string should have whole number of bytes");
      for (; s > 0 && r[s - 1] === e; s--)
        if ((s - 1) * t % 8 === 0)
          throw new Error("padding: invalid, string has too much padding");
      return r.slice(0, s);
    }
  };
}
const Dy = (t, e) => e === 0 ? t : Dy(e, t % e), sl = /* @__NO_SIDE_EFFECTS__ */ (t, e) => t + (e - Dy(t, e)), pu = /* @__PURE__ */ (() => {
  let t = [];
  for (let e = 0; e < 40; e++)
    t.push(2 ** e);
  return t;
})();
function qf(t, e, r, s) {
  if (Ih(t), e <= 0 || e > 32)
    throw new Error(`convertRadix2: wrong from=${e}`);
  if (r <= 0 || r > 32)
    throw new Error(`convertRadix2: wrong to=${r}`);
  if (/* @__PURE__ */ sl(e, r) > 32)
    throw new Error(`convertRadix2: carry overflow from=${e} to=${r} carryBits=${/* @__PURE__ */ sl(e, r)}`);
  let n = 0, i = 0;
  const o = pu[e], a = pu[r] - 1, c = [];
  for (const l of t) {
    if (ep(l), l >= o)
      throw new Error(`convertRadix2: invalid data word=${l} from=${e}`);
    if (n = n << e | l, i + e > 32)
      throw new Error(`convertRadix2: carry overflow pos=${i} from=${e}`);
    for (i += e; i >= r; i -= r)
      c.push((n >> i - r & a) >>> 0);
    const u = pu[i];
    if (u === void 0)
      throw new Error("invalid carry");
    n &= u - 1;
  }
  if (n = n << r - i & a, !s && i >= e)
    throw new Error("Excess padding");
  if (!s && n > 0)
    throw new Error(`Non-zero padding: ${n}`);
  return s && i > 0 && c.push(n >>> 0), c;
}
// @__NO_SIDE_EFFECTS__
function Zk(t, e = !1) {
  if (ep(t), t <= 0 || t > 32)
    throw new Error("radix2: bits should be in (0..32]");
  if (/* @__PURE__ */ sl(8, t) > 32 || /* @__PURE__ */ sl(t, 8) > 32)
    throw new Error("radix2: carry overflow");
  return {
    encode: (r) => {
      if (!Hk(r))
        throw new Error("radix2.encode input should be Uint8Array");
      return qf(Array.from(r), 8, t, !e);
    },
    decode: (r) => (qk("radix2.decode", r), Uint8Array.from(qf(r, t, 8, e)))
  };
}
const Jk = /* @__PURE__ */ Kk(/* @__PURE__ */ Zk(5), /* @__PURE__ */ Vk("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), /* @__PURE__ */ Wk(5), /* @__PURE__ */ Gk(""));
function tp(t) {
  return globalThis.Buffer != null ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : t;
}
function Oy(t = 0) {
  return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? tp(globalThis.Buffer.allocUnsafe(t)) : new Uint8Array(t);
}
function Xr(t, e) {
  e || (e = t.reduce((n, i) => n + i.length, 0));
  const r = Oy(e);
  let s = 0;
  for (const n of t)
    r.set(n, s), s += n.length;
  return tp(r);
}
function Xk(t, e) {
  if (t.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var r = new Uint8Array(256), s = 0; s < r.length; s++)
    r[s] = 255;
  for (var n = 0; n < t.length; n++) {
    var i = t.charAt(n), o = i.charCodeAt(0);
    if (r[o] !== 255)
      throw new TypeError(i + " is ambiguous");
    r[o] = n;
  }
  var a = t.length, c = t.charAt(0), l = Math.log(a) / Math.log(256), u = Math.log(256) / Math.log(a);
  function h(b) {
    if (b instanceof Uint8Array || (ArrayBuffer.isView(b) ? b = new Uint8Array(b.buffer, b.byteOffset, b.byteLength) : Array.isArray(b) && (b = Uint8Array.from(b))), !(b instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (b.length === 0)
      return "";
    for (var g = 0, x = 0, I = 0, U = b.length; I !== U && b[I] === 0; )
      I++, g++;
    for (var A = (U - I) * u + 1 >>> 0, M = new Uint8Array(A); I !== U; ) {
      for (var B = b[I], q = 0, H = A - 1; (B !== 0 || q < x) && H !== -1; H--, q++)
        B += 256 * M[H] >>> 0, M[H] = B % a >>> 0, B = B / a >>> 0;
      if (B !== 0)
        throw new Error("Non-zero carry");
      x = q, I++;
    }
    for (var F = A - x; F !== A && M[F] === 0; )
      F++;
    for (var w = c.repeat(g); F < A; ++F)
      w += t.charAt(M[F]);
    return w;
  }
  function p(b) {
    if (typeof b != "string")
      throw new TypeError("Expected String");
    if (b.length === 0)
      return new Uint8Array();
    var g = 0;
    if (b[g] !== " ") {
      for (var x = 0, I = 0; b[g] === c; )
        x++, g++;
      for (var U = (b.length - g) * l + 1 >>> 0, A = new Uint8Array(U); b[g]; ) {
        var M = r[b.charCodeAt(g)];
        if (M === 255)
          return;
        for (var B = 0, q = U - 1; (M !== 0 || B < I) && q !== -1; q--, B++)
          M += a * A[q] >>> 0, A[q] = M % 256 >>> 0, M = M / 256 >>> 0;
        if (M !== 0)
          throw new Error("Non-zero carry");
        I = B, g++;
      }
      if (b[g] !== " ") {
        for (var H = U - I; H !== U && A[H] === 0; )
          H++;
        for (var F = new Uint8Array(x + (U - H)), w = x; H !== U; )
          F[w++] = A[H++];
        return F;
      }
    }
  }
  function y(b) {
    var g = p(b);
    if (g)
      return g;
    throw new Error(`Non-${e} character`);
  }
  return {
    encode: h,
    decodeUnsafe: p,
    decode: y
  };
}
var Yk = Xk, Qk = Yk;
const eC = (t) => {
  if (t instanceof Uint8Array && t.constructor.name === "Uint8Array")
    return t;
  if (t instanceof ArrayBuffer)
    return new Uint8Array(t);
  if (ArrayBuffer.isView(t))
    return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  throw new Error("Unknown type, must be binary type");
}, tC = (t) => new TextEncoder().encode(t), rC = (t) => new TextDecoder().decode(t);
class sC {
  constructor(e, r, s) {
    this.name = e, this.prefix = r, this.baseEncode = s;
  }
  encode(e) {
    if (e instanceof Uint8Array)
      return `${this.prefix}${this.baseEncode(e)}`;
    throw Error("Unknown type, must be binary type");
  }
}
class nC {
  constructor(e, r, s) {
    if (this.name = e, this.prefix = r, r.codePointAt(0) === void 0)
      throw new Error("Invalid prefix character");
    this.prefixCodePoint = r.codePointAt(0), this.baseDecode = s;
  }
  decode(e) {
    if (typeof e == "string") {
      if (e.codePointAt(0) !== this.prefixCodePoint)
        throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
      return this.baseDecode(e.slice(this.prefix.length));
    } else
      throw Error("Can only multibase decode strings");
  }
  or(e) {
    return Py(this, e);
  }
}
class iC {
  constructor(e) {
    this.decoders = e;
  }
  or(e) {
    return Py(this, e);
  }
  decode(e) {
    const r = e[0], s = this.decoders[r];
    if (s)
      return s.decode(e);
    throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
  }
}
const Py = (t, e) => new iC({
  ...t.decoders || { [t.prefix]: t },
  ...e.decoders || { [e.prefix]: e }
});
class oC {
  constructor(e, r, s, n) {
    this.name = e, this.prefix = r, this.baseEncode = s, this.baseDecode = n, this.encoder = new sC(e, r, s), this.decoder = new nC(e, r, n);
  }
  encode(e) {
    return this.encoder.encode(e);
  }
  decode(e) {
    return this.decoder.decode(e);
  }
}
const vl = ({ name: t, prefix: e, encode: r, decode: s }) => new oC(t, e, r, s), fa = ({ prefix: t, name: e, alphabet: r }) => {
  const { encode: s, decode: n } = Qk(r, e);
  return vl({
    prefix: t,
    name: e,
    encode: s,
    decode: (i) => eC(n(i))
  });
}, aC = (t, e, r, s) => {
  const n = {};
  for (let u = 0; u < e.length; ++u)
    n[e[u]] = u;
  let i = t.length;
  for (; t[i - 1] === "="; )
    --i;
  const o = new Uint8Array(i * r / 8 | 0);
  let a = 0, c = 0, l = 0;
  for (let u = 0; u < i; ++u) {
    const h = n[t[u]];
    if (h === void 0)
      throw new SyntaxError(`Non-${s} character`);
    c = c << r | h, a += r, a >= 8 && (a -= 8, o[l++] = 255 & c >> a);
  }
  if (a >= r || 255 & c << 8 - a)
    throw new SyntaxError("Unexpected end of data");
  return o;
}, cC = (t, e, r) => {
  const s = e[e.length - 1] === "=", n = (1 << r) - 1;
  let i = "", o = 0, a = 0;
  for (let c = 0; c < t.length; ++c)
    for (a = a << 8 | t[c], o += 8; o > r; )
      o -= r, i += e[n & a >> o];
  if (o && (i += e[n & a << r - o]), s)
    for (; i.length * r & 7; )
      i += "=";
  return i;
}, ft = ({ name: t, prefix: e, bitsPerChar: r, alphabet: s }) => vl({
  prefix: e,
  name: t,
  encode(n) {
    return cC(n, s, r);
  },
  decode(n) {
    return aC(n, s, r, t);
  }
}), lC = vl({
  prefix: "\0",
  name: "identity",
  encode: (t) => rC(t),
  decode: (t) => tC(t)
}), uC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  identity: lC
}, Symbol.toStringTag, { value: "Module" })), hC = ft({
  prefix: "0",
  name: "base2",
  alphabet: "01",
  bitsPerChar: 1
}), dC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base2: hC
}, Symbol.toStringTag, { value: "Module" })), pC = ft({
  prefix: "7",
  name: "base8",
  alphabet: "01234567",
  bitsPerChar: 3
}), fC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base8: pC
}, Symbol.toStringTag, { value: "Module" })), mC = fa({
  prefix: "9",
  name: "base10",
  alphabet: "0123456789"
}), bC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base10: mC
}, Symbol.toStringTag, { value: "Module" })), yC = ft({
  prefix: "f",
  name: "base16",
  alphabet: "0123456789abcdef",
  bitsPerChar: 4
}), gC = ft({
  prefix: "F",
  name: "base16upper",
  alphabet: "0123456789ABCDEF",
  bitsPerChar: 4
}), wC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base16: yC,
  base16upper: gC
}, Symbol.toStringTag, { value: "Module" })), EC = ft({
  prefix: "b",
  name: "base32",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567",
  bitsPerChar: 5
}), xC = ft({
  prefix: "B",
  name: "base32upper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
  bitsPerChar: 5
}), vC = ft({
  prefix: "c",
  name: "base32pad",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
  bitsPerChar: 5
}), kC = ft({
  prefix: "C",
  name: "base32padupper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
  bitsPerChar: 5
}), CC = ft({
  prefix: "v",
  name: "base32hex",
  alphabet: "0123456789abcdefghijklmnopqrstuv",
  bitsPerChar: 5
}), SC = ft({
  prefix: "V",
  name: "base32hexupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
  bitsPerChar: 5
}), IC = ft({
  prefix: "t",
  name: "base32hexpad",
  alphabet: "0123456789abcdefghijklmnopqrstuv=",
  bitsPerChar: 5
}), AC = ft({
  prefix: "T",
  name: "base32hexpadupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
  bitsPerChar: 5
}), _C = ft({
  prefix: "h",
  name: "base32z",
  alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
  bitsPerChar: 5
}), TC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base32: EC,
  base32hex: CC,
  base32hexpad: IC,
  base32hexpadupper: AC,
  base32hexupper: SC,
  base32pad: vC,
  base32padupper: kC,
  base32upper: xC,
  base32z: _C
}, Symbol.toStringTag, { value: "Module" })), UC = fa({
  prefix: "k",
  name: "base36",
  alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $C = fa({
  prefix: "K",
  name: "base36upper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
}), BC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base36: UC,
  base36upper: $C
}, Symbol.toStringTag, { value: "Module" })), DC = fa({
  name: "base58btc",
  prefix: "z",
  alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), OC = fa({
  name: "base58flickr",
  prefix: "Z",
  alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
}), PC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base58btc: DC,
  base58flickr: OC
}, Symbol.toStringTag, { value: "Module" })), RC = ft({
  prefix: "m",
  name: "base64",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
  bitsPerChar: 6
}), NC = ft({
  prefix: "M",
  name: "base64pad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  bitsPerChar: 6
}), LC = ft({
  prefix: "u",
  name: "base64url",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
  bitsPerChar: 6
}), MC = ft({
  prefix: "U",
  name: "base64urlpad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
  bitsPerChar: 6
}), FC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base64: RC,
  base64pad: NC,
  base64url: LC,
  base64urlpad: MC
}, Symbol.toStringTag, { value: "Module" })), Ry = Array.from("🚀🪐☄🛰🌌🌑🌒🌓🌔🌕🌖🌗🌘🌍🌏🌎🐉☀💻🖥💾💿😂❤😍🤣😊🙏💕😭😘👍😅👏😁🔥🥰💔💖💙😢🤔😆🙄💪😉☺👌🤗💜😔😎😇🌹🤦🎉💞✌✨🤷😱😌🌸🙌😋💗💚😏💛🙂💓🤩😄😀🖤😃💯🙈👇🎶😒🤭❣😜💋👀😪😑💥🙋😞😩😡🤪👊🥳😥🤤👉💃😳✋😚😝😴🌟😬🙃🍀🌷😻😓⭐✅🥺🌈😈🤘💦✔😣🏃💐☹🎊💘😠☝😕🌺🎂🌻😐🖕💝🙊😹🗣💫💀👑🎵🤞😛🔴😤🌼😫⚽🤙☕🏆🤫👈😮🙆🍻🍃🐶💁😲🌿🧡🎁⚡🌞🎈❌✊👋😰🤨😶🤝🚶💰🍓💢🤟🙁🚨💨🤬✈🎀🍺🤓😙💟🌱😖👶🥴▶➡❓💎💸⬇😨🌚🦋😷🕺⚠🙅😟😵👎🤲🤠🤧📌🔵💅🧐🐾🍒😗🤑🌊🤯🐷☎💧😯💆👆🎤🙇🍑❄🌴💣🐸💌📍🥀🤢👅💡💩👐📸👻🤐🤮🎼🥵🚩🍎🍊👼💍📣🥂"), zC = Ry.reduce((t, e, r) => (t[r] = e, t), []), jC = Ry.reduce((t, e, r) => (t[e.codePointAt(0)] = r, t), []);
function HC(t) {
  return t.reduce((e, r) => (e += zC[r], e), "");
}
function qC(t) {
  const e = [];
  for (const r of t) {
    const s = jC[r.codePointAt(0)];
    if (s === void 0)
      throw new Error(`Non-base256emoji character: ${r}`);
    e.push(s);
  }
  return new Uint8Array(e);
}
const KC = vl({
  prefix: "🚀",
  name: "base256emoji",
  encode: HC,
  decode: qC
}), VC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base256emoji: KC
}, Symbol.toStringTag, { value: "Module" }));
new TextEncoder();
new TextDecoder();
const Kf = {
  ...uC,
  ...dC,
  ...fC,
  ...bC,
  ...wC,
  ...TC,
  ...BC,
  ...PC,
  ...FC,
  ...VC
};
function Ny(t, e, r, s) {
  return {
    name: t,
    prefix: e,
    encoder: {
      name: t,
      prefix: e,
      encode: r
    },
    decoder: { decode: s }
  };
}
const Vf = Ny("utf8", "u", (t) => "u" + new TextDecoder("utf8").decode(t), (t) => new TextEncoder().encode(t.substring(1))), fu = Ny("ascii", "a", (t) => {
  let e = "a";
  for (let r = 0; r < t.length; r++)
    e += String.fromCharCode(t[r]);
  return e;
}, (t) => {
  t = t.substring(1);
  const e = Oy(t.length);
  for (let r = 0; r < t.length; r++)
    e[r] = t.charCodeAt(r);
  return e;
}), Ly = {
  utf8: Vf,
  "utf-8": Vf,
  hex: Kf.base16,
  latin1: fu,
  ascii: fu,
  binary: fu,
  ...Kf
};
function Le(t, e = "utf8") {
  const r = Ly[e];
  if (!r)
    throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? tp(globalThis.Buffer.from(t, "utf-8")) : r.decoder.decode(`${r.prefix}${t}`);
}
function Ce(t, e = "utf8") {
  const r = Ly[e];
  if (!r)
    throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(t.buffer, t.byteOffset, t.byteLength).toString("utf8") : r.encoder.encode(t).substring(1);
}
const My = { waku: { publish: "waku_publish", batchPublish: "waku_batchPublish", subscribe: "waku_subscribe", batchSubscribe: "waku_batchSubscribe", subscription: "waku_subscription", unsubscribe: "waku_unsubscribe", batchUnsubscribe: "waku_batchUnsubscribe", batchFetchMessages: "waku_batchFetchMessages" }, irn: { publish: "irn_publish", batchPublish: "irn_batchPublish", subscribe: "irn_subscribe", batchSubscribe: "irn_batchSubscribe", subscription: "irn_subscription", unsubscribe: "irn_unsubscribe", batchUnsubscribe: "irn_batchUnsubscribe", batchFetchMessages: "irn_batchFetchMessages" }, iridium: { publish: "iridium_publish", batchPublish: "iridium_batchPublish", subscribe: "iridium_subscribe", batchSubscribe: "iridium_batchSubscribe", subscription: "iridium_subscription", unsubscribe: "iridium_unsubscribe", batchUnsubscribe: "iridium_batchUnsubscribe", batchFetchMessages: "iridium_batchFetchMessages" } }, GC = "Input must be an string, Buffer or Uint8Array";
function WC(t) {
  let e;
  if (t instanceof Uint8Array)
    e = t;
  else if (typeof t == "string")
    e = new TextEncoder().encode(t);
  else
    throw new Error(GC);
  return e;
}
function ZC(t) {
  return Array.prototype.map.call(t, function(e) {
    return (e < 16 ? "0" : "") + e.toString(16);
  }).join("");
}
function za(t) {
  return (4294967296 + t).toString(16).substring(1);
}
function JC(t, e, r) {
  let s = `
` + t + " = ";
  for (let n = 0; n < e.length; n += 2) {
    if (r === 32)
      s += za(e[n]).toUpperCase(), s += " ", s += za(e[n + 1]).toUpperCase();
    else if (r === 64)
      s += za(e[n + 1]).toUpperCase(), s += za(e[n]).toUpperCase();
    else throw new Error("Invalid size " + r);
    n % 6 === 4 ? s += `
` + new Array(t.length + 4).join(" ") : n < e.length - 2 && (s += " ");
  }
  console.log(s);
}
function XC(t, e, r) {
  let s = (/* @__PURE__ */ new Date()).getTime();
  const n = new Uint8Array(e);
  for (let o = 0; o < e; o++)
    n[o] = o % 256;
  const i = (/* @__PURE__ */ new Date()).getTime();
  console.log("Generated random input in " + (i - s) + "ms"), s = i;
  for (let o = 0; o < r; o++) {
    const a = t(n), c = (/* @__PURE__ */ new Date()).getTime(), l = c - s;
    s = c, console.log("Hashed in " + l + "ms: " + a.substring(0, 20) + "..."), console.log(
      Math.round(e / (1 << 20) / (l / 1e3) * 100) / 100 + " MB PER SECOND"
    );
  }
}
var Fy = {
  normalizeInput: WC,
  toHex: ZC,
  debugPrint: JC,
  testSpeed: XC
};
const Rc = Fy;
function ja(t, e, r) {
  const s = t[e] + t[r];
  let n = t[e + 1] + t[r + 1];
  s >= 4294967296 && n++, t[e] = s, t[e + 1] = n;
}
function Gf(t, e, r, s) {
  let n = t[e] + r;
  r < 0 && (n += 4294967296);
  let i = t[e + 1] + s;
  n >= 4294967296 && i++, t[e] = n, t[e + 1] = i;
}
function zy(t, e) {
  return t[e] ^ t[e + 1] << 8 ^ t[e + 2] << 16 ^ t[e + 3] << 24;
}
function $s(t, e, r, s, n, i) {
  const o = wo[n], a = wo[n + 1], c = wo[i], l = wo[i + 1];
  ja(ce, t, e), Gf(ce, t, o, a);
  let u = ce[s] ^ ce[t], h = ce[s + 1] ^ ce[t + 1];
  ce[s] = h, ce[s + 1] = u, ja(ce, r, s), u = ce[e] ^ ce[r], h = ce[e + 1] ^ ce[r + 1], ce[e] = u >>> 24 ^ h << 8, ce[e + 1] = h >>> 24 ^ u << 8, ja(ce, t, e), Gf(ce, t, c, l), u = ce[s] ^ ce[t], h = ce[s + 1] ^ ce[t + 1], ce[s] = u >>> 16 ^ h << 16, ce[s + 1] = h >>> 16 ^ u << 16, ja(ce, r, s), u = ce[e] ^ ce[r], h = ce[e + 1] ^ ce[r + 1], ce[e] = h >>> 31 ^ u << 1, ce[e + 1] = u >>> 31 ^ h << 1;
}
const jy = new Uint32Array([
  4089235720,
  1779033703,
  2227873595,
  3144134277,
  4271175723,
  1013904242,
  1595750129,
  2773480762,
  2917565137,
  1359893119,
  725511199,
  2600822924,
  4215389547,
  528734635,
  327033209,
  1541459225
]), YC = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3,
  11,
  8,
  12,
  0,
  5,
  2,
  15,
  13,
  10,
  14,
  3,
  6,
  7,
  1,
  9,
  4,
  7,
  9,
  3,
  1,
  13,
  12,
  11,
  14,
  2,
  6,
  5,
  10,
  4,
  0,
  15,
  8,
  9,
  0,
  5,
  7,
  2,
  4,
  10,
  15,
  14,
  1,
  11,
  12,
  6,
  8,
  3,
  13,
  2,
  12,
  6,
  10,
  0,
  11,
  8,
  3,
  4,
  13,
  7,
  5,
  15,
  14,
  1,
  9,
  12,
  5,
  1,
  15,
  14,
  13,
  4,
  10,
  0,
  7,
  6,
  3,
  9,
  2,
  8,
  11,
  13,
  11,
  7,
  14,
  12,
  1,
  3,
  9,
  5,
  0,
  15,
  4,
  8,
  6,
  2,
  10,
  6,
  15,
  14,
  9,
  11,
  3,
  0,
  8,
  12,
  2,
  13,
  7,
  1,
  4,
  10,
  5,
  10,
  2,
  8,
  4,
  7,
  6,
  1,
  5,
  15,
  11,
  9,
  14,
  3,
  12,
  13,
  0,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3
], yt = new Uint8Array(
  YC.map(function(t) {
    return t * 2;
  })
), ce = new Uint32Array(32), wo = new Uint32Array(32);
function Hy(t, e) {
  let r = 0;
  for (r = 0; r < 16; r++)
    ce[r] = t.h[r], ce[r + 16] = jy[r];
  for (ce[24] = ce[24] ^ t.t, ce[25] = ce[25] ^ t.t / 4294967296, e && (ce[28] = ~ce[28], ce[29] = ~ce[29]), r = 0; r < 32; r++)
    wo[r] = zy(t.b, 4 * r);
  for (r = 0; r < 12; r++)
    $s(0, 8, 16, 24, yt[r * 16 + 0], yt[r * 16 + 1]), $s(2, 10, 18, 26, yt[r * 16 + 2], yt[r * 16 + 3]), $s(4, 12, 20, 28, yt[r * 16 + 4], yt[r * 16 + 5]), $s(6, 14, 22, 30, yt[r * 16 + 6], yt[r * 16 + 7]), $s(0, 10, 20, 30, yt[r * 16 + 8], yt[r * 16 + 9]), $s(2, 12, 22, 24, yt[r * 16 + 10], yt[r * 16 + 11]), $s(4, 14, 16, 26, yt[r * 16 + 12], yt[r * 16 + 13]), $s(6, 8, 18, 28, yt[r * 16 + 14], yt[r * 16 + 15]);
  for (r = 0; r < 16; r++)
    t.h[r] = t.h[r] ^ ce[r] ^ ce[r + 16];
}
const Bs = new Uint8Array([
  0,
  0,
  0,
  0,
  //  0: outlen, keylen, fanout, depth
  0,
  0,
  0,
  0,
  //  4: leaf length, sequential mode
  0,
  0,
  0,
  0,
  //  8: node offset
  0,
  0,
  0,
  0,
  // 12: node offset
  0,
  0,
  0,
  0,
  // 16: node depth, inner length, rfu
  0,
  0,
  0,
  0,
  // 20: rfu
  0,
  0,
  0,
  0,
  // 24: rfu
  0,
  0,
  0,
  0,
  // 28: rfu
  0,
  0,
  0,
  0,
  // 32: salt
  0,
  0,
  0,
  0,
  // 36: salt
  0,
  0,
  0,
  0,
  // 40: salt
  0,
  0,
  0,
  0,
  // 44: salt
  0,
  0,
  0,
  0,
  // 48: personal
  0,
  0,
  0,
  0,
  // 52: personal
  0,
  0,
  0,
  0,
  // 56: personal
  0,
  0,
  0,
  0
  // 60: personal
]);
function qy(t, e, r, s) {
  if (t === 0 || t > 64)
    throw new Error("Illegal output length, expected 0 < length <= 64");
  if (e && e.length > 64)
    throw new Error("Illegal key, expected Uint8Array with 0 < length <= 64");
  if (r && r.length !== 16)
    throw new Error("Illegal salt, expected Uint8Array with length is 16");
  if (s && s.length !== 16)
    throw new Error("Illegal personal, expected Uint8Array with length is 16");
  const n = {
    b: new Uint8Array(128),
    h: new Uint32Array(16),
    t: 0,
    // input count
    c: 0,
    // pointer within buffer
    outlen: t
    // output length in bytes
  };
  Bs.fill(0), Bs[0] = t, e && (Bs[1] = e.length), Bs[2] = 1, Bs[3] = 1, r && Bs.set(r, 32), s && Bs.set(s, 48);
  for (let i = 0; i < 16; i++)
    n.h[i] = jy[i] ^ zy(Bs, i * 4);
  return e && (rp(n, e), n.c = 128), n;
}
function rp(t, e) {
  for (let r = 0; r < e.length; r++)
    t.c === 128 && (t.t += t.c, Hy(t, !1), t.c = 0), t.b[t.c++] = e[r];
}
function Ky(t) {
  for (t.t += t.c; t.c < 128; )
    t.b[t.c++] = 0;
  Hy(t, !0);
  const e = new Uint8Array(t.outlen);
  for (let r = 0; r < t.outlen; r++)
    e[r] = t.h[r >> 2] >> 8 * (r & 3);
  return e;
}
function Vy(t, e, r, s, n) {
  r = r || 64, t = Rc.normalizeInput(t), s && (s = Rc.normalizeInput(s)), n && (n = Rc.normalizeInput(n));
  const i = qy(r, e, s, n);
  return rp(i, t), Ky(i);
}
function QC(t, e, r, s, n) {
  const i = Vy(t, e, r, s, n);
  return Rc.toHex(i);
}
var e5 = {
  blake2b: Vy,
  blake2bHex: QC,
  blake2bInit: qy,
  blake2bUpdate: rp,
  blake2bFinal: Ky
};
const Gy = Fy;
function t5(t, e) {
  return t[e] ^ t[e + 1] << 8 ^ t[e + 2] << 16 ^ t[e + 3] << 24;
}
function Ds(t, e, r, s, n, i) {
  we[t] = we[t] + we[e] + n, we[s] = Ha(we[s] ^ we[t], 16), we[r] = we[r] + we[s], we[e] = Ha(we[e] ^ we[r], 12), we[t] = we[t] + we[e] + i, we[s] = Ha(we[s] ^ we[t], 8), we[r] = we[r] + we[s], we[e] = Ha(we[e] ^ we[r], 7);
}
function Ha(t, e) {
  return t >>> e ^ t << 32 - e;
}
const Wy = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), gt = new Uint8Array([
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3,
  11,
  8,
  12,
  0,
  5,
  2,
  15,
  13,
  10,
  14,
  3,
  6,
  7,
  1,
  9,
  4,
  7,
  9,
  3,
  1,
  13,
  12,
  11,
  14,
  2,
  6,
  5,
  10,
  4,
  0,
  15,
  8,
  9,
  0,
  5,
  7,
  2,
  4,
  10,
  15,
  14,
  1,
  11,
  12,
  6,
  8,
  3,
  13,
  2,
  12,
  6,
  10,
  0,
  11,
  8,
  3,
  4,
  13,
  7,
  5,
  15,
  14,
  1,
  9,
  12,
  5,
  1,
  15,
  14,
  13,
  4,
  10,
  0,
  7,
  6,
  3,
  9,
  2,
  8,
  11,
  13,
  11,
  7,
  14,
  12,
  1,
  3,
  9,
  5,
  0,
  15,
  4,
  8,
  6,
  2,
  10,
  6,
  15,
  14,
  9,
  11,
  3,
  0,
  8,
  12,
  2,
  13,
  7,
  1,
  4,
  10,
  5,
  10,
  2,
  8,
  4,
  7,
  6,
  1,
  5,
  15,
  11,
  9,
  14,
  3,
  12,
  13,
  0
]), we = new Uint32Array(16), nt = new Uint32Array(16);
function Zy(t, e) {
  let r = 0;
  for (r = 0; r < 8; r++)
    we[r] = t.h[r], we[r + 8] = Wy[r];
  for (we[12] ^= t.t, we[13] ^= t.t / 4294967296, e && (we[14] = ~we[14]), r = 0; r < 16; r++)
    nt[r] = t5(t.b, 4 * r);
  for (r = 0; r < 10; r++)
    Ds(0, 4, 8, 12, nt[gt[r * 16 + 0]], nt[gt[r * 16 + 1]]), Ds(1, 5, 9, 13, nt[gt[r * 16 + 2]], nt[gt[r * 16 + 3]]), Ds(2, 6, 10, 14, nt[gt[r * 16 + 4]], nt[gt[r * 16 + 5]]), Ds(3, 7, 11, 15, nt[gt[r * 16 + 6]], nt[gt[r * 16 + 7]]), Ds(0, 5, 10, 15, nt[gt[r * 16 + 8]], nt[gt[r * 16 + 9]]), Ds(1, 6, 11, 12, nt[gt[r * 16 + 10]], nt[gt[r * 16 + 11]]), Ds(2, 7, 8, 13, nt[gt[r * 16 + 12]], nt[gt[r * 16 + 13]]), Ds(3, 4, 9, 14, nt[gt[r * 16 + 14]], nt[gt[r * 16 + 15]]);
  for (r = 0; r < 8; r++)
    t.h[r] ^= we[r] ^ we[r + 8];
}
function Jy(t, e) {
  if (!(t > 0 && t <= 32))
    throw new Error("Incorrect output length, should be in [1, 32]");
  const r = e ? e.length : 0;
  if (e && !(r > 0 && r <= 32))
    throw new Error("Incorrect key length, should be in [1, 32]");
  const s = {
    h: new Uint32Array(Wy),
    // hash state
    b: new Uint8Array(64),
    // input block
    c: 0,
    // pointer within block
    t: 0,
    // input count
    outlen: t
    // output length in bytes
  };
  return s.h[0] ^= 16842752 ^ r << 8 ^ t, r > 0 && (sp(s, e), s.c = 64), s;
}
function sp(t, e) {
  for (let r = 0; r < e.length; r++)
    t.c === 64 && (t.t += t.c, Zy(t, !1), t.c = 0), t.b[t.c++] = e[r];
}
function Xy(t) {
  for (t.t += t.c; t.c < 64; )
    t.b[t.c++] = 0;
  Zy(t, !0);
  const e = new Uint8Array(t.outlen);
  for (let r = 0; r < t.outlen; r++)
    e[r] = t.h[r >> 2] >> 8 * (r & 3) & 255;
  return e;
}
function Yy(t, e, r) {
  r = r || 32, t = Gy.normalizeInput(t);
  const s = Jy(r, e);
  return sp(s, t), Xy(s);
}
function r5(t, e, r) {
  const s = Yy(t, e, r);
  return Gy.toHex(s);
}
var s5 = {
  blake2s: Yy,
  blake2sHex: r5,
  blake2sInit: Jy,
  blake2sUpdate: sp,
  blake2sFinal: Xy
};
const zi = e5, ji = s5;
var n5 = {
  blake2b: zi.blake2b,
  blake2bHex: zi.blake2bHex,
  blake2bInit: zi.blake2bInit,
  blake2bUpdate: zi.blake2bUpdate,
  blake2bFinal: zi.blake2bFinal,
  blake2s: ji.blake2s,
  blake2sHex: ji.blake2sHex,
  blake2sInit: ji.blake2sInit,
  blake2sUpdate: ji.blake2sUpdate,
  blake2sFinal: ji.blake2sFinal
};
const i5 = "ReactNative", Or = { reactNative: "react-native", node: "node", browser: "browser", unknown: "unknown" }, o5 = "js";
function nl() {
  return typeof process < "u" && typeof process.versions < "u" && typeof process.versions.node < "u";
}
function On() {
  return !fr() && !!da() && navigator.product === i5;
}
function a5() {
  return On() && typeof globalThis < "u" && typeof (globalThis == null ? void 0 : globalThis.Platform) < "u" && (globalThis == null ? void 0 : globalThis.Platform.OS) === "android";
}
function c5() {
  return On() && typeof globalThis < "u" && typeof (globalThis == null ? void 0 : globalThis.Platform) < "u" && (globalThis == null ? void 0 : globalThis.Platform.OS) === "ios";
}
function ma() {
  return !nl() && !!da() && !!fr();
}
function kl() {
  return On() ? Or.reactNative : nl() ? Or.node : ma() ? Or.browser : Or.unknown;
}
function Wf() {
  var t;
  try {
    return On() && typeof globalThis < "u" && typeof (globalThis == null ? void 0 : globalThis.Application) < "u" ? (t = globalThis.Application) == null ? void 0 : t.applicationId : void 0;
  } catch {
    return;
  }
}
function l5(t, e) {
  const r = new URLSearchParams(t);
  for (const s of Object.keys(e).sort()) if (e.hasOwnProperty(s)) {
    const n = e[s];
    n !== void 0 && r.set(s, n);
  }
  return r.toString();
}
function u5() {
  return Jd() || { name: "", description: "", url: "", icons: [""] };
}
function h5() {
  if (kl() === Or.reactNative && typeof globalThis < "u" && typeof (globalThis == null ? void 0 : globalThis.Platform) < "u") {
    const { OS: r, Version: s } = globalThis.Platform;
    return [r, s].join("-");
  }
  const t = ly();
  if (t === null) return "unknown";
  const e = t.os ? t.os.replace(" ", "").toLowerCase() : "unknown";
  return t.type === "browser" ? [e, t.name, t.version].join("-") : [e, t.version].join("-");
}
function d5() {
  var t;
  const e = kl();
  return e === Or.browser ? [e, ((t = Wd()) == null ? void 0 : t.host) || "unknown"].join(":") : e;
}
function Qy(t, e, r) {
  const s = h5(), n = d5();
  return [[t, e].join("-"), [o5, r].join("-"), s, n].join("/");
}
function p5({ protocol: t, version: e, relayUrl: r, sdkVersion: s, auth: n, projectId: i, useOnCloseEvent: o, bundleId: a, packageName: c }) {
  const l = r.split("?"), u = Qy(t, e, s), h = { auth: n, ua: u, projectId: i, useOnCloseEvent: o, packageName: c || void 0, bundleId: a || void 0 }, p = l5(l[1] || "", h);
  return l[0] + "?" + p;
}
function Ah(t) {
  return Object.fromEntries(t.entries());
}
function _h(t) {
  return new Map(Object.entries(t));
}
function f5(t = V.FIVE_MINUTES, e) {
  const r = V.toMiliseconds(t || V.FIVE_MINUTES);
  let s, n, i, o;
  return { resolve: (a) => {
    i && s && (clearTimeout(i), s(a), o = Promise.resolve(a));
  }, reject: (a) => {
    i && n && (clearTimeout(i), n(a));
  }, done: () => new Promise((a, c) => {
    if (o) return a(o);
    i = setTimeout(() => {
      const l = new Error(e);
      o = Promise.reject(l), c(l);
    }, r), s = a, n = c;
  }) };
}
function tn(t, e, r) {
  return new Promise(async (s, n) => {
    const i = setTimeout(() => n(new Error(r)), e);
    try {
      const o = await t;
      s(o);
    } catch (o) {
      n(o);
    }
    clearTimeout(i);
  });
}
function eg(t, e) {
  if (typeof e == "string" && e.startsWith(`${t}:`)) return e;
  if (t.toLowerCase() === "topic") {
    if (typeof e != "string") throw new Error('Value must be "string" for expirer target type: topic');
    return `topic:${e}`;
  } else if (t.toLowerCase() === "id") {
    if (typeof e != "number") throw new Error('Value must be "number" for expirer target type: id');
    return `id:${e}`;
  }
  throw new Error(`Unknown expirer target type: ${t}`);
}
function m5(t) {
  return eg("topic", t);
}
function b5(t) {
  return eg("id", t);
}
function y5(t) {
  const [e, r] = t.split(":"), s = { id: void 0, topic: void 0 };
  if (e === "topic" && typeof r == "string") s.topic = r;
  else if (e === "id" && Number.isInteger(Number(r))) s.id = Number(r);
  else throw new Error(`Invalid target, expected id:number or topic:string, got ${e}:${r}`);
  return s;
}
function $o(t, e) {
  return V.fromMiliseconds(Date.now() + V.toMiliseconds(t));
}
function Zf(t) {
  return Date.now() >= V.toMiliseconds(t);
}
function mu(t, e) {
  return `${t}${e ? `:${e}` : ""}`;
}
function Jf() {
  return typeof crypto < "u" && crypto != null && crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/gu, (t) => {
    const e = Math.random() * 16 | 0;
    return (t === "x" ? e : e & 3 | 8).toString(16);
  });
}
function tg() {
  return typeof process < "u" && process.env.IS_VITEST === "true";
}
function rg(t) {
  return Buffer.from(t, "base64").toString("utf-8");
}
function g5(t) {
  return new Promise((e) => setTimeout(e, t));
}
const qa = BigInt(2 ** 32 - 1), Xf = BigInt(32);
function sg(t, e = !1) {
  return e ? { h: Number(t & qa), l: Number(t >> Xf & qa) } : { h: Number(t >> Xf & qa) | 0, l: Number(t & qa) | 0 };
}
function ng(t, e = !1) {
  const r = t.length;
  let s = new Uint32Array(r), n = new Uint32Array(r);
  for (let i = 0; i < r; i++) {
    const { h: o, l: a } = sg(t[i], e);
    [s[i], n[i]] = [o, a];
  }
  return [s, n];
}
const Yf = (t, e, r) => t >>> r, Qf = (t, e, r) => t << 32 - r | e >>> r, Gs = (t, e, r) => t >>> r | e << 32 - r, Ws = (t, e, r) => t << 32 - r | e >>> r, Eo = (t, e, r) => t << 64 - r | e >>> r - 32, xo = (t, e, r) => t >>> r - 32 | e << 64 - r, w5 = (t, e) => e, E5 = (t, e) => t, x5 = (t, e, r) => t << r | e >>> 32 - r, v5 = (t, e, r) => e << r | t >>> 32 - r, k5 = (t, e, r) => e << r - 32 | t >>> 64 - r, C5 = (t, e, r) => t << r - 32 | e >>> 64 - r;
function Ur(t, e, r, s) {
  const n = (e >>> 0) + (s >>> 0);
  return { h: t + r + (n / 2 ** 32 | 0) | 0, l: n | 0 };
}
const np = (t, e, r) => (t >>> 0) + (e >>> 0) + (r >>> 0), ip = (t, e, r, s) => e + r + s + (t / 2 ** 32 | 0) | 0, S5 = (t, e, r, s) => (t >>> 0) + (e >>> 0) + (r >>> 0) + (s >>> 0), I5 = (t, e, r, s, n) => e + r + s + n + (t / 2 ** 32 | 0) | 0, A5 = (t, e, r, s, n) => (t >>> 0) + (e >>> 0) + (r >>> 0) + (s >>> 0) + (n >>> 0), _5 = (t, e, r, s, n, i) => e + r + s + n + i + (t / 2 ** 32 | 0) | 0, qn = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
function op(t) {
  return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function vs(t) {
  if (!Number.isSafeInteger(t) || t < 0) throw new Error("positive integer expected, got " + t);
}
function mr(t, ...e) {
  if (!op(t)) throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(t.length)) throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function ap(t) {
  if (typeof t != "function" || typeof t.create != "function") throw new Error("Hash should be wrapped by utils.createHasher");
  vs(t.outputLen), vs(t.blockLen);
}
function cn(t, e = !0) {
  if (t.destroyed) throw new Error("Hash instance has been destroyed");
  if (e && t.finished) throw new Error("Hash#digest() has already been called");
}
function cp(t, e) {
  mr(t);
  const r = e.outputLen;
  if (t.length < r) throw new Error("digestInto() expects output buffer of length at least " + r);
}
function Jo(t) {
  return new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4));
}
function br(...t) {
  for (let e = 0; e < t.length; e++) t[e].fill(0);
}
function bu(t) {
  return new DataView(t.buffer, t.byteOffset, t.byteLength);
}
function zr(t, e) {
  return t << 32 - e | t >>> e;
}
const ig = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
function og(t) {
  return t << 24 & 4278190080 | t << 8 & 16711680 | t >>> 8 & 65280 | t >>> 24 & 255;
}
const fs = ig ? (t) => t : (t) => og(t);
function T5(t) {
  for (let e = 0; e < t.length; e++) t[e] = og(t[e]);
  return t;
}
const Zs = ig ? (t) => t : T5, ag = typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", U5 = Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function Xo(t) {
  if (mr(t), ag) return t.toHex();
  let e = "";
  for (let r = 0; r < t.length; r++) e += U5[t[r]];
  return e;
}
const ns = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function em(t) {
  if (t >= ns._0 && t <= ns._9) return t - ns._0;
  if (t >= ns.A && t <= ns.F) return t - (ns.A - 10);
  if (t >= ns.a && t <= ns.f) return t - (ns.a - 10);
}
function lp(t) {
  if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
  if (ag) return Uint8Array.fromHex(t);
  const e = t.length, r = e / 2;
  if (e % 2) throw new Error("hex string expected, got unpadded hex of length " + e);
  const s = new Uint8Array(r);
  for (let n = 0, i = 0; n < r; n++, i += 2) {
    const o = em(t.charCodeAt(i)), a = em(t.charCodeAt(i + 1));
    if (o === void 0 || a === void 0) {
      const c = t[i] + t[i + 1];
      throw new Error('hex string expected, got non-hex character "' + c + '" at index ' + i);
    }
    s[n] = o * 16 + a;
  }
  return s;
}
function $5(t) {
  if (typeof t != "string") throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(t));
}
function Rr(t) {
  return typeof t == "string" && (t = $5(t)), mr(t), t;
}
function wn(...t) {
  let e = 0;
  for (let s = 0; s < t.length; s++) {
    const n = t[s];
    mr(n), e += n.length;
  }
  const r = new Uint8Array(e);
  for (let s = 0, n = 0; s < t.length; s++) {
    const i = t[s];
    r.set(i, n), n += i.length;
  }
  return r;
}
let Cl = class {
};
function ba(t) {
  const e = (s) => t().update(Rr(s)).digest(), r = t();
  return e.outputLen = r.outputLen, e.blockLen = r.blockLen, e.create = () => t(), e;
}
function B5(t) {
  const e = (s, n) => t(n).update(Rr(s)).digest(), r = t({});
  return e.outputLen = r.outputLen, e.blockLen = r.blockLen, e.create = (s) => t(s), e;
}
function Ei(t = 32) {
  if (qn && typeof qn.getRandomValues == "function") return qn.getRandomValues(new Uint8Array(t));
  if (qn && typeof qn.randomBytes == "function") return Uint8Array.from(qn.randomBytes(t));
  throw new Error("crypto.getRandomValues must be defined");
}
const D5 = BigInt(0), Hi = BigInt(1), O5 = BigInt(2), P5 = BigInt(7), R5 = BigInt(256), N5 = BigInt(113), cg = [], lg = [], ug = [];
for (let t = 0, e = Hi, r = 1, s = 0; t < 24; t++) {
  [r, s] = [s, (2 * r + 3 * s) % 5], cg.push(2 * (5 * s + r)), lg.push((t + 1) * (t + 2) / 2 % 64);
  let n = D5;
  for (let i = 0; i < 7; i++) e = (e << Hi ^ (e >> P5) * N5) % R5, e & O5 && (n ^= Hi << (Hi << BigInt(i)) - Hi);
  ug.push(n);
}
const hg = ng(ug, !0), L5 = hg[0], M5 = hg[1], tm = (t, e, r) => r > 32 ? k5(t, e, r) : x5(t, e, r), rm = (t, e, r) => r > 32 ? C5(t, e, r) : v5(t, e, r);
function F5(t, e = 24) {
  const r = new Uint32Array(10);
  for (let s = 24 - e; s < 24; s++) {
    for (let o = 0; o < 10; o++) r[o] = t[o] ^ t[o + 10] ^ t[o + 20] ^ t[o + 30] ^ t[o + 40];
    for (let o = 0; o < 10; o += 2) {
      const a = (o + 8) % 10, c = (o + 2) % 10, l = r[c], u = r[c + 1], h = tm(l, u, 1) ^ r[a], p = rm(l, u, 1) ^ r[a + 1];
      for (let y = 0; y < 50; y += 10) t[o + y] ^= h, t[o + y + 1] ^= p;
    }
    let n = t[2], i = t[3];
    for (let o = 0; o < 24; o++) {
      const a = lg[o], c = tm(n, i, a), l = rm(n, i, a), u = cg[o];
      n = t[u], i = t[u + 1], t[u] = c, t[u + 1] = l;
    }
    for (let o = 0; o < 50; o += 10) {
      for (let a = 0; a < 10; a++) r[a] = t[o + a];
      for (let a = 0; a < 10; a++) t[o + a] ^= ~r[(a + 2) % 10] & r[(a + 4) % 10];
    }
    t[0] ^= L5[s], t[1] ^= M5[s];
  }
  br(r);
}
let z5 = class dg extends Cl {
  constructor(e, r, s, n = !1, i = 24) {
    if (super(), this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, this.enableXOF = !1, this.blockLen = e, this.suffix = r, this.outputLen = s, this.enableXOF = n, this.rounds = i, vs(s), !(0 < e && e < 200)) throw new Error("only keccak-f1600 function is supported");
    this.state = new Uint8Array(200), this.state32 = Jo(this.state);
  }
  clone() {
    return this._cloneInto();
  }
  keccak() {
    Zs(this.state32), F5(this.state32, this.rounds), Zs(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(e) {
    cn(this), e = Rr(e), mr(e);
    const { blockLen: r, state: s } = this, n = e.length;
    for (let i = 0; i < n; ) {
      const o = Math.min(r - this.pos, n - i);
      for (let a = 0; a < o; a++) s[this.pos++] ^= e[i++];
      this.pos === r && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished) return;
    this.finished = !0;
    const { state: e, suffix: r, pos: s, blockLen: n } = this;
    e[s] ^= r, (r & 128) !== 0 && s === n - 1 && this.keccak(), e[n - 1] ^= 128, this.keccak();
  }
  writeInto(e) {
    cn(this, !1), mr(e), this.finish();
    const r = this.state, { blockLen: s } = this;
    for (let n = 0, i = e.length; n < i; ) {
      this.posOut >= s && this.keccak();
      const o = Math.min(s - this.posOut, i - n);
      e.set(r.subarray(this.posOut, this.posOut + o), n), this.posOut += o, n += o;
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return vs(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if (cp(e, this), this.finished) throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, br(this.state);
  }
  _cloneInto(e) {
    const { blockLen: r, suffix: s, outputLen: n, rounds: i, enableXOF: o } = this;
    return e || (e = new dg(r, s, n, o, i)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = i, e.suffix = s, e.outputLen = n, e.enableXOF = o, e.destroyed = this.destroyed, e;
  }
};
const j5 = (t, e, r) => ba(() => new z5(e, t, r));
j5(1, 136, 256 / 8);
function H5(t, e, r, s) {
  if (typeof t.setBigUint64 == "function") return t.setBigUint64(e, r, s);
  const n = BigInt(32), i = BigInt(4294967295), o = Number(r >> n & i), a = Number(r & i), c = s ? 4 : 0, l = s ? 0 : 4;
  t.setUint32(e + c, o, s), t.setUint32(e + l, a, s);
}
function q5(t, e, r) {
  return t & e ^ ~t & r;
}
function K5(t, e, r) {
  return t & e ^ t & r ^ e & r;
}
let pg = class extends Cl {
  constructor(e, r, s, n) {
    super(), this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.blockLen = e, this.outputLen = r, this.padOffset = s, this.isLE = n, this.buffer = new Uint8Array(e), this.view = bu(this.buffer);
  }
  update(e) {
    cn(this), e = Rr(e), mr(e);
    const { view: r, buffer: s, blockLen: n } = this, i = e.length;
    for (let o = 0; o < i; ) {
      const a = Math.min(n - this.pos, i - o);
      if (a === n) {
        const c = bu(e);
        for (; n <= i - o; o += n) this.process(c, o);
        continue;
      }
      s.set(e.subarray(o, o + a), this.pos), this.pos += a, o += a, this.pos === n && (this.process(r, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    cn(this), cp(e, this), this.finished = !0;
    const { buffer: r, view: s, blockLen: n, isLE: i } = this;
    let { pos: o } = this;
    r[o++] = 128, br(this.buffer.subarray(o)), this.padOffset > n - o && (this.process(s, 0), o = 0);
    for (let h = o; h < n; h++) r[h] = 0;
    H5(s, n - 8, BigInt(this.length * 8), i), this.process(s, 0);
    const a = bu(e), c = this.outputLen;
    if (c % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
    const l = c / 4, u = this.get();
    if (l > u.length) throw new Error("_sha2: outputLen bigger than state");
    for (let h = 0; h < l; h++) a.setUint32(4 * h, u[h], i);
  }
  digest() {
    const { buffer: e, outputLen: r } = this;
    this.digestInto(e);
    const s = e.slice(0, r);
    return this.destroy(), s;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: r, buffer: s, length: n, finished: i, destroyed: o, pos: a } = this;
    return e.destroyed = o, e.finished = i, e.length = n, e.pos = a, n % r && e.buffer.set(s), e;
  }
  clone() {
    return this._cloneInto();
  }
};
const Os = Uint32Array.from([1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225]), wt = Uint32Array.from([3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428]), Et = Uint32Array.from([1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209]), V5 = Uint32Array.from([1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298]), Ps = new Uint32Array(64);
let G5 = class extends pg {
  constructor(e = 32) {
    super(64, e, 8, !1), this.A = Os[0] | 0, this.B = Os[1] | 0, this.C = Os[2] | 0, this.D = Os[3] | 0, this.E = Os[4] | 0, this.F = Os[5] | 0, this.G = Os[6] | 0, this.H = Os[7] | 0;
  }
  get() {
    const { A: e, B: r, C: s, D: n, E: i, F: o, G: a, H: c } = this;
    return [e, r, s, n, i, o, a, c];
  }
  set(e, r, s, n, i, o, a, c) {
    this.A = e | 0, this.B = r | 0, this.C = s | 0, this.D = n | 0, this.E = i | 0, this.F = o | 0, this.G = a | 0, this.H = c | 0;
  }
  process(e, r) {
    for (let h = 0; h < 16; h++, r += 4) Ps[h] = e.getUint32(r, !1);
    for (let h = 16; h < 64; h++) {
      const p = Ps[h - 15], y = Ps[h - 2], b = zr(p, 7) ^ zr(p, 18) ^ p >>> 3, g = zr(y, 17) ^ zr(y, 19) ^ y >>> 10;
      Ps[h] = g + Ps[h - 7] + b + Ps[h - 16] | 0;
    }
    let { A: s, B: n, C: i, D: o, E: a, F: c, G: l, H: u } = this;
    for (let h = 0; h < 64; h++) {
      const p = zr(a, 6) ^ zr(a, 11) ^ zr(a, 25), y = u + p + q5(a, c, l) + V5[h] + Ps[h] | 0, b = (zr(s, 2) ^ zr(s, 13) ^ zr(s, 22)) + K5(s, n, i) | 0;
      u = l, l = c, c = a, a = o + y | 0, o = i, i = n, n = s, s = y + b | 0;
    }
    s = s + this.A | 0, n = n + this.B | 0, i = i + this.C | 0, o = o + this.D | 0, a = a + this.E | 0, c = c + this.F | 0, l = l + this.G | 0, u = u + this.H | 0, this.set(s, n, i, o, a, c, l, u);
  }
  roundClean() {
    br(Ps);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), br(this.buffer);
  }
};
const fg = ng(["0x428a2f98d728ae22", "0x7137449123ef65cd", "0xb5c0fbcfec4d3b2f", "0xe9b5dba58189dbbc", "0x3956c25bf348b538", "0x59f111f1b605d019", "0x923f82a4af194f9b", "0xab1c5ed5da6d8118", "0xd807aa98a3030242", "0x12835b0145706fbe", "0x243185be4ee4b28c", "0x550c7dc3d5ffb4e2", "0x72be5d74f27b896f", "0x80deb1fe3b1696b1", "0x9bdc06a725c71235", "0xc19bf174cf692694", "0xe49b69c19ef14ad2", "0xefbe4786384f25e3", "0x0fc19dc68b8cd5b5", "0x240ca1cc77ac9c65", "0x2de92c6f592b0275", "0x4a7484aa6ea6e483", "0x5cb0a9dcbd41fbd4", "0x76f988da831153b5", "0x983e5152ee66dfab", "0xa831c66d2db43210", "0xb00327c898fb213f", "0xbf597fc7beef0ee4", "0xc6e00bf33da88fc2", "0xd5a79147930aa725", "0x06ca6351e003826f", "0x142929670a0e6e70", "0x27b70a8546d22ffc", "0x2e1b21385c26c926", "0x4d2c6dfc5ac42aed", "0x53380d139d95b3df", "0x650a73548baf63de", "0x766a0abb3c77b2a8", "0x81c2c92e47edaee6", "0x92722c851482353b", "0xa2bfe8a14cf10364", "0xa81a664bbc423001", "0xc24b8b70d0f89791", "0xc76c51a30654be30", "0xd192e819d6ef5218", "0xd69906245565a910", "0xf40e35855771202a", "0x106aa07032bbd1b8", "0x19a4c116b8d2d0c8", "0x1e376c085141ab53", "0x2748774cdf8eeb99", "0x34b0bcb5e19b48a8", "0x391c0cb3c5c95a63", "0x4ed8aa4ae3418acb", "0x5b9cca4f7763e373", "0x682e6ff3d6b2b8a3", "0x748f82ee5defb2fc", "0x78a5636f43172f60", "0x84c87814a1f0ab72", "0x8cc702081a6439ec", "0x90befffa23631e28", "0xa4506cebde82bde9", "0xbef9a3f7b2c67915", "0xc67178f2e372532b", "0xca273eceea26619c", "0xd186b8c721c0c207", "0xeada7dd6cde0eb1e", "0xf57d4f7fee6ed178", "0x06f067aa72176fba", "0x0a637dc5a2c898a6", "0x113f9804bef90dae", "0x1b710b35131c471b", "0x28db77f523047d84", "0x32caab7b40c72493", "0x3c9ebe0a15c9bebc", "0x431d67c49c100d4c", "0x4cc5d4becb3e42b6", "0x597f299cfc657e2a", "0x5fcb6fab3ad6faec", "0x6c44198c4a475817"].map((t) => BigInt(t))), W5 = fg[0], Z5 = fg[1], Rs = new Uint32Array(80), Ns = new Uint32Array(80);
let up = class extends pg {
  constructor(e = 64) {
    super(128, e, 16, !1), this.Ah = Et[0] | 0, this.Al = Et[1] | 0, this.Bh = Et[2] | 0, this.Bl = Et[3] | 0, this.Ch = Et[4] | 0, this.Cl = Et[5] | 0, this.Dh = Et[6] | 0, this.Dl = Et[7] | 0, this.Eh = Et[8] | 0, this.El = Et[9] | 0, this.Fh = Et[10] | 0, this.Fl = Et[11] | 0, this.Gh = Et[12] | 0, this.Gl = Et[13] | 0, this.Hh = Et[14] | 0, this.Hl = Et[15] | 0;
  }
  get() {
    const { Ah: e, Al: r, Bh: s, Bl: n, Ch: i, Cl: o, Dh: a, Dl: c, Eh: l, El: u, Fh: h, Fl: p, Gh: y, Gl: b, Hh: g, Hl: x } = this;
    return [e, r, s, n, i, o, a, c, l, u, h, p, y, b, g, x];
  }
  set(e, r, s, n, i, o, a, c, l, u, h, p, y, b, g, x) {
    this.Ah = e | 0, this.Al = r | 0, this.Bh = s | 0, this.Bl = n | 0, this.Ch = i | 0, this.Cl = o | 0, this.Dh = a | 0, this.Dl = c | 0, this.Eh = l | 0, this.El = u | 0, this.Fh = h | 0, this.Fl = p | 0, this.Gh = y | 0, this.Gl = b | 0, this.Hh = g | 0, this.Hl = x | 0;
  }
  process(e, r) {
    for (let A = 0; A < 16; A++, r += 4) Rs[A] = e.getUint32(r), Ns[A] = e.getUint32(r += 4);
    for (let A = 16; A < 80; A++) {
      const M = Rs[A - 15] | 0, B = Ns[A - 15] | 0, q = Gs(M, B, 1) ^ Gs(M, B, 8) ^ Yf(M, B, 7), H = Ws(M, B, 1) ^ Ws(M, B, 8) ^ Qf(M, B, 7), F = Rs[A - 2] | 0, w = Ns[A - 2] | 0, T = Gs(F, w, 19) ^ Eo(F, w, 61) ^ Yf(F, w, 6), k = Ws(F, w, 19) ^ xo(F, w, 61) ^ Qf(F, w, 6), S = S5(H, k, Ns[A - 7], Ns[A - 16]), O = I5(S, q, T, Rs[A - 7], Rs[A - 16]);
      Rs[A] = O | 0, Ns[A] = S | 0;
    }
    let { Ah: s, Al: n, Bh: i, Bl: o, Ch: a, Cl: c, Dh: l, Dl: u, Eh: h, El: p, Fh: y, Fl: b, Gh: g, Gl: x, Hh: I, Hl: U } = this;
    for (let A = 0; A < 80; A++) {
      const M = Gs(h, p, 14) ^ Gs(h, p, 18) ^ Eo(h, p, 41), B = Ws(h, p, 14) ^ Ws(h, p, 18) ^ xo(h, p, 41), q = h & y ^ ~h & g, H = p & b ^ ~p & x, F = A5(U, B, H, Z5[A], Ns[A]), w = _5(F, I, M, q, W5[A], Rs[A]), T = F | 0, k = Gs(s, n, 28) ^ Eo(s, n, 34) ^ Eo(s, n, 39), S = Ws(s, n, 28) ^ xo(s, n, 34) ^ xo(s, n, 39), O = s & i ^ s & a ^ i & a, N = n & o ^ n & c ^ o & c;
      I = g | 0, U = x | 0, g = y | 0, x = b | 0, y = h | 0, b = p | 0, { h, l: p } = Ur(l | 0, u | 0, w | 0, T | 0), l = a | 0, u = c | 0, a = i | 0, c = o | 0, i = s | 0, o = n | 0;
      const _ = np(T, S, N);
      s = ip(_, w, k, O), n = _ | 0;
    }
    ({ h: s, l: n } = Ur(this.Ah | 0, this.Al | 0, s | 0, n | 0)), { h: i, l: o } = Ur(this.Bh | 0, this.Bl | 0, i | 0, o | 0), { h: a, l: c } = Ur(this.Ch | 0, this.Cl | 0, a | 0, c | 0), { h: l, l: u } = Ur(this.Dh | 0, this.Dl | 0, l | 0, u | 0), { h, l: p } = Ur(this.Eh | 0, this.El | 0, h | 0, p | 0), { h: y, l: b } = Ur(this.Fh | 0, this.Fl | 0, y | 0, b | 0), { h: g, l: x } = Ur(this.Gh | 0, this.Gl | 0, g | 0, x | 0), { h: I, l: U } = Ur(this.Hh | 0, this.Hl | 0, I | 0, U | 0), this.set(s, n, i, o, a, c, l, u, h, p, y, b, g, x, I, U);
  }
  roundClean() {
    br(Rs, Ns);
  }
  destroy() {
    br(this.buffer), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}, J5 = class extends up {
  constructor() {
    super(48), this.Ah = wt[0] | 0, this.Al = wt[1] | 0, this.Bh = wt[2] | 0, this.Bl = wt[3] | 0, this.Ch = wt[4] | 0, this.Cl = wt[5] | 0, this.Dh = wt[6] | 0, this.Dl = wt[7] | 0, this.Eh = wt[8] | 0, this.El = wt[9] | 0, this.Fh = wt[10] | 0, this.Fl = wt[11] | 0, this.Gh = wt[12] | 0, this.Gl = wt[13] | 0, this.Hh = wt[14] | 0, this.Hl = wt[15] | 0;
  }
};
const xt = Uint32Array.from([573645204, 4230739756, 2673172387, 3360449730, 596883563, 1867755857, 2520282905, 1497426621, 2519219938, 2827943907, 3193839141, 1401305490, 721525244, 746961066, 246885852, 2177182882]);
let X5 = class extends up {
  constructor() {
    super(32), this.Ah = xt[0] | 0, this.Al = xt[1] | 0, this.Bh = xt[2] | 0, this.Bl = xt[3] | 0, this.Ch = xt[4] | 0, this.Cl = xt[5] | 0, this.Dh = xt[6] | 0, this.Dl = xt[7] | 0, this.Eh = xt[8] | 0, this.El = xt[9] | 0, this.Fh = xt[10] | 0, this.Fl = xt[11] | 0, this.Gh = xt[12] | 0, this.Gl = xt[13] | 0, this.Hh = xt[14] | 0, this.Hl = xt[15] | 0;
  }
};
const mg = ba(() => new G5()), Y5 = ba(() => new up()), Q5 = ba(() => new J5());
ba(() => new X5());
const e4 = Uint8Array.from([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3, 11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1, 9, 4, 7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8, 9, 0, 5, 7, 2, 4, 10, 15, 14, 1, 11, 12, 6, 8, 3, 13, 2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5, 15, 14, 1, 9, 12, 5, 1, 15, 14, 13, 4, 10, 0, 7, 6, 3, 9, 2, 8, 11, 13, 11, 7, 14, 12, 1, 3, 9, 5, 0, 15, 4, 8, 6, 2, 10, 6, 15, 14, 9, 11, 3, 0, 8, 12, 2, 13, 7, 1, 4, 10, 5, 10, 2, 8, 4, 7, 6, 1, 5, 15, 11, 9, 14, 3, 12, 13, 0, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3, 11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1, 9, 4, 7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8, 9, 0, 5, 7, 2, 4, 10, 15, 14, 1, 11, 12, 6, 8, 3, 13, 2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5, 15, 14, 1, 9]), Ge = Uint32Array.from([4089235720, 1779033703, 2227873595, 3144134277, 4271175723, 1013904242, 1595750129, 2773480762, 2917565137, 1359893119, 725511199, 2600822924, 4215389547, 528734635, 327033209, 1541459225]), ee = new Uint32Array(32);
function Ls(t, e, r, s, n, i) {
  const o = n[i], a = n[i + 1];
  let c = ee[2 * t], l = ee[2 * t + 1], u = ee[2 * e], h = ee[2 * e + 1], p = ee[2 * r], y = ee[2 * r + 1], b = ee[2 * s], g = ee[2 * s + 1], x = np(c, u, o);
  l = ip(x, l, h, a), c = x | 0, { Dh: g, Dl: b } = { Dh: g ^ l, Dl: b ^ c }, { Dh: g, Dl: b } = { Dh: w5(g, b), Dl: E5(g) }, { h: y, l: p } = Ur(y, p, g, b), { Bh: h, Bl: u } = { Bh: h ^ y, Bl: u ^ p }, { Bh: h, Bl: u } = { Bh: Gs(h, u, 24), Bl: Ws(h, u, 24) }, ee[2 * t] = c, ee[2 * t + 1] = l, ee[2 * e] = u, ee[2 * e + 1] = h, ee[2 * r] = p, ee[2 * r + 1] = y, ee[2 * s] = b, ee[2 * s + 1] = g;
}
function Ms(t, e, r, s, n, i) {
  const o = n[i], a = n[i + 1];
  let c = ee[2 * t], l = ee[2 * t + 1], u = ee[2 * e], h = ee[2 * e + 1], p = ee[2 * r], y = ee[2 * r + 1], b = ee[2 * s], g = ee[2 * s + 1], x = np(c, u, o);
  l = ip(x, l, h, a), c = x | 0, { Dh: g, Dl: b } = { Dh: g ^ l, Dl: b ^ c }, { Dh: g, Dl: b } = { Dh: Gs(g, b, 16), Dl: Ws(g, b, 16) }, { h: y, l: p } = Ur(y, p, g, b), { Bh: h, Bl: u } = { Bh: h ^ y, Bl: u ^ p }, { Bh: h, Bl: u } = { Bh: Eo(h, u, 63), Bl: xo(h, u, 63) }, ee[2 * t] = c, ee[2 * t + 1] = l, ee[2 * e] = u, ee[2 * e + 1] = h, ee[2 * r] = p, ee[2 * r + 1] = y, ee[2 * s] = b, ee[2 * s + 1] = g;
}
function t4(t, e = {}, r, s, n) {
  if (vs(r), t < 0 || t > r) throw new Error("outputLen bigger than keyLen");
  const { key: i, salt: o, personalization: a } = e;
  if (i !== void 0 && (i.length < 1 || i.length > r)) throw new Error("key length must be undefined or 1.." + r);
  if (o !== void 0 && o.length !== s) throw new Error("salt must be undefined or " + s);
  if (a !== void 0 && a.length !== n) throw new Error("personalization must be undefined or " + n);
}
let r4 = class extends Cl {
  constructor(e, r) {
    super(), this.finished = !1, this.destroyed = !1, this.length = 0, this.pos = 0, vs(e), vs(r), this.blockLen = e, this.outputLen = r, this.buffer = new Uint8Array(e), this.buffer32 = Jo(this.buffer);
  }
  update(e) {
    cn(this), e = Rr(e), mr(e);
    const { blockLen: r, buffer: s, buffer32: n } = this, i = e.length, o = e.byteOffset, a = e.buffer;
    for (let c = 0; c < i; ) {
      this.pos === r && (Zs(n), this.compress(n, 0, !1), Zs(n), this.pos = 0);
      const l = Math.min(r - this.pos, i - c), u = o + c;
      if (l === r && !(u % 4) && c + l < i) {
        const h = new Uint32Array(a, u, Math.floor((i - c) / 4));
        Zs(h);
        for (let p = 0; c + r < i; p += n.length, c += r) this.length += r, this.compress(h, p, !1);
        Zs(h);
        continue;
      }
      s.set(e.subarray(c, c + l), this.pos), this.pos += l, this.length += l, c += l;
    }
    return this;
  }
  digestInto(e) {
    cn(this), cp(e, this);
    const { pos: r, buffer32: s } = this;
    this.finished = !0, br(this.buffer.subarray(r)), Zs(s), this.compress(s, 0, !0), Zs(s);
    const n = Jo(e);
    this.get().forEach((i, o) => n[o] = fs(i));
  }
  digest() {
    const { buffer: e, outputLen: r } = this;
    this.digestInto(e);
    const s = e.slice(0, r);
    return this.destroy(), s;
  }
  _cloneInto(e) {
    const { buffer: r, length: s, finished: n, destroyed: i, outputLen: o, pos: a } = this;
    return e || (e = new this.constructor({ dkLen: o })), e.set(...this.get()), e.buffer.set(r), e.destroyed = i, e.finished = n, e.length = s, e.pos = a, e.outputLen = o, e;
  }
  clone() {
    return this._cloneInto();
  }
}, s4 = class extends r4 {
  constructor(e = {}) {
    const r = e.dkLen === void 0 ? 64 : e.dkLen;
    super(128, r), this.v0l = Ge[0] | 0, this.v0h = Ge[1] | 0, this.v1l = Ge[2] | 0, this.v1h = Ge[3] | 0, this.v2l = Ge[4] | 0, this.v2h = Ge[5] | 0, this.v3l = Ge[6] | 0, this.v3h = Ge[7] | 0, this.v4l = Ge[8] | 0, this.v4h = Ge[9] | 0, this.v5l = Ge[10] | 0, this.v5h = Ge[11] | 0, this.v6l = Ge[12] | 0, this.v6h = Ge[13] | 0, this.v7l = Ge[14] | 0, this.v7h = Ge[15] | 0, t4(r, e, 64, 16, 16);
    let { key: s, personalization: n, salt: i } = e, o = 0;
    if (s !== void 0 && (s = Rr(s), o = s.length), this.v0l ^= this.outputLen | o << 8 | 65536 | 1 << 24, i !== void 0) {
      i = Rr(i);
      const a = Jo(i);
      this.v4l ^= fs(a[0]), this.v4h ^= fs(a[1]), this.v5l ^= fs(a[2]), this.v5h ^= fs(a[3]);
    }
    if (n !== void 0) {
      n = Rr(n);
      const a = Jo(n);
      this.v6l ^= fs(a[0]), this.v6h ^= fs(a[1]), this.v7l ^= fs(a[2]), this.v7h ^= fs(a[3]);
    }
    if (s !== void 0) {
      const a = new Uint8Array(this.blockLen);
      a.set(s), this.update(a);
    }
  }
  get() {
    let { v0l: e, v0h: r, v1l: s, v1h: n, v2l: i, v2h: o, v3l: a, v3h: c, v4l: l, v4h: u, v5l: h, v5h: p, v6l: y, v6h: b, v7l: g, v7h: x } = this;
    return [e, r, s, n, i, o, a, c, l, u, h, p, y, b, g, x];
  }
  set(e, r, s, n, i, o, a, c, l, u, h, p, y, b, g, x) {
    this.v0l = e | 0, this.v0h = r | 0, this.v1l = s | 0, this.v1h = n | 0, this.v2l = i | 0, this.v2h = o | 0, this.v3l = a | 0, this.v3h = c | 0, this.v4l = l | 0, this.v4h = u | 0, this.v5l = h | 0, this.v5h = p | 0, this.v6l = y | 0, this.v6h = b | 0, this.v7l = g | 0, this.v7h = x | 0;
  }
  compress(e, r, s) {
    this.get().forEach((c, l) => ee[l] = c), ee.set(Ge, 16);
    let { h: n, l: i } = sg(BigInt(this.length));
    ee[24] = Ge[8] ^ i, ee[25] = Ge[9] ^ n, s && (ee[28] = ~ee[28], ee[29] = ~ee[29]);
    let o = 0;
    const a = e4;
    for (let c = 0; c < 12; c++) Ls(0, 4, 8, 12, e, r + 2 * a[o++]), Ms(0, 4, 8, 12, e, r + 2 * a[o++]), Ls(1, 5, 9, 13, e, r + 2 * a[o++]), Ms(1, 5, 9, 13, e, r + 2 * a[o++]), Ls(2, 6, 10, 14, e, r + 2 * a[o++]), Ms(2, 6, 10, 14, e, r + 2 * a[o++]), Ls(3, 7, 11, 15, e, r + 2 * a[o++]), Ms(3, 7, 11, 15, e, r + 2 * a[o++]), Ls(0, 5, 10, 15, e, r + 2 * a[o++]), Ms(0, 5, 10, 15, e, r + 2 * a[o++]), Ls(1, 6, 11, 12, e, r + 2 * a[o++]), Ms(1, 6, 11, 12, e, r + 2 * a[o++]), Ls(2, 7, 8, 13, e, r + 2 * a[o++]), Ms(2, 7, 8, 13, e, r + 2 * a[o++]), Ls(3, 4, 9, 14, e, r + 2 * a[o++]), Ms(3, 4, 9, 14, e, r + 2 * a[o++]);
    this.v0l ^= ee[0] ^ ee[16], this.v0h ^= ee[1] ^ ee[17], this.v1l ^= ee[2] ^ ee[18], this.v1h ^= ee[3] ^ ee[19], this.v2l ^= ee[4] ^ ee[20], this.v2h ^= ee[5] ^ ee[21], this.v3l ^= ee[6] ^ ee[22], this.v3h ^= ee[7] ^ ee[23], this.v4l ^= ee[8] ^ ee[24], this.v4h ^= ee[9] ^ ee[25], this.v5l ^= ee[10] ^ ee[26], this.v5h ^= ee[11] ^ ee[27], this.v6l ^= ee[12] ^ ee[28], this.v6h ^= ee[13] ^ ee[29], this.v7l ^= ee[14] ^ ee[30], this.v7h ^= ee[15] ^ ee[31], br(ee);
  }
  destroy() {
    this.destroyed = !0, br(this.buffer32), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
};
B5((t) => new s4(t));
/*! noble-ciphers - MIT License (c) 2023 Paul Miller (paulmillr.com) */
function bg(t) {
  return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function Th(t) {
  if (typeof t != "boolean") throw new Error(`boolean expected, not ${t}`);
}
function yu(t) {
  if (!Number.isSafeInteger(t) || t < 0) throw new Error("positive integer expected, got " + t);
}
function Ht(t, ...e) {
  if (!bg(t)) throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(t.length)) throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function sm(t, e = !0) {
  if (t.destroyed) throw new Error("Hash instance has been destroyed");
  if (e && t.finished) throw new Error("Hash#digest() has already been called");
}
function n4(t, e) {
  Ht(t);
  const r = e.outputLen;
  if (t.length < r) throw new Error("digestInto() expects output buffer of length at least " + r);
}
function sn(t) {
  return new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4));
}
function oi(...t) {
  for (let e = 0; e < t.length; e++) t[e].fill(0);
}
function i4(t) {
  return new DataView(t.buffer, t.byteOffset, t.byteLength);
}
const o4 = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
function a4(t) {
  if (typeof t != "string") throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(t));
}
function Uh(t) {
  if (typeof t == "string") t = a4(t);
  else if (bg(t)) t = $h(t);
  else throw new Error("Uint8Array expected, got " + typeof t);
  return t;
}
function c4(t, e) {
  if (e == null || typeof e != "object") throw new Error("options must be defined");
  return Object.assign(t, e);
}
function l4(t, e) {
  if (t.length !== e.length) return !1;
  let r = 0;
  for (let s = 0; s < t.length; s++) r |= t[s] ^ e[s];
  return r === 0;
}
const u4 = (t, e) => {
  function r(s, ...n) {
    if (Ht(s), !o4) throw new Error("Non little-endian hardware is not yet supported");
    if (t.nonceLength !== void 0) {
      const l = n[0];
      if (!l) throw new Error("nonce / iv required");
      t.varSizeNonce ? Ht(l) : Ht(l, t.nonceLength);
    }
    const i = t.tagLength;
    i && n[1] !== void 0 && Ht(n[1]);
    const o = e(s, ...n), a = (l, u) => {
      if (u !== void 0) {
        if (l !== 2) throw new Error("cipher output not supported");
        Ht(u);
      }
    };
    let c = !1;
    return { encrypt(l, u) {
      if (c) throw new Error("cannot encrypt() twice with same key + nonce");
      return c = !0, Ht(l), a(o.encrypt.length, u), o.encrypt(l, u);
    }, decrypt(l, u) {
      if (Ht(l), i && l.length < i) throw new Error("invalid ciphertext length: smaller than tagLength=" + i);
      return a(o.decrypt.length, u), o.decrypt(l, u);
    } };
  }
  return Object.assign(r, t), r;
};
function nm(t, e, r = !0) {
  if (e === void 0) return new Uint8Array(t);
  if (e.length !== t) throw new Error("invalid output length, expected " + t + ", got: " + e.length);
  if (r && !d4(e)) throw new Error("invalid output, must be aligned");
  return e;
}
function im(t, e, r, s) {
  if (typeof t.setBigUint64 == "function") return t.setBigUint64(e, r, s);
  const n = BigInt(32), i = BigInt(4294967295), o = Number(r >> n & i), a = Number(r & i);
  t.setUint32(e + 4, o, s), t.setUint32(e + 0, a, s);
}
function h4(t, e, r) {
  Th(r);
  const s = new Uint8Array(16), n = i4(s);
  return im(n, 0, BigInt(e), r), im(n, 8, BigInt(t), r), s;
}
function d4(t) {
  return t.byteOffset % 4 === 0;
}
function $h(t) {
  return Uint8Array.from(t);
}
const yg = (t) => Uint8Array.from(t.split("").map((e) => e.charCodeAt(0))), p4 = yg("expand 16-byte k"), f4 = yg("expand 32-byte k"), m4 = sn(p4), b4 = sn(f4);
function me(t, e) {
  return t << e | t >>> 32 - e;
}
function Bh(t) {
  return t.byteOffset % 4 === 0;
}
const Ka = 64, y4 = 16, gg = 2 ** 32 - 1, om = new Uint32Array();
function g4(t, e, r, s, n, i, o, a) {
  const c = n.length, l = new Uint8Array(Ka), u = sn(l), h = Bh(n) && Bh(i), p = h ? sn(n) : om, y = h ? sn(i) : om;
  for (let b = 0; b < c; o++) {
    if (t(e, r, s, u, o, a), o >= gg) throw new Error("arx: counter overflow");
    const g = Math.min(Ka, c - b);
    if (h && g === Ka) {
      const x = b / 4;
      if (b % 4 !== 0) throw new Error("arx: invalid block position");
      for (let I = 0, U; I < y4; I++) U = x + I, y[U] = p[U] ^ u[I];
      b += Ka;
      continue;
    }
    for (let x = 0, I; x < g; x++) I = b + x, i[I] = n[I] ^ l[x];
    b += g;
  }
}
function w4(t, e) {
  const { allowShortKeys: r, extendNonceFn: s, counterLength: n, counterRight: i, rounds: o } = c4({ allowShortKeys: !1, counterLength: 8, counterRight: !1, rounds: 20 }, e);
  if (typeof t != "function") throw new Error("core must be a function");
  return yu(n), yu(o), Th(i), Th(r), (a, c, l, u, h = 0) => {
    Ht(a), Ht(c), Ht(l);
    const p = l.length;
    if (u === void 0 && (u = new Uint8Array(p)), Ht(u), yu(h), h < 0 || h >= gg) throw new Error("arx: counter overflow");
    if (u.length < p) throw new Error(`arx: output (${u.length}) is shorter than data (${p})`);
    const y = [];
    let b = a.length, g, x;
    if (b === 32) y.push(g = $h(a)), x = b4;
    else if (b === 16 && r) g = new Uint8Array(32), g.set(a), g.set(a, 16), x = m4, y.push(g);
    else throw new Error(`arx: invalid 32-byte key, got length=${b}`);
    Bh(c) || y.push(c = $h(c));
    const I = sn(g);
    if (s) {
      if (c.length !== 24) throw new Error("arx: extended nonce must be 24 bytes");
      s(x, I, sn(c.subarray(0, 16)), I), c = c.subarray(16);
    }
    const U = 16 - n;
    if (U !== c.length) throw new Error(`arx: nonce must be ${U} or 16 bytes`);
    if (U !== 12) {
      const M = new Uint8Array(12);
      M.set(c, i ? 0 : 12 - c.length), c = M, y.push(c);
    }
    const A = sn(c);
    return g4(t, x, I, A, l, u, h, o), oi(...y), u;
  };
}
const it = (t, e) => t[e++] & 255 | (t[e++] & 255) << 8;
let E4 = class {
  constructor(e) {
    this.blockLen = 16, this.outputLen = 16, this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.pos = 0, this.finished = !1, e = Uh(e), Ht(e, 32);
    const r = it(e, 0), s = it(e, 2), n = it(e, 4), i = it(e, 6), o = it(e, 8), a = it(e, 10), c = it(e, 12), l = it(e, 14);
    this.r[0] = r & 8191, this.r[1] = (r >>> 13 | s << 3) & 8191, this.r[2] = (s >>> 10 | n << 6) & 7939, this.r[3] = (n >>> 7 | i << 9) & 8191, this.r[4] = (i >>> 4 | o << 12) & 255, this.r[5] = o >>> 1 & 8190, this.r[6] = (o >>> 14 | a << 2) & 8191, this.r[7] = (a >>> 11 | c << 5) & 8065, this.r[8] = (c >>> 8 | l << 8) & 8191, this.r[9] = l >>> 5 & 127;
    for (let u = 0; u < 8; u++) this.pad[u] = it(e, 16 + 2 * u);
  }
  process(e, r, s = !1) {
    const n = s ? 0 : 2048, { h: i, r: o } = this, a = o[0], c = o[1], l = o[2], u = o[3], h = o[4], p = o[5], y = o[6], b = o[7], g = o[8], x = o[9], I = it(e, r + 0), U = it(e, r + 2), A = it(e, r + 4), M = it(e, r + 6), B = it(e, r + 8), q = it(e, r + 10), H = it(e, r + 12), F = it(e, r + 14);
    let w = i[0] + (I & 8191), T = i[1] + ((I >>> 13 | U << 3) & 8191), k = i[2] + ((U >>> 10 | A << 6) & 8191), S = i[3] + ((A >>> 7 | M << 9) & 8191), O = i[4] + ((M >>> 4 | B << 12) & 8191), N = i[5] + (B >>> 1 & 8191), _ = i[6] + ((B >>> 14 | q << 2) & 8191), C = i[7] + ((q >>> 11 | H << 5) & 8191), $ = i[8] + ((H >>> 8 | F << 8) & 8191), P = i[9] + (F >>> 5 | n), D = 0, z = D + w * a + T * (5 * x) + k * (5 * g) + S * (5 * b) + O * (5 * y);
    D = z >>> 13, z &= 8191, z += N * (5 * p) + _ * (5 * h) + C * (5 * u) + $ * (5 * l) + P * (5 * c), D += z >>> 13, z &= 8191;
    let L = D + w * c + T * a + k * (5 * x) + S * (5 * g) + O * (5 * b);
    D = L >>> 13, L &= 8191, L += N * (5 * y) + _ * (5 * p) + C * (5 * h) + $ * (5 * u) + P * (5 * l), D += L >>> 13, L &= 8191;
    let K = D + w * l + T * c + k * a + S * (5 * x) + O * (5 * g);
    D = K >>> 13, K &= 8191, K += N * (5 * b) + _ * (5 * y) + C * (5 * p) + $ * (5 * h) + P * (5 * u), D += K >>> 13, K &= 8191;
    let J = D + w * u + T * l + k * c + S * a + O * (5 * x);
    D = J >>> 13, J &= 8191, J += N * (5 * g) + _ * (5 * b) + C * (5 * y) + $ * (5 * p) + P * (5 * h), D += J >>> 13, J &= 8191;
    let X = D + w * h + T * u + k * l + S * c + O * a;
    D = X >>> 13, X &= 8191, X += N * (5 * x) + _ * (5 * g) + C * (5 * b) + $ * (5 * y) + P * (5 * p), D += X >>> 13, X &= 8191;
    let Y = D + w * p + T * h + k * u + S * l + O * c;
    D = Y >>> 13, Y &= 8191, Y += N * a + _ * (5 * x) + C * (5 * g) + $ * (5 * b) + P * (5 * y), D += Y >>> 13, Y &= 8191;
    let re = D + w * y + T * p + k * h + S * u + O * l;
    D = re >>> 13, re &= 8191, re += N * c + _ * a + C * (5 * x) + $ * (5 * g) + P * (5 * b), D += re >>> 13, re &= 8191;
    let ae = D + w * b + T * y + k * p + S * h + O * u;
    D = ae >>> 13, ae &= 8191, ae += N * l + _ * c + C * a + $ * (5 * x) + P * (5 * g), D += ae >>> 13, ae &= 8191;
    let ne = D + w * g + T * b + k * y + S * p + O * h;
    D = ne >>> 13, ne &= 8191, ne += N * u + _ * l + C * c + $ * a + P * (5 * x), D += ne >>> 13, ne &= 8191;
    let se = D + w * x + T * g + k * b + S * y + O * p;
    D = se >>> 13, se &= 8191, se += N * h + _ * u + C * l + $ * c + P * a, D += se >>> 13, se &= 8191, D = (D << 2) + D | 0, D = D + z | 0, z = D & 8191, D = D >>> 13, L += D, i[0] = z, i[1] = L, i[2] = K, i[3] = J, i[4] = X, i[5] = Y, i[6] = re, i[7] = ae, i[8] = ne, i[9] = se;
  }
  finalize() {
    const { h: e, pad: r } = this, s = new Uint16Array(10);
    let n = e[1] >>> 13;
    e[1] &= 8191;
    for (let a = 2; a < 10; a++) e[a] += n, n = e[a] >>> 13, e[a] &= 8191;
    e[0] += n * 5, n = e[0] >>> 13, e[0] &= 8191, e[1] += n, n = e[1] >>> 13, e[1] &= 8191, e[2] += n, s[0] = e[0] + 5, n = s[0] >>> 13, s[0] &= 8191;
    for (let a = 1; a < 10; a++) s[a] = e[a] + n, n = s[a] >>> 13, s[a] &= 8191;
    s[9] -= 8192;
    let i = (n ^ 1) - 1;
    for (let a = 0; a < 10; a++) s[a] &= i;
    i = ~i;
    for (let a = 0; a < 10; a++) e[a] = e[a] & i | s[a];
    e[0] = (e[0] | e[1] << 13) & 65535, e[1] = (e[1] >>> 3 | e[2] << 10) & 65535, e[2] = (e[2] >>> 6 | e[3] << 7) & 65535, e[3] = (e[3] >>> 9 | e[4] << 4) & 65535, e[4] = (e[4] >>> 12 | e[5] << 1 | e[6] << 14) & 65535, e[5] = (e[6] >>> 2 | e[7] << 11) & 65535, e[6] = (e[7] >>> 5 | e[8] << 8) & 65535, e[7] = (e[8] >>> 8 | e[9] << 5) & 65535;
    let o = e[0] + r[0];
    e[0] = o & 65535;
    for (let a = 1; a < 8; a++) o = (e[a] + r[a] | 0) + (o >>> 16) | 0, e[a] = o & 65535;
    oi(s);
  }
  update(e) {
    sm(this), e = Uh(e), Ht(e);
    const { buffer: r, blockLen: s } = this, n = e.length;
    for (let i = 0; i < n; ) {
      const o = Math.min(s - this.pos, n - i);
      if (o === s) {
        for (; s <= n - i; i += s) this.process(e, i);
        continue;
      }
      r.set(e.subarray(i, i + o), this.pos), this.pos += o, i += o, this.pos === s && (this.process(r, 0, !1), this.pos = 0);
    }
    return this;
  }
  destroy() {
    oi(this.h, this.r, this.buffer, this.pad);
  }
  digestInto(e) {
    sm(this), n4(e, this), this.finished = !0;
    const { buffer: r, h: s } = this;
    let { pos: n } = this;
    if (n) {
      for (r[n++] = 1; n < 16; n++) r[n] = 0;
      this.process(r, 0, !0);
    }
    this.finalize();
    let i = 0;
    for (let o = 0; o < 8; o++) e[i++] = s[o] >>> 0, e[i++] = s[o] >>> 8;
    return e;
  }
  digest() {
    const { buffer: e, outputLen: r } = this;
    this.digestInto(e);
    const s = e.slice(0, r);
    return this.destroy(), s;
  }
};
function x4(t) {
  const e = (s, n) => t(n).update(Uh(s)).digest(), r = t(new Uint8Array(32));
  return e.outputLen = r.outputLen, e.blockLen = r.blockLen, e.create = (s) => t(s), e;
}
const v4 = x4((t) => new E4(t));
function k4(t, e, r, s, n, i = 20) {
  let o = t[0], a = t[1], c = t[2], l = t[3], u = e[0], h = e[1], p = e[2], y = e[3], b = e[4], g = e[5], x = e[6], I = e[7], U = n, A = r[0], M = r[1], B = r[2], q = o, H = a, F = c, w = l, T = u, k = h, S = p, O = y, N = b, _ = g, C = x, $ = I, P = U, D = A, z = M, L = B;
  for (let J = 0; J < i; J += 2) q = q + T | 0, P = me(P ^ q, 16), N = N + P | 0, T = me(T ^ N, 12), q = q + T | 0, P = me(P ^ q, 8), N = N + P | 0, T = me(T ^ N, 7), H = H + k | 0, D = me(D ^ H, 16), _ = _ + D | 0, k = me(k ^ _, 12), H = H + k | 0, D = me(D ^ H, 8), _ = _ + D | 0, k = me(k ^ _, 7), F = F + S | 0, z = me(z ^ F, 16), C = C + z | 0, S = me(S ^ C, 12), F = F + S | 0, z = me(z ^ F, 8), C = C + z | 0, S = me(S ^ C, 7), w = w + O | 0, L = me(L ^ w, 16), $ = $ + L | 0, O = me(O ^ $, 12), w = w + O | 0, L = me(L ^ w, 8), $ = $ + L | 0, O = me(O ^ $, 7), q = q + k | 0, L = me(L ^ q, 16), C = C + L | 0, k = me(k ^ C, 12), q = q + k | 0, L = me(L ^ q, 8), C = C + L | 0, k = me(k ^ C, 7), H = H + S | 0, P = me(P ^ H, 16), $ = $ + P | 0, S = me(S ^ $, 12), H = H + S | 0, P = me(P ^ H, 8), $ = $ + P | 0, S = me(S ^ $, 7), F = F + O | 0, D = me(D ^ F, 16), N = N + D | 0, O = me(O ^ N, 12), F = F + O | 0, D = me(D ^ F, 8), N = N + D | 0, O = me(O ^ N, 7), w = w + T | 0, z = me(z ^ w, 16), _ = _ + z | 0, T = me(T ^ _, 12), w = w + T | 0, z = me(z ^ w, 8), _ = _ + z | 0, T = me(T ^ _, 7);
  let K = 0;
  s[K++] = o + q | 0, s[K++] = a + H | 0, s[K++] = c + F | 0, s[K++] = l + w | 0, s[K++] = u + T | 0, s[K++] = h + k | 0, s[K++] = p + S | 0, s[K++] = y + O | 0, s[K++] = b + N | 0, s[K++] = g + _ | 0, s[K++] = x + C | 0, s[K++] = I + $ | 0, s[K++] = U + P | 0, s[K++] = A + D | 0, s[K++] = M + z | 0, s[K++] = B + L | 0;
}
const C4 = w4(k4, { counterRight: !1, counterLength: 4, allowShortKeys: !1 }), S4 = new Uint8Array(16), am = (t, e) => {
  t.update(e);
  const r = e.length % 16;
  r && t.update(S4.subarray(r));
}, I4 = new Uint8Array(32);
function cm(t, e, r, s, n) {
  const i = t(e, r, I4), o = v4.create(i);
  n && am(o, n), am(o, s);
  const a = h4(s.length, n ? n.length : 0, !0);
  o.update(a);
  const c = o.digest();
  return oi(i, a), c;
}
const A4 = (t) => (e, r, s) => ({ encrypt(n, i) {
  const o = n.length;
  i = nm(o + 16, i, !1), i.set(n);
  const a = i.subarray(0, -16);
  t(e, r, a, a, 1);
  const c = cm(t, e, r, a, s);
  return i.set(c, o), oi(c), i;
}, decrypt(n, i) {
  i = nm(n.length - 16, i, !1);
  const o = n.subarray(0, -16), a = n.subarray(-16), c = cm(t, e, r, o, s);
  if (!l4(a, c)) throw new Error("invalid tag");
  return i.set(n.subarray(0, -16)), t(e, r, i, i, 1), oi(c), i;
} }), wg = u4({ blockSize: 64, nonceLength: 12, tagLength: 16 }, A4(C4));
let Eg = class extends Cl {
  constructor(e, r) {
    super(), this.finished = !1, this.destroyed = !1, ap(e);
    const s = Rr(r);
    if (this.iHash = e.create(), typeof this.iHash.update != "function") throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const n = this.blockLen, i = new Uint8Array(n);
    i.set(s.length > n ? e.create().update(s).digest() : s);
    for (let o = 0; o < i.length; o++) i[o] ^= 54;
    this.iHash.update(i), this.oHash = e.create();
    for (let o = 0; o < i.length; o++) i[o] ^= 106;
    this.oHash.update(i), br(i);
  }
  update(e) {
    return cn(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    cn(this), mr(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: r, iHash: s, finished: n, destroyed: i, blockLen: o, outputLen: a } = this;
    return e = e, e.finished = n, e.destroyed = i, e.blockLen = o, e.outputLen = a, e.oHash = r._cloneInto(e.oHash), e.iHash = s._cloneInto(e.iHash), e;
  }
  clone() {
    return this._cloneInto();
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
};
const Sl = (t, e, r) => new Eg(t, e).update(r).digest();
Sl.create = (t, e) => new Eg(t, e);
function _4(t, e, r) {
  return ap(t), r === void 0 && (r = new Uint8Array(t.outputLen)), Sl(t, Rr(r), Rr(e));
}
const gu = Uint8Array.from([0]), lm = Uint8Array.of();
function T4(t, e, r, s = 32) {
  ap(t), vs(s);
  const n = t.outputLen;
  if (s > 255 * n) throw new Error("Length should be <= 255*HashLen");
  const i = Math.ceil(s / n);
  r === void 0 && (r = lm);
  const o = new Uint8Array(i * n), a = Sl.create(t, e), c = a._cloneInto(), l = new Uint8Array(a.outputLen);
  for (let u = 0; u < i; u++) gu[0] = u + 1, c.update(u === 0 ? lm : l).update(r).update(gu).digestInto(l), o.set(l, n * u), a._cloneInto(c);
  return a.destroy(), c.destroy(), br(l, gu), o.slice(0, s);
}
const U4 = (t, e, r, s, n) => T4(t, _4(t, e, r), s, n), Il = mg, hp = BigInt(0), Dh = BigInt(1);
function il(t, e) {
  if (typeof e != "boolean") throw new Error(t + " boolean expected, got " + e);
}
function Va(t) {
  const e = t.toString(16);
  return e.length & 1 ? "0" + e : e;
}
function xg(t) {
  if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
  return t === "" ? hp : BigInt("0x" + t);
}
function Al(t) {
  return xg(Xo(t));
}
function ol(t) {
  return mr(t), xg(Xo(Uint8Array.from(t).reverse()));
}
function dp(t, e) {
  return lp(t.toString(16).padStart(e * 2, "0"));
}
function pp(t, e) {
  return dp(t, e).reverse();
}
function Ft(t, e, r) {
  let s;
  if (typeof e == "string") try {
    s = lp(e);
  } catch (i) {
    throw new Error(t + " must be hex string or Uint8Array, cause: " + i);
  }
  else if (op(e)) s = Uint8Array.from(e);
  else throw new Error(t + " must be hex string or Uint8Array");
  const n = s.length;
  if (typeof r == "number" && n !== r) throw new Error(t + " of length " + r + " expected, got " + n);
  return s;
}
const wu = (t) => typeof t == "bigint" && hp <= t;
function $4(t, e, r) {
  return wu(t) && wu(e) && wu(r) && e <= t && t < r;
}
function Oh(t, e, r, s) {
  if (!$4(e, r, s)) throw new Error("expected valid " + t + ": " + r + " <= n < " + s + ", got " + e);
}
function B4(t) {
  let e;
  for (e = 0; t > hp; t >>= Dh, e += 1) ;
  return e;
}
const _l = (t) => (Dh << BigInt(t)) - Dh;
function D4(t, e, r) {
  if (typeof t != "number" || t < 2) throw new Error("hashLen must be a number");
  if (typeof e != "number" || e < 2) throw new Error("qByteLen must be a number");
  if (typeof r != "function") throw new Error("hmacFn must be a function");
  const s = (p) => new Uint8Array(p), n = (p) => Uint8Array.of(p);
  let i = s(t), o = s(t), a = 0;
  const c = () => {
    i.fill(1), o.fill(0), a = 0;
  }, l = (...p) => r(o, i, ...p), u = (p = s(0)) => {
    o = l(n(0), p), i = l(), p.length !== 0 && (o = l(n(1), p), i = l());
  }, h = () => {
    if (a++ >= 1e3) throw new Error("drbg: tried 1000 values");
    let p = 0;
    const y = [];
    for (; p < e; ) {
      i = l();
      const b = i.slice();
      y.push(b), p += i.length;
    }
    return wn(...y);
  };
  return (p, y) => {
    c(), u(p);
    let b;
    for (; !(b = y(h())); ) u();
    return c(), b;
  };
}
function Tl(t, e, r = {}) {
  if (!t || typeof t != "object") throw new Error("expected valid options object");
  function s(n, i, o) {
    const a = t[n];
    if (o && a === void 0) return;
    const c = typeof a;
    if (c !== i || a === null) throw new Error(`param "${n}" is invalid: expected ${i}, got ${c}`);
  }
  Object.entries(e).forEach(([n, i]) => s(n, i, !1)), Object.entries(r).forEach(([n, i]) => s(n, i, !0));
}
function um(t) {
  const e = /* @__PURE__ */ new WeakMap();
  return (r, ...s) => {
    const n = e.get(r);
    if (n !== void 0) return n;
    const i = t(r, ...s);
    return e.set(r, i), i;
  };
}
const Kt = BigInt(0), Ut = BigInt(1), En = BigInt(2), O4 = BigInt(3), vg = BigInt(4), kg = BigInt(5), Cg = BigInt(8);
function dr(t, e) {
  const r = t % e;
  return r >= Kt ? r : e + r;
}
function Ar(t, e, r) {
  let s = t;
  for (; e-- > Kt; ) s *= s, s %= r;
  return s;
}
function hm(t, e) {
  if (t === Kt) throw new Error("invert: expected non-zero number");
  if (e <= Kt) throw new Error("invert: expected positive modulus, got " + e);
  let r = dr(t, e), s = e, n = Kt, i = Ut;
  for (; r !== Kt; ) {
    const o = s / r, a = s % r, c = n - i * o;
    s = r, r = a, n = i, i = c;
  }
  if (s !== Ut) throw new Error("invert: does not exist");
  return dr(n, e);
}
function Sg(t, e) {
  const r = (t.ORDER + Ut) / vg, s = t.pow(e, r);
  if (!t.eql(t.sqr(s), e)) throw new Error("Cannot find square root");
  return s;
}
function P4(t, e) {
  const r = (t.ORDER - kg) / Cg, s = t.mul(e, En), n = t.pow(s, r), i = t.mul(e, n), o = t.mul(t.mul(i, En), n), a = t.mul(i, t.sub(o, t.ONE));
  if (!t.eql(t.sqr(a), e)) throw new Error("Cannot find square root");
  return a;
}
function R4(t) {
  if (t < BigInt(3)) throw new Error("sqrt is not defined for small field");
  let e = t - Ut, r = 0;
  for (; e % En === Kt; ) e /= En, r++;
  let s = En;
  const n = xi(t);
  for (; dm(n, s) === 1; ) if (s++ > 1e3) throw new Error("Cannot find square root: probably non-prime P");
  if (r === 1) return Sg;
  let i = n.pow(s, e);
  const o = (e + Ut) / En;
  return function(a, c) {
    if (a.is0(c)) return c;
    if (dm(a, c) !== 1) throw new Error("Cannot find square root");
    let l = r, u = a.mul(a.ONE, i), h = a.pow(c, e), p = a.pow(c, o);
    for (; !a.eql(h, a.ONE); ) {
      if (a.is0(h)) return a.ZERO;
      let y = 1, b = a.sqr(h);
      for (; !a.eql(b, a.ONE); ) if (y++, b = a.sqr(b), y === l) throw new Error("Cannot find square root");
      const g = Ut << BigInt(l - y - 1), x = a.pow(u, g);
      l = y, u = a.sqr(x), h = a.mul(h, u), p = a.mul(p, x);
    }
    return p;
  };
}
function N4(t) {
  return t % vg === O4 ? Sg : t % Cg === kg ? P4 : R4(t);
}
const L4 = ["create", "isValid", "is0", "neg", "inv", "sqrt", "sqr", "eql", "add", "sub", "mul", "pow", "div", "addN", "subN", "mulN", "sqrN"];
function M4(t) {
  const e = { ORDER: "bigint", MASK: "bigint", BYTES: "number", BITS: "number" }, r = L4.reduce((s, n) => (s[n] = "function", s), e);
  return Tl(t, r), t;
}
function F4(t, e, r) {
  if (r < Kt) throw new Error("invalid exponent, negatives unsupported");
  if (r === Kt) return t.ONE;
  if (r === Ut) return e;
  let s = t.ONE, n = e;
  for (; r > Kt; ) r & Ut && (s = t.mul(s, n)), n = t.sqr(n), r >>= Ut;
  return s;
}
function Ig(t, e, r = !1) {
  const s = new Array(e.length).fill(r ? t.ZERO : void 0), n = e.reduce((o, a, c) => t.is0(a) ? o : (s[c] = o, t.mul(o, a)), t.ONE), i = t.inv(n);
  return e.reduceRight((o, a, c) => t.is0(a) ? o : (s[c] = t.mul(o, s[c]), t.mul(o, a)), i), s;
}
function dm(t, e) {
  const r = (t.ORDER - Ut) / En, s = t.pow(e, r), n = t.eql(s, t.ONE), i = t.eql(s, t.ZERO), o = t.eql(s, t.neg(t.ONE));
  if (!n && !i && !o) throw new Error("invalid Legendre symbol result");
  return n ? 1 : i ? 0 : -1;
}
function z4(t, e) {
  e !== void 0 && vs(e);
  const r = e !== void 0 ? e : t.toString(2).length, s = Math.ceil(r / 8);
  return { nBitLength: r, nByteLength: s };
}
function xi(t, e, r = !1, s = {}) {
  if (t <= Kt) throw new Error("invalid field: expected ORDER > 0, got " + t);
  let n, i;
  if (typeof e == "object" && e != null) {
    if (s.sqrt || r) throw new Error("cannot specify opts in two arguments");
    const u = e;
    u.BITS && (n = u.BITS), u.sqrt && (i = u.sqrt), typeof u.isLE == "boolean" && (r = u.isLE);
  } else typeof e == "number" && (n = e), s.sqrt && (i = s.sqrt);
  const { nBitLength: o, nByteLength: a } = z4(t, n);
  if (a > 2048) throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let c;
  const l = Object.freeze({ ORDER: t, isLE: r, BITS: o, BYTES: a, MASK: _l(o), ZERO: Kt, ONE: Ut, create: (u) => dr(u, t), isValid: (u) => {
    if (typeof u != "bigint") throw new Error("invalid field element: expected bigint, got " + typeof u);
    return Kt <= u && u < t;
  }, is0: (u) => u === Kt, isValidNot0: (u) => !l.is0(u) && l.isValid(u), isOdd: (u) => (u & Ut) === Ut, neg: (u) => dr(-u, t), eql: (u, h) => u === h, sqr: (u) => dr(u * u, t), add: (u, h) => dr(u + h, t), sub: (u, h) => dr(u - h, t), mul: (u, h) => dr(u * h, t), pow: (u, h) => F4(l, u, h), div: (u, h) => dr(u * hm(h, t), t), sqrN: (u) => u * u, addN: (u, h) => u + h, subN: (u, h) => u - h, mulN: (u, h) => u * h, inv: (u) => hm(u, t), sqrt: i || ((u) => (c || (c = N4(t)), c(l, u))), toBytes: (u) => r ? pp(u, a) : dp(u, a), fromBytes: (u) => {
    if (u.length !== a) throw new Error("Field.fromBytes: expected " + a + " bytes, got " + u.length);
    return r ? ol(u) : Al(u);
  }, invertBatch: (u) => Ig(l, u), cmov: (u, h, p) => p ? h : u });
  return Object.freeze(l);
}
function Ag(t) {
  if (typeof t != "bigint") throw new Error("field order must be bigint");
  const e = t.toString(2).length;
  return Math.ceil(e / 8);
}
function _g(t) {
  const e = Ag(t);
  return e + Math.ceil(e / 2);
}
function j4(t, e, r = !1) {
  const s = t.length, n = Ag(e), i = _g(e);
  if (s < 16 || s < i || s > 1024) throw new Error("expected " + i + "-1024 bytes of input, got " + s);
  const o = r ? ol(t) : Al(t), a = dr(o, e - Ut) + Ut;
  return r ? pp(a, n) : dp(a, n);
}
const ai = BigInt(0), xn = BigInt(1);
function Bo(t, e) {
  const r = e.negate();
  return t ? r : e;
}
function H4(t, e, r) {
  const s = (i) => i.pz, n = Ig(t.Fp, r.map(s));
  return r.map((i, o) => i.toAffine(n[o])).map(t.fromAffine);
}
function Tg(t, e) {
  if (!Number.isSafeInteger(t) || t <= 0 || t > e) throw new Error("invalid window size, expected [1.." + e + "], got W=" + t);
}
function Eu(t, e) {
  Tg(t, e);
  const r = Math.ceil(e / t) + 1, s = 2 ** (t - 1), n = 2 ** t, i = _l(t), o = BigInt(t);
  return { windows: r, windowSize: s, mask: i, maxNumber: n, shiftBy: o };
}
function pm(t, e, r) {
  const { windowSize: s, mask: n, maxNumber: i, shiftBy: o } = r;
  let a = Number(t & n), c = t >> o;
  a > s && (a -= i, c += xn);
  const l = e * s, u = l + Math.abs(a) - 1, h = a === 0, p = a < 0, y = e % 2 !== 0;
  return { nextN: c, offset: u, isZero: h, isNeg: p, isNegF: y, offsetF: l };
}
function q4(t, e) {
  if (!Array.isArray(t)) throw new Error("array expected");
  t.forEach((r, s) => {
    if (!(r instanceof e)) throw new Error("invalid point at index " + s);
  });
}
function K4(t, e) {
  if (!Array.isArray(t)) throw new Error("array of scalars expected");
  t.forEach((r, s) => {
    if (!e.isValid(r)) throw new Error("invalid scalar at index " + s);
  });
}
const xu = /* @__PURE__ */ new WeakMap(), Ug = /* @__PURE__ */ new WeakMap();
function vu(t) {
  return Ug.get(t) || 1;
}
function fm(t) {
  if (t !== ai) throw new Error("invalid wNAF");
}
function V4(t, e) {
  return { constTimeNegate: Bo, hasPrecomputes(r) {
    return vu(r) !== 1;
  }, unsafeLadder(r, s, n = t.ZERO) {
    let i = r;
    for (; s > ai; ) s & xn && (n = n.add(i)), i = i.double(), s >>= xn;
    return n;
  }, precomputeWindow(r, s) {
    const { windows: n, windowSize: i } = Eu(s, e), o = [];
    let a = r, c = a;
    for (let l = 0; l < n; l++) {
      c = a, o.push(c);
      for (let u = 1; u < i; u++) c = c.add(a), o.push(c);
      a = c.double();
    }
    return o;
  }, wNAF(r, s, n) {
    let i = t.ZERO, o = t.BASE;
    const a = Eu(r, e);
    for (let c = 0; c < a.windows; c++) {
      const { nextN: l, offset: u, isZero: h, isNeg: p, isNegF: y, offsetF: b } = pm(n, c, a);
      n = l, h ? o = o.add(Bo(y, s[b])) : i = i.add(Bo(p, s[u]));
    }
    return fm(n), { p: i, f: o };
  }, wNAFUnsafe(r, s, n, i = t.ZERO) {
    const o = Eu(r, e);
    for (let a = 0; a < o.windows && n !== ai; a++) {
      const { nextN: c, offset: l, isZero: u, isNeg: h } = pm(n, a, o);
      if (n = c, !u) {
        const p = s[l];
        i = i.add(h ? p.negate() : p);
      }
    }
    return fm(n), i;
  }, getPrecomputes(r, s, n) {
    let i = xu.get(s);
    return i || (i = this.precomputeWindow(s, r), r !== 1 && (typeof n == "function" && (i = n(i)), xu.set(s, i))), i;
  }, wNAFCached(r, s, n) {
    const i = vu(r);
    return this.wNAF(i, this.getPrecomputes(i, r, n), s);
  }, wNAFCachedUnsafe(r, s, n, i) {
    const o = vu(r);
    return o === 1 ? this.unsafeLadder(r, s, i) : this.wNAFUnsafe(o, this.getPrecomputes(o, r, n), s, i);
  }, setWindowSize(r, s) {
    Tg(s, e), Ug.set(r, s), xu.delete(r);
  } };
}
function G4(t, e, r, s) {
  let n = e, i = t.ZERO, o = t.ZERO;
  for (; r > ai || s > ai; ) r & xn && (i = i.add(n)), s & xn && (o = o.add(n)), n = n.double(), r >>= xn, s >>= xn;
  return { p1: i, p2: o };
}
function W4(t, e, r, s) {
  q4(r, t), K4(s, e);
  const n = r.length, i = s.length;
  if (n !== i) throw new Error("arrays of points and scalars must have equal length");
  const o = t.ZERO, a = B4(BigInt(n));
  let c = 1;
  a > 12 ? c = a - 3 : a > 4 ? c = a - 2 : a > 0 && (c = 2);
  const l = _l(c), u = new Array(Number(l) + 1).fill(o), h = Math.floor((e.BITS - 1) / c) * c;
  let p = o;
  for (let y = h; y >= 0; y -= c) {
    u.fill(o);
    for (let g = 0; g < i; g++) {
      const x = s[g], I = Number(x >> BigInt(y) & l);
      u[I] = u[I].add(r[g]);
    }
    let b = o;
    for (let g = u.length - 1, x = o; g > 0; g--) x = x.add(u[g]), b = b.add(x);
    if (p = p.add(b), y !== 0) for (let g = 0; g < c; g++) p = p.double();
  }
  return p;
}
function mm(t, e) {
  if (e) {
    if (e.ORDER !== t) throw new Error("Field.ORDER must match order: Fp == p, Fn == n");
    return M4(e), e;
  } else return xi(t);
}
function Z4(t, e, r = {}) {
  if (!e || typeof e != "object") throw new Error(`expected valid ${t} CURVE object`);
  for (const o of ["p", "n", "h"]) {
    const a = e[o];
    if (!(typeof a == "bigint" && a > ai)) throw new Error(`CURVE.${o} must be positive bigint`);
  }
  const s = mm(e.p, r.Fp), n = mm(e.n, r.Fn), i = ["Gx", "Gy", "a", "b"];
  for (const o of i) if (!s.isValid(e[o])) throw new Error(`CURVE.${o} must be valid field element of CURVE.Fp`);
  return { Fp: s, Fn: n };
}
BigInt(0), BigInt(1), BigInt(2), BigInt(8);
const qi = BigInt(0), Kn = BigInt(1), Ga = BigInt(2);
function J4(t) {
  return Tl(t, { adjustScalarBytes: "function", powPminus2: "function" }), Object.freeze({ ...t });
}
function X4(t) {
  const e = J4(t), { P: r, type: s, adjustScalarBytes: n, powPminus2: i, randomBytes: o } = e, a = s === "x25519";
  if (!a && s !== "x448") throw new Error("invalid type");
  const c = o || Ei, l = a ? 255 : 448, u = a ? 32 : 56, h = BigInt(a ? 9 : 5), p = BigInt(a ? 121665 : 39081), y = a ? Ga ** BigInt(254) : Ga ** BigInt(447), b = a ? BigInt(8) * Ga ** BigInt(251) - Kn : BigInt(4) * Ga ** BigInt(445) - Kn, g = y + b + Kn, x = (w) => dr(w, r), I = U(h);
  function U(w) {
    return pp(x(w), u);
  }
  function A(w) {
    const T = Ft("u coordinate", w, u);
    return a && (T[31] &= 127), x(ol(T));
  }
  function M(w) {
    return ol(n(Ft("scalar", w, u)));
  }
  function B(w, T) {
    const k = F(A(T), M(w));
    if (k === qi) throw new Error("invalid private or public key received");
    return U(k);
  }
  function q(w) {
    return B(w, I);
  }
  function H(w, T, k) {
    const S = x(w * (T - k));
    return T = x(T - S), k = x(k + S), { x_2: T, x_3: k };
  }
  function F(w, T) {
    Oh("u", w, qi, r), Oh("scalar", T, y, g);
    const k = T, S = w;
    let O = Kn, N = qi, _ = w, C = Kn, $ = qi;
    for (let D = BigInt(l - 1); D >= qi; D--) {
      const z = k >> D & Kn;
      $ ^= z, { x_2: O, x_3: _ } = H($, O, _), { x_2: N, x_3: C } = H($, N, C), $ = z;
      const L = O + N, K = x(L * L), J = O - N, X = x(J * J), Y = K - X, re = _ + C, ae = _ - C, ne = x(ae * L), se = x(re * J), fe = ne + se, Oe = ne - se;
      _ = x(fe * fe), C = x(S * x(Oe * Oe)), O = x(K * X), N = x(Y * (K + x(p * Y)));
    }
    ({ x_2: O, x_3: _ } = H($, O, _)), { x_2: N, x_3: C } = H($, N, C);
    const P = i(N);
    return x(O * P);
  }
  return { scalarMult: B, scalarMultBase: q, getSharedSecret: (w, T) => B(w, T), getPublicKey: (w) => q(w), utils: { randomPrivateKey: () => c(u) }, GuBytes: I.slice() };
}
BigInt(0);
const Y4 = BigInt(1), bm = BigInt(2), Q4 = BigInt(3), eS = BigInt(5);
BigInt(8);
const $g = { p: BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffed"), n: BigInt("0x1000000000000000000000000000000014def9dea2f79cd65812631a5cf5d3ed"), a: BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffec"), d: BigInt("0x52036cee2b6ffe738cc740797779e89800700a4d4141d8ab75eb4dca135978a3"), Gx: BigInt("0x216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a"), Gy: BigInt("0x6666666666666666666666666666666666666666666666666666666666666658") };
function tS(t) {
  const e = BigInt(10), r = BigInt(20), s = BigInt(40), n = BigInt(80), i = $g.p, o = t * t % i * t % i, a = Ar(o, bm, i) * o % i, c = Ar(a, Y4, i) * t % i, l = Ar(c, eS, i) * c % i, u = Ar(l, e, i) * l % i, h = Ar(u, r, i) * u % i, p = Ar(h, s, i) * h % i, y = Ar(p, n, i) * p % i, b = Ar(y, n, i) * p % i, g = Ar(b, e, i) * l % i;
  return { pow_p_5_8: Ar(g, bm, i) * t % i, b2: o };
}
function rS(t) {
  return t[0] &= 248, t[31] &= 127, t[31] |= 64, t;
}
const Ph = (() => {
  const t = $g.p;
  return X4({ P: t, type: "x25519", powPminus2: (e) => {
    const { pow_p_5_8: r, b2: s } = tS(e);
    return dr(Ar(r, Q4, t) * s, t);
  }, adjustScalarBytes: rS });
})();
function ym(t) {
  t.lowS !== void 0 && il("lowS", t.lowS), t.prehash !== void 0 && il("prehash", t.prehash);
}
let sS = class extends Error {
  constructor(e = "") {
    super(e);
  }
};
const ys = { Err: sS, _tlv: { encode: (t, e) => {
  const { Err: r } = ys;
  if (t < 0 || t > 256) throw new r("tlv.encode: wrong tag");
  if (e.length & 1) throw new r("tlv.encode: unpadded data");
  const s = e.length / 2, n = Va(s);
  if (n.length / 2 & 128) throw new r("tlv.encode: long form length too big");
  const i = s > 127 ? Va(n.length / 2 | 128) : "";
  return Va(t) + i + n + e;
}, decode(t, e) {
  const { Err: r } = ys;
  let s = 0;
  if (t < 0 || t > 256) throw new r("tlv.encode: wrong tag");
  if (e.length < 2 || e[s++] !== t) throw new r("tlv.decode: wrong tlv");
  const n = e[s++], i = !!(n & 128);
  let o = 0;
  if (!i) o = n;
  else {
    const c = n & 127;
    if (!c) throw new r("tlv.decode(long): indefinite length not supported");
    if (c > 4) throw new r("tlv.decode(long): byte length is too big");
    const l = e.subarray(s, s + c);
    if (l.length !== c) throw new r("tlv.decode: length bytes not complete");
    if (l[0] === 0) throw new r("tlv.decode(long): zero leftmost byte");
    for (const u of l) o = o << 8 | u;
    if (s += c, o < 128) throw new r("tlv.decode(long): not minimal encoding");
  }
  const a = e.subarray(s, s + o);
  if (a.length !== o) throw new r("tlv.decode: wrong value length");
  return { v: a, l: e.subarray(s + o) };
} }, _int: { encode(t) {
  const { Err: e } = ys;
  if (t < Do) throw new e("integer: negative integers are not allowed");
  let r = Va(t);
  if (Number.parseInt(r[0], 16) & 8 && (r = "00" + r), r.length & 1) throw new e("unexpected DER parsing assertion: unpadded hex");
  return r;
}, decode(t) {
  const { Err: e } = ys;
  if (t[0] & 128) throw new e("invalid signature integer: negative");
  if (t[0] === 0 && !(t[1] & 128)) throw new e("invalid signature integer: unnecessary leading zero");
  return Al(t);
} }, toSig(t) {
  const { Err: e, _int: r, _tlv: s } = ys, n = Ft("signature", t), { v: i, l: o } = s.decode(48, n);
  if (o.length) throw new e("invalid signature: left bytes after parsing");
  const { v: a, l: c } = s.decode(2, i), { v: l, l: u } = s.decode(2, c);
  if (u.length) throw new e("invalid signature: left bytes after parsing");
  return { r: r.decode(a), s: r.decode(l) };
}, hexFromSig(t) {
  const { _tlv: e, _int: r } = ys, s = e.encode(2, r.encode(t.r)), n = e.encode(2, r.encode(t.s)), i = s + n;
  return e.encode(48, i);
} }, Do = BigInt(0), Oo = BigInt(1), nS = BigInt(2), Wa = BigInt(3), iS = BigInt(4);
function oS(t, e, r) {
  function s(n) {
    const i = t.sqr(n), o = t.mul(i, n);
    return t.add(t.add(o, t.mul(n, e)), r);
  }
  return s;
}
function Bg(t, e, r) {
  const { BYTES: s } = t;
  function n(i) {
    let o;
    if (typeof i == "bigint") o = i;
    else {
      let a = Ft("private key", i);
      if (e) {
        if (!e.includes(a.length * 2)) throw new Error("invalid private key");
        const c = new Uint8Array(s);
        c.set(a, c.length - a.length), a = c;
      }
      try {
        o = t.fromBytes(a);
      } catch {
        throw new Error(`invalid private key: expected ui8a of size ${s}, got ${typeof i}`);
      }
    }
    if (r && (o = t.create(o)), !t.isValidNot0(o)) throw new Error("invalid private key: out of range [1..N-1]");
    return o;
  }
  return n;
}
function aS(t, e = {}) {
  const { Fp: r, Fn: s } = Z4("weierstrass", t, e), { h: n, n: i } = t;
  Tl(e, {}, { allowInfinityPoint: "boolean", clearCofactor: "function", isTorsionFree: "function", fromBytes: "function", toBytes: "function", endo: "object", wrapPrivateKey: "boolean" });
  const { endo: o } = e;
  if (o && (!r.is0(t.a) || typeof o.beta != "bigint" || typeof o.splitScalar != "function")) throw new Error('invalid endo: expected "beta": bigint and "splitScalar": function');
  function a() {
    if (!r.isOdd) throw new Error("compression is not supported: Field does not have .isOdd()");
  }
  function c(F, w, T) {
    const { x: k, y: S } = w.toAffine(), O = r.toBytes(k);
    if (il("isCompressed", T), T) {
      a();
      const N = !r.isOdd(S);
      return wn(Dg(N), O);
    } else return wn(Uint8Array.of(4), O, r.toBytes(S));
  }
  function l(F) {
    mr(F);
    const w = r.BYTES, T = w + 1, k = 2 * w + 1, S = F.length, O = F[0], N = F.subarray(1);
    if (S === T && (O === 2 || O === 3)) {
      const _ = r.fromBytes(N);
      if (!r.isValid(_)) throw new Error("bad point: is not on curve, wrong x");
      const C = p(_);
      let $;
      try {
        $ = r.sqrt(C);
      } catch (D) {
        const z = D instanceof Error ? ": " + D.message : "";
        throw new Error("bad point: is not on curve, sqrt error" + z);
      }
      a();
      const P = r.isOdd($);
      return (O & 1) === 1 !== P && ($ = r.neg($)), { x: _, y: $ };
    } else if (S === k && O === 4) {
      const _ = r.fromBytes(N.subarray(w * 0, w * 1)), C = r.fromBytes(N.subarray(w * 1, w * 2));
      if (!y(_, C)) throw new Error("bad point: is not on curve");
      return { x: _, y: C };
    } else throw new Error(`bad point: got length ${S}, expected compressed=${T} or uncompressed=${k}`);
  }
  const u = e.toBytes || c, h = e.fromBytes || l, p = oS(r, t.a, t.b);
  function y(F, w) {
    const T = r.sqr(w), k = p(F);
    return r.eql(T, k);
  }
  if (!y(t.Gx, t.Gy)) throw new Error("bad curve params: generator point");
  const b = r.mul(r.pow(t.a, Wa), iS), g = r.mul(r.sqr(t.b), BigInt(27));
  if (r.is0(r.add(b, g))) throw new Error("bad curve params: a or b");
  function x(F, w, T = !1) {
    if (!r.isValid(w) || T && r.is0(w)) throw new Error(`bad point coordinate ${F}`);
    return w;
  }
  function I(F) {
    if (!(F instanceof B)) throw new Error("ProjectivePoint expected");
  }
  const U = um((F, w) => {
    const { px: T, py: k, pz: S } = F;
    if (r.eql(S, r.ONE)) return { x: T, y: k };
    const O = F.is0();
    w == null && (w = O ? r.ONE : r.inv(S));
    const N = r.mul(T, w), _ = r.mul(k, w), C = r.mul(S, w);
    if (O) return { x: r.ZERO, y: r.ZERO };
    if (!r.eql(C, r.ONE)) throw new Error("invZ was invalid");
    return { x: N, y: _ };
  }), A = um((F) => {
    if (F.is0()) {
      if (e.allowInfinityPoint && !r.is0(F.py)) return;
      throw new Error("bad point: ZERO");
    }
    const { x: w, y: T } = F.toAffine();
    if (!r.isValid(w) || !r.isValid(T)) throw new Error("bad point: x or y not field elements");
    if (!y(w, T)) throw new Error("bad point: equation left != right");
    if (!F.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
    return !0;
  });
  function M(F, w, T, k, S) {
    return T = new B(r.mul(T.px, F), T.py, T.pz), w = Bo(k, w), T = Bo(S, T), w.add(T);
  }
  class B {
    constructor(w, T, k) {
      this.px = x("x", w), this.py = x("y", T, !0), this.pz = x("z", k), Object.freeze(this);
    }
    static fromAffine(w) {
      const { x: T, y: k } = w || {};
      if (!w || !r.isValid(T) || !r.isValid(k)) throw new Error("invalid affine point");
      if (w instanceof B) throw new Error("projective point not allowed");
      return r.is0(T) && r.is0(k) ? B.ZERO : new B(T, k, r.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static normalizeZ(w) {
      return H4(B, "pz", w);
    }
    static fromBytes(w) {
      return mr(w), B.fromHex(w);
    }
    static fromHex(w) {
      const T = B.fromAffine(h(Ft("pointHex", w)));
      return T.assertValidity(), T;
    }
    static fromPrivateKey(w) {
      const T = Bg(s, e.allowedPrivateKeyLengths, e.wrapPrivateKey);
      return B.BASE.multiply(T(w));
    }
    static msm(w, T) {
      return W4(B, s, w, T);
    }
    precompute(w = 8, T = !0) {
      return H.setWindowSize(this, w), T || this.multiply(Wa), this;
    }
    _setWindowSize(w) {
      this.precompute(w);
    }
    assertValidity() {
      A(this);
    }
    hasEvenY() {
      const { y: w } = this.toAffine();
      if (!r.isOdd) throw new Error("Field doesn't support isOdd");
      return !r.isOdd(w);
    }
    equals(w) {
      I(w);
      const { px: T, py: k, pz: S } = this, { px: O, py: N, pz: _ } = w, C = r.eql(r.mul(T, _), r.mul(O, S)), $ = r.eql(r.mul(k, _), r.mul(N, S));
      return C && $;
    }
    negate() {
      return new B(this.px, r.neg(this.py), this.pz);
    }
    double() {
      const { a: w, b: T } = t, k = r.mul(T, Wa), { px: S, py: O, pz: N } = this;
      let _ = r.ZERO, C = r.ZERO, $ = r.ZERO, P = r.mul(S, S), D = r.mul(O, O), z = r.mul(N, N), L = r.mul(S, O);
      return L = r.add(L, L), $ = r.mul(S, N), $ = r.add($, $), _ = r.mul(w, $), C = r.mul(k, z), C = r.add(_, C), _ = r.sub(D, C), C = r.add(D, C), C = r.mul(_, C), _ = r.mul(L, _), $ = r.mul(k, $), z = r.mul(w, z), L = r.sub(P, z), L = r.mul(w, L), L = r.add(L, $), $ = r.add(P, P), P = r.add($, P), P = r.add(P, z), P = r.mul(P, L), C = r.add(C, P), z = r.mul(O, N), z = r.add(z, z), P = r.mul(z, L), _ = r.sub(_, P), $ = r.mul(z, D), $ = r.add($, $), $ = r.add($, $), new B(_, C, $);
    }
    add(w) {
      I(w);
      const { px: T, py: k, pz: S } = this, { px: O, py: N, pz: _ } = w;
      let C = r.ZERO, $ = r.ZERO, P = r.ZERO;
      const D = t.a, z = r.mul(t.b, Wa);
      let L = r.mul(T, O), K = r.mul(k, N), J = r.mul(S, _), X = r.add(T, k), Y = r.add(O, N);
      X = r.mul(X, Y), Y = r.add(L, K), X = r.sub(X, Y), Y = r.add(T, S);
      let re = r.add(O, _);
      return Y = r.mul(Y, re), re = r.add(L, J), Y = r.sub(Y, re), re = r.add(k, S), C = r.add(N, _), re = r.mul(re, C), C = r.add(K, J), re = r.sub(re, C), P = r.mul(D, Y), C = r.mul(z, J), P = r.add(C, P), C = r.sub(K, P), P = r.add(K, P), $ = r.mul(C, P), K = r.add(L, L), K = r.add(K, L), J = r.mul(D, J), Y = r.mul(z, Y), K = r.add(K, J), J = r.sub(L, J), J = r.mul(D, J), Y = r.add(Y, J), L = r.mul(K, Y), $ = r.add($, L), L = r.mul(re, Y), C = r.mul(X, C), C = r.sub(C, L), L = r.mul(X, K), P = r.mul(re, P), P = r.add(P, L), new B(C, $, P);
    }
    subtract(w) {
      return this.add(w.negate());
    }
    is0() {
      return this.equals(B.ZERO);
    }
    multiply(w) {
      const { endo: T } = e;
      if (!s.isValidNot0(w)) throw new Error("invalid scalar: out of range");
      let k, S;
      const O = (N) => H.wNAFCached(this, N, B.normalizeZ);
      if (T) {
        const { k1neg: N, k1: _, k2neg: C, k2: $ } = T.splitScalar(w), { p: P, f: D } = O(_), { p: z, f: L } = O($);
        S = D.add(L), k = M(T.beta, P, z, N, C);
      } else {
        const { p: N, f: _ } = O(w);
        k = N, S = _;
      }
      return B.normalizeZ([k, S])[0];
    }
    multiplyUnsafe(w) {
      const { endo: T } = e, k = this;
      if (!s.isValid(w)) throw new Error("invalid scalar: out of range");
      if (w === Do || k.is0()) return B.ZERO;
      if (w === Oo) return k;
      if (H.hasPrecomputes(this)) return this.multiply(w);
      if (T) {
        const { k1neg: S, k1: O, k2neg: N, k2: _ } = T.splitScalar(w), { p1: C, p2: $ } = G4(B, k, O, _);
        return M(T.beta, C, $, S, N);
      } else return H.wNAFCachedUnsafe(k, w);
    }
    multiplyAndAddUnsafe(w, T, k) {
      const S = this.multiplyUnsafe(T).add(w.multiplyUnsafe(k));
      return S.is0() ? void 0 : S;
    }
    toAffine(w) {
      return U(this, w);
    }
    isTorsionFree() {
      const { isTorsionFree: w } = e;
      return n === Oo ? !0 : w ? w(B, this) : H.wNAFCachedUnsafe(this, i).is0();
    }
    clearCofactor() {
      const { clearCofactor: w } = e;
      return n === Oo ? this : w ? w(B, this) : this.multiplyUnsafe(n);
    }
    toBytes(w = !0) {
      return il("isCompressed", w), this.assertValidity(), u(B, this, w);
    }
    toRawBytes(w = !0) {
      return this.toBytes(w);
    }
    toHex(w = !0) {
      return Xo(this.toBytes(w));
    }
    toString() {
      return `<Point ${this.is0() ? "ZERO" : this.toHex()}>`;
    }
  }
  B.BASE = new B(t.Gx, t.Gy, r.ONE), B.ZERO = new B(r.ZERO, r.ONE, r.ZERO), B.Fp = r, B.Fn = s;
  const q = s.BITS, H = V4(B, e.endo ? Math.ceil(q / 2) : q);
  return B;
}
function Dg(t) {
  return Uint8Array.of(t ? 2 : 3);
}
function cS(t, e, r = {}) {
  Tl(e, { hash: "function" }, { hmac: "function", lowS: "boolean", randomBytes: "function", bits2int: "function", bits2int_modN: "function" });
  const s = e.randomBytes || Ei, n = e.hmac || ((k, ...S) => Sl(e.hash, k, wn(...S))), { Fp: i, Fn: o } = t, { ORDER: a, BITS: c } = o;
  function l(k) {
    const S = a >> Oo;
    return k > S;
  }
  function u(k) {
    return l(k) ? o.neg(k) : k;
  }
  function h(k, S) {
    if (!o.isValidNot0(S)) throw new Error(`invalid signature ${k}: out of range 1..CURVE.n`);
  }
  class p {
    constructor(S, O, N) {
      h("r", S), h("s", O), this.r = S, this.s = O, N != null && (this.recovery = N), Object.freeze(this);
    }
    static fromCompact(S) {
      const O = o.BYTES, N = Ft("compactSignature", S, O * 2);
      return new p(o.fromBytes(N.subarray(0, O)), o.fromBytes(N.subarray(O, O * 2)));
    }
    static fromDER(S) {
      const { r: O, s: N } = ys.toSig(Ft("DER", S));
      return new p(O, N);
    }
    assertValidity() {
    }
    addRecoveryBit(S) {
      return new p(this.r, this.s, S);
    }
    recoverPublicKey(S) {
      const O = i.ORDER, { r: N, s: _, recovery: C } = this;
      if (C == null || ![0, 1, 2, 3].includes(C)) throw new Error("recovery id invalid");
      if (a * nS < O && C > 1) throw new Error("recovery id is ambiguous for h>1 curve");
      const $ = C === 2 || C === 3 ? N + a : N;
      if (!i.isValid($)) throw new Error("recovery id 2 or 3 invalid");
      const P = i.toBytes($), D = t.fromHex(wn(Dg((C & 1) === 0), P)), z = o.inv($), L = A(Ft("msgHash", S)), K = o.create(-L * z), J = o.create(_ * z), X = t.BASE.multiplyUnsafe(K).add(D.multiplyUnsafe(J));
      if (X.is0()) throw new Error("point at infinify");
      return X.assertValidity(), X;
    }
    hasHighS() {
      return l(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new p(this.r, o.neg(this.s), this.recovery) : this;
    }
    toBytes(S) {
      if (S === "compact") return wn(o.toBytes(this.r), o.toBytes(this.s));
      if (S === "der") return lp(ys.hexFromSig(this));
      throw new Error("invalid format");
    }
    toDERRawBytes() {
      return this.toBytes("der");
    }
    toDERHex() {
      return Xo(this.toBytes("der"));
    }
    toCompactRawBytes() {
      return this.toBytes("compact");
    }
    toCompactHex() {
      return Xo(this.toBytes("compact"));
    }
  }
  const y = Bg(o, r.allowedPrivateKeyLengths, r.wrapPrivateKey), b = { isValidPrivateKey(k) {
    try {
      return y(k), !0;
    } catch {
      return !1;
    }
  }, normPrivateKeyToScalar: y, randomPrivateKey: () => {
    const k = a;
    return j4(s(_g(k)), k);
  }, precompute(k = 8, S = t.BASE) {
    return S.precompute(k, !1);
  } };
  function g(k, S = !0) {
    return t.fromPrivateKey(k).toBytes(S);
  }
  function x(k) {
    if (typeof k == "bigint") return !1;
    if (k instanceof t) return !0;
    const S = Ft("key", k).length, O = i.BYTES, N = O + 1, _ = 2 * O + 1;
    if (!(r.allowedPrivateKeyLengths || o.BYTES === N)) return S === N || S === _;
  }
  function I(k, S, O = !0) {
    if (x(k) === !0) throw new Error("first arg must be private key");
    if (x(S) === !1) throw new Error("second arg must be public key");
    return t.fromHex(S).multiply(y(k)).toBytes(O);
  }
  const U = e.bits2int || function(k) {
    if (k.length > 8192) throw new Error("input is too large");
    const S = Al(k), O = k.length * 8 - c;
    return O > 0 ? S >> BigInt(O) : S;
  }, A = e.bits2int_modN || function(k) {
    return o.create(U(k));
  }, M = _l(c);
  function B(k) {
    return Oh("num < 2^" + c, k, Do, M), o.toBytes(k);
  }
  function q(k, S, O = H) {
    if (["recovered", "canonical"].some((X) => X in O)) throw new Error("sign() legacy options not supported");
    const { hash: N } = e;
    let { lowS: _, prehash: C, extraEntropy: $ } = O;
    _ == null && (_ = !0), k = Ft("msgHash", k), ym(O), C && (k = Ft("prehashed msgHash", N(k)));
    const P = A(k), D = y(S), z = [B(D), B(P)];
    if ($ != null && $ !== !1) {
      const X = $ === !0 ? s(i.BYTES) : $;
      z.push(Ft("extraEntropy", X));
    }
    const L = wn(...z), K = P;
    function J(X) {
      const Y = U(X);
      if (!o.isValidNot0(Y)) return;
      const re = o.inv(Y), ae = t.BASE.multiply(Y).toAffine(), ne = o.create(ae.x);
      if (ne === Do) return;
      const se = o.create(re * o.create(K + ne * D));
      if (se === Do) return;
      let fe = (ae.x === ne ? 0 : 2) | Number(ae.y & Oo), Oe = se;
      return _ && l(se) && (Oe = u(se), fe ^= 1), new p(ne, Oe, fe);
    }
    return { seed: L, k2sig: J };
  }
  const H = { lowS: e.lowS, prehash: !1 }, F = { lowS: e.lowS, prehash: !1 };
  function w(k, S, O = H) {
    const { seed: N, k2sig: _ } = q(k, S, O);
    return D4(e.hash.outputLen, o.BYTES, n)(N, _);
  }
  t.BASE.precompute(8);
  function T(k, S, O, N = F) {
    const _ = k;
    S = Ft("msgHash", S), O = Ft("publicKey", O), ym(N);
    const { lowS: C, prehash: $, format: P } = N;
    if ("strict" in N) throw new Error("options.strict was renamed to lowS");
    if (P !== void 0 && !["compact", "der", "js"].includes(P)) throw new Error('format must be "compact", "der" or "js"');
    const D = typeof _ == "string" || op(_), z = !D && !P && typeof _ == "object" && _ !== null && typeof _.r == "bigint" && typeof _.s == "bigint";
    if (!D && !z) throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
    let L, K;
    try {
      if (z) if (P === void 0 || P === "js") L = new p(_.r, _.s);
      else throw new Error("invalid format");
      if (D) {
        try {
          P !== "compact" && (L = p.fromDER(_));
        } catch (fe) {
          if (!(fe instanceof ys.Err)) throw fe;
        }
        !L && P !== "der" && (L = p.fromCompact(_));
      }
      K = t.fromHex(O);
    } catch {
      return !1;
    }
    if (!L || C && L.hasHighS()) return !1;
    $ && (S = e.hash(S));
    const { r: J, s: X } = L, Y = A(S), re = o.inv(X), ae = o.create(Y * re), ne = o.create(J * re), se = t.BASE.multiplyUnsafe(ae).add(K.multiplyUnsafe(ne));
    return se.is0() ? !1 : o.create(se.x) === J;
  }
  return Object.freeze({ getPublicKey: g, getSharedSecret: I, sign: w, verify: T, utils: b, Point: t, Signature: p });
}
function lS(t) {
  const e = { a: t.a, b: t.b, p: t.Fp.ORDER, n: t.n, h: t.h, Gx: t.Gx, Gy: t.Gy }, r = t.Fp, s = xi(e.n, t.nBitLength), n = { Fp: r, Fn: s, allowedPrivateKeyLengths: t.allowedPrivateKeyLengths, allowInfinityPoint: t.allowInfinityPoint, endo: t.endo, wrapPrivateKey: t.wrapPrivateKey, isTorsionFree: t.isTorsionFree, clearCofactor: t.clearCofactor, fromBytes: t.fromBytes, toBytes: t.toBytes };
  return { CURVE: e, curveOpts: n };
}
function uS(t) {
  const { CURVE: e, curveOpts: r } = lS(t), s = { hash: t.hash, hmac: t.hmac, randomBytes: t.randomBytes, lowS: t.lowS, bits2int: t.bits2int, bits2int_modN: t.bits2int_modN };
  return { CURVE: e, curveOpts: r, ecdsaOpts: s };
}
function hS(t, e) {
  return Object.assign({}, e, { ProjectivePoint: e.Point, CURVE: t });
}
function dS(t) {
  const { CURVE: e, curveOpts: r, ecdsaOpts: s } = uS(t), n = aS(e, r), i = cS(n, s, r);
  return hS(t, i);
}
function Rh(t, e) {
  const r = (s) => dS({ ...t, hash: s });
  return { ...r(e), create: r };
}
const Og = { p: BigInt("0xffffffff00000001000000000000000000000000ffffffffffffffffffffffff"), n: BigInt("0xffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551"), h: BigInt(1), a: BigInt("0xffffffff00000001000000000000000000000000fffffffffffffffffffffffc"), b: BigInt("0x5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b"), Gx: BigInt("0x6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296"), Gy: BigInt("0x4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5") }, Pg = { p: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffeffffffff0000000000000000ffffffff"), n: BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffc7634d81f4372ddf581a0db248b0a77aecec196accc52973"), h: BigInt(1), a: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffeffffffff0000000000000000fffffffc"), b: BigInt("0xb3312fa7e23ee7e4988e056be3f82d19181d9c6efe8141120314088f5013875ac656398d8a2ed19d2a85c8edd3ec2aef"), Gx: BigInt("0xaa87ca22be8b05378eb1c71ef320ad746e1d3b628ba79b9859f741e082542a385502f25dbf55296c3a545e3872760ab7"), Gy: BigInt("0x3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f") }, Rg = { p: BigInt("0x1ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), n: BigInt("0x01fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffa51868783bf2f966b7fcc0148f709a5d03bb5c9b8899c47aebb6fb71e91386409"), h: BigInt(1), a: BigInt("0x1fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffc"), b: BigInt("0x0051953eb9618e1c9a1f929a21a0b68540eea2da725b99b315f3b8b489918ef109e156193951ec7e937b1652c0bd3bb1bf073573df883d2c34f1ef451fd46b503f00"), Gx: BigInt("0x00c6858e06b70404e9cd9e3ecb662395b4429c648139053fb521f828af606b4d3dbaa14b5e77efe75928fe1dc127a2ffa8de3348b3c1856a429bf97e7e31c2e5bd66"), Gy: BigInt("0x011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650") }, pS = xi(Og.p), fS = xi(Pg.p), mS = xi(Rg.p), bS = Rh({ ...Og, Fp: pS, lowS: !1 }, mg);
Rh({ ...Pg, Fp: fS, lowS: !1 }, Q5), Rh({ ...Rg, Fp: mS, lowS: !1, allowedPrivateKeyLengths: [130, 131, 132] }, Y5);
const yS = bS, Ng = "base10", $t = "base16", In = "base64pad", fp = "base64url", ya = "utf8", Lg = 0, vi = 1, Ul = 2, gS = 0, gm = 1, Po = 12, mp = 32;
function wS() {
  const t = Ph.utils.randomPrivateKey(), e = Ph.getPublicKey(t);
  return { privateKey: Ce(t, $t), publicKey: Ce(e, $t) };
}
function Nh() {
  const t = Ei(mp);
  return Ce(t, $t);
}
function ES(t, e) {
  const r = Ph.getSharedSecret(Le(t, $t), Le(e, $t)), s = U4(Il, r, void 0, void 0, mp);
  return Ce(s, $t);
}
function xS(t) {
  const e = Il(Le(t, $t));
  return Ce(e, $t);
}
function Nc(t) {
  const e = Il(Le(t, ya));
  return Ce(e, $t);
}
function Mg(t) {
  return Le(`${t}`, Ng);
}
function Tn(t) {
  return Number(Ce(t, Ng));
}
function Fg(t) {
  return t.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function zg(t) {
  const e = t.replace(/-/g, "+").replace(/_/g, "/"), r = (4 - e.length % 4) % 4;
  return e + "=".repeat(r);
}
function vS(t) {
  const e = Mg(typeof t.type < "u" ? t.type : Lg);
  if (Tn(e) === vi && typeof t.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
  const r = typeof t.senderPublicKey < "u" ? Le(t.senderPublicKey, $t) : void 0, s = typeof t.iv < "u" ? Le(t.iv, $t) : Ei(Po), n = Le(t.symKey, $t), i = wg(n, s).encrypt(Le(t.message, ya)), o = jg({ type: e, sealed: i, iv: s, senderPublicKey: r });
  return t.encoding === fp ? Fg(o) : o;
}
function kS(t) {
  const e = Le(t.symKey, $t), { sealed: r, iv: s } = Yo({ encoded: t.encoded, encoding: t.encoding }), n = wg(e, s).decrypt(r);
  if (n === null) throw new Error("Failed to decrypt");
  return Ce(n, ya);
}
function CS(t, e) {
  const r = Mg(Ul), s = Ei(Po), n = Le(t, ya), i = jg({ type: r, sealed: n, iv: s });
  return e === fp ? Fg(i) : i;
}
function SS(t, e) {
  const { sealed: r } = Yo({ encoded: t, encoding: e });
  return Ce(r, ya);
}
function jg(t) {
  if (Tn(t.type) === Ul) return Ce(Xr([t.type, t.sealed]), In);
  if (Tn(t.type) === vi) {
    if (typeof t.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    return Ce(Xr([t.type, t.senderPublicKey, t.iv, t.sealed]), In);
  }
  return Ce(Xr([t.type, t.iv, t.sealed]), In);
}
function Yo(t) {
  const e = (t.encoding || In) === fp ? zg(t.encoded) : t.encoded, r = Le(e, In), s = r.slice(gS, gm), n = gm;
  if (Tn(s) === vi) {
    const c = n + mp, l = c + Po, u = r.slice(n, c), h = r.slice(c, l), p = r.slice(l);
    return { type: s, sealed: p, iv: h, senderPublicKey: u };
  }
  if (Tn(s) === Ul) {
    const c = r.slice(n), l = Ei(Po);
    return { type: s, sealed: c, iv: l };
  }
  const i = n + Po, o = r.slice(n, i), a = r.slice(i);
  return { type: s, sealed: a, iv: o };
}
function IS(t, e) {
  const r = Yo({ encoded: t, encoding: e == null ? void 0 : e.encoding });
  return Hg({ type: Tn(r.type), senderPublicKey: typeof r.senderPublicKey < "u" ? Ce(r.senderPublicKey, $t) : void 0, receiverPublicKey: e == null ? void 0 : e.receiverPublicKey });
}
function Hg(t) {
  const e = (t == null ? void 0 : t.type) || Lg;
  if (e === vi) {
    if (typeof (t == null ? void 0 : t.senderPublicKey) > "u") throw new Error("missing sender public key");
    if (typeof (t == null ? void 0 : t.receiverPublicKey) > "u") throw new Error("missing receiver public key");
  }
  return { type: e, senderPublicKey: t == null ? void 0 : t.senderPublicKey, receiverPublicKey: t == null ? void 0 : t.receiverPublicKey };
}
function wm(t) {
  return t.type === vi && typeof t.senderPublicKey == "string" && typeof t.receiverPublicKey == "string";
}
function Em(t) {
  return t.type === Ul;
}
function AS(t) {
  const e = Buffer.from(t.x, "base64"), r = Buffer.from(t.y, "base64");
  return Xr([new Uint8Array([4]), e, r]);
}
function _S(t, e) {
  const [r, s, n] = t.split("."), i = Buffer.from(zg(n), "base64");
  if (i.length !== 64) throw new Error("Invalid signature length");
  const o = i.slice(0, 32), a = i.slice(32, 64), c = `${r}.${s}`, l = Il(c), u = AS(e);
  if (!yS.verify(Xr([o, a]), l, u)) throw new Error("Invalid signature");
  return ni(t).payload;
}
const TS = "irn";
function al(t) {
  return (t == null ? void 0 : t.relay) || { protocol: TS };
}
function vo(t) {
  const e = My[t];
  if (typeof e > "u") throw new Error(`Relay Protocol not supported: ${t}`);
  return e;
}
function US(t, e = "-") {
  const r = {}, s = "relay" + e;
  return Object.keys(t).forEach((n) => {
    if (n.startsWith(s)) {
      const i = n.replace(s, ""), o = t[n];
      r[i] = o;
    }
  }), r;
}
function xm(t) {
  if (!t.includes("wc:")) {
    const l = rg(t);
    l != null && l.includes("wc:") && (t = l);
  }
  t = t.includes("wc://") ? t.replace("wc://", "") : t, t = t.includes("wc:") ? t.replace("wc:", "") : t;
  const e = t.indexOf(":"), r = t.indexOf("?") !== -1 ? t.indexOf("?") : void 0, s = t.substring(0, e), n = t.substring(e + 1, r).split("@"), i = typeof r < "u" ? t.substring(r) : "", o = new URLSearchParams(i), a = {};
  o.forEach((l, u) => {
    a[u] = l;
  });
  const c = typeof a.methods == "string" ? a.methods.split(",") : void 0;
  return { protocol: s, topic: $S(n[0]), version: parseInt(n[1], 10), symKey: a.symKey, relay: US(a), methods: c, expiryTimestamp: a.expiryTimestamp ? parseInt(a.expiryTimestamp, 10) : void 0 };
}
function $S(t) {
  return t.startsWith("//") ? t.substring(2) : t;
}
function BS(t, e = "-") {
  const r = "relay", s = {};
  return Object.keys(t).forEach((n) => {
    const i = n, o = r + e + i;
    t[i] && (s[o] = t[i]);
  }), s;
}
function vm(t) {
  const e = new URLSearchParams(), r = BS(t.relay);
  Object.keys(r).sort().forEach((n) => {
    e.set(n, r[n]);
  }), e.set("symKey", t.symKey), t.expiryTimestamp && e.set("expiryTimestamp", t.expiryTimestamp.toString()), t.methods && e.set("methods", t.methods.join(","));
  const s = e.toString();
  return `${t.protocol}:${t.topic}@${t.version}?${s}`;
}
const DS = { INVALID_METHOD: { message: "Invalid method.", code: 1001 }, INVALID_EVENT: { message: "Invalid event.", code: 1002 }, INVALID_UPDATE_REQUEST: { message: "Invalid update request.", code: 1003 }, INVALID_EXTEND_REQUEST: { message: "Invalid extend request.", code: 1004 }, INVALID_SESSION_SETTLE_REQUEST: { message: "Invalid session settle request.", code: 1005 }, UNAUTHORIZED_METHOD: { message: "Unauthorized method.", code: 3001 }, UNAUTHORIZED_EVENT: { message: "Unauthorized event.", code: 3002 }, UNAUTHORIZED_UPDATE_REQUEST: { message: "Unauthorized update request.", code: 3003 }, UNAUTHORIZED_EXTEND_REQUEST: { message: "Unauthorized extend request.", code: 3004 }, USER_REJECTED: { message: "User rejected.", code: 5e3 }, USER_REJECTED_CHAINS: { message: "User rejected chains.", code: 5001 }, USER_REJECTED_METHODS: { message: "User rejected methods.", code: 5002 }, USER_REJECTED_EVENTS: { message: "User rejected events.", code: 5003 }, UNSUPPORTED_CHAINS: { message: "Unsupported chains.", code: 5100 }, UNSUPPORTED_METHODS: { message: "Unsupported methods.", code: 5101 }, UNSUPPORTED_EVENTS: { message: "Unsupported events.", code: 5102 }, UNSUPPORTED_ACCOUNTS: { message: "Unsupported accounts.", code: 5103 }, UNSUPPORTED_NAMESPACE_KEY: { message: "Unsupported namespace key.", code: 5104 }, USER_DISCONNECTED: { message: "User disconnected.", code: 6e3 }, SESSION_SETTLEMENT_FAILED: { message: "Session settlement failed.", code: 7e3 }, WC_METHOD_UNSUPPORTED: { message: "Unsupported wc_ method.", code: 10001 } }, OS = { NOT_INITIALIZED: { message: "Not initialized.", code: 1 }, NO_MATCHING_KEY: { message: "No matching key.", code: 2 }, RESTORE_WILL_OVERRIDE: { message: "Restore will override.", code: 3 }, RESUBSCRIBED: { message: "Resubscribed.", code: 4 }, MISSING_OR_INVALID: { message: "Missing or invalid.", code: 5 }, EXPIRED: { message: "Expired.", code: 6 }, UNKNOWN_TYPE: { message: "Unknown type.", code: 7 }, MISMATCHED_TOPIC: { message: "Mismatched topic.", code: 8 }, NON_CONFORMING_NAMESPACES: { message: "Non conforming namespaces.", code: 9 } };
function xe(t, e) {
  const { message: r, code: s } = OS[t];
  return { message: e ? `${r} ${e}` : r, code: s };
}
function ko(t, e) {
  const { message: r, code: s } = DS[t];
  return { message: e ? `${r} ${e}` : r, code: s };
}
function Lh(t) {
  return typeof t > "u";
}
function qg(t, e) {
  return typeof t == "string" && !!t.trim().length;
}
function PS(t) {
  function e(r) {
    try {
      return typeof new URL(r) < "u";
    } catch {
      return !1;
    }
  }
  try {
    if (qg(t, !1)) {
      if (e(t)) return !0;
      const r = rg(t);
      return e(r);
    }
  } catch {
  }
  return !1;
}
function RS(t) {
  var e;
  return (e = t == null ? void 0 : t.proposer) == null ? void 0 : e.publicKey;
}
function NS(t) {
  return t == null ? void 0 : t.topic;
}
function ku(t) {
  return typeof t < "u" && typeof t !== null;
}
function km() {
  const t = kl();
  return new Promise((e) => {
    switch (t) {
      case Or.browser:
        e(LS());
        break;
      case Or.reactNative:
        e(MS());
        break;
      case Or.node:
        e(FS());
        break;
      default:
        e(!0);
    }
  });
}
function LS() {
  return ma() && (navigator == null ? void 0 : navigator.onLine);
}
async function MS() {
  if (On() && typeof globalThis < "u" && globalThis != null && globalThis.NetInfo) {
    const t = await (globalThis == null ? void 0 : globalThis.NetInfo.fetch());
    return t == null ? void 0 : t.isConnected;
  }
  return !0;
}
function FS() {
  return !0;
}
function zS(t) {
  switch (kl()) {
    case Or.browser:
      jS(t);
      break;
    case Or.reactNative:
      HS(t);
      break;
  }
}
function jS(t) {
  !On() && ma() && (window.addEventListener("online", () => t(!0)), window.addEventListener("offline", () => t(!1)));
}
function HS(t) {
  On() && typeof globalThis < "u" && globalThis != null && globalThis.NetInfo && (globalThis == null || globalThis.NetInfo.addEventListener((e) => t(e == null ? void 0 : e.isConnected)));
}
function qS() {
  var t;
  return ma() && fr() ? ((t = fr()) == null ? void 0 : t.visibilityState) === "visible" : !0;
}
const KS = "PARSE_ERROR", VS = "INVALID_REQUEST", GS = "METHOD_NOT_FOUND", WS = "INVALID_PARAMS", Kg = "INTERNAL_ERROR", bp = "SERVER_ERROR", ZS = [-32700, -32600, -32601, -32602, -32603], Ro = {
  [KS]: { code: -32700, message: "Parse error" },
  [VS]: { code: -32600, message: "Invalid Request" },
  [GS]: { code: -32601, message: "Method not found" },
  [WS]: { code: -32602, message: "Invalid params" },
  [Kg]: { code: -32603, message: "Internal error" },
  [bp]: { code: -32e3, message: "Server error" }
}, Vg = bp;
function JS(t) {
  return ZS.includes(t);
}
function Cm(t) {
  return Object.keys(Ro).includes(t) ? Ro[t] : Ro[Vg];
}
function XS(t) {
  const e = Object.values(Ro).find((r) => r.code === t);
  return e || Ro[Vg];
}
function YS(t, e, r) {
  return t.message.includes("getaddrinfo ENOTFOUND") || t.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${r} RPC url at ${e}`) : t;
}
var Gg = {}, is = {}, Sm;
function QS() {
  if (Sm) return is;
  Sm = 1, Object.defineProperty(is, "__esModule", { value: !0 }), is.isBrowserCryptoAvailable = is.getSubtleCrypto = is.getBrowerCrypto = void 0;
  function t() {
    return (globalThis == null ? void 0 : globalThis.crypto) || (globalThis == null ? void 0 : globalThis.msCrypto) || {};
  }
  is.getBrowerCrypto = t;
  function e() {
    const s = t();
    return s.subtle || s.webkitSubtle;
  }
  is.getSubtleCrypto = e;
  function r() {
    return !!t() && !!e();
  }
  return is.isBrowserCryptoAvailable = r, is;
}
var os = {}, Im;
function e9() {
  if (Im) return os;
  Im = 1, Object.defineProperty(os, "__esModule", { value: !0 }), os.isBrowser = os.isNode = os.isReactNative = void 0;
  function t() {
    return typeof document > "u" && typeof navigator < "u" && navigator.product === "ReactNative";
  }
  os.isReactNative = t;
  function e() {
    return typeof process < "u" && typeof process.versions < "u" && typeof process.versions.node < "u";
  }
  os.isNode = e;
  function r() {
    return !t() && !e();
  }
  return os.isBrowser = r, os;
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  const e = oa;
  e.__exportStar(QS(), t), e.__exportStar(e9(), t);
})(Gg);
function Gr(t = 3) {
  const e = Date.now() * Math.pow(10, t), r = Math.floor(Math.random() * Math.pow(10, t));
  return e + r;
}
function ws(t = 6) {
  return BigInt(Gr(t));
}
function Es(t, e, r) {
  return {
    id: r || Gr(),
    jsonrpc: "2.0",
    method: t,
    params: e
  };
}
function ga(t, e) {
  return {
    id: t,
    jsonrpc: "2.0",
    result: e
  };
}
function $l(t, e, r) {
  return {
    id: t,
    jsonrpc: "2.0",
    error: t9(e)
  };
}
function t9(t, e) {
  return typeof t > "u" ? Cm(Kg) : (typeof t == "string" && (t = Object.assign(Object.assign({}, Cm(bp)), { message: t })), JS(t.code) && (t = XS(t.code)), t);
}
class r9 {
}
class s9 extends r9 {
  constructor() {
    super();
  }
}
class n9 extends s9 {
  constructor(e) {
    super();
  }
}
const i9 = "^wss?:";
function o9(t) {
  const e = t.match(new RegExp(/^\w+:/, "gi"));
  if (!(!e || !e.length))
    return e[0];
}
function a9(t, e) {
  const r = o9(t);
  return typeof r > "u" ? !1 : new RegExp(e).test(r);
}
function Am(t) {
  return a9(t, i9);
}
function c9(t) {
  return new RegExp("wss?://localhost(:d{2,5})?").test(t);
}
function Wg(t) {
  return typeof t == "object" && "id" in t && "jsonrpc" in t && t.jsonrpc === "2.0";
}
function wa(t) {
  return Wg(t) && "method" in t;
}
function ki(t) {
  return Wg(t) && (Dr(t) || jt(t));
}
function Dr(t) {
  return "result" in t;
}
function jt(t) {
  return "error" in t;
}
let Zg = class extends n9 {
  constructor(e) {
    super(e), this.events = new dt.EventEmitter(), this.hasRegisteredEventListeners = !1, this.connection = this.setConnection(e), this.connection.connected && this.registerEventListeners();
  }
  async connect(e = this.connection) {
    await this.open(e);
  }
  async disconnect() {
    await this.close();
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  async request(e, r) {
    return this.requestStrict(Es(e.method, e.params || [], e.id || ws().toString()), r);
  }
  async requestStrict(e, r) {
    return new Promise(async (s, n) => {
      if (!this.connection.connected) try {
        await this.open();
      } catch (i) {
        n(i);
      }
      this.events.on(`${e.id}`, (i) => {
        jt(i) ? n(i.error) : s(i.result);
      });
      try {
        await this.connection.send(e, r);
      } catch (i) {
        n(i);
      }
    });
  }
  setConnection(e = this.connection) {
    return e;
  }
  onPayload(e) {
    this.events.emit("payload", e), ki(e) ? this.events.emit(`${e.id}`, e) : this.events.emit("message", { type: e.method, data: e.params });
  }
  onClose(e) {
    e && e.code === 3e3 && this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${e.code} ${e.reason ? `(${e.reason})` : ""}`)), this.events.emit("disconnect");
  }
  async open(e = this.connection) {
    this.connection === e && this.connection.connected || (this.connection.connected && this.close(), typeof e == "string" && (await this.connection.open(e), e = this.connection), this.connection = this.setConnection(e), await this.connection.open(), this.registerEventListeners(), this.events.emit("connect"));
  }
  async close() {
    await this.connection.close();
  }
  registerEventListeners() {
    this.hasRegisteredEventListeners || (this.connection.on("payload", (e) => this.onPayload(e)), this.connection.on("close", (e) => this.onClose(e)), this.connection.on("error", (e) => this.events.emit("error", e)), this.connection.on("register_error", (e) => this.onClose()), this.hasRegisteredEventListeners = !0);
  }
};
const l9 = () => typeof WebSocket < "u" ? WebSocket : typeof globalThis < "u" && typeof globalThis.WebSocket < "u" ? globalThis.WebSocket : typeof window < "u" && typeof window.WebSocket < "u" ? window.WebSocket : typeof self < "u" && typeof self.WebSocket < "u" ? self.WebSocket : require("ws"), u9 = () => typeof WebSocket < "u" || typeof globalThis < "u" && typeof globalThis.WebSocket < "u" || typeof window < "u" && typeof window.WebSocket < "u" || typeof self < "u" && typeof self.WebSocket < "u", _m = (t) => t.split("?")[0], Tm = 10, h9 = l9();
let Jg = class {
  constructor(e) {
    if (this.url = e, this.events = new dt.EventEmitter(), this.registering = !1, !Am(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
    this.url = e;
  }
  get connected() {
    return typeof this.socket < "u";
  }
  get connecting() {
    return this.registering;
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  async open(e = this.url) {
    await this.register(e);
  }
  async close() {
    return new Promise((e, r) => {
      if (typeof this.socket > "u") {
        r(new Error("Connection already closed"));
        return;
      }
      this.socket.onclose = (s) => {
        this.onClose(s), e();
      }, this.socket.close();
    });
  }
  async send(e) {
    typeof this.socket > "u" && (this.socket = await this.register());
    try {
      this.socket.send(an(e));
    } catch (r) {
      this.onError(e.id, r);
    }
  }
  register(e = this.url) {
    if (!Am(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
    if (this.registering) {
      const r = this.events.getMaxListeners();
      return (this.events.listenerCount("register_error") >= r || this.events.listenerCount("open") >= r) && this.events.setMaxListeners(r + 1), new Promise((s, n) => {
        this.events.once("register_error", (i) => {
          this.resetMaxListeners(), n(i);
        }), this.events.once("open", () => {
          if (this.resetMaxListeners(), typeof this.socket > "u") return n(new Error("WebSocket connection is missing or invalid"));
          s(this.socket);
        });
      });
    }
    return this.url = e, this.registering = !0, new Promise((r, s) => {
      const n = Gg.isReactNative() ? void 0 : { rejectUnauthorized: !c9(e) }, i = new h9(e, [], n);
      u9() ? i.onerror = (o) => {
        const a = o;
        s(this.emitError(a.error));
      } : i.on("error", (o) => {
        s(this.emitError(o));
      }), i.onopen = () => {
        this.onOpen(i), r(i);
      };
    });
  }
  onOpen(e) {
    e.onmessage = (r) => this.onPayload(r), e.onclose = (r) => this.onClose(r), this.socket = e, this.registering = !1, this.events.emit("open");
  }
  onClose(e) {
    this.socket = void 0, this.registering = !1, this.events.emit("close", e);
  }
  onPayload(e) {
    if (typeof e.data > "u") return;
    const r = typeof e.data == "string" ? on(e.data) : e.data;
    this.events.emit("payload", r);
  }
  onError(e, r) {
    const s = this.parseError(r), n = s.message || s.toString(), i = $l(e, n);
    this.events.emit("payload", i);
  }
  parseError(e, r = this.url) {
    return YS(e, _m(r), "WS");
  }
  resetMaxListeners() {
    this.events.getMaxListeners() > Tm && this.events.setMaxListeners(Tm);
  }
  emitError(e) {
    const r = this.parseError(new Error((e == null ? void 0 : e.message) || `WebSocket connection failed for host: ${_m(this.url)}`));
    return this.events.emit("register_error", r), r;
  }
};
const Xg = "wc", Yg = 2, Mh = "core", Qr = `${Xg}@2:${Mh}:`, d9 = { logger: "error" }, p9 = { database: ":memory:" }, f9 = "crypto", Um = "client_ed25519_seed", m9 = V.ONE_DAY, b9 = "keychain", y9 = "0.3", g9 = "messages", w9 = "0.3", $m = V.SIX_HOURS, E9 = "publisher", x9 = "irn", v9 = "error", Qg = "wss://relay.walletconnect.org", k9 = "relayer", At = { message: "relayer_message", message_ack: "relayer_message_ack", connect: "relayer_connect", disconnect: "relayer_disconnect", error: "relayer_error", connection_stalled: "relayer_connection_stalled", transport_closed: "relayer_transport_closed", publish: "relayer_publish" }, C9 = "_subscription", cr = { payload: "payload", connect: "connect", disconnect: "disconnect", error: "error" }, S9 = 0.1, Fh = "2.21.3", ci = { link_mode: "link_mode", relay: "relay" }, Lc = { inbound: "inbound", outbound: "outbound" }, I9 = "0.3", A9 = "WALLETCONNECT_CLIENT_ID", Bm = "WALLETCONNECT_LINK_MODE_APPS", Qt = { created: "subscription_created", deleted: "subscription_deleted", expired: "subscription_expired", disabled: "subscription_disabled", sync: "subscription_sync", resubscribed: "subscription_resubscribed" }, _9 = "subscription", T9 = "0.3", U9 = "pairing", $9 = "0.3", Ki = { wc_pairingDelete: { req: { ttl: V.ONE_DAY, prompt: !1, tag: 1e3 }, res: { ttl: V.ONE_DAY, prompt: !1, tag: 1001 } }, wc_pairingPing: { req: { ttl: V.THIRTY_SECONDS, prompt: !1, tag: 1002 }, res: { ttl: V.THIRTY_SECONDS, prompt: !1, tag: 1003 } }, unregistered_method: { req: { ttl: V.ONE_DAY, prompt: !1, tag: 0 }, res: { ttl: V.ONE_DAY, prompt: !1, tag: 0 } } }, Vi = { create: "pairing_create", expire: "pairing_expire", delete: "pairing_delete", ping: "pairing_ping" }, vr = { created: "history_created", updated: "history_updated", deleted: "history_deleted", sync: "history_sync" }, B9 = "history", D9 = "0.3", O9 = "expirer", _r = { created: "expirer_created", deleted: "expirer_deleted", expired: "expirer_expired", sync: "expirer_sync" }, P9 = "0.3", R9 = "verify-api", N9 = "https://verify.walletconnect.com", ew = "https://verify.walletconnect.org", Mc = ew, L9 = `${Mc}/v3`, M9 = [N9, ew], F9 = "echo", z9 = "https://echo.walletconnect.com", as = { pairing_started: "pairing_started", pairing_uri_validation_success: "pairing_uri_validation_success", pairing_uri_not_expired: "pairing_uri_not_expired", store_new_pairing: "store_new_pairing", subscribing_pairing_topic: "subscribing_pairing_topic", subscribe_pairing_topic_success: "subscribe_pairing_topic_success", existing_pairing: "existing_pairing", pairing_not_expired: "pairing_not_expired", emit_inactive_pairing: "emit_inactive_pairing" }, Fs = { no_internet_connection: "no_internet_connection", malformed_pairing_uri: "malformed_pairing_uri", active_pairing_already_exists: "active_pairing_already_exists", subscribe_pairing_topic_failure: "subscribe_pairing_topic_failure", pairing_expired: "pairing_expired" }, j9 = 0.1, H9 = "event-client", q9 = 86400, K9 = "https://pulse.walletconnect.org/batch";
function V9(t, e) {
  if (t.length >= 255) throw new TypeError("Alphabet too long");
  for (var r = new Uint8Array(256), s = 0; s < r.length; s++) r[s] = 255;
  for (var n = 0; n < t.length; n++) {
    var i = t.charAt(n), o = i.charCodeAt(0);
    if (r[o] !== 255) throw new TypeError(i + " is ambiguous");
    r[o] = n;
  }
  var a = t.length, c = t.charAt(0), l = Math.log(a) / Math.log(256), u = Math.log(256) / Math.log(a);
  function h(b) {
    if (b instanceof Uint8Array || (ArrayBuffer.isView(b) ? b = new Uint8Array(b.buffer, b.byteOffset, b.byteLength) : Array.isArray(b) && (b = Uint8Array.from(b))), !(b instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
    if (b.length === 0) return "";
    for (var g = 0, x = 0, I = 0, U = b.length; I !== U && b[I] === 0; ) I++, g++;
    for (var A = (U - I) * u + 1 >>> 0, M = new Uint8Array(A); I !== U; ) {
      for (var B = b[I], q = 0, H = A - 1; (B !== 0 || q < x) && H !== -1; H--, q++) B += 256 * M[H] >>> 0, M[H] = B % a >>> 0, B = B / a >>> 0;
      if (B !== 0) throw new Error("Non-zero carry");
      x = q, I++;
    }
    for (var F = A - x; F !== A && M[F] === 0; ) F++;
    for (var w = c.repeat(g); F < A; ++F) w += t.charAt(M[F]);
    return w;
  }
  function p(b) {
    if (typeof b != "string") throw new TypeError("Expected String");
    if (b.length === 0) return new Uint8Array();
    var g = 0;
    if (b[g] !== " ") {
      for (var x = 0, I = 0; b[g] === c; ) x++, g++;
      for (var U = (b.length - g) * l + 1 >>> 0, A = new Uint8Array(U); b[g]; ) {
        var M = r[b.charCodeAt(g)];
        if (M === 255) return;
        for (var B = 0, q = U - 1; (M !== 0 || B < I) && q !== -1; q--, B++) M += a * A[q] >>> 0, A[q] = M % 256 >>> 0, M = M / 256 >>> 0;
        if (M !== 0) throw new Error("Non-zero carry");
        I = B, g++;
      }
      if (b[g] !== " ") {
        for (var H = U - I; H !== U && A[H] === 0; ) H++;
        for (var F = new Uint8Array(x + (U - H)), w = x; H !== U; ) F[w++] = A[H++];
        return F;
      }
    }
  }
  function y(b) {
    var g = p(b);
    if (g) return g;
    throw new Error(`Non-${e} character`);
  }
  return { encode: h, decodeUnsafe: p, decode: y };
}
var G9 = V9, W9 = G9;
const tw = (t) => {
  if (t instanceof Uint8Array && t.constructor.name === "Uint8Array") return t;
  if (t instanceof ArrayBuffer) return new Uint8Array(t);
  if (ArrayBuffer.isView(t)) return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  throw new Error("Unknown type, must be binary type");
}, Z9 = (t) => new TextEncoder().encode(t), J9 = (t) => new TextDecoder().decode(t);
let X9 = class {
  constructor(e, r, s) {
    this.name = e, this.prefix = r, this.baseEncode = s;
  }
  encode(e) {
    if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
    throw Error("Unknown type, must be binary type");
  }
}, Y9 = class {
  constructor(e, r, s) {
    if (this.name = e, this.prefix = r, r.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
    this.prefixCodePoint = r.codePointAt(0), this.baseDecode = s;
  }
  decode(e) {
    if (typeof e == "string") {
      if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
      return this.baseDecode(e.slice(this.prefix.length));
    } else throw Error("Can only multibase decode strings");
  }
  or(e) {
    return rw(this, e);
  }
}, Q9 = class {
  constructor(e) {
    this.decoders = e;
  }
  or(e) {
    return rw(this, e);
  }
  decode(e) {
    const r = e[0], s = this.decoders[r];
    if (s) return s.decode(e);
    throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
  }
};
const rw = (t, e) => new Q9({ ...t.decoders || { [t.prefix]: t }, ...e.decoders || { [e.prefix]: e } });
let eI = class {
  constructor(e, r, s, n) {
    this.name = e, this.prefix = r, this.baseEncode = s, this.baseDecode = n, this.encoder = new X9(e, r, s), this.decoder = new Y9(e, r, n);
  }
  encode(e) {
    return this.encoder.encode(e);
  }
  decode(e) {
    return this.decoder.decode(e);
  }
};
const Bl = ({ name: t, prefix: e, encode: r, decode: s }) => new eI(t, e, r, s), Ea = ({ prefix: t, name: e, alphabet: r }) => {
  const { encode: s, decode: n } = W9(r, e);
  return Bl({ prefix: t, name: e, encode: s, decode: (i) => tw(n(i)) });
}, tI = (t, e, r, s) => {
  const n = {};
  for (let u = 0; u < e.length; ++u) n[e[u]] = u;
  let i = t.length;
  for (; t[i - 1] === "="; ) --i;
  const o = new Uint8Array(i * r / 8 | 0);
  let a = 0, c = 0, l = 0;
  for (let u = 0; u < i; ++u) {
    const h = n[t[u]];
    if (h === void 0) throw new SyntaxError(`Non-${s} character`);
    c = c << r | h, a += r, a >= 8 && (a -= 8, o[l++] = 255 & c >> a);
  }
  if (a >= r || 255 & c << 8 - a) throw new SyntaxError("Unexpected end of data");
  return o;
}, rI = (t, e, r) => {
  const s = e[e.length - 1] === "=", n = (1 << r) - 1;
  let i = "", o = 0, a = 0;
  for (let c = 0; c < t.length; ++c) for (a = a << 8 | t[c], o += 8; o > r; ) o -= r, i += e[n & a >> o];
  if (o && (i += e[n & a << r - o]), s) for (; i.length * r & 7; ) i += "=";
  return i;
}, mt = ({ name: t, prefix: e, bitsPerChar: r, alphabet: s }) => Bl({ prefix: e, name: t, encode(n) {
  return rI(n, s, r);
}, decode(n) {
  return tI(n, s, r, t);
} }), sI = Bl({ prefix: "\0", name: "identity", encode: (t) => J9(t), decode: (t) => Z9(t) });
var nI = Object.freeze({ __proto__: null, identity: sI });
const iI = mt({ prefix: "0", name: "base2", alphabet: "01", bitsPerChar: 1 });
var oI = Object.freeze({ __proto__: null, base2: iI });
const aI = mt({ prefix: "7", name: "base8", alphabet: "01234567", bitsPerChar: 3 });
var cI = Object.freeze({ __proto__: null, base8: aI });
const lI = Ea({ prefix: "9", name: "base10", alphabet: "0123456789" });
var uI = Object.freeze({ __proto__: null, base10: lI });
const hI = mt({ prefix: "f", name: "base16", alphabet: "0123456789abcdef", bitsPerChar: 4 }), dI = mt({ prefix: "F", name: "base16upper", alphabet: "0123456789ABCDEF", bitsPerChar: 4 });
var pI = Object.freeze({ __proto__: null, base16: hI, base16upper: dI });
const fI = mt({ prefix: "b", name: "base32", alphabet: "abcdefghijklmnopqrstuvwxyz234567", bitsPerChar: 5 }), mI = mt({ prefix: "B", name: "base32upper", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567", bitsPerChar: 5 }), bI = mt({ prefix: "c", name: "base32pad", alphabet: "abcdefghijklmnopqrstuvwxyz234567=", bitsPerChar: 5 }), yI = mt({ prefix: "C", name: "base32padupper", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=", bitsPerChar: 5 }), gI = mt({ prefix: "v", name: "base32hex", alphabet: "0123456789abcdefghijklmnopqrstuv", bitsPerChar: 5 }), wI = mt({ prefix: "V", name: "base32hexupper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV", bitsPerChar: 5 }), EI = mt({ prefix: "t", name: "base32hexpad", alphabet: "0123456789abcdefghijklmnopqrstuv=", bitsPerChar: 5 }), xI = mt({ prefix: "T", name: "base32hexpadupper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=", bitsPerChar: 5 }), vI = mt({ prefix: "h", name: "base32z", alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769", bitsPerChar: 5 });
var kI = Object.freeze({ __proto__: null, base32: fI, base32upper: mI, base32pad: bI, base32padupper: yI, base32hex: gI, base32hexupper: wI, base32hexpad: EI, base32hexpadupper: xI, base32z: vI });
const CI = Ea({ prefix: "k", name: "base36", alphabet: "0123456789abcdefghijklmnopqrstuvwxyz" }), SI = Ea({ prefix: "K", name: "base36upper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ" });
var II = Object.freeze({ __proto__: null, base36: CI, base36upper: SI });
const AI = Ea({ name: "base58btc", prefix: "z", alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz" }), _I = Ea({ name: "base58flickr", prefix: "Z", alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ" });
var TI = Object.freeze({ __proto__: null, base58btc: AI, base58flickr: _I });
const UI = mt({ prefix: "m", name: "base64", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", bitsPerChar: 6 }), $I = mt({ prefix: "M", name: "base64pad", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", bitsPerChar: 6 }), BI = mt({ prefix: "u", name: "base64url", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", bitsPerChar: 6 }), DI = mt({ prefix: "U", name: "base64urlpad", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=", bitsPerChar: 6 });
var OI = Object.freeze({ __proto__: null, base64: UI, base64pad: $I, base64url: BI, base64urlpad: DI });
const sw = Array.from("🚀🪐☄🛰🌌🌑🌒🌓🌔🌕🌖🌗🌘🌍🌏🌎🐉☀💻🖥💾💿😂❤😍🤣😊🙏💕😭😘👍😅👏😁🔥🥰💔💖💙😢🤔😆🙄💪😉☺👌🤗💜😔😎😇🌹🤦🎉💞✌✨🤷😱😌🌸🙌😋💗💚😏💛🙂💓🤩😄😀🖤😃💯🙈👇🎶😒🤭❣😜💋👀😪😑💥🙋😞😩😡🤪👊🥳😥🤤👉💃😳✋😚😝😴🌟😬🙃🍀🌷😻😓⭐✅🥺🌈😈🤘💦✔😣🏃💐☹🎊💘😠☝😕🌺🎂🌻😐🖕💝🙊😹🗣💫💀👑🎵🤞😛🔴😤🌼😫⚽🤙☕🏆🤫👈😮🙆🍻🍃🐶💁😲🌿🧡🎁⚡🌞🎈❌✊👋😰🤨😶🤝🚶💰🍓💢🤟🙁🚨💨🤬✈🎀🍺🤓😙💟🌱😖👶🥴▶➡❓💎💸⬇😨🌚🦋😷🕺⚠🙅😟😵👎🤲🤠🤧📌🔵💅🧐🐾🍒😗🤑🌊🤯🐷☎💧😯💆👆🎤🙇🍑❄🌴💣🐸💌📍🥀🤢👅💡💩👐📸👻🤐🤮🎼🥵🚩🍎🍊👼💍📣🥂"), PI = sw.reduce((t, e, r) => (t[r] = e, t), []), RI = sw.reduce((t, e, r) => (t[e.codePointAt(0)] = r, t), []);
function NI(t) {
  return t.reduce((e, r) => (e += PI[r], e), "");
}
function LI(t) {
  const e = [];
  for (const r of t) {
    const s = RI[r.codePointAt(0)];
    if (s === void 0) throw new Error(`Non-base256emoji character: ${r}`);
    e.push(s);
  }
  return new Uint8Array(e);
}
const MI = Bl({ prefix: "🚀", name: "base256emoji", encode: NI, decode: LI });
var FI = Object.freeze({ __proto__: null, base256emoji: MI }), zI = nw, Dm = 128, jI = -128, HI = Math.pow(2, 31);
function nw(t, e, r) {
  e = e || [], r = r || 0;
  for (var s = r; t >= HI; ) e[r++] = t & 255 | Dm, t /= 128;
  for (; t & jI; ) e[r++] = t & 255 | Dm, t >>>= 7;
  return e[r] = t | 0, nw.bytes = r - s + 1, e;
}
var qI = zh, KI = 128, Om = 127;
function zh(t, s) {
  var r = 0, s = s || 0, n = 0, i = s, o, a = t.length;
  do {
    if (i >= a) throw zh.bytes = 0, new RangeError("Could not decode varint");
    o = t[i++], r += n < 28 ? (o & Om) << n : (o & Om) * Math.pow(2, n), n += 7;
  } while (o >= KI);
  return zh.bytes = i - s, r;
}
var VI = Math.pow(2, 7), GI = Math.pow(2, 14), WI = Math.pow(2, 21), ZI = Math.pow(2, 28), JI = Math.pow(2, 35), XI = Math.pow(2, 42), YI = Math.pow(2, 49), QI = Math.pow(2, 56), eA = Math.pow(2, 63), tA = function(t) {
  return t < VI ? 1 : t < GI ? 2 : t < WI ? 3 : t < ZI ? 4 : t < JI ? 5 : t < XI ? 6 : t < YI ? 7 : t < QI ? 8 : t < eA ? 9 : 10;
}, rA = { encode: zI, decode: qI, encodingLength: tA }, iw = rA;
const Pm = (t, e, r = 0) => (iw.encode(t, e, r), e), Rm = (t) => iw.encodingLength(t), jh = (t, e) => {
  const r = e.byteLength, s = Rm(t), n = s + Rm(r), i = new Uint8Array(n + r);
  return Pm(t, i, 0), Pm(r, i, s), i.set(e, n), new sA(t, r, e, i);
};
let sA = class {
  constructor(e, r, s, n) {
    this.code = e, this.size = r, this.digest = s, this.bytes = n;
  }
};
const ow = ({ name: t, code: e, encode: r }) => new nA(t, e, r);
let nA = class {
  constructor(e, r, s) {
    this.name = e, this.code = r, this.encode = s;
  }
  digest(e) {
    if (e instanceof Uint8Array) {
      const r = this.encode(e);
      return r instanceof Uint8Array ? jh(this.code, r) : r.then((s) => jh(this.code, s));
    } else throw Error("Unknown type, must be binary type");
  }
};
const aw = (t) => async (e) => new Uint8Array(await crypto.subtle.digest(t, e)), iA = ow({ name: "sha2-256", code: 18, encode: aw("SHA-256") }), oA = ow({ name: "sha2-512", code: 19, encode: aw("SHA-512") });
var aA = Object.freeze({ __proto__: null, sha256: iA, sha512: oA });
const cw = 0, cA = "identity", lw = tw, lA = (t) => jh(cw, lw(t)), uA = { code: cw, name: cA, encode: lw, digest: lA };
var hA = Object.freeze({ __proto__: null, identity: uA });
new TextEncoder(), new TextDecoder();
const Nm = { ...nI, ...oI, ...cI, ...uI, ...pI, ...kI, ...II, ...TI, ...OI, ...FI };
({ ...aA, ...hA });
function uw(t) {
  return globalThis.Buffer != null ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : t;
}
function dA(t = 0) {
  return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? uw(globalThis.Buffer.allocUnsafe(t)) : new Uint8Array(t);
}
function hw(t, e, r, s) {
  return { name: t, prefix: e, encoder: { name: t, prefix: e, encode: r }, decoder: { decode: s } };
}
const Lm = hw("utf8", "u", (t) => "u" + new TextDecoder("utf8").decode(t), (t) => new TextEncoder().encode(t.substring(1))), Cu = hw("ascii", "a", (t) => {
  let e = "a";
  for (let r = 0; r < t.length; r++) e += String.fromCharCode(t[r]);
  return e;
}, (t) => {
  t = t.substring(1);
  const e = dA(t.length);
  for (let r = 0; r < t.length; r++) e[r] = t.charCodeAt(r);
  return e;
}), pA = { utf8: Lm, "utf-8": Lm, hex: Nm.base16, latin1: Cu, ascii: Cu, binary: Cu, ...Nm };
function fA(t, e = "utf8") {
  const r = pA[e];
  if (!r) throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? uw(globalThis.Buffer.from(t, "utf-8")) : r.decoder.decode(`${r.prefix}${t}`);
}
var mA = Object.defineProperty, bA = (t, e, r) => e in t ? mA(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, jr = (t, e, r) => bA(t, typeof e != "symbol" ? e + "" : e, r);
let yA = class {
  constructor(e, r) {
    this.core = e, this.logger = r, jr(this, "keychain", /* @__PURE__ */ new Map()), jr(this, "name", b9), jr(this, "version", y9), jr(this, "initialized", !1), jr(this, "storagePrefix", Qr), jr(this, "init", async () => {
      if (!this.initialized) {
        const s = await this.getKeyChain();
        typeof s < "u" && (this.keychain = s), this.initialized = !0;
      }
    }), jr(this, "has", (s) => (this.isInitialized(), this.keychain.has(s))), jr(this, "set", async (s, n) => {
      this.isInitialized(), this.keychain.set(s, n), await this.persist();
    }), jr(this, "get", (s) => {
      this.isInitialized();
      const n = this.keychain.get(s);
      if (typeof n > "u") {
        const { message: i } = xe("NO_MATCHING_KEY", `${this.name}: ${s}`);
        throw new Error(i);
      }
      return n;
    }), jr(this, "del", async (s) => {
      this.isInitialized(), this.keychain.delete(s), await this.persist();
    }), this.core = e, this.logger = ve(r, this.name);
  }
  get context() {
    return De(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  async setKeyChain(e) {
    await this.core.storage.setItem(this.storageKey, Ah(e));
  }
  async getKeyChain() {
    const e = await this.core.storage.getItem(this.storageKey);
    return typeof e < "u" ? _h(e) : void 0;
  }
  async persist() {
    await this.setKeyChain(this.keychain);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = xe("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
};
var gA = Object.defineProperty, wA = (t, e, r) => e in t ? gA(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ot = (t, e, r) => wA(t, typeof e != "symbol" ? e + "" : e, r);
let EA = class {
  constructor(e, r, s) {
    this.core = e, this.logger = r, ot(this, "name", f9), ot(this, "keychain"), ot(this, "randomSessionIdentifier", Nh()), ot(this, "initialized", !1), ot(this, "init", async () => {
      this.initialized || (await this.keychain.init(), this.initialized = !0);
    }), ot(this, "hasKeys", (n) => (this.isInitialized(), this.keychain.has(n))), ot(this, "getClientId", async () => {
      this.isInitialized();
      const n = await this.getClientSeed(), i = Xc(n);
      return Gd(i.publicKey);
    }), ot(this, "generateKeyPair", () => {
      this.isInitialized();
      const n = wS();
      return this.setPrivateKey(n.publicKey, n.privateKey);
    }), ot(this, "signJWT", async (n) => {
      this.isInitialized();
      const i = await this.getClientSeed(), o = Xc(i), a = this.randomSessionIdentifier;
      return await cy(a, n, m9, o);
    }), ot(this, "generateSharedKey", (n, i, o) => {
      this.isInitialized();
      const a = this.getPrivateKey(n), c = ES(a, i);
      return this.setSymKey(c, o);
    }), ot(this, "setSymKey", async (n, i) => {
      this.isInitialized();
      const o = i || xS(n);
      return await this.keychain.set(o, n), o;
    }), ot(this, "deleteKeyPair", async (n) => {
      this.isInitialized(), await this.keychain.del(n);
    }), ot(this, "deleteSymKey", async (n) => {
      this.isInitialized(), await this.keychain.del(n);
    }), ot(this, "encode", async (n, i, o) => {
      this.isInitialized();
      const a = Hg(o), c = an(i);
      if (Em(a)) return CS(c, o == null ? void 0 : o.encoding);
      if (wm(a)) {
        const p = a.senderPublicKey, y = a.receiverPublicKey;
        n = await this.generateSharedKey(p, y);
      }
      const l = this.getSymKey(n), { type: u, senderPublicKey: h } = a;
      return vS({ type: u, symKey: l, message: c, senderPublicKey: h, encoding: o == null ? void 0 : o.encoding });
    }), ot(this, "decode", async (n, i, o) => {
      this.isInitialized();
      const a = IS(i, o);
      if (Em(a)) {
        const c = SS(i, o == null ? void 0 : o.encoding);
        return on(c);
      }
      if (wm(a)) {
        const c = a.receiverPublicKey, l = a.senderPublicKey;
        n = await this.generateSharedKey(c, l);
      }
      try {
        const c = this.getSymKey(n), l = kS({ symKey: c, encoded: i, encoding: o == null ? void 0 : o.encoding });
        return on(l);
      } catch (c) {
        this.logger.error(`Failed to decode message from topic: '${n}', clientId: '${await this.getClientId()}'`), this.logger.error(c);
      }
    }), ot(this, "getPayloadType", (n, i = In) => {
      const o = Yo({ encoded: n, encoding: i });
      return Tn(o.type);
    }), ot(this, "getPayloadSenderPublicKey", (n, i = In) => {
      const o = Yo({ encoded: n, encoding: i });
      return o.senderPublicKey ? Ce(o.senderPublicKey, $t) : void 0;
    }), this.core = e, this.logger = ve(r, this.name), this.keychain = s || new yA(this.core, this.logger);
  }
  get context() {
    return De(this.logger);
  }
  async setPrivateKey(e, r) {
    return await this.keychain.set(e, r), e;
  }
  getPrivateKey(e) {
    return this.keychain.get(e);
  }
  async getClientSeed() {
    let e = "";
    try {
      e = this.keychain.get(Um);
    } catch {
      e = Nh(), await this.keychain.set(Um, e);
    }
    return fA(e, "base16");
  }
  getSymKey(e) {
    return this.keychain.get(e);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = xe("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
};
var xA = Object.defineProperty, vA = Object.defineProperties, kA = Object.getOwnPropertyDescriptors, Mm = Object.getOwnPropertySymbols, CA = Object.prototype.hasOwnProperty, SA = Object.prototype.propertyIsEnumerable, Hh = (t, e, r) => e in t ? xA(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, IA = (t, e) => {
  for (var r in e || (e = {})) CA.call(e, r) && Hh(t, r, e[r]);
  if (Mm) for (var r of Mm(e)) SA.call(e, r) && Hh(t, r, e[r]);
  return t;
}, AA = (t, e) => vA(t, kA(e)), Zt = (t, e, r) => Hh(t, typeof e != "symbol" ? e + "" : e, r);
let _A = class extends qv {
  constructor(e, r) {
    super(e, r), this.logger = e, this.core = r, Zt(this, "messages", /* @__PURE__ */ new Map()), Zt(this, "messagesWithoutClientAck", /* @__PURE__ */ new Map()), Zt(this, "name", g9), Zt(this, "version", w9), Zt(this, "initialized", !1), Zt(this, "storagePrefix", Qr), Zt(this, "init", async () => {
      if (!this.initialized) {
        this.logger.trace("Initialized");
        try {
          const s = await this.getRelayerMessages();
          typeof s < "u" && (this.messages = s);
          const n = await this.getRelayerMessagesWithoutClientAck();
          typeof n < "u" && (this.messagesWithoutClientAck = n), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({ type: "method", method: "restore", size: this.messages.size });
        } catch (s) {
          this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(s);
        } finally {
          this.initialized = !0;
        }
      }
    }), Zt(this, "set", async (s, n, i) => {
      this.isInitialized();
      const o = Nc(n);
      let a = this.messages.get(s);
      if (typeof a > "u" && (a = {}), typeof a[o] < "u") return o;
      if (a[o] = n, this.messages.set(s, a), i === Lc.inbound) {
        const c = this.messagesWithoutClientAck.get(s) || {};
        this.messagesWithoutClientAck.set(s, AA(IA({}, c), { [o]: n }));
      }
      return await this.persist(), o;
    }), Zt(this, "get", (s) => {
      this.isInitialized();
      let n = this.messages.get(s);
      return typeof n > "u" && (n = {}), n;
    }), Zt(this, "getWithoutAck", (s) => {
      this.isInitialized();
      const n = {};
      for (const i of s) {
        const o = this.messagesWithoutClientAck.get(i) || {};
        n[i] = Object.values(o);
      }
      return n;
    }), Zt(this, "has", (s, n) => {
      this.isInitialized();
      const i = this.get(s), o = Nc(n);
      return typeof i[o] < "u";
    }), Zt(this, "ack", async (s, n) => {
      this.isInitialized();
      const i = this.messagesWithoutClientAck.get(s);
      if (typeof i > "u") return;
      const o = Nc(n);
      delete i[o], Object.keys(i).length === 0 ? this.messagesWithoutClientAck.delete(s) : this.messagesWithoutClientAck.set(s, i), await this.persist();
    }), Zt(this, "del", async (s) => {
      this.isInitialized(), this.messages.delete(s), this.messagesWithoutClientAck.delete(s), await this.persist();
    }), this.logger = ve(e, this.name), this.core = r;
  }
  get context() {
    return De(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get storageKeyWithoutClientAck() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name + "_withoutClientAck";
  }
  async setRelayerMessages(e) {
    await this.core.storage.setItem(this.storageKey, Ah(e));
  }
  async setRelayerMessagesWithoutClientAck(e) {
    await this.core.storage.setItem(this.storageKeyWithoutClientAck, Ah(e));
  }
  async getRelayerMessages() {
    const e = await this.core.storage.getItem(this.storageKey);
    return typeof e < "u" ? _h(e) : void 0;
  }
  async getRelayerMessagesWithoutClientAck() {
    const e = await this.core.storage.getItem(this.storageKeyWithoutClientAck);
    return typeof e < "u" ? _h(e) : void 0;
  }
  async persist() {
    await this.setRelayerMessages(this.messages), await this.setRelayerMessagesWithoutClientAck(this.messagesWithoutClientAck);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = xe("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
};
var TA = Object.defineProperty, UA = Object.defineProperties, $A = Object.getOwnPropertyDescriptors, Fm = Object.getOwnPropertySymbols, BA = Object.prototype.hasOwnProperty, DA = Object.prototype.propertyIsEnumerable, qh = (t, e, r) => e in t ? TA(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Za = (t, e) => {
  for (var r in e || (e = {})) BA.call(e, r) && qh(t, r, e[r]);
  if (Fm) for (var r of Fm(e)) DA.call(e, r) && qh(t, r, e[r]);
  return t;
}, Su = (t, e) => UA(t, $A(e)), kr = (t, e, r) => qh(t, typeof e != "symbol" ? e + "" : e, r);
let OA = class extends Kv {
  constructor(e, r) {
    super(e, r), this.relayer = e, this.logger = r, kr(this, "events", new dt.EventEmitter()), kr(this, "name", E9), kr(this, "queue", /* @__PURE__ */ new Map()), kr(this, "publishTimeout", V.toMiliseconds(V.ONE_MINUTE)), kr(this, "initialPublishTimeout", V.toMiliseconds(V.ONE_SECOND * 15)), kr(this, "needsTransportRestart", !1), kr(this, "publish", async (s, n, i) => {
      var o;
      this.logger.debug("Publishing Payload"), this.logger.trace({ type: "method", method: "publish", params: { topic: s, message: n, opts: i } });
      const a = (i == null ? void 0 : i.ttl) || $m, c = al(i), l = (i == null ? void 0 : i.prompt) || !1, u = (i == null ? void 0 : i.tag) || 0, h = (i == null ? void 0 : i.id) || ws().toString(), p = { topic: s, message: n, opts: { ttl: a, relay: c, prompt: l, tag: u, id: h, attestation: i == null ? void 0 : i.attestation, tvf: i == null ? void 0 : i.tvf } }, y = `Failed to publish payload, please try again. id:${h} tag:${u}`;
      try {
        const b = new Promise(async (g) => {
          const x = ({ id: U }) => {
            p.opts.id === U && (this.removeRequestFromQueue(U), this.relayer.events.removeListener(At.publish, x), g(p));
          };
          this.relayer.events.on(At.publish, x);
          const I = tn(new Promise((U, A) => {
            this.rpcPublish({ topic: s, message: n, ttl: a, prompt: l, tag: u, id: h, attestation: i == null ? void 0 : i.attestation, tvf: i == null ? void 0 : i.tvf }).then(U).catch((M) => {
              this.logger.warn(M, M == null ? void 0 : M.message), A(M);
            });
          }), this.initialPublishTimeout, `Failed initial publish, retrying.... id:${h} tag:${u}`);
          try {
            await I, this.events.removeListener(At.publish, x);
          } catch (U) {
            this.queue.set(h, Su(Za({}, p), { attempt: 1 })), this.logger.warn(U, U == null ? void 0 : U.message);
          }
        });
        this.logger.trace({ type: "method", method: "publish", params: { id: h, topic: s, message: n, opts: i } }), await tn(b, this.publishTimeout, y);
      } catch (b) {
        if (this.logger.debug("Failed to Publish Payload"), this.logger.error(b), (o = i == null ? void 0 : i.internal) != null && o.throwOnFailedPublish) throw b;
      } finally {
        this.queue.delete(h);
      }
    }), kr(this, "on", (s, n) => {
      this.events.on(s, n);
    }), kr(this, "once", (s, n) => {
      this.events.once(s, n);
    }), kr(this, "off", (s, n) => {
      this.events.off(s, n);
    }), kr(this, "removeListener", (s, n) => {
      this.events.removeListener(s, n);
    }), this.relayer = e, this.logger = ve(r, this.name), this.registerEventListeners();
  }
  get context() {
    return De(this.logger);
  }
  async rpcPublish(e) {
    var r, s, n, i;
    const { topic: o, message: a, ttl: c = $m, prompt: l, tag: u, id: h, attestation: p, tvf: y } = e, b = { method: vo(al().protocol).publish, params: Za({ topic: o, message: a, ttl: c, prompt: l, tag: u, attestation: p }, y), id: h };
    Lh((r = b.params) == null ? void 0 : r.prompt) && ((s = b.params) == null || delete s.prompt), Lh((n = b.params) == null ? void 0 : n.tag) && ((i = b.params) == null || delete i.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "message", direction: "outgoing", request: b });
    const g = await this.relayer.request(b);
    return this.relayer.events.emit(At.publish, e), this.logger.debug("Successfully Published Payload"), g;
  }
  removeRequestFromQueue(e) {
    this.queue.delete(e);
  }
  checkQueue() {
    this.queue.forEach(async (e, r) => {
      const s = e.attempt + 1;
      this.queue.set(r, Su(Za({}, e), { attempt: s }));
      const { topic: n, message: i, opts: o, attestation: a } = e;
      this.logger.warn({}, `Publisher: queue->publishing: ${e.opts.id}, tag: ${e.opts.tag}, attempt: ${s}`), await this.rpcPublish(Su(Za({}, e), { topic: n, message: i, ttl: o.ttl, prompt: o.prompt, tag: o.tag, id: o.id, attestation: a, tvf: o.tvf })), this.logger.warn({}, `Publisher: queue->published: ${e.opts.id}`);
    });
  }
  registerEventListeners() {
    this.relayer.core.heartbeat.on(ir.pulse, () => {
      if (this.needsTransportRestart) {
        this.needsTransportRestart = !1, this.relayer.events.emit(At.connection_stalled);
        return;
      }
      this.checkQueue();
    }), this.relayer.on(At.message_ack, (e) => {
      this.removeRequestFromQueue(e.id.toString());
    });
  }
};
var PA = Object.defineProperty, RA = (t, e, r) => e in t ? PA(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Vn = (t, e, r) => RA(t, typeof e != "symbol" ? e + "" : e, r);
let NA = class {
  constructor() {
    Vn(this, "map", /* @__PURE__ */ new Map()), Vn(this, "set", (e, r) => {
      const s = this.get(e);
      this.exists(e, r) || this.map.set(e, [...s, r]);
    }), Vn(this, "get", (e) => this.map.get(e) || []), Vn(this, "exists", (e, r) => this.get(e).includes(r)), Vn(this, "delete", (e, r) => {
      if (typeof r > "u") {
        this.map.delete(e);
        return;
      }
      if (!this.map.has(e)) return;
      const s = this.get(e);
      if (!this.exists(e, r)) return;
      const n = s.filter((i) => i !== r);
      if (!n.length) {
        this.map.delete(e);
        return;
      }
      this.map.set(e, n);
    }), Vn(this, "clear", () => {
      this.map.clear();
    });
  }
  get topics() {
    return Array.from(this.map.keys());
  }
};
var LA = Object.defineProperty, MA = Object.defineProperties, FA = Object.getOwnPropertyDescriptors, zm = Object.getOwnPropertySymbols, zA = Object.prototype.hasOwnProperty, jA = Object.prototype.propertyIsEnumerable, Kh = (t, e, r) => e in t ? LA(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Gi = (t, e) => {
  for (var r in e || (e = {})) zA.call(e, r) && Kh(t, r, e[r]);
  if (zm) for (var r of zm(e)) jA.call(e, r) && Kh(t, r, e[r]);
  return t;
}, Iu = (t, e) => MA(t, FA(e)), Ae = (t, e, r) => Kh(t, typeof e != "symbol" ? e + "" : e, r);
let HA = class extends Wv {
  constructor(e, r) {
    super(e, r), this.relayer = e, this.logger = r, Ae(this, "subscriptions", /* @__PURE__ */ new Map()), Ae(this, "topicMap", new NA()), Ae(this, "events", new dt.EventEmitter()), Ae(this, "name", _9), Ae(this, "version", T9), Ae(this, "pending", /* @__PURE__ */ new Map()), Ae(this, "cached", []), Ae(this, "initialized", !1), Ae(this, "storagePrefix", Qr), Ae(this, "subscribeTimeout", V.toMiliseconds(V.ONE_MINUTE)), Ae(this, "initialSubscribeTimeout", V.toMiliseconds(V.ONE_SECOND * 15)), Ae(this, "clientId"), Ae(this, "batchSubscribeTopicsLimit", 500), Ae(this, "init", async () => {
      this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), await this.restore()), this.initialized = !0;
    }), Ae(this, "subscribe", async (s, n) => {
      this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({ type: "method", method: "subscribe", params: { topic: s, opts: n } });
      try {
        const i = al(n), o = { topic: s, relay: i, transportType: n == null ? void 0 : n.transportType };
        this.pending.set(s, o);
        const a = await this.rpcSubscribe(s, i, n);
        return typeof a == "string" && (this.onSubscribe(a, o), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({ type: "method", method: "subscribe", params: { topic: s, opts: n } })), a;
      } catch (i) {
        throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(i), i;
      }
    }), Ae(this, "unsubscribe", async (s, n) => {
      this.isInitialized(), typeof (n == null ? void 0 : n.id) < "u" ? await this.unsubscribeById(s, n.id, n) : await this.unsubscribeByTopic(s, n);
    }), Ae(this, "isSubscribed", (s) => new Promise((n) => {
      n(this.topicMap.topics.includes(s));
    })), Ae(this, "isKnownTopic", (s) => new Promise((n) => {
      n(this.topicMap.topics.includes(s) || this.pending.has(s) || this.cached.some((i) => i.topic === s));
    })), Ae(this, "on", (s, n) => {
      this.events.on(s, n);
    }), Ae(this, "once", (s, n) => {
      this.events.once(s, n);
    }), Ae(this, "off", (s, n) => {
      this.events.off(s, n);
    }), Ae(this, "removeListener", (s, n) => {
      this.events.removeListener(s, n);
    }), Ae(this, "start", async () => {
      await this.onConnect();
    }), Ae(this, "stop", async () => {
      await this.onDisconnect();
    }), Ae(this, "restart", async () => {
      await this.restore(), await this.onRestart();
    }), Ae(this, "checkPending", async () => {
      if (this.pending.size === 0 && (!this.initialized || !this.relayer.connected)) return;
      const s = [];
      this.pending.forEach((n) => {
        s.push(n);
      }), await this.batchSubscribe(s);
    }), Ae(this, "registerEventListeners", () => {
      this.relayer.core.heartbeat.on(ir.pulse, async () => {
        await this.checkPending();
      }), this.events.on(Qt.created, async (s) => {
        const n = Qt.created;
        this.logger.info(`Emitting ${n}`), this.logger.debug({ type: "event", event: n, data: s }), await this.persist();
      }), this.events.on(Qt.deleted, async (s) => {
        const n = Qt.deleted;
        this.logger.info(`Emitting ${n}`), this.logger.debug({ type: "event", event: n, data: s }), await this.persist();
      });
    }), this.relayer = e, this.logger = ve(r, this.name), this.clientId = "";
  }
  get context() {
    return De(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
  }
  get length() {
    return this.subscriptions.size;
  }
  get ids() {
    return Array.from(this.subscriptions.keys());
  }
  get values() {
    return Array.from(this.subscriptions.values());
  }
  get topics() {
    return this.topicMap.topics;
  }
  get hasAnyTopics() {
    return this.topicMap.topics.length > 0 || this.pending.size > 0 || this.cached.length > 0 || this.subscriptions.size > 0;
  }
  hasSubscription(e, r) {
    let s = !1;
    try {
      s = this.getSubscription(e).topic === r;
    } catch {
    }
    return s;
  }
  reset() {
    this.cached = [], this.initialized = !0;
  }
  onDisable() {
    this.values.length > 0 && (this.cached = this.values), this.subscriptions.clear(), this.topicMap.clear();
  }
  async unsubscribeByTopic(e, r) {
    const s = this.topicMap.get(e);
    await Promise.all(s.map(async (n) => await this.unsubscribeById(e, n, r)));
  }
  async unsubscribeById(e, r, s) {
    this.logger.debug("Unsubscribing Topic"), this.logger.trace({ type: "method", method: "unsubscribe", params: { topic: e, id: r, opts: s } });
    try {
      const n = al(s);
      await this.restartToComplete({ topic: e, id: r, relay: n }), await this.rpcUnsubscribe(e, r, n);
      const i = ko("USER_DISCONNECTED", `${this.name}, ${e}`);
      await this.onUnsubscribe(e, r, i), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({ type: "method", method: "unsubscribe", params: { topic: e, id: r, opts: s } });
    } catch (n) {
      throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(n), n;
    }
  }
  async rpcSubscribe(e, r, s) {
    var n;
    (!s || (s == null ? void 0 : s.transportType) === ci.relay) && await this.restartToComplete({ topic: e, id: e, relay: r });
    const i = { method: vo(r.protocol).subscribe, params: { topic: e } };
    this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: i });
    const o = (n = s == null ? void 0 : s.internal) == null ? void 0 : n.throwOnFailedPublish;
    try {
      const a = await this.getSubscriptionId(e);
      if ((s == null ? void 0 : s.transportType) === ci.link_mode) return setTimeout(() => {
        (this.relayer.connected || this.relayer.connecting) && this.relayer.request(i).catch((u) => this.logger.warn(u));
      }, V.toMiliseconds(V.ONE_SECOND)), a;
      const c = new Promise(async (u) => {
        const h = (p) => {
          p.topic === e && (this.events.removeListener(Qt.created, h), u(p.id));
        };
        this.events.on(Qt.created, h);
        try {
          const p = await tn(new Promise((y, b) => {
            this.relayer.request(i).catch((g) => {
              this.logger.warn(g, g == null ? void 0 : g.message), b(g);
            }).then(y);
          }), this.initialSubscribeTimeout, `Subscribing to ${e} failed, please try again`);
          this.events.removeListener(Qt.created, h), u(p);
        } catch {
        }
      }), l = await tn(c, this.subscribeTimeout, `Subscribing to ${e} failed, please try again`);
      if (!l && o) throw new Error(`Subscribing to ${e} failed, please try again`);
      return l ? a : null;
    } catch (a) {
      if (this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit(At.connection_stalled), o) throw a;
    }
    return null;
  }
  async rpcBatchSubscribe(e) {
    if (!e.length) return;
    const r = e[0].relay, s = { method: vo(r.protocol).batchSubscribe, params: { topics: e.map((n) => n.topic) } };
    this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: s });
    try {
      await await tn(new Promise((n) => {
        this.relayer.request(s).catch((i) => this.logger.warn(i)).then(n);
      }), this.subscribeTimeout, "rpcBatchSubscribe failed, please try again");
    } catch {
      this.relayer.events.emit(At.connection_stalled);
    }
  }
  async rpcBatchFetchMessages(e) {
    if (!e.length) return;
    const r = e[0].relay, s = { method: vo(r.protocol).batchFetchMessages, params: { topics: e.map((i) => i.topic) } };
    this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: s });
    let n;
    try {
      n = await await tn(new Promise((i, o) => {
        this.relayer.request(s).catch((a) => {
          this.logger.warn(a), o(a);
        }).then(i);
      }), this.subscribeTimeout, "rpcBatchFetchMessages failed, please try again");
    } catch {
      this.relayer.events.emit(At.connection_stalled);
    }
    return n;
  }
  rpcUnsubscribe(e, r, s) {
    const n = { method: vo(s.protocol).unsubscribe, params: { topic: e, id: r } };
    return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: n }), this.relayer.request(n);
  }
  onSubscribe(e, r) {
    this.setSubscription(e, Iu(Gi({}, r), { id: e })), this.pending.delete(r.topic);
  }
  onBatchSubscribe(e) {
    e.length && e.forEach((r) => {
      this.setSubscription(r.id, Gi({}, r)), this.pending.delete(r.topic);
    });
  }
  async onUnsubscribe(e, r, s) {
    this.events.removeAllListeners(r), this.hasSubscription(r, e) && this.deleteSubscription(r, s), await this.relayer.messages.del(e);
  }
  async setRelayerSubscriptions(e) {
    await this.relayer.core.storage.setItem(this.storageKey, e);
  }
  async getRelayerSubscriptions() {
    return await this.relayer.core.storage.getItem(this.storageKey);
  }
  setSubscription(e, r) {
    this.logger.debug("Setting subscription"), this.logger.trace({ type: "method", method: "setSubscription", id: e, subscription: r }), this.addSubscription(e, r);
  }
  addSubscription(e, r) {
    this.subscriptions.set(e, Gi({}, r)), this.topicMap.set(r.topic, e), this.events.emit(Qt.created, r);
  }
  getSubscription(e) {
    this.logger.debug("Getting subscription"), this.logger.trace({ type: "method", method: "getSubscription", id: e });
    const r = this.subscriptions.get(e);
    if (!r) {
      const { message: s } = xe("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw new Error(s);
    }
    return r;
  }
  deleteSubscription(e, r) {
    this.logger.debug("Deleting subscription"), this.logger.trace({ type: "method", method: "deleteSubscription", id: e, reason: r });
    const s = this.getSubscription(e);
    this.subscriptions.delete(e), this.topicMap.delete(s.topic, e), this.events.emit(Qt.deleted, Iu(Gi({}, s), { reason: r }));
  }
  async persist() {
    await this.setRelayerSubscriptions(this.values), this.events.emit(Qt.sync);
  }
  async onRestart() {
    if (this.cached.length) {
      const e = [...this.cached], r = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
      for (let s = 0; s < r; s++) {
        const n = e.splice(0, this.batchSubscribeTopicsLimit);
        await this.batchSubscribe(n);
      }
    }
    this.events.emit(Qt.resubscribed);
  }
  async restore() {
    try {
      const e = await this.getRelayerSubscriptions();
      if (typeof e > "u" || !e.length) return;
      if (this.subscriptions.size) {
        const { message: r } = xe("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({ type: "method", method: "restore", subscriptions: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
    }
  }
  async batchSubscribe(e) {
    e.length && (await this.rpcBatchSubscribe(e), this.onBatchSubscribe(await Promise.all(e.map(async (r) => Iu(Gi({}, r), { id: await this.getSubscriptionId(r.topic) })))));
  }
  async batchFetchMessages(e) {
    if (!e.length) return;
    this.logger.trace(`Fetching batch messages for ${e.length} subscriptions`);
    const r = await this.rpcBatchFetchMessages(e);
    r && r.messages && (await g5(V.toMiliseconds(V.ONE_SECOND)), await this.relayer.handleBatchMessageEvents(r.messages));
  }
  async onConnect() {
    await this.restart(), this.reset();
  }
  onDisconnect() {
    this.onDisable();
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = xe("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  async restartToComplete(e) {
    !this.relayer.connected && !this.relayer.connecting && (this.cached.push(e), await this.relayer.transportOpen());
  }
  async getClientId() {
    return this.clientId || (this.clientId = await this.relayer.core.crypto.getClientId()), this.clientId;
  }
  async getSubscriptionId(e) {
    return Nc(e + await this.getClientId());
  }
};
var qA = Object.defineProperty, jm = Object.getOwnPropertySymbols, KA = Object.prototype.hasOwnProperty, VA = Object.prototype.propertyIsEnumerable, Vh = (t, e, r) => e in t ? qA(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Hm = (t, e) => {
  for (var r in e || (e = {})) KA.call(e, r) && Vh(t, r, e[r]);
  if (jm) for (var r of jm(e)) VA.call(e, r) && Vh(t, r, e[r]);
  return t;
}, be = (t, e, r) => Vh(t, typeof e != "symbol" ? e + "" : e, r);
let GA = class extends Vv {
  constructor(e) {
    super(e), be(this, "protocol", "wc"), be(this, "version", 2), be(this, "core"), be(this, "logger"), be(this, "events", new dt.EventEmitter()), be(this, "provider"), be(this, "messages"), be(this, "subscriber"), be(this, "publisher"), be(this, "name", k9), be(this, "transportExplicitlyClosed", !1), be(this, "initialized", !1), be(this, "connectionAttemptInProgress", !1), be(this, "relayUrl"), be(this, "projectId"), be(this, "packageName"), be(this, "bundleId"), be(this, "hasExperiencedNetworkDisruption", !1), be(this, "pingTimeout"), be(this, "heartBeatTimeout", V.toMiliseconds(V.THIRTY_SECONDS + V.FIVE_SECONDS)), be(this, "reconnectTimeout"), be(this, "connectPromise"), be(this, "reconnectInProgress", !1), be(this, "requestsInFlight", []), be(this, "connectTimeout", V.toMiliseconds(V.ONE_SECOND * 15)), be(this, "request", async (r) => {
      var s, n;
      this.logger.debug("Publishing Request Payload");
      const i = r.id || ws().toString();
      await this.toEstablishConnection();
      try {
        this.logger.trace({ id: i, method: r.method, topic: (s = r.params) == null ? void 0 : s.topic }, "relayer.request - publishing...");
        const o = `${i}:${((n = r.params) == null ? void 0 : n.tag) || ""}`;
        this.requestsInFlight.push(o);
        const a = await this.provider.request(r);
        return this.requestsInFlight = this.requestsInFlight.filter((c) => c !== o), a;
      } catch (o) {
        throw this.logger.debug(`Failed to Publish Request: ${i}`), o;
      }
    }), be(this, "resetPingTimeout", () => {
      nl() && (clearTimeout(this.pingTimeout), this.pingTimeout = setTimeout(() => {
        var r, s, n, i;
        try {
          this.logger.debug({}, "pingTimeout: Connection stalled, terminating..."), (i = (n = (s = (r = this.provider) == null ? void 0 : r.connection) == null ? void 0 : s.socket) == null ? void 0 : n.terminate) == null || i.call(n);
        } catch (o) {
          this.logger.warn(o, o == null ? void 0 : o.message);
        }
      }, this.heartBeatTimeout));
    }), be(this, "onPayloadHandler", (r) => {
      this.onProviderPayload(r), this.resetPingTimeout();
    }), be(this, "onConnectHandler", () => {
      this.logger.warn({}, "Relayer connected 🛜"), this.startPingTimeout(), this.events.emit(At.connect);
    }), be(this, "onDisconnectHandler", () => {
      this.logger.warn({}, "Relayer disconnected 🛑"), this.requestsInFlight = [], this.onProviderDisconnect();
    }), be(this, "onProviderErrorHandler", (r) => {
      this.logger.fatal(`Fatal socket error: ${r.message}`), this.events.emit(At.error, r), this.logger.fatal("Fatal socket error received, closing transport"), this.transportClose();
    }), be(this, "registerProviderListeners", () => {
      this.provider.on(cr.payload, this.onPayloadHandler), this.provider.on(cr.connect, this.onConnectHandler), this.provider.on(cr.disconnect, this.onDisconnectHandler), this.provider.on(cr.error, this.onProviderErrorHandler);
    }), this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? ve(e.logger, this.name) : ca(ua({ level: e.logger || v9 })), this.messages = new _A(this.logger, e.core), this.subscriber = new HA(this, this.logger), this.publisher = new OA(this, this.logger), this.relayUrl = (e == null ? void 0 : e.relayUrl) || Qg, this.projectId = e.projectId, a5() ? this.packageName = Wf() : c5() && (this.bundleId = Wf()), this.provider = {};
  }
  async init() {
    this.logger.trace("Initialized"), this.registerEventListeners(), await Promise.all([this.messages.init(), this.subscriber.init()]), this.initialized = !0, this.transportOpen().catch((e) => this.logger.warn(e, e == null ? void 0 : e.message));
  }
  get context() {
    return De(this.logger);
  }
  get connected() {
    var e, r, s;
    return ((s = (r = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : r.socket) == null ? void 0 : s.readyState) === 1 || !1;
  }
  get connecting() {
    var e, r, s;
    return ((s = (r = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : r.socket) == null ? void 0 : s.readyState) === 0 || this.connectPromise !== void 0 || !1;
  }
  async publish(e, r, s) {
    this.isInitialized(), await this.publisher.publish(e, r, s), await this.recordMessageEvent({ topic: e, message: r, publishedAt: Date.now(), transportType: ci.relay }, Lc.outbound);
  }
  async subscribe(e, r) {
    var s, n, i;
    this.isInitialized(), (!(r != null && r.transportType) || (r == null ? void 0 : r.transportType) === "relay") && await this.toEstablishConnection();
    const o = typeof ((s = r == null ? void 0 : r.internal) == null ? void 0 : s.throwOnFailedPublish) > "u" ? !0 : (n = r == null ? void 0 : r.internal) == null ? void 0 : n.throwOnFailedPublish;
    let a = ((i = this.subscriber.topicMap.get(e)) == null ? void 0 : i[0]) || "", c;
    const l = (u) => {
      u.topic === e && (this.subscriber.off(Qt.created, l), c());
    };
    return await Promise.all([new Promise((u) => {
      c = u, this.subscriber.on(Qt.created, l);
    }), new Promise(async (u, h) => {
      a = await this.subscriber.subscribe(e, Hm({ internal: { throwOnFailedPublish: o } }, r)).catch((p) => {
        o && h(p);
      }) || a, u();
    })]), a;
  }
  async unsubscribe(e, r) {
    this.isInitialized(), await this.subscriber.unsubscribe(e, r);
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  async transportDisconnect() {
    this.provider.disconnect && (this.hasExperiencedNetworkDisruption || this.connected) ? await tn(this.provider.disconnect(), 2e3, "provider.disconnect()").catch(() => this.onProviderDisconnect()) : this.onProviderDisconnect();
  }
  async transportClose() {
    this.transportExplicitlyClosed = !0, await this.transportDisconnect();
  }
  async transportOpen(e) {
    if (!this.subscriber.hasAnyTopics) {
      this.logger.warn("Starting WS connection skipped because the client has no topics to work with.");
      return;
    }
    if (this.connectPromise ? (this.logger.debug({}, "Waiting for existing connection attempt to resolve..."), await this.connectPromise, this.logger.debug({}, "Existing connection attempt resolved")) : (this.connectPromise = new Promise(async (r, s) => {
      await this.connect(e).then(r).catch(s).finally(() => {
        this.connectPromise = void 0;
      });
    }), await this.connectPromise), !this.connected) throw new Error(`Couldn't establish socket connection to the relay server: ${this.relayUrl}`);
  }
  async restartTransport(e) {
    this.logger.debug({}, "Restarting transport..."), !this.connectionAttemptInProgress && (this.relayUrl = e || this.relayUrl, await this.confirmOnlineStateOrThrow(), await this.transportClose(), await this.transportOpen());
  }
  async confirmOnlineStateOrThrow() {
    if (!await km()) throw new Error("No internet connection detected. Please restart your network and try again.");
  }
  async handleBatchMessageEvents(e) {
    if ((e == null ? void 0 : e.length) === 0) {
      this.logger.trace("Batch message events is empty. Ignoring...");
      return;
    }
    const r = e.sort((s, n) => s.publishedAt - n.publishedAt);
    this.logger.debug(`Batch of ${r.length} message events sorted`);
    for (const s of r) try {
      await this.onMessageEvent(s);
    } catch (n) {
      this.logger.warn(n, "Error while processing batch message event: " + (n == null ? void 0 : n.message));
    }
    this.logger.trace(`Batch of ${r.length} message events processed`);
  }
  async onLinkMessageEvent(e, r) {
    const { topic: s } = e;
    if (!r.sessionExists) {
      const n = $o(V.FIVE_MINUTES), i = { topic: s, expiry: n, relay: { protocol: "irn" }, active: !1 };
      await this.core.pairing.pairings.set(s, i);
    }
    this.events.emit(At.message, e), await this.recordMessageEvent(e, Lc.inbound);
  }
  async connect(e) {
    await this.confirmOnlineStateOrThrow(), e && e !== this.relayUrl && (this.relayUrl = e, await this.transportDisconnect()), this.connectionAttemptInProgress = !0, this.transportExplicitlyClosed = !1;
    let r = 1;
    for (; r < 6; ) {
      try {
        if (this.transportExplicitlyClosed) break;
        this.logger.debug({}, `Connecting to ${this.relayUrl}, attempt: ${r}...`), await this.createProvider(), await new Promise(async (s, n) => {
          const i = () => {
            n(new Error("Connection interrupted while trying to connect"));
          };
          this.provider.once(cr.disconnect, i), await tn(new Promise((o, a) => {
            this.provider.connect().then(o).catch(a);
          }), this.connectTimeout, `Socket stalled when trying to connect to ${this.relayUrl}`).catch((o) => {
            n(o);
          }).finally(() => {
            this.provider.off(cr.disconnect, i), clearTimeout(this.reconnectTimeout);
          }), await new Promise(async (o, a) => {
            const c = () => {
              n(new Error("Connection interrupted while trying to subscribe"));
            };
            this.provider.once(cr.disconnect, c), await this.subscriber.start().then(o).catch(a).finally(() => {
              this.provider.off(cr.disconnect, c);
            });
          }), this.hasExperiencedNetworkDisruption = !1, s();
        });
      } catch (s) {
        await this.subscriber.stop();
        const n = s;
        this.logger.warn({}, n.message), this.hasExperiencedNetworkDisruption = !0;
      } finally {
        this.connectionAttemptInProgress = !1;
      }
      if (this.connected) {
        this.logger.debug({}, `Connected to ${this.relayUrl} successfully on attempt: ${r}`);
        break;
      }
      await new Promise((s) => setTimeout(s, V.toMiliseconds(r * 1))), r++;
    }
  }
  startPingTimeout() {
    var e, r, s, n, i;
    if (nl()) try {
      (r = (e = this.provider) == null ? void 0 : e.connection) != null && r.socket && ((i = (n = (s = this.provider) == null ? void 0 : s.connection) == null ? void 0 : n.socket) == null || i.on("ping", () => {
        this.resetPingTimeout();
      })), this.resetPingTimeout();
    } catch (o) {
      this.logger.warn(o, o == null ? void 0 : o.message);
    }
  }
  async createProvider() {
    this.provider.connection && this.unregisterProviderListeners();
    const e = await this.core.crypto.signJWT(this.relayUrl);
    this.provider = new Zg(new Jg(p5({ sdkVersion: Fh, protocol: this.protocol, version: this.version, relayUrl: this.relayUrl, projectId: this.projectId, auth: e, useOnCloseEvent: !0, bundleId: this.bundleId, packageName: this.packageName }))), this.registerProviderListeners();
  }
  async recordMessageEvent(e, r) {
    const { topic: s, message: n } = e;
    await this.messages.set(s, n, r);
  }
  async shouldIgnoreMessageEvent(e) {
    const { topic: r, message: s } = e;
    if (!s || s.length === 0) return this.logger.warn(`Ignoring invalid/empty message: ${s}`), !0;
    if (!await this.subscriber.isKnownTopic(r)) return this.logger.warn(`Ignoring message for unknown topic ${r}`), !0;
    const n = this.messages.has(r, s);
    return n && this.logger.warn(`Ignoring duplicate message: ${s}`), n;
  }
  async onProviderPayload(e) {
    if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({ type: "payload", direction: "incoming", payload: e }), wa(e)) {
      if (!e.method.endsWith(C9)) return;
      const r = e.params, { topic: s, message: n, publishedAt: i, attestation: o } = r.data, a = { topic: s, message: n, publishedAt: i, transportType: ci.relay, attestation: o };
      this.logger.debug("Emitting Relayer Payload"), this.logger.trace(Hm({ type: "event", event: r.id }, a)), this.events.emit(r.id, a), await this.acknowledgePayload(e), await this.onMessageEvent(a);
    } else ki(e) && this.events.emit(At.message_ack, e);
  }
  async onMessageEvent(e) {
    await this.shouldIgnoreMessageEvent(e) || (await this.recordMessageEvent(e, Lc.inbound), this.events.emit(At.message, e));
  }
  async acknowledgePayload(e) {
    const r = ga(e.id, !0);
    await this.provider.connection.send(r);
  }
  unregisterProviderListeners() {
    this.provider.off(cr.payload, this.onPayloadHandler), this.provider.off(cr.connect, this.onConnectHandler), this.provider.off(cr.disconnect, this.onDisconnectHandler), this.provider.off(cr.error, this.onProviderErrorHandler), clearTimeout(this.pingTimeout);
  }
  async registerEventListeners() {
    let e = await km();
    zS(async (r) => {
      e !== r && (e = r, r ? await this.transportOpen().catch((s) => this.logger.error(s, s == null ? void 0 : s.message)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportDisconnect(), this.transportExplicitlyClosed = !1));
    }), this.core.heartbeat.on(ir.pulse, async () => {
      if (!this.transportExplicitlyClosed && !this.connected && qS()) try {
        await this.confirmOnlineStateOrThrow(), await this.transportOpen();
      } catch (r) {
        this.logger.warn(r, r == null ? void 0 : r.message);
      }
    });
  }
  async onProviderDisconnect() {
    clearTimeout(this.pingTimeout), this.events.emit(At.disconnect), this.connectionAttemptInProgress = !1, !this.reconnectInProgress && (this.reconnectInProgress = !0, await this.subscriber.stop(), this.subscriber.hasAnyTopics && (this.transportExplicitlyClosed || (this.reconnectTimeout = setTimeout(async () => {
      await this.transportOpen().catch((e) => this.logger.error(e, e == null ? void 0 : e.message)), this.reconnectTimeout = void 0, this.reconnectInProgress = !1;
    }, V.toMiliseconds(S9)))));
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = xe("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  async toEstablishConnection() {
    if (await this.confirmOnlineStateOrThrow(), !this.connected) {
      if (this.connectPromise) {
        await this.connectPromise;
        return;
      }
      await this.connect();
    }
  }
};
function WA(t, e) {
  return t === e || Number.isNaN(t) && Number.isNaN(e);
}
function qm(t) {
  return Object.getOwnPropertySymbols(t).filter((e) => Object.prototype.propertyIsEnumerable.call(t, e));
}
function Km(t) {
  return t == null ? t === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(t);
}
const ZA = "[object RegExp]", JA = "[object String]", XA = "[object Number]", YA = "[object Boolean]", Vm = "[object Arguments]", QA = "[object Symbol]", e_ = "[object Date]", t_ = "[object Map]", r_ = "[object Set]", s_ = "[object Array]", n_ = "[object Function]", i_ = "[object ArrayBuffer]", Au = "[object Object]", o_ = "[object Error]", a_ = "[object DataView]", c_ = "[object Uint8Array]", l_ = "[object Uint8ClampedArray]", u_ = "[object Uint16Array]", h_ = "[object Uint32Array]", d_ = "[object BigUint64Array]", p_ = "[object Int8Array]", f_ = "[object Int16Array]", m_ = "[object Int32Array]", b_ = "[object BigInt64Array]", y_ = "[object Float32Array]", g_ = "[object Float64Array]";
function w_() {
}
function Gm(t) {
  if (!t || typeof t != "object") return !1;
  const e = Object.getPrototypeOf(t);
  return e === null || e === Object.prototype || Object.getPrototypeOf(e) === null ? Object.prototype.toString.call(t) === "[object Object]" : !1;
}
function E_(t, e, r) {
  return Co(t, e, void 0, void 0, void 0, void 0, r);
}
function Co(t, e, r, s, n, i, o) {
  const a = o(t, e, r, s, n, i);
  if (a !== void 0) return a;
  if (typeof t == typeof e) switch (typeof t) {
    case "bigint":
    case "string":
    case "boolean":
    case "symbol":
    case "undefined":
      return t === e;
    case "number":
      return t === e || Object.is(t, e);
    case "function":
      return t === e;
    case "object":
      return No(t, e, i, o);
  }
  return No(t, e, i, o);
}
function No(t, e, r, s) {
  if (Object.is(t, e)) return !0;
  let n = Km(t), i = Km(e);
  if (n === Vm && (n = Au), i === Vm && (i = Au), n !== i) return !1;
  switch (n) {
    case JA:
      return t.toString() === e.toString();
    case XA: {
      const c = t.valueOf(), l = e.valueOf();
      return WA(c, l);
    }
    case YA:
    case e_:
    case QA:
      return Object.is(t.valueOf(), e.valueOf());
    case ZA:
      return t.source === e.source && t.flags === e.flags;
    case n_:
      return t === e;
  }
  r = r ?? /* @__PURE__ */ new Map();
  const o = r.get(t), a = r.get(e);
  if (o != null && a != null) return o === e;
  r.set(t, e), r.set(e, t);
  try {
    switch (n) {
      case t_: {
        if (t.size !== e.size) return !1;
        for (const [c, l] of t.entries()) if (!e.has(c) || !Co(l, e.get(c), c, t, e, r, s)) return !1;
        return !0;
      }
      case r_: {
        if (t.size !== e.size) return !1;
        const c = Array.from(t.values()), l = Array.from(e.values());
        for (let u = 0; u < c.length; u++) {
          const h = c[u], p = l.findIndex((y) => Co(h, y, void 0, t, e, r, s));
          if (p === -1) return !1;
          l.splice(p, 1);
        }
        return !0;
      }
      case s_:
      case c_:
      case l_:
      case u_:
      case h_:
      case d_:
      case p_:
      case f_:
      case m_:
      case b_:
      case y_:
      case g_: {
        if (typeof Buffer < "u" && Buffer.isBuffer(t) !== Buffer.isBuffer(e) || t.length !== e.length) return !1;
        for (let c = 0; c < t.length; c++) if (!Co(t[c], e[c], c, t, e, r, s)) return !1;
        return !0;
      }
      case i_:
        return t.byteLength !== e.byteLength ? !1 : No(new Uint8Array(t), new Uint8Array(e), r, s);
      case a_:
        return t.byteLength !== e.byteLength || t.byteOffset !== e.byteOffset ? !1 : No(new Uint8Array(t), new Uint8Array(e), r, s);
      case o_:
        return t.name === e.name && t.message === e.message;
      case Au: {
        if (!(No(t.constructor, e.constructor, r, s) || Gm(t) && Gm(e))) return !1;
        const c = [...Object.keys(t), ...qm(t)], l = [...Object.keys(e), ...qm(e)];
        if (c.length !== l.length) return !1;
        for (let u = 0; u < c.length; u++) {
          const h = c[u], p = t[h];
          if (!Object.hasOwn(e, h)) return !1;
          const y = e[h];
          if (!Co(p, y, h, t, e, r, s)) return !1;
        }
        return !0;
      }
      default:
        return !1;
    }
  } finally {
    r.delete(t), r.delete(e);
  }
}
function x_(t, e) {
  return E_(t, e, w_);
}
var v_ = Object.defineProperty, Wm = Object.getOwnPropertySymbols, k_ = Object.prototype.hasOwnProperty, C_ = Object.prototype.propertyIsEnumerable, Gh = (t, e, r) => e in t ? v_(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Zm = (t, e) => {
  for (var r in e || (e = {})) k_.call(e, r) && Gh(t, r, e[r]);
  if (Wm) for (var r of Wm(e)) C_.call(e, r) && Gh(t, r, e[r]);
  return t;
}, Pt = (t, e, r) => Gh(t, typeof e != "symbol" ? e + "" : e, r);
let S_ = class extends Gv {
  constructor(e, r, s, n = Qr, i = void 0) {
    super(e, r, s, n), this.core = e, this.logger = r, this.name = s, Pt(this, "map", /* @__PURE__ */ new Map()), Pt(this, "version", I9), Pt(this, "cached", []), Pt(this, "initialized", !1), Pt(this, "getKey"), Pt(this, "storagePrefix", Qr), Pt(this, "recentlyDeleted", []), Pt(this, "recentlyDeletedLimit", 200), Pt(this, "init", async () => {
      this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((o) => {
        this.getKey && o !== null && !Lh(o) ? this.map.set(this.getKey(o), o) : RS(o) ? this.map.set(o.id, o) : NS(o) && this.map.set(o.topic, o);
      }), this.cached = [], this.initialized = !0);
    }), Pt(this, "set", async (o, a) => {
      this.isInitialized(), this.map.has(o) ? await this.update(o, a) : (this.logger.debug("Setting value"), this.logger.trace({ type: "method", method: "set", key: o, value: a }), this.map.set(o, a), await this.persist());
    }), Pt(this, "get", (o) => (this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({ type: "method", method: "get", key: o }), this.getData(o))), Pt(this, "getAll", (o) => (this.isInitialized(), o ? this.values.filter((a) => Object.keys(o).every((c) => x_(a[c], o[c]))) : this.values)), Pt(this, "update", async (o, a) => {
      this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({ type: "method", method: "update", key: o, update: a });
      const c = Zm(Zm({}, this.getData(o)), a);
      this.map.set(o, c), await this.persist();
    }), Pt(this, "delete", async (o, a) => {
      this.isInitialized(), this.map.has(o) && (this.logger.debug("Deleting value"), this.logger.trace({ type: "method", method: "delete", key: o, reason: a }), this.map.delete(o), this.addToRecentlyDeleted(o), await this.persist());
    }), this.logger = ve(r, this.name), this.storagePrefix = n, this.getKey = i;
  }
  get context() {
    return De(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get length() {
    return this.map.size;
  }
  get keys() {
    return Array.from(this.map.keys());
  }
  get values() {
    return Array.from(this.map.values());
  }
  addToRecentlyDeleted(e) {
    this.recentlyDeleted.push(e), this.recentlyDeleted.length >= this.recentlyDeletedLimit && this.recentlyDeleted.splice(0, this.recentlyDeletedLimit / 2);
  }
  async setDataStore(e) {
    await this.core.storage.setItem(this.storageKey, e);
  }
  async getDataStore() {
    return await this.core.storage.getItem(this.storageKey);
  }
  getData(e) {
    const r = this.map.get(e);
    if (!r) {
      if (this.recentlyDeleted.includes(e)) {
        const { message: n } = xe("MISSING_OR_INVALID", `Record was recently deleted - ${this.name}: ${e}`);
        throw this.logger.error(n), new Error(n);
      }
      const { message: s } = xe("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw this.logger.error(s), new Error(s);
    }
    return r;
  }
  async persist() {
    await this.setDataStore(this.values);
  }
  async restore() {
    try {
      const e = await this.getDataStore();
      if (typeof e > "u" || !e.length) return;
      if (this.map.size) {
        const { message: r } = xe("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({ type: "method", method: "restore", value: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
    }
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = xe("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
};
var I_ = Object.defineProperty, A_ = (t, e, r) => e in t ? I_(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, he = (t, e, r) => A_(t, typeof e != "symbol" ? e + "" : e, r);
let __ = class {
  constructor(e, r) {
    this.core = e, this.logger = r, he(this, "name", U9), he(this, "version", $9), he(this, "events", new Ld()), he(this, "pairings"), he(this, "initialized", !1), he(this, "storagePrefix", Qr), he(this, "ignoredPayloadTypes", [vi]), he(this, "registeredMethods", []), he(this, "init", async () => {
      this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
    }), he(this, "register", ({ methods: s }) => {
      this.isInitialized(), this.registeredMethods = [.../* @__PURE__ */ new Set([...this.registeredMethods, ...s])];
    }), he(this, "create", async (s) => {
      this.isInitialized();
      const n = Nh(), i = await this.core.crypto.setSymKey(n), o = $o(V.FIVE_MINUTES), a = { protocol: x9 }, c = { topic: i, expiry: o, relay: a, active: !1, methods: s == null ? void 0 : s.methods }, l = vm({ protocol: this.core.protocol, version: this.core.version, topic: i, symKey: n, relay: a, expiryTimestamp: o, methods: s == null ? void 0 : s.methods });
      return this.events.emit(Vi.create, c), this.core.expirer.set(i, o), await this.pairings.set(i, c), await this.core.relayer.subscribe(i, { transportType: s == null ? void 0 : s.transportType }), { topic: i, uri: l };
    }), he(this, "pair", async (s) => {
      this.isInitialized();
      const n = this.core.eventClient.createEvent({ properties: { topic: s == null ? void 0 : s.uri, trace: [as.pairing_started] } });
      this.isValidPair(s, n);
      const { topic: i, symKey: o, relay: a, expiryTimestamp: c, methods: l } = xm(s.uri);
      n.props.properties.topic = i, n.addTrace(as.pairing_uri_validation_success), n.addTrace(as.pairing_uri_not_expired);
      let u;
      if (this.pairings.keys.includes(i)) {
        if (u = this.pairings.get(i), n.addTrace(as.existing_pairing), u.active) throw n.setError(Fs.active_pairing_already_exists), new Error(`Pairing already exists: ${i}. Please try again with a new connection URI.`);
        n.addTrace(as.pairing_not_expired);
      }
      const h = c || $o(V.FIVE_MINUTES), p = { topic: i, relay: a, expiry: h, active: !1, methods: l };
      this.core.expirer.set(i, h), await this.pairings.set(i, p), n.addTrace(as.store_new_pairing), s.activatePairing && await this.activate({ topic: i }), this.events.emit(Vi.create, p), n.addTrace(as.emit_inactive_pairing), this.core.crypto.keychain.has(i) || await this.core.crypto.setSymKey(o, i), n.addTrace(as.subscribing_pairing_topic);
      try {
        await this.core.relayer.confirmOnlineStateOrThrow();
      } catch {
        n.setError(Fs.no_internet_connection);
      }
      try {
        await this.core.relayer.subscribe(i, { relay: a });
      } catch (y) {
        throw n.setError(Fs.subscribe_pairing_topic_failure), y;
      }
      return n.addTrace(as.subscribe_pairing_topic_success), p;
    }), he(this, "activate", async ({ topic: s }) => {
      this.isInitialized();
      const n = $o(V.FIVE_MINUTES);
      this.core.expirer.set(s, n), await this.pairings.update(s, { active: !0, expiry: n });
    }), he(this, "ping", async (s) => {
      this.isInitialized(), await this.isValidPing(s), this.logger.warn("ping() is deprecated and will be removed in the next major release.");
      const { topic: n } = s;
      if (this.pairings.keys.includes(n)) {
        const i = await this.sendRequest(n, "wc_pairingPing", {}), { done: o, resolve: a, reject: c } = f5();
        this.events.once(mu("pairing_ping", i), ({ error: l }) => {
          l ? c(l) : a();
        }), await o();
      }
    }), he(this, "updateExpiry", async ({ topic: s, expiry: n }) => {
      this.isInitialized(), await this.pairings.update(s, { expiry: n });
    }), he(this, "updateMetadata", async ({ topic: s, metadata: n }) => {
      this.isInitialized(), await this.pairings.update(s, { peerMetadata: n });
    }), he(this, "getPairings", () => (this.isInitialized(), this.pairings.values)), he(this, "disconnect", async (s) => {
      this.isInitialized(), await this.isValidDisconnect(s);
      const { topic: n } = s;
      this.pairings.keys.includes(n) && (await this.sendRequest(n, "wc_pairingDelete", ko("USER_DISCONNECTED")), await this.deletePairing(n));
    }), he(this, "formatUriFromPairing", (s) => {
      this.isInitialized();
      const { topic: n, relay: i, expiry: o, methods: a } = s, c = this.core.crypto.keychain.get(n);
      return vm({ protocol: this.core.protocol, version: this.core.version, topic: n, symKey: c, relay: i, expiryTimestamp: o, methods: a });
    }), he(this, "sendRequest", async (s, n, i) => {
      const o = Es(n, i), a = await this.core.crypto.encode(s, o), c = Ki[n].req;
      return this.core.history.set(s, o), this.core.relayer.publish(s, a, c), o.id;
    }), he(this, "sendResult", async (s, n, i) => {
      const o = ga(s, i), a = await this.core.crypto.encode(n, o), c = (await this.core.history.get(n, s)).request.method, l = Ki[c].res;
      await this.core.relayer.publish(n, a, l), await this.core.history.resolve(o);
    }), he(this, "sendError", async (s, n, i) => {
      const o = $l(s, i), a = await this.core.crypto.encode(n, o), c = (await this.core.history.get(n, s)).request.method, l = Ki[c] ? Ki[c].res : Ki.unregistered_method.res;
      await this.core.relayer.publish(n, a, l), await this.core.history.resolve(o);
    }), he(this, "deletePairing", async (s, n) => {
      await this.core.relayer.unsubscribe(s), await Promise.all([this.pairings.delete(s, ko("USER_DISCONNECTED")), this.core.crypto.deleteSymKey(s), n ? Promise.resolve() : this.core.expirer.del(s)]);
    }), he(this, "cleanup", async () => {
      const s = this.pairings.getAll().filter((n) => Zf(n.expiry));
      await Promise.all(s.map((n) => this.deletePairing(n.topic)));
    }), he(this, "onRelayEventRequest", async (s) => {
      const { topic: n, payload: i } = s;
      switch (i.method) {
        case "wc_pairingPing":
          return await this.onPairingPingRequest(n, i);
        case "wc_pairingDelete":
          return await this.onPairingDeleteRequest(n, i);
        default:
          return await this.onUnknownRpcMethodRequest(n, i);
      }
    }), he(this, "onRelayEventResponse", async (s) => {
      const { topic: n, payload: i } = s, o = (await this.core.history.get(n, i.id)).request.method;
      switch (o) {
        case "wc_pairingPing":
          return this.onPairingPingResponse(n, i);
        default:
          return this.onUnknownRpcMethodResponse(o);
      }
    }), he(this, "onPairingPingRequest", async (s, n) => {
      const { id: i } = n;
      try {
        this.isValidPing({ topic: s }), await this.sendResult(i, s, !0), this.events.emit(Vi.ping, { id: i, topic: s });
      } catch (o) {
        await this.sendError(i, s, o), this.logger.error(o);
      }
    }), he(this, "onPairingPingResponse", (s, n) => {
      const { id: i } = n;
      setTimeout(() => {
        Dr(n) ? this.events.emit(mu("pairing_ping", i), {}) : jt(n) && this.events.emit(mu("pairing_ping", i), { error: n.error });
      }, 500);
    }), he(this, "onPairingDeleteRequest", async (s, n) => {
      const { id: i } = n;
      try {
        this.isValidDisconnect({ topic: s }), await this.deletePairing(s), this.events.emit(Vi.delete, { id: i, topic: s });
      } catch (o) {
        await this.sendError(i, s, o), this.logger.error(o);
      }
    }), he(this, "onUnknownRpcMethodRequest", async (s, n) => {
      const { id: i, method: o } = n;
      try {
        if (this.registeredMethods.includes(o)) return;
        const a = ko("WC_METHOD_UNSUPPORTED", o);
        await this.sendError(i, s, a), this.logger.error(a);
      } catch (a) {
        await this.sendError(i, s, a), this.logger.error(a);
      }
    }), he(this, "onUnknownRpcMethodResponse", (s) => {
      this.registeredMethods.includes(s) || this.logger.error(ko("WC_METHOD_UNSUPPORTED", s));
    }), he(this, "isValidPair", (s, n) => {
      var i;
      if (!ku(s)) {
        const { message: a } = xe("MISSING_OR_INVALID", `pair() params: ${s}`);
        throw n.setError(Fs.malformed_pairing_uri), new Error(a);
      }
      if (!PS(s.uri)) {
        const { message: a } = xe("MISSING_OR_INVALID", `pair() uri: ${s.uri}`);
        throw n.setError(Fs.malformed_pairing_uri), new Error(a);
      }
      const o = xm(s == null ? void 0 : s.uri);
      if (!((i = o == null ? void 0 : o.relay) != null && i.protocol)) {
        const { message: a } = xe("MISSING_OR_INVALID", "pair() uri#relay-protocol");
        throw n.setError(Fs.malformed_pairing_uri), new Error(a);
      }
      if (!(o != null && o.symKey)) {
        const { message: a } = xe("MISSING_OR_INVALID", "pair() uri#symKey");
        throw n.setError(Fs.malformed_pairing_uri), new Error(a);
      }
      if (o != null && o.expiryTimestamp && V.toMiliseconds(o == null ? void 0 : o.expiryTimestamp) < Date.now()) {
        n.setError(Fs.pairing_expired);
        const { message: a } = xe("EXPIRED", "pair() URI has expired. Please try again with a new connection URI.");
        throw new Error(a);
      }
    }), he(this, "isValidPing", async (s) => {
      if (!ku(s)) {
        const { message: i } = xe("MISSING_OR_INVALID", `ping() params: ${s}`);
        throw new Error(i);
      }
      const { topic: n } = s;
      await this.isValidPairingTopic(n);
    }), he(this, "isValidDisconnect", async (s) => {
      if (!ku(s)) {
        const { message: i } = xe("MISSING_OR_INVALID", `disconnect() params: ${s}`);
        throw new Error(i);
      }
      const { topic: n } = s;
      await this.isValidPairingTopic(n);
    }), he(this, "isValidPairingTopic", async (s) => {
      if (!qg(s)) {
        const { message: n } = xe("MISSING_OR_INVALID", `pairing topic should be a string: ${s}`);
        throw new Error(n);
      }
      if (!this.pairings.keys.includes(s)) {
        const { message: n } = xe("NO_MATCHING_KEY", `pairing topic doesn't exist: ${s}`);
        throw new Error(n);
      }
      if (Zf(this.pairings.get(s).expiry)) {
        await this.deletePairing(s);
        const { message: n } = xe("EXPIRED", `pairing topic: ${s}`);
        throw new Error(n);
      }
    }), this.core = e, this.logger = ve(r, this.name), this.pairings = new S_(this.core, this.logger, this.name, this.storagePrefix);
  }
  get context() {
    return De(this.logger);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = xe("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  registerRelayerEvents() {
    this.core.relayer.on(At.message, async (e) => {
      const { topic: r, message: s, transportType: n } = e;
      if (this.pairings.keys.includes(r) && n !== ci.link_mode && !this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(s))) try {
        const i = await this.core.crypto.decode(r, s);
        wa(i) ? (this.core.history.set(r, i), await this.onRelayEventRequest({ topic: r, payload: i })) : ki(i) && (await this.core.history.resolve(i), await this.onRelayEventResponse({ topic: r, payload: i }), this.core.history.delete(r, i.id)), await this.core.relayer.messages.ack(r, s);
      } catch (i) {
        this.logger.error(i);
      }
    });
  }
  registerExpirerEvents() {
    this.core.expirer.on(_r.expired, async (e) => {
      const { topic: r } = y5(e.target);
      r && this.pairings.keys.includes(r) && (await this.deletePairing(r, !0), this.events.emit(Vi.expire, { topic: r }));
    });
  }
};
var T_ = Object.defineProperty, U_ = (t, e, r) => e in t ? T_(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, at = (t, e, r) => U_(t, typeof e != "symbol" ? e + "" : e, r);
let $_ = class extends Hv {
  constructor(e, r) {
    super(e, r), this.core = e, this.logger = r, at(this, "records", /* @__PURE__ */ new Map()), at(this, "events", new dt.EventEmitter()), at(this, "name", B9), at(this, "version", D9), at(this, "cached", []), at(this, "initialized", !1), at(this, "storagePrefix", Qr), at(this, "init", async () => {
      this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((s) => this.records.set(s.id, s)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
    }), at(this, "set", (s, n, i) => {
      if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({ type: "method", method: "set", topic: s, request: n, chainId: i }), this.records.has(n.id)) return;
      const o = { id: n.id, topic: s, request: { method: n.method, params: n.params || null }, chainId: i, expiry: $o(V.THIRTY_DAYS) };
      this.records.set(o.id, o), this.persist(), this.events.emit(vr.created, o);
    }), at(this, "resolve", async (s) => {
      if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({ type: "method", method: "update", response: s }), !this.records.has(s.id)) return;
      const n = await this.getRecord(s.id);
      typeof n.response > "u" && (n.response = jt(s) ? { error: s.error } : { result: s.result }, this.records.set(n.id, n), this.persist(), this.events.emit(vr.updated, n));
    }), at(this, "get", async (s, n) => (this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({ type: "method", method: "get", topic: s, id: n }), await this.getRecord(n))), at(this, "delete", (s, n) => {
      this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({ type: "method", method: "delete", id: n }), this.values.forEach((i) => {
        if (i.topic === s) {
          if (typeof n < "u" && i.id !== n) return;
          this.records.delete(i.id), this.events.emit(vr.deleted, i);
        }
      }), this.persist();
    }), at(this, "exists", async (s, n) => (this.isInitialized(), this.records.has(n) ? (await this.getRecord(n)).topic === s : !1)), at(this, "on", (s, n) => {
      this.events.on(s, n);
    }), at(this, "once", (s, n) => {
      this.events.once(s, n);
    }), at(this, "off", (s, n) => {
      this.events.off(s, n);
    }), at(this, "removeListener", (s, n) => {
      this.events.removeListener(s, n);
    }), this.logger = ve(r, this.name);
  }
  get context() {
    return De(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get size() {
    return this.records.size;
  }
  get keys() {
    return Array.from(this.records.keys());
  }
  get values() {
    return Array.from(this.records.values());
  }
  get pending() {
    const e = [];
    return this.values.forEach((r) => {
      if (typeof r.response < "u") return;
      const s = { topic: r.topic, request: Es(r.request.method, r.request.params, r.id), chainId: r.chainId };
      return e.push(s);
    }), e;
  }
  async setJsonRpcRecords(e) {
    await this.core.storage.setItem(this.storageKey, e);
  }
  async getJsonRpcRecords() {
    return await this.core.storage.getItem(this.storageKey);
  }
  getRecord(e) {
    this.isInitialized();
    const r = this.records.get(e);
    if (!r) {
      const { message: s } = xe("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw new Error(s);
    }
    return r;
  }
  async persist() {
    await this.setJsonRpcRecords(this.values), this.events.emit(vr.sync);
  }
  async restore() {
    try {
      const e = await this.getJsonRpcRecords();
      if (typeof e > "u" || !e.length) return;
      if (this.records.size) {
        const { message: r } = xe("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({ type: "method", method: "restore", records: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
    }
  }
  registerEventListeners() {
    this.events.on(vr.created, (e) => {
      const r = vr.created;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, record: e });
    }), this.events.on(vr.updated, (e) => {
      const r = vr.updated;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, record: e });
    }), this.events.on(vr.deleted, (e) => {
      const r = vr.deleted;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, record: e });
    }), this.core.heartbeat.on(ir.pulse, () => {
      this.cleanup();
    });
  }
  cleanup() {
    try {
      this.isInitialized();
      let e = !1;
      this.records.forEach((r) => {
        V.toMiliseconds(r.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${r.id}`), this.records.delete(r.id), this.events.emit(vr.deleted, r, !1), e = !0);
      }), e && this.persist();
    } catch (e) {
      this.logger.warn(e);
    }
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = xe("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
};
var B_ = Object.defineProperty, D_ = (t, e, r) => e in t ? B_(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, vt = (t, e, r) => D_(t, typeof e != "symbol" ? e + "" : e, r);
let O_ = class extends Zv {
  constructor(e, r) {
    super(e, r), this.core = e, this.logger = r, vt(this, "expirations", /* @__PURE__ */ new Map()), vt(this, "events", new dt.EventEmitter()), vt(this, "name", O9), vt(this, "version", P9), vt(this, "cached", []), vt(this, "initialized", !1), vt(this, "storagePrefix", Qr), vt(this, "init", async () => {
      this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((s) => this.expirations.set(s.target, s)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
    }), vt(this, "has", (s) => {
      try {
        const n = this.formatTarget(s);
        return typeof this.getExpiration(n) < "u";
      } catch {
        return !1;
      }
    }), vt(this, "set", (s, n) => {
      this.isInitialized();
      const i = this.formatTarget(s), o = { target: i, expiry: n };
      this.expirations.set(i, o), this.checkExpiry(i, o), this.events.emit(_r.created, { target: i, expiration: o });
    }), vt(this, "get", (s) => {
      this.isInitialized();
      const n = this.formatTarget(s);
      return this.getExpiration(n);
    }), vt(this, "del", (s) => {
      if (this.isInitialized(), this.has(s)) {
        const n = this.formatTarget(s), i = this.getExpiration(n);
        this.expirations.delete(n), this.events.emit(_r.deleted, { target: n, expiration: i });
      }
    }), vt(this, "on", (s, n) => {
      this.events.on(s, n);
    }), vt(this, "once", (s, n) => {
      this.events.once(s, n);
    }), vt(this, "off", (s, n) => {
      this.events.off(s, n);
    }), vt(this, "removeListener", (s, n) => {
      this.events.removeListener(s, n);
    }), this.logger = ve(r, this.name);
  }
  get context() {
    return De(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get length() {
    return this.expirations.size;
  }
  get keys() {
    return Array.from(this.expirations.keys());
  }
  get values() {
    return Array.from(this.expirations.values());
  }
  formatTarget(e) {
    if (typeof e == "string") return m5(e);
    if (typeof e == "number") return b5(e);
    const { message: r } = xe("UNKNOWN_TYPE", `Target type: ${typeof e}`);
    throw new Error(r);
  }
  async setExpirations(e) {
    await this.core.storage.setItem(this.storageKey, e);
  }
  async getExpirations() {
    return await this.core.storage.getItem(this.storageKey);
  }
  async persist() {
    await this.setExpirations(this.values), this.events.emit(_r.sync);
  }
  async restore() {
    try {
      const e = await this.getExpirations();
      if (typeof e > "u" || !e.length) return;
      if (this.expirations.size) {
        const { message: r } = xe("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({ type: "method", method: "restore", expirations: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
    }
  }
  getExpiration(e) {
    const r = this.expirations.get(e);
    if (!r) {
      const { message: s } = xe("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw this.logger.warn(s), new Error(s);
    }
    return r;
  }
  checkExpiry(e, r) {
    const { expiry: s } = r;
    V.toMiliseconds(s) - Date.now() <= 0 && this.expire(e, r);
  }
  expire(e, r) {
    this.expirations.delete(e), this.events.emit(_r.expired, { target: e, expiration: r });
  }
  checkExpirations() {
    this.core.relayer.connected && this.expirations.forEach((e, r) => this.checkExpiry(r, e));
  }
  registerEventListeners() {
    this.core.heartbeat.on(ir.pulse, () => this.checkExpirations()), this.events.on(_r.created, (e) => {
      const r = _r.created;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), this.persist();
    }), this.events.on(_r.expired, (e) => {
      const r = _r.expired;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), this.persist();
    }), this.events.on(_r.deleted, (e) => {
      const r = _r.deleted;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), this.persist();
    });
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = xe("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
};
var P_ = Object.defineProperty, R_ = (t, e, r) => e in t ? P_(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, qe = (t, e, r) => R_(t, typeof e != "symbol" ? e + "" : e, r);
let N_ = class extends Jv {
  constructor(e, r, s) {
    super(e, r, s), this.core = e, this.logger = r, this.store = s, qe(this, "name", R9), qe(this, "abortController"), qe(this, "isDevEnv"), qe(this, "verifyUrlV3", L9), qe(this, "storagePrefix", Qr), qe(this, "version", Yg), qe(this, "publicKey"), qe(this, "fetchPromise"), qe(this, "init", async () => {
      var n;
      this.isDevEnv || (this.publicKey = await this.store.getItem(this.storeKey), this.publicKey && V.toMiliseconds((n = this.publicKey) == null ? void 0 : n.expiresAt) < Date.now() && (this.logger.debug("verify v2 public key expired"), await this.removePublicKey()));
    }), qe(this, "register", async (n) => {
      if (!ma() || this.isDevEnv) return;
      const i = window.location.origin, { id: o, decryptedId: a } = n, c = `${this.verifyUrlV3}/attestation?projectId=${this.core.projectId}&origin=${i}&id=${o}&decryptedId=${a}`;
      try {
        const l = fr(), u = this.startAbortTimer(V.ONE_SECOND * 5), h = await new Promise((p, y) => {
          const b = () => {
            window.removeEventListener("message", x), l.body.removeChild(g), y("attestation aborted");
          };
          this.abortController.signal.addEventListener("abort", b);
          const g = l.createElement("iframe");
          g.src = c, g.style.display = "none", g.addEventListener("error", b, { signal: this.abortController.signal });
          const x = (I) => {
            if (I.data && typeof I.data == "string") try {
              const U = JSON.parse(I.data);
              if (U.type === "verify_attestation") {
                if (ni(U.attestation).payload.id !== o) return;
                clearInterval(u), l.body.removeChild(g), this.abortController.signal.removeEventListener("abort", b), window.removeEventListener("message", x), p(U.attestation === null ? "" : U.attestation);
              }
            } catch (U) {
              this.logger.warn(U);
            }
          };
          l.body.appendChild(g), window.addEventListener("message", x, { signal: this.abortController.signal });
        });
        return this.logger.debug("jwt attestation", h), h;
      } catch (l) {
        this.logger.warn(l);
      }
      return "";
    }), qe(this, "resolve", async (n) => {
      if (this.isDevEnv) return "";
      const { attestationId: i, hash: o, encryptedId: a } = n;
      if (i === "") {
        this.logger.debug("resolve: attestationId is empty, skipping");
        return;
      }
      if (i) {
        if (ni(i).payload.id !== a) return;
        const l = await this.isValidJwtAttestation(i);
        if (l) {
          if (!l.isVerified) {
            this.logger.warn("resolve: jwt attestation: origin url not verified");
            return;
          }
          return l;
        }
      }
      if (!o) return;
      const c = this.getVerifyUrl(n == null ? void 0 : n.verifyUrl);
      return this.fetchAttestation(o, c);
    }), qe(this, "fetchAttestation", async (n, i) => {
      this.logger.debug(`resolving attestation: ${n} from url: ${i}`);
      const o = this.startAbortTimer(V.ONE_SECOND * 5), a = await fetch(`${i}/attestation/${n}?v2Supported=true`, { signal: this.abortController.signal });
      return clearTimeout(o), a.status === 200 ? await a.json() : void 0;
    }), qe(this, "getVerifyUrl", (n) => {
      let i = n || Mc;
      return M9.includes(i) || (this.logger.info(`verify url: ${i}, not included in trusted list, assigning default: ${Mc}`), i = Mc), i;
    }), qe(this, "fetchPublicKey", async () => {
      try {
        this.logger.debug(`fetching public key from: ${this.verifyUrlV3}`);
        const n = this.startAbortTimer(V.FIVE_SECONDS), i = await fetch(`${this.verifyUrlV3}/public-key`, { signal: this.abortController.signal });
        return clearTimeout(n), await i.json();
      } catch (n) {
        this.logger.warn(n);
      }
    }), qe(this, "persistPublicKey", async (n) => {
      this.logger.debug("persisting public key to local storage", n), await this.store.setItem(this.storeKey, n), this.publicKey = n;
    }), qe(this, "removePublicKey", async () => {
      this.logger.debug("removing verify v2 public key from storage"), await this.store.removeItem(this.storeKey), this.publicKey = void 0;
    }), qe(this, "isValidJwtAttestation", async (n) => {
      const i = await this.getPublicKey();
      try {
        if (i) return this.validateAttestation(n, i);
      } catch (a) {
        this.logger.error(a, a.message), this.logger.warn("error validating attestation");
      }
      const o = await this.fetchAndPersistPublicKey();
      if (o) return this.validateAttestation(n, o);
    }), qe(this, "getPublicKey", async () => this.publicKey ? this.publicKey : await this.fetchAndPersistPublicKey()), qe(this, "fetchAndPersistPublicKey", async () => {
      if (this.fetchPromise) return await this.fetchPromise, this.publicKey;
      this.fetchPromise = new Promise(async (i) => {
        const o = await this.fetchPublicKey();
        o && (await this.persistPublicKey(o), i(o));
      });
      const n = await this.fetchPromise;
      return this.fetchPromise = void 0, n;
    }), qe(this, "validateAttestation", (n, i) => {
      const o = _S(n, i.publicKey), a = { hasExpired: V.toMiliseconds(o.exp) < Date.now(), payload: o };
      if (a.hasExpired) throw this.logger.warn("resolve: jwt attestation expired"), new Error("JWT attestation expired");
      return { origin: a.payload.origin, isScam: a.payload.isScam, isVerified: a.payload.isVerified };
    }), this.logger = ve(r, this.name), this.abortController = new AbortController(), this.isDevEnv = tg(), this.init();
  }
  get storeKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//verify:public:key";
  }
  get context() {
    return De(this.logger);
  }
  startAbortTimer(e) {
    return this.abortController = new AbortController(), setTimeout(() => this.abortController.abort(), V.toMiliseconds(e));
  }
};
var L_ = Object.defineProperty, M_ = (t, e, r) => e in t ? L_(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Jm = (t, e, r) => M_(t, typeof e != "symbol" ? e + "" : e, r);
let F_ = class extends Xv {
  constructor(e, r) {
    super(e, r), this.projectId = e, this.logger = r, Jm(this, "context", F9), Jm(this, "registerDeviceToken", async (s) => {
      const { clientId: n, token: i, notificationType: o, enableEncrypted: a = !1 } = s, c = `${z9}/${this.projectId}/clients`;
      await fetch(c, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ client_id: n, type: o, token: i, always_raw: a }) });
    }), this.logger = ve(r, this.context);
  }
};
var z_ = Object.defineProperty, Xm = Object.getOwnPropertySymbols, j_ = Object.prototype.hasOwnProperty, H_ = Object.prototype.propertyIsEnumerable, Wh = (t, e, r) => e in t ? z_(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Wi = (t, e) => {
  for (var r in e || (e = {})) j_.call(e, r) && Wh(t, r, e[r]);
  if (Xm) for (var r of Xm(e)) H_.call(e, r) && Wh(t, r, e[r]);
  return t;
}, Xe = (t, e, r) => Wh(t, typeof e != "symbol" ? e + "" : e, r);
let q_ = class extends Yv {
  constructor(e, r, s = !0) {
    super(e, r, s), this.core = e, this.logger = r, Xe(this, "context", H9), Xe(this, "storagePrefix", Qr), Xe(this, "storageVersion", j9), Xe(this, "events", /* @__PURE__ */ new Map()), Xe(this, "shouldPersist", !1), Xe(this, "init", async () => {
      if (!tg()) try {
        const n = { eventId: Jf(), timestamp: Date.now(), domain: this.getAppDomain(), props: { event: "INIT", type: "", properties: { client_id: await this.core.crypto.getClientId(), user_agent: Qy(this.core.relayer.protocol, this.core.relayer.version, Fh) } } };
        await this.sendEvent([n]);
      } catch (n) {
        this.logger.warn(n);
      }
    }), Xe(this, "createEvent", (n) => {
      const { event: i = "ERROR", type: o = "", properties: { topic: a, trace: c } } = n, l = Jf(), u = this.core.projectId || "", h = Date.now(), p = Wi({ eventId: l, timestamp: h, props: { event: i, type: o, properties: { topic: a, trace: c } }, bundleId: u, domain: this.getAppDomain() }, this.setMethods(l));
      return this.telemetryEnabled && (this.events.set(l, p), this.shouldPersist = !0), p;
    }), Xe(this, "getEvent", (n) => {
      const { eventId: i, topic: o } = n;
      if (i) return this.events.get(i);
      const a = Array.from(this.events.values()).find((c) => c.props.properties.topic === o);
      if (a) return Wi(Wi({}, a), this.setMethods(a.eventId));
    }), Xe(this, "deleteEvent", (n) => {
      const { eventId: i } = n;
      this.events.delete(i), this.shouldPersist = !0;
    }), Xe(this, "setEventListeners", () => {
      this.core.heartbeat.on(ir.pulse, async () => {
        this.shouldPersist && await this.persist(), this.events.forEach((n) => {
          V.fromMiliseconds(Date.now()) - V.fromMiliseconds(n.timestamp) > q9 && (this.events.delete(n.eventId), this.shouldPersist = !0);
        });
      });
    }), Xe(this, "setMethods", (n) => ({ addTrace: (i) => this.addTrace(n, i), setError: (i) => this.setError(n, i) })), Xe(this, "addTrace", (n, i) => {
      const o = this.events.get(n);
      o && (o.props.properties.trace.push(i), this.events.set(n, o), this.shouldPersist = !0);
    }), Xe(this, "setError", (n, i) => {
      const o = this.events.get(n);
      o && (o.props.type = i, o.timestamp = Date.now(), this.events.set(n, o), this.shouldPersist = !0);
    }), Xe(this, "persist", async () => {
      await this.core.storage.setItem(this.storageKey, Array.from(this.events.values())), this.shouldPersist = !1;
    }), Xe(this, "restore", async () => {
      try {
        const n = await this.core.storage.getItem(this.storageKey) || [];
        if (!n.length) return;
        n.forEach((i) => {
          this.events.set(i.eventId, Wi(Wi({}, i), this.setMethods(i.eventId)));
        });
      } catch (n) {
        this.logger.warn(n);
      }
    }), Xe(this, "submit", async () => {
      if (!this.telemetryEnabled || this.events.size === 0) return;
      const n = [];
      for (const [i, o] of this.events) o.props.type && n.push(o);
      if (n.length !== 0) try {
        if ((await this.sendEvent(n)).ok) for (const i of n) this.events.delete(i.eventId), this.shouldPersist = !0;
      } catch (i) {
        this.logger.warn(i);
      }
    }), Xe(this, "sendEvent", async (n) => {
      const i = this.getAppDomain() ? "" : "&sp=desktop";
      return await fetch(`${K9}?projectId=${this.core.projectId}&st=events_sdk&sv=js-${Fh}${i}`, { method: "POST", body: JSON.stringify(n) });
    }), Xe(this, "getAppDomain", () => u5().url), this.logger = ve(r, this.context), this.telemetryEnabled = s, s ? this.restore().then(async () => {
      await this.submit(), this.setEventListeners();
    }) : this.persist();
  }
  get storageKey() {
    return this.storagePrefix + this.storageVersion + this.core.customStoragePrefix + "//" + this.context;
  }
};
var K_ = Object.defineProperty, Ym = Object.getOwnPropertySymbols, V_ = Object.prototype.hasOwnProperty, G_ = Object.prototype.propertyIsEnumerable, Zh = (t, e, r) => e in t ? K_(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Qm = (t, e) => {
  for (var r in e || (e = {})) V_.call(e, r) && Zh(t, r, e[r]);
  if (Ym) for (var r of Ym(e)) G_.call(e, r) && Zh(t, r, e[r]);
  return t;
}, Ue = (t, e, r) => Zh(t, typeof e != "symbol" ? e + "" : e, r);
let W_ = class dw extends Mv {
  constructor(e) {
    var r;
    super(e), Ue(this, "protocol", Xg), Ue(this, "version", Yg), Ue(this, "name", Mh), Ue(this, "relayUrl"), Ue(this, "projectId"), Ue(this, "customStoragePrefix"), Ue(this, "events", new dt.EventEmitter()), Ue(this, "logger"), Ue(this, "heartbeat"), Ue(this, "relayer"), Ue(this, "crypto"), Ue(this, "storage"), Ue(this, "history"), Ue(this, "expirer"), Ue(this, "pairing"), Ue(this, "verify"), Ue(this, "echoClient"), Ue(this, "linkModeSupportedApps"), Ue(this, "eventClient"), Ue(this, "initialized", !1), Ue(this, "logChunkController"), Ue(this, "on", (a, c) => this.events.on(a, c)), Ue(this, "once", (a, c) => this.events.once(a, c)), Ue(this, "off", (a, c) => this.events.off(a, c)), Ue(this, "removeListener", (a, c) => this.events.removeListener(a, c)), Ue(this, "dispatchEnvelope", ({ topic: a, message: c, sessionExists: l }) => {
      if (!a || !c) return;
      const u = { topic: a, message: c, publishedAt: Date.now(), transportType: ci.link_mode };
      this.relayer.onLinkMessageEvent(u, { sessionExists: l });
    });
    const s = this.getGlobalCore(e == null ? void 0 : e.customStoragePrefix);
    if (s) try {
      return this.customStoragePrefix = s.customStoragePrefix, this.logger = s.logger, this.heartbeat = s.heartbeat, this.crypto = s.crypto, this.history = s.history, this.expirer = s.expirer, this.storage = s.storage, this.relayer = s.relayer, this.pairing = s.pairing, this.verify = s.verify, this.echoClient = s.echoClient, this.linkModeSupportedApps = s.linkModeSupportedApps, this.eventClient = s.eventClient, this.initialized = s.initialized, this.logChunkController = s.logChunkController, s;
    } catch (a) {
      console.warn("Failed to copy global core", a);
    }
    this.projectId = e == null ? void 0 : e.projectId, this.relayUrl = (e == null ? void 0 : e.relayUrl) || Qg, this.customStoragePrefix = e != null && e.customStoragePrefix ? `:${e.customStoragePrefix}` : "";
    const n = ua({ level: typeof (e == null ? void 0 : e.logger) == "string" && e.logger ? e.logger : d9.logger, name: Mh }), { logger: i, chunkLoggerController: o } = D0({ opts: n, maxSizeInBytes: e == null ? void 0 : e.maxLogBlobSizeInBytes, loggerOverride: e == null ? void 0 : e.logger });
    this.logChunkController = o, (r = this.logChunkController) != null && r.downloadLogsBlobInBrowser && (window.downloadLogsBlobInBrowser = async () => {
      var a, c;
      (a = this.logChunkController) != null && a.downloadLogsBlobInBrowser && ((c = this.logChunkController) == null || c.downloadLogsBlobInBrowser({ clientId: await this.crypto.getClientId() }));
    }), this.logger = ve(i, this.name), this.heartbeat = new I0(), this.crypto = new EA(this, this.logger, e == null ? void 0 : e.keychain), this.history = new $_(this, this.logger), this.expirer = new O_(this, this.logger), this.storage = e != null && e.storage ? e.storage : new T0(Qm(Qm({}, p9), e == null ? void 0 : e.storageOptions)), this.relayer = new GA({ core: this, logger: this.logger, relayUrl: this.relayUrl, projectId: this.projectId }), this.pairing = new __(this, this.logger), this.verify = new N_(this, this.logger, this.storage), this.echoClient = new F_(this.projectId || "", this.logger), this.linkModeSupportedApps = [], this.eventClient = new q_(this, this.logger, e == null ? void 0 : e.telemetryEnabled), this.setGlobalCore(this);
  }
  static async init(e) {
    const r = new dw(e);
    await r.initialize();
    const s = await r.crypto.getClientId();
    return await r.storage.setItem(A9, s), r;
  }
  get context() {
    return De(this.logger);
  }
  async start() {
    this.initialized || await this.initialize();
  }
  async getLogsBlob() {
    var e;
    return (e = this.logChunkController) == null ? void 0 : e.logsToBlob({ clientId: await this.crypto.getClientId() });
  }
  async addLinkModeSupportedApp(e) {
    this.linkModeSupportedApps.includes(e) || (this.linkModeSupportedApps.push(e), await this.storage.setItem(Bm, this.linkModeSupportedApps));
  }
  async initialize() {
    this.logger.trace("Initialized");
    try {
      await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.linkModeSupportedApps = await this.storage.getItem(Bm) || [], this.initialized = !0, this.logger.info("Core Initialization Success");
    } catch (e) {
      throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
    }
  }
  getGlobalCore(e = "") {
    try {
      if (this.isGlobalCoreDisabled()) return;
      const r = `_walletConnectCore_${e}`, s = `${r}_count`;
      return globalThis[s] = (globalThis[s] || 0) + 1, globalThis[s] > 1 && console.warn(`WalletConnect Core is already initialized. This is probably a mistake and can lead to unexpected behavior. Init() was called ${globalThis[s]} times.`), globalThis[r];
    } catch (r) {
      console.warn("Failed to get global WalletConnect core", r);
      return;
    }
  }
  setGlobalCore(e) {
    var r;
    try {
      if (this.isGlobalCoreDisabled()) return;
      const s = `_walletConnectCore_${((r = e.opts) == null ? void 0 : r.customStoragePrefix) || ""}`;
      globalThis[s] = e;
    } catch (s) {
      console.warn("Failed to set global WalletConnect core", s);
    }
  }
  isGlobalCoreDisabled() {
    try {
      return typeof process < "u" && process.env.DISABLE_GLOBAL_CORE === "true";
    } catch {
      return !0;
    }
  }
};
const Z_ = W_;
var pw = {}, Dl = {};
Dl.byteLength = Y_;
Dl.toByteArray = eT;
Dl.fromByteArray = sT;
var Zr = [], hr = [], J_ = typeof Uint8Array < "u" ? Uint8Array : Array, _u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Gn = 0, X_ = _u.length; Gn < X_; ++Gn)
  Zr[Gn] = _u[Gn], hr[_u.charCodeAt(Gn)] = Gn;
hr[45] = 62;
hr[95] = 63;
function fw(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  r === -1 && (r = e);
  var s = r === e ? 0 : 4 - r % 4;
  return [r, s];
}
function Y_(t) {
  var e = fw(t), r = e[0], s = e[1];
  return (r + s) * 3 / 4 - s;
}
function Q_(t, e, r) {
  return (e + r) * 3 / 4 - r;
}
function eT(t) {
  var e, r = fw(t), s = r[0], n = r[1], i = new J_(Q_(t, s, n)), o = 0, a = n > 0 ? s - 4 : s, c;
  for (c = 0; c < a; c += 4)
    e = hr[t.charCodeAt(c)] << 18 | hr[t.charCodeAt(c + 1)] << 12 | hr[t.charCodeAt(c + 2)] << 6 | hr[t.charCodeAt(c + 3)], i[o++] = e >> 16 & 255, i[o++] = e >> 8 & 255, i[o++] = e & 255;
  return n === 2 && (e = hr[t.charCodeAt(c)] << 2 | hr[t.charCodeAt(c + 1)] >> 4, i[o++] = e & 255), n === 1 && (e = hr[t.charCodeAt(c)] << 10 | hr[t.charCodeAt(c + 1)] << 4 | hr[t.charCodeAt(c + 2)] >> 2, i[o++] = e >> 8 & 255, i[o++] = e & 255), i;
}
function tT(t) {
  return Zr[t >> 18 & 63] + Zr[t >> 12 & 63] + Zr[t >> 6 & 63] + Zr[t & 63];
}
function rT(t, e, r) {
  for (var s, n = [], i = e; i < r; i += 3)
    s = (t[i] << 16 & 16711680) + (t[i + 1] << 8 & 65280) + (t[i + 2] & 255), n.push(tT(s));
  return n.join("");
}
function sT(t) {
  for (var e, r = t.length, s = r % 3, n = [], i = 16383, o = 0, a = r - s; o < a; o += i)
    n.push(rT(t, o, o + i > a ? a : o + i));
  return s === 1 ? (e = t[r - 1], n.push(
    Zr[e >> 2] + Zr[e << 4 & 63] + "=="
  )) : s === 2 && (e = (t[r - 2] << 8) + t[r - 1], n.push(
    Zr[e >> 10] + Zr[e >> 4 & 63] + Zr[e << 2 & 63] + "="
  )), n.join("");
}
var yp = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
yp.read = function(t, e, r, s, n) {
  var i, o, a = n * 8 - s - 1, c = (1 << a) - 1, l = c >> 1, u = -7, h = r ? n - 1 : 0, p = r ? -1 : 1, y = t[e + h];
  for (h += p, i = y & (1 << -u) - 1, y >>= -u, u += a; u > 0; i = i * 256 + t[e + h], h += p, u -= 8)
    ;
  for (o = i & (1 << -u) - 1, i >>= -u, u += s; u > 0; o = o * 256 + t[e + h], h += p, u -= 8)
    ;
  if (i === 0)
    i = 1 - l;
  else {
    if (i === c)
      return o ? NaN : (y ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, s), i = i - l;
  }
  return (y ? -1 : 1) * o * Math.pow(2, i - s);
};
yp.write = function(t, e, r, s, n, i) {
  var o, a, c, l = i * 8 - n - 1, u = (1 << l) - 1, h = u >> 1, p = n === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, y = s ? 0 : i - 1, b = s ? 1 : -1, g = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, o = u) : (o = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -o)) < 1 && (o--, c *= 2), o + h >= 1 ? e += p / c : e += p * Math.pow(2, 1 - h), e * c >= 2 && (o++, c /= 2), o + h >= u ? (a = 0, o = u) : o + h >= 1 ? (a = (e * c - 1) * Math.pow(2, n), o = o + h) : (a = e * Math.pow(2, h - 1) * Math.pow(2, n), o = 0)); n >= 8; t[r + y] = a & 255, y += b, a /= 256, n -= 8)
    ;
  for (o = o << n | a, l += n; l > 0; t[r + y] = o & 255, y += b, o /= 256, l -= 8)
    ;
  t[r + y - b] |= g * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(t) {
  const e = Dl, r = yp, s = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  t.Buffer = a, t.SlowBuffer = U, t.INSPECT_MAX_BYTES = 50;
  const n = 2147483647;
  t.kMaxLength = n, a.TYPED_ARRAY_SUPPORT = i(), !a.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function i() {
    try {
      const E = new Uint8Array(1), f = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(f, Uint8Array.prototype), Object.setPrototypeOf(E, f), E.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(a.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (a.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(a.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (a.isBuffer(this))
        return this.byteOffset;
    }
  });
  function o(E) {
    if (E > n)
      throw new RangeError('The value "' + E + '" is invalid for option "size"');
    const f = new Uint8Array(E);
    return Object.setPrototypeOf(f, a.prototype), f;
  }
  function a(E, f, m) {
    if (typeof E == "number") {
      if (typeof f == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return h(E);
    }
    return c(E, f, m);
  }
  a.poolSize = 8192;
  function c(E, f, m) {
    if (typeof E == "string")
      return p(E, f);
    if (ArrayBuffer.isView(E))
      return b(E);
    if (E == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof E
      );
    if (Wt(E, ArrayBuffer) || E && Wt(E.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Wt(E, SharedArrayBuffer) || E && Wt(E.buffer, SharedArrayBuffer)))
      return g(E, f, m);
    if (typeof E == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const v = E.valueOf && E.valueOf();
    if (v != null && v !== E)
      return a.from(v, f, m);
    const R = x(E);
    if (R) return R;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof E[Symbol.toPrimitive] == "function")
      return a.from(E[Symbol.toPrimitive]("string"), f, m);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof E
    );
  }
  a.from = function(E, f, m) {
    return c(E, f, m);
  }, Object.setPrototypeOf(a.prototype, Uint8Array.prototype), Object.setPrototypeOf(a, Uint8Array);
  function l(E) {
    if (typeof E != "number")
      throw new TypeError('"size" argument must be of type number');
    if (E < 0)
      throw new RangeError('The value "' + E + '" is invalid for option "size"');
  }
  function u(E, f, m) {
    return l(E), E <= 0 ? o(E) : f !== void 0 ? typeof m == "string" ? o(E).fill(f, m) : o(E).fill(f) : o(E);
  }
  a.alloc = function(E, f, m) {
    return u(E, f, m);
  };
  function h(E) {
    return l(E), o(E < 0 ? 0 : I(E) | 0);
  }
  a.allocUnsafe = function(E) {
    return h(E);
  }, a.allocUnsafeSlow = function(E) {
    return h(E);
  };
  function p(E, f) {
    if ((typeof f != "string" || f === "") && (f = "utf8"), !a.isEncoding(f))
      throw new TypeError("Unknown encoding: " + f);
    const m = A(E, f) | 0;
    let v = o(m);
    const R = v.write(E, f);
    return R !== m && (v = v.slice(0, R)), v;
  }
  function y(E) {
    const f = E.length < 0 ? 0 : I(E.length) | 0, m = o(f);
    for (let v = 0; v < f; v += 1)
      m[v] = E[v] & 255;
    return m;
  }
  function b(E) {
    if (Wt(E, Uint8Array)) {
      const f = new Uint8Array(E);
      return g(f.buffer, f.byteOffset, f.byteLength);
    }
    return y(E);
  }
  function g(E, f, m) {
    if (f < 0 || E.byteLength < f)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (E.byteLength < f + (m || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let v;
    return f === void 0 && m === void 0 ? v = new Uint8Array(E) : m === void 0 ? v = new Uint8Array(E, f) : v = new Uint8Array(E, f, m), Object.setPrototypeOf(v, a.prototype), v;
  }
  function x(E) {
    if (a.isBuffer(E)) {
      const f = I(E.length) | 0, m = o(f);
      return m.length === 0 || E.copy(m, 0, 0, f), m;
    }
    if (E.length !== void 0)
      return typeof E.length != "number" || Ln(E.length) ? o(0) : y(E);
    if (E.type === "Buffer" && Array.isArray(E.data))
      return y(E.data);
  }
  function I(E) {
    if (E >= n)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + n.toString(16) + " bytes");
    return E | 0;
  }
  function U(E) {
    return +E != E && (E = 0), a.alloc(+E);
  }
  a.isBuffer = function(f) {
    return f != null && f._isBuffer === !0 && f !== a.prototype;
  }, a.compare = function(f, m) {
    if (Wt(f, Uint8Array) && (f = a.from(f, f.offset, f.byteLength)), Wt(m, Uint8Array) && (m = a.from(m, m.offset, m.byteLength)), !a.isBuffer(f) || !a.isBuffer(m))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (f === m) return 0;
    let v = f.length, R = m.length;
    for (let j = 0, G = Math.min(v, R); j < G; ++j)
      if (f[j] !== m[j]) {
        v = f[j], R = m[j];
        break;
      }
    return v < R ? -1 : R < v ? 1 : 0;
  }, a.isEncoding = function(f) {
    switch (String(f).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, a.concat = function(f, m) {
    if (!Array.isArray(f))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (f.length === 0)
      return a.alloc(0);
    let v;
    if (m === void 0)
      for (m = 0, v = 0; v < f.length; ++v)
        m += f[v].length;
    const R = a.allocUnsafe(m);
    let j = 0;
    for (v = 0; v < f.length; ++v) {
      let G = f[v];
      if (Wt(G, Uint8Array))
        j + G.length > R.length ? (a.isBuffer(G) || (G = a.from(G)), G.copy(R, j)) : Uint8Array.prototype.set.call(
          R,
          G,
          j
        );
      else if (a.isBuffer(G))
        G.copy(R, j);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      j += G.length;
    }
    return R;
  };
  function A(E, f) {
    if (a.isBuffer(E))
      return E.length;
    if (ArrayBuffer.isView(E) || Wt(E, ArrayBuffer))
      return E.byteLength;
    if (typeof E != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof E
      );
    const m = E.length, v = arguments.length > 2 && arguments[2] === !0;
    if (!v && m === 0) return 0;
    let R = !1;
    for (; ; )
      switch (f) {
        case "ascii":
        case "latin1":
        case "binary":
          return m;
        case "utf8":
        case "utf-8":
          return Bi(E).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return m * 2;
        case "hex":
          return m >>> 1;
        case "base64":
          return Di(E).length;
        default:
          if (R)
            return v ? -1 : Bi(E).length;
          f = ("" + f).toLowerCase(), R = !0;
      }
  }
  a.byteLength = A;
  function M(E, f, m) {
    let v = !1;
    if ((f === void 0 || f < 0) && (f = 0), f > this.length || ((m === void 0 || m > this.length) && (m = this.length), m <= 0) || (m >>>= 0, f >>>= 0, m <= f))
      return "";
    for (E || (E = "utf8"); ; )
      switch (E) {
        case "hex":
          return D(this, f, m);
        case "utf8":
        case "utf-8":
          return N(this, f, m);
        case "ascii":
          return $(this, f, m);
        case "latin1":
        case "binary":
          return P(this, f, m);
        case "base64":
          return O(this, f, m);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return z(this, f, m);
        default:
          if (v) throw new TypeError("Unknown encoding: " + E);
          E = (E + "").toLowerCase(), v = !0;
      }
  }
  a.prototype._isBuffer = !0;
  function B(E, f, m) {
    const v = E[f];
    E[f] = E[m], E[m] = v;
  }
  a.prototype.swap16 = function() {
    const f = this.length;
    if (f % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let m = 0; m < f; m += 2)
      B(this, m, m + 1);
    return this;
  }, a.prototype.swap32 = function() {
    const f = this.length;
    if (f % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let m = 0; m < f; m += 4)
      B(this, m, m + 3), B(this, m + 1, m + 2);
    return this;
  }, a.prototype.swap64 = function() {
    const f = this.length;
    if (f % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let m = 0; m < f; m += 8)
      B(this, m, m + 7), B(this, m + 1, m + 6), B(this, m + 2, m + 5), B(this, m + 3, m + 4);
    return this;
  }, a.prototype.toString = function() {
    const f = this.length;
    return f === 0 ? "" : arguments.length === 0 ? N(this, 0, f) : M.apply(this, arguments);
  }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(f) {
    if (!a.isBuffer(f)) throw new TypeError("Argument must be a Buffer");
    return this === f ? !0 : a.compare(this, f) === 0;
  }, a.prototype.inspect = function() {
    let f = "";
    const m = t.INSPECT_MAX_BYTES;
    return f = this.toString("hex", 0, m).replace(/(.{2})/g, "$1 ").trim(), this.length > m && (f += " ... "), "<Buffer " + f + ">";
  }, s && (a.prototype[s] = a.prototype.inspect), a.prototype.compare = function(f, m, v, R, j) {
    if (Wt(f, Uint8Array) && (f = a.from(f, f.offset, f.byteLength)), !a.isBuffer(f))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof f
      );
    if (m === void 0 && (m = 0), v === void 0 && (v = f ? f.length : 0), R === void 0 && (R = 0), j === void 0 && (j = this.length), m < 0 || v > f.length || R < 0 || j > this.length)
      throw new RangeError("out of range index");
    if (R >= j && m >= v)
      return 0;
    if (R >= j)
      return -1;
    if (m >= v)
      return 1;
    if (m >>>= 0, v >>>= 0, R >>>= 0, j >>>= 0, this === f) return 0;
    let G = j - R, ue = v - m;
    const Me = Math.min(G, ue), Ne = this.slice(R, j), Fe = f.slice(m, v);
    for (let Ie = 0; Ie < Me; ++Ie)
      if (Ne[Ie] !== Fe[Ie]) {
        G = Ne[Ie], ue = Fe[Ie];
        break;
      }
    return G < ue ? -1 : ue < G ? 1 : 0;
  };
  function q(E, f, m, v, R) {
    if (E.length === 0) return -1;
    if (typeof m == "string" ? (v = m, m = 0) : m > 2147483647 ? m = 2147483647 : m < -2147483648 && (m = -2147483648), m = +m, Ln(m) && (m = R ? 0 : E.length - 1), m < 0 && (m = E.length + m), m >= E.length) {
      if (R) return -1;
      m = E.length - 1;
    } else if (m < 0)
      if (R) m = 0;
      else return -1;
    if (typeof f == "string" && (f = a.from(f, v)), a.isBuffer(f))
      return f.length === 0 ? -1 : H(E, f, m, v, R);
    if (typeof f == "number")
      return f = f & 255, typeof Uint8Array.prototype.indexOf == "function" ? R ? Uint8Array.prototype.indexOf.call(E, f, m) : Uint8Array.prototype.lastIndexOf.call(E, f, m) : H(E, [f], m, v, R);
    throw new TypeError("val must be string, number or Buffer");
  }
  function H(E, f, m, v, R) {
    let j = 1, G = E.length, ue = f.length;
    if (v !== void 0 && (v = String(v).toLowerCase(), v === "ucs2" || v === "ucs-2" || v === "utf16le" || v === "utf-16le")) {
      if (E.length < 2 || f.length < 2)
        return -1;
      j = 2, G /= 2, ue /= 2, m /= 2;
    }
    function Me(Fe, Ie) {
      return j === 1 ? Fe[Ie] : Fe.readUInt16BE(Ie * j);
    }
    let Ne;
    if (R) {
      let Fe = -1;
      for (Ne = m; Ne < G; Ne++)
        if (Me(E, Ne) === Me(f, Fe === -1 ? 0 : Ne - Fe)) {
          if (Fe === -1 && (Fe = Ne), Ne - Fe + 1 === ue) return Fe * j;
        } else
          Fe !== -1 && (Ne -= Ne - Fe), Fe = -1;
    } else
      for (m + ue > G && (m = G - ue), Ne = m; Ne >= 0; Ne--) {
        let Fe = !0;
        for (let Ie = 0; Ie < ue; Ie++)
          if (Me(E, Ne + Ie) !== Me(f, Ie)) {
            Fe = !1;
            break;
          }
        if (Fe) return Ne;
      }
    return -1;
  }
  a.prototype.includes = function(f, m, v) {
    return this.indexOf(f, m, v) !== -1;
  }, a.prototype.indexOf = function(f, m, v) {
    return q(this, f, m, v, !0);
  }, a.prototype.lastIndexOf = function(f, m, v) {
    return q(this, f, m, v, !1);
  };
  function F(E, f, m, v) {
    m = Number(m) || 0;
    const R = E.length - m;
    v ? (v = Number(v), v > R && (v = R)) : v = R;
    const j = f.length;
    v > j / 2 && (v = j / 2);
    let G;
    for (G = 0; G < v; ++G) {
      const ue = parseInt(f.substr(G * 2, 2), 16);
      if (Ln(ue)) return G;
      E[m + G] = ue;
    }
    return G;
  }
  function w(E, f, m, v) {
    return Is(Bi(f, E.length - m), E, m, v);
  }
  function T(E, f, m, v) {
    return Is(Wl(f), E, m, v);
  }
  function k(E, f, m, v) {
    return Is(Di(f), E, m, v);
  }
  function S(E, f, m, v) {
    return Is(Ta(f, E.length - m), E, m, v);
  }
  a.prototype.write = function(f, m, v, R) {
    if (m === void 0)
      R = "utf8", v = this.length, m = 0;
    else if (v === void 0 && typeof m == "string")
      R = m, v = this.length, m = 0;
    else if (isFinite(m))
      m = m >>> 0, isFinite(v) ? (v = v >>> 0, R === void 0 && (R = "utf8")) : (R = v, v = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const j = this.length - m;
    if ((v === void 0 || v > j) && (v = j), f.length > 0 && (v < 0 || m < 0) || m > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    R || (R = "utf8");
    let G = !1;
    for (; ; )
      switch (R) {
        case "hex":
          return F(this, f, m, v);
        case "utf8":
        case "utf-8":
          return w(this, f, m, v);
        case "ascii":
        case "latin1":
        case "binary":
          return T(this, f, m, v);
        case "base64":
          return k(this, f, m, v);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return S(this, f, m, v);
        default:
          if (G) throw new TypeError("Unknown encoding: " + R);
          R = ("" + R).toLowerCase(), G = !0;
      }
  }, a.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function O(E, f, m) {
    return f === 0 && m === E.length ? e.fromByteArray(E) : e.fromByteArray(E.slice(f, m));
  }
  function N(E, f, m) {
    m = Math.min(E.length, m);
    const v = [];
    let R = f;
    for (; R < m; ) {
      const j = E[R];
      let G = null, ue = j > 239 ? 4 : j > 223 ? 3 : j > 191 ? 2 : 1;
      if (R + ue <= m) {
        let Me, Ne, Fe, Ie;
        switch (ue) {
          case 1:
            j < 128 && (G = j);
            break;
          case 2:
            Me = E[R + 1], (Me & 192) === 128 && (Ie = (j & 31) << 6 | Me & 63, Ie > 127 && (G = Ie));
            break;
          case 3:
            Me = E[R + 1], Ne = E[R + 2], (Me & 192) === 128 && (Ne & 192) === 128 && (Ie = (j & 15) << 12 | (Me & 63) << 6 | Ne & 63, Ie > 2047 && (Ie < 55296 || Ie > 57343) && (G = Ie));
            break;
          case 4:
            Me = E[R + 1], Ne = E[R + 2], Fe = E[R + 3], (Me & 192) === 128 && (Ne & 192) === 128 && (Fe & 192) === 128 && (Ie = (j & 15) << 18 | (Me & 63) << 12 | (Ne & 63) << 6 | Fe & 63, Ie > 65535 && Ie < 1114112 && (G = Ie));
        }
      }
      G === null ? (G = 65533, ue = 1) : G > 65535 && (G -= 65536, v.push(G >>> 10 & 1023 | 55296), G = 56320 | G & 1023), v.push(G), R += ue;
    }
    return C(v);
  }
  const _ = 4096;
  function C(E) {
    const f = E.length;
    if (f <= _)
      return String.fromCharCode.apply(String, E);
    let m = "", v = 0;
    for (; v < f; )
      m += String.fromCharCode.apply(
        String,
        E.slice(v, v += _)
      );
    return m;
  }
  function $(E, f, m) {
    let v = "";
    m = Math.min(E.length, m);
    for (let R = f; R < m; ++R)
      v += String.fromCharCode(E[R] & 127);
    return v;
  }
  function P(E, f, m) {
    let v = "";
    m = Math.min(E.length, m);
    for (let R = f; R < m; ++R)
      v += String.fromCharCode(E[R]);
    return v;
  }
  function D(E, f, m) {
    const v = E.length;
    (!f || f < 0) && (f = 0), (!m || m < 0 || m > v) && (m = v);
    let R = "";
    for (let j = f; j < m; ++j)
      R += Ua[E[j]];
    return R;
  }
  function z(E, f, m) {
    const v = E.slice(f, m);
    let R = "";
    for (let j = 0; j < v.length - 1; j += 2)
      R += String.fromCharCode(v[j] + v[j + 1] * 256);
    return R;
  }
  a.prototype.slice = function(f, m) {
    const v = this.length;
    f = ~~f, m = m === void 0 ? v : ~~m, f < 0 ? (f += v, f < 0 && (f = 0)) : f > v && (f = v), m < 0 ? (m += v, m < 0 && (m = 0)) : m > v && (m = v), m < f && (m = f);
    const R = this.subarray(f, m);
    return Object.setPrototypeOf(R, a.prototype), R;
  };
  function L(E, f, m) {
    if (E % 1 !== 0 || E < 0) throw new RangeError("offset is not uint");
    if (E + f > m) throw new RangeError("Trying to access beyond buffer length");
  }
  a.prototype.readUintLE = a.prototype.readUIntLE = function(f, m, v) {
    f = f >>> 0, m = m >>> 0, v || L(f, m, this.length);
    let R = this[f], j = 1, G = 0;
    for (; ++G < m && (j *= 256); )
      R += this[f + G] * j;
    return R;
  }, a.prototype.readUintBE = a.prototype.readUIntBE = function(f, m, v) {
    f = f >>> 0, m = m >>> 0, v || L(f, m, this.length);
    let R = this[f + --m], j = 1;
    for (; m > 0 && (j *= 256); )
      R += this[f + --m] * j;
    return R;
  }, a.prototype.readUint8 = a.prototype.readUInt8 = function(f, m) {
    return f = f >>> 0, m || L(f, 1, this.length), this[f];
  }, a.prototype.readUint16LE = a.prototype.readUInt16LE = function(f, m) {
    return f = f >>> 0, m || L(f, 2, this.length), this[f] | this[f + 1] << 8;
  }, a.prototype.readUint16BE = a.prototype.readUInt16BE = function(f, m) {
    return f = f >>> 0, m || L(f, 2, this.length), this[f] << 8 | this[f + 1];
  }, a.prototype.readUint32LE = a.prototype.readUInt32LE = function(f, m) {
    return f = f >>> 0, m || L(f, 4, this.length), (this[f] | this[f + 1] << 8 | this[f + 2] << 16) + this[f + 3] * 16777216;
  }, a.prototype.readUint32BE = a.prototype.readUInt32BE = function(f, m) {
    return f = f >>> 0, m || L(f, 4, this.length), this[f] * 16777216 + (this[f + 1] << 16 | this[f + 2] << 8 | this[f + 3]);
  }, a.prototype.readBigUInt64LE = Er(function(f) {
    f = f >>> 0, wr(f, "offset");
    const m = this[f], v = this[f + 7];
    (m === void 0 || v === void 0) && ar(f, this.length - 8);
    const R = m + this[++f] * 2 ** 8 + this[++f] * 2 ** 16 + this[++f] * 2 ** 24, j = this[++f] + this[++f] * 2 ** 8 + this[++f] * 2 ** 16 + v * 2 ** 24;
    return BigInt(R) + (BigInt(j) << BigInt(32));
  }), a.prototype.readBigUInt64BE = Er(function(f) {
    f = f >>> 0, wr(f, "offset");
    const m = this[f], v = this[f + 7];
    (m === void 0 || v === void 0) && ar(f, this.length - 8);
    const R = m * 2 ** 24 + this[++f] * 2 ** 16 + this[++f] * 2 ** 8 + this[++f], j = this[++f] * 2 ** 24 + this[++f] * 2 ** 16 + this[++f] * 2 ** 8 + v;
    return (BigInt(R) << BigInt(32)) + BigInt(j);
  }), a.prototype.readIntLE = function(f, m, v) {
    f = f >>> 0, m = m >>> 0, v || L(f, m, this.length);
    let R = this[f], j = 1, G = 0;
    for (; ++G < m && (j *= 256); )
      R += this[f + G] * j;
    return j *= 128, R >= j && (R -= Math.pow(2, 8 * m)), R;
  }, a.prototype.readIntBE = function(f, m, v) {
    f = f >>> 0, m = m >>> 0, v || L(f, m, this.length);
    let R = m, j = 1, G = this[f + --R];
    for (; R > 0 && (j *= 256); )
      G += this[f + --R] * j;
    return j *= 128, G >= j && (G -= Math.pow(2, 8 * m)), G;
  }, a.prototype.readInt8 = function(f, m) {
    return f = f >>> 0, m || L(f, 1, this.length), this[f] & 128 ? (255 - this[f] + 1) * -1 : this[f];
  }, a.prototype.readInt16LE = function(f, m) {
    f = f >>> 0, m || L(f, 2, this.length);
    const v = this[f] | this[f + 1] << 8;
    return v & 32768 ? v | 4294901760 : v;
  }, a.prototype.readInt16BE = function(f, m) {
    f = f >>> 0, m || L(f, 2, this.length);
    const v = this[f + 1] | this[f] << 8;
    return v & 32768 ? v | 4294901760 : v;
  }, a.prototype.readInt32LE = function(f, m) {
    return f = f >>> 0, m || L(f, 4, this.length), this[f] | this[f + 1] << 8 | this[f + 2] << 16 | this[f + 3] << 24;
  }, a.prototype.readInt32BE = function(f, m) {
    return f = f >>> 0, m || L(f, 4, this.length), this[f] << 24 | this[f + 1] << 16 | this[f + 2] << 8 | this[f + 3];
  }, a.prototype.readBigInt64LE = Er(function(f) {
    f = f >>> 0, wr(f, "offset");
    const m = this[f], v = this[f + 7];
    (m === void 0 || v === void 0) && ar(f, this.length - 8);
    const R = this[f + 4] + this[f + 5] * 2 ** 8 + this[f + 6] * 2 ** 16 + (v << 24);
    return (BigInt(R) << BigInt(32)) + BigInt(m + this[++f] * 2 ** 8 + this[++f] * 2 ** 16 + this[++f] * 2 ** 24);
  }), a.prototype.readBigInt64BE = Er(function(f) {
    f = f >>> 0, wr(f, "offset");
    const m = this[f], v = this[f + 7];
    (m === void 0 || v === void 0) && ar(f, this.length - 8);
    const R = (m << 24) + // Overflow
    this[++f] * 2 ** 16 + this[++f] * 2 ** 8 + this[++f];
    return (BigInt(R) << BigInt(32)) + BigInt(this[++f] * 2 ** 24 + this[++f] * 2 ** 16 + this[++f] * 2 ** 8 + v);
  }), a.prototype.readFloatLE = function(f, m) {
    return f = f >>> 0, m || L(f, 4, this.length), r.read(this, f, !0, 23, 4);
  }, a.prototype.readFloatBE = function(f, m) {
    return f = f >>> 0, m || L(f, 4, this.length), r.read(this, f, !1, 23, 4);
  }, a.prototype.readDoubleLE = function(f, m) {
    return f = f >>> 0, m || L(f, 8, this.length), r.read(this, f, !0, 52, 8);
  }, a.prototype.readDoubleBE = function(f, m) {
    return f = f >>> 0, m || L(f, 8, this.length), r.read(this, f, !1, 52, 8);
  };
  function K(E, f, m, v, R, j) {
    if (!a.isBuffer(E)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (f > R || f < j) throw new RangeError('"value" argument is out of bounds');
    if (m + v > E.length) throw new RangeError("Index out of range");
  }
  a.prototype.writeUintLE = a.prototype.writeUIntLE = function(f, m, v, R) {
    if (f = +f, m = m >>> 0, v = v >>> 0, !R) {
      const ue = Math.pow(2, 8 * v) - 1;
      K(this, f, m, v, ue, 0);
    }
    let j = 1, G = 0;
    for (this[m] = f & 255; ++G < v && (j *= 256); )
      this[m + G] = f / j & 255;
    return m + v;
  }, a.prototype.writeUintBE = a.prototype.writeUIntBE = function(f, m, v, R) {
    if (f = +f, m = m >>> 0, v = v >>> 0, !R) {
      const ue = Math.pow(2, 8 * v) - 1;
      K(this, f, m, v, ue, 0);
    }
    let j = v - 1, G = 1;
    for (this[m + j] = f & 255; --j >= 0 && (G *= 256); )
      this[m + j] = f / G & 255;
    return m + v;
  }, a.prototype.writeUint8 = a.prototype.writeUInt8 = function(f, m, v) {
    return f = +f, m = m >>> 0, v || K(this, f, m, 1, 255, 0), this[m] = f & 255, m + 1;
  }, a.prototype.writeUint16LE = a.prototype.writeUInt16LE = function(f, m, v) {
    return f = +f, m = m >>> 0, v || K(this, f, m, 2, 65535, 0), this[m] = f & 255, this[m + 1] = f >>> 8, m + 2;
  }, a.prototype.writeUint16BE = a.prototype.writeUInt16BE = function(f, m, v) {
    return f = +f, m = m >>> 0, v || K(this, f, m, 2, 65535, 0), this[m] = f >>> 8, this[m + 1] = f & 255, m + 2;
  }, a.prototype.writeUint32LE = a.prototype.writeUInt32LE = function(f, m, v) {
    return f = +f, m = m >>> 0, v || K(this, f, m, 4, 4294967295, 0), this[m + 3] = f >>> 24, this[m + 2] = f >>> 16, this[m + 1] = f >>> 8, this[m] = f & 255, m + 4;
  }, a.prototype.writeUint32BE = a.prototype.writeUInt32BE = function(f, m, v) {
    return f = +f, m = m >>> 0, v || K(this, f, m, 4, 4294967295, 0), this[m] = f >>> 24, this[m + 1] = f >>> 16, this[m + 2] = f >>> 8, this[m + 3] = f & 255, m + 4;
  };
  function J(E, f, m, v, R) {
    Lr(f, v, R, E, m, 7);
    let j = Number(f & BigInt(4294967295));
    E[m++] = j, j = j >> 8, E[m++] = j, j = j >> 8, E[m++] = j, j = j >> 8, E[m++] = j;
    let G = Number(f >> BigInt(32) & BigInt(4294967295));
    return E[m++] = G, G = G >> 8, E[m++] = G, G = G >> 8, E[m++] = G, G = G >> 8, E[m++] = G, m;
  }
  function X(E, f, m, v, R) {
    Lr(f, v, R, E, m, 7);
    let j = Number(f & BigInt(4294967295));
    E[m + 7] = j, j = j >> 8, E[m + 6] = j, j = j >> 8, E[m + 5] = j, j = j >> 8, E[m + 4] = j;
    let G = Number(f >> BigInt(32) & BigInt(4294967295));
    return E[m + 3] = G, G = G >> 8, E[m + 2] = G, G = G >> 8, E[m + 1] = G, G = G >> 8, E[m] = G, m + 8;
  }
  a.prototype.writeBigUInt64LE = Er(function(f, m = 0) {
    return J(this, f, m, BigInt(0), BigInt("0xffffffffffffffff"));
  }), a.prototype.writeBigUInt64BE = Er(function(f, m = 0) {
    return X(this, f, m, BigInt(0), BigInt("0xffffffffffffffff"));
  }), a.prototype.writeIntLE = function(f, m, v, R) {
    if (f = +f, m = m >>> 0, !R) {
      const Me = Math.pow(2, 8 * v - 1);
      K(this, f, m, v, Me - 1, -Me);
    }
    let j = 0, G = 1, ue = 0;
    for (this[m] = f & 255; ++j < v && (G *= 256); )
      f < 0 && ue === 0 && this[m + j - 1] !== 0 && (ue = 1), this[m + j] = (f / G >> 0) - ue & 255;
    return m + v;
  }, a.prototype.writeIntBE = function(f, m, v, R) {
    if (f = +f, m = m >>> 0, !R) {
      const Me = Math.pow(2, 8 * v - 1);
      K(this, f, m, v, Me - 1, -Me);
    }
    let j = v - 1, G = 1, ue = 0;
    for (this[m + j] = f & 255; --j >= 0 && (G *= 256); )
      f < 0 && ue === 0 && this[m + j + 1] !== 0 && (ue = 1), this[m + j] = (f / G >> 0) - ue & 255;
    return m + v;
  }, a.prototype.writeInt8 = function(f, m, v) {
    return f = +f, m = m >>> 0, v || K(this, f, m, 1, 127, -128), f < 0 && (f = 255 + f + 1), this[m] = f & 255, m + 1;
  }, a.prototype.writeInt16LE = function(f, m, v) {
    return f = +f, m = m >>> 0, v || K(this, f, m, 2, 32767, -32768), this[m] = f & 255, this[m + 1] = f >>> 8, m + 2;
  }, a.prototype.writeInt16BE = function(f, m, v) {
    return f = +f, m = m >>> 0, v || K(this, f, m, 2, 32767, -32768), this[m] = f >>> 8, this[m + 1] = f & 255, m + 2;
  }, a.prototype.writeInt32LE = function(f, m, v) {
    return f = +f, m = m >>> 0, v || K(this, f, m, 4, 2147483647, -2147483648), this[m] = f & 255, this[m + 1] = f >>> 8, this[m + 2] = f >>> 16, this[m + 3] = f >>> 24, m + 4;
  }, a.prototype.writeInt32BE = function(f, m, v) {
    return f = +f, m = m >>> 0, v || K(this, f, m, 4, 2147483647, -2147483648), f < 0 && (f = 4294967295 + f + 1), this[m] = f >>> 24, this[m + 1] = f >>> 16, this[m + 2] = f >>> 8, this[m + 3] = f & 255, m + 4;
  }, a.prototype.writeBigInt64LE = Er(function(f, m = 0) {
    return J(this, f, m, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), a.prototype.writeBigInt64BE = Er(function(f, m = 0) {
    return X(this, f, m, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function Y(E, f, m, v, R, j) {
    if (m + v > E.length) throw new RangeError("Index out of range");
    if (m < 0) throw new RangeError("Index out of range");
  }
  function re(E, f, m, v, R) {
    return f = +f, m = m >>> 0, R || Y(E, f, m, 4), r.write(E, f, m, v, 23, 4), m + 4;
  }
  a.prototype.writeFloatLE = function(f, m, v) {
    return re(this, f, m, !0, v);
  }, a.prototype.writeFloatBE = function(f, m, v) {
    return re(this, f, m, !1, v);
  };
  function ae(E, f, m, v, R) {
    return f = +f, m = m >>> 0, R || Y(E, f, m, 8), r.write(E, f, m, v, 52, 8), m + 8;
  }
  a.prototype.writeDoubleLE = function(f, m, v) {
    return ae(this, f, m, !0, v);
  }, a.prototype.writeDoubleBE = function(f, m, v) {
    return ae(this, f, m, !1, v);
  }, a.prototype.copy = function(f, m, v, R) {
    if (!a.isBuffer(f)) throw new TypeError("argument should be a Buffer");
    if (v || (v = 0), !R && R !== 0 && (R = this.length), m >= f.length && (m = f.length), m || (m = 0), R > 0 && R < v && (R = v), R === v || f.length === 0 || this.length === 0) return 0;
    if (m < 0)
      throw new RangeError("targetStart out of bounds");
    if (v < 0 || v >= this.length) throw new RangeError("Index out of range");
    if (R < 0) throw new RangeError("sourceEnd out of bounds");
    R > this.length && (R = this.length), f.length - m < R - v && (R = f.length - m + v);
    const j = R - v;
    return this === f && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(m, v, R) : Uint8Array.prototype.set.call(
      f,
      this.subarray(v, R),
      m
    ), j;
  }, a.prototype.fill = function(f, m, v, R) {
    if (typeof f == "string") {
      if (typeof m == "string" ? (R = m, m = 0, v = this.length) : typeof v == "string" && (R = v, v = this.length), R !== void 0 && typeof R != "string")
        throw new TypeError("encoding must be a string");
      if (typeof R == "string" && !a.isEncoding(R))
        throw new TypeError("Unknown encoding: " + R);
      if (f.length === 1) {
        const G = f.charCodeAt(0);
        (R === "utf8" && G < 128 || R === "latin1") && (f = G);
      }
    } else typeof f == "number" ? f = f & 255 : typeof f == "boolean" && (f = Number(f));
    if (m < 0 || this.length < m || this.length < v)
      throw new RangeError("Out of range index");
    if (v <= m)
      return this;
    m = m >>> 0, v = v === void 0 ? this.length : v >>> 0, f || (f = 0);
    let j;
    if (typeof f == "number")
      for (j = m; j < v; ++j)
        this[j] = f;
    else {
      const G = a.isBuffer(f) ? f : a.from(f, R), ue = G.length;
      if (ue === 0)
        throw new TypeError('The value "' + f + '" is invalid for argument "value"');
      for (j = 0; j < v - m; ++j)
        this[j + m] = G[j % ue];
    }
    return this;
  };
  const ne = {};
  function se(E, f, m) {
    ne[E] = class extends m {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: f.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${E}]`, this.stack, delete this.name;
      }
      get code() {
        return E;
      }
      set code(R) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: R,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${E}]: ${this.message}`;
      }
    };
  }
  se(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(E) {
      return E ? `${E} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), se(
    "ERR_INVALID_ARG_TYPE",
    function(E, f) {
      return `The "${E}" argument must be of type number. Received type ${typeof f}`;
    },
    TypeError
  ), se(
    "ERR_OUT_OF_RANGE",
    function(E, f, m) {
      let v = `The value of "${E}" is out of range.`, R = m;
      return Number.isInteger(m) && Math.abs(m) > 2 ** 32 ? R = fe(String(m)) : typeof m == "bigint" && (R = String(m), (m > BigInt(2) ** BigInt(32) || m < -(BigInt(2) ** BigInt(32))) && (R = fe(R)), R += "n"), v += ` It must be ${f}. Received ${R}`, v;
    },
    RangeError
  );
  function fe(E) {
    let f = "", m = E.length;
    const v = E[0] === "-" ? 1 : 0;
    for (; m >= v + 4; m -= 3)
      f = `_${E.slice(m - 3, m)}${f}`;
    return `${E.slice(0, m)}${f}`;
  }
  function Oe(E, f, m) {
    wr(f, "offset"), (E[f] === void 0 || E[f + m] === void 0) && ar(f, E.length - (m + 1));
  }
  function Lr(E, f, m, v, R, j) {
    if (E > m || E < f) {
      const G = typeof f == "bigint" ? "n" : "";
      let ue;
      throw f === 0 || f === BigInt(0) ? ue = `>= 0${G} and < 2${G} ** ${(j + 1) * 8}${G}` : ue = `>= -(2${G} ** ${(j + 1) * 8 - 1}${G}) and < 2 ** ${(j + 1) * 8 - 1}${G}`, new ne.ERR_OUT_OF_RANGE("value", ue, E);
    }
    Oe(v, R, j);
  }
  function wr(E, f) {
    if (typeof E != "number")
      throw new ne.ERR_INVALID_ARG_TYPE(f, "number", E);
  }
  function ar(E, f, m) {
    throw Math.floor(E) !== E ? (wr(E, m), new ne.ERR_OUT_OF_RANGE("offset", "an integer", E)) : f < 0 ? new ne.ERR_BUFFER_OUT_OF_BOUNDS() : new ne.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${f}`,
      E
    );
  }
  const $i = /[^+/0-9A-Za-z-_]/g;
  function Gl(E) {
    if (E = E.split("=")[0], E = E.trim().replace($i, ""), E.length < 2) return "";
    for (; E.length % 4 !== 0; )
      E = E + "=";
    return E;
  }
  function Bi(E, f) {
    f = f || 1 / 0;
    let m;
    const v = E.length;
    let R = null;
    const j = [];
    for (let G = 0; G < v; ++G) {
      if (m = E.charCodeAt(G), m > 55295 && m < 57344) {
        if (!R) {
          if (m > 56319) {
            (f -= 3) > -1 && j.push(239, 191, 189);
            continue;
          } else if (G + 1 === v) {
            (f -= 3) > -1 && j.push(239, 191, 189);
            continue;
          }
          R = m;
          continue;
        }
        if (m < 56320) {
          (f -= 3) > -1 && j.push(239, 191, 189), R = m;
          continue;
        }
        m = (R - 55296 << 10 | m - 56320) + 65536;
      } else R && (f -= 3) > -1 && j.push(239, 191, 189);
      if (R = null, m < 128) {
        if ((f -= 1) < 0) break;
        j.push(m);
      } else if (m < 2048) {
        if ((f -= 2) < 0) break;
        j.push(
          m >> 6 | 192,
          m & 63 | 128
        );
      } else if (m < 65536) {
        if ((f -= 3) < 0) break;
        j.push(
          m >> 12 | 224,
          m >> 6 & 63 | 128,
          m & 63 | 128
        );
      } else if (m < 1114112) {
        if ((f -= 4) < 0) break;
        j.push(
          m >> 18 | 240,
          m >> 12 & 63 | 128,
          m >> 6 & 63 | 128,
          m & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return j;
  }
  function Wl(E) {
    const f = [];
    for (let m = 0; m < E.length; ++m)
      f.push(E.charCodeAt(m) & 255);
    return f;
  }
  function Ta(E, f) {
    let m, v, R;
    const j = [];
    for (let G = 0; G < E.length && !((f -= 2) < 0); ++G)
      m = E.charCodeAt(G), v = m >> 8, R = m % 256, j.push(R), j.push(v);
    return j;
  }
  function Di(E) {
    return e.toByteArray(Gl(E));
  }
  function Is(E, f, m, v) {
    let R;
    for (R = 0; R < v && !(R + m >= f.length || R >= E.length); ++R)
      f[R + m] = E[R];
    return R;
  }
  function Wt(E, f) {
    return E instanceof f || E != null && E.constructor != null && E.constructor.name != null && E.constructor.name === f.name;
  }
  function Ln(E) {
    return E !== E;
  }
  const Ua = function() {
    const E = "0123456789abcdef", f = new Array(256);
    for (let m = 0; m < 16; ++m) {
      const v = m * 16;
      for (let R = 0; R < 16; ++R)
        f[v + R] = E[m] + E[R];
    }
    return f;
  }();
  function Er(E) {
    return typeof BigInt > "u" ? $a : E;
  }
  function $a() {
    throw new Error("BigInt not supported");
  }
})(pw);
var nT = Object.defineProperty, iT = (t, e, r) => e in t ? nT(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, eb = (t, e, r) => iT(t, typeof e != "symbol" ? e + "" : e, r);
let oT = class extends nr {
  constructor(e) {
    super(), this.opts = e, eb(this, "protocol", "wc"), eb(this, "version", 2);
  }
};
var aT = Object.defineProperty, cT = (t, e, r) => e in t ? aT(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, lT = (t, e, r) => cT(t, e + "", r);
let uT = class extends nr {
  constructor(e, r) {
    super(), this.core = e, this.logger = r, lT(this, "records", /* @__PURE__ */ new Map());
  }
}, hT = class {
  constructor(e, r) {
    this.logger = e, this.core = r;
  }
};
class dT extends nr {
  constructor(e, r) {
    super(), this.relayer = e, this.logger = r;
  }
}
class pT extends nr {
  constructor(e) {
    super();
  }
}
let fT = class {
  constructor(e, r, s, n) {
    this.core = e, this.logger = r, this.name = s;
  }
}, mT = class extends nr {
  constructor(e, r) {
    super(), this.relayer = e, this.logger = r;
  }
}, bT = class extends nr {
  constructor(e, r) {
    super(), this.core = e, this.logger = r;
  }
}, yT = class {
  constructor(e, r, s) {
    this.core = e, this.logger = r, this.store = s;
  }
}, gT = class {
  constructor(e, r) {
    this.projectId = e, this.logger = r;
  }
}, wT = class {
  constructor(e, r, s) {
    this.core = e, this.logger = r, this.telemetryEnabled = s;
  }
};
var ET = Object.defineProperty, xT = (t, e, r) => e in t ? ET(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, tb = (t, e, r) => xT(t, typeof e != "symbol" ? e + "" : e, r);
let vT = class {
  constructor(e) {
    this.opts = e, tb(this, "protocol", "wc"), tb(this, "version", 2);
  }
}, kT = class {
  constructor(e) {
    this.client = e;
  }
};
const CT = ":";
function Fc(t) {
  const [e, r] = t.split(CT);
  return { namespace: e, reference: r };
}
function mw(t, e) {
  return t.includes(":") ? [t] : e.chains || [];
}
var ST = Object.defineProperty, IT = Object.defineProperties, AT = Object.getOwnPropertyDescriptors, rb = Object.getOwnPropertySymbols, _T = Object.prototype.hasOwnProperty, TT = Object.prototype.propertyIsEnumerable, Jh = (t, e, r) => e in t ? ST(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, sb = (t, e) => {
  for (var r in e || (e = {})) _T.call(e, r) && Jh(t, r, e[r]);
  if (rb) for (var r of rb(e)) TT.call(e, r) && Jh(t, r, e[r]);
  return t;
}, UT = (t, e) => IT(t, AT(e)), nb = (t, e, r) => Jh(t, typeof e != "symbol" ? e + "" : e, r);
const $T = "ReactNative", rr = { reactNative: "react-native", node: "node", browser: "browser", unknown: "unknown" }, BT = "js";
function cl() {
  return typeof process < "u" && typeof process.versions < "u" && typeof process.versions.node < "u";
}
function hn() {
  return !fr() && !!da() && navigator.product === $T;
}
function DT() {
  return hn() && typeof globalThis < "u" && typeof (globalThis == null ? void 0 : globalThis.Platform) < "u" && (globalThis == null ? void 0 : globalThis.Platform.OS) === "android";
}
function OT() {
  return hn() && typeof globalThis < "u" && typeof (globalThis == null ? void 0 : globalThis.Platform) < "u" && (globalThis == null ? void 0 : globalThis.Platform.OS) === "ios";
}
function Ci() {
  return !cl() && !!da() && !!fr();
}
function xa() {
  return hn() ? rr.reactNative : cl() ? rr.node : Ci() ? rr.browser : rr.unknown;
}
function ib() {
  var t;
  try {
    return hn() && typeof globalThis < "u" && typeof (globalThis == null ? void 0 : globalThis.Application) < "u" ? (t = globalThis.Application) == null ? void 0 : t.applicationId : void 0;
  } catch {
    return;
  }
}
function PT(t, e) {
  const r = new URLSearchParams(t);
  for (const s of Object.keys(e).sort()) if (e.hasOwnProperty(s)) {
    const n = e[s];
    n !== void 0 && r.set(s, n);
  }
  return r.toString();
}
function RT(t) {
  var e, r;
  const s = bw();
  try {
    return t != null && t.url && s.url && new URL(t.url).host !== new URL(s.url).host && (console.warn(`The configured WalletConnect 'metadata.url':${t.url} differs from the actual page url:${s.url}. This is probably unintended and can lead to issues.`), t.url = s.url), (e = t == null ? void 0 : t.icons) != null && e.length && t.icons.length > 0 && (t.icons = t.icons.filter((n) => n !== "")), UT(sb(sb({}, s), t), { url: (t == null ? void 0 : t.url) || s.url, name: (t == null ? void 0 : t.name) || s.name, description: (t == null ? void 0 : t.description) || s.description, icons: (r = t == null ? void 0 : t.icons) != null && r.length && t.icons.length > 0 ? t.icons : s.icons });
  } catch (n) {
    return console.warn("Error populating app metadata", n), t || s;
  }
}
function bw() {
  return Jd() || { name: "", description: "", url: "", icons: [""] };
}
function NT() {
  if (xa() === rr.reactNative && typeof globalThis < "u" && typeof (globalThis == null ? void 0 : globalThis.Platform) < "u") {
    const { OS: r, Version: s } = globalThis.Platform;
    return [r, s].join("-");
  }
  const t = ly();
  if (t === null) return "unknown";
  const e = t.os ? t.os.replace(" ", "").toLowerCase() : "unknown";
  return t.type === "browser" ? [e, t.name, t.version].join("-") : [e, t.version].join("-");
}
function LT() {
  var t;
  const e = xa();
  return e === rr.browser ? [e, ((t = Wd()) == null ? void 0 : t.host) || "unknown"].join(":") : e;
}
function yw(t, e, r) {
  const s = NT(), n = LT();
  return [[t, e].join("-"), [BT, r].join("-"), s, n].join("/");
}
function MT({ protocol: t, version: e, relayUrl: r, sdkVersion: s, auth: n, projectId: i, useOnCloseEvent: o, bundleId: a, packageName: c }) {
  const l = r.split("?"), u = yw(t, e, s), h = { auth: n, ua: u, projectId: i, useOnCloseEvent: o, packageName: c || void 0, bundleId: a || void 0 }, p = PT(l[1] || "", h);
  return l[0] + "?" + p;
}
function vn(t, e) {
  return t.filter((r) => e.includes(r)).length === t.length;
}
function Xh(t) {
  return Object.fromEntries(t.entries());
}
function Yh(t) {
  return new Map(Object.entries(t));
}
function bn(t = V.FIVE_MINUTES, e) {
  const r = V.toMiliseconds(t || V.FIVE_MINUTES);
  let s, n, i, o;
  return { resolve: (a) => {
    i && s && (clearTimeout(i), s(a), o = Promise.resolve(a));
  }, reject: (a) => {
    i && n && (clearTimeout(i), n(a));
  }, done: () => new Promise((a, c) => {
    if (o) return a(o);
    i = setTimeout(() => {
      const l = new Error(e);
      o = Promise.reject(l), c(l);
    }, r), s = a, n = c;
  }) };
}
function rn(t, e, r) {
  return new Promise(async (s, n) => {
    const i = setTimeout(() => n(new Error(r)), e);
    try {
      const o = await t;
      s(o);
    } catch (o) {
      n(o);
    }
    clearTimeout(i);
  });
}
function gw(t, e) {
  if (typeof e == "string" && e.startsWith(`${t}:`)) return e;
  if (t.toLowerCase() === "topic") {
    if (typeof e != "string") throw new Error('Value must be "string" for expirer target type: topic');
    return `topic:${e}`;
  } else if (t.toLowerCase() === "id") {
    if (typeof e != "number") throw new Error('Value must be "number" for expirer target type: id');
    return `id:${e}`;
  }
  throw new Error(`Unknown expirer target type: ${t}`);
}
function FT(t) {
  return gw("topic", t);
}
function zT(t) {
  return gw("id", t);
}
function ww(t) {
  const [e, r] = t.split(":"), s = { id: void 0, topic: void 0 };
  if (e === "topic" && typeof r == "string") s.topic = r;
  else if (e === "id" && Number.isInteger(Number(r))) s.id = Number(r);
  else throw new Error(`Invalid target, expected id:number or topic:string, got ${e}:${r}`);
  return s;
}
function Ze(t, e) {
  return V.fromMiliseconds(Date.now() + V.toMiliseconds(t));
}
function Js(t) {
  return Date.now() >= V.toMiliseconds(t);
}
function Ee(t, e) {
  return `${t}${e ? `:${e}` : ""}`;
}
function An(t = [], e = []) {
  return [.../* @__PURE__ */ new Set([...t, ...e])];
}
async function jT({ id: t, topic: e, wcDeepLink: r }) {
  var s;
  try {
    if (!r) return;
    const n = typeof r == "string" ? JSON.parse(r) : r, i = n == null ? void 0 : n.href;
    if (typeof i != "string") return;
    const o = HT(i, t, e), a = xa();
    if (a === rr.browser) {
      if (!((s = fr()) != null && s.hasFocus())) {
        console.warn("Document does not have focus, skipping deeplink.");
        return;
      }
      qT(o);
    } else a === rr.reactNative && typeof (globalThis == null ? void 0 : globalThis.Linking) < "u" && await globalThis.Linking.openURL(o);
  } catch (n) {
    console.error(n);
  }
}
function HT(t, e, r) {
  const s = `requestId=${e}&sessionTopic=${r}`;
  t.endsWith("/") && (t = t.slice(0, -1));
  let n = `${t}`;
  if (t.startsWith("https://t.me")) {
    const i = t.includes("?") ? "&startapp=" : "?startapp=";
    n = `${n}${i}${WT(s, !0)}`;
  } else n = `${n}/wc?${s}`;
  return n;
}
function qT(t) {
  let e = "_self";
  GT() ? e = "_top" : (VT() || t.startsWith("https://") || t.startsWith("http://")) && (e = "_blank"), window.open(t, e, "noreferrer noopener");
}
async function KT(t, e) {
  let r = "";
  try {
    if (Ci() && (r = localStorage.getItem(e), r)) return r;
    r = await t.getItem(e);
  } catch (s) {
    console.error(s);
  }
  return r;
}
function ob(t, e) {
  if (!t.includes(e)) return null;
  const r = t.split(/([&,?,=])/), s = r.indexOf(e);
  return r[s + 2];
}
function ab() {
  return typeof crypto < "u" && crypto != null && crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/gu, (t) => {
    const e = Math.random() * 16 | 0;
    return (t === "x" ? e : e & 3 | 8).toString(16);
  });
}
function gp() {
  return typeof process < "u" && process.env.IS_VITEST === "true";
}
function VT() {
  return typeof window < "u" && (!!window.TelegramWebviewProxy || !!window.Telegram || !!window.TelegramWebviewProxyProto);
}
function GT() {
  try {
    return window.self !== window.top;
  } catch {
    return !1;
  }
}
function WT(t, e = !1) {
  const r = Buffer.from(t).toString("base64");
  return e ? r.replace(/[=]/g, "") : r;
}
function Ew(t) {
  return Buffer.from(t, "base64").toString("utf-8");
}
function ZT(t) {
  return new Promise((e) => setTimeout(e, t));
}
let JT = class {
  constructor({ limit: e }) {
    nb(this, "limit"), nb(this, "set"), this.limit = e, this.set = /* @__PURE__ */ new Set();
  }
  add(e) {
    if (!this.set.has(e)) {
      if (this.set.size >= this.limit) {
        const r = this.set.values().next().value;
        r && this.set.delete(r);
      }
      this.set.add(e);
    }
  }
  has(e) {
    return this.set.has(e);
  }
};
const Ja = BigInt(2 ** 32 - 1), cb = BigInt(32);
function xw(t, e = !1) {
  return e ? { h: Number(t & Ja), l: Number(t >> cb & Ja) } : { h: Number(t >> cb & Ja) | 0, l: Number(t & Ja) | 0 };
}
function vw(t, e = !1) {
  const r = t.length;
  let s = new Uint32Array(r), n = new Uint32Array(r);
  for (let i = 0; i < r; i++) {
    const { h: o, l: a } = xw(t[i], e);
    [s[i], n[i]] = [o, a];
  }
  return [s, n];
}
const lb = (t, e, r) => t >>> r, ub = (t, e, r) => t << 32 - r | e >>> r, Xs = (t, e, r) => t >>> r | e << 32 - r, Ys = (t, e, r) => t << 32 - r | e >>> r, So = (t, e, r) => t << 64 - r | e >>> r - 32, Io = (t, e, r) => t >>> r - 32 | e << 64 - r, XT = (t, e) => e, YT = (t, e) => t, QT = (t, e, r) => t << r | e >>> 32 - r, eU = (t, e, r) => e << r | t >>> 32 - r, tU = (t, e, r) => e << r - 32 | t >>> 64 - r, rU = (t, e, r) => t << r - 32 | e >>> 64 - r;
function $r(t, e, r, s) {
  const n = (e >>> 0) + (s >>> 0);
  return { h: t + r + (n / 2 ** 32 | 0) | 0, l: n | 0 };
}
const wp = (t, e, r) => (t >>> 0) + (e >>> 0) + (r >>> 0), Ep = (t, e, r, s) => e + r + s + (t / 2 ** 32 | 0) | 0, sU = (t, e, r, s) => (t >>> 0) + (e >>> 0) + (r >>> 0) + (s >>> 0), nU = (t, e, r, s, n) => e + r + s + n + (t / 2 ** 32 | 0) | 0, iU = (t, e, r, s, n) => (t >>> 0) + (e >>> 0) + (r >>> 0) + (s >>> 0) + (n >>> 0), oU = (t, e, r, s, n, i) => e + r + s + n + i + (t / 2 ** 32 | 0) | 0, Wn = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
function xp(t) {
  return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function ks(t) {
  if (!Number.isSafeInteger(t) || t < 0) throw new Error("positive integer expected, got " + t);
}
function yr(t, ...e) {
  if (!xp(t)) throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(t.length)) throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function vp(t) {
  if (typeof t != "function" || typeof t.create != "function") throw new Error("Hash should be wrapped by utils.createHasher");
  ks(t.outputLen), ks(t.blockLen);
}
function ln(t, e = !0) {
  if (t.destroyed) throw new Error("Hash instance has been destroyed");
  if (e && t.finished) throw new Error("Hash#digest() has already been called");
}
function kp(t, e) {
  yr(t);
  const r = e.outputLen;
  if (t.length < r) throw new Error("digestInto() expects output buffer of length at least " + r);
}
function Qo(t) {
  return new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4));
}
function gr(...t) {
  for (let e = 0; e < t.length; e++) t[e].fill(0);
}
function Tu(t) {
  return new DataView(t.buffer, t.byteOffset, t.byteLength);
}
function Hr(t, e) {
  return t << 32 - e | t >>> e;
}
const kw = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
function Cw(t) {
  return t << 24 & 4278190080 | t << 8 & 16711680 | t >>> 8 & 65280 | t >>> 24 & 255;
}
const ms = kw ? (t) => t : (t) => Cw(t);
function aU(t) {
  for (let e = 0; e < t.length; e++) t[e] = Cw(t[e]);
  return t;
}
const Qs = kw ? (t) => t : aU, Sw = typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", cU = Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function ea(t) {
  if (yr(t), Sw) return t.toHex();
  let e = "";
  for (let r = 0; r < t.length; r++) e += cU[t[r]];
  return e;
}
const cs = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function hb(t) {
  if (t >= cs._0 && t <= cs._9) return t - cs._0;
  if (t >= cs.A && t <= cs.F) return t - (cs.A - 10);
  if (t >= cs.a && t <= cs.f) return t - (cs.a - 10);
}
function Cp(t) {
  if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
  if (Sw) return Uint8Array.fromHex(t);
  const e = t.length, r = e / 2;
  if (e % 2) throw new Error("hex string expected, got unpadded hex of length " + e);
  const s = new Uint8Array(r);
  for (let n = 0, i = 0; n < r; n++, i += 2) {
    const o = hb(t.charCodeAt(i)), a = hb(t.charCodeAt(i + 1));
    if (o === void 0 || a === void 0) {
      const c = t[i] + t[i + 1];
      throw new Error('hex string expected, got non-hex character "' + c + '" at index ' + i);
    }
    s[n] = o * 16 + a;
  }
  return s;
}
function lU(t) {
  if (typeof t != "string") throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(t));
}
function Nr(t) {
  return typeof t == "string" && (t = lU(t)), yr(t), t;
}
function kn(...t) {
  let e = 0;
  for (let s = 0; s < t.length; s++) {
    const n = t[s];
    yr(n), e += n.length;
  }
  const r = new Uint8Array(e);
  for (let s = 0, n = 0; s < t.length; s++) {
    const i = t[s];
    r.set(i, n), n += i.length;
  }
  return r;
}
let Ol = class {
};
function va(t) {
  const e = (s) => t().update(Nr(s)).digest(), r = t();
  return e.outputLen = r.outputLen, e.blockLen = r.blockLen, e.create = () => t(), e;
}
function uU(t) {
  const e = (s, n) => t(n).update(Nr(s)).digest(), r = t({});
  return e.outputLen = r.outputLen, e.blockLen = r.blockLen, e.create = (s) => t(s), e;
}
function Si(t = 32) {
  if (Wn && typeof Wn.getRandomValues == "function") return Wn.getRandomValues(new Uint8Array(t));
  if (Wn && typeof Wn.randomBytes == "function") return Uint8Array.from(Wn.randomBytes(t));
  throw new Error("crypto.getRandomValues must be defined");
}
const hU = BigInt(0), Zi = BigInt(1), dU = BigInt(2), pU = BigInt(7), fU = BigInt(256), mU = BigInt(113), Iw = [], Aw = [], _w = [];
for (let t = 0, e = Zi, r = 1, s = 0; t < 24; t++) {
  [r, s] = [s, (2 * r + 3 * s) % 5], Iw.push(2 * (5 * s + r)), Aw.push((t + 1) * (t + 2) / 2 % 64);
  let n = hU;
  for (let i = 0; i < 7; i++) e = (e << Zi ^ (e >> pU) * mU) % fU, e & dU && (n ^= Zi << (Zi << BigInt(i)) - Zi);
  _w.push(n);
}
const Tw = vw(_w, !0), bU = Tw[0], yU = Tw[1], db = (t, e, r) => r > 32 ? tU(t, e, r) : QT(t, e, r), pb = (t, e, r) => r > 32 ? rU(t, e, r) : eU(t, e, r);
function gU(t, e = 24) {
  const r = new Uint32Array(10);
  for (let s = 24 - e; s < 24; s++) {
    for (let o = 0; o < 10; o++) r[o] = t[o] ^ t[o + 10] ^ t[o + 20] ^ t[o + 30] ^ t[o + 40];
    for (let o = 0; o < 10; o += 2) {
      const a = (o + 8) % 10, c = (o + 2) % 10, l = r[c], u = r[c + 1], h = db(l, u, 1) ^ r[a], p = pb(l, u, 1) ^ r[a + 1];
      for (let y = 0; y < 50; y += 10) t[o + y] ^= h, t[o + y + 1] ^= p;
    }
    let n = t[2], i = t[3];
    for (let o = 0; o < 24; o++) {
      const a = Aw[o], c = db(n, i, a), l = pb(n, i, a), u = Iw[o];
      n = t[u], i = t[u + 1], t[u] = c, t[u + 1] = l;
    }
    for (let o = 0; o < 50; o += 10) {
      for (let a = 0; a < 10; a++) r[a] = t[o + a];
      for (let a = 0; a < 10; a++) t[o + a] ^= ~r[(a + 2) % 10] & r[(a + 4) % 10];
    }
    t[0] ^= bU[s], t[1] ^= yU[s];
  }
  gr(r);
}
let wU = class Uw extends Ol {
  constructor(e, r, s, n = !1, i = 24) {
    if (super(), this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, this.enableXOF = !1, this.blockLen = e, this.suffix = r, this.outputLen = s, this.enableXOF = n, this.rounds = i, ks(s), !(0 < e && e < 200)) throw new Error("only keccak-f1600 function is supported");
    this.state = new Uint8Array(200), this.state32 = Qo(this.state);
  }
  clone() {
    return this._cloneInto();
  }
  keccak() {
    Qs(this.state32), gU(this.state32, this.rounds), Qs(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(e) {
    ln(this), e = Nr(e), yr(e);
    const { blockLen: r, state: s } = this, n = e.length;
    for (let i = 0; i < n; ) {
      const o = Math.min(r - this.pos, n - i);
      for (let a = 0; a < o; a++) s[this.pos++] ^= e[i++];
      this.pos === r && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished) return;
    this.finished = !0;
    const { state: e, suffix: r, pos: s, blockLen: n } = this;
    e[s] ^= r, (r & 128) !== 0 && s === n - 1 && this.keccak(), e[n - 1] ^= 128, this.keccak();
  }
  writeInto(e) {
    ln(this, !1), yr(e), this.finish();
    const r = this.state, { blockLen: s } = this;
    for (let n = 0, i = e.length; n < i; ) {
      this.posOut >= s && this.keccak();
      const o = Math.min(s - this.posOut, i - n);
      e.set(r.subarray(this.posOut, this.posOut + o), n), this.posOut += o, n += o;
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return ks(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if (kp(e, this), this.finished) throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, gr(this.state);
  }
  _cloneInto(e) {
    const { blockLen: r, suffix: s, outputLen: n, rounds: i, enableXOF: o } = this;
    return e || (e = new Uw(r, s, n, o, i)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = i, e.suffix = s, e.outputLen = n, e.enableXOF = o, e.destroyed = this.destroyed, e;
  }
};
const EU = (t, e, r) => va(() => new wU(e, t, r)), xU = EU(1, 136, 256 / 8);
function vU(t, e, r, s) {
  if (typeof t.setBigUint64 == "function") return t.setBigUint64(e, r, s);
  const n = BigInt(32), i = BigInt(4294967295), o = Number(r >> n & i), a = Number(r & i), c = s ? 4 : 0, l = s ? 0 : 4;
  t.setUint32(e + c, o, s), t.setUint32(e + l, a, s);
}
function kU(t, e, r) {
  return t & e ^ ~t & r;
}
function CU(t, e, r) {
  return t & e ^ t & r ^ e & r;
}
let $w = class extends Ol {
  constructor(e, r, s, n) {
    super(), this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.blockLen = e, this.outputLen = r, this.padOffset = s, this.isLE = n, this.buffer = new Uint8Array(e), this.view = Tu(this.buffer);
  }
  update(e) {
    ln(this), e = Nr(e), yr(e);
    const { view: r, buffer: s, blockLen: n } = this, i = e.length;
    for (let o = 0; o < i; ) {
      const a = Math.min(n - this.pos, i - o);
      if (a === n) {
        const c = Tu(e);
        for (; n <= i - o; o += n) this.process(c, o);
        continue;
      }
      s.set(e.subarray(o, o + a), this.pos), this.pos += a, o += a, this.pos === n && (this.process(r, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    ln(this), kp(e, this), this.finished = !0;
    const { buffer: r, view: s, blockLen: n, isLE: i } = this;
    let { pos: o } = this;
    r[o++] = 128, gr(this.buffer.subarray(o)), this.padOffset > n - o && (this.process(s, 0), o = 0);
    for (let h = o; h < n; h++) r[h] = 0;
    vU(s, n - 8, BigInt(this.length * 8), i), this.process(s, 0);
    const a = Tu(e), c = this.outputLen;
    if (c % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
    const l = c / 4, u = this.get();
    if (l > u.length) throw new Error("_sha2: outputLen bigger than state");
    for (let h = 0; h < l; h++) a.setUint32(4 * h, u[h], i);
  }
  digest() {
    const { buffer: e, outputLen: r } = this;
    this.digestInto(e);
    const s = e.slice(0, r);
    return this.destroy(), s;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: r, buffer: s, length: n, finished: i, destroyed: o, pos: a } = this;
    return e.destroyed = o, e.finished = i, e.length = n, e.pos = a, n % r && e.buffer.set(s), e;
  }
  clone() {
    return this._cloneInto();
  }
};
const zs = Uint32Array.from([1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225]), kt = Uint32Array.from([3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428]), Ct = Uint32Array.from([1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209]), SU = Uint32Array.from([1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298]), js = new Uint32Array(64);
let IU = class extends $w {
  constructor(e = 32) {
    super(64, e, 8, !1), this.A = zs[0] | 0, this.B = zs[1] | 0, this.C = zs[2] | 0, this.D = zs[3] | 0, this.E = zs[4] | 0, this.F = zs[5] | 0, this.G = zs[6] | 0, this.H = zs[7] | 0;
  }
  get() {
    const { A: e, B: r, C: s, D: n, E: i, F: o, G: a, H: c } = this;
    return [e, r, s, n, i, o, a, c];
  }
  set(e, r, s, n, i, o, a, c) {
    this.A = e | 0, this.B = r | 0, this.C = s | 0, this.D = n | 0, this.E = i | 0, this.F = o | 0, this.G = a | 0, this.H = c | 0;
  }
  process(e, r) {
    for (let h = 0; h < 16; h++, r += 4) js[h] = e.getUint32(r, !1);
    for (let h = 16; h < 64; h++) {
      const p = js[h - 15], y = js[h - 2], b = Hr(p, 7) ^ Hr(p, 18) ^ p >>> 3, g = Hr(y, 17) ^ Hr(y, 19) ^ y >>> 10;
      js[h] = g + js[h - 7] + b + js[h - 16] | 0;
    }
    let { A: s, B: n, C: i, D: o, E: a, F: c, G: l, H: u } = this;
    for (let h = 0; h < 64; h++) {
      const p = Hr(a, 6) ^ Hr(a, 11) ^ Hr(a, 25), y = u + p + kU(a, c, l) + SU[h] + js[h] | 0, b = (Hr(s, 2) ^ Hr(s, 13) ^ Hr(s, 22)) + CU(s, n, i) | 0;
      u = l, l = c, c = a, a = o + y | 0, o = i, i = n, n = s, s = y + b | 0;
    }
    s = s + this.A | 0, n = n + this.B | 0, i = i + this.C | 0, o = o + this.D | 0, a = a + this.E | 0, c = c + this.F | 0, l = l + this.G | 0, u = u + this.H | 0, this.set(s, n, i, o, a, c, l, u);
  }
  roundClean() {
    gr(js);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), gr(this.buffer);
  }
};
const Bw = vw(["0x428a2f98d728ae22", "0x7137449123ef65cd", "0xb5c0fbcfec4d3b2f", "0xe9b5dba58189dbbc", "0x3956c25bf348b538", "0x59f111f1b605d019", "0x923f82a4af194f9b", "0xab1c5ed5da6d8118", "0xd807aa98a3030242", "0x12835b0145706fbe", "0x243185be4ee4b28c", "0x550c7dc3d5ffb4e2", "0x72be5d74f27b896f", "0x80deb1fe3b1696b1", "0x9bdc06a725c71235", "0xc19bf174cf692694", "0xe49b69c19ef14ad2", "0xefbe4786384f25e3", "0x0fc19dc68b8cd5b5", "0x240ca1cc77ac9c65", "0x2de92c6f592b0275", "0x4a7484aa6ea6e483", "0x5cb0a9dcbd41fbd4", "0x76f988da831153b5", "0x983e5152ee66dfab", "0xa831c66d2db43210", "0xb00327c898fb213f", "0xbf597fc7beef0ee4", "0xc6e00bf33da88fc2", "0xd5a79147930aa725", "0x06ca6351e003826f", "0x142929670a0e6e70", "0x27b70a8546d22ffc", "0x2e1b21385c26c926", "0x4d2c6dfc5ac42aed", "0x53380d139d95b3df", "0x650a73548baf63de", "0x766a0abb3c77b2a8", "0x81c2c92e47edaee6", "0x92722c851482353b", "0xa2bfe8a14cf10364", "0xa81a664bbc423001", "0xc24b8b70d0f89791", "0xc76c51a30654be30", "0xd192e819d6ef5218", "0xd69906245565a910", "0xf40e35855771202a", "0x106aa07032bbd1b8", "0x19a4c116b8d2d0c8", "0x1e376c085141ab53", "0x2748774cdf8eeb99", "0x34b0bcb5e19b48a8", "0x391c0cb3c5c95a63", "0x4ed8aa4ae3418acb", "0x5b9cca4f7763e373", "0x682e6ff3d6b2b8a3", "0x748f82ee5defb2fc", "0x78a5636f43172f60", "0x84c87814a1f0ab72", "0x8cc702081a6439ec", "0x90befffa23631e28", "0xa4506cebde82bde9", "0xbef9a3f7b2c67915", "0xc67178f2e372532b", "0xca273eceea26619c", "0xd186b8c721c0c207", "0xeada7dd6cde0eb1e", "0xf57d4f7fee6ed178", "0x06f067aa72176fba", "0x0a637dc5a2c898a6", "0x113f9804bef90dae", "0x1b710b35131c471b", "0x28db77f523047d84", "0x32caab7b40c72493", "0x3c9ebe0a15c9bebc", "0x431d67c49c100d4c", "0x4cc5d4becb3e42b6", "0x597f299cfc657e2a", "0x5fcb6fab3ad6faec", "0x6c44198c4a475817"].map((t) => BigInt(t))), AU = Bw[0], _U = Bw[1], Hs = new Uint32Array(80), qs = new Uint32Array(80);
let Sp = class extends $w {
  constructor(e = 64) {
    super(128, e, 16, !1), this.Ah = Ct[0] | 0, this.Al = Ct[1] | 0, this.Bh = Ct[2] | 0, this.Bl = Ct[3] | 0, this.Ch = Ct[4] | 0, this.Cl = Ct[5] | 0, this.Dh = Ct[6] | 0, this.Dl = Ct[7] | 0, this.Eh = Ct[8] | 0, this.El = Ct[9] | 0, this.Fh = Ct[10] | 0, this.Fl = Ct[11] | 0, this.Gh = Ct[12] | 0, this.Gl = Ct[13] | 0, this.Hh = Ct[14] | 0, this.Hl = Ct[15] | 0;
  }
  get() {
    const { Ah: e, Al: r, Bh: s, Bl: n, Ch: i, Cl: o, Dh: a, Dl: c, Eh: l, El: u, Fh: h, Fl: p, Gh: y, Gl: b, Hh: g, Hl: x } = this;
    return [e, r, s, n, i, o, a, c, l, u, h, p, y, b, g, x];
  }
  set(e, r, s, n, i, o, a, c, l, u, h, p, y, b, g, x) {
    this.Ah = e | 0, this.Al = r | 0, this.Bh = s | 0, this.Bl = n | 0, this.Ch = i | 0, this.Cl = o | 0, this.Dh = a | 0, this.Dl = c | 0, this.Eh = l | 0, this.El = u | 0, this.Fh = h | 0, this.Fl = p | 0, this.Gh = y | 0, this.Gl = b | 0, this.Hh = g | 0, this.Hl = x | 0;
  }
  process(e, r) {
    for (let A = 0; A < 16; A++, r += 4) Hs[A] = e.getUint32(r), qs[A] = e.getUint32(r += 4);
    for (let A = 16; A < 80; A++) {
      const M = Hs[A - 15] | 0, B = qs[A - 15] | 0, q = Xs(M, B, 1) ^ Xs(M, B, 8) ^ lb(M, B, 7), H = Ys(M, B, 1) ^ Ys(M, B, 8) ^ ub(M, B, 7), F = Hs[A - 2] | 0, w = qs[A - 2] | 0, T = Xs(F, w, 19) ^ So(F, w, 61) ^ lb(F, w, 6), k = Ys(F, w, 19) ^ Io(F, w, 61) ^ ub(F, w, 6), S = sU(H, k, qs[A - 7], qs[A - 16]), O = nU(S, q, T, Hs[A - 7], Hs[A - 16]);
      Hs[A] = O | 0, qs[A] = S | 0;
    }
    let { Ah: s, Al: n, Bh: i, Bl: o, Ch: a, Cl: c, Dh: l, Dl: u, Eh: h, El: p, Fh: y, Fl: b, Gh: g, Gl: x, Hh: I, Hl: U } = this;
    for (let A = 0; A < 80; A++) {
      const M = Xs(h, p, 14) ^ Xs(h, p, 18) ^ So(h, p, 41), B = Ys(h, p, 14) ^ Ys(h, p, 18) ^ Io(h, p, 41), q = h & y ^ ~h & g, H = p & b ^ ~p & x, F = iU(U, B, H, _U[A], qs[A]), w = oU(F, I, M, q, AU[A], Hs[A]), T = F | 0, k = Xs(s, n, 28) ^ So(s, n, 34) ^ So(s, n, 39), S = Ys(s, n, 28) ^ Io(s, n, 34) ^ Io(s, n, 39), O = s & i ^ s & a ^ i & a, N = n & o ^ n & c ^ o & c;
      I = g | 0, U = x | 0, g = y | 0, x = b | 0, y = h | 0, b = p | 0, { h, l: p } = $r(l | 0, u | 0, w | 0, T | 0), l = a | 0, u = c | 0, a = i | 0, c = o | 0, i = s | 0, o = n | 0;
      const _ = wp(T, S, N);
      s = Ep(_, w, k, O), n = _ | 0;
    }
    ({ h: s, l: n } = $r(this.Ah | 0, this.Al | 0, s | 0, n | 0)), { h: i, l: o } = $r(this.Bh | 0, this.Bl | 0, i | 0, o | 0), { h: a, l: c } = $r(this.Ch | 0, this.Cl | 0, a | 0, c | 0), { h: l, l: u } = $r(this.Dh | 0, this.Dl | 0, l | 0, u | 0), { h, l: p } = $r(this.Eh | 0, this.El | 0, h | 0, p | 0), { h: y, l: b } = $r(this.Fh | 0, this.Fl | 0, y | 0, b | 0), { h: g, l: x } = $r(this.Gh | 0, this.Gl | 0, g | 0, x | 0), { h: I, l: U } = $r(this.Hh | 0, this.Hl | 0, I | 0, U | 0), this.set(s, n, i, o, a, c, l, u, h, p, y, b, g, x, I, U);
  }
  roundClean() {
    gr(Hs, qs);
  }
  destroy() {
    gr(this.buffer), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}, TU = class extends Sp {
  constructor() {
    super(48), this.Ah = kt[0] | 0, this.Al = kt[1] | 0, this.Bh = kt[2] | 0, this.Bl = kt[3] | 0, this.Ch = kt[4] | 0, this.Cl = kt[5] | 0, this.Dh = kt[6] | 0, this.Dl = kt[7] | 0, this.Eh = kt[8] | 0, this.El = kt[9] | 0, this.Fh = kt[10] | 0, this.Fl = kt[11] | 0, this.Gh = kt[12] | 0, this.Gl = kt[13] | 0, this.Hh = kt[14] | 0, this.Hl = kt[15] | 0;
  }
};
const St = Uint32Array.from([573645204, 4230739756, 2673172387, 3360449730, 596883563, 1867755857, 2520282905, 1497426621, 2519219938, 2827943907, 3193839141, 1401305490, 721525244, 746961066, 246885852, 2177182882]);
class UU extends Sp {
  constructor() {
    super(32), this.Ah = St[0] | 0, this.Al = St[1] | 0, this.Bh = St[2] | 0, this.Bl = St[3] | 0, this.Ch = St[4] | 0, this.Cl = St[5] | 0, this.Dh = St[6] | 0, this.Dl = St[7] | 0, this.Eh = St[8] | 0, this.El = St[9] | 0, this.Fh = St[10] | 0, this.Fl = St[11] | 0, this.Gh = St[12] | 0, this.Gl = St[13] | 0, this.Hh = St[14] | 0, this.Hl = St[15] | 0;
  }
}
const Pl = va(() => new IU()), $U = va(() => new Sp()), BU = va(() => new TU()), DU = va(() => new UU()), OU = Uint8Array.from([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3, 11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1, 9, 4, 7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8, 9, 0, 5, 7, 2, 4, 10, 15, 14, 1, 11, 12, 6, 8, 3, 13, 2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5, 15, 14, 1, 9, 12, 5, 1, 15, 14, 13, 4, 10, 0, 7, 6, 3, 9, 2, 8, 11, 13, 11, 7, 14, 12, 1, 3, 9, 5, 0, 15, 4, 8, 6, 2, 10, 6, 15, 14, 9, 11, 3, 0, 8, 12, 2, 13, 7, 1, 4, 10, 5, 10, 2, 8, 4, 7, 6, 1, 5, 15, 11, 9, 14, 3, 12, 13, 0, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3, 11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1, 9, 4, 7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8, 9, 0, 5, 7, 2, 4, 10, 15, 14, 1, 11, 12, 6, 8, 3, 13, 2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5, 15, 14, 1, 9]), We = Uint32Array.from([4089235720, 1779033703, 2227873595, 3144134277, 4271175723, 1013904242, 1595750129, 2773480762, 2917565137, 1359893119, 725511199, 2600822924, 4215389547, 528734635, 327033209, 1541459225]), te = new Uint32Array(32);
function Ks(t, e, r, s, n, i) {
  const o = n[i], a = n[i + 1];
  let c = te[2 * t], l = te[2 * t + 1], u = te[2 * e], h = te[2 * e + 1], p = te[2 * r], y = te[2 * r + 1], b = te[2 * s], g = te[2 * s + 1], x = wp(c, u, o);
  l = Ep(x, l, h, a), c = x | 0, { Dh: g, Dl: b } = { Dh: g ^ l, Dl: b ^ c }, { Dh: g, Dl: b } = { Dh: XT(g, b), Dl: YT(g) }, { h: y, l: p } = $r(y, p, g, b), { Bh: h, Bl: u } = { Bh: h ^ y, Bl: u ^ p }, { Bh: h, Bl: u } = { Bh: Xs(h, u, 24), Bl: Ys(h, u, 24) }, te[2 * t] = c, te[2 * t + 1] = l, te[2 * e] = u, te[2 * e + 1] = h, te[2 * r] = p, te[2 * r + 1] = y, te[2 * s] = b, te[2 * s + 1] = g;
}
function Vs(t, e, r, s, n, i) {
  const o = n[i], a = n[i + 1];
  let c = te[2 * t], l = te[2 * t + 1], u = te[2 * e], h = te[2 * e + 1], p = te[2 * r], y = te[2 * r + 1], b = te[2 * s], g = te[2 * s + 1], x = wp(c, u, o);
  l = Ep(x, l, h, a), c = x | 0, { Dh: g, Dl: b } = { Dh: g ^ l, Dl: b ^ c }, { Dh: g, Dl: b } = { Dh: Xs(g, b, 16), Dl: Ys(g, b, 16) }, { h: y, l: p } = $r(y, p, g, b), { Bh: h, Bl: u } = { Bh: h ^ y, Bl: u ^ p }, { Bh: h, Bl: u } = { Bh: So(h, u, 63), Bl: Io(h, u, 63) }, te[2 * t] = c, te[2 * t + 1] = l, te[2 * e] = u, te[2 * e + 1] = h, te[2 * r] = p, te[2 * r + 1] = y, te[2 * s] = b, te[2 * s + 1] = g;
}
function PU(t, e = {}, r, s, n) {
  if (ks(r), t < 0 || t > r) throw new Error("outputLen bigger than keyLen");
  const { key: i, salt: o, personalization: a } = e;
  if (i !== void 0 && (i.length < 1 || i.length > r)) throw new Error("key length must be undefined or 1.." + r);
  if (o !== void 0 && o.length !== s) throw new Error("salt must be undefined or " + s);
  if (a !== void 0 && a.length !== n) throw new Error("personalization must be undefined or " + n);
}
class RU extends Ol {
  constructor(e, r) {
    super(), this.finished = !1, this.destroyed = !1, this.length = 0, this.pos = 0, ks(e), ks(r), this.blockLen = e, this.outputLen = r, this.buffer = new Uint8Array(e), this.buffer32 = Qo(this.buffer);
  }
  update(e) {
    ln(this), e = Nr(e), yr(e);
    const { blockLen: r, buffer: s, buffer32: n } = this, i = e.length, o = e.byteOffset, a = e.buffer;
    for (let c = 0; c < i; ) {
      this.pos === r && (Qs(n), this.compress(n, 0, !1), Qs(n), this.pos = 0);
      const l = Math.min(r - this.pos, i - c), u = o + c;
      if (l === r && !(u % 4) && c + l < i) {
        const h = new Uint32Array(a, u, Math.floor((i - c) / 4));
        Qs(h);
        for (let p = 0; c + r < i; p += n.length, c += r) this.length += r, this.compress(h, p, !1);
        Qs(h);
        continue;
      }
      s.set(e.subarray(c, c + l), this.pos), this.pos += l, this.length += l, c += l;
    }
    return this;
  }
  digestInto(e) {
    ln(this), kp(e, this);
    const { pos: r, buffer32: s } = this;
    this.finished = !0, gr(this.buffer.subarray(r)), Qs(s), this.compress(s, 0, !0), Qs(s);
    const n = Qo(e);
    this.get().forEach((i, o) => n[o] = ms(i));
  }
  digest() {
    const { buffer: e, outputLen: r } = this;
    this.digestInto(e);
    const s = e.slice(0, r);
    return this.destroy(), s;
  }
  _cloneInto(e) {
    const { buffer: r, length: s, finished: n, destroyed: i, outputLen: o, pos: a } = this;
    return e || (e = new this.constructor({ dkLen: o })), e.set(...this.get()), e.buffer.set(r), e.destroyed = i, e.finished = n, e.length = s, e.pos = a, e.outputLen = o, e;
  }
  clone() {
    return this._cloneInto();
  }
}
class NU extends RU {
  constructor(e = {}) {
    const r = e.dkLen === void 0 ? 64 : e.dkLen;
    super(128, r), this.v0l = We[0] | 0, this.v0h = We[1] | 0, this.v1l = We[2] | 0, this.v1h = We[3] | 0, this.v2l = We[4] | 0, this.v2h = We[5] | 0, this.v3l = We[6] | 0, this.v3h = We[7] | 0, this.v4l = We[8] | 0, this.v4h = We[9] | 0, this.v5l = We[10] | 0, this.v5h = We[11] | 0, this.v6l = We[12] | 0, this.v6h = We[13] | 0, this.v7l = We[14] | 0, this.v7h = We[15] | 0, PU(r, e, 64, 16, 16);
    let { key: s, personalization: n, salt: i } = e, o = 0;
    if (s !== void 0 && (s = Nr(s), o = s.length), this.v0l ^= this.outputLen | o << 8 | 65536 | 1 << 24, i !== void 0) {
      i = Nr(i);
      const a = Qo(i);
      this.v4l ^= ms(a[0]), this.v4h ^= ms(a[1]), this.v5l ^= ms(a[2]), this.v5h ^= ms(a[3]);
    }
    if (n !== void 0) {
      n = Nr(n);
      const a = Qo(n);
      this.v6l ^= ms(a[0]), this.v6h ^= ms(a[1]), this.v7l ^= ms(a[2]), this.v7h ^= ms(a[3]);
    }
    if (s !== void 0) {
      const a = new Uint8Array(this.blockLen);
      a.set(s), this.update(a);
    }
  }
  get() {
    let { v0l: e, v0h: r, v1l: s, v1h: n, v2l: i, v2h: o, v3l: a, v3h: c, v4l: l, v4h: u, v5l: h, v5h: p, v6l: y, v6h: b, v7l: g, v7h: x } = this;
    return [e, r, s, n, i, o, a, c, l, u, h, p, y, b, g, x];
  }
  set(e, r, s, n, i, o, a, c, l, u, h, p, y, b, g, x) {
    this.v0l = e | 0, this.v0h = r | 0, this.v1l = s | 0, this.v1h = n | 0, this.v2l = i | 0, this.v2h = o | 0, this.v3l = a | 0, this.v3h = c | 0, this.v4l = l | 0, this.v4h = u | 0, this.v5l = h | 0, this.v5h = p | 0, this.v6l = y | 0, this.v6h = b | 0, this.v7l = g | 0, this.v7h = x | 0;
  }
  compress(e, r, s) {
    this.get().forEach((c, l) => te[l] = c), te.set(We, 16);
    let { h: n, l: i } = xw(BigInt(this.length));
    te[24] = We[8] ^ i, te[25] = We[9] ^ n, s && (te[28] = ~te[28], te[29] = ~te[29]);
    let o = 0;
    const a = OU;
    for (let c = 0; c < 12; c++) Ks(0, 4, 8, 12, e, r + 2 * a[o++]), Vs(0, 4, 8, 12, e, r + 2 * a[o++]), Ks(1, 5, 9, 13, e, r + 2 * a[o++]), Vs(1, 5, 9, 13, e, r + 2 * a[o++]), Ks(2, 6, 10, 14, e, r + 2 * a[o++]), Vs(2, 6, 10, 14, e, r + 2 * a[o++]), Ks(3, 7, 11, 15, e, r + 2 * a[o++]), Vs(3, 7, 11, 15, e, r + 2 * a[o++]), Ks(0, 5, 10, 15, e, r + 2 * a[o++]), Vs(0, 5, 10, 15, e, r + 2 * a[o++]), Ks(1, 6, 11, 12, e, r + 2 * a[o++]), Vs(1, 6, 11, 12, e, r + 2 * a[o++]), Ks(2, 7, 8, 13, e, r + 2 * a[o++]), Vs(2, 7, 8, 13, e, r + 2 * a[o++]), Ks(3, 4, 9, 14, e, r + 2 * a[o++]), Vs(3, 4, 9, 14, e, r + 2 * a[o++]);
    this.v0l ^= te[0] ^ te[16], this.v0h ^= te[1] ^ te[17], this.v1l ^= te[2] ^ te[18], this.v1h ^= te[3] ^ te[19], this.v2l ^= te[4] ^ te[20], this.v2h ^= te[5] ^ te[21], this.v3l ^= te[6] ^ te[22], this.v3h ^= te[7] ^ te[23], this.v4l ^= te[8] ^ te[24], this.v4h ^= te[9] ^ te[25], this.v5l ^= te[10] ^ te[26], this.v5h ^= te[11] ^ te[27], this.v6l ^= te[12] ^ te[28], this.v6h ^= te[13] ^ te[29], this.v7l ^= te[14] ^ te[30], this.v7h ^= te[15] ^ te[31], gr(te);
  }
  destroy() {
    this.destroyed = !0, gr(this.buffer32), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const LU = uU((t) => new NU(t)), MU = "https://rpc.walletconnect.org/v1";
function Dw(t) {
  const e = `Ethereum Signed Message:
${t.length}`, r = new TextEncoder().encode(e + t);
  return "0x" + Buffer.from(xU(r)).toString("hex");
}
async function FU(t, e, r, s, n, i) {
  switch (r.t) {
    case "eip191":
      return await zU(t, e, r.s);
    case "eip1271":
      return await jU(t, e, r.s, s, n, i);
    default:
      throw new Error(`verifySignature failed: Attempted to verify CacaoSignature with unknown type: ${r.t}`);
  }
}
async function zU(t, e, r) {
  return (await J7({ hash: Dw(e), signature: r })).toLowerCase() === t.toLowerCase();
}
async function jU(t, e, r, s, n, i) {
  const o = Fc(s);
  if (!o.namespace || !o.reference) throw new Error(`isValidEip1271Signature failed: chainId must be in CAIP-2 format, received: ${s}`);
  try {
    const a = "0x1626ba7e", c = "0000000000000000000000000000000000000000000000000000000000000040", l = r.substring(2), u = (l.length / 2).toString(16).padStart(64, "0"), h = (e.startsWith("0x") ? e : Dw(e)).substring(2), p = a + h + c + u + l, y = await fetch(`${i || MU}/?chainId=${s}&projectId=${n}`, { headers: { "Content-Type": "application/json" }, method: "POST", body: JSON.stringify({ id: HU(), jsonrpc: "2.0", method: "eth_call", params: [{ to: t, data: p }, "latest"] }) }), { result: b } = await y.json();
    return b ? b.slice(0, a.length).toLowerCase() === a.toLowerCase() : !1;
  } catch (a) {
    return console.error("isValidEip1271Signature: ", a), !1;
  }
}
function HU() {
  return Date.now() + Math.floor(Math.random() * 1e3);
}
function qU(t) {
  const e = atob(t), r = new Uint8Array(e.length);
  for (let o = 0; o < e.length; o++) r[o] = e.charCodeAt(o);
  const s = r[0];
  if (s === 0) throw new Error("No signatures found");
  const n = 1 + s * 64;
  if (r.length < n) throw new Error("Transaction data too short for claimed signature count");
  if (r.length < 100) throw new Error("Transaction too short");
  const i = Buffer.from(t, "base64").slice(1, 65);
  return pa.encode(i);
}
function KU(t) {
  const e = new Uint8Array(Buffer.from(t, "base64")), r = Array.from("TransactionData::").map((i) => i.charCodeAt(0)), s = new Uint8Array(r.length + e.length);
  s.set(r), s.set(e, r.length);
  const n = LU(s, { dkLen: 32 });
  return pa.encode(n);
}
function fb(t) {
  const e = new Uint8Array(Pl(VU(t)));
  return pa.encode(e);
}
function VU(t) {
  if (t instanceof Uint8Array) return t;
  if (Array.isArray(t)) return new Uint8Array(t);
  if (typeof t == "object" && t != null && t.data) return new Uint8Array(Object.values(t.data));
  if (typeof t == "object" && t) return new Uint8Array(Object.values(t));
  throw new Error("getNearUint8ArrayFromBytes: Unexpected result type from bytes array");
}
function mb(t) {
  const e = Buffer.from(t, "base64"), r = jk(e).txn;
  if (!r) throw new Error("Invalid signed transaction: missing 'txn' field");
  const s = Dk(r), n = Buffer.from("TX"), i = Buffer.concat([n, Buffer.from(s)]), o = DU(i);
  return Jk.encode(o).replace(/=+$/, "");
}
function Uu(t) {
  const e = [];
  let r = BigInt(t);
  for (; r >= BigInt(128); ) e.push(Number(r & BigInt(127) | BigInt(128))), r >>= BigInt(7);
  return e.push(Number(r)), Buffer.from(e);
}
function GU(t) {
  const e = Buffer.from(t.signed.bodyBytes, "base64"), r = Buffer.from(t.signed.authInfoBytes, "base64"), s = Buffer.from(t.signature.signature, "base64"), n = [];
  n.push(Buffer.from([10])), n.push(Uu(e.length)), n.push(e), n.push(Buffer.from([18])), n.push(Uu(r.length)), n.push(r), n.push(Buffer.from([26])), n.push(Uu(s.length)), n.push(s);
  const i = Buffer.concat(n), o = Pl(i);
  return Buffer.from(o).toString("hex").toUpperCase();
}
var WU = Object.defineProperty, ZU = Object.defineProperties, JU = Object.getOwnPropertyDescriptors, bb = Object.getOwnPropertySymbols, XU = Object.prototype.hasOwnProperty, YU = Object.prototype.propertyIsEnumerable, yb = (t, e, r) => e in t ? WU(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, QU = (t, e) => {
  for (var r in e || (e = {})) XU.call(e, r) && yb(t, r, e[r]);
  if (bb) for (var r of bb(e)) YU.call(e, r) && yb(t, r, e[r]);
  return t;
}, e$ = (t, e) => ZU(t, JU(e));
const t$ = "did:pkh:", Ip = (t) => t == null ? void 0 : t.split(":"), r$ = (t) => {
  const e = t && Ip(t);
  if (e) return t.includes(t$) ? e[3] : e[1];
}, Qh = (t) => {
  const e = t && Ip(t);
  if (e) return e[2] + ":" + e[3];
}, ll = (t) => {
  const e = t && Ip(t);
  if (e) return e.pop();
};
async function gb(t) {
  const { cacao: e, projectId: r } = t, { s, p: n } = e, i = Ow(n, n.iss), o = ll(n.iss);
  return await FU(o, i, s, Qh(n.iss), r);
}
const Ow = (t, e) => {
  const r = `${t.domain} wants you to sign in with your Ethereum account:`, s = ll(e);
  if (!t.aud && !t.uri) throw new Error("Either `aud` or `uri` is required to construct the message");
  let n = t.statement || void 0;
  const i = `URI: ${t.aud || t.uri}`, o = `Version: ${t.version}`, a = `Chain ID: ${r$(e)}`, c = `Nonce: ${t.nonce}`, l = `Issued At: ${t.iat}`, u = t.exp ? `Expiration Time: ${t.exp}` : void 0, h = t.nbf ? `Not Before: ${t.nbf}` : void 0, p = t.requestId ? `Request ID: ${t.requestId}` : void 0, y = t.resources ? `Resources:${t.resources.map((g) => `
- ${g}`).join("")}` : void 0, b = zc(t.resources);
  if (b) {
    const g = ta(b);
    n = h$(n, g);
  }
  return [r, s, "", n, "", i, o, a, c, l, u, h, p, y].filter((g) => g != null).join(`
`);
};
function s$(t) {
  return Buffer.from(JSON.stringify(t)).toString("base64");
}
function n$(t) {
  return JSON.parse(Buffer.from(t, "base64").toString("utf-8"));
}
function Un(t) {
  if (!t) throw new Error("No recap provided, value is undefined");
  if (!t.att) throw new Error("No `att` property found");
  const e = Object.keys(t.att);
  if (!(e != null && e.length)) throw new Error("No resources found in `att` property");
  e.forEach((r) => {
    const s = t.att[r];
    if (Array.isArray(s)) throw new Error(`Resource must be an object: ${r}`);
    if (typeof s != "object") throw new Error(`Resource must be an object: ${r}`);
    if (!Object.keys(s).length) throw new Error(`Resource object is empty: ${r}`);
    Object.keys(s).forEach((n) => {
      const i = s[n];
      if (!Array.isArray(i)) throw new Error(`Ability limits ${n} must be an array of objects, found: ${i}`);
      if (!i.length) throw new Error(`Value of ${n} is empty array, must be an array with objects`);
      i.forEach((o) => {
        if (typeof o != "object") throw new Error(`Ability limits (${n}) must be an array of objects, found: ${o}`);
      });
    });
  });
}
function i$(t, e, r, s = {}) {
  return r == null || r.sort((n, i) => n.localeCompare(i)), { att: { [t]: o$(e, r, s) } };
}
function o$(t, e, r = {}) {
  e = e == null ? void 0 : e.sort((n, i) => n.localeCompare(i));
  const s = e.map((n) => ({ [`${t}/${n}`]: [r] }));
  return Object.assign({}, ...s);
}
function Pw(t) {
  return Un(t), `urn:recap:${s$(t).replace(/=/g, "")}`;
}
function ta(t) {
  const e = n$(t.replace("urn:recap:", ""));
  return Un(e), e;
}
function a$(t, e, r) {
  const s = i$(t, e, r);
  return Pw(s);
}
function c$(t) {
  return t && t.includes("urn:recap:");
}
function l$(t, e) {
  const r = ta(t), s = ta(e), n = u$(r, s);
  return Pw(n);
}
function u$(t, e) {
  Un(t), Un(e);
  const r = Object.keys(t.att).concat(Object.keys(e.att)).sort((n, i) => n.localeCompare(i)), s = { att: {} };
  return r.forEach((n) => {
    var i, o;
    Object.keys(((i = t.att) == null ? void 0 : i[n]) || {}).concat(Object.keys(((o = e.att) == null ? void 0 : o[n]) || {})).sort((a, c) => a.localeCompare(c)).forEach((a) => {
      var c, l;
      s.att[n] = e$(QU({}, s.att[n]), { [a]: ((c = t.att[n]) == null ? void 0 : c[a]) || ((l = e.att[n]) == null ? void 0 : l[a]) });
    });
  }), s;
}
function h$(t = "", e) {
  Un(e);
  const r = "I further authorize the stated URI to perform the following actions on my behalf: ";
  if (t.includes(r)) return t;
  const s = [];
  let n = 0;
  Object.keys(e.att).forEach((a) => {
    const c = Object.keys(e.att[a]).map((h) => ({ ability: h.split("/")[0], action: h.split("/")[1] }));
    c.sort((h, p) => h.action.localeCompare(p.action));
    const l = {};
    c.forEach((h) => {
      l[h.ability] || (l[h.ability] = []), l[h.ability].push(h.action);
    });
    const u = Object.keys(l).map((h) => (n++, `(${n}) '${h}': '${l[h].join("', '")}' for '${a}'.`));
    s.push(u.join(", ").replace(".,", "."));
  });
  const i = s.join(" "), o = `${r}${i}`;
  return `${t ? t + " " : ""}${o}`;
}
function wb(t) {
  var e;
  const r = ta(t);
  Un(r);
  const s = (e = r.att) == null ? void 0 : e.eip155;
  return s ? Object.keys(s).map((n) => n.split("/")[1]) : [];
}
function Eb(t) {
  const e = ta(t);
  Un(e);
  const r = [];
  return Object.values(e.att).forEach((s) => {
    Object.values(s).forEach((n) => {
      var i;
      (i = n == null ? void 0 : n[0]) != null && i.chains && r.push(n[0].chains);
    });
  }), [...new Set(r.flat())];
}
function zc(t) {
  if (!t) return;
  const e = t == null ? void 0 : t[t.length - 1];
  return c$(e) ? e : void 0;
}
/*! noble-ciphers - MIT License (c) 2023 Paul Miller (paulmillr.com) */
function Rw(t) {
  return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function ed(t) {
  if (typeof t != "boolean") throw new Error(`boolean expected, not ${t}`);
}
function $u(t) {
  if (!Number.isSafeInteger(t) || t < 0) throw new Error("positive integer expected, got " + t);
}
function qt(t, ...e) {
  if (!Rw(t)) throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(t.length)) throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function xb(t, e = !0) {
  if (t.destroyed) throw new Error("Hash instance has been destroyed");
  if (e && t.finished) throw new Error("Hash#digest() has already been called");
}
function d$(t, e) {
  qt(t);
  const r = e.outputLen;
  if (t.length < r) throw new Error("digestInto() expects output buffer of length at least " + r);
}
function nn(t) {
  return new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4));
}
function li(...t) {
  for (let e = 0; e < t.length; e++) t[e].fill(0);
}
function p$(t) {
  return new DataView(t.buffer, t.byteOffset, t.byteLength);
}
const f$ = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
function m$(t) {
  if (typeof t != "string") throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(t));
}
function td(t) {
  if (typeof t == "string") t = m$(t);
  else if (Rw(t)) t = rd(t);
  else throw new Error("Uint8Array expected, got " + typeof t);
  return t;
}
function b$(t, e) {
  if (e == null || typeof e != "object") throw new Error("options must be defined");
  return Object.assign(t, e);
}
function y$(t, e) {
  if (t.length !== e.length) return !1;
  let r = 0;
  for (let s = 0; s < t.length; s++) r |= t[s] ^ e[s];
  return r === 0;
}
const g$ = (t, e) => {
  function r(s, ...n) {
    if (qt(s), !f$) throw new Error("Non little-endian hardware is not yet supported");
    if (t.nonceLength !== void 0) {
      const l = n[0];
      if (!l) throw new Error("nonce / iv required");
      t.varSizeNonce ? qt(l) : qt(l, t.nonceLength);
    }
    const i = t.tagLength;
    i && n[1] !== void 0 && qt(n[1]);
    const o = e(s, ...n), a = (l, u) => {
      if (u !== void 0) {
        if (l !== 2) throw new Error("cipher output not supported");
        qt(u);
      }
    };
    let c = !1;
    return { encrypt(l, u) {
      if (c) throw new Error("cannot encrypt() twice with same key + nonce");
      return c = !0, qt(l), a(o.encrypt.length, u), o.encrypt(l, u);
    }, decrypt(l, u) {
      if (qt(l), i && l.length < i) throw new Error("invalid ciphertext length: smaller than tagLength=" + i);
      return a(o.decrypt.length, u), o.decrypt(l, u);
    } };
  }
  return Object.assign(r, t), r;
};
function vb(t, e, r = !0) {
  if (e === void 0) return new Uint8Array(t);
  if (e.length !== t) throw new Error("invalid output length, expected " + t + ", got: " + e.length);
  if (r && !E$(e)) throw new Error("invalid output, must be aligned");
  return e;
}
function kb(t, e, r, s) {
  if (typeof t.setBigUint64 == "function") return t.setBigUint64(e, r, s);
  const n = BigInt(32), i = BigInt(4294967295), o = Number(r >> n & i), a = Number(r & i);
  t.setUint32(e + 4, o, s), t.setUint32(e + 0, a, s);
}
function w$(t, e, r) {
  ed(r);
  const s = new Uint8Array(16), n = p$(s);
  return kb(n, 0, BigInt(e), r), kb(n, 8, BigInt(t), r), s;
}
function E$(t) {
  return t.byteOffset % 4 === 0;
}
function rd(t) {
  return Uint8Array.from(t);
}
const Nw = (t) => Uint8Array.from(t.split("").map((e) => e.charCodeAt(0))), x$ = Nw("expand 16-byte k"), v$ = Nw("expand 32-byte k"), k$ = nn(x$), C$ = nn(v$);
function ye(t, e) {
  return t << e | t >>> 32 - e;
}
function sd(t) {
  return t.byteOffset % 4 === 0;
}
const Xa = 64, S$ = 16, Lw = 2 ** 32 - 1, Cb = new Uint32Array();
function I$(t, e, r, s, n, i, o, a) {
  const c = n.length, l = new Uint8Array(Xa), u = nn(l), h = sd(n) && sd(i), p = h ? nn(n) : Cb, y = h ? nn(i) : Cb;
  for (let b = 0; b < c; o++) {
    if (t(e, r, s, u, o, a), o >= Lw) throw new Error("arx: counter overflow");
    const g = Math.min(Xa, c - b);
    if (h && g === Xa) {
      const x = b / 4;
      if (b % 4 !== 0) throw new Error("arx: invalid block position");
      for (let I = 0, U; I < S$; I++) U = x + I, y[U] = p[U] ^ u[I];
      b += Xa;
      continue;
    }
    for (let x = 0, I; x < g; x++) I = b + x, i[I] = n[I] ^ l[x];
    b += g;
  }
}
function A$(t, e) {
  const { allowShortKeys: r, extendNonceFn: s, counterLength: n, counterRight: i, rounds: o } = b$({ allowShortKeys: !1, counterLength: 8, counterRight: !1, rounds: 20 }, e);
  if (typeof t != "function") throw new Error("core must be a function");
  return $u(n), $u(o), ed(i), ed(r), (a, c, l, u, h = 0) => {
    qt(a), qt(c), qt(l);
    const p = l.length;
    if (u === void 0 && (u = new Uint8Array(p)), qt(u), $u(h), h < 0 || h >= Lw) throw new Error("arx: counter overflow");
    if (u.length < p) throw new Error(`arx: output (${u.length}) is shorter than data (${p})`);
    const y = [];
    let b = a.length, g, x;
    if (b === 32) y.push(g = rd(a)), x = C$;
    else if (b === 16 && r) g = new Uint8Array(32), g.set(a), g.set(a, 16), x = k$, y.push(g);
    else throw new Error(`arx: invalid 32-byte key, got length=${b}`);
    sd(c) || y.push(c = rd(c));
    const I = nn(g);
    if (s) {
      if (c.length !== 24) throw new Error("arx: extended nonce must be 24 bytes");
      s(x, I, nn(c.subarray(0, 16)), I), c = c.subarray(16);
    }
    const U = 16 - n;
    if (U !== c.length) throw new Error(`arx: nonce must be ${U} or 16 bytes`);
    if (U !== 12) {
      const M = new Uint8Array(12);
      M.set(c, i ? 0 : 12 - c.length), c = M, y.push(c);
    }
    const A = nn(c);
    return I$(t, x, I, A, l, u, h, o), li(...y), u;
  };
}
const ct = (t, e) => t[e++] & 255 | (t[e++] & 255) << 8;
class _$ {
  constructor(e) {
    this.blockLen = 16, this.outputLen = 16, this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.pos = 0, this.finished = !1, e = td(e), qt(e, 32);
    const r = ct(e, 0), s = ct(e, 2), n = ct(e, 4), i = ct(e, 6), o = ct(e, 8), a = ct(e, 10), c = ct(e, 12), l = ct(e, 14);
    this.r[0] = r & 8191, this.r[1] = (r >>> 13 | s << 3) & 8191, this.r[2] = (s >>> 10 | n << 6) & 7939, this.r[3] = (n >>> 7 | i << 9) & 8191, this.r[4] = (i >>> 4 | o << 12) & 255, this.r[5] = o >>> 1 & 8190, this.r[6] = (o >>> 14 | a << 2) & 8191, this.r[7] = (a >>> 11 | c << 5) & 8065, this.r[8] = (c >>> 8 | l << 8) & 8191, this.r[9] = l >>> 5 & 127;
    for (let u = 0; u < 8; u++) this.pad[u] = ct(e, 16 + 2 * u);
  }
  process(e, r, s = !1) {
    const n = s ? 0 : 2048, { h: i, r: o } = this, a = o[0], c = o[1], l = o[2], u = o[3], h = o[4], p = o[5], y = o[6], b = o[7], g = o[8], x = o[9], I = ct(e, r + 0), U = ct(e, r + 2), A = ct(e, r + 4), M = ct(e, r + 6), B = ct(e, r + 8), q = ct(e, r + 10), H = ct(e, r + 12), F = ct(e, r + 14);
    let w = i[0] + (I & 8191), T = i[1] + ((I >>> 13 | U << 3) & 8191), k = i[2] + ((U >>> 10 | A << 6) & 8191), S = i[3] + ((A >>> 7 | M << 9) & 8191), O = i[4] + ((M >>> 4 | B << 12) & 8191), N = i[5] + (B >>> 1 & 8191), _ = i[6] + ((B >>> 14 | q << 2) & 8191), C = i[7] + ((q >>> 11 | H << 5) & 8191), $ = i[8] + ((H >>> 8 | F << 8) & 8191), P = i[9] + (F >>> 5 | n), D = 0, z = D + w * a + T * (5 * x) + k * (5 * g) + S * (5 * b) + O * (5 * y);
    D = z >>> 13, z &= 8191, z += N * (5 * p) + _ * (5 * h) + C * (5 * u) + $ * (5 * l) + P * (5 * c), D += z >>> 13, z &= 8191;
    let L = D + w * c + T * a + k * (5 * x) + S * (5 * g) + O * (5 * b);
    D = L >>> 13, L &= 8191, L += N * (5 * y) + _ * (5 * p) + C * (5 * h) + $ * (5 * u) + P * (5 * l), D += L >>> 13, L &= 8191;
    let K = D + w * l + T * c + k * a + S * (5 * x) + O * (5 * g);
    D = K >>> 13, K &= 8191, K += N * (5 * b) + _ * (5 * y) + C * (5 * p) + $ * (5 * h) + P * (5 * u), D += K >>> 13, K &= 8191;
    let J = D + w * u + T * l + k * c + S * a + O * (5 * x);
    D = J >>> 13, J &= 8191, J += N * (5 * g) + _ * (5 * b) + C * (5 * y) + $ * (5 * p) + P * (5 * h), D += J >>> 13, J &= 8191;
    let X = D + w * h + T * u + k * l + S * c + O * a;
    D = X >>> 13, X &= 8191, X += N * (5 * x) + _ * (5 * g) + C * (5 * b) + $ * (5 * y) + P * (5 * p), D += X >>> 13, X &= 8191;
    let Y = D + w * p + T * h + k * u + S * l + O * c;
    D = Y >>> 13, Y &= 8191, Y += N * a + _ * (5 * x) + C * (5 * g) + $ * (5 * b) + P * (5 * y), D += Y >>> 13, Y &= 8191;
    let re = D + w * y + T * p + k * h + S * u + O * l;
    D = re >>> 13, re &= 8191, re += N * c + _ * a + C * (5 * x) + $ * (5 * g) + P * (5 * b), D += re >>> 13, re &= 8191;
    let ae = D + w * b + T * y + k * p + S * h + O * u;
    D = ae >>> 13, ae &= 8191, ae += N * l + _ * c + C * a + $ * (5 * x) + P * (5 * g), D += ae >>> 13, ae &= 8191;
    let ne = D + w * g + T * b + k * y + S * p + O * h;
    D = ne >>> 13, ne &= 8191, ne += N * u + _ * l + C * c + $ * a + P * (5 * x), D += ne >>> 13, ne &= 8191;
    let se = D + w * x + T * g + k * b + S * y + O * p;
    D = se >>> 13, se &= 8191, se += N * h + _ * u + C * l + $ * c + P * a, D += se >>> 13, se &= 8191, D = (D << 2) + D | 0, D = D + z | 0, z = D & 8191, D = D >>> 13, L += D, i[0] = z, i[1] = L, i[2] = K, i[3] = J, i[4] = X, i[5] = Y, i[6] = re, i[7] = ae, i[8] = ne, i[9] = se;
  }
  finalize() {
    const { h: e, pad: r } = this, s = new Uint16Array(10);
    let n = e[1] >>> 13;
    e[1] &= 8191;
    for (let a = 2; a < 10; a++) e[a] += n, n = e[a] >>> 13, e[a] &= 8191;
    e[0] += n * 5, n = e[0] >>> 13, e[0] &= 8191, e[1] += n, n = e[1] >>> 13, e[1] &= 8191, e[2] += n, s[0] = e[0] + 5, n = s[0] >>> 13, s[0] &= 8191;
    for (let a = 1; a < 10; a++) s[a] = e[a] + n, n = s[a] >>> 13, s[a] &= 8191;
    s[9] -= 8192;
    let i = (n ^ 1) - 1;
    for (let a = 0; a < 10; a++) s[a] &= i;
    i = ~i;
    for (let a = 0; a < 10; a++) e[a] = e[a] & i | s[a];
    e[0] = (e[0] | e[1] << 13) & 65535, e[1] = (e[1] >>> 3 | e[2] << 10) & 65535, e[2] = (e[2] >>> 6 | e[3] << 7) & 65535, e[3] = (e[3] >>> 9 | e[4] << 4) & 65535, e[4] = (e[4] >>> 12 | e[5] << 1 | e[6] << 14) & 65535, e[5] = (e[6] >>> 2 | e[7] << 11) & 65535, e[6] = (e[7] >>> 5 | e[8] << 8) & 65535, e[7] = (e[8] >>> 8 | e[9] << 5) & 65535;
    let o = e[0] + r[0];
    e[0] = o & 65535;
    for (let a = 1; a < 8; a++) o = (e[a] + r[a] | 0) + (o >>> 16) | 0, e[a] = o & 65535;
    li(s);
  }
  update(e) {
    xb(this), e = td(e), qt(e);
    const { buffer: r, blockLen: s } = this, n = e.length;
    for (let i = 0; i < n; ) {
      const o = Math.min(s - this.pos, n - i);
      if (o === s) {
        for (; s <= n - i; i += s) this.process(e, i);
        continue;
      }
      r.set(e.subarray(i, i + o), this.pos), this.pos += o, i += o, this.pos === s && (this.process(r, 0, !1), this.pos = 0);
    }
    return this;
  }
  destroy() {
    li(this.h, this.r, this.buffer, this.pad);
  }
  digestInto(e) {
    xb(this), d$(e, this), this.finished = !0;
    const { buffer: r, h: s } = this;
    let { pos: n } = this;
    if (n) {
      for (r[n++] = 1; n < 16; n++) r[n] = 0;
      this.process(r, 0, !0);
    }
    this.finalize();
    let i = 0;
    for (let o = 0; o < 8; o++) e[i++] = s[o] >>> 0, e[i++] = s[o] >>> 8;
    return e;
  }
  digest() {
    const { buffer: e, outputLen: r } = this;
    this.digestInto(e);
    const s = e.slice(0, r);
    return this.destroy(), s;
  }
}
function T$(t) {
  const e = (s, n) => t(n).update(td(s)).digest(), r = t(new Uint8Array(32));
  return e.outputLen = r.outputLen, e.blockLen = r.blockLen, e.create = (s) => t(s), e;
}
const U$ = T$((t) => new _$(t));
function $$(t, e, r, s, n, i = 20) {
  let o = t[0], a = t[1], c = t[2], l = t[3], u = e[0], h = e[1], p = e[2], y = e[3], b = e[4], g = e[5], x = e[6], I = e[7], U = n, A = r[0], M = r[1], B = r[2], q = o, H = a, F = c, w = l, T = u, k = h, S = p, O = y, N = b, _ = g, C = x, $ = I, P = U, D = A, z = M, L = B;
  for (let J = 0; J < i; J += 2) q = q + T | 0, P = ye(P ^ q, 16), N = N + P | 0, T = ye(T ^ N, 12), q = q + T | 0, P = ye(P ^ q, 8), N = N + P | 0, T = ye(T ^ N, 7), H = H + k | 0, D = ye(D ^ H, 16), _ = _ + D | 0, k = ye(k ^ _, 12), H = H + k | 0, D = ye(D ^ H, 8), _ = _ + D | 0, k = ye(k ^ _, 7), F = F + S | 0, z = ye(z ^ F, 16), C = C + z | 0, S = ye(S ^ C, 12), F = F + S | 0, z = ye(z ^ F, 8), C = C + z | 0, S = ye(S ^ C, 7), w = w + O | 0, L = ye(L ^ w, 16), $ = $ + L | 0, O = ye(O ^ $, 12), w = w + O | 0, L = ye(L ^ w, 8), $ = $ + L | 0, O = ye(O ^ $, 7), q = q + k | 0, L = ye(L ^ q, 16), C = C + L | 0, k = ye(k ^ C, 12), q = q + k | 0, L = ye(L ^ q, 8), C = C + L | 0, k = ye(k ^ C, 7), H = H + S | 0, P = ye(P ^ H, 16), $ = $ + P | 0, S = ye(S ^ $, 12), H = H + S | 0, P = ye(P ^ H, 8), $ = $ + P | 0, S = ye(S ^ $, 7), F = F + O | 0, D = ye(D ^ F, 16), N = N + D | 0, O = ye(O ^ N, 12), F = F + O | 0, D = ye(D ^ F, 8), N = N + D | 0, O = ye(O ^ N, 7), w = w + T | 0, z = ye(z ^ w, 16), _ = _ + z | 0, T = ye(T ^ _, 12), w = w + T | 0, z = ye(z ^ w, 8), _ = _ + z | 0, T = ye(T ^ _, 7);
  let K = 0;
  s[K++] = o + q | 0, s[K++] = a + H | 0, s[K++] = c + F | 0, s[K++] = l + w | 0, s[K++] = u + T | 0, s[K++] = h + k | 0, s[K++] = p + S | 0, s[K++] = y + O | 0, s[K++] = b + N | 0, s[K++] = g + _ | 0, s[K++] = x + C | 0, s[K++] = I + $ | 0, s[K++] = U + P | 0, s[K++] = A + D | 0, s[K++] = M + z | 0, s[K++] = B + L | 0;
}
const B$ = A$($$, { counterRight: !1, counterLength: 4, allowShortKeys: !1 }), D$ = new Uint8Array(16), Sb = (t, e) => {
  t.update(e);
  const r = e.length % 16;
  r && t.update(D$.subarray(r));
}, O$ = new Uint8Array(32);
function Ib(t, e, r, s, n) {
  const i = t(e, r, O$), o = U$.create(i);
  n && Sb(o, n), Sb(o, s);
  const a = w$(s.length, n ? n.length : 0, !0);
  o.update(a);
  const c = o.digest();
  return li(i, a), c;
}
const P$ = (t) => (e, r, s) => ({ encrypt(n, i) {
  const o = n.length;
  i = vb(o + 16, i, !1), i.set(n);
  const a = i.subarray(0, -16);
  t(e, r, a, a, 1);
  const c = Ib(t, e, r, a, s);
  return i.set(c, o), li(c), i;
}, decrypt(n, i) {
  i = vb(n.length - 16, i, !1);
  const o = n.subarray(0, -16), a = n.subarray(-16), c = Ib(t, e, r, o, s);
  if (!y$(a, c)) throw new Error("invalid tag");
  return i.set(n.subarray(0, -16)), t(e, r, i, i, 1), li(c), i;
} }), Mw = g$({ blockSize: 64, nonceLength: 12, tagLength: 16 }, P$(B$));
let Fw = class extends Ol {
  constructor(e, r) {
    super(), this.finished = !1, this.destroyed = !1, vp(e);
    const s = Nr(r);
    if (this.iHash = e.create(), typeof this.iHash.update != "function") throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const n = this.blockLen, i = new Uint8Array(n);
    i.set(s.length > n ? e.create().update(s).digest() : s);
    for (let o = 0; o < i.length; o++) i[o] ^= 54;
    this.iHash.update(i), this.oHash = e.create();
    for (let o = 0; o < i.length; o++) i[o] ^= 106;
    this.oHash.update(i), gr(i);
  }
  update(e) {
    return ln(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    ln(this), yr(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: r, iHash: s, finished: n, destroyed: i, blockLen: o, outputLen: a } = this;
    return e = e, e.finished = n, e.destroyed = i, e.blockLen = o, e.outputLen = a, e.oHash = r._cloneInto(e.oHash), e.iHash = s._cloneInto(e.iHash), e;
  }
  clone() {
    return this._cloneInto();
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
};
const Rl = (t, e, r) => new Fw(t, e).update(r).digest();
Rl.create = (t, e) => new Fw(t, e);
function R$(t, e, r) {
  return vp(t), r === void 0 && (r = new Uint8Array(t.outputLen)), Rl(t, Nr(r), Nr(e));
}
const Bu = Uint8Array.from([0]), Ab = Uint8Array.of();
function N$(t, e, r, s = 32) {
  vp(t), ks(s);
  const n = t.outputLen;
  if (s > 255 * n) throw new Error("Length should be <= 255*HashLen");
  const i = Math.ceil(s / n);
  r === void 0 && (r = Ab);
  const o = new Uint8Array(i * n), a = Rl.create(t, e), c = a._cloneInto(), l = new Uint8Array(a.outputLen);
  for (let u = 0; u < i; u++) Bu[0] = u + 1, c.update(u === 0 ? Ab : l).update(r).update(Bu).digestInto(l), o.set(l, n * u), a._cloneInto(c);
  return a.destroy(), c.destroy(), gr(l, Bu), o.slice(0, s);
}
const L$ = (t, e, r, s, n) => N$(t, R$(t, e, r), s, n), Nl = Pl, Ap = BigInt(0), nd = BigInt(1);
function ul(t, e) {
  if (typeof e != "boolean") throw new Error(t + " boolean expected, got " + e);
}
function Ya(t) {
  const e = t.toString(16);
  return e.length & 1 ? "0" + e : e;
}
function zw(t) {
  if (typeof t != "string") throw new Error("hex string expected, got " + typeof t);
  return t === "" ? Ap : BigInt("0x" + t);
}
function Ll(t) {
  return zw(ea(t));
}
function hl(t) {
  return yr(t), zw(ea(Uint8Array.from(t).reverse()));
}
function _p(t, e) {
  return Cp(t.toString(16).padStart(e * 2, "0"));
}
function Tp(t, e) {
  return _p(t, e).reverse();
}
function zt(t, e, r) {
  let s;
  if (typeof e == "string") try {
    s = Cp(e);
  } catch (i) {
    throw new Error(t + " must be hex string or Uint8Array, cause: " + i);
  }
  else if (xp(e)) s = Uint8Array.from(e);
  else throw new Error(t + " must be hex string or Uint8Array");
  const n = s.length;
  if (typeof r == "number" && n !== r) throw new Error(t + " of length " + r + " expected, got " + n);
  return s;
}
const Du = (t) => typeof t == "bigint" && Ap <= t;
function M$(t, e, r) {
  return Du(t) && Du(e) && Du(r) && e <= t && t < r;
}
function id(t, e, r, s) {
  if (!M$(e, r, s)) throw new Error("expected valid " + t + ": " + r + " <= n < " + s + ", got " + e);
}
function F$(t) {
  let e;
  for (e = 0; t > Ap; t >>= nd, e += 1) ;
  return e;
}
const Ml = (t) => (nd << BigInt(t)) - nd;
function z$(t, e, r) {
  if (typeof t != "number" || t < 2) throw new Error("hashLen must be a number");
  if (typeof e != "number" || e < 2) throw new Error("qByteLen must be a number");
  if (typeof r != "function") throw new Error("hmacFn must be a function");
  const s = (p) => new Uint8Array(p), n = (p) => Uint8Array.of(p);
  let i = s(t), o = s(t), a = 0;
  const c = () => {
    i.fill(1), o.fill(0), a = 0;
  }, l = (...p) => r(o, i, ...p), u = (p = s(0)) => {
    o = l(n(0), p), i = l(), p.length !== 0 && (o = l(n(1), p), i = l());
  }, h = () => {
    if (a++ >= 1e3) throw new Error("drbg: tried 1000 values");
    let p = 0;
    const y = [];
    for (; p < e; ) {
      i = l();
      const b = i.slice();
      y.push(b), p += i.length;
    }
    return kn(...y);
  };
  return (p, y) => {
    c(), u(p);
    let b;
    for (; !(b = y(h())); ) u();
    return c(), b;
  };
}
function Fl(t, e, r = {}) {
  if (!t || typeof t != "object") throw new Error("expected valid options object");
  function s(n, i, o) {
    const a = t[n];
    if (o && a === void 0) return;
    const c = typeof a;
    if (c !== i || a === null) throw new Error(`param "${n}" is invalid: expected ${i}, got ${c}`);
  }
  Object.entries(e).forEach(([n, i]) => s(n, i, !1)), Object.entries(r).forEach(([n, i]) => s(n, i, !0));
}
function _b(t) {
  const e = /* @__PURE__ */ new WeakMap();
  return (r, ...s) => {
    const n = e.get(r);
    if (n !== void 0) return n;
    const i = t(r, ...s);
    return e.set(r, i), i;
  };
}
const Vt = BigInt(0), Bt = BigInt(1), Cn = BigInt(2), j$ = BigInt(3), jw = BigInt(4), Hw = BigInt(5), qw = BigInt(8);
function pr(t, e) {
  const r = t % e;
  return r >= Vt ? r : e + r;
}
function Tr(t, e, r) {
  let s = t;
  for (; e-- > Vt; ) s *= s, s %= r;
  return s;
}
function Tb(t, e) {
  if (t === Vt) throw new Error("invert: expected non-zero number");
  if (e <= Vt) throw new Error("invert: expected positive modulus, got " + e);
  let r = pr(t, e), s = e, n = Vt, i = Bt;
  for (; r !== Vt; ) {
    const o = s / r, a = s % r, c = n - i * o;
    s = r, r = a, n = i, i = c;
  }
  if (s !== Bt) throw new Error("invert: does not exist");
  return pr(n, e);
}
function Kw(t, e) {
  const r = (t.ORDER + Bt) / jw, s = t.pow(e, r);
  if (!t.eql(t.sqr(s), e)) throw new Error("Cannot find square root");
  return s;
}
function H$(t, e) {
  const r = (t.ORDER - Hw) / qw, s = t.mul(e, Cn), n = t.pow(s, r), i = t.mul(e, n), o = t.mul(t.mul(i, Cn), n), a = t.mul(i, t.sub(o, t.ONE));
  if (!t.eql(t.sqr(a), e)) throw new Error("Cannot find square root");
  return a;
}
function q$(t) {
  if (t < BigInt(3)) throw new Error("sqrt is not defined for small field");
  let e = t - Bt, r = 0;
  for (; e % Cn === Vt; ) e /= Cn, r++;
  let s = Cn;
  const n = Ii(t);
  for (; Ub(n, s) === 1; ) if (s++ > 1e3) throw new Error("Cannot find square root: probably non-prime P");
  if (r === 1) return Kw;
  let i = n.pow(s, e);
  const o = (e + Bt) / Cn;
  return function(a, c) {
    if (a.is0(c)) return c;
    if (Ub(a, c) !== 1) throw new Error("Cannot find square root");
    let l = r, u = a.mul(a.ONE, i), h = a.pow(c, e), p = a.pow(c, o);
    for (; !a.eql(h, a.ONE); ) {
      if (a.is0(h)) return a.ZERO;
      let y = 1, b = a.sqr(h);
      for (; !a.eql(b, a.ONE); ) if (y++, b = a.sqr(b), y === l) throw new Error("Cannot find square root");
      const g = Bt << BigInt(l - y - 1), x = a.pow(u, g);
      l = y, u = a.sqr(x), h = a.mul(h, u), p = a.mul(p, x);
    }
    return p;
  };
}
function K$(t) {
  return t % jw === j$ ? Kw : t % qw === Hw ? H$ : q$(t);
}
const V$ = ["create", "isValid", "is0", "neg", "inv", "sqrt", "sqr", "eql", "add", "sub", "mul", "pow", "div", "addN", "subN", "mulN", "sqrN"];
function G$(t) {
  const e = { ORDER: "bigint", MASK: "bigint", BYTES: "number", BITS: "number" }, r = V$.reduce((s, n) => (s[n] = "function", s), e);
  return Fl(t, r), t;
}
function W$(t, e, r) {
  if (r < Vt) throw new Error("invalid exponent, negatives unsupported");
  if (r === Vt) return t.ONE;
  if (r === Bt) return e;
  let s = t.ONE, n = e;
  for (; r > Vt; ) r & Bt && (s = t.mul(s, n)), n = t.sqr(n), r >>= Bt;
  return s;
}
function Vw(t, e, r = !1) {
  const s = new Array(e.length).fill(r ? t.ZERO : void 0), n = e.reduce((o, a, c) => t.is0(a) ? o : (s[c] = o, t.mul(o, a)), t.ONE), i = t.inv(n);
  return e.reduceRight((o, a, c) => t.is0(a) ? o : (s[c] = t.mul(o, s[c]), t.mul(o, a)), i), s;
}
function Ub(t, e) {
  const r = (t.ORDER - Bt) / Cn, s = t.pow(e, r), n = t.eql(s, t.ONE), i = t.eql(s, t.ZERO), o = t.eql(s, t.neg(t.ONE));
  if (!n && !i && !o) throw new Error("invalid Legendre symbol result");
  return n ? 1 : i ? 0 : -1;
}
function Z$(t, e) {
  e !== void 0 && ks(e);
  const r = e !== void 0 ? e : t.toString(2).length, s = Math.ceil(r / 8);
  return { nBitLength: r, nByteLength: s };
}
function Ii(t, e, r = !1, s = {}) {
  if (t <= Vt) throw new Error("invalid field: expected ORDER > 0, got " + t);
  let n, i;
  if (typeof e == "object" && e != null) {
    if (s.sqrt || r) throw new Error("cannot specify opts in two arguments");
    const u = e;
    u.BITS && (n = u.BITS), u.sqrt && (i = u.sqrt), typeof u.isLE == "boolean" && (r = u.isLE);
  } else typeof e == "number" && (n = e), s.sqrt && (i = s.sqrt);
  const { nBitLength: o, nByteLength: a } = Z$(t, n);
  if (a > 2048) throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let c;
  const l = Object.freeze({ ORDER: t, isLE: r, BITS: o, BYTES: a, MASK: Ml(o), ZERO: Vt, ONE: Bt, create: (u) => pr(u, t), isValid: (u) => {
    if (typeof u != "bigint") throw new Error("invalid field element: expected bigint, got " + typeof u);
    return Vt <= u && u < t;
  }, is0: (u) => u === Vt, isValidNot0: (u) => !l.is0(u) && l.isValid(u), isOdd: (u) => (u & Bt) === Bt, neg: (u) => pr(-u, t), eql: (u, h) => u === h, sqr: (u) => pr(u * u, t), add: (u, h) => pr(u + h, t), sub: (u, h) => pr(u - h, t), mul: (u, h) => pr(u * h, t), pow: (u, h) => W$(l, u, h), div: (u, h) => pr(u * Tb(h, t), t), sqrN: (u) => u * u, addN: (u, h) => u + h, subN: (u, h) => u - h, mulN: (u, h) => u * h, inv: (u) => Tb(u, t), sqrt: i || ((u) => (c || (c = K$(t)), c(l, u))), toBytes: (u) => r ? Tp(u, a) : _p(u, a), fromBytes: (u) => {
    if (u.length !== a) throw new Error("Field.fromBytes: expected " + a + " bytes, got " + u.length);
    return r ? hl(u) : Ll(u);
  }, invertBatch: (u) => Vw(l, u), cmov: (u, h, p) => p ? h : u });
  return Object.freeze(l);
}
function Gw(t) {
  if (typeof t != "bigint") throw new Error("field order must be bigint");
  const e = t.toString(2).length;
  return Math.ceil(e / 8);
}
function Ww(t) {
  const e = Gw(t);
  return e + Math.ceil(e / 2);
}
function J$(t, e, r = !1) {
  const s = t.length, n = Gw(e), i = Ww(e);
  if (s < 16 || s < i || s > 1024) throw new Error("expected " + i + "-1024 bytes of input, got " + s);
  const o = r ? hl(t) : Ll(t), a = pr(o, e - Bt) + Bt;
  return r ? Tp(a, n) : _p(a, n);
}
const ui = BigInt(0), Sn = BigInt(1);
function Lo(t, e) {
  const r = e.negate();
  return t ? r : e;
}
function X$(t, e, r) {
  const s = (i) => i.pz, n = Vw(t.Fp, r.map(s));
  return r.map((i, o) => i.toAffine(n[o])).map(t.fromAffine);
}
function Zw(t, e) {
  if (!Number.isSafeInteger(t) || t <= 0 || t > e) throw new Error("invalid window size, expected [1.." + e + "], got W=" + t);
}
function Ou(t, e) {
  Zw(t, e);
  const r = Math.ceil(e / t) + 1, s = 2 ** (t - 1), n = 2 ** t, i = Ml(t), o = BigInt(t);
  return { windows: r, windowSize: s, mask: i, maxNumber: n, shiftBy: o };
}
function $b(t, e, r) {
  const { windowSize: s, mask: n, maxNumber: i, shiftBy: o } = r;
  let a = Number(t & n), c = t >> o;
  a > s && (a -= i, c += Sn);
  const l = e * s, u = l + Math.abs(a) - 1, h = a === 0, p = a < 0, y = e % 2 !== 0;
  return { nextN: c, offset: u, isZero: h, isNeg: p, isNegF: y, offsetF: l };
}
function Y$(t, e) {
  if (!Array.isArray(t)) throw new Error("array expected");
  t.forEach((r, s) => {
    if (!(r instanceof e)) throw new Error("invalid point at index " + s);
  });
}
function Q$(t, e) {
  if (!Array.isArray(t)) throw new Error("array of scalars expected");
  t.forEach((r, s) => {
    if (!e.isValid(r)) throw new Error("invalid scalar at index " + s);
  });
}
const Pu = /* @__PURE__ */ new WeakMap(), Jw = /* @__PURE__ */ new WeakMap();
function Ru(t) {
  return Jw.get(t) || 1;
}
function Bb(t) {
  if (t !== ui) throw new Error("invalid wNAF");
}
function eB(t, e) {
  return { constTimeNegate: Lo, hasPrecomputes(r) {
    return Ru(r) !== 1;
  }, unsafeLadder(r, s, n = t.ZERO) {
    let i = r;
    for (; s > ui; ) s & Sn && (n = n.add(i)), i = i.double(), s >>= Sn;
    return n;
  }, precomputeWindow(r, s) {
    const { windows: n, windowSize: i } = Ou(s, e), o = [];
    let a = r, c = a;
    for (let l = 0; l < n; l++) {
      c = a, o.push(c);
      for (let u = 1; u < i; u++) c = c.add(a), o.push(c);
      a = c.double();
    }
    return o;
  }, wNAF(r, s, n) {
    let i = t.ZERO, o = t.BASE;
    const a = Ou(r, e);
    for (let c = 0; c < a.windows; c++) {
      const { nextN: l, offset: u, isZero: h, isNeg: p, isNegF: y, offsetF: b } = $b(n, c, a);
      n = l, h ? o = o.add(Lo(y, s[b])) : i = i.add(Lo(p, s[u]));
    }
    return Bb(n), { p: i, f: o };
  }, wNAFUnsafe(r, s, n, i = t.ZERO) {
    const o = Ou(r, e);
    for (let a = 0; a < o.windows && n !== ui; a++) {
      const { nextN: c, offset: l, isZero: u, isNeg: h } = $b(n, a, o);
      if (n = c, !u) {
        const p = s[l];
        i = i.add(h ? p.negate() : p);
      }
    }
    return Bb(n), i;
  }, getPrecomputes(r, s, n) {
    let i = Pu.get(s);
    return i || (i = this.precomputeWindow(s, r), r !== 1 && (typeof n == "function" && (i = n(i)), Pu.set(s, i))), i;
  }, wNAFCached(r, s, n) {
    const i = Ru(r);
    return this.wNAF(i, this.getPrecomputes(i, r, n), s);
  }, wNAFCachedUnsafe(r, s, n, i) {
    const o = Ru(r);
    return o === 1 ? this.unsafeLadder(r, s, i) : this.wNAFUnsafe(o, this.getPrecomputes(o, r, n), s, i);
  }, setWindowSize(r, s) {
    Zw(s, e), Jw.set(r, s), Pu.delete(r);
  } };
}
function tB(t, e, r, s) {
  let n = e, i = t.ZERO, o = t.ZERO;
  for (; r > ui || s > ui; ) r & Sn && (i = i.add(n)), s & Sn && (o = o.add(n)), n = n.double(), r >>= Sn, s >>= Sn;
  return { p1: i, p2: o };
}
function rB(t, e, r, s) {
  Y$(r, t), Q$(s, e);
  const n = r.length, i = s.length;
  if (n !== i) throw new Error("arrays of points and scalars must have equal length");
  const o = t.ZERO, a = F$(BigInt(n));
  let c = 1;
  a > 12 ? c = a - 3 : a > 4 ? c = a - 2 : a > 0 && (c = 2);
  const l = Ml(c), u = new Array(Number(l) + 1).fill(o), h = Math.floor((e.BITS - 1) / c) * c;
  let p = o;
  for (let y = h; y >= 0; y -= c) {
    u.fill(o);
    for (let g = 0; g < i; g++) {
      const x = s[g], I = Number(x >> BigInt(y) & l);
      u[I] = u[I].add(r[g]);
    }
    let b = o;
    for (let g = u.length - 1, x = o; g > 0; g--) x = x.add(u[g]), b = b.add(x);
    if (p = p.add(b), y !== 0) for (let g = 0; g < c; g++) p = p.double();
  }
  return p;
}
function Db(t, e) {
  if (e) {
    if (e.ORDER !== t) throw new Error("Field.ORDER must match order: Fp == p, Fn == n");
    return G$(e), e;
  } else return Ii(t);
}
function sB(t, e, r = {}) {
  if (!e || typeof e != "object") throw new Error(`expected valid ${t} CURVE object`);
  for (const o of ["p", "n", "h"]) {
    const a = e[o];
    if (!(typeof a == "bigint" && a > ui)) throw new Error(`CURVE.${o} must be positive bigint`);
  }
  const s = Db(e.p, r.Fp), n = Db(e.n, r.Fn), i = ["Gx", "Gy", "a", "b"];
  for (const o of i) if (!s.isValid(e[o])) throw new Error(`CURVE.${o} must be valid field element of CURVE.Fp`);
  return { Fp: s, Fn: n };
}
BigInt(0), BigInt(1), BigInt(2), BigInt(8);
const Ji = BigInt(0), Zn = BigInt(1), Qa = BigInt(2);
function nB(t) {
  return Fl(t, { adjustScalarBytes: "function", powPminus2: "function" }), Object.freeze({ ...t });
}
function iB(t) {
  const e = nB(t), { P: r, type: s, adjustScalarBytes: n, powPminus2: i, randomBytes: o } = e, a = s === "x25519";
  if (!a && s !== "x448") throw new Error("invalid type");
  const c = o || Si, l = a ? 255 : 448, u = a ? 32 : 56, h = BigInt(a ? 9 : 5), p = BigInt(a ? 121665 : 39081), y = a ? Qa ** BigInt(254) : Qa ** BigInt(447), b = a ? BigInt(8) * Qa ** BigInt(251) - Zn : BigInt(4) * Qa ** BigInt(445) - Zn, g = y + b + Zn, x = (w) => pr(w, r), I = U(h);
  function U(w) {
    return Tp(x(w), u);
  }
  function A(w) {
    const T = zt("u coordinate", w, u);
    return a && (T[31] &= 127), x(hl(T));
  }
  function M(w) {
    return hl(n(zt("scalar", w, u)));
  }
  function B(w, T) {
    const k = F(A(T), M(w));
    if (k === Ji) throw new Error("invalid private or public key received");
    return U(k);
  }
  function q(w) {
    return B(w, I);
  }
  function H(w, T, k) {
    const S = x(w * (T - k));
    return T = x(T - S), k = x(k + S), { x_2: T, x_3: k };
  }
  function F(w, T) {
    id("u", w, Ji, r), id("scalar", T, y, g);
    const k = T, S = w;
    let O = Zn, N = Ji, _ = w, C = Zn, $ = Ji;
    for (let D = BigInt(l - 1); D >= Ji; D--) {
      const z = k >> D & Zn;
      $ ^= z, { x_2: O, x_3: _ } = H($, O, _), { x_2: N, x_3: C } = H($, N, C), $ = z;
      const L = O + N, K = x(L * L), J = O - N, X = x(J * J), Y = K - X, re = _ + C, ae = _ - C, ne = x(ae * L), se = x(re * J), fe = ne + se, Oe = ne - se;
      _ = x(fe * fe), C = x(S * x(Oe * Oe)), O = x(K * X), N = x(Y * (K + x(p * Y)));
    }
    ({ x_2: O, x_3: _ } = H($, O, _)), { x_2: N, x_3: C } = H($, N, C);
    const P = i(N);
    return x(O * P);
  }
  return { scalarMult: B, scalarMultBase: q, getSharedSecret: (w, T) => B(w, T), getPublicKey: (w) => q(w), utils: { randomPrivateKey: () => c(u) }, GuBytes: I.slice() };
}
BigInt(0);
const oB = BigInt(1), Ob = BigInt(2), aB = BigInt(3), cB = BigInt(5);
BigInt(8);
const Xw = { p: BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffed"), n: BigInt("0x1000000000000000000000000000000014def9dea2f79cd65812631a5cf5d3ed"), a: BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffec"), d: BigInt("0x52036cee2b6ffe738cc740797779e89800700a4d4141d8ab75eb4dca135978a3"), Gx: BigInt("0x216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a"), Gy: BigInt("0x6666666666666666666666666666666666666666666666666666666666666658") };
function lB(t) {
  const e = BigInt(10), r = BigInt(20), s = BigInt(40), n = BigInt(80), i = Xw.p, o = t * t % i * t % i, a = Tr(o, Ob, i) * o % i, c = Tr(a, oB, i) * t % i, l = Tr(c, cB, i) * c % i, u = Tr(l, e, i) * l % i, h = Tr(u, r, i) * u % i, p = Tr(h, s, i) * h % i, y = Tr(p, n, i) * p % i, b = Tr(y, n, i) * p % i, g = Tr(b, e, i) * l % i;
  return { pow_p_5_8: Tr(g, Ob, i) * t % i, b2: o };
}
function uB(t) {
  return t[0] &= 248, t[31] &= 127, t[31] |= 64, t;
}
const od = (() => {
  const t = Xw.p;
  return iB({ P: t, type: "x25519", powPminus2: (e) => {
    const { pow_p_5_8: r, b2: s } = lB(e);
    return pr(Tr(r, aB, t) * s, t);
  }, adjustScalarBytes: uB });
})();
function Pb(t) {
  t.lowS !== void 0 && ul("lowS", t.lowS), t.prehash !== void 0 && ul("prehash", t.prehash);
}
class hB extends Error {
  constructor(e = "") {
    super(e);
  }
}
const gs = { Err: hB, _tlv: { encode: (t, e) => {
  const { Err: r } = gs;
  if (t < 0 || t > 256) throw new r("tlv.encode: wrong tag");
  if (e.length & 1) throw new r("tlv.encode: unpadded data");
  const s = e.length / 2, n = Ya(s);
  if (n.length / 2 & 128) throw new r("tlv.encode: long form length too big");
  const i = s > 127 ? Ya(n.length / 2 | 128) : "";
  return Ya(t) + i + n + e;
}, decode(t, e) {
  const { Err: r } = gs;
  let s = 0;
  if (t < 0 || t > 256) throw new r("tlv.encode: wrong tag");
  if (e.length < 2 || e[s++] !== t) throw new r("tlv.decode: wrong tlv");
  const n = e[s++], i = !!(n & 128);
  let o = 0;
  if (!i) o = n;
  else {
    const c = n & 127;
    if (!c) throw new r("tlv.decode(long): indefinite length not supported");
    if (c > 4) throw new r("tlv.decode(long): byte length is too big");
    const l = e.subarray(s, s + c);
    if (l.length !== c) throw new r("tlv.decode: length bytes not complete");
    if (l[0] === 0) throw new r("tlv.decode(long): zero leftmost byte");
    for (const u of l) o = o << 8 | u;
    if (s += c, o < 128) throw new r("tlv.decode(long): not minimal encoding");
  }
  const a = e.subarray(s, s + o);
  if (a.length !== o) throw new r("tlv.decode: wrong value length");
  return { v: a, l: e.subarray(s + o) };
} }, _int: { encode(t) {
  const { Err: e } = gs;
  if (t < Mo) throw new e("integer: negative integers are not allowed");
  let r = Ya(t);
  if (Number.parseInt(r[0], 16) & 8 && (r = "00" + r), r.length & 1) throw new e("unexpected DER parsing assertion: unpadded hex");
  return r;
}, decode(t) {
  const { Err: e } = gs;
  if (t[0] & 128) throw new e("invalid signature integer: negative");
  if (t[0] === 0 && !(t[1] & 128)) throw new e("invalid signature integer: unnecessary leading zero");
  return Ll(t);
} }, toSig(t) {
  const { Err: e, _int: r, _tlv: s } = gs, n = zt("signature", t), { v: i, l: o } = s.decode(48, n);
  if (o.length) throw new e("invalid signature: left bytes after parsing");
  const { v: a, l: c } = s.decode(2, i), { v: l, l: u } = s.decode(2, c);
  if (u.length) throw new e("invalid signature: left bytes after parsing");
  return { r: r.decode(a), s: r.decode(l) };
}, hexFromSig(t) {
  const { _tlv: e, _int: r } = gs, s = e.encode(2, r.encode(t.r)), n = e.encode(2, r.encode(t.s)), i = s + n;
  return e.encode(48, i);
} }, Mo = BigInt(0), Fo = BigInt(1), dB = BigInt(2), ec = BigInt(3), pB = BigInt(4);
function fB(t, e, r) {
  function s(n) {
    const i = t.sqr(n), o = t.mul(i, n);
    return t.add(t.add(o, t.mul(n, e)), r);
  }
  return s;
}
function Yw(t, e, r) {
  const { BYTES: s } = t;
  function n(i) {
    let o;
    if (typeof i == "bigint") o = i;
    else {
      let a = zt("private key", i);
      if (e) {
        if (!e.includes(a.length * 2)) throw new Error("invalid private key");
        const c = new Uint8Array(s);
        c.set(a, c.length - a.length), a = c;
      }
      try {
        o = t.fromBytes(a);
      } catch {
        throw new Error(`invalid private key: expected ui8a of size ${s}, got ${typeof i}`);
      }
    }
    if (r && (o = t.create(o)), !t.isValidNot0(o)) throw new Error("invalid private key: out of range [1..N-1]");
    return o;
  }
  return n;
}
function mB(t, e = {}) {
  const { Fp: r, Fn: s } = sB("weierstrass", t, e), { h: n, n: i } = t;
  Fl(e, {}, { allowInfinityPoint: "boolean", clearCofactor: "function", isTorsionFree: "function", fromBytes: "function", toBytes: "function", endo: "object", wrapPrivateKey: "boolean" });
  const { endo: o } = e;
  if (o && (!r.is0(t.a) || typeof o.beta != "bigint" || typeof o.splitScalar != "function")) throw new Error('invalid endo: expected "beta": bigint and "splitScalar": function');
  function a() {
    if (!r.isOdd) throw new Error("compression is not supported: Field does not have .isOdd()");
  }
  function c(F, w, T) {
    const { x: k, y: S } = w.toAffine(), O = r.toBytes(k);
    if (ul("isCompressed", T), T) {
      a();
      const N = !r.isOdd(S);
      return kn(Qw(N), O);
    } else return kn(Uint8Array.of(4), O, r.toBytes(S));
  }
  function l(F) {
    yr(F);
    const w = r.BYTES, T = w + 1, k = 2 * w + 1, S = F.length, O = F[0], N = F.subarray(1);
    if (S === T && (O === 2 || O === 3)) {
      const _ = r.fromBytes(N);
      if (!r.isValid(_)) throw new Error("bad point: is not on curve, wrong x");
      const C = p(_);
      let $;
      try {
        $ = r.sqrt(C);
      } catch (D) {
        const z = D instanceof Error ? ": " + D.message : "";
        throw new Error("bad point: is not on curve, sqrt error" + z);
      }
      a();
      const P = r.isOdd($);
      return (O & 1) === 1 !== P && ($ = r.neg($)), { x: _, y: $ };
    } else if (S === k && O === 4) {
      const _ = r.fromBytes(N.subarray(w * 0, w * 1)), C = r.fromBytes(N.subarray(w * 1, w * 2));
      if (!y(_, C)) throw new Error("bad point: is not on curve");
      return { x: _, y: C };
    } else throw new Error(`bad point: got length ${S}, expected compressed=${T} or uncompressed=${k}`);
  }
  const u = e.toBytes || c, h = e.fromBytes || l, p = fB(r, t.a, t.b);
  function y(F, w) {
    const T = r.sqr(w), k = p(F);
    return r.eql(T, k);
  }
  if (!y(t.Gx, t.Gy)) throw new Error("bad curve params: generator point");
  const b = r.mul(r.pow(t.a, ec), pB), g = r.mul(r.sqr(t.b), BigInt(27));
  if (r.is0(r.add(b, g))) throw new Error("bad curve params: a or b");
  function x(F, w, T = !1) {
    if (!r.isValid(w) || T && r.is0(w)) throw new Error(`bad point coordinate ${F}`);
    return w;
  }
  function I(F) {
    if (!(F instanceof B)) throw new Error("ProjectivePoint expected");
  }
  const U = _b((F, w) => {
    const { px: T, py: k, pz: S } = F;
    if (r.eql(S, r.ONE)) return { x: T, y: k };
    const O = F.is0();
    w == null && (w = O ? r.ONE : r.inv(S));
    const N = r.mul(T, w), _ = r.mul(k, w), C = r.mul(S, w);
    if (O) return { x: r.ZERO, y: r.ZERO };
    if (!r.eql(C, r.ONE)) throw new Error("invZ was invalid");
    return { x: N, y: _ };
  }), A = _b((F) => {
    if (F.is0()) {
      if (e.allowInfinityPoint && !r.is0(F.py)) return;
      throw new Error("bad point: ZERO");
    }
    const { x: w, y: T } = F.toAffine();
    if (!r.isValid(w) || !r.isValid(T)) throw new Error("bad point: x or y not field elements");
    if (!y(w, T)) throw new Error("bad point: equation left != right");
    if (!F.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
    return !0;
  });
  function M(F, w, T, k, S) {
    return T = new B(r.mul(T.px, F), T.py, T.pz), w = Lo(k, w), T = Lo(S, T), w.add(T);
  }
  class B {
    constructor(w, T, k) {
      this.px = x("x", w), this.py = x("y", T, !0), this.pz = x("z", k), Object.freeze(this);
    }
    static fromAffine(w) {
      const { x: T, y: k } = w || {};
      if (!w || !r.isValid(T) || !r.isValid(k)) throw new Error("invalid affine point");
      if (w instanceof B) throw new Error("projective point not allowed");
      return r.is0(T) && r.is0(k) ? B.ZERO : new B(T, k, r.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static normalizeZ(w) {
      return X$(B, "pz", w);
    }
    static fromBytes(w) {
      return yr(w), B.fromHex(w);
    }
    static fromHex(w) {
      const T = B.fromAffine(h(zt("pointHex", w)));
      return T.assertValidity(), T;
    }
    static fromPrivateKey(w) {
      const T = Yw(s, e.allowedPrivateKeyLengths, e.wrapPrivateKey);
      return B.BASE.multiply(T(w));
    }
    static msm(w, T) {
      return rB(B, s, w, T);
    }
    precompute(w = 8, T = !0) {
      return H.setWindowSize(this, w), T || this.multiply(ec), this;
    }
    _setWindowSize(w) {
      this.precompute(w);
    }
    assertValidity() {
      A(this);
    }
    hasEvenY() {
      const { y: w } = this.toAffine();
      if (!r.isOdd) throw new Error("Field doesn't support isOdd");
      return !r.isOdd(w);
    }
    equals(w) {
      I(w);
      const { px: T, py: k, pz: S } = this, { px: O, py: N, pz: _ } = w, C = r.eql(r.mul(T, _), r.mul(O, S)), $ = r.eql(r.mul(k, _), r.mul(N, S));
      return C && $;
    }
    negate() {
      return new B(this.px, r.neg(this.py), this.pz);
    }
    double() {
      const { a: w, b: T } = t, k = r.mul(T, ec), { px: S, py: O, pz: N } = this;
      let _ = r.ZERO, C = r.ZERO, $ = r.ZERO, P = r.mul(S, S), D = r.mul(O, O), z = r.mul(N, N), L = r.mul(S, O);
      return L = r.add(L, L), $ = r.mul(S, N), $ = r.add($, $), _ = r.mul(w, $), C = r.mul(k, z), C = r.add(_, C), _ = r.sub(D, C), C = r.add(D, C), C = r.mul(_, C), _ = r.mul(L, _), $ = r.mul(k, $), z = r.mul(w, z), L = r.sub(P, z), L = r.mul(w, L), L = r.add(L, $), $ = r.add(P, P), P = r.add($, P), P = r.add(P, z), P = r.mul(P, L), C = r.add(C, P), z = r.mul(O, N), z = r.add(z, z), P = r.mul(z, L), _ = r.sub(_, P), $ = r.mul(z, D), $ = r.add($, $), $ = r.add($, $), new B(_, C, $);
    }
    add(w) {
      I(w);
      const { px: T, py: k, pz: S } = this, { px: O, py: N, pz: _ } = w;
      let C = r.ZERO, $ = r.ZERO, P = r.ZERO;
      const D = t.a, z = r.mul(t.b, ec);
      let L = r.mul(T, O), K = r.mul(k, N), J = r.mul(S, _), X = r.add(T, k), Y = r.add(O, N);
      X = r.mul(X, Y), Y = r.add(L, K), X = r.sub(X, Y), Y = r.add(T, S);
      let re = r.add(O, _);
      return Y = r.mul(Y, re), re = r.add(L, J), Y = r.sub(Y, re), re = r.add(k, S), C = r.add(N, _), re = r.mul(re, C), C = r.add(K, J), re = r.sub(re, C), P = r.mul(D, Y), C = r.mul(z, J), P = r.add(C, P), C = r.sub(K, P), P = r.add(K, P), $ = r.mul(C, P), K = r.add(L, L), K = r.add(K, L), J = r.mul(D, J), Y = r.mul(z, Y), K = r.add(K, J), J = r.sub(L, J), J = r.mul(D, J), Y = r.add(Y, J), L = r.mul(K, Y), $ = r.add($, L), L = r.mul(re, Y), C = r.mul(X, C), C = r.sub(C, L), L = r.mul(X, K), P = r.mul(re, P), P = r.add(P, L), new B(C, $, P);
    }
    subtract(w) {
      return this.add(w.negate());
    }
    is0() {
      return this.equals(B.ZERO);
    }
    multiply(w) {
      const { endo: T } = e;
      if (!s.isValidNot0(w)) throw new Error("invalid scalar: out of range");
      let k, S;
      const O = (N) => H.wNAFCached(this, N, B.normalizeZ);
      if (T) {
        const { k1neg: N, k1: _, k2neg: C, k2: $ } = T.splitScalar(w), { p: P, f: D } = O(_), { p: z, f: L } = O($);
        S = D.add(L), k = M(T.beta, P, z, N, C);
      } else {
        const { p: N, f: _ } = O(w);
        k = N, S = _;
      }
      return B.normalizeZ([k, S])[0];
    }
    multiplyUnsafe(w) {
      const { endo: T } = e, k = this;
      if (!s.isValid(w)) throw new Error("invalid scalar: out of range");
      if (w === Mo || k.is0()) return B.ZERO;
      if (w === Fo) return k;
      if (H.hasPrecomputes(this)) return this.multiply(w);
      if (T) {
        const { k1neg: S, k1: O, k2neg: N, k2: _ } = T.splitScalar(w), { p1: C, p2: $ } = tB(B, k, O, _);
        return M(T.beta, C, $, S, N);
      } else return H.wNAFCachedUnsafe(k, w);
    }
    multiplyAndAddUnsafe(w, T, k) {
      const S = this.multiplyUnsafe(T).add(w.multiplyUnsafe(k));
      return S.is0() ? void 0 : S;
    }
    toAffine(w) {
      return U(this, w);
    }
    isTorsionFree() {
      const { isTorsionFree: w } = e;
      return n === Fo ? !0 : w ? w(B, this) : H.wNAFCachedUnsafe(this, i).is0();
    }
    clearCofactor() {
      const { clearCofactor: w } = e;
      return n === Fo ? this : w ? w(B, this) : this.multiplyUnsafe(n);
    }
    toBytes(w = !0) {
      return ul("isCompressed", w), this.assertValidity(), u(B, this, w);
    }
    toRawBytes(w = !0) {
      return this.toBytes(w);
    }
    toHex(w = !0) {
      return ea(this.toBytes(w));
    }
    toString() {
      return `<Point ${this.is0() ? "ZERO" : this.toHex()}>`;
    }
  }
  B.BASE = new B(t.Gx, t.Gy, r.ONE), B.ZERO = new B(r.ZERO, r.ONE, r.ZERO), B.Fp = r, B.Fn = s;
  const q = s.BITS, H = eB(B, e.endo ? Math.ceil(q / 2) : q);
  return B;
}
function Qw(t) {
  return Uint8Array.of(t ? 2 : 3);
}
function bB(t, e, r = {}) {
  Fl(e, { hash: "function" }, { hmac: "function", lowS: "boolean", randomBytes: "function", bits2int: "function", bits2int_modN: "function" });
  const s = e.randomBytes || Si, n = e.hmac || ((k, ...S) => Rl(e.hash, k, kn(...S))), { Fp: i, Fn: o } = t, { ORDER: a, BITS: c } = o;
  function l(k) {
    const S = a >> Fo;
    return k > S;
  }
  function u(k) {
    return l(k) ? o.neg(k) : k;
  }
  function h(k, S) {
    if (!o.isValidNot0(S)) throw new Error(`invalid signature ${k}: out of range 1..CURVE.n`);
  }
  class p {
    constructor(S, O, N) {
      h("r", S), h("s", O), this.r = S, this.s = O, N != null && (this.recovery = N), Object.freeze(this);
    }
    static fromCompact(S) {
      const O = o.BYTES, N = zt("compactSignature", S, O * 2);
      return new p(o.fromBytes(N.subarray(0, O)), o.fromBytes(N.subarray(O, O * 2)));
    }
    static fromDER(S) {
      const { r: O, s: N } = gs.toSig(zt("DER", S));
      return new p(O, N);
    }
    assertValidity() {
    }
    addRecoveryBit(S) {
      return new p(this.r, this.s, S);
    }
    recoverPublicKey(S) {
      const O = i.ORDER, { r: N, s: _, recovery: C } = this;
      if (C == null || ![0, 1, 2, 3].includes(C)) throw new Error("recovery id invalid");
      if (a * dB < O && C > 1) throw new Error("recovery id is ambiguous for h>1 curve");
      const $ = C === 2 || C === 3 ? N + a : N;
      if (!i.isValid($)) throw new Error("recovery id 2 or 3 invalid");
      const P = i.toBytes($), D = t.fromHex(kn(Qw((C & 1) === 0), P)), z = o.inv($), L = A(zt("msgHash", S)), K = o.create(-L * z), J = o.create(_ * z), X = t.BASE.multiplyUnsafe(K).add(D.multiplyUnsafe(J));
      if (X.is0()) throw new Error("point at infinify");
      return X.assertValidity(), X;
    }
    hasHighS() {
      return l(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new p(this.r, o.neg(this.s), this.recovery) : this;
    }
    toBytes(S) {
      if (S === "compact") return kn(o.toBytes(this.r), o.toBytes(this.s));
      if (S === "der") return Cp(gs.hexFromSig(this));
      throw new Error("invalid format");
    }
    toDERRawBytes() {
      return this.toBytes("der");
    }
    toDERHex() {
      return ea(this.toBytes("der"));
    }
    toCompactRawBytes() {
      return this.toBytes("compact");
    }
    toCompactHex() {
      return ea(this.toBytes("compact"));
    }
  }
  const y = Yw(o, r.allowedPrivateKeyLengths, r.wrapPrivateKey), b = { isValidPrivateKey(k) {
    try {
      return y(k), !0;
    } catch {
      return !1;
    }
  }, normPrivateKeyToScalar: y, randomPrivateKey: () => {
    const k = a;
    return J$(s(Ww(k)), k);
  }, precompute(k = 8, S = t.BASE) {
    return S.precompute(k, !1);
  } };
  function g(k, S = !0) {
    return t.fromPrivateKey(k).toBytes(S);
  }
  function x(k) {
    if (typeof k == "bigint") return !1;
    if (k instanceof t) return !0;
    const S = zt("key", k).length, O = i.BYTES, N = O + 1, _ = 2 * O + 1;
    if (!(r.allowedPrivateKeyLengths || o.BYTES === N)) return S === N || S === _;
  }
  function I(k, S, O = !0) {
    if (x(k) === !0) throw new Error("first arg must be private key");
    if (x(S) === !1) throw new Error("second arg must be public key");
    return t.fromHex(S).multiply(y(k)).toBytes(O);
  }
  const U = e.bits2int || function(k) {
    if (k.length > 8192) throw new Error("input is too large");
    const S = Ll(k), O = k.length * 8 - c;
    return O > 0 ? S >> BigInt(O) : S;
  }, A = e.bits2int_modN || function(k) {
    return o.create(U(k));
  }, M = Ml(c);
  function B(k) {
    return id("num < 2^" + c, k, Mo, M), o.toBytes(k);
  }
  function q(k, S, O = H) {
    if (["recovered", "canonical"].some((X) => X in O)) throw new Error("sign() legacy options not supported");
    const { hash: N } = e;
    let { lowS: _, prehash: C, extraEntropy: $ } = O;
    _ == null && (_ = !0), k = zt("msgHash", k), Pb(O), C && (k = zt("prehashed msgHash", N(k)));
    const P = A(k), D = y(S), z = [B(D), B(P)];
    if ($ != null && $ !== !1) {
      const X = $ === !0 ? s(i.BYTES) : $;
      z.push(zt("extraEntropy", X));
    }
    const L = kn(...z), K = P;
    function J(X) {
      const Y = U(X);
      if (!o.isValidNot0(Y)) return;
      const re = o.inv(Y), ae = t.BASE.multiply(Y).toAffine(), ne = o.create(ae.x);
      if (ne === Mo) return;
      const se = o.create(re * o.create(K + ne * D));
      if (se === Mo) return;
      let fe = (ae.x === ne ? 0 : 2) | Number(ae.y & Fo), Oe = se;
      return _ && l(se) && (Oe = u(se), fe ^= 1), new p(ne, Oe, fe);
    }
    return { seed: L, k2sig: J };
  }
  const H = { lowS: e.lowS, prehash: !1 }, F = { lowS: e.lowS, prehash: !1 };
  function w(k, S, O = H) {
    const { seed: N, k2sig: _ } = q(k, S, O);
    return z$(e.hash.outputLen, o.BYTES, n)(N, _);
  }
  t.BASE.precompute(8);
  function T(k, S, O, N = F) {
    const _ = k;
    S = zt("msgHash", S), O = zt("publicKey", O), Pb(N);
    const { lowS: C, prehash: $, format: P } = N;
    if ("strict" in N) throw new Error("options.strict was renamed to lowS");
    if (P !== void 0 && !["compact", "der", "js"].includes(P)) throw new Error('format must be "compact", "der" or "js"');
    const D = typeof _ == "string" || xp(_), z = !D && !P && typeof _ == "object" && _ !== null && typeof _.r == "bigint" && typeof _.s == "bigint";
    if (!D && !z) throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
    let L, K;
    try {
      if (z) if (P === void 0 || P === "js") L = new p(_.r, _.s);
      else throw new Error("invalid format");
      if (D) {
        try {
          P !== "compact" && (L = p.fromDER(_));
        } catch (fe) {
          if (!(fe instanceof gs.Err)) throw fe;
        }
        !L && P !== "der" && (L = p.fromCompact(_));
      }
      K = t.fromHex(O);
    } catch {
      return !1;
    }
    if (!L || C && L.hasHighS()) return !1;
    $ && (S = e.hash(S));
    const { r: J, s: X } = L, Y = A(S), re = o.inv(X), ae = o.create(Y * re), ne = o.create(J * re), se = t.BASE.multiplyUnsafe(ae).add(K.multiplyUnsafe(ne));
    return se.is0() ? !1 : o.create(se.x) === J;
  }
  return Object.freeze({ getPublicKey: g, getSharedSecret: I, sign: w, verify: T, utils: b, Point: t, Signature: p });
}
function yB(t) {
  const e = { a: t.a, b: t.b, p: t.Fp.ORDER, n: t.n, h: t.h, Gx: t.Gx, Gy: t.Gy }, r = t.Fp, s = Ii(e.n, t.nBitLength), n = { Fp: r, Fn: s, allowedPrivateKeyLengths: t.allowedPrivateKeyLengths, allowInfinityPoint: t.allowInfinityPoint, endo: t.endo, wrapPrivateKey: t.wrapPrivateKey, isTorsionFree: t.isTorsionFree, clearCofactor: t.clearCofactor, fromBytes: t.fromBytes, toBytes: t.toBytes };
  return { CURVE: e, curveOpts: n };
}
function gB(t) {
  const { CURVE: e, curveOpts: r } = yB(t), s = { hash: t.hash, hmac: t.hmac, randomBytes: t.randomBytes, lowS: t.lowS, bits2int: t.bits2int, bits2int_modN: t.bits2int_modN };
  return { CURVE: e, curveOpts: r, ecdsaOpts: s };
}
function wB(t, e) {
  return Object.assign({}, e, { ProjectivePoint: e.Point, CURVE: t });
}
function EB(t) {
  const { CURVE: e, curveOpts: r, ecdsaOpts: s } = gB(t), n = mB(e, r), i = bB(n, s, r);
  return wB(t, i);
}
function ad(t, e) {
  const r = (s) => EB({ ...t, hash: s });
  return { ...r(e), create: r };
}
const e2 = { p: BigInt("0xffffffff00000001000000000000000000000000ffffffffffffffffffffffff"), n: BigInt("0xffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551"), h: BigInt(1), a: BigInt("0xffffffff00000001000000000000000000000000fffffffffffffffffffffffc"), b: BigInt("0x5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b"), Gx: BigInt("0x6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296"), Gy: BigInt("0x4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5") }, t2 = { p: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffeffffffff0000000000000000ffffffff"), n: BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffc7634d81f4372ddf581a0db248b0a77aecec196accc52973"), h: BigInt(1), a: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffeffffffff0000000000000000fffffffc"), b: BigInt("0xb3312fa7e23ee7e4988e056be3f82d19181d9c6efe8141120314088f5013875ac656398d8a2ed19d2a85c8edd3ec2aef"), Gx: BigInt("0xaa87ca22be8b05378eb1c71ef320ad746e1d3b628ba79b9859f741e082542a385502f25dbf55296c3a545e3872760ab7"), Gy: BigInt("0x3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f") }, r2 = { p: BigInt("0x1ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), n: BigInt("0x01fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffa51868783bf2f966b7fcc0148f709a5d03bb5c9b8899c47aebb6fb71e91386409"), h: BigInt(1), a: BigInt("0x1fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffc"), b: BigInt("0x0051953eb9618e1c9a1f929a21a0b68540eea2da725b99b315f3b8b489918ef109e156193951ec7e937b1652c0bd3bb1bf073573df883d2c34f1ef451fd46b503f00"), Gx: BigInt("0x00c6858e06b70404e9cd9e3ecb662395b4429c648139053fb521f828af606b4d3dbaa14b5e77efe75928fe1dc127a2ffa8de3348b3c1856a429bf97e7e31c2e5bd66"), Gy: BigInt("0x011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650") }, xB = Ii(e2.p), vB = Ii(t2.p), kB = Ii(r2.p), CB = ad({ ...e2, Fp: xB, lowS: !1 }, Pl);
ad({ ...t2, Fp: vB, lowS: !1 }, BU), ad({ ...r2, Fp: kB, lowS: !1, allowedPrivateKeyLengths: [130, 131, 132] }, $U);
const SB = CB, s2 = "base10", Dt = "base16", Pr = "base64pad", en = "base64url", ka = "utf8", n2 = 0, xs = 1, Ca = 2, IB = 0, Rb = 1, zo = 12, Up = 32;
function AB() {
  const t = od.utils.randomPrivateKey(), e = od.getPublicKey(t);
  return { privateKey: Ce(t, Dt), publicKey: Ce(e, Dt) };
}
function cd() {
  const t = Si(Up);
  return Ce(t, Dt);
}
function _B(t, e) {
  const r = od.getSharedSecret(Le(t, Dt), Le(e, Dt)), s = L$(Nl, r, void 0, void 0, Up);
  return Ce(s, Dt);
}
function jc(t) {
  const e = Nl(Le(t, Dt));
  return Ce(e, Dt);
}
function Wr(t) {
  const e = Nl(Le(t, ka));
  return Ce(e, Dt);
}
function i2(t) {
  return Le(`${t}`, s2);
}
function $n(t) {
  return Number(Ce(t, s2));
}
function o2(t) {
  return t.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function a2(t) {
  const e = t.replace(/-/g, "+").replace(/_/g, "/"), r = (4 - e.length % 4) % 4;
  return e + "=".repeat(r);
}
function TB(t) {
  const e = i2(typeof t.type < "u" ? t.type : n2);
  if ($n(e) === xs && typeof t.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
  const r = typeof t.senderPublicKey < "u" ? Le(t.senderPublicKey, Dt) : void 0, s = typeof t.iv < "u" ? Le(t.iv, Dt) : Si(zo), n = Le(t.symKey, Dt), i = Mw(n, s).encrypt(Le(t.message, ka)), o = c2({ type: e, sealed: i, iv: s, senderPublicKey: r });
  return t.encoding === en ? o2(o) : o;
}
function UB(t) {
  const e = Le(t.symKey, Dt), { sealed: r, iv: s } = ra({ encoded: t.encoded, encoding: t.encoding }), n = Mw(e, s).decrypt(r);
  if (n === null) throw new Error("Failed to decrypt");
  return Ce(n, ka);
}
function $B(t, e) {
  const r = i2(Ca), s = Si(zo), n = Le(t, ka), i = c2({ type: r, sealed: n, iv: s });
  return e === en ? o2(i) : i;
}
function BB(t, e) {
  const { sealed: r } = ra({ encoded: t, encoding: e });
  return Ce(r, ka);
}
function c2(t) {
  if ($n(t.type) === Ca) return Ce(Xr([t.type, t.sealed]), Pr);
  if ($n(t.type) === xs) {
    if (typeof t.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    return Ce(Xr([t.type, t.senderPublicKey, t.iv, t.sealed]), Pr);
  }
  return Ce(Xr([t.type, t.iv, t.sealed]), Pr);
}
function ra(t) {
  const e = (t.encoding || Pr) === en ? a2(t.encoded) : t.encoded, r = Le(e, Pr), s = r.slice(IB, Rb), n = Rb;
  if ($n(s) === xs) {
    const c = n + Up, l = c + zo, u = r.slice(n, c), h = r.slice(c, l), p = r.slice(l);
    return { type: s, sealed: p, iv: h, senderPublicKey: u };
  }
  if ($n(s) === Ca) {
    const c = r.slice(n), l = Si(zo);
    return { type: s, sealed: c, iv: l };
  }
  const i = n + zo, o = r.slice(n, i), a = r.slice(i);
  return { type: s, sealed: a, iv: o };
}
function DB(t, e) {
  const r = ra({ encoded: t, encoding: e == null ? void 0 : e.encoding });
  return l2({ type: $n(r.type), senderPublicKey: typeof r.senderPublicKey < "u" ? Ce(r.senderPublicKey, Dt) : void 0, receiverPublicKey: e == null ? void 0 : e.receiverPublicKey });
}
function l2(t) {
  const e = (t == null ? void 0 : t.type) || n2;
  if (e === xs) {
    if (typeof (t == null ? void 0 : t.senderPublicKey) > "u") throw new Error("missing sender public key");
    if (typeof (t == null ? void 0 : t.receiverPublicKey) > "u") throw new Error("missing receiver public key");
  }
  return { type: e, senderPublicKey: t == null ? void 0 : t.senderPublicKey, receiverPublicKey: t == null ? void 0 : t.receiverPublicKey };
}
function Nb(t) {
  return t.type === xs && typeof t.senderPublicKey == "string" && typeof t.receiverPublicKey == "string";
}
function Lb(t) {
  return t.type === Ca;
}
function OB(t) {
  const e = Buffer.from(t.x, "base64"), r = Buffer.from(t.y, "base64");
  return Xr([new Uint8Array([4]), e, r]);
}
function PB(t, e) {
  const [r, s, n] = t.split("."), i = Buffer.from(a2(n), "base64");
  if (i.length !== 64) throw new Error("Invalid signature length");
  const o = i.slice(0, 32), a = i.slice(32, 64), c = `${r}.${s}`, l = Nl(c), u = OB(e);
  if (!SB.verify(Xr([o, a]), l, u)) throw new Error("Invalid signature");
  return ni(t).payload;
}
const RB = "irn";
function dl(t) {
  return (t == null ? void 0 : t.relay) || { protocol: RB };
}
function Ao(t) {
  const e = My[t];
  if (typeof e > "u") throw new Error(`Relay Protocol not supported: ${t}`);
  return e;
}
function NB(t, e = "-") {
  const r = {}, s = "relay" + e;
  return Object.keys(t).forEach((n) => {
    if (n.startsWith(s)) {
      const i = n.replace(s, ""), o = t[n];
      r[i] = o;
    }
  }), r;
}
function Mb(t) {
  if (!t.includes("wc:")) {
    const l = Ew(t);
    l != null && l.includes("wc:") && (t = l);
  }
  t = t.includes("wc://") ? t.replace("wc://", "") : t, t = t.includes("wc:") ? t.replace("wc:", "") : t;
  const e = t.indexOf(":"), r = t.indexOf("?") !== -1 ? t.indexOf("?") : void 0, s = t.substring(0, e), n = t.substring(e + 1, r).split("@"), i = typeof r < "u" ? t.substring(r) : "", o = new URLSearchParams(i), a = {};
  o.forEach((l, u) => {
    a[u] = l;
  });
  const c = typeof a.methods == "string" ? a.methods.split(",") : void 0;
  return { protocol: s, topic: LB(n[0]), version: parseInt(n[1], 10), symKey: a.symKey, relay: NB(a), methods: c, expiryTimestamp: a.expiryTimestamp ? parseInt(a.expiryTimestamp, 10) : void 0 };
}
function LB(t) {
  return t.startsWith("//") ? t.substring(2) : t;
}
function MB(t, e = "-") {
  const r = "relay", s = {};
  return Object.keys(t).forEach((n) => {
    const i = n, o = r + e + i;
    t[i] && (s[o] = t[i]);
  }), s;
}
function Fb(t) {
  const e = new URLSearchParams(), r = MB(t.relay);
  Object.keys(r).sort().forEach((n) => {
    e.set(n, r[n]);
  }), e.set("symKey", t.symKey), t.expiryTimestamp && e.set("expiryTimestamp", t.expiryTimestamp.toString()), t.methods && e.set("methods", t.methods.join(","));
  const s = e.toString();
  return `${t.protocol}:${t.topic}@${t.version}?${s}`;
}
function tc(t, e, r) {
  return `${t}?wc_ev=${r}&topic=${e}`;
}
var FB = Object.defineProperty, zB = Object.defineProperties, jB = Object.getOwnPropertyDescriptors, zb = Object.getOwnPropertySymbols, HB = Object.prototype.hasOwnProperty, qB = Object.prototype.propertyIsEnumerable, jb = (t, e, r) => e in t ? FB(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, KB = (t, e) => {
  for (var r in e || (e = {})) HB.call(e, r) && jb(t, r, e[r]);
  if (zb) for (var r of zb(e)) qB.call(e, r) && jb(t, r, e[r]);
  return t;
}, VB = (t, e) => zB(t, jB(e));
function Ai(t) {
  const e = [];
  return t.forEach((r) => {
    const [s, n] = r.split(":");
    e.push(`${s}:${n}`);
  }), e;
}
function GB(t) {
  const e = [];
  return Object.values(t).forEach((r) => {
    e.push(...Ai(r.accounts));
  }), e;
}
function WB(t, e) {
  const r = [];
  return Object.values(t).forEach((s) => {
    Ai(s.accounts).includes(e) && r.push(...s.methods);
  }), r;
}
function ZB(t, e) {
  const r = [];
  return Object.values(t).forEach((s) => {
    Ai(s.accounts).includes(e) && r.push(...s.events);
  }), r;
}
function u2(t) {
  return t.includes(":");
}
function JB(t) {
  return u2(t) ? t.split(":")[0] : t;
}
function Hb(t) {
  var e, r, s;
  const n = {};
  if (!sa(t)) return n;
  for (const [i, o] of Object.entries(t)) {
    const a = u2(i) ? [i] : o.chains, c = o.methods || [], l = o.events || [], u = JB(i);
    n[u] = VB(KB({}, n[u]), { chains: An(a, (e = n[u]) == null ? void 0 : e.chains), methods: An(c, (r = n[u]) == null ? void 0 : r.methods), events: An(l, (s = n[u]) == null ? void 0 : s.events) });
  }
  return n;
}
function XB(t) {
  const e = {};
  return t == null || t.forEach((r) => {
    var s;
    const [n, i] = r.split(":");
    e[n] || (e[n] = { accounts: [], chains: [], events: [], methods: [] }), e[n].accounts.push(r), (s = e[n].chains) == null || s.push(`${n}:${i}`);
  }), e;
}
function qb(t, e) {
  e = e.map((s) => s.replace("did:pkh:", ""));
  const r = XB(e);
  for (const [s, n] of Object.entries(r)) n.methods ? n.methods = An(n.methods, t) : n.methods = t, n.events = ["chainChanged", "accountsChanged"];
  return r;
}
function YB(t, e) {
  var r, s, n, i, o, a;
  const c = Hb(t), l = Hb(e), u = {}, h = Object.keys(c).concat(Object.keys(l));
  for (const p of h) u[p] = { chains: An((r = c[p]) == null ? void 0 : r.chains, (s = l[p]) == null ? void 0 : s.chains), methods: An((n = c[p]) == null ? void 0 : n.methods, (i = l[p]) == null ? void 0 : i.methods), events: An((o = c[p]) == null ? void 0 : o.events, (a = l[p]) == null ? void 0 : a.events) };
  return u;
}
const QB = { INVALID_METHOD: { message: "Invalid method.", code: 1001 }, INVALID_EVENT: { message: "Invalid event.", code: 1002 }, INVALID_UPDATE_REQUEST: { message: "Invalid update request.", code: 1003 }, INVALID_EXTEND_REQUEST: { message: "Invalid extend request.", code: 1004 }, INVALID_SESSION_SETTLE_REQUEST: { message: "Invalid session settle request.", code: 1005 }, UNAUTHORIZED_METHOD: { message: "Unauthorized method.", code: 3001 }, UNAUTHORIZED_EVENT: { message: "Unauthorized event.", code: 3002 }, UNAUTHORIZED_UPDATE_REQUEST: { message: "Unauthorized update request.", code: 3003 }, UNAUTHORIZED_EXTEND_REQUEST: { message: "Unauthorized extend request.", code: 3004 }, USER_REJECTED: { message: "User rejected.", code: 5e3 }, USER_REJECTED_CHAINS: { message: "User rejected chains.", code: 5001 }, USER_REJECTED_METHODS: { message: "User rejected methods.", code: 5002 }, USER_REJECTED_EVENTS: { message: "User rejected events.", code: 5003 }, UNSUPPORTED_CHAINS: { message: "Unsupported chains.", code: 5100 }, UNSUPPORTED_METHODS: { message: "Unsupported methods.", code: 5101 }, UNSUPPORTED_EVENTS: { message: "Unsupported events.", code: 5102 }, UNSUPPORTED_ACCOUNTS: { message: "Unsupported accounts.", code: 5103 }, UNSUPPORTED_NAMESPACE_KEY: { message: "Unsupported namespace key.", code: 5104 }, USER_DISCONNECTED: { message: "User disconnected.", code: 6e3 }, SESSION_SETTLEMENT_FAILED: { message: "Session settlement failed.", code: 7e3 }, WC_METHOD_UNSUPPORTED: { message: "Unsupported wc_ method.", code: 10001 } }, eD = { NOT_INITIALIZED: { message: "Not initialized.", code: 1 }, NO_MATCHING_KEY: { message: "No matching key.", code: 2 }, RESTORE_WILL_OVERRIDE: { message: "Restore will override.", code: 3 }, RESUBSCRIBED: { message: "Resubscribed.", code: 4 }, MISSING_OR_INVALID: { message: "Missing or invalid.", code: 5 }, EXPIRED: { message: "Expired.", code: 6 }, UNKNOWN_TYPE: { message: "Unknown type.", code: 7 }, MISMATCHED_TOPIC: { message: "Mismatched topic.", code: 8 }, NON_CONFORMING_NAMESPACES: { message: "Non conforming namespaces.", code: 9 } };
function Q(t, e) {
  const { message: r, code: s } = eD[t];
  return { message: e ? `${r} ${e}` : r, code: s };
}
function ze(t, e) {
  const { message: r, code: s } = QB[t];
  return { message: e ? `${r} ${e}` : r, code: s };
}
function hi(t, e) {
  return Array.isArray(t) ? typeof e < "u" && t.length ? t.every(e) : !0 : !1;
}
function sa(t) {
  return Object.getPrototypeOf(t) === Object.prototype && Object.keys(t).length;
}
function ht(t) {
  return typeof t > "u";
}
function Ve(t, e) {
  return e && ht(t) ? !0 : typeof t == "string" && !!t.trim().length;
}
function $p(t, e) {
  return e && ht(t) ? !0 : typeof t == "number" && !isNaN(t);
}
function tD(t, e) {
  const { requiredNamespaces: r } = e, s = Object.keys(t.namespaces), n = Object.keys(r);
  let i = !0;
  return vn(n, s) ? (s.forEach((o) => {
    const { accounts: a, methods: c, events: l } = t.namespaces[o], u = Ai(a), h = r[o];
    (!vn(mw(o, h), u) || !vn(h.methods, c) || !vn(h.events, l)) && (i = !1);
  }), i) : !1;
}
function pl(t) {
  return Ve(t, !1) && t.includes(":") ? t.split(":").length === 2 : !1;
}
function rD(t) {
  if (Ve(t, !1) && t.includes(":")) {
    const e = t.split(":");
    if (e.length === 3) {
      const r = e[0] + ":" + e[1];
      return !!e[2] && pl(r);
    }
  }
  return !1;
}
function sD(t) {
  function e(r) {
    try {
      return typeof new URL(r) < "u";
    } catch {
      return !1;
    }
  }
  try {
    if (Ve(t, !1)) {
      if (e(t)) return !0;
      const r = Ew(t);
      return e(r);
    }
  } catch {
  }
  return !1;
}
function nD(t) {
  var e;
  return (e = t == null ? void 0 : t.proposer) == null ? void 0 : e.publicKey;
}
function iD(t) {
  return t == null ? void 0 : t.topic;
}
function oD(t, e) {
  let r = null;
  return Ve(t == null ? void 0 : t.publicKey, !1) || (r = Q("MISSING_OR_INVALID", `${e} controller public key should be a string`)), r;
}
function Kb(t) {
  let e = !0;
  return hi(t) ? t.length && (e = t.every((r) => Ve(r, !1))) : e = !1, e;
}
function aD(t, e, r) {
  let s = null;
  return hi(e) && e.length ? e.forEach((n) => {
    s || pl(n) || (s = ze("UNSUPPORTED_CHAINS", `${r}, chain ${n} should be a string and conform to "namespace:chainId" format`));
  }) : pl(t) || (s = ze("UNSUPPORTED_CHAINS", `${r}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), s;
}
function cD(t, e, r) {
  let s = null;
  return Object.entries(t).forEach(([n, i]) => {
    if (s) return;
    const o = aD(n, mw(n, i), `${e} ${r}`);
    o && (s = o);
  }), s;
}
function lD(t, e) {
  let r = null;
  return hi(t) ? t.forEach((s) => {
    r || rD(s) || (r = ze("UNSUPPORTED_ACCOUNTS", `${e}, account ${s} should be a string and conform to "namespace:chainId:address" format`));
  }) : r = ze("UNSUPPORTED_ACCOUNTS", `${e}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), r;
}
function uD(t, e) {
  let r = null;
  return Object.values(t).forEach((s) => {
    if (r) return;
    const n = lD(s == null ? void 0 : s.accounts, `${e} namespace`);
    n && (r = n);
  }), r;
}
function hD(t, e) {
  let r = null;
  return Kb(t == null ? void 0 : t.methods) ? Kb(t == null ? void 0 : t.events) || (r = ze("UNSUPPORTED_EVENTS", `${e}, events should be an array of strings or empty array for no events`)) : r = ze("UNSUPPORTED_METHODS", `${e}, methods should be an array of strings or empty array for no methods`), r;
}
function h2(t, e) {
  let r = null;
  return Object.values(t).forEach((s) => {
    if (r) return;
    const n = hD(s, `${e}, namespace`);
    n && (r = n);
  }), r;
}
function dD(t, e, r) {
  let s = null;
  if (t && sa(t)) {
    const n = h2(t, e);
    n && (s = n);
    const i = cD(t, e, r);
    i && (s = i);
  } else s = Q("MISSING_OR_INVALID", `${e}, ${r} should be an object with data`);
  return s;
}
function Nu(t, e) {
  let r = null;
  if (t && sa(t)) {
    const s = h2(t, e);
    s && (r = s);
    const n = uD(t, e);
    n && (r = n);
  } else r = Q("MISSING_OR_INVALID", `${e}, namespaces should be an object with data`);
  return r;
}
function d2(t) {
  return Ve(t.protocol, !0);
}
function pD(t, e) {
  let r = !1;
  return t ? t && hi(t) && t.length && t.forEach((s) => {
    r = d2(s);
  }) : r = !0, r;
}
function fD(t) {
  return typeof t == "number";
}
function Mt(t) {
  return typeof t < "u" && typeof t !== null;
}
function mD(t) {
  return !(!t || typeof t != "object" || !t.code || !$p(t.code, !1) || !t.message || !Ve(t.message, !1));
}
function bD(t) {
  return !(ht(t) || !Ve(t.method, !1));
}
function yD(t) {
  return !(ht(t) || ht(t.result) && ht(t.error) || !$p(t.id, !1) || !Ve(t.jsonrpc, !1));
}
function gD(t) {
  return !(ht(t) || !Ve(t.name, !1));
}
function Vb(t, e) {
  return !(!pl(e) || !GB(t).includes(e));
}
function wD(t, e, r) {
  return Ve(r, !1) ? WB(t, e).includes(r) : !1;
}
function ED(t, e, r) {
  return Ve(r, !1) ? ZB(t, e).includes(r) : !1;
}
function Gb(t, e, r) {
  let s = null;
  const n = xD(t), i = vD(e), o = Object.keys(n), a = Object.keys(i), c = Wb(Object.keys(t)), l = Wb(Object.keys(e)), u = c.filter((h) => !l.includes(h));
  return u.length && (s = Q("NON_CONFORMING_NAMESPACES", `${r} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(e).toString()}`)), vn(o, a) || (s = Q("NON_CONFORMING_NAMESPACES", `${r} namespaces chains don't satisfy required namespaces.
      Required: ${o.toString()}
      Approved: ${a.toString()}`)), Object.keys(e).forEach((h) => {
    if (!h.includes(":") || s) return;
    const p = Ai(e[h].accounts);
    p.includes(h) || (s = Q("NON_CONFORMING_NAMESPACES", `${r} namespaces accounts don't satisfy namespace accounts for ${h}
        Required: ${h}
        Approved: ${p.toString()}`));
  }), o.forEach((h) => {
    s || (vn(n[h].methods, i[h].methods) ? vn(n[h].events, i[h].events) || (s = Q("NON_CONFORMING_NAMESPACES", `${r} namespaces events don't satisfy namespace events for ${h}`)) : s = Q("NON_CONFORMING_NAMESPACES", `${r} namespaces methods don't satisfy namespace methods for ${h}`));
  }), s;
}
function xD(t) {
  const e = {};
  return Object.keys(t).forEach((r) => {
    var s;
    r.includes(":") ? e[r] = t[r] : (s = t[r].chains) == null || s.forEach((n) => {
      e[n] = { methods: t[r].methods, events: t[r].events };
    });
  }), e;
}
function Wb(t) {
  return [...new Set(t.map((e) => e.includes(":") ? e.split(":")[0] : e))];
}
function vD(t) {
  const e = {};
  return Object.keys(t).forEach((r) => {
    if (r.includes(":")) e[r] = t[r];
    else {
      const s = Ai(t[r].accounts);
      s == null || s.forEach((n) => {
        e[n] = { accounts: t[r].accounts.filter((i) => i.includes(`${n}:`)), methods: t[r].methods, events: t[r].events };
      });
    }
  }), e;
}
function kD(t, e) {
  return $p(t, !1) && t <= e.max && t >= e.min;
}
function Zb() {
  const t = xa();
  return new Promise((e) => {
    switch (t) {
      case rr.browser:
        e(CD());
        break;
      case rr.reactNative:
        e(SD());
        break;
      case rr.node:
        e(ID());
        break;
      default:
        e(!0);
    }
  });
}
function CD() {
  return Ci() && (navigator == null ? void 0 : navigator.onLine);
}
async function SD() {
  if (hn() && typeof globalThis < "u" && globalThis != null && globalThis.NetInfo) {
    const t = await (globalThis == null ? void 0 : globalThis.NetInfo.fetch());
    return t == null ? void 0 : t.isConnected;
  }
  return !0;
}
function ID() {
  return !0;
}
function AD(t) {
  switch (xa()) {
    case rr.browser:
      _D(t);
      break;
    case rr.reactNative:
      TD(t);
      break;
  }
}
function _D(t) {
  !hn() && Ci() && (window.addEventListener("online", () => t(!0)), window.addEventListener("offline", () => t(!1)));
}
function TD(t) {
  hn() && typeof globalThis < "u" && globalThis != null && globalThis.NetInfo && (globalThis == null || globalThis.NetInfo.addEventListener((e) => t(e == null ? void 0 : e.isConnected)));
}
function UD() {
  var t;
  return Ci() && fr() ? ((t = fr()) == null ? void 0 : t.visibilityState) === "visible" : !0;
}
const Lu = {};
class Xi {
  static get(e) {
    return Lu[e];
  }
  static set(e, r) {
    Lu[e] = r;
  }
  static delete(e) {
    delete Lu[e];
  }
}
function $D(t) {
  const e = pa.decode(t);
  if (e.length < 33) throw new Error("Too short to contain a public key");
  return e.slice(1, 33);
}
function BD({ publicKey: t, signature: e, payload: r }) {
  var s;
  const n = ld(r.method), i = 128 | parseInt(((s = r.version) == null ? void 0 : s.toString()) || "4"), o = PD(r.address), a = r.era === "00" ? new Uint8Array([0]) : ld(r.era);
  if (a.length !== 1 && a.length !== 2) throw new Error("Invalid era length");
  const c = parseInt(r.nonce, 16), l = new Uint8Array([c & 255, c >> 8 & 255]), u = BigInt(`0x${OD(r.tip)}`), h = ND(u), p = new Uint8Array([0, ...t, o, ...e, ...a, ...l, ...h, ...n]), y = RD(p.length + 1);
  return new Uint8Array([...y, i, ...p]);
}
function DD(t) {
  const e = ld(t), r = n5.blake2b(e, void 0, 32);
  return "0x" + Buffer.from(r).toString("hex");
}
function ld(t) {
  return new Uint8Array(t.replace(/^0x/, "").match(/.{1,2}/g).map((e) => parseInt(e, 16)));
}
function OD(t) {
  return t.startsWith("0x") ? t.slice(2) : t;
}
function PD(t) {
  const e = pa.decode(t)[0];
  return e === 42 ? 0 : e === 60 ? 2 : 1;
}
function RD(t) {
  if (t < 64) return new Uint8Array([t << 2]);
  if (t < 16384) {
    const e = t << 2 | 1;
    return new Uint8Array([e & 255, e >> 8 & 255]);
  } else if (t < 1 << 30) {
    const e = t << 2 | 2;
    return new Uint8Array([e & 255, e >> 8 & 255, e >> 16 & 255, e >> 24 & 255]);
  } else throw new Error("Compact encoding > 2^30 not supported");
}
function ND(t) {
  if (t < BigInt(1) << BigInt(6)) return new Uint8Array([Number(t << BigInt(2))]);
  if (t < BigInt(1) << BigInt(14)) {
    const e = t << BigInt(2) | BigInt(1);
    return new Uint8Array([Number(e & BigInt(255)), Number(e >> BigInt(8) & BigInt(255))]);
  } else if (t < BigInt(1) << BigInt(30)) {
    const e = t << BigInt(2) | BigInt(2);
    return new Uint8Array([Number(e & BigInt(255)), Number(e >> BigInt(8) & BigInt(255)), Number(e >> BigInt(16) & BigInt(255)), Number(e >> BigInt(24) & BigInt(255))]);
  } else throw new Error("BigInt compact encoding not supported > 2^30");
}
function LD(t) {
  const e = Uint8Array.from(Buffer.from(t.signature, "hex")), r = $D(t.transaction.address), s = BD({ publicKey: r, signature: e, payload: t.transaction }), n = Buffer.from(s).toString("hex");
  return DD(n);
}
const p2 = "wc", f2 = 2, ud = "core", es = `${p2}@2:${ud}:`, MD = { logger: "error" }, FD = { database: ":memory:" }, zD = "crypto", Jb = "client_ed25519_seed", jD = V.ONE_DAY, HD = "keychain", qD = "0.3", KD = "messages", VD = "0.3", Xb = V.SIX_HOURS, GD = "publisher", m2 = "irn", WD = "error", b2 = "wss://relay.walletconnect.org", ZD = "relayer", tt = { message: "relayer_message", message_ack: "relayer_message_ack", connect: "relayer_connect", disconnect: "relayer_disconnect", error: "relayer_error", connection_stalled: "relayer_connection_stalled", transport_closed: "relayer_transport_closed", publish: "relayer_publish" }, JD = "_subscription", lr = { payload: "payload", connect: "connect", disconnect: "disconnect", error: "error" }, XD = 0.1, hd = "2.21.4", Re = { link_mode: "link_mode", relay: "relay" }, Hc = { inbound: "inbound", outbound: "outbound" }, YD = "0.3", QD = "WALLETCONNECT_CLIENT_ID", Yb = "WALLETCONNECT_LINK_MODE_APPS", er = { created: "subscription_created", deleted: "subscription_deleted", expired: "subscription_expired", disabled: "subscription_disabled", sync: "subscription_sync", resubscribed: "subscription_resubscribed" }, eO = "subscription", tO = "0.3", rO = "pairing", sO = "0.3", Yi = { wc_pairingDelete: { req: { ttl: V.ONE_DAY, prompt: !1, tag: 1e3 }, res: { ttl: V.ONE_DAY, prompt: !1, tag: 1001 } }, wc_pairingPing: { req: { ttl: V.THIRTY_SECONDS, prompt: !1, tag: 1002 }, res: { ttl: V.THIRTY_SECONDS, prompt: !1, tag: 1003 } }, unregistered_method: { req: { ttl: V.ONE_DAY, prompt: !1, tag: 0 }, res: { ttl: V.ONE_DAY, prompt: !1, tag: 0 } } }, gn = { create: "pairing_create", expire: "pairing_expire", delete: "pairing_delete", ping: "pairing_ping" }, Cr = { created: "history_created", updated: "history_updated", deleted: "history_deleted", sync: "history_sync" }, nO = "history", iO = "0.3", oO = "expirer", ur = { created: "expirer_created", deleted: "expirer_deleted", expired: "expirer_expired", sync: "expirer_sync" }, aO = "0.3", cO = "verify-api", lO = "https://verify.walletconnect.com", y2 = "https://verify.walletconnect.org", jo = y2, uO = `${jo}/v3`, hO = [lO, y2], dO = "echo", pO = "https://echo.walletconnect.com", Vr = { pairing_started: "pairing_started", pairing_uri_validation_success: "pairing_uri_validation_success", pairing_uri_not_expired: "pairing_uri_not_expired", store_new_pairing: "store_new_pairing", subscribing_pairing_topic: "subscribing_pairing_topic", subscribe_pairing_topic_success: "subscribe_pairing_topic_success", existing_pairing: "existing_pairing", pairing_not_expired: "pairing_not_expired", emit_inactive_pairing: "emit_inactive_pairing", emit_session_proposal: "emit_session_proposal", subscribing_to_pairing_topic: "subscribing_to_pairing_topic" }, bs = { no_wss_connection: "no_wss_connection", no_internet_connection: "no_internet_connection", malformed_pairing_uri: "malformed_pairing_uri", active_pairing_already_exists: "active_pairing_already_exists", subscribe_pairing_topic_failure: "subscribe_pairing_topic_failure", pairing_expired: "pairing_expired", proposal_expired: "proposal_expired", proposal_listener_not_found: "proposal_listener_not_found" }, Sr = { session_approve_started: "session_approve_started", proposal_not_expired: "proposal_not_expired", session_namespaces_validation_success: "session_namespaces_validation_success", create_session_topic: "create_session_topic", subscribing_session_topic: "subscribing_session_topic", subscribe_session_topic_success: "subscribe_session_topic_success", publishing_session_approve: "publishing_session_approve", session_approve_publish_success: "session_approve_publish_success", store_session: "store_session", publishing_session_settle: "publishing_session_settle", session_settle_publish_success: "session_settle_publish_success" }, fn = { no_internet_connection: "no_internet_connection", no_wss_connection: "no_wss_connection", proposal_expired: "proposal_expired", subscribe_session_topic_failure: "subscribe_session_topic_failure", session_approve_publish_failure: "session_approve_publish_failure", session_settle_publish_failure: "session_settle_publish_failure", session_approve_namespace_validation_failure: "session_approve_namespace_validation_failure", proposal_not_found: "proposal_not_found" }, mn = { authenticated_session_approve_started: "authenticated_session_approve_started", create_authenticated_session_topic: "create_authenticated_session_topic", cacaos_verified: "cacaos_verified", store_authenticated_session: "store_authenticated_session", subscribing_authenticated_session_topic: "subscribing_authenticated_session_topic", subscribe_authenticated_session_topic_success: "subscribe_authenticated_session_topic_success", publishing_authenticated_session_approve: "publishing_authenticated_session_approve" }, Qi = { no_internet_connection: "no_internet_connection", invalid_cacao: "invalid_cacao", subscribe_authenticated_session_topic_failure: "subscribe_authenticated_session_topic_failure", authenticated_session_approve_publish_failure: "authenticated_session_approve_publish_failure", authenticated_session_pending_request_not_found: "authenticated_session_pending_request_not_found" }, fO = 0.1, mO = "event-client", bO = 86400, yO = "https://pulse.walletconnect.org/batch";
function gO(t, e) {
  if (t.length >= 255) throw new TypeError("Alphabet too long");
  for (var r = new Uint8Array(256), s = 0; s < r.length; s++) r[s] = 255;
  for (var n = 0; n < t.length; n++) {
    var i = t.charAt(n), o = i.charCodeAt(0);
    if (r[o] !== 255) throw new TypeError(i + " is ambiguous");
    r[o] = n;
  }
  var a = t.length, c = t.charAt(0), l = Math.log(a) / Math.log(256), u = Math.log(256) / Math.log(a);
  function h(b) {
    if (b instanceof Uint8Array || (ArrayBuffer.isView(b) ? b = new Uint8Array(b.buffer, b.byteOffset, b.byteLength) : Array.isArray(b) && (b = Uint8Array.from(b))), !(b instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
    if (b.length === 0) return "";
    for (var g = 0, x = 0, I = 0, U = b.length; I !== U && b[I] === 0; ) I++, g++;
    for (var A = (U - I) * u + 1 >>> 0, M = new Uint8Array(A); I !== U; ) {
      for (var B = b[I], q = 0, H = A - 1; (B !== 0 || q < x) && H !== -1; H--, q++) B += 256 * M[H] >>> 0, M[H] = B % a >>> 0, B = B / a >>> 0;
      if (B !== 0) throw new Error("Non-zero carry");
      x = q, I++;
    }
    for (var F = A - x; F !== A && M[F] === 0; ) F++;
    for (var w = c.repeat(g); F < A; ++F) w += t.charAt(M[F]);
    return w;
  }
  function p(b) {
    if (typeof b != "string") throw new TypeError("Expected String");
    if (b.length === 0) return new Uint8Array();
    var g = 0;
    if (b[g] !== " ") {
      for (var x = 0, I = 0; b[g] === c; ) x++, g++;
      for (var U = (b.length - g) * l + 1 >>> 0, A = new Uint8Array(U); b[g]; ) {
        var M = r[b.charCodeAt(g)];
        if (M === 255) return;
        for (var B = 0, q = U - 1; (M !== 0 || B < I) && q !== -1; q--, B++) M += a * A[q] >>> 0, A[q] = M % 256 >>> 0, M = M / 256 >>> 0;
        if (M !== 0) throw new Error("Non-zero carry");
        I = B, g++;
      }
      if (b[g] !== " ") {
        for (var H = U - I; H !== U && A[H] === 0; ) H++;
        for (var F = new Uint8Array(x + (U - H)), w = x; H !== U; ) F[w++] = A[H++];
        return F;
      }
    }
  }
  function y(b) {
    var g = p(b);
    if (g) return g;
    throw new Error(`Non-${e} character`);
  }
  return { encode: h, decodeUnsafe: p, decode: y };
}
var wO = gO, EO = wO;
const g2 = (t) => {
  if (t instanceof Uint8Array && t.constructor.name === "Uint8Array") return t;
  if (t instanceof ArrayBuffer) return new Uint8Array(t);
  if (ArrayBuffer.isView(t)) return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  throw new Error("Unknown type, must be binary type");
}, xO = (t) => new TextEncoder().encode(t), vO = (t) => new TextDecoder().decode(t);
class kO {
  constructor(e, r, s) {
    this.name = e, this.prefix = r, this.baseEncode = s;
  }
  encode(e) {
    if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
    throw Error("Unknown type, must be binary type");
  }
}
class CO {
  constructor(e, r, s) {
    if (this.name = e, this.prefix = r, r.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
    this.prefixCodePoint = r.codePointAt(0), this.baseDecode = s;
  }
  decode(e) {
    if (typeof e == "string") {
      if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
      return this.baseDecode(e.slice(this.prefix.length));
    } else throw Error("Can only multibase decode strings");
  }
  or(e) {
    return w2(this, e);
  }
}
class SO {
  constructor(e) {
    this.decoders = e;
  }
  or(e) {
    return w2(this, e);
  }
  decode(e) {
    const r = e[0], s = this.decoders[r];
    if (s) return s.decode(e);
    throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
  }
}
const w2 = (t, e) => new SO({ ...t.decoders || { [t.prefix]: t }, ...e.decoders || { [e.prefix]: e } });
class IO {
  constructor(e, r, s, n) {
    this.name = e, this.prefix = r, this.baseEncode = s, this.baseDecode = n, this.encoder = new kO(e, r, s), this.decoder = new CO(e, r, n);
  }
  encode(e) {
    return this.encoder.encode(e);
  }
  decode(e) {
    return this.decoder.decode(e);
  }
}
const zl = ({ name: t, prefix: e, encode: r, decode: s }) => new IO(t, e, r, s), Sa = ({ prefix: t, name: e, alphabet: r }) => {
  const { encode: s, decode: n } = EO(r, e);
  return zl({ prefix: t, name: e, encode: s, decode: (i) => g2(n(i)) });
}, AO = (t, e, r, s) => {
  const n = {};
  for (let u = 0; u < e.length; ++u) n[e[u]] = u;
  let i = t.length;
  for (; t[i - 1] === "="; ) --i;
  const o = new Uint8Array(i * r / 8 | 0);
  let a = 0, c = 0, l = 0;
  for (let u = 0; u < i; ++u) {
    const h = n[t[u]];
    if (h === void 0) throw new SyntaxError(`Non-${s} character`);
    c = c << r | h, a += r, a >= 8 && (a -= 8, o[l++] = 255 & c >> a);
  }
  if (a >= r || 255 & c << 8 - a) throw new SyntaxError("Unexpected end of data");
  return o;
}, _O = (t, e, r) => {
  const s = e[e.length - 1] === "=", n = (1 << r) - 1;
  let i = "", o = 0, a = 0;
  for (let c = 0; c < t.length; ++c) for (a = a << 8 | t[c], o += 8; o > r; ) o -= r, i += e[n & a >> o];
  if (o && (i += e[n & a << r - o]), s) for (; i.length * r & 7; ) i += "=";
  return i;
}, bt = ({ name: t, prefix: e, bitsPerChar: r, alphabet: s }) => zl({ prefix: e, name: t, encode(n) {
  return _O(n, s, r);
}, decode(n) {
  return AO(n, s, r, t);
} }), TO = zl({ prefix: "\0", name: "identity", encode: (t) => vO(t), decode: (t) => xO(t) });
var UO = Object.freeze({ __proto__: null, identity: TO });
const $O = bt({ prefix: "0", name: "base2", alphabet: "01", bitsPerChar: 1 });
var BO = Object.freeze({ __proto__: null, base2: $O });
const DO = bt({ prefix: "7", name: "base8", alphabet: "01234567", bitsPerChar: 3 });
var OO = Object.freeze({ __proto__: null, base8: DO });
const PO = Sa({ prefix: "9", name: "base10", alphabet: "0123456789" });
var RO = Object.freeze({ __proto__: null, base10: PO });
const NO = bt({ prefix: "f", name: "base16", alphabet: "0123456789abcdef", bitsPerChar: 4 }), LO = bt({ prefix: "F", name: "base16upper", alphabet: "0123456789ABCDEF", bitsPerChar: 4 });
var MO = Object.freeze({ __proto__: null, base16: NO, base16upper: LO });
const FO = bt({ prefix: "b", name: "base32", alphabet: "abcdefghijklmnopqrstuvwxyz234567", bitsPerChar: 5 }), zO = bt({ prefix: "B", name: "base32upper", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567", bitsPerChar: 5 }), jO = bt({ prefix: "c", name: "base32pad", alphabet: "abcdefghijklmnopqrstuvwxyz234567=", bitsPerChar: 5 }), HO = bt({ prefix: "C", name: "base32padupper", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=", bitsPerChar: 5 }), qO = bt({ prefix: "v", name: "base32hex", alphabet: "0123456789abcdefghijklmnopqrstuv", bitsPerChar: 5 }), KO = bt({ prefix: "V", name: "base32hexupper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV", bitsPerChar: 5 }), VO = bt({ prefix: "t", name: "base32hexpad", alphabet: "0123456789abcdefghijklmnopqrstuv=", bitsPerChar: 5 }), GO = bt({ prefix: "T", name: "base32hexpadupper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=", bitsPerChar: 5 }), WO = bt({ prefix: "h", name: "base32z", alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769", bitsPerChar: 5 });
var ZO = Object.freeze({ __proto__: null, base32: FO, base32upper: zO, base32pad: jO, base32padupper: HO, base32hex: qO, base32hexupper: KO, base32hexpad: VO, base32hexpadupper: GO, base32z: WO });
const JO = Sa({ prefix: "k", name: "base36", alphabet: "0123456789abcdefghijklmnopqrstuvwxyz" }), XO = Sa({ prefix: "K", name: "base36upper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ" });
var YO = Object.freeze({ __proto__: null, base36: JO, base36upper: XO });
const QO = Sa({ name: "base58btc", prefix: "z", alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz" }), eP = Sa({ name: "base58flickr", prefix: "Z", alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ" });
var tP = Object.freeze({ __proto__: null, base58btc: QO, base58flickr: eP });
const rP = bt({ prefix: "m", name: "base64", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", bitsPerChar: 6 }), sP = bt({ prefix: "M", name: "base64pad", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", bitsPerChar: 6 }), nP = bt({ prefix: "u", name: "base64url", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", bitsPerChar: 6 }), iP = bt({ prefix: "U", name: "base64urlpad", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=", bitsPerChar: 6 });
var oP = Object.freeze({ __proto__: null, base64: rP, base64pad: sP, base64url: nP, base64urlpad: iP });
const E2 = Array.from("🚀🪐☄🛰🌌🌑🌒🌓🌔🌕🌖🌗🌘🌍🌏🌎🐉☀💻🖥💾💿😂❤😍🤣😊🙏💕😭😘👍😅👏😁🔥🥰💔💖💙😢🤔😆🙄💪😉☺👌🤗💜😔😎😇🌹🤦🎉💞✌✨🤷😱😌🌸🙌😋💗💚😏💛🙂💓🤩😄😀🖤😃💯🙈👇🎶😒🤭❣😜💋👀😪😑💥🙋😞😩😡🤪👊🥳😥🤤👉💃😳✋😚😝😴🌟😬🙃🍀🌷😻😓⭐✅🥺🌈😈🤘💦✔😣🏃💐☹🎊💘😠☝😕🌺🎂🌻😐🖕💝🙊😹🗣💫💀👑🎵🤞😛🔴😤🌼😫⚽🤙☕🏆🤫👈😮🙆🍻🍃🐶💁😲🌿🧡🎁⚡🌞🎈❌✊👋😰🤨😶🤝🚶💰🍓💢🤟🙁🚨💨🤬✈🎀🍺🤓😙💟🌱😖👶🥴▶➡❓💎💸⬇😨🌚🦋😷🕺⚠🙅😟😵👎🤲🤠🤧📌🔵💅🧐🐾🍒😗🤑🌊🤯🐷☎💧😯💆👆🎤🙇🍑❄🌴💣🐸💌📍🥀🤢👅💡💩👐📸👻🤐🤮🎼🥵🚩🍎🍊👼💍📣🥂"), aP = E2.reduce((t, e, r) => (t[r] = e, t), []), cP = E2.reduce((t, e, r) => (t[e.codePointAt(0)] = r, t), []);
function lP(t) {
  return t.reduce((e, r) => (e += aP[r], e), "");
}
function uP(t) {
  const e = [];
  for (const r of t) {
    const s = cP[r.codePointAt(0)];
    if (s === void 0) throw new Error(`Non-base256emoji character: ${r}`);
    e.push(s);
  }
  return new Uint8Array(e);
}
const hP = zl({ prefix: "🚀", name: "base256emoji", encode: lP, decode: uP });
var dP = Object.freeze({ __proto__: null, base256emoji: hP }), pP = x2, Qb = 128, fP = -128, mP = Math.pow(2, 31);
function x2(t, e, r) {
  e = e || [], r = r || 0;
  for (var s = r; t >= mP; ) e[r++] = t & 255 | Qb, t /= 128;
  for (; t & fP; ) e[r++] = t & 255 | Qb, t >>>= 7;
  return e[r] = t | 0, x2.bytes = r - s + 1, e;
}
var bP = dd, yP = 128, e1 = 127;
function dd(t, s) {
  var r = 0, s = s || 0, n = 0, i = s, o, a = t.length;
  do {
    if (i >= a) throw dd.bytes = 0, new RangeError("Could not decode varint");
    o = t[i++], r += n < 28 ? (o & e1) << n : (o & e1) * Math.pow(2, n), n += 7;
  } while (o >= yP);
  return dd.bytes = i - s, r;
}
var gP = Math.pow(2, 7), wP = Math.pow(2, 14), EP = Math.pow(2, 21), xP = Math.pow(2, 28), vP = Math.pow(2, 35), kP = Math.pow(2, 42), CP = Math.pow(2, 49), SP = Math.pow(2, 56), IP = Math.pow(2, 63), AP = function(t) {
  return t < gP ? 1 : t < wP ? 2 : t < EP ? 3 : t < xP ? 4 : t < vP ? 5 : t < kP ? 6 : t < CP ? 7 : t < SP ? 8 : t < IP ? 9 : 10;
}, _P = { encode: pP, decode: bP, encodingLength: AP }, v2 = _P;
const t1 = (t, e, r = 0) => (v2.encode(t, e, r), e), r1 = (t) => v2.encodingLength(t), pd = (t, e) => {
  const r = e.byteLength, s = r1(t), n = s + r1(r), i = new Uint8Array(n + r);
  return t1(t, i, 0), t1(r, i, s), i.set(e, n), new TP(t, r, e, i);
};
class TP {
  constructor(e, r, s, n) {
    this.code = e, this.size = r, this.digest = s, this.bytes = n;
  }
}
const k2 = ({ name: t, code: e, encode: r }) => new UP(t, e, r);
class UP {
  constructor(e, r, s) {
    this.name = e, this.code = r, this.encode = s;
  }
  digest(e) {
    if (e instanceof Uint8Array) {
      const r = this.encode(e);
      return r instanceof Uint8Array ? pd(this.code, r) : r.then((s) => pd(this.code, s));
    } else throw Error("Unknown type, must be binary type");
  }
}
const C2 = (t) => async (e) => new Uint8Array(await crypto.subtle.digest(t, e)), $P = k2({ name: "sha2-256", code: 18, encode: C2("SHA-256") }), BP = k2({ name: "sha2-512", code: 19, encode: C2("SHA-512") });
var DP = Object.freeze({ __proto__: null, sha256: $P, sha512: BP });
const S2 = 0, OP = "identity", I2 = g2, PP = (t) => pd(S2, I2(t)), RP = { code: S2, name: OP, encode: I2, digest: PP };
var NP = Object.freeze({ __proto__: null, identity: RP });
new TextEncoder(), new TextDecoder();
const s1 = { ...UO, ...BO, ...OO, ...RO, ...MO, ...ZO, ...YO, ...tP, ...oP, ...dP };
({ ...DP, ...NP });
function A2(t) {
  return globalThis.Buffer != null ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : t;
}
function LP(t = 0) {
  return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? A2(globalThis.Buffer.allocUnsafe(t)) : new Uint8Array(t);
}
function _2(t, e, r, s) {
  return { name: t, prefix: e, encoder: { name: t, prefix: e, encode: r }, decoder: { decode: s } };
}
const n1 = _2("utf8", "u", (t) => "u" + new TextDecoder("utf8").decode(t), (t) => new TextEncoder().encode(t.substring(1))), Mu = _2("ascii", "a", (t) => {
  let e = "a";
  for (let r = 0; r < t.length; r++) e += String.fromCharCode(t[r]);
  return e;
}, (t) => {
  t = t.substring(1);
  const e = LP(t.length);
  for (let r = 0; r < t.length; r++) e[r] = t.charCodeAt(r);
  return e;
}), MP = { utf8: n1, "utf-8": n1, hex: s1.base16, latin1: Mu, ascii: Mu, binary: Mu, ...s1 };
function FP(t, e = "utf8") {
  const r = MP[e];
  if (!r) throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? A2(globalThis.Buffer.from(t, "utf-8")) : r.decoder.decode(`${r.prefix}${t}`);
}
var zP = Object.defineProperty, jP = (t, e, r) => e in t ? zP(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, qr = (t, e, r) => jP(t, typeof e != "symbol" ? e + "" : e, r);
class HP {
  constructor(e, r) {
    this.core = e, this.logger = r, qr(this, "keychain", /* @__PURE__ */ new Map()), qr(this, "name", HD), qr(this, "version", qD), qr(this, "initialized", !1), qr(this, "storagePrefix", es), qr(this, "init", async () => {
      if (!this.initialized) {
        const s = await this.getKeyChain();
        typeof s < "u" && (this.keychain = s), this.initialized = !0;
      }
    }), qr(this, "has", (s) => (this.isInitialized(), this.keychain.has(s))), qr(this, "set", async (s, n) => {
      this.isInitialized(), this.keychain.set(s, n), await this.persist();
    }), qr(this, "get", (s) => {
      this.isInitialized();
      const n = this.keychain.get(s);
      if (typeof n > "u") {
        const { message: i } = Q("NO_MATCHING_KEY", `${this.name}: ${s}`);
        throw new Error(i);
      }
      return n;
    }), qr(this, "del", async (s) => {
      this.isInitialized(), this.keychain.delete(s), await this.persist();
    }), this.core = e, this.logger = ve(r, this.name);
  }
  get context() {
    return De(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  async setKeyChain(e) {
    await this.core.storage.setItem(this.storageKey, Xh(e));
  }
  async getKeyChain() {
    const e = await this.core.storage.getItem(this.storageKey);
    return typeof e < "u" ? Yh(e) : void 0;
  }
  async persist() {
    await this.setKeyChain(this.keychain);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Q("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
var qP = Object.defineProperty, KP = (t, e, r) => e in t ? qP(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, lt = (t, e, r) => KP(t, typeof e != "symbol" ? e + "" : e, r);
class VP {
  constructor(e, r, s) {
    this.core = e, this.logger = r, lt(this, "name", zD), lt(this, "keychain"), lt(this, "randomSessionIdentifier", cd()), lt(this, "initialized", !1), lt(this, "init", async () => {
      this.initialized || (await this.keychain.init(), this.initialized = !0);
    }), lt(this, "hasKeys", (n) => (this.isInitialized(), this.keychain.has(n))), lt(this, "getClientId", async () => {
      this.isInitialized();
      const n = await this.getClientSeed(), i = Xc(n);
      return Gd(i.publicKey);
    }), lt(this, "generateKeyPair", () => {
      this.isInitialized();
      const n = AB();
      return this.setPrivateKey(n.publicKey, n.privateKey);
    }), lt(this, "signJWT", async (n) => {
      this.isInitialized();
      const i = await this.getClientSeed(), o = Xc(i), a = this.randomSessionIdentifier;
      return await cy(a, n, jD, o);
    }), lt(this, "generateSharedKey", (n, i, o) => {
      this.isInitialized();
      const a = this.getPrivateKey(n), c = _B(a, i);
      return this.setSymKey(c, o);
    }), lt(this, "setSymKey", async (n, i) => {
      this.isInitialized();
      const o = i || jc(n);
      return await this.keychain.set(o, n), o;
    }), lt(this, "deleteKeyPair", async (n) => {
      this.isInitialized(), await this.keychain.del(n);
    }), lt(this, "deleteSymKey", async (n) => {
      this.isInitialized(), await this.keychain.del(n);
    }), lt(this, "encode", async (n, i, o) => {
      this.isInitialized();
      const a = l2(o), c = an(i);
      if (Lb(a)) return $B(c, o == null ? void 0 : o.encoding);
      if (Nb(a)) {
        const p = a.senderPublicKey, y = a.receiverPublicKey;
        n = await this.generateSharedKey(p, y);
      }
      const l = this.getSymKey(n), { type: u, senderPublicKey: h } = a;
      return TB({ type: u, symKey: l, message: c, senderPublicKey: h, encoding: o == null ? void 0 : o.encoding });
    }), lt(this, "decode", async (n, i, o) => {
      this.isInitialized();
      const a = DB(i, o);
      if (Lb(a)) {
        const c = BB(i, o == null ? void 0 : o.encoding);
        return on(c);
      }
      if (Nb(a)) {
        const c = a.receiverPublicKey, l = a.senderPublicKey;
        n = await this.generateSharedKey(c, l);
      }
      try {
        const c = this.getSymKey(n), l = UB({ symKey: c, encoded: i, encoding: o == null ? void 0 : o.encoding });
        return on(l);
      } catch (c) {
        this.logger.error(`Failed to decode message from topic: '${n}', clientId: '${await this.getClientId()}'`), this.logger.error(c);
      }
    }), lt(this, "getPayloadType", (n, i = Pr) => {
      const o = ra({ encoded: n, encoding: i });
      return $n(o.type);
    }), lt(this, "getPayloadSenderPublicKey", (n, i = Pr) => {
      const o = ra({ encoded: n, encoding: i });
      return o.senderPublicKey ? Ce(o.senderPublicKey, Dt) : void 0;
    }), this.core = e, this.logger = ve(r, this.name), this.keychain = s || new HP(this.core, this.logger);
  }
  get context() {
    return De(this.logger);
  }
  async setPrivateKey(e, r) {
    return await this.keychain.set(e, r), e;
  }
  getPrivateKey(e) {
    return this.keychain.get(e);
  }
  async getClientSeed() {
    let e = "";
    try {
      e = this.keychain.get(Jb);
    } catch {
      e = cd(), await this.keychain.set(Jb, e);
    }
    return FP(e, "base16");
  }
  getSymKey(e) {
    return this.keychain.get(e);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Q("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
var GP = Object.defineProperty, WP = Object.defineProperties, ZP = Object.getOwnPropertyDescriptors, i1 = Object.getOwnPropertySymbols, JP = Object.prototype.hasOwnProperty, XP = Object.prototype.propertyIsEnumerable, fd = (t, e, r) => e in t ? GP(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, YP = (t, e) => {
  for (var r in e || (e = {})) JP.call(e, r) && fd(t, r, e[r]);
  if (i1) for (var r of i1(e)) XP.call(e, r) && fd(t, r, e[r]);
  return t;
}, QP = (t, e) => WP(t, ZP(e)), Jt = (t, e, r) => fd(t, typeof e != "symbol" ? e + "" : e, r);
class eR extends hT {
  constructor(e, r) {
    super(e, r), this.logger = e, this.core = r, Jt(this, "messages", /* @__PURE__ */ new Map()), Jt(this, "messagesWithoutClientAck", /* @__PURE__ */ new Map()), Jt(this, "name", KD), Jt(this, "version", VD), Jt(this, "initialized", !1), Jt(this, "storagePrefix", es), Jt(this, "init", async () => {
      if (!this.initialized) {
        this.logger.trace("Initialized");
        try {
          const s = await this.getRelayerMessages();
          typeof s < "u" && (this.messages = s);
          const n = await this.getRelayerMessagesWithoutClientAck();
          typeof n < "u" && (this.messagesWithoutClientAck = n), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({ type: "method", method: "restore", size: this.messages.size });
        } catch (s) {
          this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(s);
        } finally {
          this.initialized = !0;
        }
      }
    }), Jt(this, "set", async (s, n, i) => {
      this.isInitialized();
      const o = Wr(n);
      let a = this.messages.get(s);
      if (typeof a > "u" && (a = {}), typeof a[o] < "u") return o;
      if (a[o] = n, this.messages.set(s, a), i === Hc.inbound) {
        const c = this.messagesWithoutClientAck.get(s) || {};
        this.messagesWithoutClientAck.set(s, QP(YP({}, c), { [o]: n }));
      }
      return await this.persist(), o;
    }), Jt(this, "get", (s) => {
      this.isInitialized();
      let n = this.messages.get(s);
      return typeof n > "u" && (n = {}), n;
    }), Jt(this, "getWithoutAck", (s) => {
      this.isInitialized();
      const n = {};
      for (const i of s) {
        const o = this.messagesWithoutClientAck.get(i) || {};
        n[i] = Object.values(o);
      }
      return n;
    }), Jt(this, "has", (s, n) => {
      this.isInitialized();
      const i = this.get(s), o = Wr(n);
      return typeof i[o] < "u";
    }), Jt(this, "ack", async (s, n) => {
      this.isInitialized();
      const i = this.messagesWithoutClientAck.get(s);
      if (typeof i > "u") return;
      const o = Wr(n);
      delete i[o], Object.keys(i).length === 0 ? this.messagesWithoutClientAck.delete(s) : this.messagesWithoutClientAck.set(s, i), await this.persist();
    }), Jt(this, "del", async (s) => {
      this.isInitialized(), this.messages.delete(s), this.messagesWithoutClientAck.delete(s), await this.persist();
    }), this.logger = ve(e, this.name), this.core = r;
  }
  get context() {
    return De(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get storageKeyWithoutClientAck() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name + "_withoutClientAck";
  }
  async setRelayerMessages(e) {
    await this.core.storage.setItem(this.storageKey, Xh(e));
  }
  async setRelayerMessagesWithoutClientAck(e) {
    await this.core.storage.setItem(this.storageKeyWithoutClientAck, Xh(e));
  }
  async getRelayerMessages() {
    const e = await this.core.storage.getItem(this.storageKey);
    return typeof e < "u" ? Yh(e) : void 0;
  }
  async getRelayerMessagesWithoutClientAck() {
    const e = await this.core.storage.getItem(this.storageKeyWithoutClientAck);
    return typeof e < "u" ? Yh(e) : void 0;
  }
  async persist() {
    await this.setRelayerMessages(this.messages), await this.setRelayerMessagesWithoutClientAck(this.messagesWithoutClientAck);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Q("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
var tR = Object.defineProperty, rR = Object.defineProperties, sR = Object.getOwnPropertyDescriptors, o1 = Object.getOwnPropertySymbols, nR = Object.prototype.hasOwnProperty, iR = Object.prototype.propertyIsEnumerable, md = (t, e, r) => e in t ? tR(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, rc = (t, e) => {
  for (var r in e || (e = {})) nR.call(e, r) && md(t, r, e[r]);
  if (o1) for (var r of o1(e)) iR.call(e, r) && md(t, r, e[r]);
  return t;
}, Fu = (t, e) => rR(t, sR(e)), Ir = (t, e, r) => md(t, typeof e != "symbol" ? e + "" : e, r);
class oR extends dT {
  constructor(e, r) {
    super(e, r), this.relayer = e, this.logger = r, Ir(this, "events", new dt.EventEmitter()), Ir(this, "name", GD), Ir(this, "queue", /* @__PURE__ */ new Map()), Ir(this, "publishTimeout", V.toMiliseconds(V.ONE_MINUTE)), Ir(this, "initialPublishTimeout", V.toMiliseconds(V.ONE_SECOND * 15)), Ir(this, "needsTransportRestart", !1), Ir(this, "publish", async (s, n, i) => {
      var o;
      this.logger.debug("Publishing Payload"), this.logger.trace({ type: "method", method: "publish", params: { topic: s, message: n, opts: i } });
      const a = (i == null ? void 0 : i.ttl) || Xb, c = dl(i), l = (i == null ? void 0 : i.prompt) || !1, u = (i == null ? void 0 : i.tag) || 0, h = (i == null ? void 0 : i.id) || ws().toString(), p = { topic: s, message: n, opts: { ttl: a, relay: c, prompt: l, tag: u, id: h, attestation: i == null ? void 0 : i.attestation, tvf: i == null ? void 0 : i.tvf } }, y = `Failed to publish payload, please try again. id:${h} tag:${u}`;
      try {
        const b = new Promise(async (g) => {
          const x = ({ id: U }) => {
            p.opts.id === U && (this.removeRequestFromQueue(U), this.relayer.events.removeListener(tt.publish, x), g(p));
          };
          this.relayer.events.on(tt.publish, x);
          const I = rn(new Promise((U, A) => {
            this.rpcPublish({ topic: s, message: n, ttl: a, prompt: l, tag: u, id: h, attestation: i == null ? void 0 : i.attestation, tvf: i == null ? void 0 : i.tvf }).then(U).catch((M) => {
              this.logger.warn(M, M == null ? void 0 : M.message), A(M);
            });
          }), this.initialPublishTimeout, `Failed initial publish, retrying.... id:${h} tag:${u}`);
          try {
            await I, this.events.removeListener(tt.publish, x);
          } catch (U) {
            this.queue.set(h, Fu(rc({}, p), { attempt: 1 })), this.logger.warn(U, U == null ? void 0 : U.message);
          }
        });
        this.logger.trace({ type: "method", method: "publish", params: { id: h, topic: s, message: n, opts: i } }), await rn(b, this.publishTimeout, y);
      } catch (b) {
        if (this.logger.debug("Failed to Publish Payload"), this.logger.error(b), (o = i == null ? void 0 : i.internal) != null && o.throwOnFailedPublish) throw b;
      } finally {
        this.queue.delete(h);
      }
    }), Ir(this, "on", (s, n) => {
      this.events.on(s, n);
    }), Ir(this, "once", (s, n) => {
      this.events.once(s, n);
    }), Ir(this, "off", (s, n) => {
      this.events.off(s, n);
    }), Ir(this, "removeListener", (s, n) => {
      this.events.removeListener(s, n);
    }), this.relayer = e, this.logger = ve(r, this.name), this.registerEventListeners();
  }
  get context() {
    return De(this.logger);
  }
  async rpcPublish(e) {
    var r, s, n, i;
    const { topic: o, message: a, ttl: c = Xb, prompt: l, tag: u, id: h, attestation: p, tvf: y } = e, b = { method: Ao(dl().protocol).publish, params: rc({ topic: o, message: a, ttl: c, prompt: l, tag: u, attestation: p }, y), id: h };
    ht((r = b.params) == null ? void 0 : r.prompt) && ((s = b.params) == null || delete s.prompt), ht((n = b.params) == null ? void 0 : n.tag) && ((i = b.params) == null || delete i.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "message", direction: "outgoing", request: b });
    const g = await this.relayer.request(b);
    return this.relayer.events.emit(tt.publish, e), this.logger.debug("Successfully Published Payload"), g;
  }
  removeRequestFromQueue(e) {
    this.queue.delete(e);
  }
  checkQueue() {
    this.queue.forEach(async (e, r) => {
      const s = e.attempt + 1;
      this.queue.set(r, Fu(rc({}, e), { attempt: s }));
      const { topic: n, message: i, opts: o, attestation: a } = e;
      this.logger.warn({}, `Publisher: queue->publishing: ${e.opts.id}, tag: ${e.opts.tag}, attempt: ${s}`), await this.rpcPublish(Fu(rc({}, e), { topic: n, message: i, ttl: o.ttl, prompt: o.prompt, tag: o.tag, id: o.id, attestation: a, tvf: o.tvf })), this.logger.warn({}, `Publisher: queue->published: ${e.opts.id}`);
    });
  }
  registerEventListeners() {
    this.relayer.core.heartbeat.on(ir.pulse, () => {
      if (this.needsTransportRestart) {
        this.needsTransportRestart = !1, this.relayer.events.emit(tt.connection_stalled);
        return;
      }
      this.checkQueue();
    }), this.relayer.on(tt.message_ack, (e) => {
      this.removeRequestFromQueue(e.id.toString());
    });
  }
}
var aR = Object.defineProperty, cR = (t, e, r) => e in t ? aR(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Jn = (t, e, r) => cR(t, typeof e != "symbol" ? e + "" : e, r);
class lR {
  constructor() {
    Jn(this, "map", /* @__PURE__ */ new Map()), Jn(this, "set", (e, r) => {
      const s = this.get(e);
      this.exists(e, r) || this.map.set(e, [...s, r]);
    }), Jn(this, "get", (e) => this.map.get(e) || []), Jn(this, "exists", (e, r) => this.get(e).includes(r)), Jn(this, "delete", (e, r) => {
      if (typeof r > "u") {
        this.map.delete(e);
        return;
      }
      if (!this.map.has(e)) return;
      const s = this.get(e);
      if (!this.exists(e, r)) return;
      const n = s.filter((i) => i !== r);
      if (!n.length) {
        this.map.delete(e);
        return;
      }
      this.map.set(e, n);
    }), Jn(this, "clear", () => {
      this.map.clear();
    });
  }
  get topics() {
    return Array.from(this.map.keys());
  }
}
var uR = Object.defineProperty, hR = Object.defineProperties, dR = Object.getOwnPropertyDescriptors, a1 = Object.getOwnPropertySymbols, pR = Object.prototype.hasOwnProperty, fR = Object.prototype.propertyIsEnumerable, bd = (t, e, r) => e in t ? uR(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, eo = (t, e) => {
  for (var r in e || (e = {})) pR.call(e, r) && bd(t, r, e[r]);
  if (a1) for (var r of a1(e)) fR.call(e, r) && bd(t, r, e[r]);
  return t;
}, zu = (t, e) => hR(t, dR(e)), _e = (t, e, r) => bd(t, typeof e != "symbol" ? e + "" : e, r);
class mR extends mT {
  constructor(e, r) {
    super(e, r), this.relayer = e, this.logger = r, _e(this, "subscriptions", /* @__PURE__ */ new Map()), _e(this, "topicMap", new lR()), _e(this, "events", new dt.EventEmitter()), _e(this, "name", eO), _e(this, "version", tO), _e(this, "pending", /* @__PURE__ */ new Map()), _e(this, "cached", []), _e(this, "initialized", !1), _e(this, "storagePrefix", es), _e(this, "subscribeTimeout", V.toMiliseconds(V.ONE_MINUTE)), _e(this, "initialSubscribeTimeout", V.toMiliseconds(V.ONE_SECOND * 15)), _e(this, "clientId"), _e(this, "batchSubscribeTopicsLimit", 500), _e(this, "init", async () => {
      this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), await this.restore()), this.initialized = !0;
    }), _e(this, "subscribe", async (s, n) => {
      this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({ type: "method", method: "subscribe", params: { topic: s, opts: n } });
      try {
        const i = dl(n), o = { topic: s, relay: i, transportType: n == null ? void 0 : n.transportType };
        this.pending.set(s, o);
        const a = await this.rpcSubscribe(s, i, n);
        return typeof a == "string" && (this.onSubscribe(a, o), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({ type: "method", method: "subscribe", params: { topic: s, opts: n } })), a;
      } catch (i) {
        throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(i), i;
      }
    }), _e(this, "unsubscribe", async (s, n) => {
      this.isInitialized(), typeof (n == null ? void 0 : n.id) < "u" ? await this.unsubscribeById(s, n.id, n) : await this.unsubscribeByTopic(s, n);
    }), _e(this, "isSubscribed", (s) => new Promise((n) => {
      n(this.topicMap.topics.includes(s));
    })), _e(this, "isKnownTopic", (s) => new Promise((n) => {
      n(this.topicMap.topics.includes(s) || this.pending.has(s) || this.cached.some((i) => i.topic === s));
    })), _e(this, "on", (s, n) => {
      this.events.on(s, n);
    }), _e(this, "once", (s, n) => {
      this.events.once(s, n);
    }), _e(this, "off", (s, n) => {
      this.events.off(s, n);
    }), _e(this, "removeListener", (s, n) => {
      this.events.removeListener(s, n);
    }), _e(this, "start", async () => {
      await this.onConnect();
    }), _e(this, "stop", async () => {
      await this.onDisconnect();
    }), _e(this, "restart", async () => {
      await this.restore(), await this.onRestart();
    }), _e(this, "checkPending", async () => {
      if (this.pending.size === 0 && (!this.initialized || !this.relayer.connected)) return;
      const s = [];
      this.pending.forEach((n) => {
        s.push(n);
      }), await this.batchSubscribe(s);
    }), _e(this, "registerEventListeners", () => {
      this.relayer.core.heartbeat.on(ir.pulse, async () => {
        await this.checkPending();
      }), this.events.on(er.created, async (s) => {
        const n = er.created;
        this.logger.info(`Emitting ${n}`), this.logger.debug({ type: "event", event: n, data: s }), await this.persist();
      }), this.events.on(er.deleted, async (s) => {
        const n = er.deleted;
        this.logger.info(`Emitting ${n}`), this.logger.debug({ type: "event", event: n, data: s }), await this.persist();
      });
    }), this.relayer = e, this.logger = ve(r, this.name), this.clientId = "";
  }
  get context() {
    return De(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
  }
  get length() {
    return this.subscriptions.size;
  }
  get ids() {
    return Array.from(this.subscriptions.keys());
  }
  get values() {
    return Array.from(this.subscriptions.values());
  }
  get topics() {
    return this.topicMap.topics;
  }
  get hasAnyTopics() {
    return this.topicMap.topics.length > 0 || this.pending.size > 0 || this.cached.length > 0 || this.subscriptions.size > 0;
  }
  hasSubscription(e, r) {
    let s = !1;
    try {
      s = this.getSubscription(e).topic === r;
    } catch {
    }
    return s;
  }
  reset() {
    this.cached = [], this.initialized = !0;
  }
  onDisable() {
    this.values.length > 0 && (this.cached = this.values), this.subscriptions.clear(), this.topicMap.clear();
  }
  async unsubscribeByTopic(e, r) {
    const s = this.topicMap.get(e);
    await Promise.all(s.map(async (n) => await this.unsubscribeById(e, n, r)));
  }
  async unsubscribeById(e, r, s) {
    this.logger.debug("Unsubscribing Topic"), this.logger.trace({ type: "method", method: "unsubscribe", params: { topic: e, id: r, opts: s } });
    try {
      const n = dl(s);
      await this.restartToComplete({ topic: e, id: r, relay: n }), await this.rpcUnsubscribe(e, r, n);
      const i = ze("USER_DISCONNECTED", `${this.name}, ${e}`);
      await this.onUnsubscribe(e, r, i), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({ type: "method", method: "unsubscribe", params: { topic: e, id: r, opts: s } });
    } catch (n) {
      throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(n), n;
    }
  }
  async rpcSubscribe(e, r, s) {
    var n;
    (!s || (s == null ? void 0 : s.transportType) === Re.relay) && await this.restartToComplete({ topic: e, id: e, relay: r });
    const i = { method: Ao(r.protocol).subscribe, params: { topic: e } };
    this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: i });
    const o = (n = s == null ? void 0 : s.internal) == null ? void 0 : n.throwOnFailedPublish;
    try {
      const a = await this.getSubscriptionId(e);
      if ((s == null ? void 0 : s.transportType) === Re.link_mode) return setTimeout(() => {
        (this.relayer.connected || this.relayer.connecting) && this.relayer.request(i).catch((u) => this.logger.warn(u));
      }, V.toMiliseconds(V.ONE_SECOND)), a;
      const c = new Promise(async (u) => {
        const h = (p) => {
          p.topic === e && (this.events.removeListener(er.created, h), u(p.id));
        };
        this.events.on(er.created, h);
        try {
          const p = await rn(new Promise((y, b) => {
            this.relayer.request(i).catch((g) => {
              this.logger.warn(g, g == null ? void 0 : g.message), b(g);
            }).then(y);
          }), this.initialSubscribeTimeout, `Subscribing to ${e} failed, please try again`);
          this.events.removeListener(er.created, h), u(p);
        } catch {
        }
      }), l = await rn(c, this.subscribeTimeout, `Subscribing to ${e} failed, please try again`);
      if (!l && o) throw new Error(`Subscribing to ${e} failed, please try again`);
      return l ? a : null;
    } catch (a) {
      if (this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit(tt.connection_stalled), o) throw a;
    }
    return null;
  }
  async rpcBatchSubscribe(e) {
    if (!e.length) return;
    const r = e[0].relay, s = { method: Ao(r.protocol).batchSubscribe, params: { topics: e.map((n) => n.topic) } };
    this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: s });
    try {
      await await rn(new Promise((n) => {
        this.relayer.request(s).catch((i) => this.logger.warn(i)).then(n);
      }), this.subscribeTimeout, "rpcBatchSubscribe failed, please try again");
    } catch {
      this.relayer.events.emit(tt.connection_stalled);
    }
  }
  async rpcBatchFetchMessages(e) {
    if (!e.length) return;
    const r = e[0].relay, s = { method: Ao(r.protocol).batchFetchMessages, params: { topics: e.map((i) => i.topic) } };
    this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: s });
    let n;
    try {
      n = await await rn(new Promise((i, o) => {
        this.relayer.request(s).catch((a) => {
          this.logger.warn(a), o(a);
        }).then(i);
      }), this.subscribeTimeout, "rpcBatchFetchMessages failed, please try again");
    } catch {
      this.relayer.events.emit(tt.connection_stalled);
    }
    return n;
  }
  rpcUnsubscribe(e, r, s) {
    const n = { method: Ao(s.protocol).unsubscribe, params: { topic: e, id: r } };
    return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: n }), this.relayer.request(n);
  }
  onSubscribe(e, r) {
    this.setSubscription(e, zu(eo({}, r), { id: e })), this.pending.delete(r.topic);
  }
  onBatchSubscribe(e) {
    e.length && e.forEach((r) => {
      this.setSubscription(r.id, eo({}, r)), this.pending.delete(r.topic);
    });
  }
  async onUnsubscribe(e, r, s) {
    this.events.removeAllListeners(r), this.hasSubscription(r, e) && this.deleteSubscription(r, s), await this.relayer.messages.del(e);
  }
  async setRelayerSubscriptions(e) {
    await this.relayer.core.storage.setItem(this.storageKey, e);
  }
  async getRelayerSubscriptions() {
    return await this.relayer.core.storage.getItem(this.storageKey);
  }
  setSubscription(e, r) {
    this.logger.debug("Setting subscription"), this.logger.trace({ type: "method", method: "setSubscription", id: e, subscription: r }), this.addSubscription(e, r);
  }
  addSubscription(e, r) {
    this.subscriptions.set(e, eo({}, r)), this.topicMap.set(r.topic, e), this.events.emit(er.created, r);
  }
  getSubscription(e) {
    this.logger.debug("Getting subscription"), this.logger.trace({ type: "method", method: "getSubscription", id: e });
    const r = this.subscriptions.get(e);
    if (!r) {
      const { message: s } = Q("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw new Error(s);
    }
    return r;
  }
  deleteSubscription(e, r) {
    this.logger.debug("Deleting subscription"), this.logger.trace({ type: "method", method: "deleteSubscription", id: e, reason: r });
    const s = this.getSubscription(e);
    this.subscriptions.delete(e), this.topicMap.delete(s.topic, e), this.events.emit(er.deleted, zu(eo({}, s), { reason: r }));
  }
  async persist() {
    await this.setRelayerSubscriptions(this.values), this.events.emit(er.sync);
  }
  async onRestart() {
    if (this.cached.length) {
      const e = [...this.cached], r = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
      for (let s = 0; s < r; s++) {
        const n = e.splice(0, this.batchSubscribeTopicsLimit);
        await this.batchSubscribe(n);
      }
    }
    this.events.emit(er.resubscribed);
  }
  async restore() {
    try {
      const e = await this.getRelayerSubscriptions();
      if (typeof e > "u" || !e.length) return;
      if (this.subscriptions.size) {
        const { message: r } = Q("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({ type: "method", method: "restore", subscriptions: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
    }
  }
  async batchSubscribe(e) {
    e.length && (await this.rpcBatchSubscribe(e), this.onBatchSubscribe(await Promise.all(e.map(async (r) => zu(eo({}, r), { id: await this.getSubscriptionId(r.topic) })))));
  }
  async batchFetchMessages(e) {
    if (!e.length) return;
    this.logger.trace(`Fetching batch messages for ${e.length} subscriptions`);
    const r = await this.rpcBatchFetchMessages(e);
    r && r.messages && (await ZT(V.toMiliseconds(V.ONE_SECOND)), await this.relayer.handleBatchMessageEvents(r.messages));
  }
  async onConnect() {
    await this.restart(), this.reset();
  }
  onDisconnect() {
    this.onDisable();
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Q("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  async restartToComplete(e) {
    !this.relayer.connected && !this.relayer.connecting && (this.cached.push(e), await this.relayer.transportOpen());
  }
  async getClientId() {
    return this.clientId || (this.clientId = await this.relayer.core.crypto.getClientId()), this.clientId;
  }
  async getSubscriptionId(e) {
    return Wr(e + await this.getClientId());
  }
}
var bR = Object.defineProperty, c1 = Object.getOwnPropertySymbols, yR = Object.prototype.hasOwnProperty, gR = Object.prototype.propertyIsEnumerable, yd = (t, e, r) => e in t ? bR(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, l1 = (t, e) => {
  for (var r in e || (e = {})) yR.call(e, r) && yd(t, r, e[r]);
  if (c1) for (var r of c1(e)) gR.call(e, r) && yd(t, r, e[r]);
  return t;
}, ge = (t, e, r) => yd(t, typeof e != "symbol" ? e + "" : e, r);
class wR extends pT {
  constructor(e) {
    super(e), ge(this, "protocol", "wc"), ge(this, "version", 2), ge(this, "core"), ge(this, "logger"), ge(this, "events", new dt.EventEmitter()), ge(this, "provider"), ge(this, "messages"), ge(this, "subscriber"), ge(this, "publisher"), ge(this, "name", ZD), ge(this, "transportExplicitlyClosed", !1), ge(this, "initialized", !1), ge(this, "connectionAttemptInProgress", !1), ge(this, "relayUrl"), ge(this, "projectId"), ge(this, "packageName"), ge(this, "bundleId"), ge(this, "hasExperiencedNetworkDisruption", !1), ge(this, "pingTimeout"), ge(this, "heartBeatTimeout", V.toMiliseconds(V.THIRTY_SECONDS + V.FIVE_SECONDS)), ge(this, "reconnectTimeout"), ge(this, "connectPromise"), ge(this, "reconnectInProgress", !1), ge(this, "requestsInFlight", []), ge(this, "connectTimeout", V.toMiliseconds(V.ONE_SECOND * 15)), ge(this, "request", async (r) => {
      var s, n;
      this.logger.debug("Publishing Request Payload");
      const i = r.id || ws().toString();
      await this.toEstablishConnection();
      try {
        this.logger.trace({ id: i, method: r.method, topic: (s = r.params) == null ? void 0 : s.topic }, "relayer.request - publishing...");
        const o = `${i}:${((n = r.params) == null ? void 0 : n.tag) || ""}`;
        this.requestsInFlight.push(o);
        const a = await this.provider.request(r);
        return this.requestsInFlight = this.requestsInFlight.filter((c) => c !== o), a;
      } catch (o) {
        throw this.logger.debug(`Failed to Publish Request: ${i}`), o;
      }
    }), ge(this, "resetPingTimeout", () => {
      cl() && (clearTimeout(this.pingTimeout), this.pingTimeout = setTimeout(() => {
        var r, s, n, i;
        try {
          this.logger.debug({}, "pingTimeout: Connection stalled, terminating..."), (i = (n = (s = (r = this.provider) == null ? void 0 : r.connection) == null ? void 0 : s.socket) == null ? void 0 : n.terminate) == null || i.call(n);
        } catch (o) {
          this.logger.warn(o, o == null ? void 0 : o.message);
        }
      }, this.heartBeatTimeout));
    }), ge(this, "onPayloadHandler", (r) => {
      this.onProviderPayload(r), this.resetPingTimeout();
    }), ge(this, "onConnectHandler", () => {
      this.logger.warn({}, "Relayer connected 🛜"), this.startPingTimeout(), this.events.emit(tt.connect);
    }), ge(this, "onDisconnectHandler", () => {
      this.logger.warn({}, "Relayer disconnected 🛑"), this.requestsInFlight = [], this.onProviderDisconnect();
    }), ge(this, "onProviderErrorHandler", (r) => {
      this.logger.fatal(`Fatal socket error: ${r.message}`), this.events.emit(tt.error, r), this.logger.fatal("Fatal socket error received, closing transport"), this.transportClose();
    }), ge(this, "registerProviderListeners", () => {
      this.provider.on(lr.payload, this.onPayloadHandler), this.provider.on(lr.connect, this.onConnectHandler), this.provider.on(lr.disconnect, this.onDisconnectHandler), this.provider.on(lr.error, this.onProviderErrorHandler);
    }), this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? ve(e.logger, this.name) : ca(ua({ level: e.logger || WD })), this.messages = new eR(this.logger, e.core), this.subscriber = new mR(this, this.logger), this.publisher = new oR(this, this.logger), this.relayUrl = (e == null ? void 0 : e.relayUrl) || b2, this.projectId = e.projectId, DT() ? this.packageName = ib() : OT() && (this.bundleId = ib()), this.provider = {};
  }
  async init() {
    this.logger.trace("Initialized"), this.registerEventListeners(), await Promise.all([this.messages.init(), this.subscriber.init()]), this.initialized = !0, this.transportOpen().catch((e) => this.logger.warn(e, e == null ? void 0 : e.message));
  }
  get context() {
    return De(this.logger);
  }
  get connected() {
    var e, r, s;
    return ((s = (r = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : r.socket) == null ? void 0 : s.readyState) === 1 || !1;
  }
  get connecting() {
    var e, r, s;
    return ((s = (r = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : r.socket) == null ? void 0 : s.readyState) === 0 || this.connectPromise !== void 0 || !1;
  }
  async publish(e, r, s) {
    this.isInitialized(), await this.publisher.publish(e, r, s), await this.recordMessageEvent({ topic: e, message: r, publishedAt: Date.now(), transportType: Re.relay }, Hc.outbound);
  }
  async subscribe(e, r) {
    var s, n, i;
    this.isInitialized(), (!(r != null && r.transportType) || (r == null ? void 0 : r.transportType) === "relay") && await this.toEstablishConnection();
    const o = typeof ((s = r == null ? void 0 : r.internal) == null ? void 0 : s.throwOnFailedPublish) > "u" ? !0 : (n = r == null ? void 0 : r.internal) == null ? void 0 : n.throwOnFailedPublish;
    let a = ((i = this.subscriber.topicMap.get(e)) == null ? void 0 : i[0]) || "", c;
    const l = (u) => {
      u.topic === e && (this.subscriber.off(er.created, l), c());
    };
    return await Promise.all([new Promise((u) => {
      c = u, this.subscriber.on(er.created, l);
    }), new Promise(async (u, h) => {
      a = await this.subscriber.subscribe(e, l1({ internal: { throwOnFailedPublish: o } }, r)).catch((p) => {
        o && h(p);
      }) || a, u();
    })]), a;
  }
  async unsubscribe(e, r) {
    this.isInitialized(), await this.subscriber.unsubscribe(e, r);
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  async transportDisconnect() {
    this.provider.disconnect && (this.hasExperiencedNetworkDisruption || this.connected) ? await rn(this.provider.disconnect(), 2e3, "provider.disconnect()").catch(() => this.onProviderDisconnect()) : this.onProviderDisconnect();
  }
  async transportClose() {
    this.transportExplicitlyClosed = !0, await this.transportDisconnect();
  }
  async transportOpen(e) {
    if (!this.subscriber.hasAnyTopics) {
      this.logger.warn("Starting WS connection skipped because the client has no topics to work with.");
      return;
    }
    if (this.connectPromise ? (this.logger.debug({}, "Waiting for existing connection attempt to resolve..."), await this.connectPromise, this.logger.debug({}, "Existing connection attempt resolved")) : (this.connectPromise = new Promise(async (r, s) => {
      await this.connect(e).then(r).catch(s).finally(() => {
        this.connectPromise = void 0;
      });
    }), await this.connectPromise), !this.connected) throw new Error(`Couldn't establish socket connection to the relay server: ${this.relayUrl}`);
  }
  async restartTransport(e) {
    this.logger.debug({}, "Restarting transport..."), !this.connectionAttemptInProgress && (this.relayUrl = e || this.relayUrl, await this.confirmOnlineStateOrThrow(), await this.transportClose(), await this.transportOpen());
  }
  async confirmOnlineStateOrThrow() {
    if (!await Zb()) throw new Error("No internet connection detected. Please restart your network and try again.");
  }
  async handleBatchMessageEvents(e) {
    if ((e == null ? void 0 : e.length) === 0) {
      this.logger.trace("Batch message events is empty. Ignoring...");
      return;
    }
    const r = e.sort((s, n) => s.publishedAt - n.publishedAt);
    this.logger.debug(`Batch of ${r.length} message events sorted`);
    for (const s of r) try {
      await this.onMessageEvent(s);
    } catch (n) {
      this.logger.warn(n, "Error while processing batch message event: " + (n == null ? void 0 : n.message));
    }
    this.logger.trace(`Batch of ${r.length} message events processed`);
  }
  async onLinkMessageEvent(e, r) {
    const { topic: s } = e;
    if (!r.sessionExists) {
      const n = Ze(V.FIVE_MINUTES), i = { topic: s, expiry: n, relay: { protocol: "irn" }, active: !1 };
      await this.core.pairing.pairings.set(s, i);
    }
    this.events.emit(tt.message, e), await this.recordMessageEvent(e, Hc.inbound);
  }
  async connect(e) {
    await this.confirmOnlineStateOrThrow(), e && e !== this.relayUrl && (this.relayUrl = e, await this.transportDisconnect()), this.connectionAttemptInProgress = !0, this.transportExplicitlyClosed = !1;
    let r = 1;
    for (; r < 6; ) {
      try {
        if (this.transportExplicitlyClosed) break;
        this.logger.debug({}, `Connecting to ${this.relayUrl}, attempt: ${r}...`), await this.createProvider(), await new Promise(async (s, n) => {
          const i = () => {
            n(new Error("Connection interrupted while trying to connect"));
          };
          this.provider.once(lr.disconnect, i), await rn(new Promise((o, a) => {
            this.provider.connect().then(o).catch(a);
          }), this.connectTimeout, `Socket stalled when trying to connect to ${this.relayUrl}`).catch((o) => {
            n(o);
          }).finally(() => {
            this.provider.off(lr.disconnect, i), clearTimeout(this.reconnectTimeout);
          }), await new Promise(async (o, a) => {
            const c = () => {
              n(new Error("Connection interrupted while trying to subscribe"));
            };
            this.provider.once(lr.disconnect, c), await this.subscriber.start().then(o).catch(a).finally(() => {
              this.provider.off(lr.disconnect, c);
            });
          }), this.hasExperiencedNetworkDisruption = !1, s();
        });
      } catch (s) {
        await this.subscriber.stop();
        const n = s;
        this.logger.warn({}, n.message), this.hasExperiencedNetworkDisruption = !0;
      } finally {
        this.connectionAttemptInProgress = !1;
      }
      if (this.connected) {
        this.logger.debug({}, `Connected to ${this.relayUrl} successfully on attempt: ${r}`);
        break;
      }
      await new Promise((s) => setTimeout(s, V.toMiliseconds(r * 1))), r++;
    }
  }
  startPingTimeout() {
    var e, r, s, n, i;
    if (cl()) try {
      (r = (e = this.provider) == null ? void 0 : e.connection) != null && r.socket && ((i = (n = (s = this.provider) == null ? void 0 : s.connection) == null ? void 0 : n.socket) == null || i.on("ping", () => {
        this.resetPingTimeout();
      })), this.resetPingTimeout();
    } catch (o) {
      this.logger.warn(o, o == null ? void 0 : o.message);
    }
  }
  async createProvider() {
    this.provider.connection && this.unregisterProviderListeners();
    const e = await this.core.crypto.signJWT(this.relayUrl);
    this.provider = new Zg(new Jg(MT({ sdkVersion: hd, protocol: this.protocol, version: this.version, relayUrl: this.relayUrl, projectId: this.projectId, auth: e, useOnCloseEvent: !0, bundleId: this.bundleId, packageName: this.packageName }))), this.registerProviderListeners();
  }
  async recordMessageEvent(e, r) {
    const { topic: s, message: n } = e;
    await this.messages.set(s, n, r);
  }
  async shouldIgnoreMessageEvent(e) {
    const { topic: r, message: s } = e;
    if (!s || s.length === 0) return this.logger.warn(`Ignoring invalid/empty message: ${s}`), !0;
    if (!await this.subscriber.isKnownTopic(r)) return this.logger.warn(`Ignoring message for unknown topic ${r}`), !0;
    const n = this.messages.has(r, s);
    return n && this.logger.warn(`Ignoring duplicate message: ${s}`), n;
  }
  async onProviderPayload(e) {
    if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({ type: "payload", direction: "incoming", payload: e }), wa(e)) {
      if (!e.method.endsWith(JD)) return;
      const r = e.params, { topic: s, message: n, publishedAt: i, attestation: o } = r.data, a = { topic: s, message: n, publishedAt: i, transportType: Re.relay, attestation: o };
      this.logger.debug("Emitting Relayer Payload"), this.logger.trace(l1({ type: "event", event: r.id }, a)), this.events.emit(r.id, a), await this.acknowledgePayload(e), await this.onMessageEvent(a);
    } else ki(e) && this.events.emit(tt.message_ack, e);
  }
  async onMessageEvent(e) {
    await this.shouldIgnoreMessageEvent(e) || (await this.recordMessageEvent(e, Hc.inbound), this.events.emit(tt.message, e));
  }
  async acknowledgePayload(e) {
    const r = ga(e.id, !0);
    await this.provider.connection.send(r);
  }
  unregisterProviderListeners() {
    this.provider.off(lr.payload, this.onPayloadHandler), this.provider.off(lr.connect, this.onConnectHandler), this.provider.off(lr.disconnect, this.onDisconnectHandler), this.provider.off(lr.error, this.onProviderErrorHandler), clearTimeout(this.pingTimeout);
  }
  async registerEventListeners() {
    let e = await Zb();
    AD(async (r) => {
      e !== r && (e = r, r ? await this.transportOpen().catch((s) => this.logger.error(s, s == null ? void 0 : s.message)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportDisconnect(), this.transportExplicitlyClosed = !1));
    }), this.core.heartbeat.on(ir.pulse, async () => {
      if (!this.transportExplicitlyClosed && !this.connected && UD()) try {
        await this.confirmOnlineStateOrThrow(), await this.transportOpen();
      } catch (r) {
        this.logger.warn(r, r == null ? void 0 : r.message);
      }
    });
  }
  async onProviderDisconnect() {
    clearTimeout(this.pingTimeout), this.events.emit(tt.disconnect), this.connectionAttemptInProgress = !1, !this.reconnectInProgress && (this.reconnectInProgress = !0, await this.subscriber.stop(), this.subscriber.hasAnyTopics && (this.transportExplicitlyClosed || (this.reconnectTimeout = setTimeout(async () => {
      await this.transportOpen().catch((e) => this.logger.error(e, e == null ? void 0 : e.message)), this.reconnectTimeout = void 0, this.reconnectInProgress = !1;
    }, V.toMiliseconds(XD)))));
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Q("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  async toEstablishConnection() {
    if (await this.confirmOnlineStateOrThrow(), !this.connected) {
      if (this.connectPromise) {
        await this.connectPromise;
        return;
      }
      await this.connect();
    }
  }
}
function ER(t, e) {
  return t === e || Number.isNaN(t) && Number.isNaN(e);
}
function u1(t) {
  return Object.getOwnPropertySymbols(t).filter((e) => Object.prototype.propertyIsEnumerable.call(t, e));
}
function h1(t) {
  return t == null ? t === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(t);
}
const xR = "[object RegExp]", vR = "[object String]", kR = "[object Number]", CR = "[object Boolean]", d1 = "[object Arguments]", SR = "[object Symbol]", IR = "[object Date]", AR = "[object Map]", _R = "[object Set]", TR = "[object Array]", UR = "[object Function]", $R = "[object ArrayBuffer]", ju = "[object Object]", BR = "[object Error]", DR = "[object DataView]", OR = "[object Uint8Array]", PR = "[object Uint8ClampedArray]", RR = "[object Uint16Array]", NR = "[object Uint32Array]", LR = "[object BigUint64Array]", MR = "[object Int8Array]", FR = "[object Int16Array]", zR = "[object Int32Array]", jR = "[object BigInt64Array]", HR = "[object Float32Array]", qR = "[object Float64Array]";
function KR() {
}
function p1(t) {
  if (!t || typeof t != "object") return !1;
  const e = Object.getPrototypeOf(t);
  return e === null || e === Object.prototype || Object.getPrototypeOf(e) === null ? Object.prototype.toString.call(t) === "[object Object]" : !1;
}
function VR(t, e, r) {
  return _o(t, e, void 0, void 0, void 0, void 0, r);
}
function _o(t, e, r, s, n, i, o) {
  const a = o(t, e, r, s, n, i);
  if (a !== void 0) return a;
  if (typeof t == typeof e) switch (typeof t) {
    case "bigint":
    case "string":
    case "boolean":
    case "symbol":
    case "undefined":
      return t === e;
    case "number":
      return t === e || Object.is(t, e);
    case "function":
      return t === e;
    case "object":
      return Ho(t, e, i, o);
  }
  return Ho(t, e, i, o);
}
function Ho(t, e, r, s) {
  if (Object.is(t, e)) return !0;
  let n = h1(t), i = h1(e);
  if (n === d1 && (n = ju), i === d1 && (i = ju), n !== i) return !1;
  switch (n) {
    case vR:
      return t.toString() === e.toString();
    case kR: {
      const c = t.valueOf(), l = e.valueOf();
      return ER(c, l);
    }
    case CR:
    case IR:
    case SR:
      return Object.is(t.valueOf(), e.valueOf());
    case xR:
      return t.source === e.source && t.flags === e.flags;
    case UR:
      return t === e;
  }
  r = r ?? /* @__PURE__ */ new Map();
  const o = r.get(t), a = r.get(e);
  if (o != null && a != null) return o === e;
  r.set(t, e), r.set(e, t);
  try {
    switch (n) {
      case AR: {
        if (t.size !== e.size) return !1;
        for (const [c, l] of t.entries()) if (!e.has(c) || !_o(l, e.get(c), c, t, e, r, s)) return !1;
        return !0;
      }
      case _R: {
        if (t.size !== e.size) return !1;
        const c = Array.from(t.values()), l = Array.from(e.values());
        for (let u = 0; u < c.length; u++) {
          const h = c[u], p = l.findIndex((y) => _o(h, y, void 0, t, e, r, s));
          if (p === -1) return !1;
          l.splice(p, 1);
        }
        return !0;
      }
      case TR:
      case OR:
      case PR:
      case RR:
      case NR:
      case LR:
      case MR:
      case FR:
      case zR:
      case jR:
      case HR:
      case qR: {
        if (typeof Buffer < "u" && Buffer.isBuffer(t) !== Buffer.isBuffer(e) || t.length !== e.length) return !1;
        for (let c = 0; c < t.length; c++) if (!_o(t[c], e[c], c, t, e, r, s)) return !1;
        return !0;
      }
      case $R:
        return t.byteLength !== e.byteLength ? !1 : Ho(new Uint8Array(t), new Uint8Array(e), r, s);
      case DR:
        return t.byteLength !== e.byteLength || t.byteOffset !== e.byteOffset ? !1 : Ho(new Uint8Array(t), new Uint8Array(e), r, s);
      case BR:
        return t.name === e.name && t.message === e.message;
      case ju: {
        if (!(Ho(t.constructor, e.constructor, r, s) || p1(t) && p1(e))) return !1;
        const c = [...Object.keys(t), ...u1(t)], l = [...Object.keys(e), ...u1(e)];
        if (c.length !== l.length) return !1;
        for (let u = 0; u < c.length; u++) {
          const h = c[u], p = t[h];
          if (!Object.hasOwn(e, h)) return !1;
          const y = e[h];
          if (!_o(p, y, h, t, e, r, s)) return !1;
        }
        return !0;
      }
      default:
        return !1;
    }
  } finally {
    r.delete(t), r.delete(e);
  }
}
function GR(t, e) {
  return VR(t, e, KR);
}
var WR = Object.defineProperty, f1 = Object.getOwnPropertySymbols, ZR = Object.prototype.hasOwnProperty, JR = Object.prototype.propertyIsEnumerable, gd = (t, e, r) => e in t ? WR(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, m1 = (t, e) => {
  for (var r in e || (e = {})) ZR.call(e, r) && gd(t, r, e[r]);
  if (f1) for (var r of f1(e)) JR.call(e, r) && gd(t, r, e[r]);
  return t;
}, Rt = (t, e, r) => gd(t, typeof e != "symbol" ? e + "" : e, r);
class Pn extends fT {
  constructor(e, r, s, n = es, i = void 0) {
    super(e, r, s, n), this.core = e, this.logger = r, this.name = s, Rt(this, "map", /* @__PURE__ */ new Map()), Rt(this, "version", YD), Rt(this, "cached", []), Rt(this, "initialized", !1), Rt(this, "getKey"), Rt(this, "storagePrefix", es), Rt(this, "recentlyDeleted", []), Rt(this, "recentlyDeletedLimit", 200), Rt(this, "init", async () => {
      this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((o) => {
        this.getKey && o !== null && !ht(o) ? this.map.set(this.getKey(o), o) : nD(o) ? this.map.set(o.id, o) : iD(o) && this.map.set(o.topic, o);
      }), this.cached = [], this.initialized = !0);
    }), Rt(this, "set", async (o, a) => {
      this.isInitialized(), this.map.has(o) ? await this.update(o, a) : (this.logger.debug("Setting value"), this.logger.trace({ type: "method", method: "set", key: o, value: a }), this.map.set(o, a), await this.persist());
    }), Rt(this, "get", (o) => (this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({ type: "method", method: "get", key: o }), this.getData(o))), Rt(this, "getAll", (o) => (this.isInitialized(), o ? this.values.filter((a) => Object.keys(o).every((c) => GR(a[c], o[c]))) : this.values)), Rt(this, "update", async (o, a) => {
      this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({ type: "method", method: "update", key: o, update: a });
      const c = m1(m1({}, this.getData(o)), a);
      this.map.set(o, c), await this.persist();
    }), Rt(this, "delete", async (o, a) => {
      this.isInitialized(), this.map.has(o) && (this.logger.debug("Deleting value"), this.logger.trace({ type: "method", method: "delete", key: o, reason: a }), this.map.delete(o), this.addToRecentlyDeleted(o), await this.persist());
    }), this.logger = ve(r, this.name), this.storagePrefix = n, this.getKey = i;
  }
  get context() {
    return De(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get length() {
    return this.map.size;
  }
  get keys() {
    return Array.from(this.map.keys());
  }
  get values() {
    return Array.from(this.map.values());
  }
  addToRecentlyDeleted(e) {
    this.recentlyDeleted.push(e), this.recentlyDeleted.length >= this.recentlyDeletedLimit && this.recentlyDeleted.splice(0, this.recentlyDeletedLimit / 2);
  }
  async setDataStore(e) {
    await this.core.storage.setItem(this.storageKey, e);
  }
  async getDataStore() {
    return await this.core.storage.getItem(this.storageKey);
  }
  getData(e) {
    const r = this.map.get(e);
    if (!r) {
      if (this.recentlyDeleted.includes(e)) {
        const { message: n } = Q("MISSING_OR_INVALID", `Record was recently deleted - ${this.name}: ${e}`);
        throw this.logger.error(n), new Error(n);
      }
      const { message: s } = Q("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw this.logger.error(s), new Error(s);
    }
    return r;
  }
  async persist() {
    await this.setDataStore(this.values);
  }
  async restore() {
    try {
      const e = await this.getDataStore();
      if (typeof e > "u" || !e.length) return;
      if (this.map.size) {
        const { message: r } = Q("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({ type: "method", method: "restore", value: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
    }
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Q("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
var XR = Object.defineProperty, YR = (t, e, r) => e in t ? XR(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, de = (t, e, r) => YR(t, typeof e != "symbol" ? e + "" : e, r);
class QR {
  constructor(e, r) {
    this.core = e, this.logger = r, de(this, "name", rO), de(this, "version", sO), de(this, "events", new Ld()), de(this, "pairings"), de(this, "initialized", !1), de(this, "storagePrefix", es), de(this, "ignoredPayloadTypes", [xs]), de(this, "registeredMethods", []), de(this, "init", async () => {
      this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
    }), de(this, "register", ({ methods: s }) => {
      this.isInitialized(), this.registeredMethods = [.../* @__PURE__ */ new Set([...this.registeredMethods, ...s])];
    }), de(this, "create", async (s) => {
      this.isInitialized();
      const n = cd(), i = await this.core.crypto.setSymKey(n), o = Ze(V.FIVE_MINUTES), a = { protocol: m2 }, c = { topic: i, expiry: o, relay: a, active: !1, methods: s == null ? void 0 : s.methods }, l = Fb({ protocol: this.core.protocol, version: this.core.version, topic: i, symKey: n, relay: a, expiryTimestamp: o, methods: s == null ? void 0 : s.methods });
      return this.events.emit(gn.create, c), this.core.expirer.set(i, o), await this.pairings.set(i, c), await this.core.relayer.subscribe(i, { transportType: s == null ? void 0 : s.transportType }), { topic: i, uri: l };
    }), de(this, "pair", async (s) => {
      this.isInitialized();
      const n = this.core.eventClient.createEvent({ properties: { topic: s == null ? void 0 : s.uri, trace: [Vr.pairing_started] } });
      this.isValidPair(s, n);
      const { topic: i, symKey: o, relay: a, expiryTimestamp: c, methods: l } = Mb(s.uri);
      n.props.properties.topic = i, n.addTrace(Vr.pairing_uri_validation_success), n.addTrace(Vr.pairing_uri_not_expired);
      let u;
      if (this.pairings.keys.includes(i)) {
        if (u = this.pairings.get(i), n.addTrace(Vr.existing_pairing), u.active) throw n.setError(bs.active_pairing_already_exists), new Error(`Pairing already exists: ${i}. Please try again with a new connection URI.`);
        n.addTrace(Vr.pairing_not_expired);
      }
      const h = c || Ze(V.FIVE_MINUTES), p = { topic: i, relay: a, expiry: h, active: !1, methods: l };
      this.core.expirer.set(i, h), await this.pairings.set(i, p), n.addTrace(Vr.store_new_pairing), s.activatePairing && await this.activate({ topic: i }), this.events.emit(gn.create, p), n.addTrace(Vr.emit_inactive_pairing), this.core.crypto.keychain.has(i) || await this.core.crypto.setSymKey(o, i), n.addTrace(Vr.subscribing_pairing_topic);
      try {
        await this.core.relayer.confirmOnlineStateOrThrow();
      } catch {
        n.setError(bs.no_internet_connection);
      }
      try {
        await this.core.relayer.subscribe(i, { relay: a });
      } catch (y) {
        throw n.setError(bs.subscribe_pairing_topic_failure), y;
      }
      return n.addTrace(Vr.subscribe_pairing_topic_success), p;
    }), de(this, "activate", async ({ topic: s }) => {
      this.isInitialized();
      const n = Ze(V.FIVE_MINUTES);
      this.core.expirer.set(s, n), await this.pairings.update(s, { active: !0, expiry: n });
    }), de(this, "ping", async (s) => {
      this.isInitialized(), await this.isValidPing(s), this.logger.warn("ping() is deprecated and will be removed in the next major release.");
      const { topic: n } = s;
      if (this.pairings.keys.includes(n)) {
        const i = await this.sendRequest(n, "wc_pairingPing", {}), { done: o, resolve: a, reject: c } = bn();
        this.events.once(Ee("pairing_ping", i), ({ error: l }) => {
          l ? c(l) : a();
        }), await o();
      }
    }), de(this, "updateExpiry", async ({ topic: s, expiry: n }) => {
      this.isInitialized(), await this.pairings.update(s, { expiry: n });
    }), de(this, "updateMetadata", async ({ topic: s, metadata: n }) => {
      this.isInitialized(), await this.pairings.update(s, { peerMetadata: n });
    }), de(this, "getPairings", () => (this.isInitialized(), this.pairings.values)), de(this, "disconnect", async (s) => {
      this.isInitialized(), await this.isValidDisconnect(s);
      const { topic: n } = s;
      this.pairings.keys.includes(n) && (await this.sendRequest(n, "wc_pairingDelete", ze("USER_DISCONNECTED")), await this.deletePairing(n));
    }), de(this, "formatUriFromPairing", (s) => {
      this.isInitialized();
      const { topic: n, relay: i, expiry: o, methods: a } = s, c = this.core.crypto.keychain.get(n);
      return Fb({ protocol: this.core.protocol, version: this.core.version, topic: n, symKey: c, relay: i, expiryTimestamp: o, methods: a });
    }), de(this, "sendRequest", async (s, n, i) => {
      const o = Es(n, i), a = await this.core.crypto.encode(s, o), c = Yi[n].req;
      return this.core.history.set(s, o), this.core.relayer.publish(s, a, c), o.id;
    }), de(this, "sendResult", async (s, n, i) => {
      const o = ga(s, i), a = await this.core.crypto.encode(n, o), c = (await this.core.history.get(n, s)).request.method, l = Yi[c].res;
      await this.core.relayer.publish(n, a, l), await this.core.history.resolve(o);
    }), de(this, "sendError", async (s, n, i) => {
      const o = $l(s, i), a = await this.core.crypto.encode(n, o), c = (await this.core.history.get(n, s)).request.method, l = Yi[c] ? Yi[c].res : Yi.unregistered_method.res;
      await this.core.relayer.publish(n, a, l), await this.core.history.resolve(o);
    }), de(this, "deletePairing", async (s, n) => {
      await this.core.relayer.unsubscribe(s), await Promise.all([this.pairings.delete(s, ze("USER_DISCONNECTED")), this.core.crypto.deleteSymKey(s), n ? Promise.resolve() : this.core.expirer.del(s)]);
    }), de(this, "cleanup", async () => {
      const s = this.pairings.getAll().filter((n) => Js(n.expiry));
      await Promise.all(s.map((n) => this.deletePairing(n.topic)));
    }), de(this, "onRelayEventRequest", async (s) => {
      const { topic: n, payload: i } = s;
      switch (i.method) {
        case "wc_pairingPing":
          return await this.onPairingPingRequest(n, i);
        case "wc_pairingDelete":
          return await this.onPairingDeleteRequest(n, i);
        default:
          return await this.onUnknownRpcMethodRequest(n, i);
      }
    }), de(this, "onRelayEventResponse", async (s) => {
      const { topic: n, payload: i } = s, o = (await this.core.history.get(n, i.id)).request.method;
      switch (o) {
        case "wc_pairingPing":
          return this.onPairingPingResponse(n, i);
        default:
          return this.onUnknownRpcMethodResponse(o);
      }
    }), de(this, "onPairingPingRequest", async (s, n) => {
      const { id: i } = n;
      try {
        this.isValidPing({ topic: s }), await this.sendResult(i, s, !0), this.events.emit(gn.ping, { id: i, topic: s });
      } catch (o) {
        await this.sendError(i, s, o), this.logger.error(o);
      }
    }), de(this, "onPairingPingResponse", (s, n) => {
      const { id: i } = n;
      setTimeout(() => {
        Dr(n) ? this.events.emit(Ee("pairing_ping", i), {}) : jt(n) && this.events.emit(Ee("pairing_ping", i), { error: n.error });
      }, 500);
    }), de(this, "onPairingDeleteRequest", async (s, n) => {
      const { id: i } = n;
      try {
        this.isValidDisconnect({ topic: s }), await this.deletePairing(s), this.events.emit(gn.delete, { id: i, topic: s });
      } catch (o) {
        await this.sendError(i, s, o), this.logger.error(o);
      }
    }), de(this, "onUnknownRpcMethodRequest", async (s, n) => {
      const { id: i, method: o } = n;
      try {
        if (this.registeredMethods.includes(o)) return;
        const a = ze("WC_METHOD_UNSUPPORTED", o);
        await this.sendError(i, s, a), this.logger.error(a);
      } catch (a) {
        await this.sendError(i, s, a), this.logger.error(a);
      }
    }), de(this, "onUnknownRpcMethodResponse", (s) => {
      this.registeredMethods.includes(s) || this.logger.error(ze("WC_METHOD_UNSUPPORTED", s));
    }), de(this, "isValidPair", (s, n) => {
      var i;
      if (!Mt(s)) {
        const { message: a } = Q("MISSING_OR_INVALID", `pair() params: ${s}`);
        throw n.setError(bs.malformed_pairing_uri), new Error(a);
      }
      if (!sD(s.uri)) {
        const { message: a } = Q("MISSING_OR_INVALID", `pair() uri: ${s.uri}`);
        throw n.setError(bs.malformed_pairing_uri), new Error(a);
      }
      const o = Mb(s == null ? void 0 : s.uri);
      if (!((i = o == null ? void 0 : o.relay) != null && i.protocol)) {
        const { message: a } = Q("MISSING_OR_INVALID", "pair() uri#relay-protocol");
        throw n.setError(bs.malformed_pairing_uri), new Error(a);
      }
      if (!(o != null && o.symKey)) {
        const { message: a } = Q("MISSING_OR_INVALID", "pair() uri#symKey");
        throw n.setError(bs.malformed_pairing_uri), new Error(a);
      }
      if (o != null && o.expiryTimestamp && V.toMiliseconds(o == null ? void 0 : o.expiryTimestamp) < Date.now()) {
        n.setError(bs.pairing_expired);
        const { message: a } = Q("EXPIRED", "pair() URI has expired. Please try again with a new connection URI.");
        throw new Error(a);
      }
    }), de(this, "isValidPing", async (s) => {
      if (!Mt(s)) {
        const { message: i } = Q("MISSING_OR_INVALID", `ping() params: ${s}`);
        throw new Error(i);
      }
      const { topic: n } = s;
      await this.isValidPairingTopic(n);
    }), de(this, "isValidDisconnect", async (s) => {
      if (!Mt(s)) {
        const { message: i } = Q("MISSING_OR_INVALID", `disconnect() params: ${s}`);
        throw new Error(i);
      }
      const { topic: n } = s;
      await this.isValidPairingTopic(n);
    }), de(this, "isValidPairingTopic", async (s) => {
      if (!Ve(s, !1)) {
        const { message: n } = Q("MISSING_OR_INVALID", `pairing topic should be a string: ${s}`);
        throw new Error(n);
      }
      if (!this.pairings.keys.includes(s)) {
        const { message: n } = Q("NO_MATCHING_KEY", `pairing topic doesn't exist: ${s}`);
        throw new Error(n);
      }
      if (Js(this.pairings.get(s).expiry)) {
        await this.deletePairing(s);
        const { message: n } = Q("EXPIRED", `pairing topic: ${s}`);
        throw new Error(n);
      }
    }), this.core = e, this.logger = ve(r, this.name), this.pairings = new Pn(this.core, this.logger, this.name, this.storagePrefix);
  }
  get context() {
    return De(this.logger);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Q("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  registerRelayerEvents() {
    this.core.relayer.on(tt.message, async (e) => {
      const { topic: r, message: s, transportType: n } = e;
      if (this.pairings.keys.includes(r) && n !== Re.link_mode && !this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(s))) try {
        const i = await this.core.crypto.decode(r, s);
        wa(i) ? (this.core.history.set(r, i), await this.onRelayEventRequest({ topic: r, payload: i })) : ki(i) && (await this.core.history.resolve(i), await this.onRelayEventResponse({ topic: r, payload: i }), this.core.history.delete(r, i.id)), await this.core.relayer.messages.ack(r, s);
      } catch (i) {
        this.logger.error(i);
      }
    });
  }
  registerExpirerEvents() {
    this.core.expirer.on(ur.expired, async (e) => {
      const { topic: r } = ww(e.target);
      r && this.pairings.keys.includes(r) && (await this.deletePairing(r, !0), this.events.emit(gn.expire, { topic: r }));
    });
  }
}
var eN = Object.defineProperty, tN = (t, e, r) => e in t ? eN(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ut = (t, e, r) => tN(t, typeof e != "symbol" ? e + "" : e, r);
class rN extends uT {
  constructor(e, r) {
    super(e, r), this.core = e, this.logger = r, ut(this, "records", /* @__PURE__ */ new Map()), ut(this, "events", new dt.EventEmitter()), ut(this, "name", nO), ut(this, "version", iO), ut(this, "cached", []), ut(this, "initialized", !1), ut(this, "storagePrefix", es), ut(this, "init", async () => {
      this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((s) => this.records.set(s.id, s)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
    }), ut(this, "set", (s, n, i) => {
      if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({ type: "method", method: "set", topic: s, request: n, chainId: i }), this.records.has(n.id)) return;
      const o = { id: n.id, topic: s, request: { method: n.method, params: n.params || null }, chainId: i, expiry: Ze(V.THIRTY_DAYS) };
      this.records.set(o.id, o), this.persist(), this.events.emit(Cr.created, o);
    }), ut(this, "resolve", async (s) => {
      if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({ type: "method", method: "update", response: s }), !this.records.has(s.id)) return;
      const n = await this.getRecord(s.id);
      typeof n.response > "u" && (n.response = jt(s) ? { error: s.error } : { result: s.result }, this.records.set(n.id, n), this.persist(), this.events.emit(Cr.updated, n));
    }), ut(this, "get", async (s, n) => (this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({ type: "method", method: "get", topic: s, id: n }), await this.getRecord(n))), ut(this, "delete", (s, n) => {
      this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({ type: "method", method: "delete", id: n }), this.values.forEach((i) => {
        if (i.topic === s) {
          if (typeof n < "u" && i.id !== n) return;
          this.records.delete(i.id), this.events.emit(Cr.deleted, i);
        }
      }), this.persist();
    }), ut(this, "exists", async (s, n) => (this.isInitialized(), this.records.has(n) ? (await this.getRecord(n)).topic === s : !1)), ut(this, "on", (s, n) => {
      this.events.on(s, n);
    }), ut(this, "once", (s, n) => {
      this.events.once(s, n);
    }), ut(this, "off", (s, n) => {
      this.events.off(s, n);
    }), ut(this, "removeListener", (s, n) => {
      this.events.removeListener(s, n);
    }), this.logger = ve(r, this.name);
  }
  get context() {
    return De(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get size() {
    return this.records.size;
  }
  get keys() {
    return Array.from(this.records.keys());
  }
  get values() {
    return Array.from(this.records.values());
  }
  get pending() {
    const e = [];
    return this.values.forEach((r) => {
      if (typeof r.response < "u") return;
      const s = { topic: r.topic, request: Es(r.request.method, r.request.params, r.id), chainId: r.chainId };
      return e.push(s);
    }), e;
  }
  async setJsonRpcRecords(e) {
    await this.core.storage.setItem(this.storageKey, e);
  }
  async getJsonRpcRecords() {
    return await this.core.storage.getItem(this.storageKey);
  }
  getRecord(e) {
    this.isInitialized();
    const r = this.records.get(e);
    if (!r) {
      const { message: s } = Q("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw new Error(s);
    }
    return r;
  }
  async persist() {
    await this.setJsonRpcRecords(this.values), this.events.emit(Cr.sync);
  }
  async restore() {
    try {
      const e = await this.getJsonRpcRecords();
      if (typeof e > "u" || !e.length) return;
      if (this.records.size) {
        const { message: r } = Q("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({ type: "method", method: "restore", records: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
    }
  }
  registerEventListeners() {
    this.events.on(Cr.created, (e) => {
      const r = Cr.created;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, record: e });
    }), this.events.on(Cr.updated, (e) => {
      const r = Cr.updated;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, record: e });
    }), this.events.on(Cr.deleted, (e) => {
      const r = Cr.deleted;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, record: e });
    }), this.core.heartbeat.on(ir.pulse, () => {
      this.cleanup();
    });
  }
  cleanup() {
    try {
      this.isInitialized();
      let e = !1;
      this.records.forEach((r) => {
        V.toMiliseconds(r.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${r.id}`), this.records.delete(r.id), this.events.emit(Cr.deleted, r, !1), e = !0);
      }), e && this.persist();
    } catch (e) {
      this.logger.warn(e);
    }
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Q("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
var sN = Object.defineProperty, nN = (t, e, r) => e in t ? sN(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, It = (t, e, r) => nN(t, typeof e != "symbol" ? e + "" : e, r);
class iN extends bT {
  constructor(e, r) {
    super(e, r), this.core = e, this.logger = r, It(this, "expirations", /* @__PURE__ */ new Map()), It(this, "events", new dt.EventEmitter()), It(this, "name", oO), It(this, "version", aO), It(this, "cached", []), It(this, "initialized", !1), It(this, "storagePrefix", es), It(this, "init", async () => {
      this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((s) => this.expirations.set(s.target, s)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
    }), It(this, "has", (s) => {
      try {
        const n = this.formatTarget(s);
        return typeof this.getExpiration(n) < "u";
      } catch {
        return !1;
      }
    }), It(this, "set", (s, n) => {
      this.isInitialized();
      const i = this.formatTarget(s), o = { target: i, expiry: n };
      this.expirations.set(i, o), this.checkExpiry(i, o), this.events.emit(ur.created, { target: i, expiration: o });
    }), It(this, "get", (s) => {
      this.isInitialized();
      const n = this.formatTarget(s);
      return this.getExpiration(n);
    }), It(this, "del", (s) => {
      if (this.isInitialized(), this.has(s)) {
        const n = this.formatTarget(s), i = this.getExpiration(n);
        this.expirations.delete(n), this.events.emit(ur.deleted, { target: n, expiration: i });
      }
    }), It(this, "on", (s, n) => {
      this.events.on(s, n);
    }), It(this, "once", (s, n) => {
      this.events.once(s, n);
    }), It(this, "off", (s, n) => {
      this.events.off(s, n);
    }), It(this, "removeListener", (s, n) => {
      this.events.removeListener(s, n);
    }), this.logger = ve(r, this.name);
  }
  get context() {
    return De(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get length() {
    return this.expirations.size;
  }
  get keys() {
    return Array.from(this.expirations.keys());
  }
  get values() {
    return Array.from(this.expirations.values());
  }
  formatTarget(e) {
    if (typeof e == "string") return FT(e);
    if (typeof e == "number") return zT(e);
    const { message: r } = Q("UNKNOWN_TYPE", `Target type: ${typeof e}`);
    throw new Error(r);
  }
  async setExpirations(e) {
    await this.core.storage.setItem(this.storageKey, e);
  }
  async getExpirations() {
    return await this.core.storage.getItem(this.storageKey);
  }
  async persist() {
    await this.setExpirations(this.values), this.events.emit(ur.sync);
  }
  async restore() {
    try {
      const e = await this.getExpirations();
      if (typeof e > "u" || !e.length) return;
      if (this.expirations.size) {
        const { message: r } = Q("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({ type: "method", method: "restore", expirations: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
    }
  }
  getExpiration(e) {
    const r = this.expirations.get(e);
    if (!r) {
      const { message: s } = Q("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw this.logger.warn(s), new Error(s);
    }
    return r;
  }
  checkExpiry(e, r) {
    const { expiry: s } = r;
    V.toMiliseconds(s) - Date.now() <= 0 && this.expire(e, r);
  }
  expire(e, r) {
    this.expirations.delete(e), this.events.emit(ur.expired, { target: e, expiration: r });
  }
  checkExpirations() {
    this.core.relayer.connected && this.expirations.forEach((e, r) => this.checkExpiry(r, e));
  }
  registerEventListeners() {
    this.core.heartbeat.on(ir.pulse, () => this.checkExpirations()), this.events.on(ur.created, (e) => {
      const r = ur.created;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), this.persist();
    }), this.events.on(ur.expired, (e) => {
      const r = ur.expired;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), this.persist();
    }), this.events.on(ur.deleted, (e) => {
      const r = ur.deleted;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), this.persist();
    });
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Q("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
var oN = Object.defineProperty, aN = (t, e, r) => e in t ? oN(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Ke = (t, e, r) => aN(t, typeof e != "symbol" ? e + "" : e, r);
class cN extends yT {
  constructor(e, r, s) {
    super(e, r, s), this.core = e, this.logger = r, this.store = s, Ke(this, "name", cO), Ke(this, "abortController"), Ke(this, "isDevEnv"), Ke(this, "verifyUrlV3", uO), Ke(this, "storagePrefix", es), Ke(this, "version", f2), Ke(this, "publicKey"), Ke(this, "fetchPromise"), Ke(this, "init", async () => {
      var n;
      this.isDevEnv || (this.publicKey = await this.store.getItem(this.storeKey), this.publicKey && V.toMiliseconds((n = this.publicKey) == null ? void 0 : n.expiresAt) < Date.now() && (this.logger.debug("verify v2 public key expired"), await this.removePublicKey()));
    }), Ke(this, "register", async (n) => {
      if (!Ci() || this.isDevEnv) return;
      const i = window.location.origin, { id: o, decryptedId: a } = n, c = `${this.verifyUrlV3}/attestation?projectId=${this.core.projectId}&origin=${i}&id=${o}&decryptedId=${a}`;
      try {
        const l = fr(), u = this.startAbortTimer(V.ONE_SECOND * 5), h = await new Promise((p, y) => {
          const b = () => {
            window.removeEventListener("message", x), l.body.removeChild(g), y("attestation aborted");
          };
          this.abortController.signal.addEventListener("abort", b);
          const g = l.createElement("iframe");
          g.src = c, g.style.display = "none", g.addEventListener("error", b, { signal: this.abortController.signal });
          const x = (I) => {
            if (I.data && typeof I.data == "string") try {
              const U = JSON.parse(I.data);
              if (U.type === "verify_attestation") {
                if (ni(U.attestation).payload.id !== o) return;
                clearInterval(u), l.body.removeChild(g), this.abortController.signal.removeEventListener("abort", b), window.removeEventListener("message", x), p(U.attestation === null ? "" : U.attestation);
              }
            } catch (U) {
              this.logger.warn(U);
            }
          };
          l.body.appendChild(g), window.addEventListener("message", x, { signal: this.abortController.signal });
        });
        return this.logger.debug("jwt attestation", h), h;
      } catch (l) {
        this.logger.warn(l);
      }
      return "";
    }), Ke(this, "resolve", async (n) => {
      if (this.isDevEnv) return "";
      const { attestationId: i, hash: o, encryptedId: a } = n;
      if (i === "") {
        this.logger.debug("resolve: attestationId is empty, skipping");
        return;
      }
      if (i) {
        if (ni(i).payload.id !== a) return;
        const l = await this.isValidJwtAttestation(i);
        if (l) {
          if (!l.isVerified) {
            this.logger.warn("resolve: jwt attestation: origin url not verified");
            return;
          }
          return l;
        }
      }
      if (!o) return;
      const c = this.getVerifyUrl(n == null ? void 0 : n.verifyUrl);
      return this.fetchAttestation(o, c);
    }), Ke(this, "fetchAttestation", async (n, i) => {
      this.logger.debug(`resolving attestation: ${n} from url: ${i}`);
      const o = this.startAbortTimer(V.ONE_SECOND * 5), a = await fetch(`${i}/attestation/${n}?v2Supported=true`, { signal: this.abortController.signal });
      return clearTimeout(o), a.status === 200 ? await a.json() : void 0;
    }), Ke(this, "getVerifyUrl", (n) => {
      let i = n || jo;
      return hO.includes(i) || (this.logger.info(`verify url: ${i}, not included in trusted list, assigning default: ${jo}`), i = jo), i;
    }), Ke(this, "fetchPublicKey", async () => {
      try {
        this.logger.debug(`fetching public key from: ${this.verifyUrlV3}`);
        const n = this.startAbortTimer(V.FIVE_SECONDS), i = await fetch(`${this.verifyUrlV3}/public-key`, { signal: this.abortController.signal });
        return clearTimeout(n), await i.json();
      } catch (n) {
        this.logger.warn(n);
      }
    }), Ke(this, "persistPublicKey", async (n) => {
      this.logger.debug("persisting public key to local storage", n), await this.store.setItem(this.storeKey, n), this.publicKey = n;
    }), Ke(this, "removePublicKey", async () => {
      this.logger.debug("removing verify v2 public key from storage"), await this.store.removeItem(this.storeKey), this.publicKey = void 0;
    }), Ke(this, "isValidJwtAttestation", async (n) => {
      const i = await this.getPublicKey();
      try {
        if (i) return this.validateAttestation(n, i);
      } catch (a) {
        this.logger.error(a), this.logger.warn("error validating attestation");
      }
      const o = await this.fetchAndPersistPublicKey();
      try {
        if (o) return this.validateAttestation(n, o);
      } catch (a) {
        this.logger.error(a), this.logger.warn("error validating attestation");
      }
    }), Ke(this, "getPublicKey", async () => this.publicKey ? this.publicKey : await this.fetchAndPersistPublicKey()), Ke(this, "fetchAndPersistPublicKey", async () => {
      if (this.fetchPromise) return await this.fetchPromise, this.publicKey;
      this.fetchPromise = new Promise(async (i) => {
        const o = await this.fetchPublicKey();
        o && (await this.persistPublicKey(o), i(o));
      });
      const n = await this.fetchPromise;
      return this.fetchPromise = void 0, n;
    }), Ke(this, "validateAttestation", (n, i) => {
      const o = PB(n, i.publicKey), a = { hasExpired: V.toMiliseconds(o.exp) < Date.now(), payload: o };
      if (a.hasExpired) throw this.logger.warn("resolve: jwt attestation expired"), new Error("JWT attestation expired");
      return { origin: a.payload.origin, isScam: a.payload.isScam, isVerified: a.payload.isVerified };
    }), this.logger = ve(r, this.name), this.abortController = new AbortController(), this.isDevEnv = gp(), this.init();
  }
  get storeKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//verify:public:key";
  }
  get context() {
    return De(this.logger);
  }
  startAbortTimer(e) {
    return this.abortController = new AbortController(), setTimeout(() => this.abortController.abort(), V.toMiliseconds(e));
  }
}
var lN = Object.defineProperty, uN = (t, e, r) => e in t ? lN(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, b1 = (t, e, r) => uN(t, typeof e != "symbol" ? e + "" : e, r);
class hN extends gT {
  constructor(e, r) {
    super(e, r), this.projectId = e, this.logger = r, b1(this, "context", dO), b1(this, "registerDeviceToken", async (s) => {
      const { clientId: n, token: i, notificationType: o, enableEncrypted: a = !1 } = s, c = `${pO}/${this.projectId}/clients`;
      await fetch(c, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ client_id: n, type: o, token: i, always_raw: a }) });
    }), this.logger = ve(r, this.context);
  }
}
var dN = Object.defineProperty, y1 = Object.getOwnPropertySymbols, pN = Object.prototype.hasOwnProperty, fN = Object.prototype.propertyIsEnumerable, wd = (t, e, r) => e in t ? dN(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, to = (t, e) => {
  for (var r in e || (e = {})) pN.call(e, r) && wd(t, r, e[r]);
  if (y1) for (var r of y1(e)) fN.call(e, r) && wd(t, r, e[r]);
  return t;
}, Ye = (t, e, r) => wd(t, typeof e != "symbol" ? e + "" : e, r);
class mN extends wT {
  constructor(e, r, s = !0) {
    super(e, r, s), this.core = e, this.logger = r, Ye(this, "context", mO), Ye(this, "storagePrefix", es), Ye(this, "storageVersion", fO), Ye(this, "events", /* @__PURE__ */ new Map()), Ye(this, "shouldPersist", !1), Ye(this, "init", async () => {
      if (!gp()) try {
        const n = { eventId: ab(), timestamp: Date.now(), domain: this.getAppDomain(), props: { event: "INIT", type: "", properties: { client_id: await this.core.crypto.getClientId(), user_agent: yw(this.core.relayer.protocol, this.core.relayer.version, hd) } } };
        await this.sendEvent([n]);
      } catch (n) {
        this.logger.warn(n);
      }
    }), Ye(this, "createEvent", (n) => {
      const { event: i = "ERROR", type: o = "", properties: { topic: a, trace: c } } = n, l = ab(), u = this.core.projectId || "", h = Date.now(), p = to({ eventId: l, timestamp: h, props: { event: i, type: o, properties: { topic: a, trace: c } }, bundleId: u, domain: this.getAppDomain() }, this.setMethods(l));
      return this.telemetryEnabled && (this.events.set(l, p), this.shouldPersist = !0), p;
    }), Ye(this, "getEvent", (n) => {
      const { eventId: i, topic: o } = n;
      if (i) return this.events.get(i);
      const a = Array.from(this.events.values()).find((c) => c.props.properties.topic === o);
      if (a) return to(to({}, a), this.setMethods(a.eventId));
    }), Ye(this, "deleteEvent", (n) => {
      const { eventId: i } = n;
      this.events.delete(i), this.shouldPersist = !0;
    }), Ye(this, "setEventListeners", () => {
      this.core.heartbeat.on(ir.pulse, async () => {
        this.shouldPersist && await this.persist(), this.events.forEach((n) => {
          V.fromMiliseconds(Date.now()) - V.fromMiliseconds(n.timestamp) > bO && (this.events.delete(n.eventId), this.shouldPersist = !0);
        });
      });
    }), Ye(this, "setMethods", (n) => ({ addTrace: (i) => this.addTrace(n, i), setError: (i) => this.setError(n, i) })), Ye(this, "addTrace", (n, i) => {
      const o = this.events.get(n);
      o && (o.props.properties.trace.push(i), this.events.set(n, o), this.shouldPersist = !0);
    }), Ye(this, "setError", (n, i) => {
      const o = this.events.get(n);
      o && (o.props.type = i, o.timestamp = Date.now(), this.events.set(n, o), this.shouldPersist = !0);
    }), Ye(this, "persist", async () => {
      await this.core.storage.setItem(this.storageKey, Array.from(this.events.values())), this.shouldPersist = !1;
    }), Ye(this, "restore", async () => {
      try {
        const n = await this.core.storage.getItem(this.storageKey) || [];
        if (!n.length) return;
        n.forEach((i) => {
          this.events.set(i.eventId, to(to({}, i), this.setMethods(i.eventId)));
        });
      } catch (n) {
        this.logger.warn(n);
      }
    }), Ye(this, "submit", async () => {
      if (!this.telemetryEnabled || this.events.size === 0) return;
      const n = [];
      for (const [i, o] of this.events) o.props.type && n.push(o);
      if (n.length !== 0) try {
        if ((await this.sendEvent(n)).ok) for (const i of n) this.events.delete(i.eventId), this.shouldPersist = !0;
      } catch (i) {
        this.logger.warn(i);
      }
    }), Ye(this, "sendEvent", async (n) => {
      const i = this.getAppDomain() ? "" : "&sp=desktop";
      return await fetch(`${yO}?projectId=${this.core.projectId}&st=events_sdk&sv=js-${hd}${i}`, { method: "POST", body: JSON.stringify(n) });
    }), Ye(this, "getAppDomain", () => bw().url), this.logger = ve(r, this.context), this.telemetryEnabled = s, s ? this.restore().then(async () => {
      await this.submit(), this.setEventListeners();
    }) : this.persist();
  }
  get storageKey() {
    return this.storagePrefix + this.storageVersion + this.core.customStoragePrefix + "//" + this.context;
  }
}
var bN = Object.defineProperty, g1 = Object.getOwnPropertySymbols, yN = Object.prototype.hasOwnProperty, gN = Object.prototype.propertyIsEnumerable, Ed = (t, e, r) => e in t ? bN(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, w1 = (t, e) => {
  for (var r in e || (e = {})) yN.call(e, r) && Ed(t, r, e[r]);
  if (g1) for (var r of g1(e)) gN.call(e, r) && Ed(t, r, e[r]);
  return t;
}, $e = (t, e, r) => Ed(t, typeof e != "symbol" ? e + "" : e, r);
class Bp extends oT {
  constructor(e) {
    var r;
    super(e), $e(this, "protocol", p2), $e(this, "version", f2), $e(this, "name", ud), $e(this, "relayUrl"), $e(this, "projectId"), $e(this, "customStoragePrefix"), $e(this, "events", new dt.EventEmitter()), $e(this, "logger"), $e(this, "heartbeat"), $e(this, "relayer"), $e(this, "crypto"), $e(this, "storage"), $e(this, "history"), $e(this, "expirer"), $e(this, "pairing"), $e(this, "verify"), $e(this, "echoClient"), $e(this, "linkModeSupportedApps"), $e(this, "eventClient"), $e(this, "initialized", !1), $e(this, "logChunkController"), $e(this, "on", (a, c) => this.events.on(a, c)), $e(this, "once", (a, c) => this.events.once(a, c)), $e(this, "off", (a, c) => this.events.off(a, c)), $e(this, "removeListener", (a, c) => this.events.removeListener(a, c)), $e(this, "dispatchEnvelope", ({ topic: a, message: c, sessionExists: l }) => {
      if (!a || !c) return;
      const u = { topic: a, message: c, publishedAt: Date.now(), transportType: Re.link_mode };
      this.relayer.onLinkMessageEvent(u, { sessionExists: l });
    });
    const s = this.getGlobalCore(e == null ? void 0 : e.customStoragePrefix);
    if (s) try {
      return this.customStoragePrefix = s.customStoragePrefix, this.logger = s.logger, this.heartbeat = s.heartbeat, this.crypto = s.crypto, this.history = s.history, this.expirer = s.expirer, this.storage = s.storage, this.relayer = s.relayer, this.pairing = s.pairing, this.verify = s.verify, this.echoClient = s.echoClient, this.linkModeSupportedApps = s.linkModeSupportedApps, this.eventClient = s.eventClient, this.initialized = s.initialized, this.logChunkController = s.logChunkController, s;
    } catch (a) {
      console.warn("Failed to copy global core", a);
    }
    this.projectId = e == null ? void 0 : e.projectId, this.relayUrl = (e == null ? void 0 : e.relayUrl) || b2, this.customStoragePrefix = e != null && e.customStoragePrefix ? `:${e.customStoragePrefix}` : "";
    const n = ua({ level: typeof (e == null ? void 0 : e.logger) == "string" && e.logger ? e.logger : MD.logger, name: ud }), { logger: i, chunkLoggerController: o } = D0({ opts: n, maxSizeInBytes: e == null ? void 0 : e.maxLogBlobSizeInBytes, loggerOverride: e == null ? void 0 : e.logger });
    this.logChunkController = o, (r = this.logChunkController) != null && r.downloadLogsBlobInBrowser && (window.downloadLogsBlobInBrowser = async () => {
      var a, c;
      (a = this.logChunkController) != null && a.downloadLogsBlobInBrowser && ((c = this.logChunkController) == null || c.downloadLogsBlobInBrowser({ clientId: await this.crypto.getClientId() }));
    }), this.logger = ve(i, this.name), this.heartbeat = new I0(), this.crypto = new VP(this, this.logger, e == null ? void 0 : e.keychain), this.history = new rN(this, this.logger), this.expirer = new iN(this, this.logger), this.storage = e != null && e.storage ? e.storage : new T0(w1(w1({}, FD), e == null ? void 0 : e.storageOptions)), this.relayer = new wR({ core: this, logger: this.logger, relayUrl: this.relayUrl, projectId: this.projectId }), this.pairing = new QR(this, this.logger), this.verify = new cN(this, this.logger, this.storage), this.echoClient = new hN(this.projectId || "", this.logger), this.linkModeSupportedApps = [], this.eventClient = new mN(this, this.logger, e == null ? void 0 : e.telemetryEnabled), this.setGlobalCore(this);
  }
  static async init(e) {
    const r = new Bp(e);
    await r.initialize();
    const s = await r.crypto.getClientId();
    return await r.storage.setItem(QD, s), r;
  }
  get context() {
    return De(this.logger);
  }
  async start() {
    this.initialized || await this.initialize();
  }
  async getLogsBlob() {
    var e;
    return (e = this.logChunkController) == null ? void 0 : e.logsToBlob({ clientId: await this.crypto.getClientId() });
  }
  async addLinkModeSupportedApp(e) {
    this.linkModeSupportedApps.includes(e) || (this.linkModeSupportedApps.push(e), await this.storage.setItem(Yb, this.linkModeSupportedApps));
  }
  async initialize() {
    this.logger.trace("Initialized");
    try {
      await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.linkModeSupportedApps = await this.storage.getItem(Yb) || [], this.initialized = !0, this.logger.info("Core Initialization Success");
    } catch (e) {
      throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
    }
  }
  getGlobalCore(e = "") {
    try {
      if (this.isGlobalCoreDisabled()) return;
      const r = `_walletConnectCore_${e}`, s = `${r}_count`;
      return globalThis[s] = (globalThis[s] || 0) + 1, globalThis[s] > 1 && console.warn(`WalletConnect Core is already initialized. This is probably a mistake and can lead to unexpected behavior. Init() was called ${globalThis[s]} times.`), globalThis[r];
    } catch (r) {
      console.warn("Failed to get global WalletConnect core", r);
      return;
    }
  }
  setGlobalCore(e) {
    var r;
    try {
      if (this.isGlobalCoreDisabled()) return;
      const s = `_walletConnectCore_${((r = e.opts) == null ? void 0 : r.customStoragePrefix) || ""}`;
      globalThis[s] = e;
    } catch (s) {
      console.warn("Failed to set global WalletConnect core", s);
    }
  }
  isGlobalCoreDisabled() {
    try {
      return typeof process < "u" && process.env.DISABLE_GLOBAL_CORE === "true";
    } catch {
      return !0;
    }
  }
}
const xd = Bp, T2 = "wc", U2 = 2, $2 = "client", Dp = `${T2}@${U2}:${$2}:`, Hu = { name: $2, logger: "error" }, E1 = "WALLETCONNECT_DEEPLINK_CHOICE", wN = "proposal", x1 = "Proposal expired", EN = "session", Xn = V.SEVEN_DAYS, xN = "engine", Qe = { wc_sessionPropose: { req: { ttl: V.FIVE_MINUTES, prompt: !0, tag: 1100 }, res: { ttl: V.FIVE_MINUTES, prompt: !1, tag: 1101 }, reject: { ttl: V.FIVE_MINUTES, prompt: !1, tag: 1120 }, autoReject: { ttl: V.FIVE_MINUTES, prompt: !1, tag: 1121 } }, wc_sessionSettle: { req: { ttl: V.FIVE_MINUTES, prompt: !1, tag: 1102 }, res: { ttl: V.FIVE_MINUTES, prompt: !1, tag: 1103 } }, wc_sessionUpdate: { req: { ttl: V.ONE_DAY, prompt: !1, tag: 1104 }, res: { ttl: V.ONE_DAY, prompt: !1, tag: 1105 } }, wc_sessionExtend: { req: { ttl: V.ONE_DAY, prompt: !1, tag: 1106 }, res: { ttl: V.ONE_DAY, prompt: !1, tag: 1107 } }, wc_sessionRequest: { req: { ttl: V.FIVE_MINUTES, prompt: !0, tag: 1108 }, res: { ttl: V.FIVE_MINUTES, prompt: !1, tag: 1109 } }, wc_sessionEvent: { req: { ttl: V.FIVE_MINUTES, prompt: !0, tag: 1110 }, res: { ttl: V.FIVE_MINUTES, prompt: !1, tag: 1111 } }, wc_sessionDelete: { req: { ttl: V.ONE_DAY, prompt: !1, tag: 1112 }, res: { ttl: V.ONE_DAY, prompt: !1, tag: 1113 } }, wc_sessionPing: { req: { ttl: V.ONE_DAY, prompt: !1, tag: 1114 }, res: { ttl: V.ONE_DAY, prompt: !1, tag: 1115 } }, wc_sessionAuthenticate: { req: { ttl: V.ONE_HOUR, prompt: !0, tag: 1116 }, res: { ttl: V.ONE_HOUR, prompt: !1, tag: 1117 }, reject: { ttl: V.FIVE_MINUTES, prompt: !1, tag: 1118 }, autoReject: { ttl: V.FIVE_MINUTES, prompt: !1, tag: 1119 } } }, qu = { min: V.FIVE_MINUTES, max: V.SEVEN_DAYS }, Kr = { idle: "IDLE", active: "ACTIVE" }, vN = { eth_sendTransaction: { key: "" }, eth_sendRawTransaction: { key: "" }, wallet_sendCalls: { key: "" }, solana_signTransaction: { key: "signature" }, solana_signAllTransactions: { key: "transactions" }, solana_signAndSendTransaction: { key: "signature" }, sui_signAndExecuteTransaction: { key: "digest" }, sui_signTransaction: { key: "" }, hedera_signAndExecuteTransaction: { key: "transactionId" }, hedera_executeTransaction: { key: "transactionId" }, near_signTransaction: { key: "" }, near_signTransactions: { key: "" }, tron_signTransaction: { key: "txID" }, xrpl_signTransaction: { key: "" }, xrpl_signTransactionFor: { key: "" }, algo_signTxn: { key: "" }, sendTransfer: { key: "txid" }, stacks_stxTransfer: { key: "txId" }, polkadot_signTransaction: { key: "" }, cosmos_signDirect: { key: "" } }, kN = "request", CN = ["wc_sessionPropose", "wc_sessionRequest", "wc_authRequest", "wc_sessionAuthenticate"], SN = "wc", IN = "auth", AN = "authKeys", _N = "pairingTopics", TN = "requests", jl = `${SN}@${1.5}:${IN}:`, qc = `${jl}:PUB_KEY`;
var UN = Object.defineProperty, $N = Object.defineProperties, BN = Object.getOwnPropertyDescriptors, v1 = Object.getOwnPropertySymbols, DN = Object.prototype.hasOwnProperty, ON = Object.prototype.propertyIsEnumerable, vd = (t, e, r) => e in t ? UN(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Pe = (t, e) => {
  for (var r in e || (e = {})) DN.call(e, r) && vd(t, r, e[r]);
  if (v1) for (var r of v1(e)) ON.call(e, r) && vd(t, r, e[r]);
  return t;
}, Nt = (t, e) => $N(t, BN(e)), Z = (t, e, r) => vd(t, typeof e != "symbol" ? e + "" : e, r);
class PN extends kT {
  constructor(e) {
    super(e), Z(this, "name", xN), Z(this, "events", new Ld()), Z(this, "initialized", !1), Z(this, "requestQueue", { state: Kr.idle, queue: [] }), Z(this, "sessionRequestQueue", { state: Kr.idle, queue: [] }), Z(this, "emittedSessionRequests", new JT({ limit: 500 })), Z(this, "requestQueueDelay", V.ONE_SECOND), Z(this, "expectedPairingMethodMap", /* @__PURE__ */ new Map()), Z(this, "recentlyDeletedMap", /* @__PURE__ */ new Map()), Z(this, "recentlyDeletedLimit", 200), Z(this, "relayMessageCache", []), Z(this, "pendingSessions", /* @__PURE__ */ new Map()), Z(this, "init", async () => {
      this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.registerPairingEvents(), await this.registerLinkModeListeners(), this.client.core.pairing.register({ methods: Object.keys(Qe) }), this.initialized = !0, setTimeout(async () => {
        await this.processPendingMessageEvents(), this.sessionRequestQueue.queue = this.getPendingSessionRequests(), this.processSessionRequestQueue();
      }, V.toMiliseconds(this.requestQueueDelay)));
    }), Z(this, "connect", async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow();
      const s = Nt(Pe({}, r), { requiredNamespaces: r.requiredNamespaces || {}, optionalNamespaces: r.optionalNamespaces || {} });
      await this.isValidConnect(s), s.optionalNamespaces = YB(s.requiredNamespaces, s.optionalNamespaces), s.requiredNamespaces = {};
      const { pairingTopic: n, requiredNamespaces: i, optionalNamespaces: o, sessionProperties: a, scopedProperties: c, relays: l } = s;
      let u = n, h, p = !1;
      try {
        if (u) {
          const q = this.client.core.pairing.pairings.get(u);
          this.client.logger.warn("connect() with existing pairing topic is deprecated and will be removed in the next major release."), p = q.active;
        }
      } catch (q) {
        throw this.client.logger.error(`connect() -> pairing.get(${u}) failed`), q;
      }
      if (!u || !p) {
        const { topic: q, uri: H } = await this.client.core.pairing.create();
        u = q, h = H;
      }
      if (!u) {
        const { message: q } = Q("NO_MATCHING_KEY", `connect() pairing topic: ${u}`);
        throw new Error(q);
      }
      const y = await this.client.core.crypto.generateKeyPair(), b = Qe.wc_sessionPropose.req.ttl || V.FIVE_MINUTES, g = Ze(b), x = Nt(Pe(Pe({ requiredNamespaces: i, optionalNamespaces: o, relays: l ?? [{ protocol: m2 }], proposer: { publicKey: y, metadata: this.client.metadata }, expiryTimestamp: g, pairingTopic: u }, a && { sessionProperties: a }), c && { scopedProperties: c }), { id: Gr() }), I = Ee("session_connect", x.id), { reject: U, resolve: A, done: M } = bn(b, x1), B = ({ id: q }) => {
        q === x.id && (this.client.events.off("proposal_expire", B), this.pendingSessions.delete(x.id), this.events.emit(I, { error: { message: x1, code: 0 } }));
      };
      return this.client.events.on("proposal_expire", B), this.events.once(I, ({ error: q, session: H }) => {
        this.client.events.off("proposal_expire", B), q ? U(q) : H && A(H);
      }), await this.sendRequest({ topic: u, method: "wc_sessionPropose", params: x, throwOnFailedPublish: !0, clientRpcId: x.id }), await this.setProposal(x.id, x), { uri: h, approval: M };
    }), Z(this, "pair", async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow();
      try {
        return await this.client.core.pairing.pair(r);
      } catch (s) {
        throw this.client.logger.error("pair() failed"), s;
      }
    }), Z(this, "approve", async (r) => {
      var s, n, i;
      const o = this.client.core.eventClient.createEvent({ properties: { topic: (s = r == null ? void 0 : r.id) == null ? void 0 : s.toString(), trace: [Sr.session_approve_started] } });
      try {
        this.isInitialized(), await this.confirmOnlineStateOrThrow();
      } catch (w) {
        throw o.setError(fn.no_internet_connection), w;
      }
      try {
        await this.isValidProposalId(r == null ? void 0 : r.id);
      } catch (w) {
        throw this.client.logger.error(`approve() -> proposal.get(${r == null ? void 0 : r.id}) failed`), o.setError(fn.proposal_not_found), w;
      }
      try {
        await this.isValidApprove(r);
      } catch (w) {
        throw this.client.logger.error("approve() -> isValidApprove() failed"), o.setError(fn.session_approve_namespace_validation_failure), w;
      }
      const { id: a, relayProtocol: c, namespaces: l, sessionProperties: u, scopedProperties: h, sessionConfig: p } = r, y = this.client.proposal.get(a);
      this.client.core.eventClient.deleteEvent({ eventId: o.eventId });
      const { pairingTopic: b, proposer: g, requiredNamespaces: x, optionalNamespaces: I } = y;
      let U = (n = this.client.core.eventClient) == null ? void 0 : n.getEvent({ topic: b });
      U || (U = (i = this.client.core.eventClient) == null ? void 0 : i.createEvent({ type: Sr.session_approve_started, properties: { topic: b, trace: [Sr.session_approve_started, Sr.session_namespaces_validation_success] } }));
      const A = await this.client.core.crypto.generateKeyPair(), M = g.publicKey, B = await this.client.core.crypto.generateSharedKey(A, M), q = Pe(Pe(Pe({ relay: { protocol: c ?? "irn" }, namespaces: l, controller: { publicKey: A, metadata: this.client.metadata }, expiry: Ze(Xn) }, u && { sessionProperties: u }), h && { scopedProperties: h }), p && { sessionConfig: p }), H = Re.relay;
      U.addTrace(Sr.subscribing_session_topic);
      try {
        await this.client.core.relayer.subscribe(B, { transportType: H });
      } catch (w) {
        throw U.setError(fn.subscribe_session_topic_failure), w;
      }
      U.addTrace(Sr.subscribe_session_topic_success);
      const F = Nt(Pe({}, q), { topic: B, requiredNamespaces: x, optionalNamespaces: I, pairingTopic: b, acknowledged: !1, self: q.controller, peer: { publicKey: g.publicKey, metadata: g.metadata }, controller: A, transportType: Re.relay });
      await this.client.session.set(B, F), U.addTrace(Sr.store_session);
      try {
        U.addTrace(Sr.publishing_session_settle), await this.sendRequest({ topic: B, method: "wc_sessionSettle", params: q, throwOnFailedPublish: !0 }).catch((w) => {
          throw U == null || U.setError(fn.session_settle_publish_failure), w;
        }), U.addTrace(Sr.session_settle_publish_success), U.addTrace(Sr.publishing_session_approve), await this.sendResult({ id: a, topic: b, result: { relay: { protocol: c ?? "irn" }, responderPublicKey: A }, throwOnFailedPublish: !0 }).catch((w) => {
          throw U == null || U.setError(fn.session_approve_publish_failure), w;
        }), U.addTrace(Sr.session_approve_publish_success);
      } catch (w) {
        throw this.client.logger.error(w), this.client.session.delete(B, ze("USER_DISCONNECTED")), await this.client.core.relayer.unsubscribe(B), w;
      }
      return this.client.core.eventClient.deleteEvent({ eventId: U.eventId }), await this.client.core.pairing.updateMetadata({ topic: b, metadata: g.metadata }), await this.deleteProposal(a), await this.client.core.pairing.activate({ topic: b }), await this.setExpiry(B, Ze(Xn)), { topic: B, acknowledged: () => Promise.resolve(this.client.session.get(B)) };
    }), Z(this, "reject", async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow();
      try {
        await this.isValidReject(r);
      } catch (o) {
        throw this.client.logger.error("reject() -> isValidReject() failed"), o;
      }
      const { id: s, reason: n } = r;
      let i;
      try {
        i = this.client.proposal.get(s).pairingTopic;
      } catch (o) {
        throw this.client.logger.error(`reject() -> proposal.get(${s}) failed`), o;
      }
      i && await this.sendError({ id: s, topic: i, error: n, rpcOpts: Qe.wc_sessionPropose.reject }), await this.deleteProposal(s);
    }), Z(this, "update", async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow();
      try {
        await this.isValidUpdate(r);
      } catch (h) {
        throw this.client.logger.error("update() -> isValidUpdate() failed"), h;
      }
      const { topic: s, namespaces: n } = r, { done: i, resolve: o, reject: a } = bn(), c = Gr(), l = ws().toString(), u = this.client.session.get(s).namespaces;
      return this.events.once(Ee("session_update", c), ({ error: h }) => {
        h ? a(h) : o();
      }), await this.client.session.update(s, { namespaces: n }), await this.sendRequest({ topic: s, method: "wc_sessionUpdate", params: { namespaces: n }, throwOnFailedPublish: !0, clientRpcId: c, relayRpcId: l }).catch((h) => {
        this.client.logger.error(h), this.client.session.update(s, { namespaces: u }), a(h);
      }), { acknowledged: i };
    }), Z(this, "extend", async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow();
      try {
        await this.isValidExtend(r);
      } catch (c) {
        throw this.client.logger.error("extend() -> isValidExtend() failed"), c;
      }
      const { topic: s } = r, n = Gr(), { done: i, resolve: o, reject: a } = bn();
      return this.events.once(Ee("session_extend", n), ({ error: c }) => {
        c ? a(c) : o();
      }), await this.setExpiry(s, Ze(Xn)), this.sendRequest({ topic: s, method: "wc_sessionExtend", params: {}, clientRpcId: n, throwOnFailedPublish: !0 }).catch((c) => {
        a(c);
      }), { acknowledged: i };
    }), Z(this, "request", async (r) => {
      this.isInitialized();
      try {
        await this.isValidRequest(r);
      } catch (x) {
        throw this.client.logger.error("request() -> isValidRequest() failed"), x;
      }
      const { chainId: s, request: n, topic: i, expiry: o = Qe.wc_sessionRequest.req.ttl } = r, a = this.client.session.get(i);
      (a == null ? void 0 : a.transportType) === Re.relay && await this.confirmOnlineStateOrThrow();
      const c = Gr(), l = ws().toString(), { done: u, resolve: h, reject: p } = bn(o, "Request expired. Please try again.");
      this.events.once(Ee("session_request", c), ({ error: x, result: I }) => {
        x ? p(x) : h(I);
      });
      const y = "wc_sessionRequest", b = this.getAppLinkIfEnabled(a.peer.metadata, a.transportType);
      if (b) return await this.sendRequest({ clientRpcId: c, relayRpcId: l, topic: i, method: y, params: { request: Nt(Pe({}, n), { expiryTimestamp: Ze(o) }), chainId: s }, expiry: o, throwOnFailedPublish: !0, appLink: b }).catch((x) => p(x)), this.client.events.emit("session_request_sent", { topic: i, request: n, chainId: s, id: c }), await u();
      const g = { request: Nt(Pe({}, n), { expiryTimestamp: Ze(o) }), chainId: s };
      return await Promise.all([new Promise(async (x) => {
        await this.sendRequest({ clientRpcId: c, relayRpcId: l, topic: i, method: y, params: g, expiry: o, throwOnFailedPublish: !0, tvf: this.getTVFParams(c, g) }).catch((I) => p(I)), this.client.events.emit("session_request_sent", { topic: i, request: n, chainId: s, id: c }), x();
      }), new Promise(async (x) => {
        var I;
        if (!((I = a.sessionConfig) != null && I.disableDeepLink)) {
          const U = await KT(this.client.core.storage, E1);
          await jT({ id: c, topic: i, wcDeepLink: U });
        }
        x();
      }), u()]).then((x) => x[2]);
    }), Z(this, "respond", async (r) => {
      this.isInitialized(), await this.isValidRespond(r);
      const { topic: s, response: n } = r, { id: i } = n, o = this.client.session.get(s);
      o.transportType === Re.relay && await this.confirmOnlineStateOrThrow();
      const a = this.getAppLinkIfEnabled(o.peer.metadata, o.transportType);
      Dr(n) ? await this.sendResult({ id: i, topic: s, result: n.result, throwOnFailedPublish: !0, appLink: a }) : jt(n) && await this.sendError({ id: i, topic: s, error: n.error, appLink: a }), this.cleanupAfterResponse(r);
    }), Z(this, "ping", async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow();
      try {
        await this.isValidPing(r);
      } catch (n) {
        throw this.client.logger.error("ping() -> isValidPing() failed"), n;
      }
      const { topic: s } = r;
      if (this.client.session.keys.includes(s)) {
        const n = Gr(), i = ws().toString(), { done: o, resolve: a, reject: c } = bn();
        this.events.once(Ee("session_ping", n), ({ error: l }) => {
          l ? c(l) : a();
        }), await Promise.all([this.sendRequest({ topic: s, method: "wc_sessionPing", params: {}, throwOnFailedPublish: !0, clientRpcId: n, relayRpcId: i }), o()]);
      } else this.client.core.pairing.pairings.keys.includes(s) && (this.client.logger.warn("ping() on pairing topic is deprecated and will be removed in the next major release."), await this.client.core.pairing.ping({ topic: s }));
    }), Z(this, "emit", async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow(), await this.isValidEmit(r);
      const { topic: s, event: n, chainId: i } = r, o = ws().toString(), a = Gr();
      await this.sendRequest({ topic: s, method: "wc_sessionEvent", params: { event: n, chainId: i }, throwOnFailedPublish: !0, relayRpcId: o, clientRpcId: a });
    }), Z(this, "disconnect", async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow(), await this.isValidDisconnect(r);
      const { topic: s } = r;
      if (this.client.session.keys.includes(s)) await this.sendRequest({ topic: s, method: "wc_sessionDelete", params: ze("USER_DISCONNECTED"), throwOnFailedPublish: !0 }), await this.deleteSession({ topic: s, emitEvent: !1 });
      else if (this.client.core.pairing.pairings.keys.includes(s)) await this.client.core.pairing.disconnect({ topic: s });
      else {
        const { message: n } = Q("MISMATCHED_TOPIC", `Session or pairing topic not found: ${s}`);
        throw new Error(n);
      }
    }), Z(this, "find", (r) => (this.isInitialized(), this.client.session.getAll().filter((s) => tD(s, r)))), Z(this, "getPendingSessionRequests", () => this.client.pendingRequest.getAll()), Z(this, "authenticate", async (r, s) => {
      var n;
      this.isInitialized(), this.isValidAuthenticate(r);
      const i = s && this.client.core.linkModeSupportedApps.includes(s) && ((n = this.client.metadata.redirect) == null ? void 0 : n.linkMode), o = i ? Re.link_mode : Re.relay;
      o === Re.relay && await this.confirmOnlineStateOrThrow();
      const { chains: a, statement: c = "", uri: l, domain: u, nonce: h, type: p, exp: y, nbf: b, methods: g = [], expiry: x } = r, I = [...r.resources || []], { topic: U, uri: A } = await this.client.core.pairing.create({ methods: ["wc_sessionAuthenticate"], transportType: o });
      this.client.logger.info({ message: "Generated new pairing", pairing: { topic: U, uri: A } });
      const M = await this.client.core.crypto.generateKeyPair(), B = jc(M);
      if (await Promise.all([this.client.auth.authKeys.set(qc, { responseTopic: B, publicKey: M }), this.client.auth.pairingTopics.set(B, { topic: B, pairingTopic: U })]), await this.client.core.relayer.subscribe(B, { transportType: o }), this.client.logger.info(`sending request to new pairing topic: ${U}`), g.length > 0) {
        const { namespace: D } = Fc(a[0]);
        let z = a$(D, "request", g);
        zc(I) && (z = l$(z, I.pop())), I.push(z);
      }
      const q = x && x > Qe.wc_sessionAuthenticate.req.ttl ? x : Qe.wc_sessionAuthenticate.req.ttl, H = { authPayload: { type: p ?? "caip122", chains: a, statement: c, aud: l, domain: u, version: "1", nonce: h, iat: (/* @__PURE__ */ new Date()).toISOString(), exp: y, nbf: b, resources: I }, requester: { publicKey: M, metadata: this.client.metadata }, expiryTimestamp: Ze(q) }, F = { eip155: { chains: a, methods: [.../* @__PURE__ */ new Set(["personal_sign", ...g])], events: ["chainChanged", "accountsChanged"] } }, w = { requiredNamespaces: {}, optionalNamespaces: F, relays: [{ protocol: "irn" }], pairingTopic: U, proposer: { publicKey: M, metadata: this.client.metadata }, expiryTimestamp: Ze(Qe.wc_sessionPropose.req.ttl), id: Gr() }, { done: T, resolve: k, reject: S } = bn(q, "Request expired"), O = Gr(), N = Ee("session_connect", w.id), _ = Ee("session_request", O), C = async ({ error: D, session: z }) => {
        this.events.off(_, $), D ? S(D) : z && k({ session: z });
      }, $ = async (D) => {
        var z, L, K;
        if (await this.deletePendingAuthRequest(O, { message: "fulfilled", code: 0 }), D.error) {
          const se = ze("WC_METHOD_UNSUPPORTED", "wc_sessionAuthenticate");
          return D.error.code === se.code ? void 0 : (this.events.off(N, C), S(D.error.message));
        }
        await this.deleteProposal(w.id), this.events.off(N, C);
        const { cacaos: J, responder: X } = D.result, Y = [], re = [];
        for (const se of J) {
          await gb({ cacao: se, projectId: this.client.core.projectId }) || (this.client.logger.error(se, "Signature verification failed"), S(ze("SESSION_SETTLEMENT_FAILED", "Signature verification failed")));
          const { p: fe } = se, Oe = zc(fe.resources), Lr = [Qh(fe.iss)], wr = ll(fe.iss);
          if (Oe) {
            const ar = wb(Oe), $i = Eb(Oe);
            Y.push(...ar), Lr.push(...$i);
          }
          for (const ar of Lr) re.push(`${ar}:${wr}`);
        }
        const ae = await this.client.core.crypto.generateSharedKey(M, X.publicKey);
        let ne;
        Y.length > 0 && (ne = { topic: ae, acknowledged: !0, self: { publicKey: M, metadata: this.client.metadata }, peer: X, controller: X.publicKey, expiry: Ze(Xn), requiredNamespaces: {}, optionalNamespaces: {}, relay: { protocol: "irn" }, pairingTopic: U, namespaces: qb([...new Set(Y)], [...new Set(re)]), transportType: o }, await this.client.core.relayer.subscribe(ae, { transportType: o }), await this.client.session.set(ae, ne), U && await this.client.core.pairing.updateMetadata({ topic: U, metadata: X.metadata }), ne = this.client.session.get(ae)), (z = this.client.metadata.redirect) != null && z.linkMode && (L = X.metadata.redirect) != null && L.linkMode && (K = X.metadata.redirect) != null && K.universal && s && (this.client.core.addLinkModeSupportedApp(X.metadata.redirect.universal), this.client.session.update(ae, { transportType: Re.link_mode })), k({ auths: J, session: ne });
      };
      this.events.once(N, C), this.events.once(_, $);
      let P;
      try {
        if (i) {
          const D = Es("wc_sessionAuthenticate", H, O);
          this.client.core.history.set(U, D);
          const z = await this.client.core.crypto.encode("", D, { type: Ca, encoding: en });
          P = tc(s, U, z);
        } else await Promise.all([this.sendRequest({ topic: U, method: "wc_sessionAuthenticate", params: H, expiry: r.expiry, throwOnFailedPublish: !0, clientRpcId: O }), this.sendRequest({ topic: U, method: "wc_sessionPropose", params: w, expiry: Qe.wc_sessionPropose.req.ttl, throwOnFailedPublish: !0, clientRpcId: w.id })]);
      } catch (D) {
        throw this.events.off(N, C), this.events.off(_, $), D;
      }
      return await this.setProposal(w.id, w), await this.setAuthRequest(O, { request: Nt(Pe({}, H), { verifyContext: {} }), pairingTopic: U, transportType: o }), { uri: P ?? A, response: T };
    }), Z(this, "approveSessionAuthenticate", async (r) => {
      const { id: s, auths: n } = r, i = this.client.core.eventClient.createEvent({ properties: { topic: s.toString(), trace: [mn.authenticated_session_approve_started] } });
      try {
        this.isInitialized();
      } catch (x) {
        throw i.setError(Qi.no_internet_connection), x;
      }
      const o = this.getPendingAuthRequest(s);
      if (!o) throw i.setError(Qi.authenticated_session_pending_request_not_found), new Error(`Could not find pending auth request with id ${s}`);
      const a = o.transportType || Re.relay;
      a === Re.relay && await this.confirmOnlineStateOrThrow();
      const c = o.requester.publicKey, l = await this.client.core.crypto.generateKeyPair(), u = jc(c), h = { type: xs, receiverPublicKey: c, senderPublicKey: l }, p = [], y = [];
      for (const x of n) {
        if (!await gb({ cacao: x, projectId: this.client.core.projectId })) {
          i.setError(Qi.invalid_cacao);
          const B = ze("SESSION_SETTLEMENT_FAILED", "Signature verification failed");
          throw await this.sendError({ id: s, topic: u, error: B, encodeOpts: h }), new Error(B.message);
        }
        i.addTrace(mn.cacaos_verified);
        const { p: I } = x, U = zc(I.resources), A = [Qh(I.iss)], M = ll(I.iss);
        if (U) {
          const B = wb(U), q = Eb(U);
          p.push(...B), A.push(...q);
        }
        for (const B of A) y.push(`${B}:${M}`);
      }
      const b = await this.client.core.crypto.generateSharedKey(l, c);
      i.addTrace(mn.create_authenticated_session_topic);
      let g;
      if ((p == null ? void 0 : p.length) > 0) {
        g = { topic: b, acknowledged: !0, self: { publicKey: l, metadata: this.client.metadata }, peer: { publicKey: c, metadata: o.requester.metadata }, controller: c, expiry: Ze(Xn), authentication: n, requiredNamespaces: {}, optionalNamespaces: {}, relay: { protocol: "irn" }, pairingTopic: o.pairingTopic, namespaces: qb([...new Set(p)], [...new Set(y)]), transportType: a }, i.addTrace(mn.subscribing_authenticated_session_topic);
        try {
          await this.client.core.relayer.subscribe(b, { transportType: a });
        } catch (x) {
          throw i.setError(Qi.subscribe_authenticated_session_topic_failure), x;
        }
        i.addTrace(mn.subscribe_authenticated_session_topic_success), await this.client.session.set(b, g), i.addTrace(mn.store_authenticated_session), await this.client.core.pairing.updateMetadata({ topic: o.pairingTopic, metadata: o.requester.metadata });
      }
      i.addTrace(mn.publishing_authenticated_session_approve);
      try {
        await this.sendResult({ topic: u, id: s, result: { cacaos: n, responder: { publicKey: l, metadata: this.client.metadata } }, encodeOpts: h, throwOnFailedPublish: !0, appLink: this.getAppLinkIfEnabled(o.requester.metadata, a) });
      } catch (x) {
        throw i.setError(Qi.authenticated_session_approve_publish_failure), x;
      }
      return await this.client.auth.requests.delete(s, { message: "fulfilled", code: 0 }), await this.client.core.pairing.activate({ topic: o.pairingTopic }), this.client.core.eventClient.deleteEvent({ eventId: i.eventId }), { session: g };
    }), Z(this, "rejectSessionAuthenticate", async (r) => {
      this.isInitialized();
      const { id: s, reason: n } = r, i = this.getPendingAuthRequest(s);
      if (!i) throw new Error(`Could not find pending auth request with id ${s}`);
      i.transportType === Re.relay && await this.confirmOnlineStateOrThrow();
      const o = i.requester.publicKey, a = await this.client.core.crypto.generateKeyPair(), c = jc(o), l = { type: xs, receiverPublicKey: o, senderPublicKey: a };
      await this.sendError({ id: s, topic: c, error: n, encodeOpts: l, rpcOpts: Qe.wc_sessionAuthenticate.reject, appLink: this.getAppLinkIfEnabled(i.requester.metadata, i.transportType) }), await this.client.auth.requests.delete(s, { message: "rejected", code: 0 }), await this.deleteProposal(s);
    }), Z(this, "formatAuthMessage", (r) => {
      this.isInitialized();
      const { request: s, iss: n } = r;
      return Ow(s, n);
    }), Z(this, "processRelayMessageCache", () => {
      setTimeout(async () => {
        if (this.relayMessageCache.length !== 0) for (; this.relayMessageCache.length > 0; ) try {
          const r = this.relayMessageCache.shift();
          r && await this.onRelayMessage(r);
        } catch (r) {
          this.client.logger.error(r);
        }
      }, 50);
    }), Z(this, "cleanupDuplicatePairings", async (r) => {
      if (r.pairingTopic) try {
        const s = this.client.core.pairing.pairings.get(r.pairingTopic), n = this.client.core.pairing.pairings.getAll().filter((i) => {
          var o, a;
          return ((o = i.peerMetadata) == null ? void 0 : o.url) && ((a = i.peerMetadata) == null ? void 0 : a.url) === r.peer.metadata.url && i.topic && i.topic !== s.topic;
        });
        if (n.length === 0) return;
        this.client.logger.info(`Cleaning up ${n.length} duplicate pairing(s)`), await Promise.all(n.map((i) => this.client.core.pairing.disconnect({ topic: i.topic }))), this.client.logger.info("Duplicate pairings clean up finished");
      } catch (s) {
        this.client.logger.error(s);
      }
    }), Z(this, "deleteSession", async (r) => {
      var s;
      const { topic: n, expirerHasDeleted: i = !1, emitEvent: o = !0, id: a = 0 } = r, { self: c } = this.client.session.get(n);
      await this.client.core.relayer.unsubscribe(n), await this.client.session.delete(n, ze("USER_DISCONNECTED")), this.addToRecentlyDeleted(n, "session"), this.client.core.crypto.keychain.has(c.publicKey) && await this.client.core.crypto.deleteKeyPair(c.publicKey), this.client.core.crypto.keychain.has(n) && await this.client.core.crypto.deleteSymKey(n), i || this.client.core.expirer.del(n), this.client.core.storage.removeItem(E1).catch((l) => this.client.logger.warn(l)), this.getPendingSessionRequests().forEach((l) => {
        l.topic === n && this.deletePendingSessionRequest(l.id, ze("USER_DISCONNECTED"));
      }), n === ((s = this.sessionRequestQueue.queue[0]) == null ? void 0 : s.topic) && (this.sessionRequestQueue.state = Kr.idle), o && this.client.events.emit("session_delete", { id: a, topic: n });
    }), Z(this, "deleteProposal", async (r, s) => {
      if (s) try {
        const n = this.client.proposal.get(r), i = this.client.core.eventClient.getEvent({ topic: n.pairingTopic });
        i == null || i.setError(fn.proposal_expired);
      } catch {
      }
      await Promise.all([this.client.proposal.delete(r, ze("USER_DISCONNECTED")), s ? Promise.resolve() : this.client.core.expirer.del(r)]), this.addToRecentlyDeleted(r, "proposal");
    }), Z(this, "deletePendingSessionRequest", async (r, s, n = !1) => {
      await Promise.all([this.client.pendingRequest.delete(r, s), n ? Promise.resolve() : this.client.core.expirer.del(r)]), this.addToRecentlyDeleted(r, "request"), this.sessionRequestQueue.queue = this.sessionRequestQueue.queue.filter((i) => i.id !== r), n && (this.sessionRequestQueue.state = Kr.idle, this.client.events.emit("session_request_expire", { id: r }));
    }), Z(this, "deletePendingAuthRequest", async (r, s, n = !1) => {
      await Promise.all([this.client.auth.requests.delete(r, s), n ? Promise.resolve() : this.client.core.expirer.del(r)]);
    }), Z(this, "setExpiry", async (r, s) => {
      this.client.session.keys.includes(r) && (this.client.core.expirer.set(r, s), await this.client.session.update(r, { expiry: s }));
    }), Z(this, "setProposal", async (r, s) => {
      this.client.core.expirer.set(r, Ze(Qe.wc_sessionPropose.req.ttl)), await this.client.proposal.set(r, s);
    }), Z(this, "setAuthRequest", async (r, s) => {
      const { request: n, pairingTopic: i, transportType: o = Re.relay } = s;
      this.client.core.expirer.set(r, n.expiryTimestamp), await this.client.auth.requests.set(r, { authPayload: n.authPayload, requester: n.requester, expiryTimestamp: n.expiryTimestamp, id: r, pairingTopic: i, verifyContext: n.verifyContext, transportType: o });
    }), Z(this, "setPendingSessionRequest", async (r) => {
      const { id: s, topic: n, params: i, verifyContext: o } = r, a = i.request.expiryTimestamp || Ze(Qe.wc_sessionRequest.req.ttl);
      this.client.core.expirer.set(s, a), await this.client.pendingRequest.set(s, { id: s, topic: n, params: i, verifyContext: o });
    }), Z(this, "sendRequest", async (r) => {
      const { topic: s, method: n, params: i, expiry: o, relayRpcId: a, clientRpcId: c, throwOnFailedPublish: l, appLink: u, tvf: h } = r, p = Es(n, i, c);
      let y;
      const b = !!u;
      try {
        const I = b ? en : Pr;
        y = await this.client.core.crypto.encode(s, p, { encoding: I });
      } catch (I) {
        throw await this.cleanup(), this.client.logger.error(`sendRequest() -> core.crypto.encode() for topic ${s} failed`), I;
      }
      let g;
      if (CN.includes(n)) {
        const I = Wr(JSON.stringify(p)), U = Wr(y);
        g = await this.client.core.verify.register({ id: U, decryptedId: I });
      }
      const x = Qe[n].req;
      if (x.attestation = g, o && (x.ttl = o), a && (x.id = a), this.client.core.history.set(s, p), b) {
        const I = tc(u, s, y);
        await globalThis.Linking.openURL(I, this.client.name);
      } else {
        const I = Qe[n].req;
        o && (I.ttl = o), a && (I.id = a), I.tvf = Nt(Pe({}, h), { correlationId: p.id }), l ? (I.internal = Nt(Pe({}, I.internal), { throwOnFailedPublish: !0 }), await this.client.core.relayer.publish(s, y, I)) : this.client.core.relayer.publish(s, y, I).catch((U) => this.client.logger.error(U));
      }
      return p.id;
    }), Z(this, "sendResult", async (r) => {
      const { id: s, topic: n, result: i, throwOnFailedPublish: o, encodeOpts: a, appLink: c } = r, l = ga(s, i);
      let u;
      const h = c && typeof (globalThis == null ? void 0 : globalThis.Linking) < "u";
      try {
        const b = h ? en : Pr;
        u = await this.client.core.crypto.encode(n, l, Nt(Pe({}, a || {}), { encoding: b }));
      } catch (b) {
        throw await this.cleanup(), this.client.logger.error(`sendResult() -> core.crypto.encode() for topic ${n} failed`), b;
      }
      let p, y;
      try {
        p = await this.client.core.history.get(n, s);
        const b = p.request;
        try {
          y = this.getTVFParams(s, b.params, i);
        } catch (g) {
          this.client.logger.warn(`sendResult() -> getTVFParams() failed: ${g == null ? void 0 : g.message}`);
        }
      } catch (b) {
        throw this.client.logger.error(`sendResult() -> history.get(${n}, ${s}) failed`), b;
      }
      if (h) {
        const b = tc(c, n, u);
        await globalThis.Linking.openURL(b, this.client.name);
      } else {
        const b = p.request.method, g = Qe[b].res;
        g.tvf = Nt(Pe({}, y), { correlationId: s }), o ? (g.internal = Nt(Pe({}, g.internal), { throwOnFailedPublish: !0 }), await this.client.core.relayer.publish(n, u, g)) : this.client.core.relayer.publish(n, u, g).catch((x) => this.client.logger.error(x));
      }
      await this.client.core.history.resolve(l);
    }), Z(this, "sendError", async (r) => {
      const { id: s, topic: n, error: i, encodeOpts: o, rpcOpts: a, appLink: c } = r, l = $l(s, i);
      let u;
      const h = c && typeof (globalThis == null ? void 0 : globalThis.Linking) < "u";
      try {
        const y = h ? en : Pr;
        u = await this.client.core.crypto.encode(n, l, Nt(Pe({}, o || {}), { encoding: y }));
      } catch (y) {
        throw await this.cleanup(), this.client.logger.error(`sendError() -> core.crypto.encode() for topic ${n} failed`), y;
      }
      let p;
      try {
        p = await this.client.core.history.get(n, s);
      } catch (y) {
        throw this.client.logger.error(`sendError() -> history.get(${n}, ${s}) failed`), y;
      }
      if (h) {
        const y = tc(c, n, u);
        await globalThis.Linking.openURL(y, this.client.name);
      } else {
        const y = p.request.method, b = a || Qe[y].res;
        this.client.core.relayer.publish(n, u, b);
      }
      await this.client.core.history.resolve(l);
    }), Z(this, "cleanup", async () => {
      const r = [], s = [];
      this.client.session.getAll().forEach((n) => {
        let i = !1;
        Js(n.expiry) && (i = !0), this.client.core.crypto.keychain.has(n.topic) || (i = !0), i && r.push(n.topic);
      }), this.client.proposal.getAll().forEach((n) => {
        Js(n.expiryTimestamp) && s.push(n.id);
      }), await Promise.all([...r.map((n) => this.deleteSession({ topic: n })), ...s.map((n) => this.deleteProposal(n))]);
    }), Z(this, "onProviderMessageEvent", async (r) => {
      !this.initialized || this.relayMessageCache.length > 0 ? this.relayMessageCache.push(r) : await this.onRelayMessage(r);
    }), Z(this, "onRelayEventRequest", async (r) => {
      this.requestQueue.queue.push(r), await this.processRequestsQueue();
    }), Z(this, "processRequestsQueue", async () => {
      if (this.requestQueue.state === Kr.active) {
        this.client.logger.info("Request queue already active, skipping...");
        return;
      }
      for (this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`); this.requestQueue.queue.length > 0; ) {
        this.requestQueue.state = Kr.active;
        const r = this.requestQueue.queue.shift();
        if (r) try {
          await this.processRequest(r);
        } catch (s) {
          this.client.logger.warn(s);
        }
      }
      this.requestQueue.state = Kr.idle;
    }), Z(this, "processRequest", async (r) => {
      const { topic: s, payload: n, attestation: i, transportType: o, encryptedId: a } = r, c = n.method;
      if (!this.shouldIgnorePairingRequest({ topic: s, requestMethod: c })) switch (c) {
        case "wc_sessionPropose":
          return await this.onSessionProposeRequest({ topic: s, payload: n, attestation: i, encryptedId: a });
        case "wc_sessionSettle":
          return await this.onSessionSettleRequest(s, n);
        case "wc_sessionUpdate":
          return await this.onSessionUpdateRequest(s, n);
        case "wc_sessionExtend":
          return await this.onSessionExtendRequest(s, n);
        case "wc_sessionPing":
          return await this.onSessionPingRequest(s, n);
        case "wc_sessionDelete":
          return await this.onSessionDeleteRequest(s, n);
        case "wc_sessionRequest":
          return await this.onSessionRequest({ topic: s, payload: n, attestation: i, encryptedId: a, transportType: o });
        case "wc_sessionEvent":
          return await this.onSessionEventRequest(s, n);
        case "wc_sessionAuthenticate":
          return await this.onSessionAuthenticateRequest({ topic: s, payload: n, attestation: i, encryptedId: a, transportType: o });
        default:
          return this.client.logger.info(`Unsupported request method ${c}`);
      }
    }), Z(this, "onRelayEventResponse", async (r) => {
      const { topic: s, payload: n, transportType: i } = r, o = (await this.client.core.history.get(s, n.id)).request.method;
      switch (o) {
        case "wc_sessionPropose":
          return this.onSessionProposeResponse(s, n, i);
        case "wc_sessionSettle":
          return this.onSessionSettleResponse(s, n);
        case "wc_sessionUpdate":
          return this.onSessionUpdateResponse(s, n);
        case "wc_sessionExtend":
          return this.onSessionExtendResponse(s, n);
        case "wc_sessionPing":
          return this.onSessionPingResponse(s, n);
        case "wc_sessionRequest":
          return this.onSessionRequestResponse(s, n);
        case "wc_sessionAuthenticate":
          return this.onSessionAuthenticateResponse(s, n);
        default:
          return this.client.logger.info(`Unsupported response method ${o}`);
      }
    }), Z(this, "onRelayEventUnknownPayload", (r) => {
      const { topic: s } = r, { message: n } = Q("MISSING_OR_INVALID", `Decoded payload on topic ${s} is not identifiable as a JSON-RPC request or a response.`);
      throw new Error(n);
    }), Z(this, "shouldIgnorePairingRequest", (r) => {
      const { topic: s, requestMethod: n } = r, i = this.expectedPairingMethodMap.get(s);
      return !i || i.includes(n) ? !1 : !!(i.includes("wc_sessionAuthenticate") && this.client.events.listenerCount("session_authenticate") > 0);
    }), Z(this, "onSessionProposeRequest", async (r) => {
      const { topic: s, payload: n, attestation: i, encryptedId: o } = r, { params: a, id: c } = n;
      try {
        const l = this.client.core.eventClient.getEvent({ topic: s });
        this.client.events.listenerCount("session_proposal") === 0 && (console.warn("No listener for session_proposal event"), l == null || l.setError(bs.proposal_listener_not_found)), this.isValidConnect(Pe({}, n.params));
        const u = a.expiryTimestamp || Ze(Qe.wc_sessionPropose.req.ttl), h = Pe({ id: c, pairingTopic: s, expiryTimestamp: u, attestation: i, encryptedId: o }, a);
        await this.setProposal(c, h);
        const p = await this.getVerifyContext({ attestationId: i, hash: Wr(JSON.stringify(n)), encryptedId: o, metadata: h.proposer.metadata });
        l == null || l.addTrace(Vr.emit_session_proposal), this.client.events.emit("session_proposal", { id: c, params: h, verifyContext: p });
      } catch (l) {
        await this.sendError({ id: c, topic: s, error: l, rpcOpts: Qe.wc_sessionPropose.autoReject }), this.client.logger.error(l);
      }
    }), Z(this, "onSessionProposeResponse", async (r, s, n) => {
      const { id: i } = s;
      if (Dr(s)) {
        const { result: o } = s;
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", result: o });
        const a = this.client.proposal.get(i);
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", proposal: a });
        const c = a.proposer.publicKey;
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", selfPublicKey: c });
        const l = o.responderPublicKey;
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", peerPublicKey: l });
        const u = await this.client.core.crypto.generateSharedKey(c, l);
        this.pendingSessions.set(i, { sessionTopic: u, pairingTopic: r, proposalId: i, publicKey: c });
        const h = await this.client.core.relayer.subscribe(u, { transportType: n });
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", subscriptionId: h }), await this.client.core.pairing.activate({ topic: r });
      } else if (jt(s)) {
        await this.deleteProposal(i);
        const o = Ee("session_connect", i);
        if (this.events.listenerCount(o) === 0) throw new Error(`emitting ${o} without any listeners, 954`);
        this.events.emit(o, { error: s.error });
      }
    }), Z(this, "onSessionSettleRequest", async (r, s) => {
      const { id: n, params: i } = s;
      try {
        this.isValidSessionSettleRequest(i);
        const { relay: o, controller: a, expiry: c, namespaces: l, sessionProperties: u, scopedProperties: h, sessionConfig: p } = s.params, y = [...this.pendingSessions.values()].find((x) => x.sessionTopic === r);
        if (!y) return this.client.logger.error(`Pending session not found for topic ${r}`);
        const b = this.client.proposal.get(y.proposalId), g = Nt(Pe(Pe(Pe({ topic: r, relay: o, expiry: c, namespaces: l, acknowledged: !0, pairingTopic: y.pairingTopic, requiredNamespaces: b.requiredNamespaces, optionalNamespaces: b.optionalNamespaces, controller: a.publicKey, self: { publicKey: y.publicKey, metadata: this.client.metadata }, peer: { publicKey: a.publicKey, metadata: a.metadata } }, u && { sessionProperties: u }), h && { scopedProperties: h }), p && { sessionConfig: p }), { transportType: Re.relay });
        await this.client.session.set(g.topic, g), await this.setExpiry(g.topic, g.expiry), await this.client.core.pairing.updateMetadata({ topic: y.pairingTopic, metadata: g.peer.metadata }), this.client.events.emit("session_connect", { session: g }), this.events.emit(Ee("session_connect", y.proposalId), { session: g }), this.pendingSessions.delete(y.proposalId), this.deleteProposal(y.proposalId, !1), this.cleanupDuplicatePairings(g), await this.sendResult({ id: s.id, topic: r, result: !0 });
      } catch (o) {
        await this.sendError({ id: n, topic: r, error: o }), this.client.logger.error(o);
      }
    }), Z(this, "onSessionSettleResponse", async (r, s) => {
      const { id: n } = s;
      Dr(s) ? (await this.client.session.update(r, { acknowledged: !0 }), this.events.emit(Ee("session_approve", n), {})) : jt(s) && (await this.client.session.delete(r, ze("USER_DISCONNECTED")), this.events.emit(Ee("session_approve", n), { error: s.error }));
    }), Z(this, "onSessionUpdateRequest", async (r, s) => {
      const { params: n, id: i } = s;
      try {
        const o = `${r}_session_update`, a = Xi.get(o);
        if (a && this.isRequestOutOfSync(a, i)) {
          this.client.logger.warn(`Discarding out of sync request - ${i}`), this.sendError({ id: i, topic: r, error: ze("INVALID_UPDATE_REQUEST") });
          return;
        }
        this.isValidUpdate(Pe({ topic: r }, n));
        try {
          Xi.set(o, i), await this.client.session.update(r, { namespaces: n.namespaces }), await this.sendResult({ id: i, topic: r, result: !0 });
        } catch (c) {
          throw Xi.delete(o), c;
        }
        this.client.events.emit("session_update", { id: i, topic: r, params: n });
      } catch (o) {
        await this.sendError({ id: i, topic: r, error: o }), this.client.logger.error(o);
      }
    }), Z(this, "isRequestOutOfSync", (r, s) => s.toString().slice(0, -3) < r.toString().slice(0, -3)), Z(this, "onSessionUpdateResponse", (r, s) => {
      const { id: n } = s, i = Ee("session_update", n);
      if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
      Dr(s) ? this.events.emit(Ee("session_update", n), {}) : jt(s) && this.events.emit(Ee("session_update", n), { error: s.error });
    }), Z(this, "onSessionExtendRequest", async (r, s) => {
      const { id: n } = s;
      try {
        this.isValidExtend({ topic: r }), await this.setExpiry(r, Ze(Xn)), await this.sendResult({ id: n, topic: r, result: !0 }), this.client.events.emit("session_extend", { id: n, topic: r });
      } catch (i) {
        await this.sendError({ id: n, topic: r, error: i }), this.client.logger.error(i);
      }
    }), Z(this, "onSessionExtendResponse", (r, s) => {
      const { id: n } = s, i = Ee("session_extend", n);
      if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
      Dr(s) ? this.events.emit(Ee("session_extend", n), {}) : jt(s) && this.events.emit(Ee("session_extend", n), { error: s.error });
    }), Z(this, "onSessionPingRequest", async (r, s) => {
      const { id: n } = s;
      try {
        this.isValidPing({ topic: r }), await this.sendResult({ id: n, topic: r, result: !0, throwOnFailedPublish: !0 }), this.client.events.emit("session_ping", { id: n, topic: r });
      } catch (i) {
        await this.sendError({ id: n, topic: r, error: i }), this.client.logger.error(i);
      }
    }), Z(this, "onSessionPingResponse", (r, s) => {
      const { id: n } = s, i = Ee("session_ping", n);
      setTimeout(() => {
        if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners 2176`);
        Dr(s) ? this.events.emit(Ee("session_ping", n), {}) : jt(s) && this.events.emit(Ee("session_ping", n), { error: s.error });
      }, 500);
    }), Z(this, "onSessionDeleteRequest", async (r, s) => {
      const { id: n } = s;
      try {
        this.isValidDisconnect({ topic: r, reason: s.params }), Promise.all([new Promise((i) => {
          this.client.core.relayer.once(tt.publish, async () => {
            i(await this.deleteSession({ topic: r, id: n }));
          });
        }), this.sendResult({ id: n, topic: r, result: !0 }), this.cleanupPendingSentRequestsForTopic({ topic: r, error: ze("USER_DISCONNECTED") })]).catch((i) => this.client.logger.error(i));
      } catch (i) {
        this.client.logger.error(i);
      }
    }), Z(this, "onSessionRequest", async (r) => {
      var s, n, i;
      const { topic: o, payload: a, attestation: c, encryptedId: l, transportType: u } = r, { id: h, params: p } = a;
      try {
        await this.isValidRequest(Pe({ topic: o }, p));
        const y = this.client.session.get(o), b = await this.getVerifyContext({ attestationId: c, hash: Wr(JSON.stringify(Es("wc_sessionRequest", p, h))), encryptedId: l, metadata: y.peer.metadata, transportType: u }), g = { id: h, topic: o, params: p, verifyContext: b };
        await this.setPendingSessionRequest(g), u === Re.link_mode && (s = y.peer.metadata.redirect) != null && s.universal && this.client.core.addLinkModeSupportedApp((n = y.peer.metadata.redirect) == null ? void 0 : n.universal), (i = this.client.signConfig) != null && i.disableRequestQueue ? this.emitSessionRequest(g) : (this.addSessionRequestToSessionRequestQueue(g), this.processSessionRequestQueue());
      } catch (y) {
        await this.sendError({ id: h, topic: o, error: y }), this.client.logger.error(y);
      }
    }), Z(this, "onSessionRequestResponse", (r, s) => {
      const { id: n } = s, i = Ee("session_request", n);
      if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
      Dr(s) ? this.events.emit(Ee("session_request", n), { result: s.result }) : jt(s) && this.events.emit(Ee("session_request", n), { error: s.error });
    }), Z(this, "onSessionEventRequest", async (r, s) => {
      const { id: n, params: i } = s;
      try {
        const o = `${r}_session_event_${i.event.name}`, a = Xi.get(o);
        if (a && this.isRequestOutOfSync(a, n)) {
          this.client.logger.info(`Discarding out of sync request - ${n}`);
          return;
        }
        this.isValidEmit(Pe({ topic: r }, i)), this.client.events.emit("session_event", { id: n, topic: r, params: i }), Xi.set(o, n);
      } catch (o) {
        await this.sendError({ id: n, topic: r, error: o }), this.client.logger.error(o);
      }
    }), Z(this, "onSessionAuthenticateResponse", (r, s) => {
      const { id: n } = s;
      this.client.logger.trace({ type: "method", method: "onSessionAuthenticateResponse", topic: r, payload: s }), Dr(s) ? this.events.emit(Ee("session_request", n), { result: s.result }) : jt(s) && this.events.emit(Ee("session_request", n), { error: s.error });
    }), Z(this, "onSessionAuthenticateRequest", async (r) => {
      var s;
      const { topic: n, payload: i, attestation: o, encryptedId: a, transportType: c } = r;
      try {
        const { requester: l, authPayload: u, expiryTimestamp: h } = i.params, p = await this.getVerifyContext({ attestationId: o, hash: Wr(JSON.stringify(i)), encryptedId: a, metadata: l.metadata, transportType: c }), y = { requester: l, pairingTopic: n, id: i.id, authPayload: u, verifyContext: p, expiryTimestamp: h };
        await this.setAuthRequest(i.id, { request: y, pairingTopic: n, transportType: c }), c === Re.link_mode && (s = l.metadata.redirect) != null && s.universal && this.client.core.addLinkModeSupportedApp(l.metadata.redirect.universal), this.client.events.emit("session_authenticate", { topic: n, params: i.params, id: i.id, verifyContext: p });
      } catch (l) {
        this.client.logger.error(l);
        const u = i.params.requester.publicKey, h = await this.client.core.crypto.generateKeyPair(), p = this.getAppLinkIfEnabled(i.params.requester.metadata, c), y = { type: xs, receiverPublicKey: u, senderPublicKey: h };
        await this.sendError({ id: i.id, topic: n, error: l, encodeOpts: y, rpcOpts: Qe.wc_sessionAuthenticate.autoReject, appLink: p });
      }
    }), Z(this, "addSessionRequestToSessionRequestQueue", (r) => {
      this.sessionRequestQueue.queue.push(r);
    }), Z(this, "cleanupAfterResponse", (r) => {
      this.deletePendingSessionRequest(r.response.id, { message: "fulfilled", code: 0 }), setTimeout(() => {
        this.sessionRequestQueue.state = Kr.idle, this.processSessionRequestQueue();
      }, V.toMiliseconds(this.requestQueueDelay));
    }), Z(this, "cleanupPendingSentRequestsForTopic", ({ topic: r, error: s }) => {
      const n = this.client.core.history.pending;
      n.length > 0 && n.filter((i) => i.topic === r && i.request.method === "wc_sessionRequest").forEach((i) => {
        const o = i.request.id, a = Ee("session_request", o);
        if (this.events.listenerCount(a) === 0) throw new Error(`emitting ${a} without any listeners`);
        this.events.emit(Ee("session_request", i.request.id), { error: s });
      });
    }), Z(this, "processSessionRequestQueue", () => {
      if (this.sessionRequestQueue.state === Kr.active) {
        this.client.logger.info("session request queue is already active.");
        return;
      }
      const r = this.sessionRequestQueue.queue[0];
      if (!r) {
        this.client.logger.info("session request queue is empty.");
        return;
      }
      try {
        this.emitSessionRequest(r);
      } catch (s) {
        this.client.logger.error(s);
      }
    }), Z(this, "emitSessionRequest", (r) => {
      if (this.emittedSessionRequests.has(r.id)) {
        this.client.logger.warn({ id: r.id }, `Skipping emitting \`session_request\` event for duplicate request. id: ${r.id}`);
        return;
      }
      this.sessionRequestQueue.state = Kr.active, this.emittedSessionRequests.add(r.id), this.client.events.emit("session_request", r);
    }), Z(this, "onPairingCreated", (r) => {
      if (r.methods && this.expectedPairingMethodMap.set(r.topic, r.methods), r.active) return;
      const s = this.client.proposal.getAll().find((n) => n.pairingTopic === r.topic);
      s && this.onSessionProposeRequest({ topic: r.topic, payload: Es("wc_sessionPropose", Nt(Pe({}, s), { requiredNamespaces: s.requiredNamespaces, optionalNamespaces: s.optionalNamespaces, relays: s.relays, proposer: s.proposer, sessionProperties: s.sessionProperties, scopedProperties: s.scopedProperties }), s.id), attestation: s.attestation, encryptedId: s.encryptedId });
    }), Z(this, "isValidConnect", async (r) => {
      if (!Mt(r)) {
        const { message: l } = Q("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(r)}`);
        throw new Error(l);
      }
      const { pairingTopic: s, requiredNamespaces: n, optionalNamespaces: i, sessionProperties: o, scopedProperties: a, relays: c } = r;
      if (ht(s) || await this.isValidPairingTopic(s), !pD(c)) {
        const { message: l } = Q("MISSING_OR_INVALID", `connect() relays: ${c}`);
        throw new Error(l);
      }
      if (!ht(n) && sa(n) !== 0) {
        const l = "requiredNamespaces are deprecated and are automatically assigned to optionalNamespaces";
        ["fatal", "error", "silent"].includes(this.client.logger.level) ? console.warn(l) : this.client.logger.warn(l), this.validateNamespaces(n, "requiredNamespaces");
      }
      if (!ht(i) && sa(i) !== 0 && this.validateNamespaces(i, "optionalNamespaces"), ht(o) || this.validateSessionProps(o, "sessionProperties"), !ht(a)) {
        this.validateSessionProps(a, "scopedProperties");
        const l = Object.keys(n || {}).concat(Object.keys(i || {}));
        if (!Object.keys(a).every((u) => l.includes(u.split(":")[0]))) throw new Error(`Scoped properties must be a subset of required/optional namespaces, received: ${JSON.stringify(a)}, required/optional namespaces: ${JSON.stringify(l)}`);
      }
    }), Z(this, "validateNamespaces", (r, s) => {
      const n = dD(r, "connect()", s);
      if (n) throw new Error(n.message);
    }), Z(this, "isValidApprove", async (r) => {
      if (!Mt(r)) throw new Error(Q("MISSING_OR_INVALID", `approve() params: ${r}`).message);
      const { id: s, namespaces: n, relayProtocol: i, sessionProperties: o, scopedProperties: a } = r;
      this.checkRecentlyDeleted(s), await this.isValidProposalId(s);
      const c = this.client.proposal.get(s), l = Nu(n, "approve()");
      if (l) throw new Error(l.message);
      const u = Gb(c.requiredNamespaces, n, "approve()");
      if (u) throw new Error(u.message);
      if (!Ve(i, !0)) {
        const { message: h } = Q("MISSING_OR_INVALID", `approve() relayProtocol: ${i}`);
        throw new Error(h);
      }
      if (ht(o) || this.validateSessionProps(o, "sessionProperties"), !ht(a)) {
        this.validateSessionProps(a, "scopedProperties");
        const h = new Set(Object.keys(n));
        if (!Object.keys(a).every((p) => h.has(p.split(":")[0]))) throw new Error(`Scoped properties must be a subset of approved namespaces, received: ${JSON.stringify(a)}, approved namespaces: ${Array.from(h).join(", ")}`);
      }
    }), Z(this, "isValidReject", async (r) => {
      if (!Mt(r)) {
        const { message: i } = Q("MISSING_OR_INVALID", `reject() params: ${r}`);
        throw new Error(i);
      }
      const { id: s, reason: n } = r;
      if (this.checkRecentlyDeleted(s), await this.isValidProposalId(s), !mD(n)) {
        const { message: i } = Q("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(n)}`);
        throw new Error(i);
      }
    }), Z(this, "isValidSessionSettleRequest", (r) => {
      if (!Mt(r)) {
        const { message: l } = Q("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${r}`);
        throw new Error(l);
      }
      const { relay: s, controller: n, namespaces: i, expiry: o } = r;
      if (!d2(s)) {
        const { message: l } = Q("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
        throw new Error(l);
      }
      const a = oD(n, "onSessionSettleRequest()");
      if (a) throw new Error(a.message);
      const c = Nu(i, "onSessionSettleRequest()");
      if (c) throw new Error(c.message);
      if (Js(o)) {
        const { message: l } = Q("EXPIRED", "onSessionSettleRequest()");
        throw new Error(l);
      }
    }), Z(this, "isValidUpdate", async (r) => {
      if (!Mt(r)) {
        const { message: c } = Q("MISSING_OR_INVALID", `update() params: ${r}`);
        throw new Error(c);
      }
      const { topic: s, namespaces: n } = r;
      this.checkRecentlyDeleted(s), await this.isValidSessionTopic(s);
      const i = this.client.session.get(s), o = Nu(n, "update()");
      if (o) throw new Error(o.message);
      const a = Gb(i.requiredNamespaces, n, "update()");
      if (a) throw new Error(a.message);
    }), Z(this, "isValidExtend", async (r) => {
      if (!Mt(r)) {
        const { message: n } = Q("MISSING_OR_INVALID", `extend() params: ${r}`);
        throw new Error(n);
      }
      const { topic: s } = r;
      this.checkRecentlyDeleted(s), await this.isValidSessionTopic(s);
    }), Z(this, "isValidRequest", async (r) => {
      if (!Mt(r)) {
        const { message: c } = Q("MISSING_OR_INVALID", `request() params: ${r}`);
        throw new Error(c);
      }
      const { topic: s, request: n, chainId: i, expiry: o } = r;
      this.checkRecentlyDeleted(s), await this.isValidSessionTopic(s);
      const { namespaces: a } = this.client.session.get(s);
      if (!Vb(a, i)) {
        const { message: c } = Q("MISSING_OR_INVALID", `request() chainId: ${i}`);
        throw new Error(c);
      }
      if (!bD(n)) {
        const { message: c } = Q("MISSING_OR_INVALID", `request() ${JSON.stringify(n)}`);
        throw new Error(c);
      }
      if (!wD(a, i, n.method)) {
        const { message: c } = Q("MISSING_OR_INVALID", `request() method: ${n.method}`);
        throw new Error(c);
      }
      if (o && !kD(o, qu)) {
        const { message: c } = Q("MISSING_OR_INVALID", `request() expiry: ${o}. Expiry must be a number (in seconds) between ${qu.min} and ${qu.max}`);
        throw new Error(c);
      }
    }), Z(this, "isValidRespond", async (r) => {
      var s;
      if (!Mt(r)) {
        const { message: o } = Q("MISSING_OR_INVALID", `respond() params: ${r}`);
        throw new Error(o);
      }
      const { topic: n, response: i } = r;
      try {
        await this.isValidSessionTopic(n);
      } catch (o) {
        throw (s = r == null ? void 0 : r.response) != null && s.id && this.cleanupAfterResponse(r), o;
      }
      if (!yD(i)) {
        const { message: o } = Q("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(i)}`);
        throw new Error(o);
      }
    }), Z(this, "isValidPing", async (r) => {
      if (!Mt(r)) {
        const { message: n } = Q("MISSING_OR_INVALID", `ping() params: ${r}`);
        throw new Error(n);
      }
      const { topic: s } = r;
      await this.isValidSessionOrPairingTopic(s);
    }), Z(this, "isValidEmit", async (r) => {
      if (!Mt(r)) {
        const { message: a } = Q("MISSING_OR_INVALID", `emit() params: ${r}`);
        throw new Error(a);
      }
      const { topic: s, event: n, chainId: i } = r;
      await this.isValidSessionTopic(s);
      const { namespaces: o } = this.client.session.get(s);
      if (!Vb(o, i)) {
        const { message: a } = Q("MISSING_OR_INVALID", `emit() chainId: ${i}`);
        throw new Error(a);
      }
      if (!gD(n)) {
        const { message: a } = Q("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(n)}`);
        throw new Error(a);
      }
      if (!ED(o, i, n.name)) {
        const { message: a } = Q("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(n)}`);
        throw new Error(a);
      }
    }), Z(this, "isValidDisconnect", async (r) => {
      if (!Mt(r)) {
        const { message: n } = Q("MISSING_OR_INVALID", `disconnect() params: ${r}`);
        throw new Error(n);
      }
      const { topic: s } = r;
      await this.isValidSessionOrPairingTopic(s);
    }), Z(this, "isValidAuthenticate", (r) => {
      const { chains: s, uri: n, domain: i, nonce: o } = r;
      if (!Array.isArray(s) || s.length === 0) throw new Error("chains is required and must be a non-empty array");
      if (!Ve(n, !1)) throw new Error("uri is required parameter");
      if (!Ve(i, !1)) throw new Error("domain is required parameter");
      if (!Ve(o, !1)) throw new Error("nonce is required parameter");
      if ([...new Set(s.map((c) => Fc(c).namespace))].length > 1) throw new Error("Multi-namespace requests are not supported. Please request single namespace only.");
      const { namespace: a } = Fc(s[0]);
      if (a !== "eip155") throw new Error("Only eip155 namespace is supported for authenticated sessions. Please use .connect() for non-eip155 chains.");
    }), Z(this, "getVerifyContext", async (r) => {
      const { attestationId: s, hash: n, encryptedId: i, metadata: o, transportType: a } = r, c = { verified: { verifyUrl: o.verifyUrl || jo, validation: "UNKNOWN", origin: o.url || "" } };
      try {
        if (a === Re.link_mode) {
          const u = this.getAppLinkIfEnabled(o, a);
          return c.verified.validation = u && new URL(u).origin === new URL(o.url).origin ? "VALID" : "INVALID", c;
        }
        const l = await this.client.core.verify.resolve({ attestationId: s, hash: n, encryptedId: i, verifyUrl: o.verifyUrl });
        l && (c.verified.origin = l.origin, c.verified.isScam = l.isScam, c.verified.validation = l.origin === new URL(o.url).origin ? "VALID" : "INVALID");
      } catch (l) {
        this.client.logger.warn(l);
      }
      return this.client.logger.debug(`Verify context: ${JSON.stringify(c)}`), c;
    }), Z(this, "validateSessionProps", (r, s) => {
      Object.values(r).forEach((n, i) => {
        if (n == null) {
          const { message: o } = Q("MISSING_OR_INVALID", `${s} must contain an existing value for each key. Received: ${n} for key ${Object.keys(r)[i]}`);
          throw new Error(o);
        }
      });
    }), Z(this, "getPendingAuthRequest", (r) => {
      const s = this.client.auth.requests.get(r);
      return typeof s == "object" ? s : void 0;
    }), Z(this, "addToRecentlyDeleted", (r, s) => {
      if (this.recentlyDeletedMap.set(r, s), this.recentlyDeletedMap.size >= this.recentlyDeletedLimit) {
        let n = 0;
        const i = this.recentlyDeletedLimit / 2;
        for (const o of this.recentlyDeletedMap.keys()) {
          if (n++ >= i) break;
          this.recentlyDeletedMap.delete(o);
        }
      }
    }), Z(this, "checkRecentlyDeleted", (r) => {
      const s = this.recentlyDeletedMap.get(r);
      if (s) {
        const { message: n } = Q("MISSING_OR_INVALID", `Record was recently deleted - ${s}: ${r}`);
        throw new Error(n);
      }
    }), Z(this, "isLinkModeEnabled", (r, s) => {
      var n, i, o, a, c, l, u, h, p;
      return !r || s !== Re.link_mode ? !1 : ((i = (n = this.client.metadata) == null ? void 0 : n.redirect) == null ? void 0 : i.linkMode) === !0 && ((a = (o = this.client.metadata) == null ? void 0 : o.redirect) == null ? void 0 : a.universal) !== void 0 && ((l = (c = this.client.metadata) == null ? void 0 : c.redirect) == null ? void 0 : l.universal) !== "" && ((u = r == null ? void 0 : r.redirect) == null ? void 0 : u.universal) !== void 0 && ((h = r == null ? void 0 : r.redirect) == null ? void 0 : h.universal) !== "" && ((p = r == null ? void 0 : r.redirect) == null ? void 0 : p.linkMode) === !0 && this.client.core.linkModeSupportedApps.includes(r.redirect.universal) && typeof (globalThis == null ? void 0 : globalThis.Linking) < "u";
    }), Z(this, "getAppLinkIfEnabled", (r, s) => {
      var n;
      return this.isLinkModeEnabled(r, s) ? (n = r == null ? void 0 : r.redirect) == null ? void 0 : n.universal : void 0;
    }), Z(this, "handleLinkModeMessage", ({ url: r }) => {
      if (!r || !r.includes("wc_ev") || !r.includes("topic")) return;
      const s = ob(r, "topic") || "", n = decodeURIComponent(ob(r, "wc_ev") || ""), i = this.client.session.keys.includes(s);
      i && this.client.session.update(s, { transportType: Re.link_mode }), this.client.core.dispatchEnvelope({ topic: s, message: n, sessionExists: i });
    }), Z(this, "registerLinkModeListeners", async () => {
      var r;
      if (gp() || hn() && (r = this.client.metadata.redirect) != null && r.linkMode) {
        const s = globalThis == null ? void 0 : globalThis.Linking;
        if (typeof s < "u") {
          s.addEventListener("url", this.handleLinkModeMessage, this.client.name);
          const n = await s.getInitialURL();
          n && setTimeout(() => {
            this.handleLinkModeMessage({ url: n });
          }, 50);
        }
      }
    }), Z(this, "getTVFParams", (r, s, n) => {
      var i, o, a;
      if (!((i = s.request) != null && i.method)) return {};
      const c = { correlationId: r, rpcMethods: [s.request.method], chainId: s.chainId };
      try {
        const l = this.extractTxHashesFromResult(s.request, n);
        c.txHashes = l, c.contractAddresses = this.isValidContractData(s.request.params) ? [(a = (o = s.request.params) == null ? void 0 : o[0]) == null ? void 0 : a.to] : [];
      } catch (l) {
        this.client.logger.warn("Error getting TVF params", l);
      }
      return c;
    }), Z(this, "isValidContractData", (r) => {
      var s;
      if (!r) return !1;
      try {
        const n = (r == null ? void 0 : r.data) || ((s = r == null ? void 0 : r[0]) == null ? void 0 : s.data);
        if (!n.startsWith("0x")) return !1;
        const i = n.slice(2);
        return /^[0-9a-fA-F]*$/.test(i) ? i.length % 2 === 0 : !1;
      } catch {
      }
      return !1;
    }), Z(this, "extractTxHashesFromResult", (r, s) => {
      var n;
      try {
        if (!s) return [];
        const i = r.method, o = vN[i];
        if (i === "sui_signTransaction") return [KU(s.transactionBytes)];
        if (i === "near_signTransaction") return [fb(s)];
        if (i === "near_signTransactions") return s.map((c) => fb(c));
        if (i === "xrpl_signTransactionFor" || i === "xrpl_signTransaction") return [(n = s.tx_json) == null ? void 0 : n.hash];
        if (i === "polkadot_signTransaction") return [LD({ transaction: r.params.transactionPayload, signature: s.signature })];
        if (i === "algo_signTxn") return hi(s) ? s.map((c) => mb(c)) : [mb(s)];
        if (i === "cosmos_signDirect") return [GU(s)];
        if (typeof s == "string") return [s];
        const a = s[o.key];
        if (hi(a)) return i === "solana_signAllTransactions" ? a.map((c) => qU(c)) : a;
        if (typeof a == "string") return [a];
      } catch (i) {
        this.client.logger.warn("Error extracting tx hashes from result", i);
      }
      return [];
    });
  }
  async processPendingMessageEvents() {
    try {
      const e = this.client.session.keys, r = this.client.core.relayer.messages.getWithoutAck(e);
      for (const [s, n] of Object.entries(r)) for (const i of n) try {
        await this.onProviderMessageEvent({ topic: s, message: i, publishedAt: Date.now() });
      } catch {
        this.client.logger.warn(`Error processing pending message event for topic: ${s}, message: ${i}`);
      }
    } catch (e) {
      this.client.logger.warn("processPendingMessageEvents failed", e);
    }
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = Q("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  async confirmOnlineStateOrThrow() {
    await this.client.core.relayer.confirmOnlineStateOrThrow();
  }
  registerRelayerEvents() {
    this.client.core.relayer.on(tt.message, (e) => {
      this.onProviderMessageEvent(e);
    });
  }
  async onRelayMessage(e) {
    const { topic: r, message: s, attestation: n, transportType: i } = e, { publicKey: o } = this.client.auth.authKeys.keys.includes(qc) ? this.client.auth.authKeys.get(qc) : { publicKey: void 0 };
    try {
      const a = await this.client.core.crypto.decode(r, s, { receiverPublicKey: o, encoding: i === Re.link_mode ? en : Pr });
      wa(a) ? (this.client.core.history.set(r, a), await this.onRelayEventRequest({ topic: r, payload: a, attestation: n, transportType: i, encryptedId: Wr(s) })) : ki(a) ? (await this.client.core.history.resolve(a), await this.onRelayEventResponse({ topic: r, payload: a, transportType: i }), this.client.core.history.delete(r, a.id)) : await this.onRelayEventUnknownPayload({ topic: r, payload: a, transportType: i }), await this.client.core.relayer.messages.ack(r, s);
    } catch (a) {
      this.client.logger.error(a);
    }
  }
  registerExpirerEvents() {
    this.client.core.expirer.on(ur.expired, async (e) => {
      const { topic: r, id: s } = ww(e.target);
      if (s && this.client.pendingRequest.keys.includes(s)) return await this.deletePendingSessionRequest(s, Q("EXPIRED"), !0);
      if (s && this.client.auth.requests.keys.includes(s)) return await this.deletePendingAuthRequest(s, Q("EXPIRED"), !0);
      r ? this.client.session.keys.includes(r) && (await this.deleteSession({ topic: r, expirerHasDeleted: !0 }), this.client.events.emit("session_expire", { topic: r })) : s && (await this.deleteProposal(s, !0), this.client.events.emit("proposal_expire", { id: s }));
    });
  }
  registerPairingEvents() {
    this.client.core.pairing.events.on(gn.create, (e) => this.onPairingCreated(e)), this.client.core.pairing.events.on(gn.delete, (e) => {
      this.addToRecentlyDeleted(e.topic, "pairing");
    });
  }
  isValidPairingTopic(e) {
    if (!Ve(e, !1)) {
      const { message: r } = Q("MISSING_OR_INVALID", `pairing topic should be a string: ${e}`);
      throw new Error(r);
    }
    if (!this.client.core.pairing.pairings.keys.includes(e)) {
      const { message: r } = Q("NO_MATCHING_KEY", `pairing topic doesn't exist: ${e}`);
      throw new Error(r);
    }
    if (Js(this.client.core.pairing.pairings.get(e).expiry)) {
      const { message: r } = Q("EXPIRED", `pairing topic: ${e}`);
      throw new Error(r);
    }
  }
  async isValidSessionTopic(e) {
    if (!Ve(e, !1)) {
      const { message: r } = Q("MISSING_OR_INVALID", `session topic should be a string: ${e}`);
      throw new Error(r);
    }
    if (this.checkRecentlyDeleted(e), !this.client.session.keys.includes(e)) {
      const { message: r } = Q("NO_MATCHING_KEY", `session topic doesn't exist: ${e}`);
      throw new Error(r);
    }
    if (Js(this.client.session.get(e).expiry)) {
      await this.deleteSession({ topic: e });
      const { message: r } = Q("EXPIRED", `session topic: ${e}`);
      throw new Error(r);
    }
    if (!this.client.core.crypto.keychain.has(e)) {
      const { message: r } = Q("MISSING_OR_INVALID", `session topic does not exist in keychain: ${e}`);
      throw await this.deleteSession({ topic: e }), new Error(r);
    }
  }
  async isValidSessionOrPairingTopic(e) {
    if (this.checkRecentlyDeleted(e), this.client.session.keys.includes(e)) await this.isValidSessionTopic(e);
    else if (this.client.core.pairing.pairings.keys.includes(e)) this.isValidPairingTopic(e);
    else if (Ve(e, !1)) {
      const { message: r } = Q("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${e}`);
      throw new Error(r);
    } else {
      const { message: r } = Q("MISSING_OR_INVALID", `session or pairing topic should be a string: ${e}`);
      throw new Error(r);
    }
  }
  async isValidProposalId(e) {
    if (!fD(e)) {
      const { message: r } = Q("MISSING_OR_INVALID", `proposal id should be a number: ${e}`);
      throw new Error(r);
    }
    if (!this.client.proposal.keys.includes(e)) {
      const { message: r } = Q("NO_MATCHING_KEY", `proposal id doesn't exist: ${e}`);
      throw new Error(r);
    }
    if (Js(this.client.proposal.get(e).expiryTimestamp)) {
      await this.deleteProposal(e);
      const { message: r } = Q("EXPIRED", `proposal id: ${e}`);
      throw new Error(r);
    }
  }
}
class RN extends Pn {
  constructor(e, r) {
    super(e, r, wN, Dp), this.core = e, this.logger = r;
  }
}
class B2 extends Pn {
  constructor(e, r) {
    super(e, r, EN, Dp), this.core = e, this.logger = r;
  }
}
class NN extends Pn {
  constructor(e, r) {
    super(e, r, kN, Dp, (s) => s.id), this.core = e, this.logger = r;
  }
}
class LN extends Pn {
  constructor(e, r) {
    super(e, r, AN, jl, () => qc), this.core = e, this.logger = r;
  }
}
class MN extends Pn {
  constructor(e, r) {
    super(e, r, _N, jl), this.core = e, this.logger = r;
  }
}
class FN extends Pn {
  constructor(e, r) {
    super(e, r, TN, jl, (s) => s.id), this.core = e, this.logger = r;
  }
}
var zN = Object.defineProperty, jN = (t, e, r) => e in t ? zN(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Ku = (t, e, r) => jN(t, typeof e != "symbol" ? e + "" : e, r);
class HN {
  constructor(e, r) {
    this.core = e, this.logger = r, Ku(this, "authKeys"), Ku(this, "pairingTopics"), Ku(this, "requests"), this.authKeys = new LN(this.core, this.logger), this.pairingTopics = new MN(this.core, this.logger), this.requests = new FN(this.core, this.logger);
  }
  async init() {
    await this.authKeys.init(), await this.pairingTopics.init(), await this.requests.init();
  }
}
var qN = Object.defineProperty, KN = (t, e, r) => e in t ? qN(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, pe = (t, e, r) => KN(t, typeof e != "symbol" ? e + "" : e, r);
class Op extends vT {
  constructor(e) {
    super(e), pe(this, "protocol", T2), pe(this, "version", U2), pe(this, "name", Hu.name), pe(this, "metadata"), pe(this, "core"), pe(this, "logger"), pe(this, "events", new dt.EventEmitter()), pe(this, "engine"), pe(this, "session"), pe(this, "proposal"), pe(this, "pendingRequest"), pe(this, "auth"), pe(this, "signConfig"), pe(this, "on", (s, n) => this.events.on(s, n)), pe(this, "once", (s, n) => this.events.once(s, n)), pe(this, "off", (s, n) => this.events.off(s, n)), pe(this, "removeListener", (s, n) => this.events.removeListener(s, n)), pe(this, "removeAllListeners", (s) => this.events.removeAllListeners(s)), pe(this, "connect", async (s) => {
      try {
        return await this.engine.connect(s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }), pe(this, "pair", async (s) => {
      try {
        return await this.engine.pair(s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }), pe(this, "approve", async (s) => {
      try {
        return await this.engine.approve(s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }), pe(this, "reject", async (s) => {
      try {
        return await this.engine.reject(s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }), pe(this, "update", async (s) => {
      try {
        return await this.engine.update(s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }), pe(this, "extend", async (s) => {
      try {
        return await this.engine.extend(s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }), pe(this, "request", async (s) => {
      try {
        return await this.engine.request(s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }), pe(this, "respond", async (s) => {
      try {
        return await this.engine.respond(s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }), pe(this, "ping", async (s) => {
      try {
        return await this.engine.ping(s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }), pe(this, "emit", async (s) => {
      try {
        return await this.engine.emit(s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }), pe(this, "disconnect", async (s) => {
      try {
        return await this.engine.disconnect(s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }), pe(this, "find", (s) => {
      try {
        return this.engine.find(s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }), pe(this, "getPendingSessionRequests", () => {
      try {
        return this.engine.getPendingSessionRequests();
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }), pe(this, "authenticate", async (s, n) => {
      try {
        return await this.engine.authenticate(s, n);
      } catch (i) {
        throw this.logger.error(i.message), i;
      }
    }), pe(this, "formatAuthMessage", (s) => {
      try {
        return this.engine.formatAuthMessage(s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }), pe(this, "approveSessionAuthenticate", async (s) => {
      try {
        return await this.engine.approveSessionAuthenticate(s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }), pe(this, "rejectSessionAuthenticate", async (s) => {
      try {
        return await this.engine.rejectSessionAuthenticate(s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }), this.name = (e == null ? void 0 : e.name) || Hu.name, this.metadata = RT(e == null ? void 0 : e.metadata), this.signConfig = e == null ? void 0 : e.signConfig;
    const r = typeof (e == null ? void 0 : e.logger) < "u" && typeof (e == null ? void 0 : e.logger) != "string" ? e.logger : ca(ua({ level: (e == null ? void 0 : e.logger) || Hu.logger }));
    this.core = (e == null ? void 0 : e.core) || new xd(e), this.logger = ve(r, this.name), this.session = new B2(this.core, this.logger), this.proposal = new RN(this.core, this.logger), this.pendingRequest = new NN(this.core, this.logger), this.engine = new PN(this), this.auth = new HN(this.core, this.logger);
  }
  static async init(e) {
    const r = new Op(e);
    return await r.initialize(), r;
  }
  get context() {
    return De(this.logger);
  }
  get pairing() {
    return this.core.pairing.pairings;
  }
  async initialize() {
    this.logger.trace("Initialized");
    try {
      await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.auth.init(), await this.engine.init(), this.logger.info("SignClient Initialization Success");
    } catch (e) {
      throw this.logger.info("SignClient Initialization Failure"), this.logger.error(e.message), e;
    }
  }
}
const VN = B2, GN = Op;
var kd = { exports: {} }, si = typeof Reflect == "object" ? Reflect : null, k1 = si && typeof si.apply == "function" ? si.apply : function(t, e, r) {
  return Function.prototype.apply.call(t, e, r);
}, Kc;
si && typeof si.ownKeys == "function" ? Kc = si.ownKeys : Object.getOwnPropertySymbols ? Kc = function(t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : Kc = function(t) {
  return Object.getOwnPropertyNames(t);
};
function WN(t) {
  console && console.warn && console.warn(t);
}
var C1 = Number.isNaN || function(t) {
  return t !== t;
};
function ke() {
  ke.init.call(this);
}
kd.exports = ke, kd.exports.once = YN, ke.EventEmitter = ke, ke.prototype._events = void 0, ke.prototype._eventsCount = 0, ke.prototype._maxListeners = void 0;
var S1 = 10;
function Vc(t) {
  if (typeof t != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
}
Object.defineProperty(ke, "defaultMaxListeners", { enumerable: !0, get: function() {
  return S1;
}, set: function(t) {
  if (typeof t != "number" || t < 0 || C1(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
  S1 = t;
} }), ke.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
}, ke.prototype.setMaxListeners = function(t) {
  if (typeof t != "number" || t < 0 || C1(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
  return this._maxListeners = t, this;
};
function D2(t) {
  return t._maxListeners === void 0 ? ke.defaultMaxListeners : t._maxListeners;
}
ke.prototype.getMaxListeners = function() {
  return D2(this);
}, ke.prototype.emit = function(t) {
  for (var e = [], r = 1; r < arguments.length; r++) e.push(arguments[r]);
  var s = t === "error", n = this._events;
  if (n !== void 0) s = s && n.error === void 0;
  else if (!s) return !1;
  if (s) {
    var i;
    if (e.length > 0 && (i = e[0]), i instanceof Error) throw i;
    var o = new Error("Unhandled error." + (i ? " (" + i.message + ")" : ""));
    throw o.context = i, o;
  }
  var a = n[t];
  if (a === void 0) return !1;
  if (typeof a == "function") k1(a, this, e);
  else for (var c = a.length, l = O2(a, c), r = 0; r < c; ++r) k1(l[r], this, e);
  return !0;
};
function I1(t, e, r, s) {
  var n, i, o;
  if (Vc(r), i = t._events, i === void 0 ? (i = t._events = /* @__PURE__ */ Object.create(null), t._eventsCount = 0) : (i.newListener !== void 0 && (t.emit("newListener", e, r.listener ? r.listener : r), i = t._events), o = i[e]), o === void 0) o = i[e] = r, ++t._eventsCount;
  else if (typeof o == "function" ? o = i[e] = s ? [r, o] : [o, r] : s ? o.unshift(r) : o.push(r), n = D2(t), n > 0 && o.length > n && !o.warned) {
    o.warned = !0;
    var a = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    a.name = "MaxListenersExceededWarning", a.emitter = t, a.type = e, a.count = o.length, WN(a);
  }
  return t;
}
ke.prototype.addListener = function(t, e) {
  return I1(this, t, e, !1);
}, ke.prototype.on = ke.prototype.addListener, ke.prototype.prependListener = function(t, e) {
  return I1(this, t, e, !0);
};
function ZN() {
  if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function A1(t, e, r) {
  var s = { fired: !1, wrapFn: void 0, target: t, type: e, listener: r }, n = ZN.bind(s);
  return n.listener = r, s.wrapFn = n, n;
}
ke.prototype.once = function(t, e) {
  return Vc(e), this.on(t, A1(this, t, e)), this;
}, ke.prototype.prependOnceListener = function(t, e) {
  return Vc(e), this.prependListener(t, A1(this, t, e)), this;
}, ke.prototype.removeListener = function(t, e) {
  var r, s, n, i, o;
  if (Vc(e), s = this._events, s === void 0) return this;
  if (r = s[t], r === void 0) return this;
  if (r === e || r.listener === e) --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete s[t], s.removeListener && this.emit("removeListener", t, r.listener || e));
  else if (typeof r != "function") {
    for (n = -1, i = r.length - 1; i >= 0; i--) if (r[i] === e || r[i].listener === e) {
      o = r[i].listener, n = i;
      break;
    }
    if (n < 0) return this;
    n === 0 ? r.shift() : JN(r, n), r.length === 1 && (s[t] = r[0]), s.removeListener !== void 0 && this.emit("removeListener", t, o || e);
  }
  return this;
}, ke.prototype.off = ke.prototype.removeListener, ke.prototype.removeAllListeners = function(t) {
  var e, r, s;
  if (r = this._events, r === void 0) return this;
  if (r.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : r[t] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete r[t]), this;
  if (arguments.length === 0) {
    var n = Object.keys(r), i;
    for (s = 0; s < n.length; ++s) i = n[s], i !== "removeListener" && this.removeAllListeners(i);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (e = r[t], typeof e == "function") this.removeListener(t, e);
  else if (e !== void 0) for (s = e.length - 1; s >= 0; s--) this.removeListener(t, e[s]);
  return this;
};
function _1(t, e, r) {
  var s = t._events;
  if (s === void 0) return [];
  var n = s[e];
  return n === void 0 ? [] : typeof n == "function" ? r ? [n.listener || n] : [n] : r ? XN(n) : O2(n, n.length);
}
ke.prototype.listeners = function(t) {
  return _1(this, t, !0);
}, ke.prototype.rawListeners = function(t) {
  return _1(this, t, !1);
}, ke.listenerCount = function(t, e) {
  return typeof t.listenerCount == "function" ? t.listenerCount(e) : T1.call(t, e);
}, ke.prototype.listenerCount = T1;
function T1(t) {
  var e = this._events;
  if (e !== void 0) {
    var r = e[t];
    if (typeof r == "function") return 1;
    if (r !== void 0) return r.length;
  }
  return 0;
}
ke.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Kc(this._events) : [];
};
function O2(t, e) {
  for (var r = new Array(e), s = 0; s < e; ++s) r[s] = t[s];
  return r;
}
function JN(t, e) {
  for (; e + 1 < t.length; e++) t[e] = t[e + 1];
  t.pop();
}
function XN(t) {
  for (var e = new Array(t.length), r = 0; r < e.length; ++r) e[r] = t[r].listener || t[r];
  return e;
}
function YN(t, e) {
  return new Promise(function(r, s) {
    function n(o) {
      t.removeListener(e, i), s(o);
    }
    function i() {
      typeof t.removeListener == "function" && t.removeListener("error", n), r([].slice.call(arguments));
    }
    P2(t, e, i, { once: !0 }), e !== "error" && QN(t, n, { once: !0 });
  });
}
function QN(t, e, r) {
  typeof t.on == "function" && P2(t, "error", e, r);
}
function P2(t, e, r, s) {
  if (typeof t.on == "function") s.once ? t.once(e, r) : t.on(e, r);
  else if (typeof t.addEventListener == "function") t.addEventListener(e, function n(i) {
    s.once && t.removeEventListener(e, n), r(i);
  });
  else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof t);
}
const eL = "WalletKit";
class tL {
  constructor(e) {
    this.opts = e;
  }
}
class rL {
  constructor(e) {
    this.client = e;
  }
}
var sL = Object.defineProperty, nL = Object.defineProperties, iL = Object.getOwnPropertyDescriptors, U1 = Object.getOwnPropertySymbols, oL = Object.prototype.hasOwnProperty, aL = Object.prototype.propertyIsEnumerable, $1 = (t, e, r) => e in t ? sL(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, cL = (t, e) => {
  for (var r in e || (e = {})) oL.call(e, r) && $1(t, r, e[r]);
  if (U1) for (var r of U1(e)) aL.call(e, r) && $1(t, r, e[r]);
  return t;
}, lL = (t, e) => nL(t, iL(e));
class uL extends rL {
  constructor(e) {
    super(e), this.init = async () => {
      this.signClient = await GN.init({ core: this.client.core, metadata: this.client.metadata, signConfig: this.client.signConfig }), this.signClient.core.eventClient.init().catch((r) => {
        this.client.logger.warn(r);
      });
    }, this.pair = async (r) => {
      await this.client.core.pairing.pair(r);
    }, this.approveSession = async (r) => {
      const { topic: s, acknowledged: n } = await this.signClient.approve(lL(cL({}, r), { id: r.id, namespaces: r.namespaces, sessionProperties: r.sessionProperties, sessionConfig: r.sessionConfig }));
      return await n(), this.signClient.session.get(s);
    }, this.rejectSession = async (r) => await this.signClient.reject(r), this.updateSession = async (r) => await this.signClient.update(r), this.extendSession = async (r) => await this.signClient.extend(r), this.respondSessionRequest = async (r) => await this.signClient.respond(r), this.disconnectSession = async (r) => await this.signClient.disconnect(r), this.emitSessionEvent = async (r) => await this.signClient.emit(r), this.getActiveSessions = () => this.signClient.session.getAll().reduce((r, s) => (r[s.topic] = s, r), {}), this.getPendingSessionProposals = () => this.signClient.proposal.getAll(), this.getPendingSessionRequests = () => this.signClient.getPendingSessionRequests(), this.approveSessionAuthenticate = async (r) => await this.signClient.approveSessionAuthenticate(r), this.rejectSessionAuthenticate = async (r) => await this.signClient.rejectSessionAuthenticate(r), this.formatAuthMessage = (r) => this.signClient.formatAuthMessage(r), this.registerDeviceToken = (r) => this.client.core.echoClient.registerDeviceToken(r), this.on = (r, s) => (this.setEvent(r, "off"), this.setEvent(r, "on"), this.client.events.on(r, s)), this.once = (r, s) => (this.setEvent(r, "off"), this.setEvent(r, "once"), this.client.events.once(r, s)), this.off = (r, s) => (this.setEvent(r, "off"), this.client.events.off(r, s)), this.removeListener = (r, s) => (this.setEvent(r, "removeListener"), this.client.events.removeListener(r, s)), this.onSessionRequest = (r) => {
      this.client.events.emit("session_request", r);
    }, this.onSessionProposal = (r) => {
      this.client.events.emit("session_proposal", r);
    }, this.onSessionDelete = (r) => {
      this.client.events.emit("session_delete", r);
    }, this.onProposalExpire = (r) => {
      this.client.events.emit("proposal_expire", r);
    }, this.onSessionRequestExpire = (r) => {
      this.client.events.emit("session_request_expire", r);
    }, this.onSessionRequestAuthenticate = (r) => {
      this.client.events.emit("session_authenticate", r);
    }, this.setEvent = (r, s) => {
      switch (r) {
        case "session_request":
          this.signClient.events[s]("session_request", this.onSessionRequest);
          break;
        case "session_proposal":
          this.signClient.events[s]("session_proposal", this.onSessionProposal);
          break;
        case "session_delete":
          this.signClient.events[s]("session_delete", this.onSessionDelete);
          break;
        case "proposal_expire":
          this.signClient.events[s]("proposal_expire", this.onProposalExpire);
          break;
        case "session_request_expire":
          this.signClient.events[s]("session_request_expire", this.onSessionRequestExpire);
          break;
        case "session_authenticate":
          this.signClient.events[s]("session_authenticate", this.onSessionRequestAuthenticate);
          break;
      }
    }, this.signClient = {};
  }
}
const hL = { decryptMessage: async (t) => {
  const e = { core: new xd({ storageOptions: t.storageOptions, storage: t.storage }) };
  await e.core.crypto.init();
  const r = e.core.crypto.decode(t.topic, t.encryptedMessage);
  return e.core = null, r;
}, getMetadata: async (t) => {
  const e = { core: new xd({ storageOptions: t.storageOptions, storage: t.storage }), sessionStore: null };
  e.sessionStore = new VN(e.core, e.core.logger), await e.sessionStore.init();
  const r = e.sessionStore.get(t.topic), s = r == null ? void 0 : r.peer.metadata;
  return e.core = null, e.sessionStore = null, s;
} }, R2 = class extends tL {
  constructor(t) {
    super(t), this.events = new kd.exports(), this.on = (e, r) => this.engine.on(e, r), this.once = (e, r) => this.engine.once(e, r), this.off = (e, r) => this.engine.off(e, r), this.removeListener = (e, r) => this.engine.removeListener(e, r), this.pair = async (e) => {
      try {
        return await this.engine.pair(e);
      } catch (r) {
        throw this.logger.error(r.message), r;
      }
    }, this.approveSession = async (e) => {
      try {
        return await this.engine.approveSession(e);
      } catch (r) {
        throw this.logger.error(r.message), r;
      }
    }, this.rejectSession = async (e) => {
      try {
        return await this.engine.rejectSession(e);
      } catch (r) {
        throw this.logger.error(r.message), r;
      }
    }, this.updateSession = async (e) => {
      try {
        return await this.engine.updateSession(e);
      } catch (r) {
        throw this.logger.error(r.message), r;
      }
    }, this.extendSession = async (e) => {
      try {
        return await this.engine.extendSession(e);
      } catch (r) {
        throw this.logger.error(r.message), r;
      }
    }, this.respondSessionRequest = async (e) => {
      try {
        return await this.engine.respondSessionRequest(e);
      } catch (r) {
        throw this.logger.error(r.message), r;
      }
    }, this.disconnectSession = async (e) => {
      try {
        return await this.engine.disconnectSession(e);
      } catch (r) {
        throw this.logger.error(r.message), r;
      }
    }, this.emitSessionEvent = async (e) => {
      try {
        return await this.engine.emitSessionEvent(e);
      } catch (r) {
        throw this.logger.error(r.message), r;
      }
    }, this.getActiveSessions = () => {
      try {
        return this.engine.getActiveSessions();
      } catch (e) {
        throw this.logger.error(e.message), e;
      }
    }, this.getPendingSessionProposals = () => {
      try {
        return this.engine.getPendingSessionProposals();
      } catch (e) {
        throw this.logger.error(e.message), e;
      }
    }, this.getPendingSessionRequests = () => {
      try {
        return this.engine.getPendingSessionRequests();
      } catch (e) {
        throw this.logger.error(e.message), e;
      }
    }, this.registerDeviceToken = (e) => {
      try {
        return this.engine.registerDeviceToken(e);
      } catch (r) {
        throw this.logger.error(r.message), r;
      }
    }, this.approveSessionAuthenticate = (e) => {
      try {
        return this.engine.approveSessionAuthenticate(e);
      } catch (r) {
        throw this.logger.error(r.message), r;
      }
    }, this.rejectSessionAuthenticate = (e) => {
      try {
        return this.engine.rejectSessionAuthenticate(e);
      } catch (r) {
        throw this.logger.error(r.message), r;
      }
    }, this.formatAuthMessage = (e) => {
      try {
        return this.engine.formatAuthMessage(e);
      } catch (r) {
        throw this.logger.error(r.message), r;
      }
    }, this.metadata = t.metadata, this.name = t.name || eL, this.signConfig = t.signConfig, this.core = t.core, this.logger = this.core.logger, this.engine = new uL(this);
  }
  static async init(t) {
    const e = new R2(t);
    return await e.initialize(), e;
  }
  async initialize() {
    this.logger.trace("Initialized");
    try {
      await this.engine.init(), this.logger.info("WalletKit Initialization Success");
    } catch (t) {
      throw this.logger.info("WalletKit Initialization Failure"), this.logger.error(t.message), t;
    }
  }
};
let N2 = R2;
N2.notifications = hL;
const dL = N2;
function Ia(t, { strict: e = !0 } = {}) {
  return !t || typeof t != "string" ? !1 : e ? /^0x[0-9a-fA-F]*$/.test(t) : t.startsWith("0x");
}
function di(t) {
  return Ia(t, { strict: !1 }) ? Math.ceil((t.length - 2) / 2) : t.length;
}
const L2 = "2.38.0";
let ro = {
  getDocsUrl: ({ docsBaseUrl: t, docsPath: e = "", docsSlug: r }) => e ? `${t ?? "https://viem.sh"}${e}${r ? `#${r}` : ""}` : void 0,
  version: `viem@${L2}`
};
class oe extends Error {
  constructor(e, r = {}) {
    var a;
    const s = (() => {
      var c;
      return r.cause instanceof oe ? r.cause.details : (c = r.cause) != null && c.message ? r.cause.message : r.details;
    })(), n = r.cause instanceof oe && r.cause.docsPath || r.docsPath, i = (a = ro.getDocsUrl) == null ? void 0 : a.call(ro, { ...r, docsPath: n }), o = [
      e || "An error occurred.",
      "",
      ...r.metaMessages ? [...r.metaMessages, ""] : [],
      ...i ? [`Docs: ${i}`] : [],
      ...s ? [`Details: ${s}`] : [],
      ...ro.version ? [`Version: ${ro.version}`] : []
    ].join(`
`);
    super(o, r.cause ? { cause: r.cause } : void 0), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseError"
    }), this.details = s, this.docsPath = n, this.metaMessages = r.metaMessages, this.name = r.name ?? this.name, this.shortMessage = e, this.version = L2;
  }
  walk(e) {
    return M2(this, e);
  }
}
function M2(t, e) {
  return e != null && e(t) ? t : t && typeof t == "object" && "cause" in t && t.cause !== void 0 ? M2(t.cause, e) : e ? null : t;
}
class sr extends oe {
  constructor({ address: e }) {
    super(`Address "${e}" is invalid.`, {
      metaMessages: [
        "- Address must be a hex value of 20 bytes (40 hex characters).",
        "- Address must match its checksum counterpart."
      ],
      name: "InvalidAddressError"
    });
  }
}
class pL extends oe {
  constructor({ offset: e, position: r, size: s }) {
    super(`Slice ${r === "start" ? "starting" : "ending"} at offset "${e}" is out-of-bounds (size: ${s}).`, { name: "SliceOffsetOutOfBoundsError" });
  }
}
class F2 extends oe {
  constructor({ size: e, targetSize: r, type: s }) {
    super(`${s.charAt(0).toUpperCase()}${s.slice(1).toLowerCase()} size (${e}) exceeds padding size (${r}).`, { name: "SizeExceedsPaddingSizeError" });
  }
}
function Rn(t, { dir: e, size: r = 32 } = {}) {
  return typeof t == "string" ? fL(t, { dir: e, size: r }) : mL(t, { dir: e, size: r });
}
function fL(t, { dir: e, size: r = 32 } = {}) {
  if (r === null)
    return t;
  const s = t.replace("0x", "");
  if (s.length > r * 2)
    throw new F2({
      size: Math.ceil(s.length / 2),
      targetSize: r,
      type: "hex"
    });
  return `0x${s[e === "right" ? "padEnd" : "padStart"](r * 2, "0")}`;
}
function mL(t, { dir: e, size: r = 32 } = {}) {
  if (r === null)
    return t;
  if (t.length > r)
    throw new F2({
      size: t.length,
      targetSize: r,
      type: "bytes"
    });
  const s = new Uint8Array(r);
  for (let n = 0; n < r; n++) {
    const i = e === "right";
    s[i ? n : r - n - 1] = t[i ? n : t.length - n - 1];
  }
  return s;
}
class bL extends oe {
  constructor({ max: e, min: r, signed: s, size: n, value: i }) {
    super(`Number "${i}" is not in safe ${n ? `${n * 8}-bit ${s ? "signed" : "unsigned"} ` : ""}integer range ${e ? `(${r} to ${e})` : `(above ${r})`}`, { name: "IntegerOutOfRangeError" });
  }
}
class yL extends oe {
  constructor({ givenSize: e, maxSize: r }) {
    super(`Size cannot exceed ${r} bytes. Given size: ${e} bytes.`, { name: "SizeOverflowError" });
  }
}
function pi(t, { dir: e = "left" } = {}) {
  let r = typeof t == "string" ? t.replace("0x", "") : t, s = 0;
  for (let n = 0; n < r.length - 1 && r[e === "left" ? n : r.length - n - 1].toString() === "0"; n++)
    s++;
  return r = e === "left" ? r.slice(s) : r.slice(0, r.length - s), typeof t == "string" ? (r.length === 1 && e === "right" && (r = `${r}0`), `0x${r.length % 2 === 1 ? `0${r}` : r}`) : r;
}
function _i(t, { size: e }) {
  if (di(t) > e)
    throw new yL({
      givenSize: di(t),
      maxSize: e
    });
}
function je(t, e = {}) {
  const { signed: r } = e;
  e.size && _i(t, { size: e.size });
  const s = BigInt(t);
  if (!r)
    return s;
  const n = (t.length - 2) / 2, i = (1n << BigInt(n) * 8n - 1n) - 1n;
  return s <= i ? s : s - BigInt(`0x${"f".padStart(n * 2, "f")}`) - 1n;
}
function na(t, e = {}) {
  return Number(je(t, e));
}
const gL = /* @__PURE__ */ Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function Te(t, e = {}) {
  return typeof t == "number" || typeof t == "bigint" ? ie(t, e) : typeof t == "string" ? xL(t, e) : typeof t == "boolean" ? wL(t, e) : Ss(t, e);
}
function wL(t, e = {}) {
  const r = `0x${Number(t)}`;
  return typeof e.size == "number" ? (_i(r, { size: e.size }), Rn(r, { size: e.size })) : r;
}
function Ss(t, e = {}) {
  let r = "";
  for (let n = 0; n < t.length; n++)
    r += gL[t[n]];
  const s = `0x${r}`;
  return typeof e.size == "number" ? (_i(s, { size: e.size }), Rn(s, { dir: "right", size: e.size })) : s;
}
function ie(t, e = {}) {
  const { signed: r, size: s } = e, n = BigInt(t);
  let i;
  s ? r ? i = (1n << BigInt(s) * 8n - 1n) - 1n : i = 2n ** (BigInt(s) * 8n) - 1n : typeof t == "number" && (i = BigInt(Number.MAX_SAFE_INTEGER));
  const o = typeof i == "bigint" && r ? -i - 1n : 0;
  if (i && n > i || n < o) {
    const c = typeof t == "bigint" ? "n" : "";
    throw new bL({
      max: i ? `${i}${c}` : void 0,
      min: `${o}${c}`,
      signed: r,
      size: s,
      value: `${t}${c}`
    });
  }
  const a = `0x${(r && n < 0 ? (1n << BigInt(s * 8)) + BigInt(n) : n).toString(16)}`;
  return s ? Rn(a, { size: s }) : a;
}
const EL = /* @__PURE__ */ new TextEncoder();
function xL(t, e = {}) {
  const r = EL.encode(t);
  return Ss(r, e);
}
const vL = /* @__PURE__ */ new TextEncoder();
function qo(t, e = {}) {
  return typeof t == "number" || typeof t == "bigint" ? CL(t, e) : typeof t == "boolean" ? kL(t, e) : Ia(t) ? Yr(t, e) : z2(t, e);
}
function kL(t, e = {}) {
  const r = new Uint8Array(1);
  return r[0] = Number(t), typeof e.size == "number" ? (_i(r, { size: e.size }), Rn(r, { size: e.size })) : r;
}
const ls = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function B1(t) {
  if (t >= ls.zero && t <= ls.nine)
    return t - ls.zero;
  if (t >= ls.A && t <= ls.F)
    return t - (ls.A - 10);
  if (t >= ls.a && t <= ls.f)
    return t - (ls.a - 10);
}
function Yr(t, e = {}) {
  let r = t;
  e.size && (_i(r, { size: e.size }), r = Rn(r, { dir: "right", size: e.size }));
  let s = r.slice(2);
  s.length % 2 && (s = `0${s}`);
  const n = s.length / 2, i = new Uint8Array(n);
  for (let o = 0, a = 0; o < n; o++) {
    const c = B1(s.charCodeAt(a++)), l = B1(s.charCodeAt(a++));
    if (c === void 0 || l === void 0)
      throw new oe(`Invalid byte sequence ("${s[a - 2]}${s[a - 1]}" in "${s}").`);
    i[o] = c * 16 + l;
  }
  return i;
}
function CL(t, e) {
  const r = ie(t, e);
  return Yr(r);
}
function z2(t, e = {}) {
  const r = vL.encode(t);
  return typeof e.size == "number" ? (_i(r, { size: e.size }), Rn(r, { dir: "right", size: e.size })) : r;
}
function SL(t, e) {
  return Cy(Ia(t, { strict: !1 }) ? qo(t) : t);
}
class j2 extends Map {
  constructor(e) {
    super(), Object.defineProperty(this, "maxSize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxSize = e;
  }
  get(e) {
    const r = super.get(e);
    return super.has(e) && r !== void 0 && (this.delete(e), super.set(e, r)), r;
  }
  set(e, r) {
    if (super.set(e, r), this.maxSize && this.size > this.maxSize) {
      const s = this.keys().next().value;
      s && this.delete(s);
    }
    return this;
  }
}
const IL = /^0x[a-fA-F0-9]{40}$/, Vu = /* @__PURE__ */ new j2(8192);
function Gt(t, e) {
  const { strict: r = !0 } = e ?? {}, s = `${t}.${r}`;
  if (Vu.has(s))
    return Vu.get(s);
  const n = IL.test(t) ? t.toLowerCase() === t ? !0 : r ? AL(t) === t : !0 : !1;
  return Vu.set(s, n), n;
}
const Gu = /* @__PURE__ */ new j2(8192);
function AL(t, e) {
  if (Gu.has(`${t}.${e}`))
    return Gu.get(`${t}.${e}`);
  const r = t.substring(2).toLowerCase(), s = SL(z2(r)), n = r.split("");
  for (let o = 0; o < 40; o += 2)
    s[o >> 1] >> 4 >= 8 && n[o] && (n[o] = n[o].toUpperCase()), (s[o >> 1] & 15) >= 8 && n[o + 1] && (n[o + 1] = n[o + 1].toUpperCase());
  const i = `0x${n.join("")}`;
  return Gu.set(`${t}.${e}`, i), i;
}
class D1 extends oe {
  constructor({ offset: e }) {
    super(`Offset \`${e}\` cannot be negative.`, {
      name: "NegativeOffsetError"
    });
  }
}
class _L extends oe {
  constructor({ length: e, position: r }) {
    super(`Position \`${r}\` is out of bounds (\`0 < position < ${e}\`).`, { name: "PositionOutOfBoundsError" });
  }
}
class TL extends oe {
  constructor({ count: e, limit: r }) {
    super(`Recursive read limit of \`${r}\` exceeded (recursive read count: \`${e}\`).`, { name: "RecursiveReadLimitExceededError" });
  }
}
const UL = {
  bytes: new Uint8Array(),
  dataView: new DataView(new ArrayBuffer(0)),
  position: 0,
  positionReadCount: /* @__PURE__ */ new Map(),
  recursiveReadCount: 0,
  recursiveReadLimit: Number.POSITIVE_INFINITY,
  assertReadLimit() {
    if (this.recursiveReadCount >= this.recursiveReadLimit)
      throw new TL({
        count: this.recursiveReadCount + 1,
        limit: this.recursiveReadLimit
      });
  },
  assertPosition(t) {
    if (t < 0 || t > this.bytes.length - 1)
      throw new _L({
        length: this.bytes.length,
        position: t
      });
  },
  decrementPosition(t) {
    if (t < 0)
      throw new D1({ offset: t });
    const e = this.position - t;
    this.assertPosition(e), this.position = e;
  },
  getReadCount(t) {
    return this.positionReadCount.get(t || this.position) || 0;
  },
  incrementPosition(t) {
    if (t < 0)
      throw new D1({ offset: t });
    const e = this.position + t;
    this.assertPosition(e), this.position = e;
  },
  inspectByte(t) {
    const e = t ?? this.position;
    return this.assertPosition(e), this.bytes[e];
  },
  inspectBytes(t, e) {
    const r = e ?? this.position;
    return this.assertPosition(r + t - 1), this.bytes.subarray(r, r + t);
  },
  inspectUint8(t) {
    const e = t ?? this.position;
    return this.assertPosition(e), this.bytes[e];
  },
  inspectUint16(t) {
    const e = t ?? this.position;
    return this.assertPosition(e + 1), this.dataView.getUint16(e);
  },
  inspectUint24(t) {
    const e = t ?? this.position;
    return this.assertPosition(e + 2), (this.dataView.getUint16(e) << 8) + this.dataView.getUint8(e + 2);
  },
  inspectUint32(t) {
    const e = t ?? this.position;
    return this.assertPosition(e + 3), this.dataView.getUint32(e);
  },
  pushByte(t) {
    this.assertPosition(this.position), this.bytes[this.position] = t, this.position++;
  },
  pushBytes(t) {
    this.assertPosition(this.position + t.length - 1), this.bytes.set(t, this.position), this.position += t.length;
  },
  pushUint8(t) {
    this.assertPosition(this.position), this.bytes[this.position] = t, this.position++;
  },
  pushUint16(t) {
    this.assertPosition(this.position + 1), this.dataView.setUint16(this.position, t), this.position += 2;
  },
  pushUint24(t) {
    this.assertPosition(this.position + 2), this.dataView.setUint16(this.position, t >> 8), this.dataView.setUint8(this.position + 2, t & 255), this.position += 3;
  },
  pushUint32(t) {
    this.assertPosition(this.position + 3), this.dataView.setUint32(this.position, t), this.position += 4;
  },
  readByte() {
    this.assertReadLimit(), this._touch();
    const t = this.inspectByte();
    return this.position++, t;
  },
  readBytes(t, e) {
    this.assertReadLimit(), this._touch();
    const r = this.inspectBytes(t);
    return this.position += e ?? t, r;
  },
  readUint8() {
    this.assertReadLimit(), this._touch();
    const t = this.inspectUint8();
    return this.position += 1, t;
  },
  readUint16() {
    this.assertReadLimit(), this._touch();
    const t = this.inspectUint16();
    return this.position += 2, t;
  },
  readUint24() {
    this.assertReadLimit(), this._touch();
    const t = this.inspectUint24();
    return this.position += 3, t;
  },
  readUint32() {
    this.assertReadLimit(), this._touch();
    const t = this.inspectUint32();
    return this.position += 4, t;
  },
  get remaining() {
    return this.bytes.length - this.position;
  },
  setPosition(t) {
    const e = this.position;
    return this.assertPosition(t), this.position = t, () => this.position = e;
  },
  _touch() {
    if (this.recursiveReadLimit === Number.POSITIVE_INFINITY)
      return;
    const t = this.getReadCount();
    this.positionReadCount.set(this.position, t + 1), t > 0 && this.recursiveReadCount++;
  }
};
function H2(t, { recursiveReadLimit: e = 8192 } = {}) {
  const r = Object.create(UL);
  return r.bytes = t, r.dataView = new DataView(t.buffer, t.byteOffset, t.byteLength), r.positionReadCount = /* @__PURE__ */ new Map(), r.recursiveReadLimit = e, r;
}
function $L(t, e, r, { strict: s } = {}) {
  return Ia(t, { strict: !1 }) ? DL(t, e, r, {
    strict: s
  }) : BL(t, e, r, {
    strict: s
  });
}
function q2(t, e, r) {
  if (di(t) !== r - e)
    throw new pL({
      offset: r,
      position: "end",
      size: di(t)
    });
}
function BL(t, e, r, { strict: s } = {}) {
  const n = t.slice(e, r);
  return s && q2(n, e, r), n;
}
function DL(t, e, r, { strict: s } = {}) {
  const n = `0x${t.replace("0x", "").slice(e * 2, r * 2)}`;
  return s && q2(n, e, r), n;
}
function Nn(t) {
  return `0x${t.reduce((e, r) => e + r.replace("0x", ""), "")}`;
}
class Ti extends oe {
  constructor({ chainId: e }) {
    super(typeof e == "number" ? `Chain ID "${e}" is invalid.` : "Chain ID is invalid.", { name: "InvalidChainIdError" });
  }
}
function Pp(t) {
  return typeof t == "string" ? { address: t, type: "json-rpc" } : t;
}
const OL = {
  gwei: 9,
  wei: 18
}, PL = {
  ether: -9,
  wei: 9
};
function K2(t, e) {
  let r = t.toString();
  const s = r.startsWith("-");
  s && (r = r.slice(1)), r = r.padStart(e, "0");
  let [n, i] = [
    r.slice(0, r.length - e),
    r.slice(r.length - e)
  ];
  return i = i.replace(/(0+)$/, ""), `${s ? "-" : ""}${n || "0"}${i ? `.${i}` : ""}`;
}
function RL(t, e = "wei") {
  return K2(t, OL[e]);
}
function _n(t, e = "wei") {
  return K2(t, PL[e]);
}
function O1(t) {
  return t.reduce((e, { slot: r, value: s }) => `${e}        ${r}: ${s}
`, "");
}
function NL(t) {
  return t.reduce((e, { address: r, ...s }) => {
    let n = `${e}    ${r}:
`;
    return s.nonce && (n += `      nonce: ${s.nonce}
`), s.balance && (n += `      balance: ${s.balance}
`), s.code && (n += `      code: ${s.code}
`), s.state && (n += `      state:
`, n += O1(s.state)), s.stateDiff && (n += `      stateDiff:
`, n += O1(s.stateDiff)), n;
  }, `  State Override:
`).slice(0, -1);
}
function V2(t) {
  const e = Object.entries(t).map(([s, n]) => n === void 0 || n === !1 ? null : [s, n]).filter(Boolean), r = e.reduce((s, [n]) => Math.max(s, n.length), 0);
  return e.map(([s, n]) => `  ${`${s}:`.padEnd(r + 1)}  ${n}`).join(`
`);
}
class LL extends oe {
  constructor() {
    super([
      "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
      "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
    ].join(`
`), { name: "FeeConflictError" });
  }
}
class ML extends oe {
  constructor({ v: e }) {
    super(`Invalid \`v\` value "${e}". Expected 27 or 28.`, {
      name: "InvalidLegacyVError"
    });
  }
}
class FL extends oe {
  constructor({ transaction: e }) {
    super("Cannot infer a transaction type from provided transaction.", {
      metaMessages: [
        "Provided Transaction:",
        "{",
        V2(e),
        "}",
        "",
        "To infer the type, either provide:",
        "- a `type` to the Transaction, or",
        "- an EIP-1559 Transaction with `maxFeePerGas`, or",
        "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
        "- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or",
        "- an EIP-7702 Transaction with `authorizationList`, or",
        "- a Legacy Transaction with `gasPrice`"
      ],
      name: "InvalidSerializableTransactionError"
    });
  }
}
class zL extends oe {
  constructor({ storageKey: e }) {
    super(`Size for storage key "${e}" is invalid. Expected 32 bytes. Got ${Math.floor((e.length - 2) / 2)} bytes.`, { name: "InvalidStorageKeySizeError" });
  }
}
class jL extends oe {
  constructor(e, { account: r, docsPath: s, chain: n, data: i, gas: o, gasPrice: a, maxFeePerGas: c, maxPriorityFeePerGas: l, nonce: u, to: h, value: p, stateOverride: y }) {
    var x;
    const b = r ? Pp(r) : void 0;
    let g = V2({
      from: b == null ? void 0 : b.address,
      to: h,
      value: typeof p < "u" && `${RL(p)} ${((x = n == null ? void 0 : n.nativeCurrency) == null ? void 0 : x.symbol) || "ETH"}`,
      data: i,
      gas: o,
      gasPrice: typeof a < "u" && `${_n(a)} gwei`,
      maxFeePerGas: typeof c < "u" && `${_n(c)} gwei`,
      maxPriorityFeePerGas: typeof l < "u" && `${_n(l)} gwei`,
      nonce: u
    });
    y && (g += `
${NL(y)}`), super(e.shortMessage, {
      cause: e,
      docsPath: s,
      metaMessages: [
        ...e.metaMessages ? [...e.metaMessages, " "] : [],
        "Raw Call Arguments:",
        g
      ].filter(Boolean),
      name: "CallExecutionError"
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.cause = e;
  }
}
class ti extends oe {
  constructor({ cause: e, message: r } = {}) {
    var n;
    const s = (n = r == null ? void 0 : r.replace("execution reverted: ", "")) == null ? void 0 : n.replace("execution reverted", "");
    super(`Execution reverted ${s ? `with reason: ${s}` : "for an unknown reason"}.`, {
      cause: e,
      name: "ExecutionRevertedError"
    });
  }
}
Object.defineProperty(ti, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 3
});
Object.defineProperty(ti, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /execution reverted/
});
class un extends oe {
  constructor({ cause: e, maxFeePerGas: r } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${r ? ` = ${_n(r)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
      cause: e,
      name: "FeeCapTooHighError"
    });
  }
}
Object.defineProperty(un, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class Cd extends oe {
  constructor({ cause: e, maxFeePerGas: r } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${r ? ` = ${_n(r)}` : ""} gwei) cannot be lower than the block base fee.`, {
      cause: e,
      name: "FeeCapTooLowError"
    });
  }
}
Object.defineProperty(Cd, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class Sd extends oe {
  constructor({ cause: e, nonce: r } = {}) {
    super(`Nonce provided for the transaction ${r ? `(${r}) ` : ""}is higher than the next one expected.`, { cause: e, name: "NonceTooHighError" });
  }
}
Object.defineProperty(Sd, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too high/
});
class Id extends oe {
  constructor({ cause: e, nonce: r } = {}) {
    super([
      `Nonce provided for the transaction ${r ? `(${r}) ` : ""}is lower than the current nonce of the account.`,
      "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
    ].join(`
`), { cause: e, name: "NonceTooLowError" });
  }
}
Object.defineProperty(Id, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too low|transaction already imported|already known/
});
class Ad extends oe {
  constructor({ cause: e, nonce: r } = {}) {
    super(`Nonce provided for the transaction ${r ? `(${r}) ` : ""}exceeds the maximum allowed nonce.`, { cause: e, name: "NonceMaxValueError" });
  }
}
Object.defineProperty(Ad, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce has max value/
});
class _d extends oe {
  constructor({ cause: e } = {}) {
    super([
      "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
    ].join(`
`), {
      cause: e,
      metaMessages: [
        "This error could arise when the account does not have enough funds to:",
        " - pay for the total gas fee,",
        " - pay for the value to send.",
        " ",
        "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
        " - `gas` is the amount of gas needed for transaction to execute,",
        " - `gas fee` is the gas fee,",
        " - `value` is the amount of ether to send to the recipient."
      ],
      name: "InsufficientFundsError"
    });
  }
}
Object.defineProperty(_d, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /insufficient funds|exceeds transaction sender account balance/
});
class Td extends oe {
  constructor({ cause: e, gas: r } = {}) {
    super(`The amount of gas ${r ? `(${r}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
      cause: e,
      name: "IntrinsicGasTooHighError"
    });
  }
}
Object.defineProperty(Td, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too high|gas limit reached/
});
class Ud extends oe {
  constructor({ cause: e, gas: r } = {}) {
    super(`The amount of gas ${r ? `(${r}) ` : ""}provided for the transaction is too low.`, {
      cause: e,
      name: "IntrinsicGasTooLowError"
    });
  }
}
Object.defineProperty(Ud, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too low/
});
class $d extends oe {
  constructor({ cause: e }) {
    super("The transaction type is not supported for this chain.", {
      cause: e,
      name: "TransactionTypeNotSupportedError"
    });
  }
}
Object.defineProperty($d, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /transaction type not valid/
});
class fi extends oe {
  constructor({ cause: e, maxPriorityFeePerGas: r, maxFeePerGas: s } = {}) {
    super([
      `The provided tip (\`maxPriorityFeePerGas\`${r ? ` = ${_n(r)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${s ? ` = ${_n(s)} gwei` : ""}).`
    ].join(`
`), {
      cause: e,
      name: "TipAboveFeeCapError"
    });
  }
}
Object.defineProperty(fi, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class G2 extends oe {
  constructor({ cause: e }) {
    super(`An error occurred while executing: ${e == null ? void 0 : e.shortMessage}`, {
      cause: e,
      name: "UnknownNodeError"
    });
  }
}
function HL(t, e) {
  const r = (t.details || "").toLowerCase(), s = t instanceof oe ? t.walk((n) => (n == null ? void 0 : n.code) === ti.code) : t;
  return s instanceof oe ? new ti({
    cause: t,
    message: s.details
  }) : ti.nodeMessage.test(r) ? new ti({
    cause: t,
    message: t.details
  }) : un.nodeMessage.test(r) ? new un({
    cause: t,
    maxFeePerGas: e == null ? void 0 : e.maxFeePerGas
  }) : Cd.nodeMessage.test(r) ? new Cd({
    cause: t,
    maxFeePerGas: e == null ? void 0 : e.maxFeePerGas
  }) : Sd.nodeMessage.test(r) ? new Sd({ cause: t, nonce: e == null ? void 0 : e.nonce }) : Id.nodeMessage.test(r) ? new Id({ cause: t, nonce: e == null ? void 0 : e.nonce }) : Ad.nodeMessage.test(r) ? new Ad({ cause: t, nonce: e == null ? void 0 : e.nonce }) : _d.nodeMessage.test(r) ? new _d({ cause: t }) : Td.nodeMessage.test(r) ? new Td({ cause: t, gas: e == null ? void 0 : e.gas }) : Ud.nodeMessage.test(r) ? new Ud({ cause: t, gas: e == null ? void 0 : e.gas }) : $d.nodeMessage.test(r) ? new $d({ cause: t }) : fi.nodeMessage.test(r) ? new fi({
    cause: t,
    maxFeePerGas: e == null ? void 0 : e.maxFeePerGas,
    maxPriorityFeePerGas: e == null ? void 0 : e.maxPriorityFeePerGas
  }) : new G2({
    cause: t
  });
}
function qL(t, { docsPath: e, ...r }) {
  const s = (() => {
    const n = HL(t, r);
    return n instanceof G2 ? t : n;
  })();
  return new jL(s, {
    docsPath: e,
    ...r
  });
}
function KL(t, { format: e }) {
  if (!e)
    return {};
  const r = {};
  function s(i) {
    const o = Object.keys(i);
    for (const a of o)
      a in t && (r[a] = t[a]), i[a] && typeof i[a] == "object" && !Array.isArray(i[a]) && s(i[a]);
  }
  const n = e(t || {});
  return s(n), r;
}
function Hl(t, e) {
  return ({ exclude: r, format: s }) => ({
    exclude: r,
    format: (n, i) => {
      const o = e(n, i);
      if (r)
        for (const a of r)
          delete o[a];
      return {
        ...o,
        ...s(n, i)
      };
    },
    type: t
  });
}
const VL = {
  legacy: "0x0",
  eip2930: "0x1",
  eip1559: "0x2",
  eip4844: "0x3",
  eip7702: "0x4"
};
function W2(t, e) {
  const r = {};
  return typeof t.authorizationList < "u" && (r.authorizationList = GL(t.authorizationList)), typeof t.accessList < "u" && (r.accessList = t.accessList), typeof t.blobVersionedHashes < "u" && (r.blobVersionedHashes = t.blobVersionedHashes), typeof t.blobs < "u" && (typeof t.blobs[0] != "string" ? r.blobs = t.blobs.map((s) => Ss(s)) : r.blobs = t.blobs), typeof t.data < "u" && (r.data = t.data), typeof t.from < "u" && (r.from = t.from), typeof t.gas < "u" && (r.gas = ie(t.gas)), typeof t.gasPrice < "u" && (r.gasPrice = ie(t.gasPrice)), typeof t.maxFeePerBlobGas < "u" && (r.maxFeePerBlobGas = ie(t.maxFeePerBlobGas)), typeof t.maxFeePerGas < "u" && (r.maxFeePerGas = ie(t.maxFeePerGas)), typeof t.maxPriorityFeePerGas < "u" && (r.maxPriorityFeePerGas = ie(t.maxPriorityFeePerGas)), typeof t.nonce < "u" && (r.nonce = ie(t.nonce)), typeof t.to < "u" && (r.to = t.to), typeof t.type < "u" && (r.type = VL[t.type]), typeof t.value < "u" && (r.value = ie(t.value)), r;
}
const Z2 = /* @__PURE__ */ Hl("transactionRequest", W2);
function GL(t) {
  return t.map((e) => ({
    address: e.address,
    r: e.r ? ie(BigInt(e.r)) : e.r,
    s: e.s ? ie(BigInt(e.s)) : e.s,
    chainId: ie(e.chainId),
    nonce: ie(e.nonce),
    ...typeof e.yParity < "u" ? { yParity: ie(e.yParity) } : {},
    ...typeof e.v < "u" && typeof e.yParity > "u" ? { v: ie(e.v) } : {}
  }));
}
const WL = 2n ** 16n - 1n, Aa = 2n ** 256n - 1n;
function ZL(t) {
  const { account: e, gasPrice: r, maxFeePerGas: s, maxPriorityFeePerGas: n, to: i } = t, o = e ? Pp(e) : void 0;
  if (o && !Gt(o.address))
    throw new sr({ address: o.address });
  if (i && !Gt(i))
    throw new sr({ address: i });
  if (typeof r < "u" && (typeof s < "u" || typeof n < "u"))
    throw new LL();
  if (s && s > Aa)
    throw new un({ maxFeePerGas: s });
  if (n && s && n > s)
    throw new fi({ maxFeePerGas: s, maxPriorityFeePerGas: n });
}
function Cs(t, e = "hex") {
  const r = J2(t), s = H2(new Uint8Array(r.length));
  return r.encode(s), e === "hex" ? Ss(s.bytes) : s.bytes;
}
function J2(t) {
  return Array.isArray(t) ? JL(t.map((e) => J2(e))) : XL(t);
}
function JL(t) {
  const e = t.reduce((n, i) => n + i.length, 0), r = X2(e);
  return {
    length: e <= 55 ? 1 + e : 1 + r + e,
    encode(n) {
      e <= 55 ? n.pushByte(192 + e) : (n.pushByte(247 + r), r === 1 ? n.pushUint8(e) : r === 2 ? n.pushUint16(e) : r === 3 ? n.pushUint24(e) : n.pushUint32(e));
      for (const { encode: i } of t)
        i(n);
    }
  };
}
function XL(t) {
  const e = typeof t == "string" ? Yr(t) : t, r = X2(e.length);
  return {
    length: e.length === 1 && e[0] < 128 ? 1 : e.length <= 55 ? 1 + e.length : 1 + r + e.length,
    encode(n) {
      e.length === 1 && e[0] < 128 ? n.pushBytes(e) : e.length <= 55 ? (n.pushByte(128 + e.length), n.pushBytes(e)) : (n.pushByte(183 + r), r === 1 ? n.pushUint8(e.length) : r === 2 ? n.pushUint16(e.length) : r === 3 ? n.pushUint24(e.length) : n.pushUint32(e.length), n.pushBytes(e));
    }
  };
}
function X2(t) {
  if (t < 2 ** 8)
    return 1;
  if (t < 2 ** 16)
    return 2;
  if (t < 2 ** 24)
    return 3;
  if (t < 2 ** 32)
    return 4;
  throw new oe("Length is too large.");
}
const Y2 = {
  "0x0": "legacy",
  "0x1": "eip2930",
  "0x2": "eip1559",
  "0x3": "eip4844",
  "0x4": "eip7702"
};
function ql(t, e) {
  const r = {
    ...t,
    blockHash: t.blockHash ? t.blockHash : null,
    blockNumber: t.blockNumber ? BigInt(t.blockNumber) : null,
    chainId: t.chainId ? na(t.chainId) : void 0,
    gas: t.gas ? BigInt(t.gas) : void 0,
    gasPrice: t.gasPrice ? BigInt(t.gasPrice) : void 0,
    maxFeePerBlobGas: t.maxFeePerBlobGas ? BigInt(t.maxFeePerBlobGas) : void 0,
    maxFeePerGas: t.maxFeePerGas ? BigInt(t.maxFeePerGas) : void 0,
    maxPriorityFeePerGas: t.maxPriorityFeePerGas ? BigInt(t.maxPriorityFeePerGas) : void 0,
    nonce: t.nonce ? na(t.nonce) : void 0,
    to: t.to ? t.to : null,
    transactionIndex: t.transactionIndex ? Number(t.transactionIndex) : null,
    type: t.type ? Y2[t.type] : void 0,
    typeHex: t.type ? t.type : void 0,
    value: t.value ? BigInt(t.value) : void 0,
    v: t.v ? BigInt(t.v) : void 0
  };
  return t.authorizationList && (r.authorizationList = YL(t.authorizationList)), r.yParity = (() => {
    if (t.yParity)
      return Number(t.yParity);
    if (typeof r.v == "bigint") {
      if (r.v === 0n || r.v === 27n)
        return 0;
      if (r.v === 1n || r.v === 28n)
        return 1;
      if (r.v >= 35n)
        return r.v % 2n === 0n ? 1 : 0;
    }
  })(), r.type === "legacy" && (delete r.accessList, delete r.maxFeePerBlobGas, delete r.maxFeePerGas, delete r.maxPriorityFeePerGas, delete r.yParity), r.type === "eip2930" && (delete r.maxFeePerBlobGas, delete r.maxFeePerGas, delete r.maxPriorityFeePerGas), r.type === "eip1559" && delete r.maxFeePerBlobGas, r;
}
const Rp = /* @__PURE__ */ Hl("transaction", ql);
function YL(t) {
  return t.map((e) => ({
    address: e.address,
    chainId: Number(e.chainId),
    nonce: Number(e.nonce),
    r: e.r,
    s: e.s,
    yParity: Number(e.yParity)
  }));
}
function QL(t, e) {
  const r = (t.transactions ?? []).map((s) => typeof s == "string" ? s : ql(s));
  return {
    ...t,
    baseFeePerGas: t.baseFeePerGas ? BigInt(t.baseFeePerGas) : null,
    blobGasUsed: t.blobGasUsed ? BigInt(t.blobGasUsed) : void 0,
    difficulty: t.difficulty ? BigInt(t.difficulty) : void 0,
    excessBlobGas: t.excessBlobGas ? BigInt(t.excessBlobGas) : void 0,
    gasLimit: t.gasLimit ? BigInt(t.gasLimit) : void 0,
    gasUsed: t.gasUsed ? BigInt(t.gasUsed) : void 0,
    hash: t.hash ? t.hash : null,
    logsBloom: t.logsBloom ? t.logsBloom : null,
    nonce: t.nonce ? t.nonce : null,
    number: t.number ? BigInt(t.number) : null,
    size: t.size ? BigInt(t.size) : void 0,
    timestamp: t.timestamp ? BigInt(t.timestamp) : void 0,
    transactions: r,
    totalDifficulty: t.totalDifficulty ? BigInt(t.totalDifficulty) : null
  };
}
const Np = /* @__PURE__ */ Hl("block", QL);
function Q2(t) {
  const { kzg: e } = t, r = t.to ?? (typeof t.blobs[0] == "string" ? "hex" : "bytes"), s = typeof t.blobs[0] == "string" ? t.blobs.map((i) => Yr(i)) : t.blobs, n = [];
  for (const i of s)
    n.push(Uint8Array.from(e.blobToKzgCommitment(i)));
  return r === "bytes" ? n : n.map((i) => Ss(i));
}
function eE(t) {
  const { kzg: e } = t, r = t.to ?? (typeof t.blobs[0] == "string" ? "hex" : "bytes"), s = typeof t.blobs[0] == "string" ? t.blobs.map((o) => Yr(o)) : t.blobs, n = typeof t.commitments[0] == "string" ? t.commitments.map((o) => Yr(o)) : t.commitments, i = [];
  for (let o = 0; o < s.length; o++) {
    const a = s[o], c = n[o];
    i.push(Uint8Array.from(e.computeBlobKzgProof(a, c)));
  }
  return r === "bytes" ? i : i.map((o) => Ss(o));
}
function tE(t, e) {
  const r = e || "hex", s = nk(Ia(t, { strict: !1 }) ? qo(t) : t);
  return r === "bytes" ? s : Te(s);
}
function eM(t) {
  const { commitment: e, version: r = 1 } = t, s = t.to ?? (typeof e == "string" ? "hex" : "bytes"), n = tE(e, "bytes");
  return n.set([r], 0), s === "bytes" ? n : Ss(n);
}
function tM(t) {
  const { commitments: e, version: r } = t, s = t.to ?? (typeof e[0] == "string" ? "hex" : "bytes"), n = [];
  for (const i of e)
    n.push(eM({
      commitment: i,
      to: s,
      version: r
    }));
  return n;
}
const P1 = 6, rE = 32, Lp = 4096, sE = rE * Lp, R1 = sE * P1 - // terminator byte (0x80).
1 - // zero byte (0x00) appended to each field element.
1 * Lp * P1, nE = 1;
class rM extends oe {
  constructor({ maxSize: e, size: r }) {
    super("Blob size is too large.", {
      metaMessages: [`Max: ${e} bytes`, `Given: ${r} bytes`],
      name: "BlobSizeTooLargeError"
    });
  }
}
class iE extends oe {
  constructor() {
    super("Blob data must not be empty.", { name: "EmptyBlobError" });
  }
}
class sM extends oe {
  constructor({ hash: e, size: r }) {
    super(`Versioned hash "${e}" size is invalid.`, {
      metaMessages: ["Expected: 32", `Received: ${r}`],
      name: "InvalidVersionedHashSizeError"
    });
  }
}
class nM extends oe {
  constructor({ hash: e, version: r }) {
    super(`Versioned hash "${e}" version is invalid.`, {
      metaMessages: [
        `Expected: ${nE}`,
        `Received: ${r}`
      ],
      name: "InvalidVersionedHashVersionError"
    });
  }
}
function iM(t) {
  const e = t.to ?? (typeof t.data == "string" ? "hex" : "bytes"), r = typeof t.data == "string" ? Yr(t.data) : t.data, s = di(r);
  if (!s)
    throw new iE();
  if (s > R1)
    throw new rM({
      maxSize: R1,
      size: s
    });
  const n = [];
  let i = !0, o = 0;
  for (; i; ) {
    const a = H2(new Uint8Array(sE));
    let c = 0;
    for (; c < Lp; ) {
      const l = r.slice(o, o + (rE - 1));
      if (a.pushByte(0), a.pushBytes(l), l.length < 31) {
        a.pushByte(128), i = !1;
        break;
      }
      c++, o += 31;
    }
    n.push(a);
  }
  return e === "bytes" ? n.map((a) => a.bytes) : n.map((a) => Ss(a.bytes));
}
function oM(t) {
  const { data: e, kzg: r, to: s } = t, n = t.blobs ?? iM({ data: e, to: s }), i = t.commitments ?? Q2({ blobs: n, kzg: r, to: s }), o = t.proofs ?? eE({ blobs: n, commitments: i, kzg: r, to: s }), a = [];
  for (let c = 0; c < n.length; c++)
    a.push({
      blob: n[c],
      commitment: i[c],
      proof: o[c]
    });
  return a;
}
function aM(t) {
  if (t.type)
    return t.type;
  if (typeof t.authorizationList < "u")
    return "eip7702";
  if (typeof t.blobs < "u" || typeof t.blobVersionedHashes < "u" || typeof t.maxFeePerBlobGas < "u" || typeof t.sidecars < "u")
    return "eip4844";
  if (typeof t.maxFeePerGas < "u" || typeof t.maxPriorityFeePerGas < "u")
    return "eip1559";
  if (typeof t.gasPrice < "u")
    return typeof t.accessList < "u" ? "eip2930" : "legacy";
  throw new FL({ transaction: t });
}
function oE(t, { args: e, eventName: r } = {}) {
  return {
    ...t,
    blockHash: t.blockHash ? t.blockHash : null,
    blockNumber: t.blockNumber ? BigInt(t.blockNumber) : null,
    logIndex: t.logIndex ? Number(t.logIndex) : null,
    transactionHash: t.transactionHash ? t.transactionHash : null,
    transactionIndex: t.transactionIndex ? Number(t.transactionIndex) : null,
    ...r ? { args: e, eventName: r } : {}
  };
}
function cM(t) {
  const { authorizationList: e } = t;
  if (e)
    for (const r of e) {
      const { chainId: s } = r, n = r.address;
      if (!Gt(n))
        throw new sr({ address: n });
      if (s < 0)
        throw new Ti({ chainId: s });
    }
  Mp(t);
}
function lM(t) {
  const { blobVersionedHashes: e } = t;
  if (e) {
    if (e.length === 0)
      throw new iE();
    for (const r of e) {
      const s = di(r), n = na($L(r, 0, 1));
      if (s !== 32)
        throw new sM({ hash: r, size: s });
      if (n !== nE)
        throw new nM({
          hash: r,
          version: n
        });
    }
  }
  Mp(t);
}
function Mp(t) {
  const { chainId: e, maxPriorityFeePerGas: r, maxFeePerGas: s, to: n } = t;
  if (e <= 0)
    throw new Ti({ chainId: e });
  if (n && !Gt(n))
    throw new sr({ address: n });
  if (s && s > Aa)
    throw new un({ maxFeePerGas: s });
  if (r && s && r > s)
    throw new fi({ maxFeePerGas: s, maxPriorityFeePerGas: r });
}
function uM(t) {
  const { chainId: e, maxPriorityFeePerGas: r, gasPrice: s, maxFeePerGas: n, to: i } = t;
  if (e <= 0)
    throw new Ti({ chainId: e });
  if (i && !Gt(i))
    throw new sr({ address: i });
  if (r || n)
    throw new oe("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid EIP-2930 Transaction attribute.");
  if (s && s > Aa)
    throw new un({ maxFeePerGas: s });
}
function hM(t) {
  const { chainId: e, maxPriorityFeePerGas: r, gasPrice: s, maxFeePerGas: n, to: i } = t;
  if (i && !Gt(i))
    throw new sr({ address: i });
  if (typeof e < "u" && e <= 0)
    throw new Ti({ chainId: e });
  if (r || n)
    throw new oe("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid Legacy Transaction attribute.");
  if (s && s > Aa)
    throw new un({ maxFeePerGas: s });
}
function _a(t) {
  if (!t || t.length === 0)
    return [];
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const { address: s, storageKeys: n } = t[r];
    for (let i = 0; i < n.length; i++)
      if (n[i].length - 2 !== 64)
        throw new zL({ storageKey: n[i] });
    if (!Gt(s, { strict: !1 }))
      throw new sr({ address: s });
    e.push([s, n]);
  }
  return e;
}
function aE(t, e) {
  const r = aM(t);
  return r === "eip1559" ? fM(t, e) : r === "eip2930" ? mM(t, e) : r === "eip4844" ? pM(t, e) : r === "eip7702" ? dM(t, e) : bM(t, e);
}
function dM(t, e) {
  const { authorizationList: r, chainId: s, gas: n, nonce: i, to: o, value: a, maxFeePerGas: c, maxPriorityFeePerGas: l, accessList: u, data: h } = t;
  cM(t);
  const p = _a(u), y = yM(r);
  return Nn([
    "0x04",
    Cs([
      ie(s),
      i ? ie(i) : "0x",
      l ? ie(l) : "0x",
      c ? ie(c) : "0x",
      n ? ie(n) : "0x",
      o ?? "0x",
      a ? ie(a) : "0x",
      h ?? "0x",
      p,
      y,
      ...Ui(t, e)
    ])
  ]);
}
function pM(t, e) {
  const { chainId: r, gas: s, nonce: n, to: i, value: o, maxFeePerBlobGas: a, maxFeePerGas: c, maxPriorityFeePerGas: l, accessList: u, data: h } = t;
  lM(t);
  let p = t.blobVersionedHashes, y = t.sidecars;
  if (t.blobs && (typeof p > "u" || typeof y > "u")) {
    const A = typeof t.blobs[0] == "string" ? t.blobs : t.blobs.map((q) => Ss(q)), M = t.kzg, B = Q2({
      blobs: A,
      kzg: M
    });
    if (typeof p > "u" && (p = tM({
      commitments: B
    })), typeof y > "u") {
      const q = eE({ blobs: A, commitments: B, kzg: M });
      y = oM({ blobs: A, commitments: B, proofs: q });
    }
  }
  const b = _a(u), g = [
    ie(r),
    n ? ie(n) : "0x",
    l ? ie(l) : "0x",
    c ? ie(c) : "0x",
    s ? ie(s) : "0x",
    i ?? "0x",
    o ? ie(o) : "0x",
    h ?? "0x",
    b,
    a ? ie(a) : "0x",
    p ?? [],
    ...Ui(t, e)
  ], x = [], I = [], U = [];
  if (y)
    for (let A = 0; A < y.length; A++) {
      const { blob: M, commitment: B, proof: q } = y[A];
      x.push(M), I.push(B), U.push(q);
    }
  return Nn([
    "0x03",
    // If sidecars are enabled, envelope turns into a "wrapper":
    Cs(y ? [g, x, I, U] : g)
  ]);
}
function fM(t, e) {
  const { chainId: r, gas: s, nonce: n, to: i, value: o, maxFeePerGas: a, maxPriorityFeePerGas: c, accessList: l, data: u } = t;
  Mp(t);
  const h = _a(l), p = [
    ie(r),
    n ? ie(n) : "0x",
    c ? ie(c) : "0x",
    a ? ie(a) : "0x",
    s ? ie(s) : "0x",
    i ?? "0x",
    o ? ie(o) : "0x",
    u ?? "0x",
    h,
    ...Ui(t, e)
  ];
  return Nn([
    "0x02",
    Cs(p)
  ]);
}
function mM(t, e) {
  const { chainId: r, gas: s, data: n, nonce: i, to: o, value: a, accessList: c, gasPrice: l } = t;
  uM(t);
  const u = _a(c), h = [
    ie(r),
    i ? ie(i) : "0x",
    l ? ie(l) : "0x",
    s ? ie(s) : "0x",
    o ?? "0x",
    a ? ie(a) : "0x",
    n ?? "0x",
    u,
    ...Ui(t, e)
  ];
  return Nn([
    "0x01",
    Cs(h)
  ]);
}
function bM(t, e) {
  const { chainId: r = 0, gas: s, data: n, nonce: i, to: o, value: a, gasPrice: c } = t;
  hM(t);
  let l = [
    i ? ie(i) : "0x",
    c ? ie(c) : "0x",
    s ? ie(s) : "0x",
    o ?? "0x",
    a ? ie(a) : "0x",
    n ?? "0x"
  ];
  if (e) {
    const u = (() => {
      if (e.v >= 35n)
        return (e.v - 35n) / 2n > 0 ? e.v : 27n + (e.v === 35n ? 0n : 1n);
      if (r > 0)
        return BigInt(r * 2) + BigInt(35n + e.v - 27n);
      const y = 27n + (e.v === 27n ? 0n : 1n);
      if (e.v !== y)
        throw new ML({ v: e.v });
      return y;
    })(), h = pi(e.r), p = pi(e.s);
    l = [
      ...l,
      ie(u),
      h === "0x00" ? "0x" : h,
      p === "0x00" ? "0x" : p
    ];
  } else r > 0 && (l = [
    ...l,
    ie(r),
    "0x",
    "0x"
  ]);
  return Cs(l);
}
function Ui(t, e) {
  const r = e ?? t, { v: s, yParity: n } = r;
  if (typeof r.r > "u")
    return [];
  if (typeof r.s > "u")
    return [];
  if (typeof s > "u" && typeof n > "u")
    return [];
  const i = pi(r.r), o = pi(r.s);
  return [typeof n == "number" ? n ? ie(1) : "0x" : s === 0n ? "0x" : s === 1n ? ie(1) : s === 27n ? "0x" : ie(1), i === "0x00" ? "0x" : i, o === "0x00" ? "0x" : o];
}
function yM(t) {
  if (!t || t.length === 0)
    return [];
  const e = [];
  for (const r of t) {
    const { chainId: s, nonce: n, ...i } = r, o = r.address;
    e.push([
      s ? Te(s) : "0x",
      o,
      n ? Te(n) : "0x",
      ...Ui({}, i)
    ]);
  }
  return e;
}
function d(t) {
  return {
    formatters: void 0,
    fees: void 0,
    serializers: void 0,
    ...t
  };
}
const gM = {
  "0x0": "reverted",
  "0x1": "success"
};
function wM(t, e) {
  const r = {
    ...t,
    blockNumber: t.blockNumber ? BigInt(t.blockNumber) : null,
    contractAddress: t.contractAddress ? t.contractAddress : null,
    cumulativeGasUsed: t.cumulativeGasUsed ? BigInt(t.cumulativeGasUsed) : null,
    effectiveGasPrice: t.effectiveGasPrice ? BigInt(t.effectiveGasPrice) : null,
    gasUsed: t.gasUsed ? BigInt(t.gasUsed) : null,
    logs: t.logs ? t.logs.map((s) => oE(s)) : null,
    to: t.to ? t.to : null,
    transactionIndex: t.transactionIndex ? na(t.transactionIndex) : null,
    status: t.status ? gM[t.status] : null,
    type: t.type ? Y2[t.type] || t.type : null
  };
  return t.blobGasPrice && (r.blobGasPrice = BigInt(t.blobGasPrice)), t.blobGasUsed && (r.blobGasUsed = BigInt(t.blobGasUsed)), r;
}
const cE = /* @__PURE__ */ Hl("transactionReceipt", wM);
class EM extends oe {
  constructor({ docsPath: e } = {}) {
    super([
      "Could not find an Account to execute with this Action.",
      "Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the Client."
    ].join(`
`), {
      docsPath: e,
      docsSlug: "account",
      name: "AccountNotFoundError"
    });
  }
}
function xM(t) {
  const e = t.state.current, r = t.state.connections.get(e), s = r == null ? void 0 : r.accounts, n = s == null ? void 0 : s[0], i = t.chains.find((a) => a.id === (r == null ? void 0 : r.chainId)), o = t.state.status;
  switch (o) {
    case "connected":
      return {
        address: n,
        addresses: s,
        chain: i,
        chainId: r == null ? void 0 : r.chainId,
        connector: r == null ? void 0 : r.connector,
        isConnected: !0,
        isConnecting: !1,
        isDisconnected: !1,
        isReconnecting: !1,
        status: o
      };
    case "reconnecting":
      return {
        address: n,
        addresses: s,
        chain: i,
        chainId: r == null ? void 0 : r.chainId,
        connector: r == null ? void 0 : r.connector,
        isConnected: !!n,
        isConnecting: !1,
        isDisconnected: !1,
        isReconnecting: !0,
        status: o
      };
    case "connecting":
      return {
        address: n,
        addresses: s,
        chain: i,
        chainId: r == null ? void 0 : r.chainId,
        connector: r == null ? void 0 : r.connector,
        isConnected: !1,
        isConnecting: !0,
        isDisconnected: !1,
        isReconnecting: !1,
        status: o
      };
    case "disconnected":
      return {
        address: void 0,
        addresses: void 0,
        chain: void 0,
        chainId: void 0,
        connector: void 0,
        isConnected: !1,
        isConnecting: !1,
        isDisconnected: !0,
        isReconnecting: !1,
        status: o
      };
  }
}
let Wu = !1;
async function vM(t, e = {}) {
  var l, u;
  if (Wu)
    return [];
  Wu = !0, t.setState((h) => ({
    ...h,
    status: h.current ? "reconnecting" : "connecting"
  }));
  const r = [];
  if ((l = e.connectors) != null && l.length)
    for (const h of e.connectors) {
      let p;
      typeof h == "function" ? p = t._internal.connectors.setup(h) : p = h, r.push(p);
    }
  else
    r.push(...t.connectors);
  let s;
  try {
    s = await ((u = t.storage) == null ? void 0 : u.getItem("recentConnectorId"));
  } catch {
  }
  const n = {};
  for (const [, h] of t.state.connections)
    n[h.connector.id] = 1;
  s && (n[s] = 0);
  const i = Object.keys(n).length > 0 ? (
    // .toSorted()
    [...r].sort((h, p) => (n[h.id] ?? 10) - (n[p.id] ?? 10))
  ) : r;
  let o = !1;
  const a = [], c = [];
  for (const h of i) {
    const p = await h.getProvider().catch(() => {
    });
    if (!p || c.some((g) => g === p) || !await h.isAuthorized())
      continue;
    const b = await h.connect({ isReconnecting: !0 }).catch(() => null);
    b && (h.emitter.off("connect", t._internal.events.connect), h.emitter.on("change", t._internal.events.change), h.emitter.on("disconnect", t._internal.events.disconnect), t.setState((g) => {
      const x = new Map(o ? g.connections : /* @__PURE__ */ new Map()).set(h.uid, { accounts: b.accounts, chainId: b.chainId, connector: h });
      return {
        ...g,
        current: o ? g.current : h.uid,
        connections: x
      };
    }), a.push({
      accounts: b.accounts,
      chainId: b.chainId,
      connector: h
    }), c.push(p), o = !0);
  }
  return (t.state.status === "reconnecting" || t.state.status === "connecting") && (o ? t.setState((h) => ({ ...h, status: "connected" })) : t.setState((h) => ({
    ...h,
    connections: /* @__PURE__ */ new Map(),
    current: null,
    status: "disconnected"
  }))), Wu = !1, a;
}
const kM = /* @__PURE__ */ d({
  id: 16600,
  name: "0G Newton Testnet",
  nativeCurrency: { name: "A0GI", symbol: "A0GI", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://evmrpc-testnet.0g.ai"]
    }
  },
  blockExplorers: {
    default: {
      name: "0G BlockChain Explorer",
      url: "https://chainscan-newton.0g.ai"
    }
  },
  testnet: !0
}), CM = /* @__PURE__ */ d({
  id: 16601,
  name: "0G Galileo Testnet",
  nativeCurrency: { name: "A0GI", symbol: "A0GI", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://evmrpc-testnet.0g.ai"]
    }
  },
  blockExplorers: {
    default: {
      name: "0G BlockChain Explorer",
      url: "https://chainscan-galileo.0g.ai"
    }
  },
  testnet: !0
}), SM = /* @__PURE__ */ d({
  id: 16661,
  name: "0G Mainnet",
  nativeCurrency: { name: "0G", symbol: "0G", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://evmrpc.0g.ai"]
    }
  },
  blockExplorers: {
    default: {
      name: "0G BlockChain Explorer",
      url: "https://chainscan.0g.ai"
    }
  },
  testnet: !1
}), IM = /* @__PURE__ */ d({
  id: 995,
  name: "5ireChain",
  nativeCurrency: { name: "5ire Token", symbol: "5IRE", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.5ire.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "5ireChain Mainnet Explorer",
      url: "https://5irescan.io/"
    }
  },
  testnet: !1
}), AM = /* @__PURE__ */ d({
  id: 179,
  name: "ABEY Mainnet",
  nativeCurrency: { name: "ABEY", symbol: "ABEY", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.abeychain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Abey Scan",
      url: "https://abeyscan.com"
    }
  },
  testnet: !1
}), Fp = 50000n, N1 = WL * 32n, lE = {
  block: /* @__PURE__ */ Np({
    format(t) {
      var r;
      const e = (r = t.transactions) == null ? void 0 : r.map((s) => {
        var i;
        if (typeof s == "string")
          return s;
        const n = (i = lE.transaction) == null ? void 0 : i.format(s);
        return n.typeHex === "0x71" ? n.type = "eip712" : n.typeHex === "0xff" && (n.type = "priority"), n;
      });
      return {
        l1BatchNumber: t.l1BatchNumber ? je(t.l1BatchNumber) : null,
        l1BatchTimestamp: t.l1BatchTimestamp ? je(t.l1BatchTimestamp) : null,
        transactions: e
      };
    }
  }),
  transaction: /* @__PURE__ */ Rp({
    format(t) {
      const e = {};
      return t.type === "0x71" ? e.type = "eip712" : t.type === "0xff" && (e.type = "priority"), {
        ...e,
        l1BatchNumber: t.l1BatchNumber ? je(t.l1BatchNumber) : null,
        l1BatchTxIndex: t.l1BatchTxIndex ? je(t.l1BatchTxIndex) : null
      };
    }
  }),
  transactionReceipt: /* @__PURE__ */ cE({
    format(t) {
      return {
        l1BatchNumber: t.l1BatchNumber ? je(t.l1BatchNumber) : null,
        l1BatchTxIndex: t.l1BatchTxIndex ? je(t.l1BatchTxIndex) : null,
        logs: t.logs.map((e) => ({
          ...oE(e),
          l1BatchNumber: e.l1BatchNumber ? je(e.l1BatchNumber) : null,
          transactionLogIndex: na(e.transactionLogIndex),
          logType: e.logType
        })),
        l2ToL1Logs: t.l2ToL1Logs.map((e) => ({
          blockNumber: je(e.blockHash),
          blockHash: e.blockHash,
          l1BatchNumber: e.l1BatchNumber ? je(e.l1BatchNumber) : null,
          transactionIndex: je(e.transactionIndex),
          shardId: je(e.shardId),
          isService: e.isService,
          sender: e.sender,
          key: e.key,
          value: e.value,
          transactionHash: e.transactionHash,
          logIndex: je(e.logIndex)
        }))
      };
    }
  }),
  transactionRequest: /* @__PURE__ */ Z2({
    exclude: [
      "customSignature",
      "factoryDeps",
      "gasPerPubdata",
      "paymaster",
      "paymasterInput"
    ],
    format(t) {
      return t.gasPerPubdata || t.paymaster && t.paymasterInput || t.factoryDeps || t.customSignature ? {
        eip712Meta: {
          ...t.gasPerPubdata ? { gasPerPubdata: Te(t.gasPerPubdata) } : { gasPerPubdata: Te(Fp) },
          ...t.paymaster && t.paymasterInput ? {
            paymasterParams: {
              paymaster: t.paymaster,
              paymasterInput: Array.from(Yr(t.paymasterInput))
            }
          } : {},
          ...t.factoryDeps ? {
            factoryDeps: t.factoryDeps.map((e) => Array.from(Yr(e)))
          } : {},
          ...t.customSignature ? {
            customSignature: Array.from(Yr(t.customSignature))
          } : {}
        },
        type: "0x71"
      } : {};
    }
  })
};
class _M extends oe {
  constructor() {
    super([
      "Transaction is not an EIP712 transaction.",
      "",
      "Transaction must:",
      '  - include `type: "eip712"`',
      "  - include one of the following: `customSignature`, `paymaster`, `paymasterInput`, `gasPerPubdata`, `factoryDeps`"
    ].join(`
`), { name: "InvalidEip712TransactionError" });
  }
}
function uE(t) {
  return !!(t.type === "eip712" || "customSignature" in t && t.customSignature || "paymaster" in t && t.paymaster || "paymasterInput" in t && t.paymasterInput || "gasPerPubdata" in t && typeof t.gasPerPubdata == "bigint" || "factoryDeps" in t && t.factoryDeps);
}
function hE(t) {
  const { chainId: e, to: r, from: s, paymaster: n, paymasterInput: i } = t;
  if (!uE(t))
    throw new _M();
  if (!e || e <= 0)
    throw new Ti({ chainId: e });
  if (r && !Gt(r))
    throw new sr({ address: r });
  if (s && !Gt(s))
    throw new sr({ address: s });
  if (n && !Gt(n))
    throw new sr({ address: n });
  if (n && !i)
    throw new oe("`paymasterInput` must be provided when `paymaster` is defined");
  if (!n && i)
    throw new oe("`paymaster` must be provided when `paymasterInput` is defined");
}
function TM(t, e) {
  return uE(t) ? $M(t) : aE(t, e);
}
const UM = {
  transaction: TM
};
function $M(t) {
  const { chainId: e, gas: r, nonce: s, to: n, from: i, value: o, maxFeePerGas: a, maxPriorityFeePerGas: c, customSignature: l, factoryDeps: u, paymaster: h, paymasterInput: p, gasPerPubdata: y, data: b } = t;
  hE(t);
  const g = [
    s ? Te(s) : "0x",
    c ? Te(c) : "0x",
    a ? Te(a) : "0x",
    r ? Te(r) : "0x",
    n ?? "0x",
    o ? Te(o) : "0x",
    b ?? "0x",
    Te(e),
    Te(""),
    Te(""),
    Te(e),
    i ?? "0x",
    Te(y || Fp),
    u ?? [],
    l ?? "0x",
    // EIP712 signature
    h && p ? [h, p] : []
  ];
  return Nn([
    "0x71",
    Cs(g)
  ]);
}
class BM extends oe {
  constructor({ givenLength: e, maxBytecodeSize: r }) {
    super(`Bytecode cannot be longer than ${r} bytes. Given length: ${e}`, { name: "BytecodeLengthExceedsMaxSizeError" });
  }
}
class DM extends oe {
  constructor({ givenLengthInWords: e }) {
    super(`Bytecode length in 32-byte words must be odd. Given length in words: ${e}`, { name: "BytecodeLengthInWordsMustBeOddError" });
  }
}
class OM extends oe {
  constructor({ givenLength: e }) {
    super(`The bytecode length in bytes must be divisible by 32. Given length: ${e}`, { name: "BytecodeLengthMustBeDivisibleBy32Error" });
  }
}
function PM(t) {
  const e = qo(t);
  if (e.length % 32 !== 0)
    throw new OM({
      givenLength: e.length
    });
  if (e.length > N1)
    throw new BM({
      givenLength: e.length,
      maxBytecodeSize: N1
    });
  const r = tE(e), s = qo(r), n = e.length / 32;
  if (n % 2 === 0)
    throw new DM({
      givenLengthInWords: n
    });
  const i = qo(n), o = Rn(i, { size: 2 }), a = new Uint8Array([1, 0]);
  return s.set(a, 0), s.set(o, 2), s;
}
const RM = (t) => {
  hE(t);
  const e = NM(t);
  return {
    domain: {
      name: "zkSync",
      version: "2",
      chainId: t.chainId
    },
    types: {
      Transaction: [
        { name: "txType", type: "uint256" },
        { name: "from", type: "uint256" },
        { name: "to", type: "uint256" },
        { name: "gasLimit", type: "uint256" },
        { name: "gasPerPubdataByteLimit", type: "uint256" },
        { name: "maxFeePerGas", type: "uint256" },
        { name: "maxPriorityFeePerGas", type: "uint256" },
        { name: "paymaster", type: "uint256" },
        { name: "nonce", type: "uint256" },
        { name: "value", type: "uint256" },
        { name: "data", type: "bytes" },
        { name: "factoryDeps", type: "bytes32[]" },
        { name: "paymasterInput", type: "bytes" }
      ]
    },
    primaryType: "Transaction",
    message: e
  };
};
function NM(t) {
  const { gas: e, nonce: r, to: s, from: n, value: i, maxFeePerGas: o, maxPriorityFeePerGas: a, factoryDeps: c, paymaster: l, paymasterInput: u, gasPerPubdata: h, data: p } = t;
  return {
    txType: 113n,
    from: BigInt(n),
    to: s ? BigInt(s) : 0n,
    gasLimit: e ?? 0n,
    gasPerPubdataByteLimit: h ?? Fp,
    maxFeePerGas: o ?? 0n,
    maxPriorityFeePerGas: a ?? 0n,
    paymaster: l ? BigInt(l) : 0n,
    nonce: r ? BigInt(r) : 0n,
    value: i ?? 0n,
    data: p ?? "0x",
    factoryDeps: (c == null ? void 0 : c.map((y) => Te(PM(y)))) ?? [],
    paymasterInput: u || "0x"
  };
}
const or = {
  blockTime: 1e3,
  formatters: lE,
  serializers: UM,
  custom: {
    getEip712Domain: RM
  }
}, LM = /* @__PURE__ */ d({
  ...or,
  id: 2741,
  name: "Abstract",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://api.mainnet.abs.xyz"],
      webSocket: ["wss://api.mainnet.abs.xyz/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://abscan.org"
    },
    native: {
      name: "Abstract Explorer",
      url: "https://explorer.mainnet.abs.xyz"
    }
  },
  contracts: {
    multicall3: {
      address: "0xAa4De41dba0Ca5dCBb288b7cC6b708F3aaC759E7",
      blockCreated: 5288
    },
    erc6492Verifier: {
      address: "0xfB688330379976DA81eB64Fe4BF50d7401763B9C",
      blockCreated: 5263
    }
  }
}), MM = /* @__PURE__ */ d({
  ...or,
  id: 11124,
  name: "Abstract Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://api.testnet.abs.xyz"] }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://sepolia.abscan.org"
    },
    native: {
      name: "Abstract Explorer",
      url: "https://explorer.testnet.abs.xyz"
    }
  },
  testnet: !0,
  contracts: {
    multicall3: {
      address: "0xF9cda624FBC7e059355ce98a31693d299FACd963",
      blockCreated: 358349
    },
    erc6492Verifier: {
      address: "0xfB688330379976DA81eB64Fe4BF50d7401763B9C",
      blockCreated: 431682
    }
  }
}), FM = /* @__PURE__ */ d({
  id: 787,
  name: "Acala",
  network: "acala",
  nativeCurrency: {
    name: "Acala",
    symbol: "ACA",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://eth-rpc-acala.aca-api.network"],
      webSocket: ["wss://eth-rpc-acala.aca-api.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Acala Blockscout",
      url: "https://blockscout.acala.network",
      apiUrl: "https://blockscout.acala.network/api"
    }
  },
  testnet: !1
}), zM = /* @__PURE__ */ d({
  id: 47,
  name: "Acria IntelliChain",
  nativeCurrency: {
    decimals: 18,
    name: "ACRIA",
    symbol: "ACRIA"
  },
  rpcUrls: {
    default: {
      http: ["https://aic.acria.ai"]
    }
  },
  blockExplorers: {
    default: {
      name: "Acria Explorer",
      url: "https://explorer.acria.ai"
    }
  },
  testnet: !1
}), jM = /* @__PURE__ */ d({
  id: 1215,
  name: "ADF Chain",
  nativeCurrency: { name: "ADDFILL", symbol: "ADF", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.adftechnology.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "ADF Mainnet Explorer",
      url: "https://explorer.adftechnology.com"
    }
  },
  testnet: !1
}), HM = /* @__PURE__ */ d({
  id: 9990,
  name: "Agung Network",
  nativeCurrency: {
    decimals: 18,
    name: "Agung",
    symbol: "AGNG"
  },
  rpcUrls: {
    default: {
      http: ["https://wss-async.agung.peaq.network"],
      webSocket: ["wss://wss-async.agung.peaq.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Subscan",
      url: "https://agung-testnet.subscan.io"
    }
  },
  testnet: !0
}), qM = /* @__PURE__ */ d({
  id: 168,
  name: "AIOZ Network",
  nativeCurrency: {
    decimals: 18,
    name: "AIOZ",
    symbol: "AIOZ"
  },
  rpcUrls: {
    default: {
      http: ["https://eth-dataseed.aioz.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "AIOZ Explorer",
      url: "https://explorer.aioz.network"
    }
  },
  testnet: !1
}), KM = /* @__PURE__ */ d({
  id: 41455,
  name: "Aleph Zero",
  nativeCurrency: { name: "Aleph Zero", symbol: "AZERO", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.alephzero.raas.gelato.cloud"]
    }
  },
  blockExplorers: {
    default: {
      name: "Aleph Zero EVM Explorer",
      url: "https://evm-explorer.alephzero.org",
      apiUrl: "https://evm-explorer.alephzero.org/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 4603377
    }
  }
}), VM = /* @__PURE__ */ d({
  id: 2039,
  name: "Aleph Zero Testnet",
  nativeCurrency: { name: "TZERO", symbol: "TZERO", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.alephzero-testnet.gelato.digital"],
      webSocket: ["wss://ws.alephzero-testnet.gelato.digital"]
    }
  },
  blockExplorers: {
    default: {
      name: "Aleph Zero EVM Testnet explorer",
      url: "https://evm-explorer-testnet.alephzero.org",
      apiUrl: "https://evm-explorer-testnet.alephzero.org/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 2861745
    }
  },
  testnet: !0
}), GM = /* @__PURE__ */ d({
  id: 10241024,
  name: "AlienX Mainnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.alienxchain.io/http"] }
  },
  blockExplorers: {
    default: {
      name: "AlienX Explorer",
      url: "https://explorer.alienxchain.io"
    }
  },
  testnet: !1
}), WM = /* @__PURE__ */ d({
  id: 10241025,
  name: "ALIENX Hal Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://hal-rpc.alienxchain.io/http"] }
  },
  blockExplorers: {
    default: {
      name: "AlienX Explorer",
      url: "https://hal-explorer.alienxchain.io"
    }
  },
  testnet: !0
}), dE = {
  gasPriceOracle: { address: "0x420000000000000000000000000000000000000F" },
  l1Block: { address: "0x4200000000000000000000000000000000000015" },
  l2CrossDomainMessenger: {
    address: "0x4200000000000000000000000000000000000007"
  },
  l2Erc721Bridge: { address: "0x4200000000000000000000000000000000000014" },
  l2StandardBridge: { address: "0x4200000000000000000000000000000000000010" },
  l2ToL1MessagePasser: {
    address: "0x4200000000000000000000000000000000000016"
  }
}, zp = {
  block: /* @__PURE__ */ Np({
    format(t) {
      var r;
      return {
        transactions: (r = t.transactions) == null ? void 0 : r.map((s) => {
          if (typeof s == "string")
            return s;
          const n = ql(s);
          return n.typeHex === "0x7e" && (n.isSystemTx = s.isSystemTx, n.mint = s.mint ? je(s.mint) : void 0, n.sourceHash = s.sourceHash, n.type = "deposit"), n;
        }),
        stateRoot: t.stateRoot
      };
    }
  }),
  transaction: /* @__PURE__ */ Rp({
    format(t) {
      const e = {};
      return t.type === "0x7e" && (e.isSystemTx = t.isSystemTx, e.mint = t.mint ? je(t.mint) : void 0, e.sourceHash = t.sourceHash, e.type = "deposit"), e;
    }
  }),
  transactionReceipt: /* @__PURE__ */ cE({
    format(t) {
      return {
        l1GasPrice: t.l1GasPrice ? je(t.l1GasPrice) : null,
        l1GasUsed: t.l1GasUsed ? je(t.l1GasUsed) : null,
        l1Fee: t.l1Fee ? je(t.l1Fee) : null,
        l1FeeScalar: t.l1FeeScalar ? Number(t.l1FeeScalar) : null
      };
    }
  })
};
function pE(t, e) {
  return XM(t) ? JM(t) : aE(t, e);
}
const ZM = {
  transaction: pE
};
function JM(t) {
  YM(t);
  const { sourceHash: e, data: r, from: s, gas: n, isSystemTx: i, mint: o, to: a, value: c } = t, l = [
    e,
    s,
    a ?? "0x",
    o ? Te(o) : "0x",
    c ? Te(c) : "0x",
    n ? Te(n) : "0x",
    i ? "0x1" : "0x",
    r ?? "0x"
  ];
  return Nn([
    "0x7e",
    Cs(l)
  ]);
}
function XM(t) {
  return t.type === "deposit" || typeof t.sourceHash < "u";
}
function YM(t) {
  const { from: e, to: r } = t;
  if (e && !Gt(e))
    throw new sr({ address: e });
  if (r && !Gt(r))
    throw new sr({ address: r });
}
const W = {
  blockTime: 2e3,
  contracts: dE,
  formatters: zp,
  serializers: ZM
}, sc = 1, QM = /* @__PURE__ */ d({
  ...W,
  id: 888888888,
  name: "Ancient8",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.ancient8.gg"]
    }
  },
  blockExplorers: {
    default: {
      name: "Ancient8 explorer",
      url: "https://scan.ancient8.gg",
      apiUrl: "https://scan.ancient8.gg/api"
    }
  },
  contracts: {
    ...W.contracts,
    l2OutputOracle: {
      [sc]: {
        address: "0xB09DC08428C8b4EFB4ff9C0827386CDF34277996"
      }
    },
    portal: {
      [sc]: {
        address: "0x639F2AECE398Aa76b07e59eF6abe2cFe32bacb68",
        blockCreated: 19070571
      }
    },
    l1StandardBridge: {
      [sc]: {
        address: "0xd5e3eDf5b68135D559D572E26bF863FBC1950033",
        blockCreated: 19070571
      }
    }
  },
  sourceId: sc
}), nc = 11155111, eF = /* @__PURE__ */ d({
  ...W,
  id: 28122024,
  name: "Ancient8 Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpcv2-testnet.ancient8.gg"]
    }
  },
  blockExplorers: {
    default: {
      name: "Ancient8 Celestia Testnet explorer",
      url: "https://scanv2-testnet.ancient8.gg",
      apiUrl: "https://scanv2-testnet.ancient8.gg/api"
    }
  },
  contracts: {
    ...W.contracts,
    l2OutputOracle: {
      [nc]: {
        address: "0x942fD5017c0F60575930D8574Eaca13BEcD6e1bB"
      }
    },
    portal: {
      [nc]: {
        address: "0xfa1d9E26A6aCD7b22115D27572c1221B9803c960",
        blockCreated: 4972908
      }
    },
    l1StandardBridge: {
      [nc]: {
        address: "0xF6Bc0146d3c74D48306e79Ae134A260E418C9335",
        blockCreated: 4972908
      }
    }
  },
  sourceId: nc
}), tF = /* @__PURE__ */ d({
  id: 31337,
  name: "Anvil",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["http://127.0.0.1:8545"],
      webSocket: ["ws://127.0.0.1:8545"]
    }
  }
}), rF = 42161, sF = /* @__PURE__ */ d({
  id: 33139,
  name: "Ape Chain",
  nativeCurrency: {
    name: "ApeCoin",
    symbol: "APE",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.apechain.com/http"],
      webSocket: ["wss://rpc.apechain.com/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Apescan",
      url: "https://apescan.io",
      apiUrl: "https://api.apescan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 20889
    }
  },
  sourceId: rF
}), nF = /* @__PURE__ */ d({
  id: 3993,
  name: "APEX Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-testnet.apexlayer.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://exp-testnet.apexlayer.xyz",
      apiUrl: "https://exp-testnet.apexlayer.xyz/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xf7642be33a6b18D16a995657adb5a68CD0438aE2",
      blockCreated: 283775
    }
  },
  testnet: !0
}), iF = /* @__PURE__ */ d({
  id: 42161,
  name: "Arbitrum One",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  blockTime: 250,
  rpcUrls: {
    default: {
      http: ["https://arb1.arbitrum.io/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Arbiscan",
      url: "https://arbiscan.io",
      apiUrl: "https://api.arbiscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 7654707
    }
  }
}), oF = /* @__PURE__ */ d({
  id: 421613,
  name: "Arbitrum Goerli",
  nativeCurrency: {
    name: "Arbitrum Goerli Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://goerli-rollup.arbitrum.io/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Arbiscan",
      url: "https://goerli.arbiscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 88114
    }
  },
  testnet: !0
}), aF = /* @__PURE__ */ d({
  id: 42170,
  name: "Arbitrum Nova",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://nova.arbitrum.io/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Arbiscan",
      url: "https://nova.arbiscan.io",
      apiUrl: "https://api-nova.arbiscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1746963
    }
  }
}), cF = /* @__PURE__ */ d({
  id: 421614,
  name: "Arbitrum Sepolia",
  blockTime: 250,
  nativeCurrency: {
    name: "Arbitrum Sepolia Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia-rollup.arbitrum.io/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Arbiscan",
      url: "https://sepolia.arbiscan.io",
      apiUrl: "https://api-sepolia.arbiscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 81930
    }
  },
  testnet: !0
}), lF = /* @__PURE__ */ d({
  id: 7897,
  name: "Arena-Z",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.arena-z.gg"]
    }
  },
  blockExplorers: {
    default: {
      name: "Arena-Z Explorer",
      url: "https://explorer.arena-z.gg",
      apiUrl: "https://explorer.arena-z.gg"
    }
  }
}), uF = /* @__PURE__ */ d({
  id: 463,
  name: "Areon Network",
  nativeCurrency: { decimals: 18, name: "AREA", symbol: "AREA" },
  rpcUrls: {
    default: {
      http: ["https://mainnet-rpc.areon.network"],
      webSocket: ["wss://mainnet-ws.areon.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Areonscan",
      url: "https://areonscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 353286
    }
  },
  testnet: !1
}), hF = /* @__PURE__ */ d({
  id: 462,
  name: "Areon Network Testnet",
  nativeCurrency: { decimals: 18, name: "TAREA", symbol: "TAREA" },
  rpcUrls: {
    default: {
      http: ["https://testnet-rpc.areon.network"],
      webSocket: ["wss://testnet-ws.areon.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Areonscan",
      url: "https://areonscan.com"
    }
  },
  testnet: !0
}), dF = /* @__PURE__ */ d({
  id: 463,
  name: "Areum",
  nativeCurrency: { decimals: 18, name: "AREA", symbol: "AREA" },
  rpcUrls: {
    default: {
      http: ["https://mainnet-rpc.areum.network"],
      webSocket: ["wss://mainnet-ws.areum.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Areum Explorer",
      url: "https://explorer.areum.network"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 353286
    }
  },
  testnet: !1
}), pF = /* @__PURE__ */ d({
  id: 11822,
  name: "Artela Testnet",
  nativeCurrency: { name: "ART", symbol: "ART", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://betanet-rpc1.artela.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Artela",
      url: "https://betanet-scan.artela.network",
      apiUrl: "https://betanet-scan.artela.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xd07c8635f76e8745Ee7092fbb6e8fbc5FeF09DD7",
      blockCreated: 7001871
    }
  },
  testnet: !0
}), fF = /* @__PURE__ */ d({
  id: 10242,
  name: "Arthera",
  nativeCurrency: { name: "Arthera", symbol: "AA", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.arthera.net"]
    }
  },
  blockExplorers: {
    default: {
      name: "Arthera EVM Explorer",
      url: "https://explorer.arthera.net",
      apiUrl: "https://explorer.arthera.net/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 4502791
    }
  }
}), mF = /* @__PURE__ */ d({
  id: 10243,
  name: "Arthera Testnet",
  nativeCurrency: { name: "Arthera", symbol: "AA", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-test.arthera.net"]
    }
  },
  blockExplorers: {
    default: {
      name: "Arthera EVM Explorer",
      url: "https://explorer-test.arthera.net",
      apiUrl: "https://explorer-test.arthera.net/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 22051
    }
  }
}), bF = /* @__PURE__ */ d({
  id: 42420,
  name: "AssetChain Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Real World Asset",
    symbol: "RWA"
  },
  rpcUrls: {
    default: { http: ["https://mainnet-rpc.assetchain.org"] }
  },
  blockExplorers: {
    default: {
      name: "Asset Chain Explorer",
      url: "https://scan.assetchain.org",
      apiUrl: "https://scan.assetchain.org/api"
    }
  },
  testnet: !1,
  contracts: {}
}), yF = /* @__PURE__ */ d({
  id: 42421,
  name: "AssetChain Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Real World Asset",
    symbol: "RWA"
  },
  rpcUrls: {
    default: { http: ["https://enugu-rpc.assetchain.org"] }
  },
  blockExplorers: {
    default: {
      name: "Asset Chain Testnet Explorer",
      url: "https://scan-testnet.assetchain.org",
      apiUrl: "https://scan-testnet.assetchain.org/api"
    }
  },
  testnet: !0,
  contracts: {
    multicall3: {
      address: "0x989F832D35988cb5e3eB001Fa2Fe789469EC31Ea",
      blockCreated: 17177
    }
  }
}), gF = /* @__PURE__ */ d({
  id: 592,
  name: "Astar",
  network: "astar-mainnet",
  nativeCurrency: {
    name: "Astar",
    symbol: "ASTR",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://astar.api.onfinality.io/public"] }
  },
  blockExplorers: {
    default: {
      name: "Astar Subscan",
      url: "https://astar.subscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 761794
    }
  },
  testnet: !1
}), wF = /* @__PURE__ */ d({
  id: 3776,
  name: "Astar zkEVM",
  network: "AstarZkEVM",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-zkevm.astar.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Astar zkEVM Explorer",
      url: "https://astar-zkevm.explorer.startale.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 93528
    }
  },
  testnet: !1
}), EF = /* @__PURE__ */ d({
  id: 6038361,
  name: "Astar zkEVM Testnet zKyoto",
  network: "zKyoto",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.startale.com/zkyoto"]
    }
  },
  blockExplorers: {
    default: {
      name: "zKyoto Explorer",
      url: "https://zkyoto.explorer.startale.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 196153
    }
  },
  testnet: !0
}), xF = /* @__PURE__ */ d({
  id: 2340,
  name: "Atleta Olympia",
  nativeCurrency: { decimals: 18, name: "Atla", symbol: "ATLA" },
  rpcUrls: {
    default: {
      http: [
        "https://testnet-rpc.atleta.network:9944",
        "https://testnet-rpc.atleta.network"
      ],
      ws: ["wss://testnet-rpc.atleta.network:9944"]
    }
  },
  blockExplorers: {
    default: {
      name: "Atleta Olympia Explorer",
      url: "https://blockscout.atleta.network",
      apiUrl: "https://blockscout.atleta.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0x1472ec6392180fb84F345d2455bCC75B26577115",
      blockCreated: 1076473
    }
  },
  testnet: !0
}), vF = /* @__PURE__ */ d({
  id: 1313161554,
  name: "Aurora",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://mainnet.aurora.dev"] }
  },
  blockExplorers: {
    default: {
      name: "Aurorascan",
      url: "https://aurorascan.dev",
      apiUrl: "https://aurorascan.dev/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 62907816
    }
  }
}), kF = /* @__PURE__ */ d({
  id: 1313161555,
  name: "Aurora Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://testnet.aurora.dev"] }
  },
  blockExplorers: {
    default: {
      name: "Aurorascan",
      url: "https://testnet.aurorascan.dev",
      apiUrl: "https://testnet.aurorascan.dev/api"
    }
  },
  testnet: !0
}), CF = /* @__PURE__ */ d({
  id: 205205,
  name: "Auroria Testnet",
  network: "auroria",
  nativeCurrency: {
    name: "Auroria Stratis",
    symbol: "tSTRAX",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://auroria.rpc.stratisevm.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Auroria Testnet Explorer",
      url: "https://auroria.explorer.stratisevm.com"
    }
  },
  testnet: !0
}), SF = /* @__PURE__ */ d({
  id: 785,
  name: "Autheo Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Autheo",
    symbol: "THEO"
  },
  rpcUrls: {
    default: {
      http: [
        "https://testnet-rpc1.autheo.com",
        "https://testnet-rpc2.autheo.com"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Autheo Testnet Block Explorer",
      url: "https://testnet-explorer.autheo.com/"
    }
  }
}), IF = /* @__PURE__ */ d({
  id: 43114,
  name: "Avalanche",
  blockTime: 1700,
  nativeCurrency: {
    decimals: 18,
    name: "Avalanche",
    symbol: "AVAX"
  },
  rpcUrls: {
    default: { http: ["https://api.avax.network/ext/bc/C/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "SnowTrace",
      url: "https://snowtrace.io",
      apiUrl: "https://api.snowtrace.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 11907934
    }
  }
}), AF = /* @__PURE__ */ d({
  id: 43113,
  name: "Avalanche Fuji",
  nativeCurrency: {
    decimals: 18,
    name: "Avalanche Fuji",
    symbol: "AVAX"
  },
  rpcUrls: {
    default: { http: ["https://api.avax-test.network/ext/bc/C/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "SnowTrace",
      url: "https://testnet.snowtrace.io",
      apiUrl: "https://api-testnet.snowtrace.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 7096959
    }
  },
  testnet: !0
}), _F = 8453, TF = /* @__PURE__ */ d({
  id: 8333,
  name: "B3",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://mainnet-rpc.b3.fun/http"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://explorer.b3.fun"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 0
    }
  },
  sourceId: _F
}), UF = 168587773, $F = /* @__PURE__ */ d({
  id: 1993,
  name: "B3 Sepolia",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia.b3.fun/http"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://sepolia.explorer.b3.fun"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 0
    }
  },
  testnet: !0,
  sourceId: UF
}), BF = /* @__PURE__ */ d({
  id: 5165,
  network: "bahamut",
  name: "Bahamut",
  nativeCurrency: { name: "Fasttoken", symbol: "FTN", decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        "https://rpc1.bahamut.io",
        "https://bahamut-rpc.publicnode.com",
        "https://rpc2.bahamut.io"
      ],
      webSocket: [
        "wss://ws1.sahara.bahamutchain.com",
        "wss://bahamut-rpc.publicnode.com",
        "wss://ws2.sahara.bahamutchain.com"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Ftnscan",
      url: "https://www.ftnscan.com",
      apiUrl: "https://www.ftnscan.com/api"
    }
  }
}), so = 1, fE = /* @__PURE__ */ d({
  ...W,
  id: 8453,
  name: "Base",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.base.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Basescan",
      url: "https://basescan.org",
      apiUrl: "https://api.basescan.org/api"
    }
  },
  contracts: {
    ...W.contracts,
    disputeGameFactory: {
      [so]: {
        address: "0x43edB88C4B80fDD2AdFF2412A7BebF9dF42cB40e"
      }
    },
    l2OutputOracle: {
      [so]: {
        address: "0x56315b90c40730925ec5485cf004d835058518A0"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 5022
    },
    portal: {
      [so]: {
        address: "0x49048044D57e1C92A77f79988d21Fa8fAF74E97e",
        blockCreated: 17482143
      }
    },
    l1StandardBridge: {
      [so]: {
        address: "0x3154Cf16ccdb4C6d922629664174b904d80F2C35",
        blockCreated: 17482143
      }
    }
  },
  sourceId: so
}), DF = /* @__PURE__ */ d({
  ...fE,
  experimental_preconfirmationTime: 200,
  rpcUrls: {
    default: {
      http: ["https://mainnet-preconf.base.org"]
    }
  }
}), OF = /* @__PURE__ */ d({
  id: 123420001114,
  name: "Basecamp Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Camp",
    symbol: "CAMP"
  },
  rpcUrls: {
    default: { http: ["https://rpc.basecamp.t.raas.gelato.cloud"] }
  },
  blockExplorers: {
    default: {
      name: "basecamp",
      url: "https://basecamp.cloud.blockscout.com"
    }
  },
  testnet: !0
}), ic = 5, PF = /* @__PURE__ */ d({
  ...W,
  id: 84531,
  name: "Base Goerli",
  nativeCurrency: { name: "Goerli Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://goerli.base.org"] }
  },
  blockExplorers: {
    default: {
      name: "Basescan",
      url: "https://goerli.basescan.org",
      apiUrl: "https://goerli.basescan.org/api"
    }
  },
  contracts: {
    ...W.contracts,
    l2OutputOracle: {
      [ic]: {
        address: "0x2A35891ff30313CcFa6CE88dcf3858bb075A2298"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1376988
    },
    portal: {
      [ic]: {
        address: "0xe93c8cD0D409341205A592f8c4Ac1A5fe5585cfA"
      }
    },
    l1StandardBridge: {
      [ic]: {
        address: "0xfA6D8Ee5BE770F84FC001D098C4bD604Fe01284a"
      }
    }
  },
  testnet: !0,
  sourceId: ic
}), no = 11155111, mE = /* @__PURE__ */ d({
  ...W,
  id: 84532,
  network: "base-sepolia",
  name: "Base Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.base.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Basescan",
      url: "https://sepolia.basescan.org",
      apiUrl: "https://api-sepolia.basescan.org/api"
    }
  },
  contracts: {
    ...W.contracts,
    disputeGameFactory: {
      [no]: {
        address: "0xd6E6dBf4F7EA0ac412fD8b65ED297e64BB7a06E1"
      }
    },
    l2OutputOracle: {
      [no]: {
        address: "0x84457ca9D0163FbC4bbfe4Dfbb20ba46e48DF254"
      }
    },
    portal: {
      [no]: {
        address: "0x49f53e41452c74589e85ca1677426ba426459e85",
        blockCreated: 4446677
      }
    },
    l1StandardBridge: {
      [no]: {
        address: "0xfd0Bf71F60660E2f608ed56e1659C450eB113120",
        blockCreated: 4446677
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1059647
    }
  },
  testnet: !0,
  sourceId: no
}), RF = /* @__PURE__ */ d({
  ...mE,
  experimental_preconfirmationTime: 200,
  rpcUrls: {
    default: {
      http: ["https://sepolia-preconf.base.org"]
    }
  }
}), NF = /* @__PURE__ */ d({
  id: 4337,
  name: "Beam",
  network: "beam",
  nativeCurrency: {
    decimals: 18,
    name: "Beam",
    symbol: "BEAM"
  },
  rpcUrls: {
    default: {
      http: ["https://build.onbeam.com/rpc"],
      webSocket: ["wss://build.onbeam.com/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Beam Explorer",
      url: "https://subnets.avax.network/beam"
    }
  },
  contracts: {
    multicall3: {
      address: "0x4956f15efdc3dc16645e90cc356eafa65ffc65ec",
      blockCreated: 1
    }
  }
}), LF = /* @__PURE__ */ d({
  id: 13337,
  name: "Beam Testnet",
  network: "beam",
  nativeCurrency: {
    decimals: 18,
    name: "Beam",
    symbol: "BEAM"
  },
  rpcUrls: {
    default: {
      http: ["https://build.onbeam.com/rpc/testnet"],
      webSocket: ["wss://build.onbeam.com/ws/testnet"]
    }
  },
  blockExplorers: {
    default: {
      name: "Beam Explorer",
      url: "https://subnets-test.avax.network/beam"
    }
  },
  contracts: {
    multicall3: {
      address: "0x9bf49b704ee2a095b95c1f2d4eb9010510c41c9e",
      blockCreated: 3
    }
  },
  testnet: !0
}), MF = /* @__PURE__ */ d({
  id: 641230,
  name: "Bear Network Chain Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "BearNetworkChain",
    symbol: "BRNKC"
  },
  rpcUrls: {
    default: { http: ["https://brnkc-mainnet.bearnetwork.net"] }
  },
  blockExplorers: {
    default: {
      name: "BrnkScan",
      url: "https://brnkscan.bearnetwork.net",
      apiUrl: "https://brnkscan.bearnetwork.net/api"
    }
  }
}), FF = /* @__PURE__ */ d({
  id: 751230,
  name: "Bear Network Chain Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "tBRNKC",
    symbol: "tBRNKC"
  },
  rpcUrls: {
    default: { http: ["https://brnkc-test.bearnetwork.net"] }
  },
  blockExplorers: {
    default: {
      name: "BrnkTestScan",
      url: "https://brnktest-scan.bearnetwork.net",
      apiUrl: "https://brnktest-scan.bearnetwork.net/api"
    }
  },
  testnet: !0
}), zF = /* @__PURE__ */ d({
  id: 80094,
  name: "Berachain",
  blockTime: 2e3,
  nativeCurrency: {
    decimals: 18,
    name: "BERA Token",
    symbol: "BERA"
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 0
    },
    ensRegistry: {
      address: "0x5b22280886a2f5e09a49bea7e320eab0e5320e28",
      blockCreated: 877007
    },
    ensUniversalResolver: {
      address: "0x4D41762915F83c76EcaF6776d9b08076aA32b492",
      blockCreated: 9310021
    }
  },
  rpcUrls: {
    default: { http: ["https://rpc.berachain.com"] }
  },
  blockExplorers: {
    default: {
      name: "Berascan",
      url: "https://berascan.com"
    }
  },
  ensTlds: [".bera"],
  testnet: !1
}), jF = /* @__PURE__ */ d({
  id: 80069,
  blockTime: 2e3,
  name: "Berachain Bepolia",
  nativeCurrency: {
    decimals: 18,
    name: "BERA Token",
    symbol: "BERA"
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 0
    }
  },
  rpcUrls: {
    default: { http: ["https://bepolia.rpc.berachain.com"] }
  },
  blockExplorers: {
    default: {
      name: "Berascan",
      url: "https://bepolia.beratrail.io"
    }
  },
  testnet: !0
}), HF = /* @__PURE__ */ d({
  id: 80085,
  name: "Berachain Artio",
  nativeCurrency: {
    decimals: 18,
    name: "BERA Token",
    symbol: "BERA"
  },
  rpcUrls: {
    default: { http: ["https://artio.rpc.berachain.com"] }
  },
  blockExplorers: {
    default: {
      name: "Berachain",
      url: "https://artio.beratrail.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 866924
    }
  },
  testnet: !0
}), qF = /* @__PURE__ */ d({
  id: 80084,
  name: "Berachain bArtio",
  nativeCurrency: {
    decimals: 18,
    name: "BERA Token",
    symbol: "BERA"
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 109269
    },
    ensRegistry: {
      address: "0xB0eef18971290b333450586D33dcA6cE122651D2",
      blockCreated: 7736794
    },
    ensUniversalResolver: {
      address: "0x41692Ef1EA0C79E6b73077E4A67572D2BDbD7057",
      blockCreated: 7736795
    }
  },
  ensTlds: [".bera"],
  rpcUrls: {
    default: { http: ["https://bartio.rpc.berachain.com"] }
  },
  blockExplorers: {
    default: {
      name: "Berachain bArtio Beratrail",
      url: "https://bartio.beratrail.io"
    }
  },
  testnet: !0
}), KF = /* @__PURE__ */ d({
  id: 11501,
  name: "BEVM Mainnet",
  nativeCurrency: { name: "Bitcoin", symbol: "BTC", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc-mainnet-1.bevm.io"] }
  },
  blockExplorers: {
    default: {
      name: "Bevmscan",
      url: "https://scan-mainnet.bevm.io",
      apiUrl: "https://scan-mainnet-api.bevm.io/api"
    }
  }
}), VF = /* @__PURE__ */ d({
  id: 3068,
  name: "Bifrost Mainnet",
  nativeCurrency: { name: "BFC", symbol: "BFC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://public-01.mainnet.bifrostnetwork.com/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Bifrost Blockscout",
      url: "https://explorer.mainnet.bifrostnetwork.com"
    }
  },
  testnet: !1
}), GF = d({
  id: 53456,
  name: "BirdLayer",
  nativeCurrency: { decimals: 18, name: "Ether", symbol: "ETH" },
  rpcUrls: {
    default: {
      http: ["https://rpc.birdlayer.xyz", "https://rpc1.birdlayer.xyz"],
      webSocket: ["wss://rpc.birdlayer.xyz/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "BirdLayer Explorer",
      url: "https://scan.birdlayer.xyz"
    }
  }
}), WF = /* @__PURE__ */ d({
  id: 32520,
  name: "Bitgert Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Brise",
    symbol: "Brise"
  },
  rpcUrls: {
    default: { http: ["https://rpc-bitgert.icecreamswap.com"] }
  },
  blockExplorers: {
    default: {
      name: "Bitgert Scan",
      url: "https://brisescan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 2118034
    }
  },
  testnet: !1
}), ZF = /* @__PURE__ */ d({
  id: 96,
  name: "KUB Mainnet",
  nativeCurrency: { name: "KUB Coin", symbol: "KUB", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.bitkubchain.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "KUB Chain Mainnet Explorer",
      url: "https://www.bkcscan.com",
      apiUrl: "https://www.bkcscan.com/api"
    }
  }
}), JF = /* @__PURE__ */ d({
  id: 25925,
  name: "Bitkub Testnet",
  network: "Bitkub Testnet",
  nativeCurrency: { name: "Bitkub Test", symbol: "tKUB", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-testnet.bitkubchain.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Bitkub Chain Testnet Explorer",
      url: "https://testnet.bkcscan.com",
      apiUrl: "https://testnet.bkcscan.com/api"
    }
  },
  testnet: !0
}), XF = /* @__PURE__ */ d({
  id: 200901,
  name: "Bitlayer Mainnet",
  nativeCurrency: {
    name: "BTC",
    symbol: "BTC",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.bitlayer.org"],
      webSocket: ["wss://ws.bitlayer.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "bitlayer mainnet scan",
      url: "https://www.btrscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0x5B256fE9e993902eCe49D138a5b1162cBb529474",
      blockCreated: 2421963
    }
  }
}), YF = /* @__PURE__ */ d({
  id: 200810,
  name: "Bitlayer Testnet",
  nativeCurrency: {
    name: "BTC",
    symbol: "BTC",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://testnet-rpc.bitlayer.org"],
      webSocket: ["wss://testnet-ws.bitlayer.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "bitlayer testnet scan",
      url: "https://testnet.btrscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0x5B256fE9e993902eCe49D138a5b1162cBb529474",
      blockCreated: 4135671
    }
  },
  testnet: !0
}), QF = /* @__PURE__ */ d({
  id: 7171,
  name: "Bitrock Mainnet",
  nativeCurrency: { name: "BROCK", symbol: "BROCK", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://brockrpc.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Bitrock Explorer",
      url: "https://explorer.bit-rock.io"
    }
  },
  testnet: !1
}), ez = /* @__PURE__ */ d({
  id: 199,
  name: "BitTorrent",
  network: "bittorrent-chain-mainnet",
  nativeCurrency: { name: "BitTorrent", symbol: "BTT", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.bittorrentchain.io"] }
  },
  blockExplorers: {
    default: {
      name: "Bttcscan",
      url: "https://bttcscan.com",
      apiUrl: "https://api.bttcscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 31078552
    }
  }
}), tz = /* @__PURE__ */ d({
  id: 1028,
  name: "BitTorrent Chain Testnet",
  network: "bittorrent-chain-testnet",
  nativeCurrency: { name: "BitTorrent", symbol: "BTT", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://testrpc.bittorrentchain.io"] }
  },
  blockExplorers: {
    default: {
      name: "Bttcscan",
      url: "https://testnet.bttcscan.com",
      apiUrl: "https://testnet.bttcscan.com/api"
    }
  },
  testnet: !0
}), oc = 1, rz = /* @__PURE__ */ d({
  ...W,
  id: 81457,
  name: "Blast",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://rpc.blast.io"] }
  },
  blockExplorers: {
    default: {
      name: "Blastscan",
      url: "https://blastscan.io",
      apiUrl: "https://api.blastscan.io/api"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 212929
    },
    l2OutputOracle: {
      [oc]: {
        address: "0x826D1B0D4111Ad9146Eb8941D7Ca2B6a44215c76",
        blockCreated: 19300358
      }
    },
    portal: {
      [oc]: {
        address: "0x0Ec68c5B10F21EFFb74f2A5C61DFe6b08C0Db6Cb",
        blockCreated: 19300357
      }
    },
    l1StandardBridge: {
      [oc]: {
        address: "0x697402166Fbf2F22E970df8a6486Ef171dbfc524",
        blockCreated: 19300360
      }
    }
  },
  sourceId: oc
}), sz = 11155111, nz = /* @__PURE__ */ d({
  id: 168587773,
  name: "Blast Sepolia",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia.blast.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blastscan",
      url: "https://sepolia.blastscan.io",
      apiUrl: "https://api-sepolia.blastscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 756690
    }
  },
  testnet: !0,
  sourceId: sz
}), Zu = 1, iz = d({
  ...W,
  id: 60808,
  name: "BOB",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.gobob.xyz"],
      webSocket: ["wss://rpc.gobob.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "BOB Explorer",
      url: "https://explorer.gobob.xyz"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 23131
    },
    l2OutputOracle: {
      [Zu]: {
        address: "0xdDa53E23f8a32640b04D7256e651C1db98dB11C1",
        blockCreated: 4462615
      }
    },
    portal: {
      [Zu]: {
        address: "0x8AdeE124447435fE03e3CD24dF3f4cAE32E65a3E",
        blockCreated: 4462615
      }
    }
  },
  sourceId: Zu
}), oz = /* @__PURE__ */ d({
  id: 288,
  name: "Boba Network",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://mainnet.boba.network"] }
  },
  blockExplorers: {
    default: {
      name: "BOBAScan",
      url: "https://bobascan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 446859
    }
  }
}), az = /* @__PURE__ */ d({
  id: 28882,
  name: "Boba Sepolia",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://sepolia.boba.network"] }
  },
  blockExplorers: {
    default: {
      name: "BOBAScan",
      url: "https://testnet.bobascan.com"
    }
  },
  testnet: !0
}), Ju = 11155111, cz = d({
  ...W,
  id: 808813,
  name: "BOB Sepolia",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://bob-sepolia.rpc.gobob.xyz"],
      webSocket: ["wss://bob-sepolia.rpc.gobob.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "BOB Sepolia Explorer",
      url: "https://bob-sepolia.explorer.gobob.xyz"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 35677
    },
    l2OutputOracle: {
      [Ju]: {
        address: "0x14D0069452b4AE2b250B395b8adAb771E4267d2f",
        blockCreated: 4462615
      }
    },
    portal: {
      [Ju]: {
        address: "0x867B1Aa872b9C8cB5E9F7755feDC45BB24Ad0ae4",
        blockCreated: 4462615
      }
    }
  },
  testnet: !0,
  sourceId: Ju
}), lz = /* @__PURE__ */ d({
  id: 11100,
  name: "Bool Beta Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "BOL",
    symbol: "BOL"
  },
  rpcUrls: {
    default: { http: ["https://beta-rpc-node-http.bool.network"] }
  },
  blockExplorers: {
    default: {
      name: "BoolScan",
      url: "https://beta-mainnet.boolscan.com/"
    }
  },
  testnet: !1
}), uz = /* @__PURE__ */ d({
  id: 3637,
  name: "Botanix",
  nativeCurrency: { name: "Bitcoin", symbol: "BTC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.botanixlabs.com"],
      webSocket: ["wss://rpc.botanixlabs.com/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Botanixscan",
      url: "https://botanixscan.io"
    }
  }
}), hz = /* @__PURE__ */ d({
  id: 3636,
  name: "Botanix Testnet",
  nativeCurrency: { name: "Bitcoin", symbol: "BTC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://node.botanixlabs.dev"]
    }
  },
  blockExplorers: {
    default: {
      name: "Botanix Testnet Explorer",
      url: "https://testnet.botanixscan.io"
    }
  },
  testnet: !0
}), dz = /* @__PURE__ */ d({
  id: 6001,
  name: "BounceBit Mainnet",
  nativeCurrency: { name: "BounceBit", symbol: "BB", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://fullnode-mainnet.bouncebitapi.com"] }
  },
  blockExplorers: {
    default: {
      name: "BB Scan",
      url: "https://bbscan.io"
    }
  },
  testnet: !1
}), pz = /* @__PURE__ */ d({
  id: 6e3,
  name: "BounceBit Testnet",
  nativeCurrency: { name: "BounceBit", symbol: "BB", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://fullnode-testnet.bouncebitapi.com"] }
  },
  blockExplorers: {
    default: {
      name: "BB Scan",
      url: "https://testnet.bbscan.io"
    }
  },
  testnet: !0
}), fz = /* @__PURE__ */ d({
  id: 1039,
  name: "Bronos",
  nativeCurrency: {
    decimals: 18,
    name: "BRO",
    symbol: "BRO"
  },
  rpcUrls: {
    default: { http: ["https://evm.bronos.org"] }
  },
  blockExplorers: {
    default: {
      name: "BronoScan",
      url: "https://broscan.bronos.org"
    }
  }
}), mz = /* @__PURE__ */ d({
  id: 1038,
  name: "Bronos Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Bronos Coin",
    symbol: "tBRO"
  },
  rpcUrls: {
    default: { http: ["https://evm-testnet.bronos.org"] }
  },
  blockExplorers: {
    default: {
      name: "BronoScan",
      url: "https://tbroscan.bronos.org"
    }
  },
  testnet: !0
}), bz = /* @__PURE__ */ d({
  id: 56,
  name: "BNB Smart Chain",
  blockTime: 750,
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "BNB"
  },
  rpcUrls: {
    default: { http: ["https://56.rpc.thirdweb.com"] }
  },
  blockExplorers: {
    default: {
      name: "BscScan",
      url: "https://bscscan.com",
      apiUrl: "https://api.bscscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 15921452
    }
  }
}), yz = /* @__PURE__ */ d({
  id: 1017,
  name: "BNB Greenfield Chain",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "BNB"
  },
  rpcUrls: {
    default: { http: ["https://greenfield-chain.bnbchain.org"] }
  },
  blockExplorers: {
    default: {
      name: "BNB Greenfield Mainnet Scan",
      url: "https://greenfieldscan.com"
    }
  },
  testnet: !1
}), gz = /* @__PURE__ */ d({
  id: 97,
  name: "BNB Smart Chain Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "tBNB"
  },
  rpcUrls: {
    default: { http: ["https://data-seed-prebsc-1-s1.bnbchain.org:8545"] }
  },
  blockExplorers: {
    default: {
      name: "BscScan",
      url: "https://testnet.bscscan.com",
      apiUrl: "https://api-testnet.bscscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 17422483
    }
  },
  testnet: !0
}), wz = /* @__PURE__ */ d({
  id: 223,
  name: "B2",
  nativeCurrency: {
    name: "Bitcoin",
    symbol: "BTC",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.bsquared.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "blockscout",
      url: "https://explorer.bsquared.network"
    }
  }
}), Ez = /* @__PURE__ */ d({
  id: 1123,
  name: "B2 Testnet",
  nativeCurrency: {
    name: "Bitcoin",
    symbol: "BTC",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://testnet-rpc.bsquared.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "blockscout",
      url: "https://testnet-explorer.bsquared.network"
    }
  },
  testnet: !0
}), xz = /* @__PURE__ */ d({
  id: 200901,
  name: "Bitlayer",
  nativeCurrency: {
    name: "Bitcoin",
    symbol: "BTC",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.bitlayer.org", "https://rpc.bitlayer-rpc.com"],
      webSocket: ["wss://ws.bitlayer.org", "wss://ws.bitlayer-rpc.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Bitlayer(BTR) Scan",
      url: "https://www.btrscan.com"
    }
  }
}), vz = /* @__PURE__ */ d({
  id: 200810,
  name: "Bitlayer Testnet",
  nativeCurrency: {
    name: "Bitcoin",
    symbol: "BTC",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://testnet-rpc.bitlayer.org"],
      webSocket: [
        "wss://testnet-ws.bitlayer.org",
        "wss://testnet-ws.bitlayer-rpc.com"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Bitlayer(BTR) Scan",
      url: "https://testnet.btrscan.com"
    }
  },
  testnet: !0
}), kz = /* @__PURE__ */ d({
  id: 4999,
  name: "BlackFort Exchange Network",
  nativeCurrency: { name: "BlackFort Token", symbol: "BXN", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.blackfort.network/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://explorer.blackfort.network",
      apiUrl: "https://explorer.blackfort.network/api"
    }
  }
}), Cz = /* @__PURE__ */ d({
  id: 4777,
  name: "BlackFort Exchange Network Testnet",
  nativeCurrency: {
    name: "BlackFort Testnet Token",
    symbol: "TBXN",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://testnet.blackfort.network/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://testnet-explorer.blackfort.network",
      apiUrl: "https://testnet-explorer.blackfort.network/api"
    }
  },
  testnet: !0
}), Sz = /* @__PURE__ */ d({
  id: 13370,
  name: "Cannon",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["http://127.0.0.1:8545"] }
  }
}), Iz = /* @__PURE__ */ d({
  id: 7700,
  name: "Canto",
  nativeCurrency: {
    decimals: 18,
    name: "Canto",
    symbol: "CANTO"
  },
  rpcUrls: {
    default: { http: ["https://canto.gravitychain.io"] }
  },
  blockExplorers: {
    default: {
      name: "Tuber.Build (Blockscout)",
      url: "https://tuber.build"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 2905789
    }
  }
}), Az = {
  /*
     * Estimates the fees per gas for a transaction.
  
     * If the transaction is to be paid in a token (feeCurrency is present) then the fees
     * are estimated in the value of the token. Otherwise falls back to the default
     * estimation by returning null.
     *
     * @param params fee estimation function parameters
     */
  estimateFeesPerGas: async (t) => {
    var n;
    if (!((n = t.request) != null && n.feeCurrency))
      return null;
    const [e, r] = await Promise.all([
      _z(t.client, t.request.feeCurrency),
      Tz(t.client, t.request.feeCurrency)
    ]);
    return {
      maxFeePerGas: t.multiply(e - r) + r,
      maxPriorityFeePerGas: r
    };
  }
};
async function _z(t, e) {
  const r = await t.request({
    method: "eth_gasPrice",
    params: [e]
  });
  return BigInt(r);
}
async function Tz(t, e) {
  const r = await t.request({
    method: "eth_maxPriorityFeePerGas",
    params: [e]
  });
  return BigInt(r);
}
function bE(t) {
  return t === 0 || t === 0n || t === void 0 || t === null || t === "0" || t === "" || typeof t == "string" && (pi(t).toLowerCase() === "0x" || pi(t).toLowerCase() === "0x00");
}
function To(t) {
  return !bE(t);
}
function Uz(t) {
  return typeof t.maxFeePerGas < "u" && typeof t.maxPriorityFeePerGas < "u";
}
function yE(t) {
  return t.type === "cip64" ? !0 : Uz(t) && To(t.feeCurrency);
}
const $z = {
  block: /* @__PURE__ */ Np({
    format(t) {
      var r;
      return {
        transactions: (r = t.transactions) == null ? void 0 : r.map((s) => typeof s == "string" ? s : {
          ...ql(s),
          ...s.gatewayFee ? {
            gatewayFee: je(s.gatewayFee),
            gatewayFeeRecipient: s.gatewayFeeRecipient
          } : {},
          feeCurrency: s.feeCurrency
        })
      };
    }
  }),
  transaction: /* @__PURE__ */ Rp({
    format(t) {
      if (t.type === "0x7e")
        return {
          isSystemTx: t.isSystemTx,
          mint: t.mint ? je(t.mint) : void 0,
          sourceHash: t.sourceHash,
          type: "deposit"
        };
      const e = { feeCurrency: t.feeCurrency };
      return t.type === "0x7b" ? e.type = "cip64" : (t.type === "0x7c" && (e.type = "cip42"), e.gatewayFee = t.gatewayFee ? je(t.gatewayFee) : null, e.gatewayFeeRecipient = t.gatewayFeeRecipient), e;
    }
  }),
  transactionRequest: /* @__PURE__ */ Z2({
    format(t) {
      const e = {};
      return t.feeCurrency && (e.feeCurrency = t.feeCurrency), yE(t) && (e.type = "0x7b"), e;
    }
  })
};
function Bz(t, e) {
  return yE(t) ? Oz(t, e) : pE(t, e);
}
const Dz = {
  transaction: Bz
};
function Oz(t, e) {
  Rz(t);
  const { chainId: r, gas: s, nonce: n, to: i, value: o, maxFeePerGas: a, maxPriorityFeePerGas: c, accessList: l, feeCurrency: u, data: h } = t, p = [
    Te(r),
    n ? Te(n) : "0x",
    c ? Te(c) : "0x",
    a ? Te(a) : "0x",
    s ? Te(s) : "0x",
    i ?? "0x",
    o ? Te(o) : "0x",
    h ?? "0x",
    _a(l),
    u,
    ...Ui(t, e)
  ];
  return Nn([
    "0x7b",
    Cs(p)
  ]);
}
const Pz = Aa;
function Rz(t) {
  const { chainId: e, maxPriorityFeePerGas: r, gasPrice: s, maxFeePerGas: n, to: i, feeCurrency: o } = t;
  if (e <= 0)
    throw new Ti({ chainId: e });
  if (i && !Gt(i))
    throw new sr({ address: i });
  if (s)
    throw new oe("`gasPrice` is not a valid CIP-64 Transaction attribute.");
  if (To(n) && n > Pz)
    throw new un({ maxFeePerGas: n });
  if (To(r) && To(n) && r > n)
    throw new fi({ maxFeePerGas: n, maxPriorityFeePerGas: r });
  if (To(o) && !Gt(o))
    throw new oe("`feeCurrency` MUST be a token address for CIP-64 transactions.");
  if (bE(o))
    throw new oe("`feeCurrency` must be provided for CIP-64 transactions.");
}
const ia = {
  blockTime: 1e3,
  contracts: dE,
  formatters: $z,
  serializers: Dz,
  fees: Az
}, Nz = /* @__PURE__ */ d({
  ...ia,
  id: 42220,
  name: "Celo",
  nativeCurrency: {
    decimals: 18,
    name: "CELO",
    symbol: "CELO"
  },
  rpcUrls: {
    default: { http: ["https://forno.celo.org"] }
  },
  blockExplorers: {
    default: {
      name: "Celo Explorer",
      url: "https://celoscan.io",
      apiUrl: "https://api.celoscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 13112599
    }
  },
  testnet: !1
}), ac = 17e3, Lz = /* @__PURE__ */ d({
  ...ia,
  id: 44787,
  name: "Alfajores",
  nativeCurrency: {
    decimals: 18,
    name: "CELO",
    symbol: "A-CELO"
  },
  rpcUrls: {
    default: {
      http: ["https://alfajores-forno.celo-testnet.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Celo Alfajores Explorer",
      url: "https://celo-alfajores.blockscout.com",
      apiUrl: "https://celo-alfajores.blockscout.com/api"
    }
  },
  contracts: {
    ...ia.contracts,
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 14569001
    },
    portal: {
      [ac]: {
        address: "0x82527353927d8D069b3B452904c942dA149BA381",
        blockCreated: 2411324
      }
    },
    disputeGameFactory: {
      [ac]: {
        address: "0xE28AAdcd9883746c0e5068F58f9ea06027b214cb",
        blockCreated: 2411324
      }
    },
    l2OutputOracle: {
      [ac]: {
        address: "0x4a2635e9e4f6e45817b1D402ac4904c1d1752438",
        blockCreated: 2411324
      }
    },
    l1StandardBridge: {
      [ac]: {
        address: "0xD1B0E0581973c9eB7f886967A606b9441A897037",
        blockCreated: 2411324
      }
    }
  },
  testnet: !0
}), Xu = 11155111, Mz = /* @__PURE__ */ d({
  ...ia,
  id: 11142220,
  name: "Celo Sepolia Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "CELO",
    symbol: "S-CELO"
  },
  rpcUrls: {
    default: {
      http: ["https://forno.celo-sepolia.celo-testnet.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Celo Sepolia Explorer",
      url: "https://celo-sepolia.blockscout.com/",
      apiUrl: "https://celo-sepolia.blockscout.com/api"
    }
  },
  contracts: {
    ...ia.contracts,
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1
    },
    portal: {
      [Xu]: {
        address: "0x44ae3d41a335a7d05eb533029917aad35662dcc2",
        blockCreated: 8825790
      }
    },
    disputeGameFactory: {
      [Xu]: {
        address: "0x57c45d82d1a995f1e135b8d7edc0a6bb5211cfaa",
        blockCreated: 8825790
      }
    },
    l1StandardBridge: {
      [Xu]: {
        address: "0xec18a3c30131a0db4246e785355fbc16e2eaf408",
        blockCreated: 8825790
      }
    }
  },
  testnet: !0
}), Fz = /* @__PURE__ */ d({
  id: 5858,
  name: "Chang Chain Foundation Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "CTH",
    symbol: "CTH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.cthscan.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Chang Chain explorer",
      url: "https://cthscan.com"
    }
  }
}), zz = /* @__PURE__ */ d({
  id: 88888,
  name: "Chiliz Chain",
  network: "chiliz-chain",
  nativeCurrency: {
    decimals: 18,
    name: "CHZ",
    symbol: "CHZ"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.chiliz.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Chiliz Explorer",
      url: "https://scan.chiliz.com",
      apiUrl: "https://scan.chiliz.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 8080847
    }
  }
}), jz = /* @__PURE__ */ d({
  id: 2882,
  name: "Chips Network",
  network: "CHIPS",
  nativeCurrency: {
    decimals: 18,
    name: "IOTA",
    symbol: "IOTA"
  },
  rpcUrls: {
    default: {
      http: [
        "https://node.chips.ooo/wasp/api/v1/chains/iota1pp3d3mnap3ufmgqnjsnw344sqmf5svjh26y2khnmc89sv6788y3r207a8fn/evm"
      ]
    }
  }
}), Hz = /* @__PURE__ */ d({
  id: 5115,
  name: "Citrea Testnet",
  nativeCurrency: { name: "cBTC", symbol: "cBTC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.citrea.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Citrea Explorer",
      url: "https://explorer.testnet.citrea.xyz",
      apiUrl: "https://explorer.testnet.citrea.xyz/api"
    }
  },
  testnet: !0
}), qz = /* @__PURE__ */ d({
  id: 61,
  name: "Ethereum Classic",
  nativeCurrency: {
    decimals: 18,
    name: "ETC",
    symbol: "ETC"
  },
  rpcUrls: {
    default: { http: ["https://etc.rivet.link"] }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://blockscout.com/etc/mainnet"
    }
  }
}), Kz = /* @__PURE__ */ d({
  id: 112,
  name: "Coinbit Mainnet",
  nativeCurrency: { name: "GIDR", symbol: "GIDR", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://coinbit-rpc-mainnet.chain.sbcrypto.app"]
    }
  },
  blockExplorers: {
    default: {
      name: "Coinbit Explorer",
      url: "https://coinbit-explorer.chain.sbcrypto.app"
    }
  },
  testnet: !1
}), Vz = /* @__PURE__ */ d({
  id: 52,
  name: "CoinEx Mainnet",
  nativeCurrency: { name: "cet", symbol: "cet", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.coinex.net"]
    }
  },
  blockExplorers: {
    default: {
      name: "CoinEx Explorer",
      url: "https://www.coinex.net"
    }
  },
  testnet: !1
}), Gz = /* @__PURE__ */ d({
  id: 1030,
  name: "Conflux eSpace",
  nativeCurrency: { name: "Conflux", symbol: "CFX", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://evm.confluxrpc.com"],
      webSocket: ["wss://evm.confluxrpc.com/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "ConfluxScan",
      url: "https://evm.confluxscan.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0xEFf0078910f638cd81996cc117bccD3eDf2B072F",
      blockCreated: 68602935
    }
  }
}), Wz = /* @__PURE__ */ d({
  id: 71,
  name: "Conflux eSpace Testnet",
  network: "cfx-espace-testnet",
  testnet: !0,
  nativeCurrency: { name: "Conflux", symbol: "CFX", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://evmtestnet.confluxrpc.com"],
      webSocket: ["wss://evmtestnet.confluxrpc.com/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "ConfluxScan",
      url: "https://evmtestnet.confluxscan.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0xEFf0078910f638cd81996cc117bccD3eDf2B072F",
      blockCreated: 117499050
    }
  }
}), Zz = /* @__PURE__ */ d({
  id: 1116,
  name: "Core Dao",
  nativeCurrency: {
    decimals: 18,
    name: "Core",
    symbol: "CORE"
  },
  rpcUrls: {
    default: { http: ["https://rpc.coredao.org"] }
  },
  blockExplorers: {
    default: {
      name: "CoreDao",
      url: "https://scan.coredao.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 11907934
    }
  },
  testnet: !1
}), Jz = /* @__PURE__ */ d({
  id: 1115,
  name: "Core Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "tCore",
    symbol: "TCORE"
  },
  rpcUrls: {
    default: { http: ["https://rpc.test.btcs.network"] }
  },
  blockExplorers: {
    default: {
      name: "Core Testnet",
      url: "https://scan.test.btcs.network",
      apiUrl: "https://api.test.btcs.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xCcddF20A1932537123C2E48Bd8e00b108B8f7569",
      blockCreated: 29350509
    }
  },
  testnet: !0
}), Xz = /* @__PURE__ */ d({
  id: 1114,
  name: "Core Testnet2",
  nativeCurrency: {
    decimals: 18,
    name: "tCore2",
    symbol: "TCORE2"
  },
  rpcUrls: {
    default: { http: ["https://rpc.test2.btcs.network"] }
  },
  blockExplorers: {
    default: {
      name: "Core Testnet2",
      url: "https://scan.test2.btcs.network",
      apiUrl: "https://api.test2.btcs.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0x3CB285ff3Cd5C7C7e570b1E7DE3De17A0f985e56",
      blockCreated: 3838600
    }
  },
  testnet: !0
}), Yz = 1, Qz = /* @__PURE__ */ d({
  id: 21e6,
  name: "Corn",
  nativeCurrency: {
    decimals: 18,
    name: "Bitcorn",
    symbol: "BTCN"
  },
  rpcUrls: {
    default: { http: ["https://21000000.rpc.thirdweb.com"] }
  },
  blockExplorers: {
    default: {
      name: "Corn Explorer",
      url: "https://cornscan.io",
      apiUrl: "https://api.routescan.io/v2/network/mainnet/evm/21000000/etherscan/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3228
    }
  },
  sourceId: Yz
}), ej = 11155111, tj = /* @__PURE__ */ d({
  id: 21000001,
  name: "Corn Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Bitcorn",
    symbol: "BTCN"
  },
  rpcUrls: {
    default: { http: ["https://21000001.rpc.thirdweb.com"] }
  },
  blockExplorers: {
    default: {
      name: "Corn Testnet Explorer",
      url: "https://testnet.cornscan.io",
      apiUrl: "https://api.routescan.io/v2/network/testnet/evm/21000001/etherscan/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 4886
    }
  },
  testnet: !0,
  sourceId: ej
}), rj = d({
  id: 44,
  name: "Crab Network",
  nativeCurrency: {
    decimals: 18,
    name: "Crab Network Native Token",
    symbol: "CRAB"
  },
  rpcUrls: {
    default: {
      http: ["https://crab-rpc.darwinia.network"],
      webSocket: ["wss://crab-rpc.darwinia.network"]
    }
  },
  blockExplorers: {
    default: { name: "Blockscout", url: "https://crab-scan.darwinia.network" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 3032593
    }
  }
}), sj = d({
  id: 66665,
  name: "Creator",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.creatorchain.io"]
    }
  },
  blockExplorers: {
    default: { name: "Explorer", url: "https://explorer.creatorchain.io" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  },
  testnet: !0
}), nj = /* @__PURE__ */ d({
  id: 102032,
  name: "Creditcoin Devnet",
  nativeCurrency: { name: "Devnet CTC", symbol: "devCTC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.cc3-devnet.creditcoin.network"],
      webSocket: ["wss://rpc.cc3-devnet.creditcoin.network/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://creditcoin-devnet.blockscout.com",
      apiUrl: "https://creditcoin3-dev.subscan.io"
    }
  },
  testnet: !0
}), ij = /* @__PURE__ */ d({
  id: 102030,
  name: "Creditcoin",
  nativeCurrency: { name: "Creditcoin", symbol: "CTC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet3.creditcoin.network"],
      webSocket: ["wss://mainnet3.creditcoin.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://creditcoin.blockscout.com",
      apiUrl: "https://creditcoin.blockscout.com/api"
    }
  },
  testnet: !1
}), oj = /* @__PURE__ */ d({
  id: 102031,
  name: "Creditcoin Testnet",
  nativeCurrency: { name: "Creditcoin Testnet", symbol: "tCTC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.cc3-testnet.creditcoin.network"],
      webSocket: ["wss://rpc.cc3-testnet.creditcoin.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://creditcoin-testnet.blockscout.com",
      apiUrl: "https://creditcoin-testnet.blockscout.com/api"
    }
  },
  testnet: !0
}), aj = /* @__PURE__ */ d({
  id: 25,
  name: "Cronos Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Cronos",
    symbol: "CRO"
  },
  rpcUrls: {
    default: { http: ["https://evm.cronos.org"] }
  },
  blockExplorers: {
    default: {
      name: "Cronos Explorer",
      url: "https://explorer.cronos.org",
      apiUrl: "https://explorer-api.cronos.org/mainnet/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1963112
    }
  }
}), cj = /* @__PURE__ */ d({
  id: 338,
  name: "Cronos Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "CRO",
    symbol: "tCRO"
  },
  rpcUrls: {
    default: { http: ["https://evm-t3.cronos.org"] }
  },
  blockExplorers: {
    default: {
      name: "Cronos Explorer (Testnet)",
      url: "https://explorer.cronos.org/testnet"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 10191251
    }
  },
  testnet: !0
}), lj = /* @__PURE__ */ d({
  id: 388,
  name: "Cronos zkEVM Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Cronos zkEVM CRO",
    symbol: "zkCRO"
  },
  rpcUrls: {
    default: { http: ["https://mainnet.zkevm.cronos.org"] }
  },
  blockExplorers: {
    default: {
      name: "Cronos zkEVM (Mainnet) Chain Explorer",
      url: "https://explorer.zkevm.cronos.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0x06f4487d7c4a5983d2660db965cc6d2565e4cfaa",
      blockCreated: 72
    }
  }
}), uj = /* @__PURE__ */ d({
  id: 282,
  name: "Cronos zkEVM Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Cronos zkEVM Test Coin",
    symbol: "zkTCRO"
  },
  rpcUrls: {
    default: { http: ["https://testnet.zkevm.cronos.org"] }
  },
  blockExplorers: {
    default: {
      name: "Cronos zkEVM Testnet Explorer",
      url: "https://explorer.zkevm.cronos.org/testnet"
    }
  },
  testnet: !0
}), hj = /* @__PURE__ */ d({
  id: 3737,
  name: "Crossbell",
  nativeCurrency: {
    decimals: 18,
    name: "CSB",
    symbol: "CSB"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.crossbell.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "CrossScan",
      url: "https://scan.crossbell.io",
      apiUrl: "https://scan.crossbell.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 38246031
    }
  }
}), dj = /* @__PURE__ */ d({
  id: 4158,
  name: "CrossFi Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "CrossFi",
    symbol: "XFI"
  },
  rpcUrls: {
    default: { http: ["https://rpc.mainnet.ms"] }
  },
  blockExplorers: {
    default: {
      name: "CrossFi Blockchain Explorer",
      url: "https://xfiscan.com"
    }
  },
  testnet: !1
}), pj = /* @__PURE__ */ d({
  id: 33111,
  name: "Curtis",
  nativeCurrency: { name: "ApeCoin", symbol: "APE", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.curtis.apechain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Curtis Explorer",
      url: "https://explorer.curtis.apechain.com"
    }
  },
  testnet: !0
}), fj = /* @__PURE__ */ d({
  id: 7560,
  name: "Cyber",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://cyber.alt.technology"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://cyberscan.co",
      apiUrl: "https://cyberscan.co/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 0
    }
  }
}), mj = /* @__PURE__ */ d({
  id: 111557560,
  name: "Cyber Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://cyber-testnet.alt.technology"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://testnet.cyberscan.co",
      apiUrl: "https://testnet.cyberscan.co/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xffc391F0018269d4758AEA1a144772E8FB99545E",
      blockCreated: 304545
    }
  },
  testnet: !0
}), bj = /* @__PURE__ */ d({
  id: 824,
  name: "Daily Network Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Daily",
    symbol: "DLY"
  },
  rpcUrls: {
    default: { http: ["https://rpc.mainnet.dailycrypto.net"] }
  },
  blockExplorers: {
    default: {
      name: "Daily Mainnet Explorer",
      url: "https://explorer.mainnet.dailycrypto.net"
    }
  },
  testnet: !1
}), yj = /* @__PURE__ */ d({
  id: 825,
  name: "Daily Network Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Daily",
    symbol: "DLY"
  },
  rpcUrls: {
    default: { http: ["https://rpc.testnet.dailycrypto.net"] }
  },
  blockExplorers: {
    default: {
      name: "Daily Testnet Explorer",
      url: "https://explorer.testnet.dailycrypto.net"
    }
  },
  testnet: !0
}), gj = /* @__PURE__ */ d({
  id: 46,
  name: "Darwinia Network",
  nativeCurrency: {
    decimals: 18,
    name: "RING",
    symbol: "RING"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.darwinia.network"],
      webSocket: ["wss://rpc.darwinia.network"]
    }
  },
  blockExplorers: {
    default: { name: "Explorer", url: "https://explorer.darwinia.network" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 69420
    }
  }
}), wj = /* @__PURE__ */ d({
  id: 20240603,
  name: "DBK chain",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.mainnet.dbkchain.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "DBK Chain Explorer",
      url: "https://scan.dbkchain.io"
    }
  },
  testnet: !1
}), Ej = /* @__PURE__ */ d({
  ...W,
  id: 2716446429837e3,
  name: "Dchain",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://dchain-2716446429837000-1.jsonrpc.sagarpc.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Dchain Explorer",
      url: "https://dchain-2716446429837000-1.sagaexplorer.io",
      apiUrl: "https://api-dchain-2716446429837000-1.sagaexplorer.io/api"
    }
  },
  contracts: {
    ...W.contracts
  }
}), xj = /* @__PURE__ */ d({
  ...W,
  id: 2713017997578e3,
  name: "Dchain Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        "https://dchaintestnet-2713017997578000-1.jsonrpc.testnet.sagarpc.io"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Dchain Explorer",
      url: "https://dchaintestnet-2713017997578000-1.testnet.sagaexplorer.io",
      apiUrl: "https://api-dchaintestnet-2713017997578000-1.testnet.sagaexplorer.io/api"
    }
  },
  contracts: {
    ...W.contracts
  }
}), vj = /* @__PURE__ */ d({
  id: 1130,
  network: "defichain-evm",
  name: "DeFiChain EVM Mainnet",
  nativeCurrency: {
    name: "DeFiChain",
    symbol: "DFI",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://eth.mainnet.ocean.jellyfishsdk.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "DeFiScan",
      url: "https://meta.defiscan.live"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 137852
    }
  }
}), kj = /* @__PURE__ */ d({
  id: 1131,
  network: "defichain-evm-testnet",
  name: "DeFiChain EVM Testnet",
  nativeCurrency: {
    name: "DeFiChain",
    symbol: "DFI",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://eth.testnet.ocean.jellyfishsdk.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "DeFiScan",
      url: "https://meta.defiscan.live/?network=TestNet"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 156462
    }
  },
  testnet: !0
}), Cj = /* @__PURE__ */ d({
  id: 666666666,
  name: "Degen",
  nativeCurrency: {
    decimals: 18,
    name: "Degen",
    symbol: "DEGEN"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.degen.tips"],
      webSocket: ["wss://rpc.degen.tips"]
    }
  },
  blockExplorers: {
    default: {
      name: "Degen Chain Explorer",
      url: "https://explorer.degen.tips",
      apiUrl: "https://explorer.degen.tips/api/v2"
    }
  }
}), Sj = /* @__PURE__ */ d({
  id: 53935,
  name: "DFK Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Jewel",
    symbol: "JEWEL"
  },
  rpcUrls: {
    default: {
      http: ["https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "DFKSubnetScan",
      url: "https://subnets.avax.network/defi-kingdoms"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14790551
    }
  }
}), Ij = /* @__PURE__ */ d({
  id: 15,
  name: "Diode Prenet",
  nativeCurrency: {
    decimals: 18,
    name: "DIODE",
    symbol: "DIODE"
  },
  rpcUrls: {
    default: {
      http: ["https://prenet.diode.io:8443"],
      webSocket: ["wss://prenet.diode.io:8443/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Diode Explorer",
      url: "https://diode.io/prenet"
    }
  },
  testnet: !1
}), Aj = /* @__PURE__ */ d({
  id: 513100,
  name: "DisChain",
  nativeCurrency: {
    decimals: 18,
    name: "DIS",
    symbol: "DIS"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.dischain.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "DisChain Explorer",
      url: "https://www.oklink.com/dis"
    }
  }
}), _j = d({
  id: 53457,
  name: "DODOchain Testnet",
  nativeCurrency: { decimals: 18, name: "DODO", symbol: "DODO" },
  rpcUrls: {
    default: {
      http: ["https://dodochain-testnet.alt.technology"],
      webSocket: ["wss://dodochain-testnet.alt.technology/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "DODOchain Testnet (Sepolia) Explorer",
      url: "https://testnet-scan.dodochain.com"
    }
  },
  testnet: !0
}), Tj = /* @__PURE__ */ d({
  id: 2e3,
  name: "Dogechain",
  nativeCurrency: {
    decimals: 18,
    name: "Wrapped Dogecoin",
    symbol: "WDOGE"
  },
  rpcUrls: {
    default: { http: ["https://rpc.dogechain.dog"] }
  },
  blockExplorers: {
    default: {
      name: "DogeChainExplorer",
      url: "https://explorer.dogechain.dog",
      apiUrl: "https://explorer.dogechain.dog/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0x68a8609a60a008EFA633dfdec592c03B030cC508",
      blockCreated: 25384031
    }
  }
}), Uj = /* @__PURE__ */ d({
  id: 97476,
  name: "Doma Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://rpc-testnet.doma.xyz"] }
  },
  blockExplorers: {
    default: {
      name: "Doma Testnet Explorer",
      url: "https://explorer-testnet.doma.xyz"
    }
  },
  testnet: !0
}), $j = /* @__PURE__ */ d({
  id: 42026,
  name: "Donatuz",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://rpc.donatuz.com"] }
  },
  blockExplorers: {
    default: {
      name: "Donatuz Explorer",
      url: "https://explorer.donatuz.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 0
    }
  }
}), Bj = /* @__PURE__ */ d({
  id: 7979,
  name: "DOS Chain",
  nativeCurrency: {
    decimals: 18,
    name: "DOS Chain",
    symbol: "DOS"
  },
  rpcUrls: {
    default: { http: ["https://main.doschain.com"] }
  },
  blockExplorers: {
    default: {
      name: "DOS Chain Explorer",
      url: "https://doscan.io",
      apiUrl: "https://api.doscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 161908
    }
  }
}), Dj = /* @__PURE__ */ d({
  id: 3939,
  name: "DOS Chain Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "DOS Chain Testnet",
    symbol: "DOS"
  },
  rpcUrls: {
    default: { http: ["https://test.doschain.com"] }
  },
  blockExplorers: {
    default: {
      name: "DOS Chain Testnet Explorer",
      url: "https://test.doscan.io",
      apiUrl: "https://api-test.doscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 69623
    }
  },
  testnet: !0
}), Oj = /* @__PURE__ */ d({
  id: 23451,
  name: "DreyerX Mainnet",
  nativeCurrency: {
    name: "DreyerX",
    symbol: "DRX",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.dreyerx.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "DreyerX Scan",
      url: "https://scan.dreyerx.com"
    }
  }
}), Pj = /* @__PURE__ */ d({
  id: 23452,
  name: "DreyerX Testnet",
  nativeCurrency: {
    name: "DreyerX",
    symbol: "DRX",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["http://testnet-rpc.dreyerx.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "DreyerX Testnet Scan",
      url: "https://testnet-scan.dreyerx.com"
    }
  },
  testnet: !0
}), Rj = /* @__PURE__ */ d({
  id: 555888,
  name: "DustBoy IoT",
  nativeCurrency: { name: "Ether", symbol: "DST", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://dustboy-rpc.jibl2.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://dustboy.jibl2.com",
      apiUrl: "https://dustboy.jibl2.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xFFD34aa2C62B2D52E00A361e466C229788f4eD6a",
      blockCreated: 526569
    }
  },
  testnet: !1
}), Nj = /* @__PURE__ */ d({
  id: 1100,
  name: "Dymension",
  nativeCurrency: {
    name: "DYM",
    symbol: "DYM",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://dymension-evm-rpc.publicnode.com"],
      webSocket: ["wss://dymension-evm-rpc.publicnode.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Dym FYI",
      url: "https://dym.fyi"
    }
  },
  testnet: !1
}), Lj = /* @__PURE__ */ d({
  id: 5424,
  name: "edeXa",
  nativeCurrency: { name: "edeXa", symbol: "EDX", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.edexa.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "edeXa Explorer",
      url: "https://explorer.edexa.network",
      apiUrl: "https://explorer.edexa.network/api/v2"
    }
  }
}), Mj = /* @__PURE__ */ d({
  id: 1995,
  name: "edeXa Testnet",
  nativeCurrency: { name: "edeXa", symbol: "tEDX", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.edexa.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "edeXa Testnet Explorer",
      url: "https://explorer.testnet.edexa.network",
      apiUrl: "https://explorer.testnet.edexa.network/api/v2"
    }
  },
  testnet: !0
}), Fj = /* @__PURE__ */ d({
  id: 2026,
  name: "Edgeless Network",
  nativeCurrency: {
    name: "Edgeless Wrapped ETH",
    symbol: "EwETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.edgeless.network/http"],
      webSocket: ["wss://rpc.edgeless.network/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Edgeless Explorer",
      url: "https://explorer.edgeless.network"
    }
  }
}), zj = /* @__PURE__ */ d({
  id: 202,
  name: "Edgeless Testnet",
  nativeCurrency: {
    name: "Edgeless Wrapped ETH",
    symbol: "EwETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://edgeless-testnet.rpc.caldera.xyz/http"],
      webSocket: ["wss://edgeless-testnet.rpc.caldera.xyz/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Edgeless Testnet Explorer",
      url: "https://testnet.explorer.edgeless.network"
    }
  }
}), jj = /* @__PURE__ */ d({
  id: 2021,
  name: "Edgeware EdgeEVM Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Edgeware",
    symbol: "EDG"
  },
  rpcUrls: {
    default: { http: ["https://edgeware-evm.jelliedowl.net"] }
  },
  blockExplorers: {
    default: {
      name: "Edgscan by Bharathcoorg",
      url: "https://edgscan.live",
      apiUrl: "https://edgscan.live/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 18117872
    }
  }
}), Hj = /* @__PURE__ */ d({
  id: 2022,
  name: "Beresheet BereEVM Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Testnet EDG",
    symbol: "tEDG"
  },
  rpcUrls: {
    default: { http: ["https://beresheet-evm.jelliedowl.net"] }
  },
  blockExplorers: {
    default: {
      name: "Edgscan by Bharathcoorg",
      url: "https://testnet.edgscan.live",
      apiUrl: "https://testnet.edgscan.live/api"
    }
  }
}), qj = /* @__PURE__ */ d({
  id: 41923,
  name: "EDU Chain",
  nativeCurrency: {
    decimals: 18,
    name: "EDU",
    symbol: "EDU"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.edu-chain.raas.gelato.cloud"]
    }
  },
  blockExplorers: {
    default: {
      name: "EDU Chain Explorer",
      url: "https://educhain.blockscout.com/"
    }
  },
  testnet: !1
}), Kj = /* @__PURE__ */ d({
  id: 656476,
  name: "EDU Chain Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "EDU",
    symbol: "EDU"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.open-campus-codex.gelato.digital/"],
      webSocket: ["wss://ws.open-campus-codex.gelato.digital"]
    }
  },
  blockExplorers: {
    default: {
      name: "EDU Chain Testnet Explorer",
      url: "https://opencampus-codex.blockscout.com",
      apiUrl: "https://opencampus-codex.blockscout.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 15514133
    }
  },
  testnet: !0
}), Vj = /* @__PURE__ */ d({
  id: 1994,
  name: "Ekta",
  nativeCurrency: {
    decimals: 18,
    name: "EKTA",
    symbol: "EKTA"
  },
  rpcUrls: {
    default: { http: ["https://main.ekta.io"] }
  },
  blockExplorers: {
    default: {
      name: "Ektascan",
      url: "https://ektascan.io",
      apiUrl: "https://ektascan.io/api"
    }
  }
}), Gj = /* @__PURE__ */ d({
  id: 1004,
  name: "Ekta Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "EKTA",
    symbol: "EKTA"
  },
  rpcUrls: {
    default: { http: ["https://test.ekta.io:8545"] }
  },
  blockExplorers: {
    default: {
      name: "Test Ektascan",
      url: "https://test.ektascan.io",
      apiUrl: "https://test.ektascan.io/api"
    }
  },
  testnet: !0
}), Wj = /* @__PURE__ */ d({
  id: 20,
  name: "Elastos Smart Chain",
  nativeCurrency: { name: "ELA", symbol: "ELA", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://api2.elastos.io/eth"]
    }
  },
  blockExplorers: {
    default: {
      name: "Elastos Explorer",
      url: "https://esc.elastos.io"
    }
  },
  testnet: !1
}), Zj = /* @__PURE__ */ d({
  id: 21,
  name: "Elastos Smart Chain Testnet",
  nativeCurrency: { name: "tELA", symbol: "tELA", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://api-testnet.elastos.io/eth"]
    }
  },
  blockExplorers: {
    default: {
      name: "Elastos Explorer",
      url: "https://esc-testnet.elastos.io"
    }
  },
  testnet: !0
}), Jj = /* @__PURE__ */ d({
  id: 52014,
  name: "Electroneum Mainnet",
  nativeCurrency: {
    name: "ETN",
    symbol: "ETN",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.electroneum.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Electroneum Block Explorer",
      url: "https://blockexplorer.electroneum.com"
    }
  },
  testnet: !1
}), Xj = /* @__PURE__ */ d({
  id: 5201420,
  name: "Electroneum Testnet",
  nativeCurrency: {
    name: "ETN",
    symbol: "ETN",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://testnet-rpc.electroneum.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Electroneum Block Explorer",
      url: "https://blockexplorer.thesecurityteam.rocks"
    }
  },
  testnet: !0
}), Yj = /* @__PURE__ */ d({
  ...W,
  id: 1338,
  name: "Elysium Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "LAVA",
    symbol: "LAVA"
  },
  rpcUrls: {
    default: {
      http: ["https://elysium-test-rpc.vulcanforged.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Elysium testnet explorer",
      url: "https://elysium-explorer.vulcanforged.com"
    }
  },
  testnet: !0
}), Qj = /* @__PURE__ */ d({
  id: 246,
  name: "Energy Mainnet",
  nativeCurrency: { name: "EWT", symbol: "EWT", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.energyweb.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "EnergyWeb Explorer",
      url: "https://explorer.energyweb.org"
    }
  },
  testnet: !1
}), eH = /* @__PURE__ */ d({
  id: 173,
  name: "ENI Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "ENI",
    symbol: "ENI"
  },
  rpcUrls: {
    default: { http: ["https://rpc.eniac.network"] }
  },
  blockExplorers: {
    default: {
      name: "ENI Explorer",
      url: "https://scan.eniac.network"
    }
  },
  testnet: !1
}), tH = /* @__PURE__ */ d({
  id: 6912115,
  name: "ENI Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "ENI Testnet Token",
    symbol: "ENI"
  },
  rpcUrls: {
    default: { http: ["https://rpc-testnet.eniac.network"] }
  },
  blockExplorers: {
    default: {
      name: "ENI Testnet Explorer",
      url: "https://scan-testnet.eniac.network"
    }
  },
  testnet: !0
}), rH = /* @__PURE__ */ d({
  id: 119,
  name: "ENULS Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "NULS",
    symbol: "NULS"
  },
  rpcUrls: {
    default: { http: ["https://evmapi2.nuls.io"] }
  },
  blockExplorers: {
    default: {
      name: "ENULS Explorer",
      url: "https://evmscan.nuls.io"
    }
  },
  testnet: !1
}), sH = /* @__PURE__ */ d({
  id: 7332,
  name: "Horizen EON",
  nativeCurrency: {
    decimals: 18,
    name: "ZEN",
    symbol: "ZEN"
  },
  rpcUrls: {
    default: { http: ["https://eon-rpc.horizenlabs.io/ethv1"] }
  },
  blockExplorers: {
    default: {
      name: "EON Explorer",
      url: "https://eon-explorer.horizenlabs.io"
    }
  },
  contracts: {}
}), nH = /* @__PURE__ */ d({
  id: 17777,
  name: "EOS EVM",
  nativeCurrency: {
    decimals: 18,
    name: "EOS",
    symbol: "EOS"
  },
  rpcUrls: {
    default: { http: ["https://api.evm.eosnetwork.com"] }
  },
  blockExplorers: {
    default: {
      name: "EOS EVM Explorer",
      url: "https://explorer.evm.eosnetwork.com",
      apiUrl: "https://explorer.evm.eosnetwork.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 7943933
    }
  }
}), iH = /* @__PURE__ */ d({
  id: 15557,
  name: "EOS EVM Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "EOS",
    symbol: "EOS"
  },
  rpcUrls: {
    default: { http: ["https://api.testnet.evm.eosnetwork.com"] }
  },
  blockExplorers: {
    default: {
      name: "EOS EVM Testnet Explorer",
      url: "https://explorer.testnet.evm.eosnetwork.com",
      apiUrl: "https://explorer.testnet.evm.eosnetwork.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 9067940
    }
  },
  testnet: !0
}), oH = /* @__PURE__ */ d({
  id: 140,
  name: "Eteria",
  nativeCurrency: { name: "Eteria", symbol: "ERA", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.eteria.io/v1"]
    }
  },
  blockExplorers: {
    default: {
      name: "Eteria Explorer",
      url: "https://explorer.eteria.io",
      apiUrl: "https://explorer.eteria.io/api"
    }
  }
}), aH = /* @__PURE__ */ d({
  id: 42793,
  name: "Etherlink",
  blockTime: 4830,
  nativeCurrency: {
    decimals: 18,
    name: "Tez",
    symbol: "XTZ"
  },
  rpcUrls: {
    default: { http: ["https://node.mainnet.etherlink.com"] }
  },
  blockExplorers: {
    default: {
      name: "Etherlink",
      url: "https://explorer.etherlink.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 33899
    }
  }
}), cH = /* @__PURE__ */ d({
  id: 128123,
  name: "Etherlink Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Tez",
    symbol: "XTZ"
  },
  rpcUrls: {
    default: { http: ["https://node.ghostnet.etherlink.com"] }
  },
  blockExplorers: {
    default: {
      name: "Etherlink Testnet",
      url: "https://testnet.explorer.etherlink.com"
    }
  },
  testnet: !0
}), lH = /* @__PURE__ */ d({
  id: 183,
  name: "Ethernity",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://mainnet.ethernitychain.io"] }
  },
  blockExplorers: {
    default: {
      name: "Ethernity Explorer",
      url: "https://ernscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 0
    }
  },
  testnet: !1
}), uH = /* @__PURE__ */ d({
  id: 20256789,
  name: "ETP Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "ETP Chain Native Token",
    symbol: "ETP"
  },
  rpcUrls: {
    default: { http: ["https://rpc.etpscan.xyz"] }
  },
  blockExplorers: {
    default: {
      name: "ETP Scan",
      url: "https://etpscan.xyz"
    }
  }
}), hH = /* @__PURE__ */ d({
  id: 9001,
  name: "Evmos",
  nativeCurrency: {
    decimals: 18,
    name: "Evmos",
    symbol: "EVMOS"
  },
  rpcUrls: {
    default: { http: ["https://eth.bd.evmos.org:8545"] }
  },
  blockExplorers: {
    default: {
      name: "Evmos Block Explorer",
      url: "https://escan.live"
    }
  }
}), dH = /* @__PURE__ */ d({
  id: 9e3,
  name: "Evmos Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Evmos",
    symbol: "EVMOS"
  },
  rpcUrls: {
    default: { http: ["https://eth.bd.evmos.dev:8545"] }
  },
  blockExplorers: {
    default: {
      name: "Evmos Testnet Block Explorer",
      url: "https://evm.evmos.dev/"
    }
  }
}), pH = /* @__PURE__ */ d({
  id: 22052002,
  name: "Excelon Mainnet",
  network: "XLON",
  nativeCurrency: {
    decimals: 18,
    name: "Excelon",
    symbol: "xlon"
  },
  rpcUrls: {
    default: {
      http: ["https://edgewallet1.xlon.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Excelon explorer",
      url: "https://explorer.excelon.io"
    }
  }
}), fH = /* @__PURE__ */ d({
  id: 2,
  name: "Expanse Network",
  nativeCurrency: {
    decimals: 18,
    name: "EXP",
    symbol: "EXP"
  },
  rpcUrls: {
    default: { http: ["https://node.expanse.tech"] }
  },
  blockExplorers: {
    default: {
      name: "Expanse Explorer",
      url: "https://explorer.expanse.tech"
    }
  },
  testnet: !1
}), mH = /* @__PURE__ */ d({
  id: 7200,
  name: "exSat Network",
  nativeCurrency: {
    decimals: 18,
    name: "BTC",
    symbol: "BTC"
  },
  rpcUrls: {
    default: { http: ["https://evm.exsat.network"] }
  },
  blockExplorers: {
    default: {
      name: "exSat Explorer",
      url: "https://scan.exsat.network",
      apiUrl: "https://scan.exsat.network/api"
    }
  }
}), bH = /* @__PURE__ */ d({
  id: 839999,
  name: "exSat Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "BTC",
    symbol: "BTC"
  },
  rpcUrls: {
    default: { http: ["https://evm-tst3.exsat.network"] }
  },
  blockExplorers: {
    default: {
      name: "exSat Explorer",
      url: "https://scan-testnet.exsat.network",
      apiUrl: "https://scan-testnet.exsat.network/api"
    }
  }
}), yH = /* @__PURE__ */ d({
  id: 250,
  name: "Fantom",
  nativeCurrency: {
    decimals: 18,
    name: "Fantom",
    symbol: "FTM"
  },
  rpcUrls: {
    default: { http: ["https://250.rpc.thirdweb.com"] }
  },
  blockExplorers: {
    default: {
      name: "FTMScan",
      url: "https://ftmscan.com",
      apiUrl: "https://api.ftmscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 33001987
    }
  }
}), gH = /* @__PURE__ */ d({
  id: 64240,
  name: "Fantom Sonic Open Testnet",
  network: "fantom-sonic-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Fantom",
    symbol: "FTM"
  },
  rpcUrls: {
    default: { http: ["https://rpcapi.sonic.fantom.network"] }
  },
  blockExplorers: {
    default: {
      name: "Fantom Sonic Open Testnet Explorer",
      url: "https://public-sonic.fantom.network"
    }
  },
  testnet: !0
}), wH = /* @__PURE__ */ d({
  id: 4002,
  name: "Fantom Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Fantom",
    symbol: "FTM"
  },
  rpcUrls: {
    default: { http: ["https://rpc.testnet.fantom.network"] }
  },
  blockExplorers: {
    default: {
      name: "FTMScan",
      url: "https://testnet.ftmscan.com",
      apiUrl: "https://testnet.ftmscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 8328688
    }
  },
  testnet: !0
}), EH = /* @__PURE__ */ d({
  id: 12306,
  name: "Fibo Chain",
  nativeCurrency: {
    decimals: 18,
    name: "fibo",
    symbol: "FIBO"
  },
  rpcUrls: {
    default: { http: ["https://network.hzroc.art"] }
  },
  blockExplorers: {
    default: {
      name: "FiboScan",
      url: "https://scan.fibochain.org"
    }
  }
}), xH = /* @__PURE__ */ d({
  id: 314,
  name: "Filecoin Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "filecoin",
    symbol: "FIL"
  },
  rpcUrls: {
    default: { http: ["https://api.node.glif.io/rpc/v1"] }
  },
  blockExplorers: {
    default: {
      name: "Filfox",
      url: "https://filfox.info/en"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3328594
    }
  }
}), vH = /* @__PURE__ */ d({
  id: 314159,
  name: "Filecoin Calibration",
  nativeCurrency: {
    decimals: 18,
    name: "testnet filecoin",
    symbol: "tFIL"
  },
  rpcUrls: {
    default: { http: ["https://api.calibration.node.glif.io/rpc/v1"] }
  },
  blockExplorers: {
    default: {
      name: "Filscan",
      url: "https://calibration.filscan.io"
    }
  },
  testnet: !0
}), kH = /* @__PURE__ */ d({
  id: 3141,
  name: "Filecoin Hyperspace",
  nativeCurrency: {
    decimals: 18,
    name: "testnet filecoin",
    symbol: "tFIL"
  },
  rpcUrls: {
    default: { http: ["https://api.hyperspace.node.glif.io/rpc/v1"] }
  },
  blockExplorers: {
    default: {
      name: "Filfox",
      url: "https://hyperspace.filfox.info/en"
    }
  },
  testnet: !0
}), CH = /* @__PURE__ */ d({
  id: 253368190,
  name: "Flame",
  network: "flame",
  nativeCurrency: {
    symbol: "TIA",
    name: "TIA",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.flame.astria.org"],
      webSocket: ["wss://ws.flame.astria.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Flame Explorer",
      url: "https://explorer.flame.astria.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 6829148
    }
  }
}), SH = /* @__PURE__ */ d({
  id: 14,
  name: "Flare Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Flare",
    symbol: "FLR"
  },
  rpcUrls: {
    default: { http: ["https://flare-api.flare.network/ext/C/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Flare Explorer",
      url: "https://flare-explorer.flare.network",
      apiUrl: "https://flare-explorer.flare.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3002461
    }
  }
}), IH = /* @__PURE__ */ d({
  id: 114,
  name: "Flare Testnet Coston2",
  nativeCurrency: {
    decimals: 18,
    name: "Coston2 Flare",
    symbol: "C2FLR"
  },
  rpcUrls: {
    default: { http: ["https://coston2-api.flare.network/ext/C/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Coston2 Explorer",
      url: "https://coston2-explorer.flare.network",
      apiUrl: "https://coston2-explorer.flare.network/api"
    }
  },
  testnet: !0
}), AH = /* @__PURE__ */ d({
  id: 747,
  name: "Flow EVM Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Flow",
    symbol: "FLOW"
  },
  rpcUrls: {
    default: {
      http: ["https://mainnet.evm.nodes.onflow.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Mainnet Explorer",
      url: "https://evm.flowscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 6205
    }
  },
  blockTime: 800
}), _H = /* @__PURE__ */ d({
  id: 646,
  name: "Flow EVM Previewnet",
  nativeCurrency: {
    decimals: 18,
    name: "Flow",
    symbol: "FLOW"
  },
  rpcUrls: {
    default: {
      http: ["https://previewnet.evm.nodes.onflow.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Previewnet Explorer",
      url: "https://previewnet.flowdiver.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 6205
    }
  }
}), TH = /* @__PURE__ */ d({
  id: 545,
  name: "Flow EVM Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Flow",
    symbol: "FLOW"
  },
  rpcUrls: {
    default: {
      http: ["https://testnet.evm.nodes.onflow.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Flow Diver",
      url: "https://evm-testnet.flowscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 137518
    }
  },
  testnet: !0,
  blockTime: 800
}), UH = /* @__PURE__ */ d({
  id: 9999999,
  name: "Fluence",
  nativeCurrency: { name: "FLT", symbol: "FLT", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.mainnet.fluence.dev"],
      webSocket: ["wss://ws.mainnet.fluence.dev"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://blockscout.mainnet.fluence.dev",
      apiUrl: "https://blockscout.mainnet.fluence.dev/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 207583
    }
  }
}), $H = /* @__PURE__ */ d({
  id: 123420000220,
  name: "Fluence Stage",
  nativeCurrency: { name: "tFLT", symbol: "tFLT", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.stage.fluence.dev"],
      webSocket: ["wss://ws.stage.fluence.dev"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://blockscout.stage.fluence.dev",
      apiUrl: "https://blockscout.stage.fluence.dev/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 83227
    }
  },
  testnet: !0
}), BH = /* @__PURE__ */ d({
  id: 52164803,
  name: "Fluence Testnet",
  nativeCurrency: { name: "tFLT", symbol: "tFLT", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.fluence.dev"],
      webSocket: ["wss://ws.testnet.fluence.dev"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://blockscout.testnet.fluence.dev",
      apiUrl: "https://blockscout.testnet.fluence.dev/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 96424
    }
  },
  testnet: !0
}), DH = /* @__PURE__ */ d({
  id: 20993,
  name: "Fluent Testnet",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.dev.gblend.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Fluent Explorer",
      url: "https://blockscout.dev.gblend.xyz"
    }
  },
  testnet: !0
}), Yn = 1, OH = /* @__PURE__ */ d({
  id: 478,
  name: "Form Network",
  nativeCurrency: {
    decimals: 18,
    name: "Ethereum",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.form.network/http"],
      webSocket: ["wss://rpc.form.network/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Form Explorer",
      url: "https://explorer.form.network"
    }
  },
  contracts: {
    ...W.contracts,
    addressManager: {
      [Yn]: {
        address: "0x15c249E46A2F924C2dB3A1560CF86729bAD1f07B"
      }
    },
    l1CrossDomainMessenger: {
      [Yn]: {
        address: "0xF333158DCCad1dF6C3F0a3aEe8BC31fA94d9eD5c"
      }
    },
    l2OutputOracle: {
      [Yn]: {
        address: "0x4ccAAF69F41c5810cA875183648B577CaCf1F67E"
      }
    },
    portal: {
      [Yn]: {
        address: "0x4E259Ee5F4136408908160dD32295A5031Fa426F"
      }
    },
    l1StandardBridge: {
      [Yn]: {
        address: "0xdc20aA63D3DE59574E065957190D8f24e0F7B8Ba"
      }
    },
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  },
  sourceId: Yn
}), PH = /* @__PURE__ */ d({
  id: 984122,
  name: "Forma",
  network: "forma",
  nativeCurrency: {
    symbol: "TIA",
    name: "TIA",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.forma.art"],
      webSocket: ["wss://ws.forma.art"]
    }
  },
  blockExplorers: {
    default: {
      name: "Forma Explorer",
      url: "https://explorer.forma.art"
    }
  },
  contracts: {
    multicall3: {
      address: "0xd53C6FFB123F7349A32980F87faeD8FfDc9ef079",
      blockCreated: 252705
    }
  }
}), Qn = 11155111, RH = /* @__PURE__ */ d({
  id: 132902,
  name: "Form Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Ethereum",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia-rpc.form.network/http"],
      webSocket: ["wss://sepolia-rpc.form.network/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Form Testnet Explorer",
      url: "https://sepolia-explorer.form.network"
    }
  },
  contracts: {
    ...W.contracts,
    addressManager: {
      [Qn]: {
        address: "0xd5C38fa934f7fd7477D4800F4f38a1c5BFdF1373"
      }
    },
    l1CrossDomainMessenger: {
      [Qn]: {
        address: "0x37A68565c4BE9700b3E3Ec60cC4416cAC3052FAa"
      }
    },
    l2OutputOracle: {
      [Qn]: {
        address: "0x9eA2239E65a59EC9C7F1ED4C116dD58Da71Fc1e2"
      }
    },
    portal: {
      [Qn]: {
        address: "0x60377e3cE15dF4CCA24c4beF076b60314240b032"
      }
    },
    l1StandardBridge: {
      [Qn]: {
        address: "0xD4531f633942b2725896F47cD2aFd260b44Ab1F7"
      }
    },
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  },
  testnet: !0,
  sourceId: Qn
}), NH = /* @__PURE__ */ d({
  id: 80931,
  name: "Forta Chain",
  nativeCurrency: {
    symbol: "FORT",
    name: "FORT",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc-forta-chain-8gj1qndmfc.t.conduit.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Forta Explorer",
      url: "https://explorer.forta.org"
    }
  }
}), LH = /* @__PURE__ */ d({
  id: 31337,
  name: "Foundry",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["http://127.0.0.1:8545"],
      webSocket: ["ws://127.0.0.1:8545"]
    }
  }
}), cc = 1, MH = /* @__PURE__ */ d({
  ...W,
  id: 252,
  name: "Fraxtal",
  nativeCurrency: { name: "Frax", symbol: "FRAX", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.frax.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "fraxscan",
      url: "https://fraxscan.com",
      apiUrl: "https://api.fraxscan.com/api"
    }
  },
  contracts: {
    ...W.contracts,
    l2OutputOracle: {
      [cc]: {
        address: "0x66CC916Ed5C6C2FA97014f7D1cD141528Ae171e4"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11"
    },
    portal: {
      [cc]: {
        address: "0x36cb65c1967A0Fb0EEE11569C51C2f2aA1Ca6f6D",
        blockCreated: 19135323
      }
    },
    l1StandardBridge: {
      [cc]: {
        address: "0x34C0bD5877A5Ee7099D0f5688D65F4bB9158BDE2",
        blockCreated: 19135323
      }
    }
  },
  sourceId: cc
}), lc = 17e3, FH = /* @__PURE__ */ d({
  ...W,
  id: 2522,
  name: "Fraxtal Testnet",
  nativeCurrency: { name: "Frax", symbol: "FRAX", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.frax.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "fraxscan testnet",
      url: "https://holesky.fraxscan.com",
      apiUrl: "https://api-holesky.fraxscan.com/api"
    }
  },
  contracts: {
    ...W.contracts,
    l2OutputOracle: {
      [lc]: {
        address: "0x715EA64DA13F4d0831ece4Ad3E8c1aa013167F32"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11"
    },
    portal: {
      [lc]: {
        address: "0xB9c64BfA498d5b9a8398Ed6f46eb76d90dE5505d",
        blockCreated: 318416
      }
    },
    l1StandardBridge: {
      [lc]: {
        address: "0x0BaafC217162f64930909aD9f2B27125121d6332",
        blockCreated: 318416
      }
    }
  },
  sourceId: lc
}), zH = 1, jH = /* @__PURE__ */ d({
  ...W,
  id: 33979,
  name: "Funki",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-mainnet.funkichain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Funki Mainnet Explorer",
      url: "https://funkiscan.io"
    }
  },
  contracts: {
    ...W.contracts
  },
  sourceId: zH
}), HH = 11155111, qH = d({
  ...W,
  id: 3397901,
  network: "funkiSepolia",
  name: "Funki Sepolia Sandbox",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://funki-testnet.alt.technology"]
    }
  },
  blockExplorers: {
    default: {
      name: "Funki Sepolia Sandbox Explorer",
      url: "https://sepolia-sandbox.funkichain.com/"
    }
  },
  testnet: !0,
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1620204
    }
  },
  sourceId: HH
}), KH = /* @__PURE__ */ d({
  id: 122,
  name: "Fuse",
  nativeCurrency: { name: "Fuse", symbol: "FUSE", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.fuse.io"] }
  },
  blockExplorers: {
    default: {
      name: "Fuse Explorer",
      url: "https://explorer.fuse.io",
      apiUrl: "https://explorer.fuse.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 16146628
    }
  }
}), VH = /* @__PURE__ */ d({
  id: 123,
  name: "Fuse Sparknet",
  nativeCurrency: { name: "Spark", symbol: "SPARK", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.fusespark.io"] }
  },
  blockExplorers: {
    default: {
      name: "Sparkent Explorer",
      url: "https://explorer.fusespark.io",
      apiUrl: "https://explorer.fusespark.io/api"
    }
  }
}), GH = /* @__PURE__ */ d({
  id: 32659,
  name: "Fusion Mainnet",
  nativeCurrency: { name: "Fusion", symbol: "FSN", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.fusionnetwork.io"],
      webSocket: ["wss://mainnet.fusionnetwork.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "FSNscan",
      url: "https://fsnscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 10441605
    }
  },
  testnet: !1
}), WH = /* @__PURE__ */ d({
  id: 46688,
  name: "Fusion Testnet",
  nativeCurrency: { name: "Fusion", symbol: "FSN", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://testnet.fusionnetwork.io"],
      webSocket: ["wss://testnet.fusionnetwork.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "FSNscan",
      url: "https://testnet.fsnscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 10428309
    }
  },
  testnet: !0
}), uc = 17e3, ZH = d({
  ...W,
  name: "Garnet Testnet",
  testnet: !0,
  id: 17069,
  sourceId: uc,
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.garnetchain.com"],
      webSocket: ["wss://rpc.garnetchain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://explorer.garnetchain.com"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11"
    },
    portal: {
      [uc]: {
        address: "0x57ee40586fbE286AfC75E67cb69511A6D9aF5909",
        blockCreated: 1274684
      }
    },
    l2OutputOracle: {
      [uc]: {
        address: "0xCb8E7AC561b8EF04F2a15865e9fbc0766FEF569B",
        blockCreated: 1274684
      }
    },
    l1StandardBridge: {
      [uc]: {
        address: "0x09bcDd311FE398F80a78BE37E489f5D440DB95DE",
        blockCreated: 1274684
      }
    }
  }
}), JH = /* @__PURE__ */ d({
  id: 63157,
  name: "Geist Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Aavegotchi GHST Token",
    symbol: "GHST"
  },
  rpcUrls: {
    default: {
      http: ["https://geist-mainnet.g.alchemy.com/public"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://geist-mainnet.explorer.alchemy.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 660735
    }
  }
}), XH = /* @__PURE__ */ d({
  id: 16507,
  name: "Genesys Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "GSYS",
    symbol: "GSYS"
  },
  rpcUrls: {
    default: { http: ["https://rpc.genesys.network"] }
  },
  blockExplorers: {
    default: {
      name: "Genesys Explorer",
      url: "https://gchainexplorer.genesys.network"
    }
  },
  testnet: !1
}), hc = 11155111, YH = /* @__PURE__ */ d({
  ...W,
  id: 91342,
  network: "giwa-sepolia",
  name: "GIWA Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  blockTime: 1e3,
  rpcUrls: {
    default: {
      http: ["https://sepolia-rpc.giwa.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://sepolia-explorer.giwa.io",
      apiUrl: "https://sepolia-explorer.giwa.io/api"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 0
    },
    disputeGameFactory: {
      [hc]: {
        address: "0x37347caB2afaa49B776372279143D71ad1f354F6"
      }
    },
    portal: {
      [hc]: {
        address: "0x956962C34687A954e611A83619ABaA37Ce6bC78A"
      }
    },
    l1StandardBridge: {
      [hc]: {
        address: "0x77b2ffc0F57598cAe1DB76cb398059cF5d10A7E7"
      }
    }
  },
  testnet: !0,
  sourceId: hc
}), QH = /* @__PURE__ */ d({
  id: 251,
  name: "Glide L1 Protocol XP",
  nativeCurrency: { name: "GLXP", symbol: "GLXP", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-api.glideprotocol.xyz/l1-rpc"],
      webSocket: ["wss://rpc-api.glideprotocol.xyz/l1-rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Glide Protocol Explore",
      url: "https://blockchain-explorer.glideprotocol.xyz"
    }
  },
  testnet: !1
}), eq = /* @__PURE__ */ d({
  id: 253,
  name: "Glide L2 Protocol XP",
  nativeCurrency: { name: "GLXP", symbol: "GLXP", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-api.glideprotocol.xyz/l2-rpc"],
      webSocket: ["wss://rpc-api.glideprotocol.xyz/l2-rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Glide Protocol Explore",
      url: "https://blockchain-explorer.glideprotocol.xyz"
    }
  },
  testnet: !1
}), tq = /* @__PURE__ */ d({
  id: 100,
  name: "Gnosis",
  nativeCurrency: {
    decimals: 18,
    name: "xDAI",
    symbol: "XDAI"
  },
  blockTime: 5e3,
  rpcUrls: {
    default: {
      http: ["https://rpc.gnosischain.com"],
      webSocket: ["wss://rpc.gnosischain.com/wss"]
    }
  },
  blockExplorers: {
    default: {
      name: "Gnosisscan",
      url: "https://gnosisscan.io",
      apiUrl: "https://api.gnosisscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 21022491
    }
  }
}), rq = /* @__PURE__ */ d({
  id: 10200,
  name: "Gnosis Chiado",
  nativeCurrency: {
    decimals: 18,
    name: "Gnosis",
    symbol: "xDAI"
  },
  blockTime: 5e3,
  rpcUrls: {
    default: {
      http: ["https://rpc.chiadochain.net"],
      webSocket: ["wss://rpc.chiadochain.net/wss"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://blockscout.chiadochain.net",
      apiUrl: "https://blockscout.chiadochain.net/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 4967313
    }
  },
  testnet: !0
}), sq = /* @__PURE__ */ d({
  id: 2345,
  name: "GOAT",
  nativeCurrency: {
    decimals: 18,
    name: "Bitcoin",
    symbol: "BTC"
  },
  rpcUrls: {
    default: { http: ["https://rpc.goat.network"] }
  },
  blockExplorers: {
    default: {
      name: "Goat Explorer",
      url: "https://explorer.goat.network"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 0
    }
  }
}), nq = /* @__PURE__ */ d({
  id: 1663,
  name: "Horizen Gobi Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Test ZEN",
    symbol: "tZEN"
  },
  rpcUrls: {
    default: { http: ["https://gobi-testnet.horizenlabs.io/ethv1"] }
  },
  blockExplorers: {
    default: {
      name: "Gobi Explorer",
      url: "https://gobi-explorer.horizen.io"
    }
  },
  contracts: {},
  testnet: !0
}), iq = /* @__PURE__ */ d({
  id: 60,
  name: "GoChain",
  nativeCurrency: {
    decimals: 18,
    name: "GO",
    symbol: "GO"
  },
  rpcUrls: {
    default: { http: ["https://rpc.gochain.io"] }
  },
  blockExplorers: {
    default: {
      name: "GoChain Explorer",
      url: "https://explorer.gochain.io"
    }
  },
  testnet: !1
}), oq = /* @__PURE__ */ d({
  id: 71402,
  name: "Godwoken Mainnet",
  nativeCurrency: { decimals: 18, name: "pCKB", symbol: "pCKB" },
  rpcUrls: {
    default: {
      http: ["https://v1.mainnet.godwoken.io/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "GW Scan",
      url: "https://v1.gwscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 15034
    }
  },
  testnet: !1
}), aq = /* @__PURE__ */ d({
  id: 5,
  name: "Goerli",
  nativeCurrency: { name: "Goerli Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://5.rpc.thirdweb.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://goerli.etherscan.io",
      apiUrl: "https://api-goerli.etherscan.io/api"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0xfc4AC75C46C914aF5892d6d3eFFcebD7917293F1",
      blockCreated: 10339206
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 6507670
    }
  },
  testnet: !0
}), cq = /* @__PURE__ */ d({
  id: 440017,
  name: "Graphite Network",
  nativeCurrency: { name: "Graphite", symbol: "@G", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://anon-entrypoint-1.atgraphite.com"],
      webSocket: ["wss://ws-anon-entrypoint-1.atgraphite.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Graphite Spectre",
      url: "https://main.atgraphite.com",
      apiUrl: "https://api.main.atgraphite.com/api"
    }
  },
  testnet: !1
}), lq = /* @__PURE__ */ d({
  id: 54170,
  name: "Graphite Network Testnet",
  nativeCurrency: { name: "Graphite", symbol: "@G", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://anon-entrypoint-test-1.atgraphite.com"],
      webSocket: ["wss://ws-anon-entrypoint-test-1.atgraphite.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Graphite Testnet Spectre",
      url: "https://test.atgraphite.com",
      apiUrl: "https://api.test.atgraphite.com/api"
    }
  },
  testnet: !0
}), uq = /* @__PURE__ */ d({
  id: 1625,
  name: "Gravity Alpha Mainnet",
  nativeCurrency: { name: "G", symbol: "G", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.gravity.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Gravity Explorer",
      url: "https://explorer.gravity.xyz",
      apiUrl: "https://explorer.gravity.xyz/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xf8ac4BEB2F75d2cFFb588c63251347fdD629B92c",
      blockCreated: 16851
    }
  }
}), hq = /* @__PURE__ */ d({
  id: 43419,
  name: "Gunz Mainnet",
  nativeCurrency: { name: "GUN", symbol: "GUN", decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        "https://rpc.gunzchain.io/ext/bc/2M47TxWHGnhNtq6pM5zPXdATBtuqubxn5EPFgFmEawCQr9WFML/rpc"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Gunz Explorer",
      url: "https://gunzscan.io/"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 70502
    }
  }
}), dq = /* @__PURE__ */ d({
  id: 260,
  name: "Guru Network Mainnet",
  nativeCurrency: {
    name: "GURU Token",
    symbol: "GURU",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: [
        "https://rpc-main.gurunetwork.ai",
        "https://rpc.gurunetwork.ai/archive/260"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Guruscan",
      url: "https://scan.gurunetwork.ai"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 271691
    }
  },
  testnet: !1
}), pq = /* @__PURE__ */ d({
  id: 261,
  name: "Guru Network Testnet",
  nativeCurrency: {
    name: "tGURU Token",
    symbol: "tGURU",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: [
        "https://rpc-test.gurunetwork.ai",
        "https://rpc.gurunetwork.ai/archive/261"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Guruscan",
      url: "https://sepolia.gurunetwork.ai"
    }
  },
  testnet: !0
}), fq = /* @__PURE__ */ d({
  id: 5112,
  name: "Ham",
  nativeCurrency: {
    decimals: 18,
    name: "Ham",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.ham.fun"],
      webSocket: ["wss://rpc.ham.fun"]
    }
  },
  blockExplorers: {
    default: {
      name: "Ham Chain Explorer",
      url: "https://explorer.ham.fun",
      apiUrl: "https://explorer.ham.fun/api/v2"
    }
  }
}), mq = /* @__PURE__ */ d({
  id: 216,
  name: "Happychain Testnet",
  nativeCurrency: {
    symbol: "HAPPY",
    name: "HAPPY",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.happy.tech/http"],
      webSocket: ["wss://rpc.testnet.happy.tech/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Happy Chain Testnet Explorer",
      url: "https://explorer.testnet.happy.tech"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1
    }
  },
  testnet: !0
}), bq = /* @__PURE__ */ d({
  id: 11235,
  name: "HAQQ Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Islamic Coin",
    symbol: "ISLM"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.eth.haqq.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "HAQQ Explorer",
      url: "https://explorer.haqq.network",
      apiUrl: "https://explorer.haqq.network/api"
    }
  }
}), yq = /* @__PURE__ */ d({
  id: 54211,
  name: "HAQQ Testedge 2",
  nativeCurrency: {
    decimals: 18,
    name: "Islamic Coin",
    symbol: "ISLMT"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.eth.testedge2.haqq.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "HAQQ Explorer",
      url: "https://explorer.testedge2.haqq.network",
      apiUrl: "https://explorer.testedge2.haqq.network/api"
    }
  }
}), gq = /* @__PURE__ */ d({
  id: 31337,
  name: "Hardhat",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["http://127.0.0.1:8545"] }
  }
}), wq = /* @__PURE__ */ d({
  id: 16666e5,
  name: "Harmony One",
  nativeCurrency: {
    name: "Harmony",
    symbol: "ONE",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://1666600000.rpc.thirdweb.com"] }
  },
  blockExplorers: {
    default: {
      name: "Harmony Explorer",
      url: "https://explorer.harmony.one"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 24185753
    }
  }
}), Eq = /* @__PURE__ */ d({
  id: 177,
  name: "HashKey Chain",
  nativeCurrency: {
    decimals: 18,
    name: "HashKey EcoPoints",
    symbol: "HSK"
  },
  rpcUrls: {
    default: {
      http: ["https://mainnet.hsk.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "HashKey Chain Explorer",
      url: "https://hashkey.blockscout.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 0
    }
  }
}), xq = /* @__PURE__ */ d({
  id: 133,
  name: "HashKey Chain Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "HashKey EcoPoints",
    symbol: "HSK"
  },
  rpcUrls: {
    default: {
      http: ["https://hashkeychain-testnet.alt.technology"]
    }
  },
  blockExplorers: {
    default: {
      name: "HashKey Chain Explorer",
      url: "https://hashkeychain-testnet-explorer.alt.technology"
    }
  },
  testnet: !0
}), vq = /* @__PURE__ */ d({
  id: 1523903251,
  name: "Haust Network Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "HAUST",
    symbol: "HAUST"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc-testnet.haust.app"]
    }
  },
  blockExplorers: {
    default: {
      name: "Haust Network Testnet Explorer",
      url: "https://explorer-testnet.haust.app"
    }
  },
  testnet: !0
}), kq = /* @__PURE__ */ d({
  id: 295,
  name: "Hedera Mainnet",
  network: "hedera-mainnet",
  nativeCurrency: {
    symbol: "HBAR",
    name: "HBAR",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://mainnet.hashio.io/api"]
    }
  },
  blockExplorers: {
    default: {
      name: "Hashscan",
      url: "https://hashscan.io/mainnet"
    }
  },
  testnet: !1
}), Cq = /* @__PURE__ */ d({
  id: 297,
  name: "Hedera Previewnet",
  network: "hedera-previewnet",
  nativeCurrency: {
    symbol: "HBAR",
    name: "HBAR",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://previewnet.hashio.io/api"]
    }
  },
  blockExplorers: {
    default: {
      name: "Hashscan",
      url: "https://hashscan.io/previewnet"
    }
  },
  testnet: !0
}), Sq = /* @__PURE__ */ d({
  id: 296,
  name: "Hedera Testnet",
  network: "hedera-testnet",
  nativeCurrency: {
    symbol: "HBAR",
    name: "HBAR",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://testnet.hashio.io/api"]
    }
  },
  blockExplorers: {
    default: {
      name: "Hashscan",
      url: "https://hashscan.io/testnet"
    }
  },
  testnet: !0
}), Iq = /* @__PURE__ */ d({
  id: 8668,
  name: "Hela Mainnet",
  nativeCurrency: {
    name: "HLUSD",
    symbol: "HLUSD",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://mainnet-rpc.helachain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Hela explorer",
      url: "https://mainnet-blockexplorer.helachain.com"
    }
  },
  testnet: !1
}), Aq = /* @__PURE__ */ d({
  id: 43111,
  name: "Hemi",
  network: "Hemi",
  blockTime: 12e3,
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.hemi.network/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "blockscout",
      url: "https://explorer.hemi.xyz"
    }
  },
  testnet: !1
}), _q = /* @__PURE__ */ d({
  id: 743111,
  name: "Hemi Sepolia",
  network: "Hemi Sepolia",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://testnet.rpc.hemi.network/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Hemi Sepolia explorer",
      url: "https://testnet.explorer.hemi.xyz"
    }
  },
  testnet: !0
}), Tq = /* @__PURE__ */ d({
  id: 17e3,
  name: "Holesky",
  nativeCurrency: { name: "Holesky Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://ethereum-holesky-rpc.publicnode.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://holesky.etherscan.io",
      apiUrl: "https://api-holesky.etherscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 77
    },
    ensUniversalResolver: {
      address: "0xeeeeeeee14d718c2b47d9923deab1335e144eeee",
      blockCreated: 4295055
    }
  },
  testnet: !0
}), Uq = /* @__PURE__ */ d({
  id: 560048,
  name: "Hoodi",
  nativeCurrency: { name: "Hoodi Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.hoodi.ethpandaops.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://hoodi.etherscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 2589
    }
  },
  testnet: !0
}), $q = /* @__PURE__ */ d({
  id: 269,
  name: "High Performance Blockchain",
  nativeCurrency: { name: "HPB", symbol: "HPB", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://hpbnode.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "hpbScan",
      url: "https://hscan.org"
    }
  },
  testnet: !1
}), Bq = 42161, Dq = /* @__PURE__ */ d({
  id: 12323,
  name: "Huddle01 dRTC Chain",
  nativeCurrency: {
    name: "Ethereum",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://huddle01.calderachain.xyz/http"],
      webSocket: ["wss://huddle01.calderachain.xyz/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Huddle01 Caldera Explorer",
      url: "https://huddle01.calderaexplorer.xyz",
      apiUrl: "https://huddle01.calderaexplorer.xyz/api"
    }
  },
  sourceId: Bq
}), Oq = 421614, Pq = /* @__PURE__ */ d({
  id: 2524852,
  name: "Huddle01 dRTC Chain Testnet",
  nativeCurrency: {
    name: "Ethereum",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://huddle-testnet.rpc.caldera.xyz/http"],
      webSocket: ["wss://huddle-testnet.rpc.caldera.xyz/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Huddle01 Caldera Explorer",
      url: "https://huddle-testnet.explorer.caldera.xyz",
      apiUrl: "https://huddle-testnet.explorer.caldera.xyz/api"
    }
  },
  sourceId: Oq
}), Rq = /* @__PURE__ */ d({
  id: 6985385,
  name: "Humanity",
  nativeCurrency: {
    name: "H",
    symbol: "H",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://humanity-mainnet.g.alchemy.com/public"]
    }
  },
  blockExplorers: {
    default: {
      name: "Humanity Mainnet Explorer",
      url: "https://humanity-mainnet.explorer.alchemy.com",
      apiUrl: "https://humanity-mainnet.explorer.alchemy.com/api"
    }
  },
  testnet: !1
}), Nq = /* @__PURE__ */ d({
  id: 7080969,
  name: "Humanity Testnet",
  nativeCurrency: {
    name: "tHP",
    symbol: "tHP",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.humanity.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Humanity Testnet Explorer",
      url: "https://humanity-testnet.explorer.alchemy.com",
      apiUrl: "https://humanity-testnet.explorer.alchemy.com/api"
    }
  },
  testnet: !0
}), Lq = /* @__PURE__ */ d({
  id: 5234,
  name: "Humanode",
  nativeCurrency: { name: "HMND", symbol: "HMND", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://explorer-rpc-http.mainnet.stages.humanode.io"],
      webSocket: ["wss://explorer-rpc-ws.mainnet.stages.humanode.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Subscan",
      url: "https://humanode.subscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 4413097
    }
  }
}), Mq = /* @__PURE__ */ d({
  id: 14853,
  name: "Humanode Testnet 5",
  nativeCurrency: { name: "HMND", symbol: "HMND", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://explorer-rpc-http.testnet5.stages.humanode.io"],
      webSocket: ["wss://explorer-rpc-ws.testnet5.stages.humanode.io"]
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11"
    }
  }
}), Fq = /* @__PURE__ */ d({
  id: 2911,
  name: "HYCHAIN",
  nativeCurrency: { name: "HYTOPIA", symbol: "TOPIA", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.hychain.com/http"] }
  },
  blockExplorers: {
    default: {
      name: "HYCHAIN Explorer",
      url: "https://explorer.hychain.com"
    }
  },
  testnet: !1
}), zq = /* @__PURE__ */ d({
  id: 29112,
  name: "HYCHAIN Testnet",
  nativeCurrency: { name: "HYTOPIA", symbol: "TOPIA", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.hychain.com/http"] }
  },
  blockExplorers: {
    default: {
      name: "HYCHAIN Explorer",
      url: "https://testnet-rpc.hychain.com/http"
    }
  },
  testnet: !0
}), jq = /* @__PURE__ */ d({
  id: 998,
  name: "Hyperliquid EVM Testnet",
  nativeCurrency: { name: "HYPE", symbol: "HYPE", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.hyperliquid-testnet.xyz/evm"]
    }
  },
  testnet: !0
}), Hq = /* @__PURE__ */ d({
  id: 73115,
  name: "ICB Network",
  nativeCurrency: {
    decimals: 18,
    name: "ICB Native Token",
    symbol: "ICBX"
  },
  rpcUrls: {
    default: { http: ["https://rpc1-mainnet.icbnetwork.info"] }
  },
  blockExplorers: {
    default: {
      name: "ICB Explorer",
      url: "https://icbscan.io",
      apiUrl: "https://icbscan.io/api"
    }
  },
  testnet: !1
}), qq = /* @__PURE__ */ d({
  id: 74,
  name: "IDChain Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "EIDI",
    symbol: "EIDI"
  },
  rpcUrls: {
    default: {
      http: ["https://idchain.one/rpc"],
      webSocket: ["wss://idchain.one/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "IDChain Explorer",
      url: "https://explorer.idchain.one"
    }
  },
  testnet: !1
}), Kq = /* @__PURE__ */ d({
  id: 13371,
  name: "Immutable zkEVM",
  nativeCurrency: {
    decimals: 18,
    name: "Immutable Coin",
    symbol: "IMX"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.immutable.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Immutable Explorer",
      url: "https://explorer.immutable.com",
      apiUrl: "https://explorer.immutable.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0x236bdA4589e44e6850f5aC6a74BfCa398a86c6c0",
      blockCreated: 4335972
    }
  }
}), Vq = /* @__PURE__ */ d({
  id: 13473,
  name: "Immutable zkEVM Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Immutable Coin",
    symbol: "IMX"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.immutable.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Immutable Testnet Explorer",
      url: "https://explorer.testnet.immutable.com/"
    }
  },
  contracts: {
    multicall3: {
      address: "0x2CC787Ed364600B0222361C4188308Fa8E68bA60",
      blockCreated: 5977391
    }
  },
  testnet: !0
}), Gq = /* @__PURE__ */ d({
  id: 2525,
  name: "inEVM Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Injective",
    symbol: "INJ"
  },
  rpcUrls: {
    default: { http: ["https://mainnet.rpc.inevm.com/http"] }
  },
  blockExplorers: {
    default: {
      name: "inEVM Explorer",
      url: "https://inevm.calderaexplorer.xyz",
      apiUrl: "https://inevm.calderaexplorer.xyz/api/v2"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 118606
    }
  }
}), Wq = /* @__PURE__ */ d({
  id: 7233,
  name: "InitVerse Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "InitVerse",
    symbol: "INI"
  },
  rpcUrls: {
    default: { http: ["https://rpc-mainnet.inichain.com"] }
  },
  blockExplorers: {
    default: {
      name: "InitVerseScan",
      url: "https://www.iniscan.com",
      apiUrl: "https://explorer-api.inichain.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0x83466BE48A067115FFF91f7b892Ed1726d032e47",
      blockCreated: 2318
    }
  }
}), Zq = /* @__PURE__ */ d({
  id: 7234,
  name: "InitVerse Genesis Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "InitVerse",
    symbol: "INI"
  },
  rpcUrls: {
    default: { http: ["https://rpc-testnet.inichain.com"] }
  },
  blockExplorers: {
    default: {
      name: "InitVerseGenesisScan",
      url: "https://genesis-testnet.iniscan.com",
      apiUrl: "https://explorer-testnet-api.inichain.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0x0cF32CBDd6c437331EA4f85ed2d881A5379B5a6F",
      blockCreated: 16361
    }
  },
  testnet: !0
}), dc = 1, Jq = /* @__PURE__ */ d({
  ...W,
  id: 57073,
  name: "Ink",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        "https://rpc-gel.inkonchain.com",
        "https://rpc-qnd.inkonchain.com"
      ],
      webSocket: [
        "wss://rpc-gel.inkonchain.com",
        "wss://rpc-qnd.inkonchain.com"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://explorer.inkonchain.com",
      apiUrl: "https://explorer.inkonchain.com/api/v2"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 0
    },
    ...W.contracts,
    disputeGameFactory: {
      [dc]: {
        address: "0x10d7b35078d3baabb96dd45a9143b94be65b12cd"
      }
    },
    portal: {
      [dc]: {
        address: "0x5d66c1782664115999c47c9fa5cd031f495d3e4f"
      }
    },
    l1StandardBridge: {
      [dc]: {
        address: "0x88ff1e5b602916615391f55854588efcbb7663f0"
      }
    }
  },
  testnet: !1,
  sourceId: dc
}), pc = 11155111, Xq = /* @__PURE__ */ d({
  ...W,
  id: 763373,
  name: "Ink Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-gel-sepolia.inkonchain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://explorer-sepolia.inkonchain.com/",
      apiUrl: "https://explorer-sepolia.inkonchain.com/api/v2"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 0
    },
    disputeGameFactory: {
      [pc]: {
        address: "0x860e626c700af381133d9f4af31412a2d1db3d5d"
      }
    },
    portal: {
      [pc]: {
        address: "0x5c1d29c6c9c8b0800692acc95d700bcb4966a1d7"
      }
    },
    l1StandardBridge: {
      [pc]: {
        address: "0x33f60714bbd74d62b66d79213c348614de51901c"
      }
    }
  },
  testnet: !0,
  sourceId: pc
}), Yq = /* @__PURE__ */ d({
  id: 8822,
  name: "IOTA EVM",
  network: "iotaevm",
  nativeCurrency: {
    decimals: 18,
    name: "IOTA",
    symbol: "IOTA"
  },
  rpcUrls: {
    default: {
      http: ["https://json-rpc.evm.iotaledger.net"],
      webSocket: ["wss://ws.json-rpc.evm.iotaledger.net"]
    }
  },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "https://explorer.evm.iota.org",
      apiUrl: "https://explorer.evm.iota.org/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 25022
    }
  }
}), Qq = /* @__PURE__ */ d({
  id: 1075,
  name: "IOTA EVM Testnet",
  network: "iotaevm-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "IOTA",
    symbol: "IOTA"
  },
  rpcUrls: {
    default: {
      http: ["https://json-rpc.evm.testnet.iotaledger.net"],
      webSocket: ["wss://ws.json-rpc.evm.testnet.iotaledger.net"]
    }
  },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "https://explorer.evm.testnet.iotaledger.net",
      apiUrl: "https://explorer.evm.testnet.iotaledger.net/api"
    }
  },
  testnet: !0
}), eK = /* @__PURE__ */ d({
  id: 4689,
  name: "IoTeX",
  nativeCurrency: {
    decimals: 18,
    name: "IoTeX",
    symbol: "IOTX"
  },
  rpcUrls: {
    default: {
      http: ["https://babel-api.mainnet.iotex.io"],
      webSocket: ["wss://babel-api.mainnet.iotex.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "IoTeXScan",
      url: "https://iotexscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 22163670
    }
  }
}), tK = /* @__PURE__ */ d({
  id: 4690,
  name: "IoTeX Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "IoTeX",
    symbol: "IOTX"
  },
  rpcUrls: {
    default: {
      http: ["https://babel-api.testnet.iotex.io"],
      webSocket: ["wss://babel-api.testnet.iotex.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "IoTeXScan",
      url: "https://testnet.iotexscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xb5cecD6894c6f473Ec726A176f1512399A2e355d",
      blockCreated: 24347592
    }
  },
  testnet: !0
}), rK = /* @__PURE__ */ d({
  id: 8017,
  name: "iSunCoin Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "ISC",
    symbol: "ISC"
  },
  rpcUrls: {
    default: {
      http: ["https://mainnet.isuncoin.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "iSunCoin Explorer",
      url: "https://baifa.io/app/chains/8017"
    }
  }
}), sK = /* @__PURE__ */ d({
  id: 8899,
  name: "JB Chain",
  network: "jbc",
  nativeCurrency: { name: "JBC", symbol: "JBC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-l1.jibchain.net"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://exp-l1.jibchain.net",
      apiUrl: "https://exp-l1.jibchain.net/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xc0C8C486D1466C57Efe13C2bf000d4c56F47CBdC",
      blockCreated: 2299048
    }
  },
  testnet: !1
}), nK = /* @__PURE__ */ d({
  id: 88991,
  name: "Jibchain Testnet",
  nativeCurrency: { name: "tJBC", symbol: "tJBC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.jibchain.net"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://exp.testnet.jibchain.net",
      apiUrl: "https://exp.testnet.jibchain.net/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xa1a858ad9041B4741e620355a3F96B3c78e70ecE",
      blockCreated: 32848
    }
  },
  testnet: !0
}), iK = /* @__PURE__ */ d({
  id: 81,
  name: "Japan Open Chain Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Japan Open Chain Token",
    symbol: "JOC"
  },
  rpcUrls: {
    default: {
      http: [
        "https://rpc-1.japanopenchain.org:8545",
        "https://rpc-2.japanopenchain.org:8545",
        "https://rpc-3.japanopenchain.org"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Block Explorer",
      url: "https://explorer.japanopenchain.org"
    }
  },
  testnet: !1
}), oK = /* @__PURE__ */ d({
  id: 10081,
  name: "Japan Open Chain Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Japan Open Chain Testnet Token",
    symbol: "JOCT"
  },
  rpcUrls: {
    default: {
      http: [
        "https://rpc-1.testnet.japanopenchain.org:8545",
        "https://rpc-2.testnet.japanopenchain.org:8545",
        "https://rpc-3.testnet.japanopenchain.org"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Testnet Block Explorer",
      url: "https://explorer.testnet.japanopenchain.org"
    }
  },
  testnet: !0
}), aK = /* @__PURE__ */ d({
  id: 5734951,
  name: "Jovay Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://api.zan.top/public/jovay-mainnet"]
    }
  },
  blockExplorers: {
    default: {
      name: "Jovay Explorer",
      url: "https://explorer.jovay.io"
    }
  },
  testnet: !1
}), cK = /* @__PURE__ */ d({
  id: 2019775,
  name: "Jovay Sepolia Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://api.zan.top/public/jovay-testnet"]
    }
  },
  blockExplorers: {
    default: {
      name: "Jovay Testnet Explorer",
      url: "https://sepolia-explorer.jovay.io/l2"
    }
  },
  testnet: !0
}), lK = /* @__PURE__ */ d({
  id: 45003,
  name: "Juneo JUNE-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "JUNE-Chain",
    symbol: "JUNE"
  },
  rpcUrls: {
    default: { http: ["https://rpc.juneo-mainnet.network/ext/bc/JUNE/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://juneoscan.io/chain/2",
      apiUrl: "https://juneoscan.io/chain/2/api"
    }
  }
}), uK = /* @__PURE__ */ d({
  id: 45013,
  name: "Juneo BCH1-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Juneo BCH1-Chain",
    symbol: "BCH1"
  },
  rpcUrls: {
    default: { http: ["https://rpc.juneo-mainnet.network/ext/bc/BCH1/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://juneoscan.io/chain/12",
      apiUrl: "https://juneoscan.io/chain/12/api"
    }
  }
}), hK = /* @__PURE__ */ d({
  id: 45004,
  name: "Juneo DAI1-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Juneo DAI1-Chain",
    symbol: "DAI1"
  },
  rpcUrls: {
    default: { http: ["https://rpc.juneo-mainnet.network/ext/bc/DAI1/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://juneoscan.io/chain/5",
      apiUrl: "https://juneoscan.io/chain/5/api"
    }
  }
}), dK = /* @__PURE__ */ d({
  id: 45010,
  name: "Juneo DOGE1-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Juneo DOGE1-Chain",
    symbol: "DOGE1"
  },
  rpcUrls: {
    default: { http: ["https://rpc.juneo-mainnet.network/ext/bc/DOGE1/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://juneoscan.io/chain/10",
      apiUrl: "https://juneoscan.io/chain/10/api"
    }
  }
}), pK = /* @__PURE__ */ d({
  id: 45011,
  name: "Juneo EUR1-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Juneo EUR1-Chain",
    symbol: "EUR1"
  },
  rpcUrls: {
    default: { http: ["https://rpc.juneo-mainnet.network/ext/bc/EUR1/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://juneoscan.io/chain/6",
      apiUrl: "https://juneoscan.io/chain/6/api"
    }
  }
}), fK = /* @__PURE__ */ d({
  id: 45008,
  name: "Juneo GLD1-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Juneo GLD1-Chain",
    symbol: "GLD1"
  },
  rpcUrls: {
    default: { http: ["https://rpc.juneo-mainnet.network/ext/bc/GLD1/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://juneoscan.io/chain/8",
      apiUrl: "https://juneoscan.io/chain/8/api"
    }
  }
}), mK = /* @__PURE__ */ d({
  id: 45014,
  name: "Juneo LINK1-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Juneo LINK1-Chain",
    symbol: "LINK1"
  },
  rpcUrls: {
    default: { http: ["https://rpc.juneo-mainnet.network/ext/bc/LINK1/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://juneoscan.io/chain/13",
      apiUrl: "https://juneoscan.io/chain/13/api"
    }
  }
}), bK = /* @__PURE__ */ d({
  id: 45009,
  name: "Juneo LTC1-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Juneo LTC1-Chain",
    symbol: "LTC1"
  },
  rpcUrls: {
    default: { http: ["https://rpc.juneo-mainnet.network/ext/bc/LTC1/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://juneoscan.io/chain/11",
      apiUrl: "https://juneoscan.io/chain/11/api"
    }
  }
}), yK = /* @__PURE__ */ d({
  id: 45007,
  name: "Juneo mBTC1-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Juneo mBTC1-Chain",
    symbol: "mBTC1"
  },
  rpcUrls: {
    default: { http: ["https://rpc.juneo-mainnet.network/ext/bc/mBTC1/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://juneoscan.io/chain/9",
      apiUrl: "https://juneoscan.io/chain/9/api"
    }
  }
}), gK = /* @__PURE__ */ d({
  id: 45012,
  name: "Juneo SGD1-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Juneo SGD1-Chain",
    symbol: "SGD1"
  },
  rpcUrls: {
    default: { http: ["https://rpc.juneo-mainnet.network/ext/bc/SGD1/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://juneoscan.io/chain/7",
      apiUrl: "https://juneoscan.io/chain/7/api"
    }
  }
}), wK = /* @__PURE__ */ d({
  id: 101003,
  name: "Socotra JUNE-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Socotra JUNE-Chain",
    symbol: "JUNE"
  },
  rpcUrls: {
    default: { http: ["https://rpc.socotra-testnet.network/ext/bc/JUNE/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://socotra.juneoscan.io/chain/2",
      apiUrl: "https://socotra.juneoscan.io/chain/2/api"
    }
  },
  testnet: !0
}), EK = /* @__PURE__ */ d({
  id: 45006,
  name: "Juneo USD1-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Juneo USD1-Chain",
    symbol: "USD1"
  },
  rpcUrls: {
    default: { http: ["https://rpc.juneo-mainnet.network/ext/bc/USD1/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://juneoscan.io/chain/4",
      apiUrl: "https://juneoscan.io/chain/4/api"
    }
  }
}), xK = /* @__PURE__ */ d({
  id: 45005,
  name: "Juneo USDT1-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Juneo USDT1-Chain",
    symbol: "USDT1"
  },
  rpcUrls: {
    default: { http: ["https://rpc.juneo-mainnet.network/ext/bc/USDT1/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://juneoscan.io/chain/3",
      apiUrl: "https://juneoscan.io/chain/3/api"
    }
  }
}), vK = /* @__PURE__ */ d({
  id: 8217,
  name: "Kaia",
  nativeCurrency: {
    decimals: 18,
    name: "Kaia",
    symbol: "KAIA"
  },
  rpcUrls: {
    default: { http: ["https://public-en.node.kaia.io"] }
  },
  blockExplorers: {
    default: {
      name: "KaiaScan",
      url: "https://kaiascan.io",
      apiUrl: "https://api-cypress.klaytnscope.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 96002415
    }
  }
}), kK = /* @__PURE__ */ d({
  id: 1001,
  name: "Kairos Testnet",
  network: "kairos",
  nativeCurrency: {
    decimals: 18,
    name: "Kairos KAIA",
    symbol: "KAIA"
  },
  rpcUrls: {
    default: { http: ["https://public-en-kairos.node.kaia.io"] }
  },
  blockExplorers: {
    default: {
      name: "KaiaScan",
      url: "https://kairos.kaiascan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 123390593
    }
  },
  testnet: !0
}), CK = /* @__PURE__ */ d({
  id: 1802203764,
  name: "Kakarot Sepolia",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia-rpc.kakarot.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Kakarot Scan",
      url: "https://sepolia.kakarotscan.org"
    }
  },
  testnet: !0
}), SK = /* @__PURE__ */ d({
  id: 920637907288165,
  name: "Kakarot Starknet Sepolia",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia-rpc.kakarot.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Kakarot Scan",
      url: "https://sepolia.kakarotscan.org"
    }
  },
  testnet: !0
}), IK = /* @__PURE__ */ d({
  id: 24,
  name: "KardiaChain Mainnet",
  nativeCurrency: { name: "KAI", symbol: "KAI", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.kardiachain.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "KardiaChain Explorer",
      url: "https://explorer.kardiachain.io"
    }
  },
  testnet: !1
}), AK = /* @__PURE__ */ d({
  id: 686,
  name: "Karura",
  network: "karura",
  nativeCurrency: {
    name: "Karura",
    symbol: "KAR",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://eth-rpc-karura.aca-api.network"],
      webSocket: ["wss://eth-rpc-karura.aca-api.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Karura Blockscout",
      url: "https://blockscout.karura.network",
      apiUrl: "https://blockscout.karura.network/api"
    }
  },
  testnet: !1
}), _K = /* @__PURE__ */ d({
  id: 747474,
  name: "Katana",
  network: "katana",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.katana.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "katana explorer",
      url: "https://explorer.katanarpc.com"
    }
  },
  testnet: !1
}), TK = /* @__PURE__ */ d({
  id: 2222,
  name: "Kava EVM",
  network: "kava-mainnet",
  nativeCurrency: {
    name: "Kava",
    symbol: "KAVA",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://evm.kava.io"] }
  },
  blockExplorers: {
    default: {
      name: "Kava EVM Explorer",
      url: "https://kavascan.com",
      apiUrl: "https://kavascan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 3661165
    }
  },
  testnet: !1
}), UK = /* @__PURE__ */ d({
  id: 2221,
  name: "Kava EVM Testnet",
  network: "kava-testnet",
  nativeCurrency: {
    name: "Kava",
    symbol: "KAVA",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://evm.testnet.kava.io"] }
  },
  blockExplorers: {
    default: {
      name: "Kava EVM Testnet Explorer",
      url: "https://testnet.kavascan.com/",
      apiUrl: "https://testnet.kavascan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
      blockCreated: 7242179
    }
  },
  testnet: !0
}), $K = /* @__PURE__ */ d({
  id: 321,
  name: "KCC Mainnet",
  network: "KCC Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "KCS",
    symbol: "KCS"
  },
  rpcUrls: {
    default: {
      http: ["https://kcc-rpc.com"]
    }
  },
  blockExplorers: {
    default: { name: "KCC Explorer", url: "https://explorer.kcc.io" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 11760430
    }
  },
  testnet: !1
}), BK = /* @__PURE__ */ d({
  id: 7887,
  name: "Kinto Mainnet",
  network: "Kinto Mainnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.kinto.xyz/http"] }
  },
  blockExplorers: {
    default: {
      name: "Kinto Explorer",
      url: "https://explorer.kinto.xyz"
    }
  },
  testnet: !1
}), DK = /* @__PURE__ */ d({
  id: 8217,
  name: "Klaytn",
  nativeCurrency: {
    decimals: 18,
    name: "Klaytn",
    symbol: "KLAY"
  },
  rpcUrls: {
    default: { http: ["https://public-en-cypress.klaytn.net"] }
  },
  blockExplorers: {
    default: {
      name: "KlaytnScope",
      url: "https://scope.klaytn.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 96002415
    }
  }
}), OK = /* @__PURE__ */ d({
  id: 1001,
  name: "Klaytn Baobab Testnet",
  network: "klaytn-baobab",
  nativeCurrency: {
    decimals: 18,
    name: "Baobab Klaytn",
    symbol: "KLAY"
  },
  rpcUrls: {
    default: { http: ["https://public-en-baobab.klaytn.net"] }
  },
  blockExplorers: {
    default: {
      name: "KlaytnScope",
      url: "https://baobab.klaytnscope.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 123390593
    }
  },
  testnet: !0
}), PK = d({
  id: 701,
  name: "Koi Network",
  nativeCurrency: {
    decimals: 18,
    name: "Koi Network Native Token",
    symbol: "KRING"
  },
  rpcUrls: {
    default: {
      http: ["https://koi-rpc.darwinia.network"],
      webSocket: ["wss://koi-rpc.darwinia.network"]
    }
  },
  blockExplorers: {
    default: { name: "Blockscout", url: "https://koi-scan.darwinia.network" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 180001
    }
  },
  testnet: !0
}), RK = /* @__PURE__ */ d({
  id: 255,
  name: "Kroma",
  nativeCurrency: { name: "ETH", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://api.kroma.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Kroma Explorer",
      url: "https://blockscout.kroma.network",
      apiUrl: "https://blockscout.kroma.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 16054868
    }
  },
  testnet: !1
}), NK = /* @__PURE__ */ d({
  id: 2358,
  name: "Kroma Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://api.sepolia.kroma.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Kroma Sepolia Explorer",
      url: "https://blockscout.sepolia.kroma.network",
      apiUrl: "https://blockscout.sepolia.kroma.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 8900914
    }
  },
  testnet: !0
}), LK = /* @__PURE__ */ d({
  id: 12324,
  name: "L3X Protocol",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-mainnet.l3x.com"],
      webSocket: ["wss://rpc-mainnet.l3x.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "L3X Mainnet Explorer",
      url: "https://explorer.l3x.com",
      apiUrl: "https://explorer.l3x.com/api/v2"
    }
  },
  testnet: !1
}), MK = /* @__PURE__ */ d({
  id: 12325,
  name: "L3X Protocol Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-testnet.l3x.com"],
      webSocket: ["wss://rpc-testnet.l3x.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "L3X Testnet Explorer",
      url: "https://explorer-testnet.l3x.com",
      apiUrl: "https://explorer-testnet.l3x.com/api/v2"
    }
  },
  testnet: !0
}), FK = /* @__PURE__ */ d({
  id: 360890,
  name: "LAVITA Mainnet",
  nativeCurrency: { name: "vTFUEL", symbol: "vTFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://tsub360890-eth-rpc.thetatoken.org/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "LAVITA Explorer",
      url: "https://tsub360890-explorer.thetatoken.org"
    }
  },
  testnet: !1
}), zK = /* @__PURE__ */ d({
  id: 232,
  name: "Lens",
  nativeCurrency: { name: "GHO", symbol: "GHO", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.lens.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Lens Block Explorer",
      url: "https://explorer.lens.xyz",
      apiUrl: "https://explorer.lens.xyz/api"
    }
  }
}), jK = /* @__PURE__ */ d({
  id: 37111,
  name: "Lens Testnet",
  nativeCurrency: { name: "GRASS", symbol: "GRASS", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.lens.dev"],
      webSocket: ["wss://rpc.testnet.lens.dev/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Lens Block Explorer",
      url: "https://block-explorer.testnet.lens.dev",
      apiUrl: "https://block-explorer-api.staging.lens.dev/api"
    }
  },
  testnet: !0
}), HK = /* @__PURE__ */ d({
  id: 21363,
  name: "Lestnet",
  nativeCurrency: { name: "Lestnet Ether", symbol: "LETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://service.lestnet.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Lestnet Explorer",
      url: "https://explore.lestnet.org"
    }
  },
  testnet: !0
}), qK = /* @__PURE__ */ d({
  id: 1891,
  name: "LightLink Pegasus Testnet",
  network: "lightlink-pegasus",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://replicator.pegasus.lightlink.io/rpc/v1"]
    }
  },
  blockExplorers: {
    default: {
      name: "LightLink Pegasus Explorer",
      url: "https://pegasus.lightlink.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 127188532
    }
  },
  testnet: !0
}), KK = /* @__PURE__ */ d({
  id: 1890,
  name: "LightLink Phoenix Mainnet",
  network: "lightlink-phoenix",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://replicator.phoenix.lightlink.io/rpc/v1"]
    }
  },
  blockExplorers: {
    default: {
      name: "LightLink Phoenix Explorer",
      url: "https://phoenix.lightlink.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 125499184
    }
  },
  testnet: !1
});
async function VK(t, e) {
  var n, i, o;
  const { account: r = t.account } = e;
  if (!r)
    throw new EM();
  const s = Pp(r);
  try {
    const { accessList: a, blockNumber: c, blockTag: l, data: u, gas: h, gasPrice: p, maxFeePerGas: y, maxPriorityFeePerGas: b, nonce: g, to: x, value: I, ...U } = e, M = (typeof c == "bigint" ? ie(c) : void 0) || l;
    ZL(e);
    const B = (o = (i = (n = t.chain) == null ? void 0 : n.formatters) == null ? void 0 : i.transactionRequest) == null ? void 0 : o.format, H = (B || W2)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...KL(U, { format: B }),
      from: s == null ? void 0 : s.address,
      accessList: a,
      data: u,
      gas: h,
      gasPrice: p,
      maxFeePerGas: y,
      maxPriorityFeePerGas: b,
      nonce: g,
      to: x,
      value: I
    }, "estimateGas"), { baseFeePerGas: F, gasLimit: w, priorityFeePerGas: T } = await t.request({
      method: "linea_estimateGas",
      params: M ? [H, M] : [H]
    });
    return {
      baseFeePerGas: BigInt(F),
      gasLimit: BigInt(w),
      priorityFeePerGas: BigInt(T)
    };
  } catch (a) {
    throw qL(a, {
      ...e,
      account: s,
      chain: t.chain
    });
  }
}
const jp = {
  fees: {
    estimateFeesPerGas: L1,
    async maxPriorityFeePerGas({ block: t, client: e, request: r }) {
      const s = await L1({
        block: t,
        client: e,
        multiply: (n) => n,
        request: r,
        type: "eip1559"
      });
      return s != null && s.maxPriorityFeePerGas ? s.maxPriorityFeePerGas : null;
    }
  }
};
async function L1({ client: t, multiply: e, request: r, type: s }) {
  try {
    const n = await VK(t, {
      ...r,
      account: r == null ? void 0 : r.account
    }), { priorityFeePerGas: i } = n, a = e(BigInt(n.baseFeePerGas)) + i;
    return s === "legacy" ? { gasPrice: a } : {
      maxFeePerGas: a,
      maxPriorityFeePerGas: i
    };
  } catch {
    return null;
  }
}
const GK = /* @__PURE__ */ d({
  ...jp,
  id: 59144,
  name: "Linea Mainnet",
  nativeCurrency: { name: "Linea Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.linea.build"],
      webSocket: ["wss://rpc.linea.build"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://lineascan.build",
      apiUrl: "https://api.lineascan.build/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 42
    },
    ensRegistry: {
      address: "0x50130b669B28C339991d8676FA73CF122a121267",
      blockCreated: 6682888
    },
    ensUniversalResolver: {
      address: "0x4D41762915F83c76EcaF6776d9b08076aA32b492",
      blockCreated: 22222151
    }
  },
  ensTlds: [".linea.eth"],
  testnet: !1
}), WK = /* @__PURE__ */ d({
  id: 59140,
  name: "Linea Goerli Testnet",
  nativeCurrency: { name: "Linea Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.goerli.linea.build"],
      webSocket: ["wss://rpc.goerli.linea.build"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://goerli.lineascan.build",
      apiUrl: "https://api-goerli.lineascan.build/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 498623
    }
  },
  testnet: !0
}), ZK = /* @__PURE__ */ d({
  ...jp,
  id: 59141,
  name: "Linea Sepolia Testnet",
  nativeCurrency: { name: "Linea Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.sepolia.linea.build"],
      webSocket: ["wss://rpc.sepolia.linea.build"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://sepolia.lineascan.build",
      apiUrl: "https://api-sepolia.lineascan.build/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 227427
    },
    ensRegistry: {
      address: "0x5B2636F0f2137B4aE722C01dd5122D7d3e9541f7",
      blockCreated: 2395094
    },
    ensUniversalResolver: {
      address: "0x4D41762915F83c76EcaF6776d9b08076aA32b492",
      blockCreated: 17168484
    }
  },
  ensTlds: [".linea.eth"],
  testnet: !0
}), JK = /* @__PURE__ */ d({
  id: 59140,
  name: "Linea Goerli Testnet",
  nativeCurrency: { name: "Linea Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.goerli.linea.build"],
      webSocket: ["wss://rpc.goerli.linea.build"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://goerli.lineascan.build",
      apiUrl: "https://goerli.lineascan.build/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 498623
    }
  },
  testnet: !0
}), fc = 1, XK = /* @__PURE__ */ d({
  ...W,
  id: 1135,
  name: "Lisk",
  network: "lisk",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.api.lisk.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://blockscout.lisk.com",
      apiUrl: "https://blockscout.lisk.com/api"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xA9d71E1dd7ca26F26e656E66d6AA81ed7f745bf0"
    },
    l2OutputOracle: {
      [fc]: {
        address: "0x113cB99283AF242Da0A0C54347667edF531Aa7d6"
      }
    },
    portal: {
      [fc]: {
        address: "0x26dB93F8b8b4f7016240af62F7730979d353f9A7"
      }
    },
    l1StandardBridge: {
      [fc]: {
        address: "0x2658723Bf70c7667De6B25F99fcce13A16D25d08"
      }
    }
  },
  sourceId: fc
}), mc = 11155111, YK = /* @__PURE__ */ d({
  ...W,
  id: 4202,
  network: "lisk-sepolia",
  name: "Lisk Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.sepolia-api.lisk.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://sepolia-blockscout.lisk.com",
      apiUrl: "https://sepolia-blockscout.lisk.com/api"
    }
  },
  contracts: {
    ...W.contracts,
    l2OutputOracle: {
      [mc]: {
        address: "0xA0E35F56C318DE1bD5D9ca6A94Fe7e37C5663348"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11"
    },
    portal: {
      [mc]: {
        address: "0xe3d90F21490686Ec7eF37BE788E02dfC12787264"
      }
    },
    l1StandardBridge: {
      [mc]: {
        address: "0x1Fb30e446eA791cd1f011675E5F3f5311b70faF5"
      }
    }
  },
  testnet: !0,
  sourceId: mc
}), QK = /* @__PURE__ */ d({
  id: 9496,
  name: "Load Alphanet",
  nativeCurrency: { name: "Testnet LOAD", symbol: "tLOAD", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://alphanet.load.network"] }
  },
  blockExplorers: {
    default: {
      name: "Load Alphanet Explorer",
      url: "https://explorer.load.network"
    }
  },
  testnet: !0
}), eV = /* @__PURE__ */ d({
  id: 1337,
  name: "Localhost",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["http://127.0.0.1:8545"] }
  }
}), tV = /* @__PURE__ */ d({
  id: 15551,
  name: "LoopNetwork Mainnet",
  nativeCurrency: {
    name: "LOOP",
    symbol: "LOOP",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://api.mainnetloop.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "LoopNetwork Blockchain Explorer",
      url: "https://explorer.mainnetloop.com/"
    }
  },
  testnet: !1
}), rV = /* @__PURE__ */ d({
  id: 42,
  network: "lukso",
  name: "LUKSO",
  nativeCurrency: {
    name: "LUKSO",
    symbol: "LYX",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.mainnet.lukso.network"],
      webSocket: ["wss://ws-rpc.mainnet.lukso.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "LUKSO Mainnet Explorer",
      url: "https://explorer.execution.mainnet.lukso.network",
      apiUrl: "https://api.explorer.execution.mainnet.lukso.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 468183
    }
  }
}), sV = /* @__PURE__ */ d({
  id: 4201,
  name: "LUKSO Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "LUKSO Testnet",
    symbol: "LYXt"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.lukso.network"],
      webSocket: ["wss://ws-rpc.testnet.lukso.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "LUKSO Testnet Explorer",
      url: "https://explorer.execution.testnet.lukso.network",
      apiUrl: "https://api.explorer.execution.testnet.lukso.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 605348
    }
  },
  testnet: !0
}), nV = /* @__PURE__ */ d({
  id: 994873017,
  name: "Lumia Mainnet",
  network: "LumiaMainnet",
  nativeCurrency: { name: "Lumia", symbol: "LUMIA", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet-rpc.lumia.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Lumia Explorer",
      url: "https://explorer.lumia.org/"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3975939
    }
  },
  testnet: !1
}), iV = /* @__PURE__ */ d({
  id: 1952959480,
  name: "Lumia Testnet",
  network: "LumiaTestnet",
  nativeCurrency: {
    name: "Lumia",
    symbol: "LUMIA",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://testnet-rpc.lumia.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Lumia Testnet Explorer",
      url: "https://testnet-explorer.lumia.org/"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 2235063
    }
  },
  testnet: !0
}), oV = /* @__PURE__ */ d({
  id: 96370,
  name: "Lumoz",
  nativeCurrency: {
    decimals: 18,
    name: "Lumoz Token",
    symbol: "MOZ"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.lumoz.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Lumoz Scan",
      url: "https://scan.lumoz.info"
    }
  },
  testnet: !1
}), aV = /* @__PURE__ */ d({
  id: 105363,
  name: "Lumoz Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Lumoz Testnet Token",
    symbol: "MOZ"
  },
  rpcUrls: {
    default: {
      http: ["https://testnet-rpc.lumoz.org"]
    }
  },
  testnet: !0
}), cV = /* @__PURE__ */ d({
  id: 721,
  name: "Lycan",
  nativeCurrency: {
    decimals: 18,
    name: "Lycan",
    symbol: "LYC"
  },
  rpcUrls: {
    default: {
      http: [
        "https://rpc.lycanchain.com",
        "https://us-east.lycanchain.com",
        "https://us-west.lycanchain.com",
        "https://eu-north.lycanchain.com",
        "https://eu-west.lycanchain.com",
        "https://asia-southeast.lycanchain.com"
      ],
      webSocket: [
        "wss://rpc.lycanchain.com",
        "wss://us-east.lycanchain.com",
        "wss://us-west.lycanchain.com",
        "wss://eu-north.lycanchain.com",
        "wss://eu-west.lycanchain.com",
        "wss://asia-southeast.lycanchain.com"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Lycan Explorer",
      url: "https://explorer.lycanchain.com"
    }
  }
}), lV = /* @__PURE__ */ d({
  id: 957,
  name: "Lyra Chain",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.lyra.finance"]
    }
  },
  blockExplorers: {
    default: {
      name: "Lyra Explorer",
      url: "https://explorer.lyra.finance",
      apiUrl: "https://explorer.lyra.finance/api/v2"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1935198
    }
  }
}), uV = /* @__PURE__ */ d({
  id: 1,
  name: "Ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  blockTime: 12e3,
  rpcUrls: {
    default: {
      http: ["https://eth.merkle.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://etherscan.io",
      apiUrl: "https://api.etherscan.io/api"
    }
  },
  contracts: {
    ensUniversalResolver: {
      address: "0xeeeeeeee14d718c2b47d9923deab1335e144eeee",
      blockCreated: 23085558
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
}), hV = /* @__PURE__ */ d({
  id: 595,
  name: "Mandala TC9",
  network: "mandala",
  nativeCurrency: {
    name: "Mandala",
    symbol: "mACA",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://eth-rpc-tc9.aca-staging.network"],
      webSocket: ["wss://eth-rpc-tc9.aca-staging.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Mandala Blockscout",
      url: "https://blockscout.mandala.aca-staging.network",
      apiUrl: "https://blockscout.mandala.aca-staging.network/api"
    }
  },
  testnet: !0
}), dV = /* @__PURE__ */ d({
  id: 169,
  name: "Manta Pacific Mainnet",
  network: "manta",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://pacific-rpc.manta.network/http"] }
  },
  blockExplorers: {
    default: {
      name: "Manta Explorer",
      url: "https://pacific-explorer.manta.network",
      apiUrl: "https://pacific-explorer.manta.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 332890
    }
  }
}), pV = /* @__PURE__ */ d({
  id: 3441006,
  name: "Manta Pacific Sepolia Testnet",
  network: "manta-sepolia",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://pacific-rpc.sepolia-testnet.manta.network/http"]
    }
  },
  blockExplorers: {
    default: {
      name: "Manta Sepolia Testnet Explorer",
      url: "https://pacific-explorer.sepolia-testnet.manta.network",
      apiUrl: "https://pacific-explorer.sepolia-testnet.manta.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca54918f7B525C8df894668846506767412b53E3",
      blockCreated: 479584
    }
  },
  testnet: !0
}), fV = /* @__PURE__ */ d({
  id: 3441005,
  name: "Manta Pacific Testnet",
  network: "manta-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://manta-testnet.calderachain.xyz/http"] }
  },
  blockExplorers: {
    default: {
      name: "Manta Testnet Explorer",
      url: "https://pacific-explorer.testnet.manta.network",
      apiUrl: "https://pacific-explorer.testnet.manta.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0x211B1643b95Fe76f11eD8880EE810ABD9A4cf56C",
      blockCreated: 419915
    }
  },
  testnet: !0
}), mV = /* @__PURE__ */ d({
  id: 5e3,
  name: "Mantle",
  nativeCurrency: {
    decimals: 18,
    name: "MNT",
    symbol: "MNT"
  },
  rpcUrls: {
    default: { http: ["https://rpc.mantle.xyz"] }
  },
  blockExplorers: {
    default: {
      name: "Mantle Explorer",
      url: "https://mantlescan.xyz/",
      apiUrl: "https://api.mantlescan.xyz/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 304717
    }
  }
}), bV = /* @__PURE__ */ d({
  id: 5003,
  name: "Mantle Sepolia Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "MNT",
    symbol: "MNT"
  },
  rpcUrls: {
    default: { http: ["https://rpc.sepolia.mantle.xyz"] }
  },
  blockExplorers: {
    default: {
      name: "Mantle Testnet Explorer",
      url: "https://explorer.sepolia.mantle.xyz/",
      apiUrl: "https://explorer.sepolia.mantle.xyz/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 4584012
    }
  },
  testnet: !0
}), yV = /* @__PURE__ */ d({
  id: 5001,
  name: "Mantle Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "MNT",
    symbol: "MNT"
  },
  rpcUrls: {
    default: { http: ["https://rpc.testnet.mantle.xyz"] }
  },
  blockExplorers: {
    default: {
      name: "Mantle Testnet Explorer",
      url: "https://explorer.testnet.mantle.xyz",
      apiUrl: "https://explorer.testnet.mantle.xyz/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 561333
    }
  },
  testnet: !0
}), gV = /* @__PURE__ */ d({
  id: 5887,
  name: "MANTRA DuKong EVM Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "OM",
    symbol: "OM"
  },
  rpcUrls: {
    default: { http: ["https://evm.dukong.mantrachain.io"] }
  },
  blockExplorers: {
    default: {
      name: "MANTRAScan",
      url: "https://mantrascan.io/dukong"
    }
  },
  testnet: !0
}), wV = /* @__PURE__ */ d({
  id: 5888,
  name: "MANTRA EVM",
  nativeCurrency: {
    decimals: 18,
    name: "OM",
    symbol: "OM"
  },
  rpcUrls: {
    default: {
      http: ["https://evm.mantrachain.io"],
      webSocket: ["https://evm.mantrachain.io/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "MANTRA Scan",
      url: "https://mantrascan.io/mainnet"
    }
  }
}), EV = /* @__PURE__ */ d({
  id: 22776,
  name: "MAP Protocol",
  nativeCurrency: {
    decimals: 18,
    name: "MAPO",
    symbol: "MAPO"
  },
  rpcUrls: {
    default: { http: ["https://rpc.maplabs.io"] }
  },
  blockExplorers: {
    default: {
      name: "MAPO Scan",
      url: "https://maposcan.io"
    }
  },
  testnet: !1
}), xV = /* @__PURE__ */ d({
  id: 698,
  name: "Matchain",
  nativeCurrency: {
    name: "BNB",
    symbol: "BNB",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://rpc.matchain.io"] }
  },
  blockExplorers: {
    default: {
      name: "Matchain Scan",
      url: "https://matchscan.io"
    }
  }
}), vV = /* @__PURE__ */ d({
  id: 699,
  name: "Matchain Testnet",
  nativeCurrency: {
    name: "BNB",
    symbol: "BNB",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://testnet-rpc.matchain.io"] }
  },
  blockExplorers: {
    default: {
      name: "Matchain Scan",
      url: "https://testnet.matchscan.io"
    }
  },
  testnet: !0
}), kV = /* @__PURE__ */ d({
  id: 29548,
  name: "MCH Verse",
  nativeCurrency: { name: "Oasys", symbol: "OAS", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.oasys.mycryptoheroes.net"]
    }
  },
  blockExplorers: {
    default: {
      name: "MCH Verse Explorer",
      url: "https://explorer.oasys.mycryptoheroes.net",
      apiUrl: "https://explorer.oasys.mycryptoheroes.net/api"
    }
  },
  testnet: !1
}), CV = /* @__PURE__ */ d({
  id: 6342,
  blockTime: 1e3,
  name: "MegaETH Testnet",
  nativeCurrency: {
    name: "MegaETH Testnet Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://carrot.megaeth.com/rpc"],
      webSocket: ["wss://carrot.megaeth.com/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "MegaETH Testnet Explorer",
      url: "https://www.megaexplorer.xyz/"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  },
  testnet: !0
}), SV = /* @__PURE__ */ d({
  id: 7078815900,
  name: "Mekong Pectra Devnet",
  nativeCurrency: { name: "eth", symbol: "eth", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.mekong.ethpandaops.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Block Explorer",
      url: "https://explorer.mekong.ethpandaops.io"
    }
  },
  testnet: !0
}), IV = /* @__PURE__ */ d({
  id: 333000333,
  name: "Meld",
  nativeCurrency: {
    decimals: 18,
    name: "Meld",
    symbol: "MELD"
  },
  rpcUrls: {
    default: { http: ["https://rpc-1.meld.com"] }
  },
  blockExplorers: {
    default: { name: "MELDscan", url: "https://meldscan.io" }
  },
  contracts: {
    multicall3: {
      address: "0x769ee5a8e82c15c1b6e358f62ac8eb6e3abe8dc5",
      blockCreated: 360069
    }
  }
}), AV = /* @__PURE__ */ d({
  id: 4352,
  name: "MemeCore",
  nativeCurrency: {
    decimals: 18,
    name: "M",
    symbol: "M"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.memecore.net"],
      webSocket: ["wss://ws.memecore.net"]
    }
  },
  blockExplorers: {
    default: {
      name: "MemeCore Explorer",
      url: "https://memecorescan.io",
      apiUrl: "https://api.memecorescan.io/api"
    },
    okx: {
      name: "MemeCore Explorer",
      url: "https://web3.okx.com/explorer/memecore"
    },
    memecore: {
      name: "MemeCore Explorer",
      url: "https://blockscout.memecore.com",
      apiUrl: "https://blockscout.memecore.com/api"
    }
  }
}), _V = /* @__PURE__ */ d({
  id: 43521,
  name: "Formicarium",
  nativeCurrency: {
    decimals: 18,
    name: "M",
    symbol: "M"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.formicarium.memecore.net"],
      webSocket: ["wss://ws.formicarium.memecore.net"]
    }
  },
  blockExplorers: {
    default: {
      name: "MemeCore Testnet Explorer",
      url: "https://formicarium.memecorescan.io"
    },
    okx: {
      name: "MemeCore Testnet Explorer",
      url: "https://web3.okx.com/explorer/formicarium-testnet"
    },
    memecore: {
      name: "MemeCore Testnet Explorer",
      url: "https://formicarium.blockscout.memecore.com",
      apiUrl: "https://formicarium.blockscout.memecore.com/api"
    }
  },
  testnet: !0
}), TV = /* @__PURE__ */ d({
  id: 4200,
  name: "Merlin",
  nativeCurrency: {
    name: "BTC",
    symbol: "BTC",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://rpc.merlinchain.io"] }
  },
  blockExplorers: {
    default: {
      name: "blockscout",
      url: "https://scan.merlinchain.io",
      apiUrl: "https://scan.merlinchain.io/api"
    }
  }
}), UV = /* @__PURE__ */ d({
  id: 4203,
  name: "Merlin Erigon Testnet",
  nativeCurrency: {
    name: "BTC",
    symbol: "BTC",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://testnet-erigon-rpc.merlinchain.io"] }
  },
  blockExplorers: {
    default: {
      name: "blockscout",
      url: "https://testnet-erigon-scan.merlinchain.io",
      apiUrl: "https://testnet-erigon-scan.merlinchain.io/api"
    }
  },
  testnet: !0
}), $V = /* @__PURE__ */ d({
  id: 571,
  name: "MetaChain Mainnet",
  nativeCurrency: { name: "Metatime Coin", symbol: "MTC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.metatime.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "MetaExplorer",
      url: "https://explorer.metatime.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0x0000000000000000000000000000000000003001",
      blockCreated: 0
    }
  }
}), BV = /* @__PURE__ */ d({
  id: 1453,
  name: "MetaChain Istanbul",
  nativeCurrency: { name: "Metatime Coin", symbol: "MTC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://istanbul-rpc.metachain.dev"]
    }
  },
  blockExplorers: {
    default: {
      name: "MetaExplorer",
      url: "https://istanbul-explorer.metachain.dev"
    }
  },
  contracts: {
    multicall3: {
      address: "0x0000000000000000000000000000000000003001",
      blockCreated: 0
    }
  },
  testnet: !0
}), DV = /* @__PURE__ */ d({
  id: 11,
  name: "Metadium Network",
  nativeCurrency: {
    decimals: 18,
    name: "META",
    symbol: "META"
  },
  rpcUrls: {
    default: { http: ["https://api.metadium.com/prod"] }
  },
  blockExplorers: {
    default: {
      name: "Metadium Explorer",
      url: "https://explorer.metadium.com"
    }
  },
  testnet: !1
}), bc = 1, OV = /* @__PURE__ */ d({
  ...W,
  id: 1750,
  name: "Metal L2",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.metall2.com"],
      webSocket: ["wss://rpc.metall2.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "https://explorer.metall2.com",
      apiUrl: "https://explorer.metall2.com/api"
    }
  },
  contracts: {
    ...W.contracts,
    l2OutputOracle: {
      [bc]: {
        address: "0x3B1F7aDa0Fcc26B13515af752Dd07fB1CAc11426"
      }
    },
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 0
    },
    portal: {
      [bc]: {
        address: "0x3F37aBdE2C6b5B2ed6F8045787Df1ED1E3753956"
      }
    },
    l1StandardBridge: {
      [bc]: {
        address: "0x6d0f65D59b55B0FEC5d2d15365154DcADC140BF3"
      }
    }
  },
  sourceId: bc
}), PV = /* @__PURE__ */ d({
  id: 82,
  name: "Meter",
  nativeCurrency: {
    decimals: 18,
    name: "MTR",
    symbol: "MTR"
  },
  rpcUrls: {
    default: { http: ["https://rpc.meter.io"] }
  },
  blockExplorers: {
    default: {
      name: "MeterScan",
      url: "https://scan.meter.io"
    }
  }
}), RV = /* @__PURE__ */ d({
  id: 83,
  name: "Meter Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "MTR",
    symbol: "MTR"
  },
  rpcUrls: {
    default: { http: ["https://rpctest.meter.io"] }
  },
  blockExplorers: {
    default: {
      name: "MeterTestnetScan",
      url: "https://scan-warringstakes.meter.io"
    }
  }
}), NV = /* @__PURE__ */ d({
  id: 1088,
  name: "Metis",
  nativeCurrency: {
    decimals: 18,
    name: "Metis",
    symbol: "METIS"
  },
  rpcUrls: {
    default: {
      http: [
        "https://metis.rpc.hypersync.xyz",
        "https://metis-pokt.nodies.app",
        "https://api.blockeden.xyz/metis/67nCBdZQSH9z3YqDDjdm",
        "https://metis-andromeda.rpc.thirdweb.com",
        "https://metis-andromeda.gateway.tenderly.co",
        "https://metis.api.onfinality.io/public",
        "https://andromeda.metis.io/?owner=1088",
        "https://metis-mainnet.public.blastapi.io"
      ],
      webSocket: ["wss://metis-rpc.publicnode.com", "wss://metis.drpc.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Metis Explorer",
      url: "https://explorer.metis.io",
      apiUrl: "https://api.routescan.io/v2/network/mainnet/evm/1088/etherscan/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 2338552
    }
  }
}), LV = /* @__PURE__ */ d({
  id: 599,
  name: "Metis Goerli",
  nativeCurrency: {
    decimals: 18,
    name: "Metis Goerli",
    symbol: "METIS"
  },
  rpcUrls: {
    default: { http: ["https://goerli.gateway.metisdevops.link"] }
  },
  blockExplorers: {
    default: {
      name: "Metis Goerli Explorer",
      url: "https://goerli.explorer.metisdevops.link",
      apiUrl: "https://goerli.explorer.metisdevops.link/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1006207
    }
  }
}), MV = /* @__PURE__ */ d({
  id: 59902,
  name: "Metis Sepolia",
  nativeCurrency: {
    decimals: 18,
    name: "Test Metis",
    symbol: "tMETIS"
  },
  rpcUrls: {
    default: {
      http: [
        "https://sepolia.metisdevops.link",
        "https://metis-sepolia-rpc.publicnode.com",
        "https://metis-sepolia.gateway.tenderly.co"
      ],
      webSocket: ["wss://metis-sepolia-rpc.publicnode.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Metis Sepolia Explorer",
      url: "https://sepolia-explorer.metisdevops.link",
      apiUrl: "https://sepolia-explorer.metisdevops.link/api-docs"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 224185
    }
  }
}), FV = /* @__PURE__ */ d({
  id: 7518,
  name: "MEVerse Chain Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "MEVerse",
    symbol: "MEV"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.meversemainnet.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "https://www.meversescan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 86881340
    }
  }
}), zV = /* @__PURE__ */ d({
  id: 4759,
  name: "MEVerse Chain Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "MEVerse",
    symbol: "MEV"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.meversetestnet.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "https://testnet.meversescan.io/"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 64371115
    }
  },
  testnet: !0
}), jV = /* @__PURE__ */ d({
  id: 185,
  name: "Mint Mainnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.mintchain.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Mintchain explorer",
      url: "https://explorer.mintchain.io"
    }
  },
  testnet: !1
}), HV = /* @__PURE__ */ d({
  id: 1686,
  name: "Mint Sepolia Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://testnet-rpc.mintchain.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Mintchain Testnet explorer",
      url: "https://testnet-explorer.mintchain.io"
    }
  },
  testnet: !0
}), qV = /* @__PURE__ */ d({
  id: 124832,
  name: "Mitosis Testnet",
  nativeCurrency: { name: "MITO", symbol: "MITO", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.mitosis.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Mitosis testnet explorer",
      url: "https://testnet.mitosiscan.xyz"
    }
  },
  testnet: !0
}), yc = 1, KV = /* @__PURE__ */ d({
  ...W,
  id: 34443,
  name: "Mode Mainnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.mode.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Modescan",
      url: "https://modescan.io"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 2465882
    },
    l2OutputOracle: {
      [yc]: {
        address: "0x4317ba146D4933D889518a3e5E11Fe7a53199b04"
      }
    },
    portal: {
      [yc]: {
        address: "0x8B34b14c7c7123459Cf3076b8Cb929BE097d0C07"
      }
    },
    l1StandardBridge: {
      [yc]: {
        address: "0x735aDBbE72226BD52e818E7181953f42E3b0FF21"
      }
    }
  },
  sourceId: yc
}), gc = 11155111, VV = /* @__PURE__ */ d({
  ...W,
  id: 919,
  name: "Mode Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.mode.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://sepolia.explorer.mode.network",
      apiUrl: "https://sepolia.explorer.mode.network/api"
    }
  },
  contracts: {
    ...W.contracts,
    l2OutputOracle: {
      [gc]: {
        address: "0x2634BD65ba27AB63811c74A63118ACb312701Bfa",
        blockCreated: 3778393
      }
    },
    portal: {
      [gc]: {
        address: "0x320e1580effF37E008F1C92700d1eBa47c1B23fD",
        blockCreated: 3778395
      }
    },
    l1StandardBridge: {
      [gc]: {
        address: "0xbC5C679879B2965296756CD959C3C739769995E2",
        blockCreated: 3778392
      }
    },
    multicall3: {
      address: "0xBAba8373113Fb7a68f195deF18732e01aF8eDfCF",
      blockCreated: 3019007
    }
  },
  testnet: !0,
  sourceId: gc
}), GV = /* @__PURE__ */ d({
  id: 10143,
  name: "Monad Testnet",
  blockTime: 400,
  nativeCurrency: {
    name: "Testnet MON Token",
    symbol: "MON",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://testnet-rpc.monad.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Monad Testnet explorer",
      url: "https://testnet.monadexplorer.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 251449
    }
  },
  testnet: !0
}), WV = /* @__PURE__ */ d({
  id: 1287,
  name: "Moonbase Alpha",
  nativeCurrency: {
    decimals: 18,
    name: "DEV",
    symbol: "DEV"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.api.moonbase.moonbeam.network"],
      webSocket: ["wss://wss.api.moonbase.moonbeam.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Moonscan",
      url: "https://moonbase.moonscan.io",
      apiUrl: "https://moonbase.moonscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1850686
    }
  },
  testnet: !0
}), ZV = /* @__PURE__ */ d({
  id: 1284,
  name: "Moonbeam",
  nativeCurrency: {
    decimals: 18,
    name: "GLMR",
    symbol: "GLMR"
  },
  rpcUrls: {
    default: {
      http: ["https://moonbeam.public.blastapi.io"],
      webSocket: ["wss://moonbeam.public.blastapi.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Moonscan",
      url: "https://moonscan.io",
      apiUrl: "https://api-moonbeam.moonscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 609002
    }
  },
  testnet: !1
}), JV = /* @__PURE__ */ d({
  id: 1281,
  name: "Moonbeam Development Node",
  nativeCurrency: {
    decimals: 18,
    name: "DEV",
    symbol: "DEV"
  },
  rpcUrls: {
    default: {
      http: ["http://127.0.0.1:9944"],
      webSocket: ["wss://127.0.0.1:9944"]
    }
  }
}), XV = /* @__PURE__ */ d({
  id: 1285,
  name: "Moonriver",
  nativeCurrency: {
    decimals: 18,
    name: "MOVR",
    symbol: "MOVR"
  },
  rpcUrls: {
    default: {
      http: ["https://moonriver.public.blastapi.io"],
      webSocket: ["wss://moonriver.public.blastapi.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Moonscan",
      url: "https://moonriver.moonscan.io",
      apiUrl: "https://api-moonriver.moonscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1597904
    }
  },
  testnet: !1
}), YV = /* @__PURE__ */ d({
  id: 2818,
  name: "Morph",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.morphl2.io"],
      webSocket: ["wss://rpc.morphl2.io:8443"]
    }
  },
  blockExplorers: {
    default: {
      name: "Morph Explorer",
      url: "https://explorer.morphl2.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3654913
    }
  },
  testnet: !1
}), QV = /* @__PURE__ */ d({
  id: 2810,
  name: "Morph Holesky",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-quicknode-holesky.morphl2.io"],
      webSocket: ["wss://rpc-quicknode-holesky.morphl2.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Morph Holesky Explorer",
      url: "https://explorer-holesky.morphl2.io",
      apiUrl: "https://explorer-api-holesky.morphl2.io/api?"
    }
  },
  testnet: !0
}), eG = /* @__PURE__ */ d({
  id: 2710,
  name: "Morph Sepolia",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-testnet.morphl2.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Morph Testnet Explorer",
      url: "https://explorer-testnet.morphl2.io",
      apiUrl: "https://explorer-api-testnet.morphl2.io/api"
    }
  },
  testnet: !0
}), tG = /* @__PURE__ */ d({
  id: 5551,
  name: "Nahmii 2 Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://l2.nahmii.io"] }
  },
  blockExplorers: {
    default: {
      name: "Nahmii 2 Explorer",
      url: "https://explorer.n2.nahmii.io"
    }
  },
  testnet: !1
}), rG = /* @__PURE__ */ d({
  id: 22222,
  name: "Nautilus Mainnet",
  nativeCurrency: { name: "ZBC", symbol: "ZBC", decimals: 9 },
  rpcUrls: {
    default: {
      http: ["https://api.nautilus.nautchain.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "NautScan",
      url: "https://nautscan.com"
    }
  }
}), sG = /* @__PURE__ */ d({
  id: 397,
  name: "NEAR Protocol",
  nativeCurrency: {
    decimals: 18,
    name: "NEAR",
    symbol: "NEAR"
  },
  rpcUrls: {
    default: { http: ["https://eth-rpc.mainnet.near.org"] }
  },
  blockExplorers: {
    default: {
      name: "NEAR Explorer",
      url: "https://eth-explorer.near.org"
    }
  },
  testnet: !1
}), nG = /* @__PURE__ */ d({
  id: 398,
  name: "NEAR Protocol Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "NEAR",
    symbol: "NEAR"
  },
  rpcUrls: {
    default: { http: ["https://eth-rpc.testnet.near.org"] }
  },
  blockExplorers: {
    default: {
      name: "NEAR Explorer",
      url: "https://eth-explorer-testnet.near.org"
    }
  },
  testnet: !0
}), iG = /* @__PURE__ */ d({
  id: 245022926,
  name: "Neon EVM DevNet",
  nativeCurrency: { name: "NEON", symbol: "NEON", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://devnet.neonevm.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Neonscan",
      url: "https://devnet.neonscan.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 205206112
    }
  },
  testnet: !0
}), oG = /* @__PURE__ */ d({
  id: 245022934,
  network: "neonMainnet",
  name: "Neon EVM MainNet",
  nativeCurrency: { name: "NEON", symbol: "NEON", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://neon-proxy-mainnet.solana.p2p.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Neonscan",
      url: "https://neonscan.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 206545524
    }
  },
  testnet: !1
}), aG = /* @__PURE__ */ d({
  id: 47763,
  name: "Neo X Mainnet",
  nativeCurrency: { name: "Gas", symbol: "GAS", decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        "https://mainnet-1.rpc.banelabs.org",
        "https://mainnet-2.rpc.banelabs.org"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Neo X - Explorer",
      url: "https://xexplorer.neo.org"
    }
  },
  testnet: !1
}), cG = /* @__PURE__ */ d({
  id: 12227332,
  name: "Neo X Testnet T4",
  nativeCurrency: { name: "Gas", symbol: "GAS", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://testnet.rpc.banelabs.org/"]
    }
  },
  blockExplorers: {
    default: {
      name: "neox-scan",
      url: "https://xt4scan.ngd.network"
    }
  },
  testnet: !0
}), lG = /* @__PURE__ */ d({
  id: 1012,
  name: "Newton",
  nativeCurrency: {
    name: "Newton",
    symbol: "NEW",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://global.rpc.mainnet.newtonproject.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "NewFi explorer",
      url: "https://explorer.newtonproject.org/"
    }
  },
  testnet: !1
}), uG = /* @__PURE__ */ d({
  id: 4242,
  name: "Nexi",
  nativeCurrency: { name: "Nexi", symbol: "NEXI", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.chain.nexi.technology"]
    }
  },
  blockExplorers: {
    default: {
      name: "NexiScan",
      url: "https://www.nexiscan.com",
      apiUrl: "https://www.nexiscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0x0277A46Cc69A57eE3A6C8c158bA874832F718B8E",
      blockCreated: 25770160
    }
  }
}), hG = /* @__PURE__ */ d({
  id: 240,
  name: "Nexilix Smart Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Nexilix",
    symbol: "NEXILIX"
  },
  rpcUrls: {
    default: { http: ["https://rpcurl.pos.nexilix.com"] }
  },
  blockExplorers: {
    default: {
      name: "NexilixScan",
      url: "https://scan.nexilix.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0x58381c8e2BF9d0C2C4259cA14BdA9Afe02831244",
      blockCreated: 74448
    }
  }
}), dG = /* @__PURE__ */ d({
  id: 6900,
  name: "Nibiru",
  nativeCurrency: {
    decimals: 18,
    name: "NIBI",
    symbol: "NIBI"
  },
  rpcUrls: {
    default: { http: ["https://evm-rpc.nibiru.fi"] }
  },
  blockExplorers: {
    default: {
      name: "NibiScan",
      url: "https://nibiscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 19587573
    }
  }
}), pG = /* @__PURE__ */ d({
  id: 200024,
  name: "Nitrograph Testnet",
  testnet: !0,
  rpcUrls: {
    default: {
      http: ["https://rpc-testnet.nitrograph.foundation"]
    }
  },
  nativeCurrency: {
    name: "Nitro",
    symbol: "NOS",
    decimals: 18
  },
  blockExplorers: {
    default: {
      url: "https://explorer-testnet.nitrograph.foundation",
      name: "Nitrograph Explorer"
    }
  }
}), fG = /* @__PURE__ */ d({
  id: 4090,
  network: "oasis-testnet",
  name: "Oasis Testnet",
  nativeCurrency: { name: "Fasttoken", symbol: "FTN", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc1.oasis.bahamutchain.com"] }
  },
  blockExplorers: {
    default: {
      name: "Ftnscan",
      url: "https://oasis.ftnscan.com",
      apiUrl: "https://oasis.ftnscan.com/api"
    }
  },
  testnet: !0
}), mG = /* @__PURE__ */ d({
  id: 248,
  name: "Oasys",
  nativeCurrency: { name: "Oasys", symbol: "OAS", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.mainnet.oasys.games"]
    }
  },
  blockExplorers: {
    default: {
      name: "OasysScan",
      url: "https://scan.oasys.games",
      apiUrl: "https://scan.oasys.games/api"
    }
  }
}), bG = /* @__PURE__ */ d({
  id: 911867,
  name: "Odyssey Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://odyssey.ithaca.xyz"] }
  },
  blockExplorers: {
    default: {
      name: "Odyssey Explorer",
      url: "https://odyssey-explorer.ithaca.xyz",
      apiUrl: "https://odyssey-explorer.ithaca.xyz/api"
    }
  },
  testnet: !0
}), yG = /* @__PURE__ */ d({
  id: 66,
  name: "OKC",
  nativeCurrency: {
    decimals: 18,
    name: "OKT",
    symbol: "OKT"
  },
  rpcUrls: {
    default: { http: ["https://exchainrpc.okex.org"] }
  },
  blockExplorers: {
    default: {
      name: "oklink",
      url: "https://www.oklink.com/okc"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 10364792
    }
  }
}), gG = /* @__PURE__ */ d({
  id: 311,
  name: "Omax Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "OMAX",
    symbol: "OMAX"
  },
  rpcUrls: {
    default: { http: ["https://mainapi.omaxray.com"] }
  },
  blockExplorers: {
    default: {
      name: "Omax Explorer",
      url: "https://omaxscan.com"
    }
  },
  testnet: !1
}), wG = d({
  id: 166,
  name: "Omni",
  nativeCurrency: { name: "Omni", symbol: "OMNI", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.omni.network"],
      webSocket: ["wss://mainnet.omni.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "OmniScan",
      url: "https://omniscan.network"
    }
  },
  testnet: !1
}), EG = /* @__PURE__ */ d({
  id: 164,
  name: "Omni Omega",
  nativeCurrency: { name: "Omni", symbol: "OMNI", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://omega.omni.network"],
      webSocket: ["wss://omega.omni.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Omega OmniScan",
      url: "https://omega.omniscan.network/"
    }
  },
  testnet: !0
}), xG = /* @__PURE__ */ d({
  id: 309075,
  name: "One World Chain Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "OWCT",
    symbol: "OWCT"
  },
  rpcUrls: {
    default: { http: ["https://mainnet-rpc.oneworldchain.org"] }
  },
  blockExplorers: {
    default: {
      name: "One World Explorer",
      url: "https://mainnet.oneworldchain.org"
    }
  },
  testnet: !1
}), vG = /* @__PURE__ */ d({
  id: 9700,
  name: "OORT MainnetDev",
  nativeCurrency: {
    decimals: 18,
    name: "OORT",
    symbol: "OORT"
  },
  rpcUrls: {
    default: { http: ["https://dev-rpc.oortech.com"] }
  },
  blockExplorers: {
    default: {
      name: "OORT MainnetDev Explorer",
      url: "https://dev-scan.oortech.com"
    }
  }
}), wc = 56, kG = /* @__PURE__ */ d({
  id: 204,
  name: "opBNB",
  nativeCurrency: {
    name: "BNB",
    symbol: "BNB",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://opbnb-mainnet-rpc.bnbchain.org"] }
  },
  blockExplorers: {
    default: {
      name: "opBNB (BSCScan)",
      url: "https://opbnb.bscscan.com",
      apiUrl: "https://api-opbnb.bscscan.com/api"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 512881
    },
    l2OutputOracle: {
      [wc]: {
        address: "0x153CAB79f4767E2ff862C94aa49573294B13D169"
      }
    },
    portal: {
      [wc]: {
        address: "0x1876EA7702C0ad0C6A2ae6036DE7733edfBca519"
      }
    },
    l1StandardBridge: {
      [wc]: {
        address: "0xF05F0e4362859c3331Cb9395CBC201E3Fa6757Ea"
      }
    }
  },
  sourceId: wc
}), Ec = 97, CG = /* @__PURE__ */ d({
  id: 5611,
  name: "opBNB Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "tBNB",
    symbol: "tBNB"
  },
  rpcUrls: {
    default: { http: ["https://opbnb-testnet-rpc.bnbchain.org"] }
  },
  blockExplorers: {
    default: {
      name: "opbnbscan",
      url: "https://testnet.opbnbscan.com"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3705108
    },
    l2OutputOracle: {
      [Ec]: {
        address: "0xFf2394Bb843012562f4349C6632a0EcB92fC8810"
      }
    },
    portal: {
      [Ec]: {
        address: "0x4386C8ABf2009aC0c263462Da568DD9d46e52a31"
      }
    },
    l1StandardBridge: {
      [Ec]: {
        address: "0x677311Fd2cCc511Bbc0f581E8d9a07B033D5E840"
      }
    }
  },
  testnet: !0,
  sourceId: Ec
}), SG = /* @__PURE__ */ d({
  id: 1612,
  name: "OpenLedger",
  nativeCurrency: { name: "Open", symbol: "OPEN", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.openledger.xyz"] }
  },
  blockExplorers: {
    default: {
      name: "OpenLedger Explorer",
      url: "https://scan.openledger.xyz"
    }
  },
  testnet: !1
}), io = 1, IG = /* @__PURE__ */ d({
  ...W,
  id: 10,
  name: "OP Mainnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.optimism.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Optimism Explorer",
      url: "https://optimistic.etherscan.io",
      apiUrl: "https://api-optimistic.etherscan.io/api"
    }
  },
  contracts: {
    ...W.contracts,
    disputeGameFactory: {
      [io]: {
        address: "0xe5965Ab5962eDc7477C8520243A95517CD252fA9"
      }
    },
    l2OutputOracle: {
      [io]: {
        address: "0xdfe97868233d1aa22e815a266982f2cf17685a27"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 4286263
    },
    portal: {
      [io]: {
        address: "0xbEb5Fc579115071764c7423A4f12eDde41f106Ed"
      }
    },
    l1StandardBridge: {
      [io]: {
        address: "0x99C9fc46f92E8a1c0deC1b1747d010903E884bE1"
      }
    }
  },
  sourceId: io
}), xc = 5, AG = /* @__PURE__ */ d({
  ...W,
  id: 420,
  name: "Optimism Goerli",
  nativeCurrency: { name: "Goerli Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://goerli.optimism.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://goerli-optimism.etherscan.io",
      apiUrl: "https://goerli-optimism.etherscan.io/api"
    }
  },
  contracts: {
    ...W.contracts,
    l2OutputOracle: {
      [xc]: {
        address: "0xE6Dfba0953616Bacab0c9A8ecb3a9BBa77FC15c0"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 49461
    },
    portal: {
      [xc]: {
        address: "0x5b47E1A08Ea6d985D6649300584e6722Ec4B1383"
      }
    },
    l1StandardBridge: {
      [xc]: {
        address: "0x636Af16bf2f682dD3109e60102b8E1A089FedAa8"
      }
    }
  },
  testnet: !0,
  sourceId: xc
}), oo = 11155111, _G = /* @__PURE__ */ d({
  ...W,
  id: 11155420,
  name: "OP Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.optimism.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://optimism-sepolia.blockscout.com",
      apiUrl: "https://optimism-sepolia.blockscout.com/api"
    }
  },
  contracts: {
    ...W.contracts,
    disputeGameFactory: {
      [oo]: {
        address: "0x05F9613aDB30026FFd634f38e5C4dFd30a197Fa1"
      }
    },
    l2OutputOracle: {
      [oo]: {
        address: "0x90E9c4f8a994a250F6aEfd61CAFb4F2e895D458F"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1620204
    },
    portal: {
      [oo]: {
        address: "0x16Fc5058F25648194471939df75CF27A2fdC48BC"
      }
    },
    l1StandardBridge: {
      [oo]: {
        address: "0xFBb0621E0B23b5478B630BD55a5f21f67730B0F1"
      }
    }
  },
  testnet: !0,
  sourceId: oo
}), TG = /* @__PURE__ */ d({
  id: 62050,
  name: "Optopia",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc-mainnet.optopia.ai"] }
  },
  blockExplorers: {
    default: {
      name: "Optopia Explorer",
      url: "https://scan.optopia.ai"
    }
  },
  testnet: !1
}), UG = /* @__PURE__ */ d({
  id: 62049,
  name: "Optopia Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc-testnet.optopia.ai"] }
  },
  blockExplorers: {
    default: {
      name: "Optopia Explorer",
      url: "https://scan-testnet.optopia.ai"
    }
  },
  testnet: !0
}), $G = /* @__PURE__ */ d({
  id: 291,
  name: "Orderly",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.orderly.network"] }
  },
  blockExplorers: {
    default: {
      name: "Orderly Explorer",
      url: "https://explorer.orderly.network"
    }
  },
  testnet: !1
}), BG = /* @__PURE__ */ d({
  id: 4460,
  name: "Orderly Sepolia",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://l2-orderly-l2-4460-sepolia-8tc3sd7dvy.t.conduit.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Orderly Explorer",
      url: "https://explorerl2new-orderly-l2-4460-sepolia-8tc3sd7dvy.t.conduit.xyz"
    }
  },
  testnet: !0
}), DG = /* @__PURE__ */ d({
  id: 41144114,
  name: "Otim Devnet",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["http://devnet.otim.xyz"]
    }
  },
  contracts: {
    batchInvoker: {
      address: "0x5FbDB2315678afecb367f032d93F642f64180aa3"
    }
  }
}), OG = /* @__PURE__ */ d({
  id: 11297108109,
  name: "Palm",
  nativeCurrency: {
    decimals: 18,
    name: "PALM",
    symbol: "PALM"
  },
  rpcUrls: {
    default: {
      http: ["https://palm-mainnet.public.blastapi.io"],
      webSocket: ["wss://palm-mainnet.public.blastapi.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Chainlens",
      url: "https://palm.chainlens.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 15429248
    }
  }
}), PG = /* @__PURE__ */ d({
  id: 11297108099,
  name: "Palm Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "PALM",
    symbol: "PALM"
  },
  rpcUrls: {
    default: {
      http: ["https://palm-mainnet.public.blastapi.io"],
      webSocket: ["wss://palm-mainnet.public.blastapi.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Chainlens",
      url: "https://palm.chainlens.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 15429248
    }
  },
  testnet: !0
}), RG = /* @__PURE__ */ d({
  id: 3338,
  name: "Peaq",
  nativeCurrency: {
    decimals: 18,
    name: "peaq",
    symbol: "PEAQ"
  },
  rpcUrls: {
    default: {
      http: [
        "https://quicknode1.peaq.xyz",
        "https://quicknode2.peaq.xyz",
        "https://quicknode3.peaq.xyz"
      ],
      webSocket: [
        "wss://quicknode1.peaq.xyz",
        "wss://quicknode2.peaq.xyz",
        "wss://quicknode3.peaq.xyz"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Subscan",
      url: "https://peaq.subscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 3566354
    }
  }
}), vc = 1, NG = /* @__PURE__ */ d({
  id: 424,
  network: "pgn",
  name: "PGN",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.publicgoods.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "PGN Explorer",
      url: "https://explorer.publicgoods.network",
      apiUrl: "https://explorer.publicgoods.network/api"
    }
  },
  contracts: {
    l2OutputOracle: {
      [vc]: {
        address: "0x9E6204F750cD866b299594e2aC9eA824E2e5f95c"
      }
    },
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3380209
    },
    portal: {
      [vc]: {
        address: "0xb26Fd985c5959bBB382BAFdD0b879E149e48116c"
      }
    },
    l1StandardBridge: {
      [vc]: {
        address: "0xD0204B9527C1bA7bD765Fa5CCD9355d38338272b"
      }
    }
  },
  formatters: zp,
  sourceId: vc
}), kc = 11155111, LG = /* @__PURE__ */ d({
  id: 58008,
  network: "pgn-testnet",
  name: "PGN ",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.publicgoods.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "PGN Testnet Explorer",
      url: "https://explorer.sepolia.publicgoods.network",
      apiUrl: "https://explorer.sepolia.publicgoods.network/api"
    }
  },
  contracts: {
    l2OutputOracle: {
      [kc]: {
        address: "0xD5bAc3152ffC25318F848B3DD5dA6C85171BaEEe"
      }
    },
    portal: {
      [kc]: {
        address: "0xF04BdD5353Bb0EFF6CA60CfcC78594278eBfE179"
      }
    },
    l1StandardBridge: {
      [kc]: {
        address: "0xFaE6abCAF30D23e233AC7faF747F2fC3a5a6Bfa3"
      }
    },
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3754925
    }
  },
  formatters: zp,
  sourceId: kc,
  testnet: !0
}), MG = /* @__PURE__ */ d({
  id: 13381,
  name: "Phoenix Blockchain",
  nativeCurrency: { name: "Phoenix", symbol: "PHX", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.phoenixplorer.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Phoenixplorer",
      url: "https://phoenixplorer.com",
      apiUrl: "https://phoenixplorer.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0x498cF757a575cFF2c2Ed9f532f56Efa797f86442",
      blockCreated: 5620192
    }
  }
}), FG = /* @__PURE__ */ d({
  id: 7070,
  name: "Planq Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "PLQ",
    symbol: "PLQ"
  },
  rpcUrls: {
    default: {
      http: [
        "https://planq-rpc.nodies.app",
        "https://evm-rpc.planq.network",
        "https://jsonrpc.planq.nodestake.top"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Planq Explorer",
      url: "https://evm.planq.network"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 8470015
    }
  },
  testnet: !1
}), zG = /* @__PURE__ */ d({
  id: 9745,
  name: "Plasma",
  nativeCurrency: {
    name: "Plasma",
    symbol: "XPL",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.plasma.to"]
    }
  },
  blockExplorers: {
    default: {
      name: "PlasmaScan",
      url: "https://plasmascan.to"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 0
    }
  }
}), jG = /* @__PURE__ */ d({
  id: 9747,
  name: "Plasma Devnet",
  nativeCurrency: {
    name: "Devnet Plasma",
    symbol: "XPL",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://devnet-rpc.plasma.to"]
    }
  },
  testnet: !0,
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 0
    }
  }
}), HG = /* @__PURE__ */ d({
  id: 9746,
  name: "Plasma Testnet",
  nativeCurrency: {
    name: "Testnet Plasma",
    symbol: "XPL",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://testnet-rpc.plasma.to"]
    }
  },
  blockExplorers: {
    default: {
      name: "RouteScan",
      url: "https://testnet.plasmascan.to"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 0
    }
  },
  testnet: !0
}), qG = /* @__PURE__ */ d({
  ...or,
  id: 1612127,
  name: "PlayFi Albireo Testnet",
  network: "albireo",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://albireo-rpc.playfi.ai"],
      webSocket: ["wss://albireo-rpc-ws.playfi.ai/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "PlayFi Albireo Explorer",
      url: "https://albireo-explorer.playfi.ai"
    }
  },
  contracts: {
    multicall3: {
      address: "0xF9cda624FBC7e059355ce98a31693d299FACd963"
    }
  },
  testnet: !0
}), KG = /* @__PURE__ */ d({
  id: 242,
  name: "Plinga",
  nativeCurrency: { name: "Plinga", symbol: "PLINGA", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpcurl.mainnet.plgchain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Plgscan",
      url: "https://www.plgscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0x0989576160f2e7092908BB9479631b901060b6e4",
      blockCreated: 204489
    }
  }
}), VG = 1, GG = /* @__PURE__ */ d({
  id: 98865,
  name: "Plume (Legacy)",
  nativeCurrency: {
    name: "Plume Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.plumenetwork.xyz"],
      webSocket: ["wss://rpc.plumenetwork.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://explorer.plumenetwork.xyz",
      apiUrl: "https://explorer.plumenetwork.xyz/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 48577
    }
  },
  sourceId: VG
}), WG = 11155111, ZG = /* @__PURE__ */ d({
  id: 98864,
  name: "Plume Devnet (Legacy)",
  nativeCurrency: {
    name: "Plume Sepolia Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://test-rpc.plumenetwork.xyz"],
      webSocket: ["wss://test-rpc.plumenetwork.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://test-explorer.plumenetwork.xyz",
      apiUrl: "https://test-explorer.plumenetwork.xyz/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 481948
    }
  },
  testnet: !0,
  sourceId: WG
}), JG = 1, XG = /* @__PURE__ */ d({
  id: 98866,
  name: "Plume",
  nativeCurrency: {
    name: "Plume",
    symbol: "PLUME",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.plume.org"],
      webSocket: ["wss://rpc.plume.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://explorer.plume.org",
      apiUrl: "https://explorer.plume.org/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 39679
    }
  },
  sourceId: JG
}), YG = 11155111, QG = /* @__PURE__ */ d({
  id: 98867,
  name: "Plume Testnet",
  nativeCurrency: {
    name: "Plume",
    symbol: "PLUME",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://testnet-rpc.plume.org"],
      webSocket: ["wss://testnet-rpc.plume.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://testnet-explorer.plume.org",
      apiUrl: "https://testnet-explorer.plume.org/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 199712
    }
  },
  testnet: !0,
  sourceId: YG
}), eW = 11155111, tW = /* @__PURE__ */ d({
  id: 161221135,
  name: "Plume Testnet (Legacy)",
  nativeCurrency: {
    name: "Plume Sepolia Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://testnet-rpc.plumenetwork.xyz/http"],
      webSocket: ["wss://testnet-rpc.plumenetwork.xyz/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://testnet-explorer.plumenetwork.xyz",
      apiUrl: "https://testnet-explorer.plumenetwork.xyz/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 6022332
    }
  },
  testnet: !0,
  sourceId: eW
}), rW = /* @__PURE__ */ d({
  id: 631571,
  name: "Polter Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Polter GHST",
    symbol: "GHST"
  },
  rpcUrls: {
    default: {
      http: ["https://geist-polter.g.alchemy.com/public"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://polter-testnet.explorer.alchemy.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 11245
    }
  },
  testnet: !0
}), sW = /* @__PURE__ */ d({
  id: 137,
  name: "Polygon",
  nativeCurrency: { name: "POL", symbol: "POL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://polygon-rpc.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "PolygonScan",
      url: "https://polygonscan.com",
      apiUrl: "https://api.polygonscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 25770160
    }
  }
}), nW = /* @__PURE__ */ d({
  id: 80002,
  name: "Polygon Amoy",
  nativeCurrency: { name: "POL", symbol: "POL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-amoy.polygon.technology"]
    }
  },
  blockExplorers: {
    default: {
      name: "PolygonScan",
      url: "https://amoy.polygonscan.com",
      apiUrl: "https://api-amoy.polygonscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 3127388
    }
  },
  testnet: !0
}), iW = /* @__PURE__ */ d({
  id: 80001,
  name: "Polygon Mumbai",
  nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://80001.rpc.thirdweb.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "PolygonScan",
      url: "https://mumbai.polygonscan.com",
      apiUrl: "https://api-testnet.polygonscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 25770160
    }
  },
  testnet: !0
}), oW = /* @__PURE__ */ d({
  id: 1101,
  name: "Polygon zkEVM",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://zkevm-rpc.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "PolygonScan",
      url: "https://zkevm.polygonscan.com",
      apiUrl: "https://api-zkevm.polygonscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 57746
    }
  }
}), aW = /* @__PURE__ */ d({
  id: 2442,
  name: "Polygon zkEVM Cardona",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.cardona.zkevm-rpc.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "PolygonScan",
      url: "https://cardona-zkevm.polygonscan.com",
      apiUrl: "https://cardona-zkevm.polygonscan.com/api"
    }
  },
  testnet: !0,
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 114091
    }
  }
}), cW = /* @__PURE__ */ d({
  id: 1442,
  name: "Polygon zkEVM Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.public.zkevm-test.net"]
    }
  },
  blockExplorers: {
    default: {
      name: "PolygonScan",
      url: "https://testnet-zkevm.polygonscan.com",
      apiUrl: "https://testnet-zkevm.polygonscan.com/api"
    }
  },
  testnet: !0,
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 525686
    }
  }
}), lW = /* @__PURE__ */ d({
  id: 8008,
  name: "Polynomial",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.polynomial.fi"]
    }
  },
  blockExplorers: {
    default: {
      name: "Polynomial Scan",
      url: "https://polynomialscan.io"
    }
  },
  testnet: !1,
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11"
    }
  }
}), uW = /* @__PURE__ */ d({
  id: 80008,
  name: "Polynomia Sepolia",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.sepolia.polynomial.fi"]
    }
  },
  blockExplorers: {
    default: {
      name: "Polynomial Scan",
      url: "https://sepolia.polynomialscan.io"
    }
  },
  testnet: !0,
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11"
    }
  }
}), hW = /* @__PURE__ */ d({
  id: 23023,
  name: "PremiumBlock Testnet",
  nativeCurrency: { name: "Premium Block", symbol: "PBLK", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.premiumblock.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "PremiumBlocks Explorer",
      url: "https://scan.premiumblock.org"
    }
  },
  testnet: !0
}), dW = /* @__PURE__ */ d({
  id: 369,
  name: "PulseChain",
  nativeCurrency: { name: "Pulse", symbol: "PLS", decimals: 18 },
  testnet: !1,
  blockTime: 1e4,
  rpcUrls: {
    default: {
      http: ["https://rpc.pulsechain.com"],
      webSocket: ["wss://ws.pulsechain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "PulseScan",
      url: "https://ipfs.scan.pulsechain.com",
      apiUrl: "https://api.scan.pulsechain.com/api"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
}), pW = /* @__PURE__ */ d({
  id: 943,
  name: "PulseChain V4",
  testnet: !0,
  nativeCurrency: { name: "V4 Pulse", symbol: "v4PLS", decimals: 18 },
  blockTime: 1e4,
  rpcUrls: {
    default: {
      http: ["https://rpc.v4.testnet.pulsechain.com"],
      webSocket: ["wss://ws.v4.testnet.pulsechain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "PulseScan",
      url: "https://scan.v4.testnet.pulsechain.com",
      apiUrl: "https://scan.v4.testnet.pulsechain.com/api"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
}), fW = /* @__PURE__ */ d({
  id: 490092,
  name: "Pumpfi Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "PMPT",
    symbol: "PMPT"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc1testnet.pumpfi.me"]
    }
  },
  blockExplorers: {
    default: {
      name: "Pumpfi Testnet Scan",
      url: "https://testnetscan.pumpfi.me"
    }
  },
  testnet: !0
}), M1 = 11155111, mW = d({
  ...W,
  name: "Pyrope Testnet",
  testnet: !0,
  id: 695569,
  sourceId: M1,
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.pyropechain.com"],
      webSocket: ["wss://rpc.pyropechain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://pyrope.blockscout.com"
    }
  },
  contracts: {
    ...W.contracts,
    l1StandardBridge: {
      [M1]: {
        address: "0xC24932c31D9621aE9e792576152B7ef010cFC2F8"
      }
    }
  }
}), bW = /* @__PURE__ */ d({
  id: 766,
  name: "QL1",
  nativeCurrency: {
    decimals: 18,
    name: "QOM",
    symbol: "QOM"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.qom.one"]
    }
  },
  blockExplorers: {
    default: {
      name: "Ql1 Explorer",
      url: "https://scan.qom.one"
    }
  },
  contracts: {
    multicall3: {
      address: "0x7A52370716ea730585884F5BDB0f6E60C39b8C64"
    }
  },
  testnet: !1
}), yW = /* @__PURE__ */ d({
  id: 35441,
  name: "Q Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Q",
    symbol: "Q"
  },
  rpcUrls: {
    default: { http: ["https://rpc.q.org"] }
  },
  blockExplorers: {
    default: {
      name: "Q Mainnet Explorer",
      url: "https://explorer.q.org",
      apiUrl: "https://explorer.q.org/api"
    }
  }
}), gW = /* @__PURE__ */ d({
  id: 35443,
  name: "Q Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Q",
    symbol: "Q"
  },
  rpcUrls: {
    default: { http: ["https://rpc.qtestnet.org"] }
  },
  blockExplorers: {
    default: {
      name: "Q Testnet Explorer",
      url: "https://explorer.qtestnet.org",
      apiUrl: "https://explorer.qtestnet.org/api"
    }
  },
  testnet: !0
}), wW = /* @__PURE__ */ d({
  id: 111188,
  name: "re.al",
  nativeCurrency: {
    name: "reETH",
    decimals: 18,
    symbol: "reETH"
  },
  rpcUrls: {
    default: { http: ["https://rpc.realforreal.gelato.digital"] }
  },
  blockExplorers: {
    default: {
      name: "re.al Explorer",
      url: "https://explorer.re.al",
      apiUrl: "https://explorer.re.al/api/v2"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 695
    }
  }
}), EW = /* @__PURE__ */ d({
  id: 151,
  name: "Redbelly Network Mainnet",
  nativeCurrency: {
    name: "Redbelly Native Coin",
    symbol: "RBNT",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://governors.mainnet.redbelly.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Routescan",
      url: "https://redbelly.routescan.io",
      apiUrl: "https://api.routescan.io/v2/network/mainnet/evm/151/etherscan/api"
    }
  },
  testnet: !1
}), xW = /* @__PURE__ */ d({
  id: 153,
  name: "Redbelly Network Testnet",
  nativeCurrency: {
    name: "Redbelly Native Coin",
    symbol: "RBNT",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://governors.testnet.redbelly.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Routescan",
      url: "https://redbelly.testnet.routescan.io",
      apiUrl: "https://api.routescan.io/v2/network/testnet/evm/153_2/etherscan/api"
    }
  },
  testnet: !0
}), vW = /* @__PURE__ */ d({
  id: 50342,
  name: "Reddio",
  nativeCurrency: { name: "Reddio", symbol: "RED", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.reddio.com/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://reddio.cloud.blockscout.com",
      apiUrl: "https://reddio.cloud.blockscout.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 848849
    }
  },
  testnet: !1
}), kW = /* @__PURE__ */ d({
  id: 50341,
  name: "Reddio Sepolia",
  nativeCurrency: { name: "Reddio", symbol: "RED", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://reddio-dev.reddio.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Reddioscan",
      url: "https://reddio-devnet.l2scan.co",
      apiUrl: "https://reddio-devnet.l2scan.co/api"
    }
  },
  testnet: !0
}), Cc = 1, CW = d({
  ...W,
  name: "Redstone",
  id: 690,
  sourceId: Cc,
  nativeCurrency: { decimals: 18, name: "Ether", symbol: "ETH" },
  rpcUrls: {
    default: {
      http: ["https://rpc.redstonechain.com"],
      webSocket: ["wss://rpc.redstonechain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://explorer.redstone.xyz"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11"
    },
    portal: {
      [Cc]: {
        address: "0xC7bCb0e8839a28A1cFadd1CF716de9016CdA51ae",
        blockCreated: 19578329
      }
    },
    l2OutputOracle: {
      [Cc]: {
        address: "0xa426A052f657AEEefc298b3B5c35a470e4739d69",
        blockCreated: 19578337
      }
    },
    l1StandardBridge: {
      [Cc]: {
        address: "0xc473ca7E02af24c129c2eEf51F2aDf0411c1Df69",
        blockCreated: 19578331
      }
    }
  }
}), SW = /* @__PURE__ */ d({
  id: 47805,
  name: "REI Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "REI",
    symbol: "REI"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.rei.network"],
      webSocket: ["wss://rpc.rei.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "REI Scan",
      url: "https://scan.rei.network"
    }
  },
  testnet: !1
}), IW = /* @__PURE__ */ d({
  id: 1729,
  name: "Reya Network",
  nativeCurrency: { decimals: 18, name: "Ether", symbol: "ETH" },
  rpcUrls: {
    default: {
      http: ["https://rpc.reya.network"],
      webSocket: ["wss://ws.reya.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Reya Network Explorer",
      url: "https://explorer.reya.network"
    }
  },
  testnet: !1
}), AW = /* @__PURE__ */ d({
  id: 11155931,
  name: "RISE Testnet",
  nativeCurrency: { name: "RISE Testnet Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://testnet.riselabs.xyz"],
      webSocket: ["wss://testnet.riselabs.xyz/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://explorer.testnet.riselabs.xyz/",
      apiUrl: "https://explorer.testnet.riselabs.xyz/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11"
    }
  },
  testnet: !0
}), _W = /* @__PURE__ */ d({
  id: 753,
  name: "Rivalz",
  nativeCurrency: { decimals: 18, name: "Ether", symbol: "ETH" },
  rpcUrls: {
    default: {
      http: ["https://rivalz.calderachain.xyz/http"]
    }
  },
  blockExplorers: {
    default: {
      name: "Rivalz Caldera Explorer",
      url: "https://rivalz.calderaexplorer.xyz"
    }
  },
  testnet: !1
}), TW = /* @__PURE__ */ d({
  id: 570,
  name: "Rollux Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Syscoin",
    symbol: "SYS"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.rollux.com"],
      webSocket: ["wss://rpc.rollux.com/wss"]
    }
  },
  blockExplorers: {
    default: {
      name: "RolluxExplorer",
      url: "https://explorer.rollux.com",
      apiUrl: "https://explorer.rollux.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 119222
    }
  }
}), UW = /* @__PURE__ */ d({
  id: 57e3,
  name: "Rollux Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Syscoin",
    symbol: "SYS"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc-tanenbaum.rollux.com/"],
      webSocket: ["wss://rpc-tanenbaum.rollux.com/wss"]
    }
  },
  blockExplorers: {
    default: {
      name: "RolluxTestnetExplorer",
      url: "https://rollux.tanenbaum.io",
      apiUrl: "https://rollux.tanenbaum.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1813675
    }
  }
}), $W = /* @__PURE__ */ d({
  id: 2020,
  name: "Ronin",
  nativeCurrency: { name: "RON", symbol: "RON", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://api.roninchain.com/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Ronin Explorer",
      url: "https://app.roninchain.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 26023535
    }
  }
}), BW = /* @__PURE__ */ d({
  id: 7668,
  name: "The Root Network",
  nativeCurrency: {
    decimals: 18,
    name: "XRP",
    symbol: "XRP"
  },
  rpcUrls: {
    default: {
      http: ["https://root.rootnet.live/archive"],
      webSocket: ["wss://root.rootnet.live/archive/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Rootscan",
      url: "https://rootscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xc9C2E2429AeC354916c476B30d729deDdC94988d",
      blockCreated: 9218338
    }
  }
}), DW = /* @__PURE__ */ d({
  id: 7672,
  name: "The Root Network - Porcini",
  nativeCurrency: {
    decimals: 18,
    name: "XRP",
    symbol: "XRP"
  },
  rpcUrls: {
    default: {
      http: ["https://porcini.rootnet.app/archive"],
      webSocket: ["wss://porcini.rootnet.app/archive/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Rootscan",
      url: "https://porcini.rootscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xc9C2E2429AeC354916c476B30d729deDdC94988d",
      blockCreated: 10555692
    }
  },
  testnet: !0
}), OW = /* @__PURE__ */ d({
  id: 30,
  name: "Rootstock Mainnet",
  network: "rootstock",
  nativeCurrency: {
    decimals: 18,
    name: "Rootstock Bitcoin",
    symbol: "RBTC"
  },
  rpcUrls: {
    default: { http: ["https://public-node.rsk.co"] }
  },
  blockExplorers: {
    default: {
      name: "RSK Explorer",
      url: "https://explorer.rsk.co"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 4249540
    }
  }
}), PW = /* @__PURE__ */ d({
  id: 31,
  name: "Rootstock Testnet",
  network: "rootstock",
  nativeCurrency: {
    decimals: 18,
    name: "Rootstock Bitcoin",
    symbol: "tRBTC"
  },
  rpcUrls: {
    default: { http: ["https://public-node.testnet.rsk.co"] }
  },
  blockExplorers: {
    default: {
      name: "RSK Explorer",
      url: "https://explorer.testnet.rootstock.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 2771150
    }
  },
  testnet: !0
}), Sc = 1, RW = /* @__PURE__ */ d({
  ...W,
  id: 12553,
  name: "RSS3 VSL Mainnet",
  nativeCurrency: { name: "RSS3", symbol: "RSS3", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.rss3.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "RSS3 VSL Mainnet Scan",
      url: "https://scan.rss3.io",
      apiUrl: "https://scan.rss3.io/api"
    }
  },
  contracts: {
    ...W.contracts,
    l2OutputOracle: {
      [Sc]: {
        address: "0xE6f24d2C32B3109B18ed33cF08eFb490b1e09C10"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14193
    },
    portal: {
      [Sc]: {
        address: "0x6A12432491bbbE8d3babf75F759766774C778Db4",
        blockCreated: 19387057
      }
    },
    l1StandardBridge: {
      [Sc]: {
        address: "0x4cbab69108Aa72151EDa5A3c164eA86845f18438"
      }
    }
  },
  sourceId: Sc
}), Ic = 11155111, NW = /* @__PURE__ */ d({
  ...W,
  id: 2331,
  name: "RSS3 VSL Sepolia Testnet",
  nativeCurrency: { name: "RSS3", symbol: "RSS3", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.rss3.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "RSS3 VSL Sepolia Testnet Scan",
      url: "https://scan.testnet.rss3.io",
      apiUrl: "https://scan.testnet.rss3.io/api"
    }
  },
  contracts: {
    ...W.contracts,
    l2OutputOracle: {
      [Ic]: {
        address: "0xDb5c46C3Eaa6Ed6aE8b2379785DF7dd029C0dC81"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 55697
    },
    portal: {
      [Ic]: {
        address: "0xcBD77E8E1E7F06B25baDe67142cdE82652Da7b57",
        blockCreated: 5345035
      }
    },
    l1StandardBridge: {
      [Ic]: {
        address: "0xdDD29bb63B0839FB1cE0eE439Ff027738595D07B"
      }
    }
  },
  testnet: !0,
  sourceId: Ic
}), LW = /* @__PURE__ */ d({
  id: 7225878,
  name: "Saakuru Mainnet",
  nativeCurrency: { name: "OAS", symbol: "OAS", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.saakuru.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Saakuru Explorer",
      url: "https://explorer.saakuru.network"
    }
  },
  testnet: !1
}), MW = /* @__PURE__ */ d({
  id: 5464,
  name: "Saga",
  network: "saga",
  nativeCurrency: {
    decimals: 18,
    name: "gas",
    symbol: "GAS"
  },
  rpcUrls: {
    default: { http: ["https://sagaevm.jsonrpc.sagarpc.io"] }
  },
  blockExplorers: {
    default: {
      name: "Saga Explorer",
      url: "https://sagaevm.sagaexplorer.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0x864DDc9B50B9A0dF676d826c9B9EDe9F8913a160",
      blockCreated: 467530
    }
  }
}), FW = /* @__PURE__ */ d({
  id: 2021,
  name: "Saigon Testnet",
  nativeCurrency: { name: "RON", symbol: "RON", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://saigon-testnet.roninchain.com/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Saigon Explorer",
      url: "https://saigon-app.roninchain.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 18736871
    }
  },
  testnet: !0
}), zW = /* @__PURE__ */ d({
  id: 1996,
  name: "Sanko",
  nativeCurrency: { name: "DMT", symbol: "DMT", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.sanko.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Sanko Explorer",
      url: "https://explorer.sanko.xyz"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 37
    }
  },
  testnet: !1
}), jW = /* @__PURE__ */ d({
  id: 23294,
  name: "Oasis Sapphire",
  network: "sapphire",
  nativeCurrency: { name: "Sapphire Rose", symbol: "ROSE", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sapphire.oasis.io"],
      webSocket: ["wss://sapphire.oasis.io/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Oasis Explorer",
      url: "https://explorer.oasis.io/mainnet/sapphire"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 734531
    }
  }
}), HW = /* @__PURE__ */ d({
  id: 23295,
  name: "Oasis Sapphire Testnet",
  network: "sapphire-testnet",
  nativeCurrency: { name: "Sapphire Test Rose", symbol: "TEST", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://testnet.sapphire.oasis.dev"],
      webSocket: ["wss://testnet.sapphire.oasis.dev/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Oasis Explorer",
      url: "https://explorer.oasis.io/testnet/sapphire"
    }
  },
  testnet: !0
}), qW = /* @__PURE__ */ d({
  id: 3109,
  name: "SatoshiVM Alpha Mainnet",
  nativeCurrency: {
    name: "BTC",
    symbol: "BTC",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://alpha-rpc-node-http.svmscan.io"] }
  },
  blockExplorers: {
    default: {
      name: "blockscout",
      url: "https://svmscan.io",
      apiUrl: "https://svmscan.io/api"
    }
  }
}), KW = /* @__PURE__ */ d({
  id: 3110,
  name: "SatoshiVM Testnet",
  nativeCurrency: {
    name: "BTC",
    symbol: "BTC",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://test-rpc-node-http.svmscan.io"] }
  },
  blockExplorers: {
    default: {
      name: "blockscout",
      url: "https://testnet.svmscan.io",
      apiUrl: "https://testnet.svmscan.io/api"
    }
  },
  testnet: !0
}), VW = /* @__PURE__ */ d({
  id: 534352,
  name: "Scroll",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.scroll.io"],
      webSocket: ["wss://wss-rpc.scroll.io/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Scrollscan",
      url: "https://scrollscan.com",
      apiUrl: "https://api.scrollscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14
    }
  },
  testnet: !1
}), GW = /* @__PURE__ */ d({
  id: 534351,
  name: "Scroll Sepolia",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia-rpc.scroll.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Scrollscan",
      url: "https://sepolia.scrollscan.com",
      apiUrl: "https://api-sepolia.scrollscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 9473
    }
  },
  testnet: !0
}), WW = /* @__PURE__ */ d({
  id: 1329,
  name: "Sei Network",
  nativeCurrency: { name: "Sei", symbol: "SEI", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://evm-rpc.sei-apis.com/"],
      webSocket: ["wss://evm-ws.sei-apis.com/"]
    }
  },
  blockExplorers: {
    default: {
      name: "Seitrace",
      url: "https://seitrace.com",
      apiUrl: "https://seitrace.com/pacific-1/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}), ZW = /* @__PURE__ */ d({
  id: 713715,
  name: "Sei Devnet",
  nativeCurrency: { name: "Sei", symbol: "SEI", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://evm-rpc-arctic-1.sei-apis.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Seitrace",
      url: "https://seitrace.com"
    }
  },
  testnet: !0
}), JW = /* @__PURE__ */ d({
  id: 5124,
  name: "Seismic Devnet",
  nativeCurrency: { name: "Seismic Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://node-2.seismicdev.net/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Seismic Devnet Explorer",
      url: "https://explorer-2.seismicdev.net"
    }
  },
  testnet: !0
}), XW = /* @__PURE__ */ d({
  id: 1328,
  name: "Sei Testnet",
  nativeCurrency: { name: "Sei", symbol: "SEI", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://evm-rpc-testnet.sei-apis.com"],
      webSocket: ["wss://evm-ws-testnet.sei-apis.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Seitrace",
      url: "https://seitrace.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 98697651
    }
  },
  testnet: !0
}), YW = /* @__PURE__ */ d({
  id: 11155111,
  name: "Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.drpc.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://sepolia.etherscan.io",
      apiUrl: "https://api-sepolia.etherscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 751532
    },
    ensUniversalResolver: {
      address: "0xeeeeeeee14d718c2b47d9923deab1335e144eeee",
      blockCreated: 8928790
    }
  },
  testnet: !0
}), Ac = 1, QW = /* @__PURE__ */ d({
  ...W,
  id: 360,
  name: "Shape",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.shape.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "shapescan",
      url: "https://shapescan.xyz",
      apiUrl: "https://shapescan.xyz/api"
    }
  },
  contracts: {
    ...W.contracts,
    l2OutputOracle: {
      [Ac]: {
        address: "0x6Ef8c69CfE4635d866e3E02732068022c06e724D",
        blockCreated: 20369940
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1
    },
    portal: {
      [Ac]: {
        address: "0xEB06fFa16011B5628BaB98E29776361c83741dd3",
        blockCreated: 20369933
      }
    },
    l1StandardBridge: {
      [Ac]: {
        address: "0x62Edd5f4930Ea92dCa3fB81689bDD9b9d076b57B",
        blockCreated: 20369935
      }
    }
  },
  sourceId: Ac
}), eZ = 11155111, tZ = /* @__PURE__ */ d({
  ...W,
  id: 11011,
  name: "Shape Sepolia Testnet",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.shape.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "blockscout",
      url: "https://explorer-sepolia.shape.network/",
      apiUrl: "https://explorer-sepolia.shape.network/api/v2"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1
    }
  },
  testnet: !0,
  sourceId: eZ
}), rZ = /* @__PURE__ */ d({
  id: 8118,
  name: "Shardeum",
  nativeCurrency: { name: "Shardeum", symbol: "SHM", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://api.shardeum.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Shardeum Explorer",
      url: "https://explorer.shardeum.org"
    }
  },
  testnet: !1
}), sZ = /* @__PURE__ */ d({
  id: 8082,
  name: "Shardeum Sphinx",
  nativeCurrency: { name: "SHARDEUM", symbol: "SHM", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sphinx.shardeum.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Shardeum Explorer",
      url: "https://explorer-sphinx.shardeum.org"
    }
  },
  testnet: !0
}), nZ = /* @__PURE__ */ d({
  id: 109,
  name: "Shibarium",
  network: "shibarium",
  nativeCurrency: { name: "Bone", symbol: "BONE", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.shibrpc.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://shibariumscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0x864Bf681ADD6052395188A89101A1B37d3B4C961",
      blockCreated: 265900
    }
  }
}), iZ = /* @__PURE__ */ d({
  id: 157,
  name: "Puppynet Shibarium",
  nativeCurrency: {
    decimals: 18,
    name: "Bone",
    symbol: "BONE"
  },
  rpcUrls: {
    default: { http: ["https://puppynet.shibrpc.com"] }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://puppyscan.shib.io",
      apiUrl: "https://puppyscan.shib.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xA4029b74FBA366c926eDFA7Dd10B21C621170a4c",
      blockCreated: 3035769
    }
  },
  testnet: !0
}), oZ = /* @__PURE__ */ d({
  id: 336,
  name: "Shiden",
  nativeCurrency: {
    decimals: 18,
    name: "SDN",
    symbol: "SDN"
  },
  rpcUrls: {
    default: {
      http: ["https://shiden.public.blastapi.io"],
      webSocket: ["wss://shiden-rpc.dwellir.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Shiden Scan",
      url: "https://shiden.subscan.io"
    }
  },
  testnet: !1
}), aZ = /* @__PURE__ */ d({
  id: 148,
  name: "Shimmer",
  network: "shimmer",
  nativeCurrency: {
    decimals: 18,
    name: "Shimmer",
    symbol: "SMR"
  },
  rpcUrls: {
    default: {
      http: ["https://json-rpc.evm.shimmer.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Shimmer Network Explorer",
      url: "https://explorer.evm.shimmer.network",
      apiUrl: "https://explorer.evm.shimmer.network/api"
    }
  }
}), cZ = /* @__PURE__ */ d({
  id: 1073,
  name: "Shimmer Testnet",
  network: "shimmer-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Shimmer",
    symbol: "SMR"
  },
  rpcUrls: {
    default: {
      http: ["https://json-rpc.evm.testnet.shimmer.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Shimmer Network Explorer",
      url: "https://explorer.evm.testnet.shimmer.network",
      apiUrl: "https://explorer.evm.testnet.shimmer.network/api"
    }
  },
  testnet: !0
}), lZ = /* @__PURE__ */ d({
  id: 97453,
  name: "Sidra Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Sidra Digital Asset",
    symbol: "SDA"
  },
  rpcUrls: {
    default: {
      http: ["https://node.sidrachain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Sidra Chain Explorer",
      url: "https://ledger.sidrachain.com"
    }
  }
}), uZ = /* @__PURE__ */ d({
  id: 2355,
  name: "Silicon zkEVM",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        "https://rpc.silicon.network",
        "https://silicon-mainnet.nodeinfra.com"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "SiliconScope",
      url: "https://scope.silicon.network"
    }
  }
}), hZ = /* @__PURE__ */ d({
  id: 1722641160,
  name: "Silicon Sepolia zkEVM",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        "https://rpc-sepolia.silicon.network",
        "https://silicon-testnet.nodeinfra.com"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "SiliconSepoliaScope",
      url: "https://scope-sepolia.silicon.network"
    }
  },
  testnet: !0
}), dZ = /* @__PURE__ */ d({
  id: 98,
  name: "Six Protocol",
  nativeCurrency: {
    decimals: 18,
    name: "SIX",
    symbol: "SIX"
  },
  rpcUrls: {
    default: {
      http: ["https://sixnet-rpc-evm.sixprotocol.net"]
    }
  },
  blockExplorers: {
    default: {
      name: "Six Protocol Scan",
      url: "https://sixscan.io/sixnet"
    }
  },
  testnet: !1
}), pZ = /* @__PURE__ */ d({
  id: 391845894,
  name: "SKALE | Block Brawlers",
  nativeCurrency: { name: "BRAWL", symbol: "BRAWL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/frayed-decent-antares"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/frayed-decent-antares"]
    }
  },
  blockExplorers: {
    default: {
      name: "SKALE Explorer",
      url: "https://frayed-decent-antares.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {}
}), fZ = /* @__PURE__ */ d({
  id: 1564830818,
  name: "SKALE Calypso Hub",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/honorable-steel-rasalhague"],
      webSocket: [
        "wss://mainnet.skalenodes.com/v1/ws/honorable-steel-rasalhague"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "SKALE Explorer",
      url: "https://honorable-steel-rasalhague.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3107626
    }
  }
}), mZ = /* @__PURE__ */ d({
  id: 974399131,
  name: "SKALE Calypso Testnet",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://testnet.skalenodes.com/v1/giant-half-dual-testnet"],
      webSocket: ["wss://testnet.skalenodes.com/v1/ws/giant-half-dual-testnet"]
    }
  },
  blockExplorers: {
    default: {
      name: "SKALE Explorer",
      url: "https://giant-half-dual-testnet.explorer.testnet.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 103220
    }
  },
  testnet: !0
}), bZ = /* @__PURE__ */ d({
  id: 1026062157,
  name: "SKALE | CryptoBlades",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/affectionate-immediate-pollux"],
      webSocket: [
        "wss://mainnet.skalenodes.com/v1/ws/affectionate-immediate-pollux"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "SKALE Explorer",
      url: "https://affectionate-immediate-pollux.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {}
}), yZ = /* @__PURE__ */ d({
  id: 1032942172,
  name: "SKALE | Crypto Colosseum",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/haunting-devoted-deneb"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/haunting-devoted-deneb"]
    }
  },
  blockExplorers: {
    default: {
      name: "SKALE Explorer",
      url: "https://haunting-devoted-deneb.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {}
}), gZ = /* @__PURE__ */ d({
  id: 2046399126,
  name: "SKALE Europa Hub",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/elated-tan-skat"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/elated-tan-skat"]
    }
  },
  blockExplorers: {
    default: {
      name: "SKALE Explorer",
      url: "https://elated-tan-skat.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3113495
    }
  }
}), wZ = /* @__PURE__ */ d({
  id: 1444673419,
  name: "SKALE Europa Testnet",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://testnet.skalenodes.com/v1/juicy-low-small-testnet"],
      webSocket: ["wss://testnet.skalenodes.com/v1/ws/juicy-low-small-testnet"]
    }
  },
  blockExplorers: {
    default: {
      name: "SKALE Explorer",
      url: "https://juicy-low-small-testnet.explorer.testnet.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 110858
    }
  },
  testnet: !0
}), EZ = /* @__PURE__ */ d({
  id: 2139927552,
  name: "Exorde Network",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/light-vast-diphda"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/light-vast-diphda"]
    }
  },
  blockExplorers: {
    default: {
      name: "SKALE Explorer",
      url: "https://light-vast-diphda.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {}
}), xZ = /* @__PURE__ */ d({
  id: 1273227453,
  name: "SKALE | Human Protocol",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/wan-red-ain"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/wan-red-ain"]
    }
  },
  blockExplorers: {
    default: {
      name: "SKALE Explorer",
      url: "https://wan-red-ain.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {}
}), vZ = /* @__PURE__ */ d({
  id: 1482601649,
  name: "SKALE Nebula Hub",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/green-giddy-denebola"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/green-giddy-denebola"]
    }
  },
  blockExplorers: {
    default: {
      name: "SKALE Explorer",
      url: "https://green-giddy-denebola.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 2372986
    }
  }
}), kZ = /* @__PURE__ */ d({
  id: 37084624,
  name: "SKALE Nebula Testnet",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://testnet.skalenodes.com/v1/lanky-ill-funny-testnet"],
      webSocket: ["wss://testnet.skalenodes.com/v1/ws/lanky-ill-funny-testnet"]
    }
  },
  blockExplorers: {
    default: {
      name: "SKALE Explorer",
      url: "https://lanky-ill-funny-testnet.explorer.testnet.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 105141
    }
  },
  testnet: !0
}), CZ = /* @__PURE__ */ d({
  id: 278611351,
  name: "SKALE | Razor Network",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/turbulent-unique-scheat"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/turbulent-unique-scheat"]
    }
  },
  blockExplorers: {
    default: {
      name: "SKALE Explorer",
      url: "https://turbulent-unique-scheat.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {}
}), SZ = /* @__PURE__ */ d({
  id: 1350216234,
  name: "SKALE Titan Hub",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/parallel-stormy-spica"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/parallel-stormy-spica"]
    }
  },
  blockExplorers: {
    default: {
      name: "SKALE Explorer",
      url: "https://parallel-stormy-spica.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 2076458
    }
  }
}), IZ = /* @__PURE__ */ d({
  id: 1020352220,
  name: "SKALE Titan Testnet",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://testnet.skalenodes.com/v1/aware-fake-trim-testnet"],
      webSocket: ["wss://testnet.skalenodes.com/v1/ws/aware-fake-trim-testnet"]
    }
  },
  blockExplorers: {
    default: {
      name: "SKALE Explorer",
      url: "https://aware-fake-trim-testnet.explorer.testnet.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 104072
    }
  },
  testnet: !0
}), AZ = /* @__PURE__ */ d({
  id: 984123,
  name: "Forma Sketchpad",
  network: "sketchpad",
  nativeCurrency: {
    symbol: "TIA",
    name: "TIA",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.sketchpad-1.forma.art"],
      webSocket: ["wss://ws.sketchpad-1.forma.art"]
    }
  },
  blockExplorers: {
    default: {
      name: "Sketchpad Explorer",
      url: "https://explorer.sketchpad-1.forma.art"
    }
  },
  testnet: !0
}), ao = 1, _Z = /* @__PURE__ */ d({
  ...W,
  id: 2192,
  network: "snaxchain-mainnet",
  name: "SnaxChain",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.snaxchain.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Snax Explorer",
      url: "https://explorer.snaxchain.io",
      apiUrl: "https://explorer.snaxchain.io/api"
    }
  },
  contracts: {
    ...W.contracts,
    disputeGameFactory: {
      [ao]: {
        address: "0x472562Fcf26D6b2793f8E0b0fB660ba0E5e08A46"
      }
    },
    l2OutputOracle: {
      [ao]: {
        address: "0x2172e492Fc807F5d5645D0E3543f139ECF539294"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11"
    },
    portal: {
      [ao]: {
        address: "0x79f446D024d74D0Bb6E699C131c703463c5D65E9"
      }
    },
    l1StandardBridge: {
      [ao]: {
        address: "0x6534Bdb6b5c060d3e6aa833433333135eFE8E0aA"
      }
    }
  },
  sourceId: ao
}), co = 11155111, TZ = /* @__PURE__ */ d({
  ...W,
  id: 13001,
  network: "snaxchain-testnet",
  name: "SnaxChain Testnet",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://testnet.snaxchain.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Snax Explorer",
      url: "https://testnet-explorer.snaxchain.io",
      apiUrl: "https://testnet-explorer.snaxchain.io/api"
    }
  },
  contracts: {
    ...W.contracts,
    disputeGameFactory: {
      [co]: {
        address: "0x206a75d89d45F146C54020F132FF93bEDD09f55E"
      }
    },
    l2OutputOracle: {
      [co]: {
        address: "0x60e3A368a4cdCEf85ffB964e372726F56A46221e"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11"
    },
    portal: {
      [co]: {
        address: "0xb5afdd0E8dDF081Ef90e8A3e0c7b5798e66E954E"
      }
    },
    l1StandardBridge: {
      [co]: {
        address: "0xbd37E1a59D4C00C9A46F75018dffd84061bC5f74"
      }
    }
  },
  testnet: !0,
  sourceId: co
}), UZ = /* @__PURE__ */ d({
  id: 50312,
  name: "Somnia Testnet",
  nativeCurrency: { name: "STT", symbol: "STT", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://dream-rpc.somnia.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Somnia Testnet Explorer",
      url: "https://shannon-explorer.somnia.network/",
      apiUrl: "https://shannon-explorer.somnia.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0x841b8199E6d3Db3C6f264f6C2bd8848b3cA64223",
      blockCreated: 71314235
    }
  },
  testnet: !0
}), lo = 1, $Z = /* @__PURE__ */ d({
  ...W,
  id: 1868,
  name: "Soneium Mainnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.soneium.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://soneium.blockscout.com",
      apiUrl: "https://soneium.blockscout.com/api"
    }
  },
  contracts: {
    ...W.contracts,
    disputeGameFactory: {
      [lo]: {
        address: "0x512a3d2c7a43bd9261d2b8e8c9c70d4bd4d503c0"
      }
    },
    l2OutputOracle: {
      [lo]: {
        address: "0x0000000000000000000000000000000000000000"
      }
    },
    portal: {
      [lo]: {
        address: "0x88e529a6ccd302c948689cd5156c83d4614fae92",
        blockCreated: 7061266
      }
    },
    l1StandardBridge: {
      [lo]: {
        address: "0xeb9bf100225c214efc3e7c651ebbadcf85177607",
        blockCreated: 7061266
      }
    },
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1
    }
  },
  sourceId: lo
}), uo = 11155111, BZ = /* @__PURE__ */ d({
  ...W,
  id: 1946,
  name: "Soneium Minato Testnet",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.minato.soneium.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://soneium-minato.blockscout.com",
      apiUrl: "https://soneium-minato.blockscout.com/api"
    }
  },
  contracts: {
    ...W.contracts,
    disputeGameFactory: {
      [uo]: {
        address: "0xB3Ad2c38E6e0640d7ce6aA952AB3A60E81bf7a01"
      }
    },
    l2OutputOracle: {
      [uo]: {
        address: "0x710e5286C746eC38beeB7538d0146f60D27be343"
      }
    },
    portal: {
      [uo]: {
        address: "0x65ea1489741A5D72fFdD8e6485B216bBdcC15Af3",
        blockCreated: 6466136
      }
    },
    l1StandardBridge: {
      [uo]: {
        address: "0x5f5a404A5edabcDD80DB05E8e54A78c9EBF000C2",
        blockCreated: 6466136
      }
    },
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1
    }
  },
  testnet: !0,
  sourceId: uo
}), DZ = /* @__PURE__ */ d({
  id: 19,
  name: "Songbird Canary-Network",
  nativeCurrency: {
    decimals: 18,
    name: "Songbird",
    symbol: "SGB"
  },
  rpcUrls: {
    default: { http: ["https://songbird-api.flare.network/ext/C/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Songbird Explorer",
      url: "https://songbird-explorer.flare.network",
      apiUrl: "https://songbird-explorer.flare.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 13382504
    }
  }
}), OZ = /* @__PURE__ */ d({
  id: 16,
  name: "Songbird Testnet Coston",
  nativeCurrency: {
    decimals: 18,
    name: "Coston Flare",
    symbol: "CFLR"
  },
  rpcUrls: {
    default: { http: ["https://coston-api.flare.network/ext/C/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Coston Explorer",
      url: "https://coston-explorer.flare.network",
      apiUrl: "https://coston-explorer.flare.network/api"
    }
  },
  testnet: !0
}), PZ = /* @__PURE__ */ d({
  id: 146,
  name: "Sonic",
  blockTime: 630,
  nativeCurrency: {
    decimals: 18,
    name: "Sonic",
    symbol: "S"
  },
  rpcUrls: {
    default: { http: ["https://rpc.soniclabs.com"] }
  },
  blockExplorers: {
    default: {
      name: "Sonic Explorer",
      url: "https://sonicscan.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 60
    }
  },
  testnet: !1
}), RZ = /* @__PURE__ */ d({
  id: 57054,
  name: "Sonic Blaze Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Sonic",
    symbol: "S"
  },
  rpcUrls: {
    default: { http: ["https://rpc.blaze.soniclabs.com"] }
  },
  blockExplorers: {
    default: {
      name: "Sonic Blaze Testnet Explorer",
      url: "https://testnet.sonicscan.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1100
    }
  },
  testnet: !0
}), NZ = /* @__PURE__ */ d({
  id: 64165,
  name: "Sonic Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Sonic",
    symbol: "S"
  },
  rpcUrls: {
    default: { http: ["https://rpc.testnet.soniclabs.com"] }
  },
  blockExplorers: {
    default: {
      name: "Sonic Testnet Explorer",
      url: "https://testnet.soniclabs.com/"
    }
  },
  testnet: !0
}), LZ = /* @__PURE__ */ d({
  ...or,
  id: 50104,
  name: "Sophon",
  nativeCurrency: {
    decimals: 18,
    name: "Sophon",
    symbol: "SOPH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.sophon.xyz"],
      webSocket: ["wss://rpc.sophon.xyz/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Sophon Block Explorer",
      url: "https://explorer.sophon.xyz"
    }
  },
  contracts: {
    multicall3: {
      address: "0x5f4867441d2416cA88B1b3fd38f21811680CD2C8",
      blockCreated: 116
    }
  },
  testnet: !1
}), MZ = /* @__PURE__ */ d({
  ...or,
  id: 531050104,
  name: "Sophon Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Sophon",
    symbol: "SOPH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.sophon.xyz"],
      webSocket: ["wss://rpc.testnet.sophon.xyz/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Sophon Block Explorer",
      url: "https://explorer.testnet.sophon.xyz"
    }
  },
  contracts: {
    multicall3: {
      address: "0x83c04d112adedA2C6D9037bb6ecb42E7f0b108Af",
      blockCreated: 15642
    }
  },
  testnet: !0
}), FZ = /* @__PURE__ */ d({
  id: 100021,
  name: "Sova",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.sova.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Sova Block Explorer",
      url: "hhttps://explorer.sova.io"
    }
  },
  testnet: !1
}), zZ = /* @__PURE__ */ d({
  id: 120893,
  name: "Sova Network Sepolia",
  nativeCurrency: {
    decimals: 18,
    name: "Sepolia Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.sova.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Sova Sepolia Explorer",
      url: "https://explorer.testnet.sova.io"
    }
  },
  testnet: !0
}), jZ = /* @__PURE__ */ d({
  id: 88882,
  name: "Chiliz Spicy Testnet",
  network: "chiliz-spicy-Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "CHZ",
    symbol: "CHZ"
  },
  rpcUrls: {
    default: {
      http: [
        "https://spicy-rpc.chiliz.com",
        "https://chiliz-spicy-rpc.publicnode.com"
      ],
      webSocket: [
        "wss://spicy-rpc-ws.chiliz.com",
        "wss://chiliz-spicy-rpc.publicnode.com"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Chiliz Explorer",
      url: "http://spicy-explorer.chiliz.com",
      apiUrl: "http://spicy-explorer.chiliz.com/api"
    }
  },
  testnet: !0
}), F1 = /* @__PURE__ */ d({
  ...jp,
  id: 1660990954,
  name: "Status Network Sepolia",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://public.sepolia.rpc.status.network"],
      webSocket: ["wss://public.sepolia.rpc.status.network/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://sepoliascan.status.network"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1578364
    }
  },
  testnet: !0
}), HZ = /* @__PURE__ */ d({
  id: 1234,
  name: "Step Network",
  nativeCurrency: { name: "FITFI", symbol: "FITFI", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.step.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Step Scan",
      url: "https://stepscan.io"
    }
  },
  testnet: !1
}), qZ = /* @__PURE__ */ d({
  id: 1514,
  name: "Story",
  nativeCurrency: {
    decimals: 18,
    name: "IP Token",
    symbol: "IP"
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 340998
    },
    ensRegistry: {
      address: "0x5dc881dda4e4a8d312be3544ad13118d1a04cb17",
      blockCreated: 648924
    },
    ensUniversalResolver: {
      address: "0xddfb18888a9466688235887dec2a10c4f5effee9",
      blockCreated: 649114
    }
  },
  rpcUrls: {
    default: { http: ["https://mainnet.storyrpc.io"] }
  },
  blockExplorers: {
    default: {
      name: "Story explorer",
      url: "https://storyscan.io",
      apiUrl: "https://storyscan.io/api/v2"
    }
  },
  ensTlds: [".ip"],
  testnet: !1
}), KZ = /* @__PURE__ */ d({
  id: 1315,
  name: "Story Aeneid",
  network: "story-aeneid",
  nativeCurrency: {
    decimals: 18,
    name: "IP",
    symbol: "IP"
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1792
    },
    ensRegistry: {
      address: "0x5dC881dDA4e4a8d312be3544AD13118D1a04Cb17",
      blockCreated: 1322033
    },
    ensUniversalResolver: {
      address: "0x6D3B3F99177FB2A5de7F9E928a9BD807bF7b5BAD",
      blockCreated: 1322097
    }
  },
  rpcUrls: {
    default: { http: ["https://aeneid.storyrpc.io"] }
  },
  blockExplorers: {
    default: {
      name: "Story Aeneid Explorer",
      url: "https://aeneid.storyscan.io",
      apiUrl: "https://aeneid.storyscan.io/api/v2"
    }
  },
  ensTlds: [".ip"],
  testnet: !0
}), VZ = /* @__PURE__ */ d({
  id: 1516,
  name: "Story Odyssey",
  nativeCurrency: {
    decimals: 18,
    name: "IP",
    symbol: "IP"
  },
  rpcUrls: {
    default: { http: ["https://rpc.odyssey.storyrpc.io"] }
  },
  blockExplorers: {
    default: {
      name: "Story Odyssey Explorer",
      url: "https://odyssey.storyscan.xyz"
    }
  },
  testnet: !0
}), GZ = /* @__PURE__ */ d({
  id: 1513,
  name: "Story Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "IP",
    symbol: "IP"
  },
  rpcUrls: {
    default: { http: ["https://testnet.storyrpc.io"] }
  },
  blockExplorers: {
    default: {
      name: "Story Testnet Explorer",
      url: "https://testnet.storyscan.xyz"
    }
  },
  testnet: !0
}), WZ = /* @__PURE__ */ d({
  id: 105105,
  name: "Stratis Mainnet",
  network: "stratis",
  nativeCurrency: {
    name: "Stratis",
    symbol: "STRAX",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.stratisevm.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Stratis Explorer",
      url: "https://explorer.stratisevm.com"
    }
  }
}), ZZ = /* @__PURE__ */ d({
  id: 8866,
  name: "SuperLumio",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.lumio.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Lumio explorer",
      url: "https://explorer.lumio.io"
    }
  },
  testnet: !1
}), JZ = /* @__PURE__ */ d({
  id: 55244,
  name: "Superposition",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.superposition.so"] }
  },
  blockExplorers: {
    default: {
      name: "Superposition Explorer",
      url: "https://explorer.superposition.so"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 39
    }
  },
  testnet: !1
}), ho = 1, XZ = /* @__PURE__ */ d({
  ...W,
  id: 5330,
  name: "Superseed",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.superseed.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Superseed Explorer",
      url: "https://explorer.superseed.xyz",
      apiUrl: "https://explorer.superseed.xyz/api/v2"
    }
  },
  contracts: {
    ...W.contracts,
    disputeGameFactory: {
      [ho]: {
        address: "0x8b097CF1f9BbD9cbFD0DD561858a1FCbC8857Be0",
        blockCreated: 20737481
      }
    },
    l2OutputOracle: {
      [ho]: {
        address: "0x693A0F8854F458D282DE3C5b69E8eE5EEE8aA949",
        blockCreated: 20737481
      }
    },
    portal: {
      [ho]: {
        address: "0x2c2150aa5c75A24fB93d4fD2F2a895D618054f07",
        blockCreated: 20737481
      }
    },
    l1StandardBridge: {
      [ho]: {
        address: "0x8b0576E39F1233679109F9b40cFcC2a7E0901Ede",
        blockCreated: 20737481
      }
    },
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  },
  sourceId: ho
}), Yu = 11155111, YZ = /* @__PURE__ */ d({
  ...W,
  id: 53302,
  name: "Superseed Sepolia",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia.superseed.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Superseed Sepolia Explorer",
      url: "https://sepolia-explorer.superseed.xyz",
      apiUrl: "https://sepolia-explorer.superseed.xyz/api/v2"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    },
    portal: {
      [Yu]: {
        address: "0x7A0db8C51432d2C3eb4e8f360a2EeB26FF2809fB",
        blockCreated: 5523438
      }
    },
    l1StandardBridge: {
      [Yu]: {
        address: "0x2B227A603fAAdB3De0ED050b63ADD232B5f2c28C",
        blockCreated: 5523442
      }
    }
  },
  testnet: !0,
  sourceId: Yu
}), QZ = /* @__PURE__ */ d({
  id: 254,
  name: "Swan Chain Mainnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://mainnet-rpc.swanchain.org"] }
  },
  blockExplorers: {
    default: {
      name: "Swan Explorer",
      url: "https://swanscan.io"
    }
  },
  testnet: !1
}), eJ = /* @__PURE__ */ d({
  id: 20241133,
  name: "Swan Proxima Testnet",
  nativeCurrency: { name: "Swan Ether", symbol: "sETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc-proxima.swanchain.io	"] }
  },
  blockExplorers: {
    default: {
      name: "Swan Explorer",
      url: "https://proxima-explorer.swanchain.io"
    }
  },
  testnet: !0
}), tJ = /* @__PURE__ */ d({
  id: 2024,
  name: "Swan Saturn Testnet",
  nativeCurrency: { name: "Swan Ether", symbol: "sETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://saturn-rpc.swanchain.io"] }
  },
  blockExplorers: {
    default: {
      name: "Swan Explorer",
      url: "https://saturn-explorer.swanchain.io"
    }
  },
  testnet: !0
}), rJ = /* @__PURE__ */ d({
  ...W,
  id: 1923,
  name: "Swellchain",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://swell-mainnet.alt.technology"]
    }
  },
  blockExplorers: {
    default: {
      name: "Swell Explorer",
      url: "https://explorer.swellnetwork.io",
      apiUrl: "https://explorer.swellnetwork.io/api"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1
    }
  }
}), sJ = /* @__PURE__ */ d({
  ...W,
  id: 1924,
  name: "Swellchain Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://swell-testnet.alt.technology"]
    }
  },
  blockExplorers: {
    default: {
      name: "Swellchain Testnet Explorer",
      url: "https://swell-testnet-explorer.alt.technology",
      apiUrl: "https://swell-testnet-explorer.alt.technology/api"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1
    }
  }
}), nJ = /* @__PURE__ */ d({
  id: 94,
  name: "SwissDLT Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "BCTS",
    symbol: "BCTS"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.swissdlt.ch"]
    }
  },
  blockExplorers: {
    default: {
      name: "SwissDLT Explorer",
      url: "https://explorer.swissdlt.ch"
    }
  },
  testnet: !1
}), iJ = /* @__PURE__ */ d({
  id: 57,
  name: "Syscoin Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Syscoin",
    symbol: "SYS"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.syscoin.org"],
      webSocket: ["wss://rpc.syscoin.org/wss"]
    }
  },
  blockExplorers: {
    default: {
      name: "SyscoinExplorer",
      url: "https://explorer.syscoin.org",
      apiUrl: "https://explorer.syscoin.org/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 287139
    }
  }
}), oJ = /* @__PURE__ */ d({
  id: 5700,
  name: "Syscoin Tanenbaum Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Syscoin",
    symbol: "SYS"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.tanenbaum.io"],
      webSocket: ["wss://rpc.tanenbaum.io/wss"]
    }
  },
  blockExplorers: {
    default: {
      name: "SyscoinTestnetExplorer",
      url: "https://tanenbaum.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 271288
    }
  }
}), aJ = /* @__PURE__ */ d({
  id: 239,
  name: "TAC",
  nativeCurrency: { name: "TAC", symbol: "TAC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.ankr.com/tac"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://tac.blockscout.com",
      apiUrl: "https://tac.blockscout.com/api"
    },
    native: {
      name: "TAC Explorer",
      url: "https://explorer.tac.build",
      apiUrl: "https://explorer.tac.build/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 0
    }
  }
}), cJ = /* @__PURE__ */ d({
  id: 2391,
  name: "TAC SPB Testnet",
  nativeCurrency: {
    name: "TAC",
    symbol: "TAC",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://spb.rpc.tac.build"]
    }
  },
  blockExplorers: {
    default: {
      name: "TAC",
      url: "https://spb.explorer.tac.build",
      apiUrl: "https://spb.explorer.tac.build/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 471429
    }
  },
  testnet: !0
}), lJ = /* @__PURE__ */ d({
  id: 167e3,
  name: "Taiko Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.mainnet.taiko.xyz"],
      webSocket: ["wss://ws.mainnet.taiko.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Taikoscan",
      url: "https://taikoscan.io",
      apiUrl: "https://api.taikoscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcb2436774C3e191c85056d248EF4260ce5f27A9D"
    }
  }
}), uJ = /* @__PURE__ */ d({
  id: 167009,
  name: "Taiko Hekla L2",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.hekla.taiko.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Taikoscan",
      url: "https://hekla.taikoscan.network"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 59757
    }
  },
  testnet: !0
}), hJ = /* @__PURE__ */ d({
  id: 167007,
  name: "Taiko Jolnir (Alpha-5 Testnet)",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.jolnir.taiko.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "blockscout",
      url: "https://explorer.jolnir.taiko.xyz"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 732706
    }
  },
  testnet: !0
}), dJ = /* @__PURE__ */ d({
  id: 167008,
  name: "Taiko Katla (Alpha-6 Testnet)",
  network: "tko-katla",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.katla.taiko.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "blockscout",
      url: "https://explorer.katla.taiko.xyz"
    }
  }
}), pJ = /* @__PURE__ */ d({
  id: 167005,
  name: "Taiko (Alpha-3 Testnet)",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.test.taiko.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "blockscout",
      url: "https://explorer.test.taiko.xyz"
    }
  }
}), fJ = /* @__PURE__ */ d({
  id: 841,
  name: "Taraxa Mainnet",
  nativeCurrency: { name: "Tara", symbol: "TARA", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.mainnet.taraxa.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Taraxa Explorer",
      url: "https://explorer.mainnet.taraxa.io"
    }
  }
}), mJ = /* @__PURE__ */ d({
  id: 842,
  name: "Taraxa Testnet",
  nativeCurrency: { name: "Tara", symbol: "TARA", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.taraxa.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Taraxa Explorer",
      url: "https://explorer.testnet.taraxa.io"
    }
  },
  testnet: !0
}), bJ = /* @__PURE__ */ d({
  id: 10218,
  name: "Tea Sepolia",
  nativeCurrency: { name: "Sepolia Tea", symbol: "TEA", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://tea-sepolia.g.alchemy.com/public"]
    }
  },
  blockExplorers: {
    default: {
      name: "Tea Sepolia Explorer",
      url: "https://sepolia.tea.xyz"
    }
  },
  testnet: !0
}), yJ = /* @__PURE__ */ d({
  id: 2017,
  name: "Telcoin Adiri Testnet",
  nativeCurrency: { name: "Telcoin", symbol: "TEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.telcoin.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "telscan",
      url: "https://telscan.io"
    }
  },
  testnet: !0
}), gJ = /* @__PURE__ */ d({
  id: 40,
  name: "Telos",
  nativeCurrency: {
    decimals: 18,
    name: "Telos",
    symbol: "TLOS"
  },
  rpcUrls: {
    default: { http: ["https://rpc.telos.net"] }
  },
  blockExplorers: {
    default: {
      name: "Teloscan",
      url: "https://www.teloscan.io/"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 246530709
    }
  }
}), wJ = /* @__PURE__ */ d({
  id: 41,
  name: "Telos",
  nativeCurrency: {
    decimals: 18,
    name: "Telos",
    symbol: "TLOS"
  },
  rpcUrls: {
    default: { http: ["https://rpc.testnet.telos.net"] }
  },
  blockExplorers: {
    default: {
      name: "Teloscan (testnet)",
      url: "https://testnet.teloscan.io/"
    }
  },
  testnet: !0
}), EJ = /* @__PURE__ */ d({
  id: 1559,
  name: "Tenet",
  network: "tenet-mainnet",
  nativeCurrency: {
    name: "TENET",
    symbol: "TENET",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://rpc.tenet.org"] }
  },
  blockExplorers: {
    default: {
      name: "TenetScan Mainnet",
      url: "https://tenetscan.io",
      apiUrl: "https://tenetscan.io/api"
    }
  },
  testnet: !1
}), xJ = /* @__PURE__ */ d({
  id: 752025,
  name: "Ternoa",
  nativeCurrency: { name: "Capsule Coin", symbol: "CAPS", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-mainnet.zkevm.ternoa.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Ternoa Explorer",
      url: "https://explorer-mainnet.zkevm.ternoa.network"
    }
  },
  testnet: !1
}), vJ = /* @__PURE__ */ d({
  id: 7,
  name: "ThaiChain",
  nativeCurrency: { name: "TCH", symbol: "TCH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.thaichain.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://exp.thaichain.org",
      apiUrl: "https://exp.thaichain.org/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0x0DaD6130e832c21719C5CE3bae93454E16A84826",
      blockCreated: 4806386
    }
  },
  testnet: !1
}), kJ = /* @__PURE__ */ d({
  id: 8428,
  name: "THAT Mainnet",
  nativeCurrency: { name: "THAT", symbol: "THAT", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://api.thatchain.io/mainnet"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://that.blockscout.com"
    }
  },
  testnet: !1
}), CJ = /* @__PURE__ */ d({
  id: 361,
  name: "Theta Mainnet",
  nativeCurrency: { name: "TFUEL", symbol: "TFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://eth-rpc-api.thetatoken.org/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Theta Explorer",
      url: "https://explorer.thetatoken.org"
    }
  },
  testnet: !1
}), SJ = /* @__PURE__ */ d({
  id: 365,
  name: "Theta Testnet",
  nativeCurrency: { name: "TFUEL", symbol: "TFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://eth-rpc-api-testnet.thetatoken.org/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Theta Explorer",
      url: "https://testnet-explorer.thetatoken.org"
    }
  },
  testnet: !0
}), IJ = /* @__PURE__ */ d({
  id: 108,
  name: "ThunderCore Mainnet",
  nativeCurrency: { name: "TT", symbol: "TT", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet-rpc.thundercore.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "ThunderCore Explorer",
      url: "https://explorer-mainnet.thundercore.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 0
    }
  },
  testnet: !1
}), AJ = /* @__PURE__ */ d({
  id: 997,
  name: "5ireChain Thunder Testnet",
  nativeCurrency: { name: "5ire Token", symbol: "5IRE", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.5ire.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "5ireChain Thunder Explorer",
      url: "https://testnet.5irescan.io/"
    }
  },
  testnet: !0
}), _J = /* @__PURE__ */ d({
  id: 62092,
  name: "TikTrix Testnet",
  nativeCurrency: {
    name: "tTTX",
    symbol: "tTTX",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://tiktrix-rpc.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "TikTrix Testnet Explorer",
      url: "https://tiktrix.xyz"
    }
  },
  testnet: !0
}), TJ = /* @__PURE__ */ d({
  id: 6969,
  name: "Tomb Mainnet",
  nativeCurrency: { name: "TOMB", symbol: "TOMB", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.tombchain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Tomb Explorer",
      url: "https://tombscout.com"
    }
  },
  testnet: !1
}), UJ = /* @__PURE__ */ d({
  ...or,
  id: 61166,
  name: "Treasure",
  nativeCurrency: {
    decimals: 18,
    name: "MAGIC",
    symbol: "MAGIC"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.treasure.lol"],
      webSocket: ["wss://rpc.treasure.lol/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Treasure Block Explorer",
      url: "https://treasurescan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0x2e29fe39496a56856D8698bD43e1dF4D0CE6266a",
      blockCreated: 101
    }
  },
  testnet: !1
}), $J = /* @__PURE__ */ d({
  ...or,
  id: 978658,
  name: "Treasure Topaz Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "MAGIC",
    symbol: "MAGIC"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.topaz.treasure.lol"],
      webSocket: ["wss://rpc.topaz.treasure.lol/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Treasure Topaz Block Explorer",
      url: "https://topaz.treasurescan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xF9cda624FBC7e059355ce98a31693d299FACd963",
      blockCreated: 108112
    }
  },
  testnet: !0
}), BJ = /* @__PURE__ */ d({
  id: 728126428,
  name: "Tron",
  nativeCurrency: { name: "TRON", symbol: "TRX", decimals: 6 },
  rpcUrls: {
    default: {
      http: ["https://api.trongrid.io/jsonrpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Tronscan",
      url: "https://tronscan.org",
      apiUrl: "https://apilist.tronscanapi.com/api"
    }
  }
}), DJ = /* @__PURE__ */ d({
  id: 3448148188,
  name: "Tron Nile",
  nativeCurrency: { name: "TRON", symbol: "TRX", decimals: 6 },
  rpcUrls: {
    default: {
      http: ["https://nile.trongrid.io/jsonrpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Tronscan",
      url: "https://nile.tronscan.org"
    }
  },
  testnet: !0
}), OJ = /* @__PURE__ */ d({
  id: 2494104990,
  name: "Tron Shasta",
  nativeCurrency: { name: "TRON", symbol: "TRX", decimals: 6 },
  rpcUrls: {
    default: {
      http: ["https://api.shasta.trongrid.io/jsonrpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Tronscan",
      url: "https://shasta.tronscan.org"
    }
  },
  testnet: !0
}), PJ = /* @__PURE__ */ d({
  id: 8,
  name: "Ubiq Mainnet",
  nativeCurrency: { name: "UBQ", symbol: "UBQ", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://pyrus2.ubiqscan.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Ubiq Scan",
      url: "https://ubiqscan.io"
    }
  },
  testnet: !1
}), RJ = /* @__PURE__ */ d({
  id: 19991,
  name: "Ultra EVM",
  nativeCurrency: {
    decimals: 18,
    name: "Ultra Token",
    symbol: "UOS"
  },
  rpcUrls: {
    default: { http: ["https://evm.ultra.eosusa.io"] }
  },
  blockExplorers: {
    default: {
      name: "Ultra EVM Explorer",
      url: "https://evmexplorer.ultra.io"
    }
  }
}), NJ = /* @__PURE__ */ d({
  id: 18881,
  name: "Ultra EVM Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Ultra Token",
    symbol: "UOS"
  },
  rpcUrls: {
    default: { http: ["https://evm.test.ultra.eosusa.io"] }
  },
  blockExplorers: {
    default: {
      name: "Ultra EVM Testnet Explorer",
      url: "https://evmexplorer.testnet.ultra.io"
    }
  },
  testnet: !0
}), LJ = /* @__PURE__ */ d({
  id: 1231,
  name: "Ultron Mainnet",
  nativeCurrency: { name: "ULX", symbol: "ULX", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://ultron-rpc.net"]
    }
  },
  blockExplorers: {
    default: {
      name: "Ultron Scan",
      url: "https://ulxscan.com"
    }
  },
  testnet: !1
}), MJ = /* @__PURE__ */ d({
  id: 1230,
  name: "Ultron Testnet",
  nativeCurrency: { name: "ULX", symbol: "ULX", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://ultron-dev.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Ultron Scan",
      url: "https://explorer.ultron-dev.io"
    }
  },
  testnet: !0
}), _c = 1, FJ = /* @__PURE__ */ d({
  ...W,
  id: 130,
  name: "Unichain",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  blockTime: 1e3,
  rpcUrls: {
    default: {
      http: ["https://mainnet.unichain.org/"]
    }
  },
  blockExplorers: {
    default: {
      name: "Uniscan",
      url: "https://uniscan.xyz",
      apiUrl: "https://api.uniscan.xyz/api"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 0
    },
    disputeGameFactory: {
      [_c]: {
        address: "0x2F12d621a16e2d3285929C9996f478508951dFe4"
      }
    },
    portal: {
      [_c]: {
        address: "0x0bd48f6B86a26D3a217d0Fa6FfE2B491B956A7a2"
      }
    },
    l1StandardBridge: {
      [_c]: {
        address: "0x81014F44b0a345033bB2b3B21C7a1A308B35fEeA"
      }
    }
  },
  sourceId: _c
}), Tc = 11155111, zJ = /* @__PURE__ */ d({
  ...W,
  id: 1301,
  name: "Unichain Sepolia",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  blockTime: 1e3,
  rpcUrls: {
    default: {
      http: ["https://sepolia.unichain.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Uniscan",
      url: "https://sepolia.uniscan.xyz",
      apiUrl: "https://api-sepolia.uniscan.xyz/api"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 0
    },
    portal: {
      [Tc]: {
        address: "0x0d83dab629f0e0F9d36c0Cbc89B69a489f0751bD"
      }
    },
    l1StandardBridge: {
      [Tc]: {
        address: "0xea58fcA6849d79EAd1f26608855c2D6407d54Ce2"
      }
    },
    disputeGameFactory: {
      [Tc]: {
        address: "0xeff73e5aa3B9AEC32c659Aa3E00444d20a84394b"
      }
    }
  },
  testnet: !0,
  sourceId: Tc
}), jJ = /* @__PURE__ */ d({
  id: 8880,
  name: "Unique Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "UNQ",
    symbol: "UNQ"
  },
  rpcUrls: {
    default: { http: ["https://rpc.unique.network"] }
  },
  blockExplorers: {
    default: {
      name: "Unique Subscan",
      url: "https://unique.subscan.io/"
    }
  }
}), HJ = /* @__PURE__ */ d({
  id: 8882,
  name: "Opal Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "OPL",
    symbol: "OPL"
  },
  rpcUrls: {
    default: { http: ["https://rpc-opal.unique.network"] }
  },
  blockExplorers: {
    default: {
      name: "Opal Subscan",
      url: "https://opal.subscan.io/"
    }
  },
  testnet: !0
}), qJ = /* @__PURE__ */ d({
  id: 8881,
  name: "Quartz Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "QTZ",
    symbol: "QTZ"
  },
  rpcUrls: {
    default: { http: ["https://rpc-quartz.unique.network"] }
  },
  blockExplorers: {
    default: {
      name: "Quartz Subscan",
      url: "https://quartz.subscan.io/"
    }
  }
}), KJ = /* @__PURE__ */ d({
  id: 18233,
  name: "Unreal",
  nativeCurrency: {
    name: "reETH",
    decimals: 18,
    symbol: "reETH"
  },
  rpcUrls: {
    default: { http: ["https://rpc.unreal-orbit.gelato.digital"] }
  },
  blockExplorers: {
    default: {
      name: "Unreal Explorer",
      url: "https://unreal.blockscout.com",
      apiUrl: "https://unreal.blockscout.com/api/v2"
    }
  },
  testnet: !0,
  contracts: {
    multicall3: {
      address: "0x8b6B0e60D8CD84898Ea8b981065A12F876eA5677",
      blockCreated: 1745
    }
  }
}), VJ = /* @__PURE__ */ d({
  id: 2040,
  name: "Vanar Mainnet",
  nativeCurrency: { name: "VANRY", symbol: "VANRY", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.vanarchain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Vanar Mainnet Explorer",
      url: "https://explorer.vanarchain.com/"
    }
  },
  testnet: !1
}), GJ = /* @__PURE__ */ d({
  id: 100009,
  name: "Vechain",
  nativeCurrency: { name: "VeChain", symbol: "VET", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.vechain.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Vechain Explorer",
      url: "https://explore.vechain.org"
    },
    vechainStats: {
      name: "Vechain Stats",
      url: "https://vechainstats.com"
    }
  }
}), WJ = /* @__PURE__ */ d({
  id: 106,
  name: "Velas EVM Mainnet",
  nativeCurrency: { name: "VLX", symbol: "VLX", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://evmexplorer.velas.com/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Velas Explorer",
      url: "https://evmexplorer.velas.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 55883577
    }
  },
  testnet: !1
}), ZJ = /* @__PURE__ */ d({
  id: 88,
  name: "Viction",
  nativeCurrency: { name: "Viction", symbol: "VIC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.viction.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "VIC Scan",
      url: "https://vicscan.xyz"
    }
  },
  testnet: !1
}), JJ = /* @__PURE__ */ d({
  id: 89,
  name: "Viction Testnet",
  nativeCurrency: { name: "Viction", symbol: "VIC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-testnet.viction.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "VIC Scan",
      url: "https://testnet.vicscan.xyz"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 12170179
    }
  },
  testnet: !0
}), XJ = /* @__PURE__ */ d({
  id: 888888,
  name: "Vision",
  nativeCurrency: { name: "VISION", symbol: "VS", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://infragrid.v.network/ethereum/compatible"]
    }
  },
  blockExplorers: {
    default: {
      name: "Vision Scan",
      url: "https://visionscan.org"
    }
  },
  testnet: !1
}), YJ = /* @__PURE__ */ d({
  id: 666666,
  name: "Vision Testnet",
  nativeCurrency: { name: "VISION", symbol: "VS", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://vpioneer.infragrid.v.network/ethereum/compatible"]
    }
  },
  blockExplorers: {
    default: {
      name: "Vision Scan",
      url: "https://visionscan.org/?chain=vpioneer"
    }
  },
  testnet: !0
}), QJ = /* @__PURE__ */ d({
  id: 888,
  name: "Wanchain",
  nativeCurrency: { name: "WANCHAIN", symbol: "WAN", decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        "https://gwan-ssl.wandevs.org:56891",
        "https://gwan2-ssl.wandevs.org"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "WanScan",
      url: "https://wanscan.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcDF6A1566e78EB4594c86Fe73Fcdc82429e97fbB",
      blockCreated: 25312390
    }
  }
}), eX = /* @__PURE__ */ d({
  id: 999,
  name: "Wanchain Testnet",
  nativeCurrency: { name: "WANCHAIN", symbol: "WANt", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://gwan-ssl.wandevs.org:46891"]
    }
  },
  blockExplorers: {
    default: {
      name: "WanScanTest",
      url: "https://wanscan.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0x11c89bF4496c39FB80535Ffb4c92715839CC5324",
      blockCreated: 24743448
    }
  },
  testnet: !0
}), tX = /* @__PURE__ */ d({
  id: 9496,
  name: "WeaveVM Alphanet",
  nativeCurrency: { name: "Testnet WeaveVM", symbol: "tWVM", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://testnet-rpc.wvm.dev"] }
  },
  blockExplorers: {
    default: {
      name: "WeaveVM Alphanet Explorer",
      url: "https://explorer.wvm.dev"
    }
  },
  testnet: !0
}), rX = /* @__PURE__ */ d({
  id: 1111,
  name: "WEMIX",
  network: "wemix-mainnet",
  nativeCurrency: { name: "WEMIX", symbol: "WEMIX", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://api.wemix.com"] }
  },
  blockExplorers: {
    default: {
      name: "wemixExplorer",
      url: "https://explorer.wemix.com"
    }
  }
}), sX = /* @__PURE__ */ d({
  id: 1112,
  name: "WEMIX Testnet",
  network: "wemix-testnet",
  nativeCurrency: { name: "WEMIX", symbol: "tWEMIX", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://api.test.wemix.com"] }
  },
  blockExplorers: {
    default: {
      name: "wemixExplorer",
      url: "https://testnet.wemixscan.com",
      apiUrl: "https://testnet.wemixscan.com/api"
    }
  },
  testnet: !0
}), nX = /* @__PURE__ */ d({
  id: 420420421,
  name: "Westend Asset Hub",
  nativeCurrency: {
    decimals: 18,
    name: "Westies",
    symbol: "WND"
  },
  rpcUrls: {
    default: { http: ["https://westend-asset-hub-eth-rpc.polkadot.io"] }
  },
  blockExplorers: {
    default: {
      name: "subscan",
      url: "https://westend-asset-hub-eth-explorer.parity.io"
    }
  },
  testnet: !0
}), iX = /* @__PURE__ */ d({
  testnet: !1,
  name: "Whitechain",
  blockExplorers: {
    default: {
      name: "Whitechain Explorer",
      url: "https://explorer.whitechain.io"
    }
  },
  id: 1875,
  rpcUrls: {
    default: {
      http: ["https://rpc.whitechain.io"]
    }
  },
  nativeCurrency: {
    decimals: 18,
    name: "WhiteBIT Coin",
    symbol: "WBT"
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 25212237
    }
  }
}), oX = /* @__PURE__ */ d({
  testnet: !0,
  name: "Whitechain Testnet",
  blockExplorers: {
    default: {
      name: "Whitechain Explorer",
      url: "https://testnet.whitechain.io"
    }
  },
  id: 2625,
  rpcUrls: {
    default: {
      http: ["https://rpc-testnet.whitechain.io"]
    }
  },
  nativeCurrency: {
    decimals: 18,
    name: "WhiteBIT Coin",
    symbol: "WBT"
  }
}), aX = /* @__PURE__ */ d({
  id: 42070,
  name: "WMC Testnet",
  nativeCurrency: { name: "WMTx", symbol: "WMTx", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-testnet-base.worldmobile.net"]
    }
  },
  blockExplorers: {
    default: {
      name: "WMC Explorer",
      url: "https://explorer2-base-testnet.worldmobile.net"
    }
  },
  testnet: !0
}), po = 1, cX = /* @__PURE__ */ d({
  ...W,
  id: 480,
  name: "World Chain",
  network: "worldchain",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://worldchain-mainnet.g.alchemy.com/public"] }
  },
  blockExplorers: {
    default: {
      name: "Worldscan",
      url: "https://worldscan.org",
      apiUrl: "https://api.worldscan.org/api"
    },
    blockscout: {
      name: "Blockscout",
      url: "https://worldchain-mainnet.explorer.alchemy.com",
      apiUrl: "https://worldchain-mainnet.explorer.alchemy.com/api"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 0
    },
    disputeGameFactory: {
      [po]: {
        address: "0x069c4c579671f8c120b1327a73217D01Ea2EC5ea"
      }
    },
    l2OutputOracle: {
      [po]: {
        address: "0x19A6d1E9034596196295CF148509796978343c5D"
      }
    },
    portal: {
      [po]: {
        address: "0xd5ec14a83B7d95BE1E2Ac12523e2dEE12Cbeea6C"
      }
    },
    l1StandardBridge: {
      [po]: {
        address: "0x470458C91978D2d929704489Ad730DC3E3001113"
      }
    }
  },
  testnet: !1,
  sourceId: po
}), fo = 11155111, lX = /* @__PURE__ */ d({
  ...W,
  id: 4801,
  name: "World Chain Sepolia",
  network: "worldchain-sepolia",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://worldchain-sepolia.g.alchemy.com/public"] }
  },
  blockExplorers: {
    default: {
      name: "Worldscan Sepolia",
      url: "https://sepolia.worldscan.org",
      apiUrl: "https://api-sepolia.worldscan.org/api"
    },
    blockscout: {
      name: "Blockscout",
      url: "https://worldchain-sepolia.explorer.alchemy.com",
      apiUrl: "https://worldchain-sepolia.explorer.alchemy.com/api"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 0
    },
    disputeGameFactory: {
      [fo]: {
        address: "0x8Ec1111f67Dad6b6A93B3F42DfBC92D81c98449A"
      }
    },
    l2OutputOracle: {
      [fo]: {
        address: "0xc8886f8BAb6Eaeb215aDB5f1c686BF699248300e"
      }
    },
    portal: {
      [fo]: {
        address: "0xFf6EBa109271fe6d4237EeeD4bAb1dD9A77dD1A4"
      }
    },
    l1StandardBridge: {
      [fo]: {
        address: "0xd7DF54b3989855eb66497301a4aAEc33Dbb3F8DE"
      }
    }
  },
  testnet: !0,
  sourceId: fo
}), uX = /* @__PURE__ */ d({
  id: 103,
  name: "WorldLand Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "WLC",
    symbol: "WLC"
  },
  rpcUrls: {
    default: {
      http: ["https://seoul.worldland.foundation"]
    }
  },
  blockExplorers: {
    default: {
      name: "WorldLand Scan",
      url: "https://scan.worldland.foundation"
    }
  },
  testnet: !1
}), hX = /* @__PURE__ */ d({
  id: 660279,
  name: "Xai Mainnet",
  nativeCurrency: { name: "Xai", symbol: "XAI", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://xai-chain.net/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://explorer.xai-chain.net"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 222549
    }
  },
  testnet: !1
}), dX = /* @__PURE__ */ d({
  id: 37714555429,
  name: "Xai Testnet",
  nativeCurrency: { name: "sXai", symbol: "sXAI", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://testnet-v2.xai-chain.net/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://testnet-explorer-v2.xai-chain.net"
    }
  },
  testnet: !0
}), pX = /* @__PURE__ */ d({
  id: 50,
  name: "XDC Network",
  nativeCurrency: {
    decimals: 18,
    name: "XDC",
    symbol: "XDC"
  },
  rpcUrls: {
    default: { http: ["https://rpc.xdcrpc.com"] }
  },
  blockExplorers: {
    default: {
      name: "XDCScan",
      url: "https://xdcscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0x0B1795ccA8E4eC4df02346a082df54D437F8D9aF",
      blockCreated: 75884020
    }
  }
}), fX = /* @__PURE__ */ d({
  id: 51,
  name: "Apothem Network",
  nativeCurrency: {
    decimals: 18,
    name: "TXDC",
    symbol: "TXDC"
  },
  rpcUrls: {
    default: { http: ["https://erpc.apothem.network"] }
  },
  blockExplorers: {
    default: {
      name: "XDCScan",
      url: "https://testnet.xdcscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 59765389
    }
  }
}), mX = /* @__PURE__ */ d({
  id: 196,
  name: "X Layer Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "OKB",
    symbol: "OKB"
  },
  rpcUrls: {
    default: { http: ["https://rpc.xlayer.tech"] }
  },
  blockExplorers: {
    default: {
      name: "OKLink",
      url: "https://www.oklink.com/xlayer",
      apiUrl: "https://www.oklink.com/api/v5/explorer/xlayer/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 47416
    }
  }
}), z1 = /* @__PURE__ */ d({
  id: 195,
  name: "X1 Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "OKB",
    symbol: "OKB"
  },
  rpcUrls: {
    default: { http: ["https://xlayertestrpc.okx.com"] }
  },
  blockExplorers: {
    default: {
      name: "OKLink",
      url: "https://www.oklink.com/xlayer-test"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 624344
    }
  },
  testnet: !0
}), bX = /* @__PURE__ */ d({
  id: 20250217,
  name: "Xphere Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "XP",
    symbol: "XP"
  },
  rpcUrls: {
    default: {
      http: ["https://en-bkk.x-phere.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Xphere Tamsa Explorer",
      url: "https://xp.tamsa.io"
    }
  },
  testnet: !1
}), yX = /* @__PURE__ */ d({
  id: 1998991,
  name: "Xphere Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "XPT",
    symbol: "XPT"
  },
  rpcUrls: {
    default: {
      http: ["http://testnet.x-phere.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Xphere Tamsa Explorer",
      url: "https://xpt.tamsa.io"
    }
  },
  testnet: !0
}), gX = /* @__PURE__ */ d({
  id: 273,
  name: "XR One",
  nativeCurrency: {
    decimals: 18,
    name: "XR1",
    symbol: "XR1"
  },
  rpcUrls: {
    default: {
      http: ["https://xr1.calderachain.xyz/http"],
      webSocket: ["wss://xr1.calderachain.xyz/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://xr1.calderaexplorer.xyz"
    }
  },
  testnet: !1
}), wX = /* @__PURE__ */ d({
  id: 1440002,
  name: "XRPL EVM Devnet",
  nativeCurrency: {
    name: "XRP",
    symbol: "XRP",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.xrplevm.org/"]
    },
    public: {
      http: ["https://rpc.xrplevm.org/"]
    }
  },
  blockExplorers: {
    default: {
      name: "XRPLEVM Devnet Explorer",
      url: "https://explorer.xrplevm.org/"
    }
  },
  contracts: {
    multicall3: {
      address: "0x82Cc144D7d0AD4B1c27cb41420e82b82Ad6e9B31",
      blockCreated: 15237286
    }
  },
  testnet: !0
}), EX = /* @__PURE__ */ d({
  id: 1449e3,
  name: "XRPL EVM Testnet",
  nativeCurrency: {
    name: "XRP",
    symbol: "XRP",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://rpc.testnet.xrplevm.org"] }
  },
  blockExplorers: {
    default: {
      name: "blockscout",
      url: "https://explorer.testnet.xrplevm.org",
      apiUrl: "https://explorer.testnet.xrplevm.org/api/v2"
    }
  },
  contracts: {
    multicall3: {
      address: "0x82Cc144D7d0AD4B1c27cb41420e82b82Ad6e9B31",
      blockCreated: 492302
    }
  },
  testnet: !0
}), xX = /* @__PURE__ */ d({
  id: 2730,
  name: "XR Sepolia",
  nativeCurrency: {
    decimals: 18,
    name: "tXR",
    symbol: "tXR"
  },
  rpcUrls: {
    default: { http: ["https://xr-sepolia-testnet.rpc.caldera.xyz/http"] }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://xr-sepolia-testnet.explorer.caldera.xyz"
    }
  },
  testnet: !0
}), vX = /* @__PURE__ */ d({
  id: 50005,
  name: "Yooldo Verse",
  nativeCurrency: { name: "OAS", symbol: "OAS", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.yooldo-verse.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Yooldo Verse Explorer",
      url: "https://explorer.yooldo-verse.xyz"
    }
  }
}), kX = /* @__PURE__ */ d({
  id: 50006,
  name: "Yooldo Verse Testnet",
  nativeCurrency: { name: "OAS", symbol: "OAS", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.yooldo-verse.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "Yooldo Verse Testnet Explorer",
      url: "https://explorer.testnet.yooldo-verse.xyz"
    }
  },
  testnet: !0
}), CX = /* @__PURE__ */ d({
  id: 8408,
  name: "ZenChain Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "ZTC",
    symbol: "ZTC"
  },
  rpcUrls: {
    default: {
      http: ["https://zenchain-testnet.api.onfinality.io/public"],
      webSocket: ["wss://zenchain-testnet.api.onfinality.io/public-ws"]
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 230019
    }
  },
  blockExplorers: {
    default: {
      name: "Zentrace",
      url: "https://zentrace.io"
    }
  },
  testnet: !0
}), SX = /* @__PURE__ */ d({
  id: 383414847825,
  name: "Zeniq Mainnet",
  nativeCurrency: { name: "ZENIQ", symbol: "ZENIQ", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://api.zeniq.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Zeniq Explorer",
      url: "https://zeniqscan.com"
    }
  },
  testnet: !1
}), IX = /* @__PURE__ */ d({
  id: 543210,
  name: "Zero Network",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.zerion.io/v1/zero"]
    }
  },
  blockExplorers: {
    default: {
      name: "Zero Network Explorer",
      url: "https://explorer.zero.network"
    }
  },
  testnet: !1
}), AX = /* @__PURE__ */ d({
  id: 7e3,
  name: "ZetaChain",
  nativeCurrency: {
    decimals: 18,
    name: "Zeta",
    symbol: "ZETA"
  },
  rpcUrls: {
    default: {
      http: ["https://zetachain-evm.blockpi.network/v1/rpc/public"]
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1632781
    }
  },
  blockExplorers: {
    default: {
      name: "ZetaScan",
      url: "https://zetascan.com"
    }
  },
  testnet: !1
}), _X = /* @__PURE__ */ d({
  id: 7001,
  name: "ZetaChain Athens Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Zeta",
    symbol: "aZETA"
  },
  rpcUrls: {
    default: {
      http: ["https://zetachain-athens-evm.blockpi.network/v1/rpc/public"]
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 2715217
    }
  },
  blockExplorers: {
    default: {
      name: "ZetaScan",
      url: "https://testnet.zetascan.com"
    }
  },
  testnet: !0
}), TX = /* @__PURE__ */ d({
  id: 1337803,
  name: "Zhejiang",
  nativeCurrency: { name: "Zhejiang Ether", symbol: "ZhejETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.zhejiang.ethpandaops.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Beaconchain",
      url: "https://zhejiang.beaconcha.in"
    }
  },
  testnet: !0
}), UX = /* @__PURE__ */ d({
  id: 32769,
  name: "Zilliqa",
  network: "zilliqa",
  nativeCurrency: { name: "Zilliqa", symbol: "ZIL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://api.zilliqa.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Ethernal",
      url: "https://evmx.zilliqa.com"
    }
  },
  testnet: !1
}), $X = /* @__PURE__ */ d({
  id: 33101,
  name: "Zilliqa Testnet",
  network: "zilliqa-testnet",
  nativeCurrency: { name: "Zilliqa", symbol: "ZIL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://dev-api.zilliqa.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Ethernal",
      url: "https://evmx.testnet.zilliqa.com"
    }
  },
  testnet: !0
}), Qu = 1, BX = /* @__PURE__ */ d({
  ...W,
  id: 48900,
  name: "Zircuit Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: [
        "https://mainnet.zircuit.com",
        "https://zircuit1-mainnet.liquify.com",
        "https://zircuit1-mainnet.p2pify.com",
        "https://zircuit-mainnet.drpc.org"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Zircuit Explorer",
      url: "https://explorer.zircuit.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    },
    l2OutputOracle: {
      [Qu]: {
        address: "0x92Ef6Af472b39F1b363da45E35530c24619245A4"
      }
    },
    portal: {
      [Qu]: {
        address: "0x17bfAfA932d2e23Bd9B909Fd5B4D2e2a27043fb1"
      }
    },
    l1StandardBridge: {
      [Qu]: {
        address: "0x386B76D9cA5F5Fb150B6BFB35CF5379B22B26dd8"
      }
    }
  },
  testnet: !1
}), eh = 11155111, DX = /* @__PURE__ */ d({
  ...W,
  id: 48898,
  name: "Zircuit Garfield Testnet",
  nativeCurrency: { name: "ETH", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://garfield-testnet.zircuit.com/"]
    }
  },
  blockExplorers: {
    default: {
      name: "Zircuit Garfield Testnet Explorer",
      url: "https://explorer.garfield-testnet.zircuit.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    },
    l2OutputOracle: {
      [eh]: {
        address: "0xd69D3AC5CA686cCF94b258291772bc520FEAf211"
      }
    },
    portal: {
      [eh]: {
        address: "0x4E21A71Ac3F7607Da5c06153A17B1DD20E702c21"
      }
    },
    l1StandardBridge: {
      [eh]: {
        address: "0x87a7E2bCA9E35BA49282E832a28A6023904460D8"
      }
    }
  },
  testnet: !0
}), th = 11155111, OX = /* @__PURE__ */ d({
  ...W,
  id: 48899,
  name: "Zircuit Testnet",
  nativeCurrency: { name: "ETH", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        "https://testnet.zircuit.com",
        "https://zircuit1-testnet.p2pify.com",
        "https://zircuit1-testnet.liquify.com"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Zircuit Testnet Explorer",
      url: "https://explorer.testnet.zircuit.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 6040287
    },
    l2OutputOracle: {
      [th]: {
        address: "0x740C2dac453aEf7140809F80b72bf0e647af8148"
      }
    },
    portal: {
      [th]: {
        address: "0x787f1C8c5924178689E0560a43D848bF8E54b23e"
      }
    },
    l1StandardBridge: {
      [th]: {
        address: "0x0545c5fe980098C16fcD0eCB5E79753afa6d9af9"
      }
    }
  },
  testnet: !0
}), PX = /* @__PURE__ */ d({
  id: 42766,
  name: "ZKFair Mainnet",
  network: "zkfair-mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "USD Coin",
    symbol: "USDC"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.zkfair.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "zkFair Explorer",
      url: "https://scan.zkfair.io",
      apiUrl: "https://scan.zkfair.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 6090959
    }
  },
  testnet: !1
}), RX = /* @__PURE__ */ d({
  id: 43851,
  name: "ZKFair Testnet",
  network: "zkfair-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "USD Coin",
    symbol: "USDC"
  },
  rpcUrls: {
    default: {
      http: ["https://testnet-rpc.zkfair.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "zkFair Explorer",
      url: "https://testnet-scan.zkfair.io"
    }
  },
  testnet: !0
}), NX = /* @__PURE__ */ d({
  id: 810180,
  name: "zkLink Nova",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://rpc.zklink.io"] }
  },
  blockExplorers: {
    default: {
      name: "zkLink Nova Block Explorer",
      url: "https://explorer.zklink.io"
    }
  }
}), LX = /* @__PURE__ */ d({
  id: 810181,
  name: "zkLink Nova Sepolia Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://sepolia.rpc.zklink.io"] }
  },
  blockExplorers: {
    default: {
      name: "zkLink Nova Block Explorer",
      url: "https://sepolia.explorer.zklink.io"
    }
  }
}), j1 = /* @__PURE__ */ d({
  ...or,
  id: 324,
  name: "ZKsync Era",
  network: "zksync-era",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://mainnet.era.zksync.io"],
      webSocket: ["wss://mainnet.era.zksync.io/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://era.zksync.network/",
      apiUrl: "https://api-era.zksync.network/api"
    },
    native: {
      name: "ZKsync Explorer",
      url: "https://explorer.zksync.io/",
      apiUrl: "https://block-explorer-api.mainnet.zksync.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xF9cda624FBC7e059355ce98a31693d299FACd963"
    },
    erc6492Verifier: {
      address: "0xfB688330379976DA81eB64Fe4BF50d7401763B9C",
      blockCreated: 45659388
    }
  }
}), H1 = /* @__PURE__ */ d({
  ...or,
  id: 260,
  name: "ZKsync InMemory Node",
  network: "zksync-in-memory-node",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["http://localhost:8011"]
    }
  },
  testnet: !0
}), MX = /* @__PURE__ */ d({
  ...or,
  id: 272,
  name: "ZKsync CLI Local Custom Hyperchain",
  nativeCurrency: { name: "BAT", symbol: "BAT", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["http://localhost:15200"],
      webSocket: ["ws://localhost:15201"]
    }
  },
  blockExplorers: {
    default: {
      name: "ZKsync explorer",
      url: "http://localhost:15005/",
      apiUrl: "http://localhost:15005/api"
    }
  },
  testnet: !0
}), FX = /* @__PURE__ */ d({
  ...or,
  id: 270,
  name: "ZKsync CLI Local Hyperchain",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["http://localhost:15100"],
      webSocket: ["ws://localhost:15101"]
    }
  },
  blockExplorers: {
    default: {
      name: "ZKsync explorer",
      url: "http://localhost:15005/",
      apiUrl: "http://localhost:15005/api"
    }
  },
  testnet: !0
}), zX = /* @__PURE__ */ d({
  id: 9,
  name: "ZKsync CLI Local Hyperchain L1",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["http://localhost:15045"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "http://localhost:15001/",
      apiUrl: "http://localhost:15001/api/v2"
    }
  },
  testnet: !0
}), q1 = /* @__PURE__ */ d({
  ...or,
  id: 270,
  name: "ZKsync CLI Local Node",
  network: "zksync-cli-local-node",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["http://localhost:3050"]
    }
  },
  testnet: !0
}), K1 = /* @__PURE__ */ d({
  ...or,
  id: 300,
  name: "ZKsync Sepolia Testnet",
  network: "zksync-sepolia-testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.era.zksync.dev"],
      webSocket: ["wss://sepolia.era.zksync.dev/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://sepolia-era.zksync.network/",
      apiUrl: "https://api-sepolia-era.zksync.network/api"
    },
    native: {
      name: "ZKsync Explorer",
      url: "https://sepolia.explorer.zksync.io/",
      blockExplorerApi: "https://block-explorer-api.sepolia.zksync.dev/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xF9cda624FBC7e059355ce98a31693d299FACd963"
    },
    erc6492Verifier: {
      address: "0xfB688330379976DA81eB64Fe4BF50d7401763B9C",
      blockCreated: 3855712
    }
  },
  testnet: !0
}), Uc = 1, jX = /* @__PURE__ */ d({
  ...W,
  id: 7777777,
  name: "Zora",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.zora.energy"],
      webSocket: ["wss://rpc.zora.energy"]
    }
  },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "https://explorer.zora.energy",
      apiUrl: "https://explorer.zora.energy/api"
    }
  },
  contracts: {
    ...W.contracts,
    l2OutputOracle: {
      [Uc]: {
        address: "0x9E6204F750cD866b299594e2aC9eA824E2e5f95c"
      }
    },
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 5882
    },
    portal: {
      [Uc]: {
        address: "0x1a0ad011913A150f69f6A19DF447A0CfD9551054"
      }
    },
    l1StandardBridge: {
      [Uc]: {
        address: "0x3e2Ea9B92B7E48A52296fD261dc26fd995284631"
      }
    }
  },
  sourceId: Uc
}), $c = 11155111, HX = /* @__PURE__ */ d({
  ...W,
  id: 999999999,
  name: "Zora Sepolia",
  network: "zora-sepolia",
  nativeCurrency: {
    decimals: 18,
    name: "Zora Sepolia",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia.rpc.zora.energy"],
      webSocket: ["wss://sepolia.rpc.zora.energy"]
    }
  },
  blockExplorers: {
    default: {
      name: "Zora Sepolia Explorer",
      url: "https://sepolia.explorer.zora.energy/",
      apiUrl: "https://sepolia.explorer.zora.energy/api"
    }
  },
  contracts: {
    ...W.contracts,
    l2OutputOracle: {
      [$c]: {
        address: "0x2615B481Bd3E5A1C0C7Ca3Da1bdc663E8615Ade9"
      }
    },
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 83160
    },
    portal: {
      [$c]: {
        address: "0xeffE2C6cA9Ab797D418f0D91eA60807713f3536f"
      }
    },
    l1StandardBridge: {
      [$c]: {
        address: "0x5376f1D543dcbB5BD416c56C189e4cB7399fCcCB"
      }
    }
  },
  sourceId: $c,
  testnet: !0
}), V1 = 5, qX = /* @__PURE__ */ d({
  ...W,
  id: 999,
  name: "Zora Goerli Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Zora Goerli",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://testnet.rpc.zora.energy"],
      webSocket: ["wss://testnet.rpc.zora.energy"]
    }
  },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "https://testnet.explorer.zora.energy",
      apiUrl: "https://testnet.explorer.zora.energy/api"
    }
  },
  contracts: {
    ...W.contracts,
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 189123
    },
    portal: {
      [V1]: {
        address: "0xDb9F51790365e7dc196e7D072728df39Be958ACe"
      }
    }
  },
  sourceId: V1,
  testnet: !0
}), KX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  abey: AM,
  abstract: LM,
  abstractTestnet: MM,
  acala: FM,
  acria: zM,
  adf: jM,
  agungTestnet: HM,
  aioz: qM,
  alephZero: KM,
  alephZeroTestnet: VM,
  alienx: GM,
  alienxHalTestnet: WM,
  ancient8: QM,
  ancient8Sepolia: eF,
  anvil: tF,
  apeChain: sF,
  apexTestnet: nF,
  arbitrum: iF,
  arbitrumGoerli: oF,
  arbitrumNova: aF,
  arbitrumSepolia: cF,
  arenaz: lF,
  areonNetwork: uF,
  areonNetworkTestnet: hF,
  areum: dF,
  artelaTestnet: pF,
  arthera: fF,
  artheraTestnet: mF,
  assetChain: bF,
  assetChainTestnet: yF,
  astar: gF,
  astarZkEVM: wF,
  astarZkyoto: EF,
  atletaOlympia: xF,
  aurora: vF,
  auroraTestnet: kF,
  auroria: CF,
  autheoTestnet: SF,
  avalanche: IF,
  avalancheFuji: AF,
  b3: TF,
  b3Sepolia: $F,
  bahamut: BF,
  base: fE,
  baseGoerli: PF,
  basePreconf: DF,
  baseSepolia: mE,
  baseSepoliaPreconf: RF,
  basecampTestnet: OF,
  beam: NF,
  beamTestnet: LF,
  bearNetworkChainMainnet: MF,
  bearNetworkChainTestnet: FF,
  berachain: zF,
  berachainBepolia: jF,
  berachainTestnet: HF,
  berachainTestnetbArtio: qF,
  bevmMainnet: KF,
  bifrost: VF,
  birdlayer: GF,
  bitTorrent: ez,
  bitTorrentTestnet: tz,
  bitgert: WF,
  bitkub: ZF,
  bitkubTestnet: JF,
  bitlayer: XF,
  bitlayerTestnet: YF,
  bitrock: QF,
  blast: rz,
  blastSepolia: nz,
  bob: iz,
  bobSepolia: cz,
  boba: oz,
  bobaSepolia: az,
  boolBetaMainnet: lz,
  botanix: uz,
  botanixTestnet: hz,
  bounceBit: dz,
  bounceBitTestnet: pz,
  bronos: fz,
  bronosTestnet: mz,
  bsc: bz,
  bscGreenfield: yz,
  bscTestnet: gz,
  bsquared: wz,
  bsquaredTestnet: Ez,
  btr: xz,
  btrTestnet: vz,
  bxn: kz,
  bxnTestnet: Cz,
  cannon: Sz,
  canto: Iz,
  celo: Nz,
  celoAlfajores: Lz,
  celoSepolia: Mz,
  chang: Fz,
  chiliz: zz,
  chips: jz,
  citreaTestnet: Hz,
  classic: qz,
  coinbit: Kz,
  coinex: Vz,
  confluxESpace: Gz,
  confluxESpaceTestnet: Wz,
  coreDao: Zz,
  coreTestnet1: Jz,
  coreTestnet2: Xz,
  corn: Qz,
  cornTestnet: tj,
  crab: rj,
  creatorTestnet: sj,
  creditCoin3Devnet: nj,
  creditCoin3Mainnet: ij,
  creditCoin3Testnet: oj,
  cronos: aj,
  cronosTestnet: cj,
  cronoszkEVM: lj,
  cronoszkEVMTestnet: uj,
  crossbell: hj,
  crossfi: dj,
  curtis: pj,
  cyber: fj,
  cyberTestnet: mj,
  dailyNetwork: bj,
  dailyNetworkTestnet: yj,
  darwinia: gj,
  dbkchain: wj,
  dchain: Ej,
  dchainTestnet: xj,
  defichainEvm: vj,
  defichainEvmTestnet: kj,
  degen: Cj,
  dfk: Sj,
  diode: Ij,
  disChain: Aj,
  dodochainTestnet: _j,
  dogechain: Tj,
  domaTestnet: Uj,
  donatuz: $j,
  dosChain: Bj,
  dosChainTestnet: Dj,
  dreyerxMainnet: Oj,
  dreyerxTestnet: Pj,
  dustboyIoT: Rj,
  dymension: Nj,
  edexa: Lj,
  edexaTestnet: Mj,
  edgeless: Fj,
  edgelessTestnet: zj,
  edgeware: jj,
  edgewareTestnet: Hj,
  eduChain: qj,
  eduChainTestnet: Kj,
  ekta: Vj,
  ektaTestnet: Gj,
  elastos: Wj,
  elastosTestnet: Zj,
  electroneum: Jj,
  electroneumTestnet: Xj,
  elysiumTestnet: Yj,
  energy: Qj,
  eni: eH,
  eniTestnet: tH,
  enuls: rH,
  eon: sH,
  eos: nH,
  eosTestnet: iH,
  eteria: oH,
  etherlink: aH,
  etherlinkTestnet: cH,
  ethernity: lH,
  etp: uH,
  evmos: hH,
  evmosTestnet: dH,
  excelonMainnet: pH,
  expanse: fH,
  exsat: mH,
  exsatTestnet: bH,
  fantom: yH,
  fantomSonicTestnet: gH,
  fantomTestnet: wH,
  fibo: EH,
  filecoin: xH,
  filecoinCalibration: vH,
  filecoinHyperspace: kH,
  fireChain: IM,
  flame: CH,
  flare: SH,
  flareTestnet: IH,
  flowMainnet: AH,
  flowPreviewnet: _H,
  flowTestnet: TH,
  fluence: UH,
  fluenceStage: $H,
  fluenceTestnet: BH,
  fluentTestnet: DH,
  form: OH,
  formTestnet: RH,
  forma: PH,
  formicarium: _V,
  forta: NH,
  foundry: LH,
  fraxtal: MH,
  fraxtalTestnet: FH,
  funkiMainnet: jH,
  funkiSepolia: qH,
  fuse: KH,
  fuseSparknet: VH,
  fusion: GH,
  fusionTestnet: WH,
  garnet: ZH,
  geist: JH,
  genesys: XH,
  giwaSepolia: YH,
  glideL1Protocol: QH,
  glideL2Protocol: eq,
  gnosis: tq,
  gnosisChiado: rq,
  goChain: iq,
  goat: sq,
  gobi: nq,
  godwoken: oq,
  goerli: aq,
  graphite: cq,
  graphiteTestnet: lq,
  gravity: uq,
  gunz: hq,
  guruNetwork: dq,
  guruTestnet: pq,
  ham: fq,
  happychainTestnet: mq,
  haqqMainnet: bq,
  haqqTestedge2: yq,
  hardhat: gq,
  harmonyOne: wq,
  hashkey: Eq,
  hashkeyTestnet: xq,
  haustTestnet: vq,
  hedera: kq,
  hederaPreviewnet: Cq,
  hederaTestnet: Sq,
  hela: Iq,
  hemi: Aq,
  hemiSepolia: _q,
  holesky: Tq,
  hoodi: Uq,
  hpb: $q,
  huddle01Mainnet: Dq,
  huddle01Testnet: Pq,
  humanity: Rq,
  humanityTestnet: Nq,
  humanode: Lq,
  humanodeTestnet5: Mq,
  hychain: Fq,
  hychainTestnet: zq,
  hyperliquidEvmTestnet: jq,
  iSunCoin: rK,
  icbNetwork: Hq,
  idchain: qq,
  immutableZkEvm: Kq,
  immutableZkEvmTestnet: Vq,
  inEVM: Gq,
  initVerse: Wq,
  initVerseGenesis: Zq,
  ink: Jq,
  inkSepolia: Xq,
  iota: Yq,
  iotaTestnet: Qq,
  iotex: eK,
  iotexTestnet: tK,
  jbc: sK,
  jbcTestnet: nK,
  jocMainnet: iK,
  jocTestnet: oK,
  jovay: aK,
  jovaySepolia: cK,
  juneo: lK,
  juneoBCH1Chain: uK,
  juneoDAI1Chain: hK,
  juneoDOGE1Chain: dK,
  juneoEUR1Chain: pK,
  juneoGLD1Chain: fK,
  juneoLINK1Chain: mK,
  juneoLTC1Chain: bK,
  juneoSGD1Chain: gK,
  juneoSocotraTestnet: wK,
  juneoUSD1Chain: EK,
  juneoUSDT1Chain: xK,
  juneomBTC1Chain: yK,
  kaia: vK,
  kairos: kK,
  kakarotSepolia: CK,
  kakarotStarknetSepolia: SK,
  kardiaChain: IK,
  karura: AK,
  katana: _K,
  kava: TK,
  kavaTestnet: UK,
  kcc: $K,
  kinto: BK,
  klaytn: DK,
  klaytnBaobab: OK,
  koi: PK,
  kroma: RK,
  kromaSepolia: NK,
  l3x: LK,
  l3xTestnet: MK,
  lavita: FK,
  lens: zK,
  lensTestnet: jK,
  lestnet: HK,
  lightlinkPegasus: qK,
  lightlinkPhoenix: KK,
  linea: GK,
  lineaGoerli: WK,
  lineaSepolia: ZK,
  lineaTestnet: JK,
  lisk: XK,
  liskSepolia: YK,
  loadAlphanet: QK,
  localhost: eV,
  loop: tV,
  lukso: rV,
  luksoTestnet: sV,
  lumiaMainnet: nV,
  lumiaTestnet: iV,
  lumoz: oV,
  lumozTestnet: aV,
  lycan: cV,
  lyra: lV,
  mainnet: uV,
  mandala: hV,
  manta: dV,
  mantaSepoliaTestnet: pV,
  mantaTestnet: fV,
  mantle: mV,
  mantleSepoliaTestnet: bV,
  mantleTestnet: yV,
  mantraDuKongEVMTestnet: gV,
  mantraEVM: wV,
  mapProtocol: EV,
  matchain: xV,
  matchainTestnet: vV,
  mchVerse: kV,
  megaethTestnet: CV,
  mekong: SV,
  meld: IV,
  memecore: AV,
  merlin: TV,
  merlinErigonTestnet: UV,
  metachain: $V,
  metachainIstanbul: BV,
  metadium: DV,
  metalL2: OV,
  meter: PV,
  meterTestnet: RV,
  metis: NV,
  metisGoerli: LV,
  metisSepolia: MV,
  mev: FV,
  mevTestnet: zV,
  mint: jV,
  mintSepoliaTestnet: HV,
  mitosisTestnet: qV,
  mode: KV,
  modeTestnet: VV,
  monadTestnet: GV,
  moonbaseAlpha: WV,
  moonbeam: ZV,
  moonbeamDev: JV,
  moonriver: XV,
  morph: YV,
  morphHolesky: QV,
  morphSepolia: eG,
  nahmii: tG,
  nautilus: rG,
  near: sG,
  nearTestnet: nG,
  neonDevnet: iG,
  neonMainnet: oG,
  neoxMainnet: aG,
  neoxT4: cG,
  newton: lG,
  nexi: uG,
  nexilix: hG,
  nibiru: dG,
  nitrographTestnet: pG,
  oasisTestnet: fG,
  oasys: mG,
  odysseyTestnet: bG,
  okc: yG,
  omax: gG,
  omni: wG,
  omniOmega: EG,
  oneWorld: xG,
  oortMainnetDev: vG,
  opBNB: kG,
  opBNBTestnet: CG,
  openledger: SG,
  optimism: IG,
  optimismGoerli: AG,
  optimismSepolia: _G,
  optopia: TG,
  optopiaTestnet: UG,
  orderly: $G,
  orderlySepolia: BG,
  otimDevnet: DG,
  palm: OG,
  palmTestnet: PG,
  peaq: RG,
  pgn: NG,
  pgnTestnet: LG,
  phoenix: MG,
  planq: FG,
  plasma: zG,
  plasmaDevnet: jG,
  plasmaTestnet: HG,
  playfiAlbireo: qG,
  plinga: KG,
  plume: GG,
  plumeDevnet: ZG,
  plumeMainnet: XG,
  plumeSepolia: QG,
  plumeTestnet: tW,
  polterTestnet: rW,
  polygon: sW,
  polygonAmoy: nW,
  polygonMumbai: iW,
  polygonZkEvm: oW,
  polygonZkEvmCardona: aW,
  polygonZkEvmTestnet: cW,
  polynomial: lW,
  polynomialSepolia: uW,
  premiumBlockTestnet: hW,
  pulsechain: dW,
  pulsechainV4: pW,
  pumpfiTestnet: fW,
  pyrope: mW,
  qMainnet: yW,
  qTestnet: gW,
  ql1: bW,
  real: wW,
  redbellyMainnet: EW,
  redbellyTestnet: xW,
  reddio: vW,
  reddioSepolia: kW,
  redstone: CW,
  rei: SW,
  reyaNetwork: IW,
  riseTestnet: AW,
  rivalz: _W,
  rollux: TW,
  rolluxTestnet: UW,
  ronin: $W,
  root: BW,
  rootPorcini: DW,
  rootstock: OW,
  rootstockTestnet: PW,
  rss3: RW,
  rss3Sepolia: NW,
  saakuru: LW,
  saga: MW,
  saigon: FW,
  sanko: zW,
  sapphire: jW,
  sapphireTestnet: HW,
  satoshiVM: qW,
  satoshiVMTestnet: KW,
  scroll: VW,
  scrollSepolia: GW,
  sei: WW,
  seiDevnet: ZW,
  seiTestnet: XW,
  seismicDevnet: JW,
  sepolia: YW,
  shape: QW,
  shapeSepolia: tZ,
  shardeum: rZ,
  shardeumSphinx: sZ,
  shibarium: nZ,
  shibariumTestnet: iZ,
  shiden: oZ,
  shimmer: aZ,
  shimmerTestnet: cZ,
  sidraChain: lZ,
  silicon: uZ,
  siliconSepolia: hZ,
  sixProtocol: dZ,
  skaleBlockBrawlers: pZ,
  skaleCalypso: fZ,
  skaleCalypsoTestnet: mZ,
  skaleCryptoBlades: bZ,
  skaleCryptoColosseum: yZ,
  skaleEuropa: gZ,
  skaleEuropaTestnet: wZ,
  skaleExorde: EZ,
  skaleHumanProtocol: xZ,
  skaleNebula: vZ,
  skaleNebulaTestnet: kZ,
  skaleRazor: CZ,
  skaleTitan: SZ,
  skaleTitanTestnet: IZ,
  sketchpad: AZ,
  snax: _Z,
  snaxTestnet: TZ,
  somniaTestnet: UZ,
  soneium: $Z,
  soneiumMinato: BZ,
  songbird: DZ,
  songbirdTestnet: OZ,
  sonic: PZ,
  sonicBlazeTestnet: RZ,
  sonicTestnet: NZ,
  sophon: LZ,
  sophonTestnet: MZ,
  sova: FZ,
  sovaSepolia: zZ,
  spicy: jZ,
  statusNetworkSepolia: F1,
  statusSepolia: F1,
  step: HZ,
  story: qZ,
  storyAeneid: KZ,
  storyOdyssey: VZ,
  storyTestnet: GZ,
  stratis: WZ,
  superlumio: ZZ,
  superposition: JZ,
  superseed: XZ,
  superseedSepolia: YZ,
  swan: QZ,
  swanProximaTestnet: eJ,
  swanSaturnTestnet: tJ,
  swellchain: rJ,
  swellchainTestnet: sJ,
  swissdlt: nJ,
  syscoin: iJ,
  syscoinTestnet: oJ,
  tac: aJ,
  tacSPB: cJ,
  taiko: lJ,
  taikoHekla: uJ,
  taikoJolnir: hJ,
  taikoKatla: dJ,
  taikoTestnetSepolia: pJ,
  taraxa: fJ,
  taraxaTestnet: mJ,
  teaSepolia: bJ,
  telcoinTestnet: yJ,
  telos: gJ,
  telosTestnet: wJ,
  tenet: EJ,
  ternoa: xJ,
  thaiChain: vJ,
  that: kJ,
  theta: CJ,
  thetaTestnet: SJ,
  thunderCore: IJ,
  thunderTestnet: AJ,
  tiktrixTestnet: _J,
  tomb: TJ,
  treasure: UJ,
  treasureTopaz: $J,
  tron: BJ,
  tronNile: DJ,
  tronShasta: OJ,
  ubiq: PJ,
  ultra: RJ,
  ultraTestnet: NJ,
  ultron: LJ,
  ultronTestnet: MJ,
  unichain: FJ,
  unichainSepolia: zJ,
  unique: jJ,
  uniqueOpal: HJ,
  uniqueQuartz: qJ,
  unreal: KJ,
  vanar: VJ,
  vechain: GJ,
  velas: WJ,
  viction: ZJ,
  victionTestnet: JJ,
  vision: XJ,
  visionTestnet: YJ,
  wanchain: QJ,
  wanchainTestnet: eX,
  weaveVMAlphanet: tX,
  wemix: rX,
  wemixTestnet: sX,
  westendAssetHub: nX,
  whitechain: iX,
  whitechainTestnet: oX,
  wmcTestnet: aX,
  worldLand: uX,
  worldchain: cX,
  worldchainSepolia: lX,
  x1Testnet: z1,
  xLayer: mX,
  xLayerTestnet: z1,
  xai: hX,
  xaiTestnet: dX,
  xdc: pX,
  xdcTestnet: fX,
  xphereMainnet: bX,
  xphereTestnet: yX,
  xrOne: gX,
  xrSepolia: xX,
  xrplevmDevnet: wX,
  xrplevmTestnet: EX,
  yooldoVerse: vX,
  yooldoVerseTestnet: kX,
  zenchainTestnet: CX,
  zeniq: SX,
  zeroG: kM,
  zeroGGalileoTestnet: CM,
  zeroGMainnet: SM,
  zeroNetwork: IX,
  zetachain: AX,
  zetachainAthensTestnet: _X,
  zhejiang: TX,
  zilliqa: UX,
  zilliqaTestnet: $X,
  zircuit: BX,
  zircuitGarfieldTestnet: DX,
  zircuitTestnet: OX,
  zkFair: PX,
  zkFairTestnet: RX,
  zkLinkNova: NX,
  zkLinkNovaSepoliaTestnet: LX,
  zkSync: j1,
  zkSyncInMemoryNode: H1,
  zkSyncLocalNode: q1,
  zkSyncSepoliaTestnet: K1,
  zksync: j1,
  zksyncInMemoryNode: H1,
  zksyncLocalCustomHyperchain: MX,
  zksyncLocalHyperchain: FX,
  zksyncLocalHyperchainL1: zX,
  zksyncLocalNode: q1,
  zksyncSepoliaTestnet: K1,
  zora: jX,
  zoraSepolia: HX,
  zoraTestnet: qX
}, Symbol.toStringTag, { value: "Module" })), Bd = {
  validateCaipAddress(t) {
    var e;
    if (((e = t.split(":")) == null ? void 0 : e.length) !== 3)
      throw new Error("Invalid CAIP Address");
    return t;
  },
  parseCaipAddress(t) {
    const e = t.split(":");
    if (e.length !== 3)
      throw new Error(`Invalid CAIP-10 address: ${t}`);
    const [r, s, n] = e;
    if (!r || !s || !n)
      throw new Error(`Invalid CAIP-10 address: ${t}`);
    return {
      chainNamespace: r,
      chainId: s,
      address: n
    };
  },
  parseCaipNetworkId(t) {
    const e = t.split(":");
    if (e.length !== 2)
      throw new Error(`Invalid CAIP-2 network id: ${t}`);
    const [r, s] = e;
    if (!r || !s)
      throw new Error(`Invalid CAIP-2 network id: ${t}`);
    return {
      chainNamespace: r,
      chainId: s
    };
  }
};
function VX(t) {
  const { method: e, params: r } = t.params.request;
  return e === "eth_sendTransaction" || e === "wallet_sendCalls" ? r[0].from : e === "personal_sign" ? r[1] : e === "eth_signTypedData_v4" || e === "wallet_getCapabilities" ? r[0] : null;
}
function GX(t) {
  const { method: e, params: r } = t.params.request;
  return e === "personal_sign" && (r[0].startsWith("0x") || (r[0] = Te(r[0]))), {
    method: e,
    params: r
  };
}
class WX {
  constructor(e, r) {
    this.appKit = e, this.wagmiConfig = r;
  }
  async getProvider() {
    var r;
    const e = (r = this.appKit) == null ? void 0 : r.getProvider("eip155");
    return e || new Promise((s, n) => {
      var a;
      const i = setTimeout(() => {
        n(new Error("Timeout waiting for provider"));
      }, 1e4), o = (a = this.appKit) == null ? void 0 : a.subscribeProviders((c) => {
        const l = c.eip155;
        l && (clearTimeout(i), o == null || o(), s(l));
      });
    });
  }
  getWagmiAccount() {
    if (!this.wagmiConfig)
      throw new Error("WagmiConfig is required to get account");
    return xM(this.wagmiConfig);
  }
  async reconnectWagmi() {
    if (!this.wagmiConfig)
      throw new Error("WagmiConfig is required to reconnect");
    await vM(this.wagmiConfig);
  }
  async waitForProvider(e = this.appKit) {
    return new Promise((r, s) => {
      if (this.getWagmiAccount().status === "disconnected") {
        s(new Error("User is disconnected"));
        return;
      }
      const i = setTimeout(() => {
        s(new Error("Timeout waiting for provider"));
      }, 1e4), o = e.subscribeProviders((a) => {
        a.eip155 && (clearTimeout(i), o(), r(a.eip155));
      });
    });
  }
  async waitForAccountStatus(e = this.appKit) {
    const r = this.getWagmiAccount();
    return r.status === "connected" || r.status === "disconnected" ? r.status : new Promise((s) => {
      e.subscribeAccount((n) => {
        (n.status === "connected" || n.status === "disconnected") && s(n.status);
      });
    });
  }
  async waitForAccountConnected(e = this.appKit) {
    if (this.getWagmiAccount().status !== "connected")
      return new Promise((s) => {
        e.subscribeAccount((n) => {
          n.status === "connected" && s();
        });
      });
  }
  async ensureCorrectNetwork(e) {
    var o;
    const { chainId: r } = Bd.parseCaipNetworkId(e), s = Object.values(KX), n = Number(r), i = s.find((a) => a.id === n);
    if (!i)
      throw new Error("No network found", { cause: e });
    await ((o = this.appKit) == null ? void 0 : o.switchNetwork(i));
  }
  async ensureCorrectAccount(e) {
    const r = VX(e);
    if (!r)
      throw new Error("No address found in request");
    const s = await this.getProvider(), n = await s.getUser({});
    n.address.toLowerCase() !== r.toLowerCase() && (n.preferredAccountType === "smartAccount" ? await s.setPreferredAccount("eoa") : await s.setPreferredAccount("smartAccount"));
  }
}
const ZX = "https://secure.walletconnect.org/sdk";
typeof process < "u" && typeof process.env < "u" && process.env.NEXT_PUBLIC_SECURE_SITE_SDK_URL;
typeof process < "u" && typeof process.env < "u" && process.env.NEXT_PUBLIC_DEFAULT_LOG_LEVEL;
typeof process < "u" && typeof process.env < "u" && process.env.NEXT_PUBLIC_SECURE_SITE_SDK_VERSION;
const G1 = {
  SAFE_RPC_METHODS: [
    "eth_accounts",
    "eth_blockNumber",
    "eth_call",
    "eth_chainId",
    "eth_estimateGas",
    "eth_feeHistory",
    "eth_gasPrice",
    "eth_getAccount",
    "eth_getBalance",
    "eth_getBlockByHash",
    "eth_getBlockByNumber",
    "eth_getBlockReceipts",
    "eth_getBlockTransactionCountByHash",
    "eth_getBlockTransactionCountByNumber",
    "eth_getCode",
    "eth_getFilterChanges",
    "eth_getFilterLogs",
    "eth_getLogs",
    "eth_getProof",
    "eth_getStorageAt",
    "eth_getTransactionByBlockHashAndIndex",
    "eth_getTransactionByBlockNumberAndIndex",
    "eth_getTransactionByHash",
    "eth_getTransactionCount",
    "eth_getTransactionReceipt",
    "eth_getUncleCountByBlockHash",
    "eth_getUncleCountByBlockNumber",
    "eth_maxPriorityFeePerGas",
    "eth_newBlockFilter",
    "eth_newFilter",
    "eth_newPendingTransactionFilter",
    "eth_sendRawTransaction",
    "eth_syncing",
    "eth_uninstallFilter",
    "wallet_getCapabilities",
    "wallet_getCallsStatus",
    "eth_getUserOperationReceipt",
    "eth_estimateUserOperationGas",
    "eth_getUserOperationByHash",
    "eth_supportedEntryPoints",
    "wallet_getAssets"
  ],
  NOT_SAFE_RPC_METHODS: [
    "personal_sign",
    "eth_signTypedData_v4",
    "eth_sendTransaction",
    "solana_signMessage",
    "solana_signTransaction",
    "solana_signAllTransactions",
    "solana_signAndSendTransaction",
    "wallet_sendCalls",
    "wallet_grantPermissions",
    "wallet_revokePermissions",
    "eth_sendUserOperation"
  ]
};
class JX {
  constructor(e) {
    st(this, "smartAccounts", []);
    st(this, "email");
    st(this, "namespaces");
    this.appKit = e;
  }
  async buildNamespaces(e, r) {
    let s = await e.getUser({ chainId: 1 });
    const { smartAccountEnabledNetworks: n } = await e.getSmartAccountEnabledNetworks(), i = n.map(
      (p) => `eip155:${p}`
    ), { saAddress: o, eoaAddress: a } = this.extractAddresses(s), c = this.getChains(r);
    if (!c || !o || !a)
      throw new Error("No chains or accounts found");
    const { smartAccounts: l, eoaAccounts: u } = this.buildAccountLists(
      c,
      o,
      a,
      i
    ), h = this.orderAccounts(l, u, s);
    this.smartAccounts = l, this.email = s.email, this.namespaces = this.buildNamespaceConfig(c, h);
  }
  getNamespaces() {
    return this.namespaces;
  }
  getSmartAccounts() {
    return this.smartAccounts;
  }
  getEmail() {
    return this.email;
  }
  extractAddresses(e) {
    var r, s, n, i;
    return {
      saAddress: (s = (r = e.accounts) == null ? void 0 : r.find((o) => o.type === "smartAccount")) == null ? void 0 : s.address,
      eoaAddress: (i = (n = e.accounts) == null ? void 0 : n.find((o) => o.type === "eoa")) == null ? void 0 : i.address
    };
  }
  getChains(e) {
    var s;
    const r = ((s = this.appKit) == null ? void 0 : s.options.networks.map(
      (n) => typeof n.id == "number" ? `eip155:${n.id}` : n.id
    )) || [];
    return e ? e.filter((n) => r.includes(n)) : r;
  }
  buildAccountLists(e, r, s, n) {
    return {
      smartAccounts: e.filter((i) => n.includes(i)).map((i) => `${i}:${r}`),
      eoaAccounts: e.map((i) => `${i}:${s}`)
    };
  }
  orderAccounts(e, r, s) {
    const n = `eip155:${s.chainId}`, i = s.preferredAccountType === "smartAccount" ? e[0] : r[0];
    let o = i;
    if (Bd.validateCaipAddress(i)) {
      const { address: c } = Bd.parseCaipAddress(
        i
      );
      o = c;
    }
    const a = `${n}:${o}`;
    return [
      a,
      ...[...e, ...r].filter(
        (c) => c !== a
      )
    ];
  }
  buildNamespaceConfig(e, r) {
    const s = G1.SAFE_RPC_METHODS.concat(
      G1.NOT_SAFE_RPC_METHODS
    );
    return {
      eip155: {
        chains: e,
        methods: s,
        events: ["accountsChanged", "chainChanged", "reown_updateEmail"],
        accounts: r
      }
    };
  }
}
var Dd = {}, Od = function(t, e) {
  return Od = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, s) {
    r.__proto__ = s;
  } || function(r, s) {
    for (var n in s) Object.prototype.hasOwnProperty.call(s, n) && (r[n] = s[n]);
  }, Od(t, e);
};
function gE(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Od(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var fl = function() {
  return fl = Object.assign || function(e) {
    for (var r, s = 1, n = arguments.length; s < n; s++) {
      r = arguments[s];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, fl.apply(this, arguments);
};
function wE(t, e) {
  var r = {};
  for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && e.indexOf(s) < 0 && (r[s] = t[s]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, s = Object.getOwnPropertySymbols(t); n < s.length; n++)
      e.indexOf(s[n]) < 0 && Object.prototype.propertyIsEnumerable.call(t, s[n]) && (r[s[n]] = t[s[n]]);
  return r;
}
function EE(t, e, r, s) {
  var n = arguments.length, i = n < 3 ? e : s === null ? s = Object.getOwnPropertyDescriptor(e, r) : s, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(t, e, r, s);
  else for (var a = t.length - 1; a >= 0; a--) (o = t[a]) && (i = (n < 3 ? o(i) : n > 3 ? o(e, r, i) : o(e, r)) || i);
  return n > 3 && i && Object.defineProperty(e, r, i), i;
}
function xE(t, e) {
  return function(r, s) {
    e(r, s, t);
  };
}
function vE(t, e, r, s, n, i) {
  function o(I) {
    if (I !== void 0 && typeof I != "function") throw new TypeError("Function expected");
    return I;
  }
  for (var a = s.kind, c = a === "getter" ? "get" : a === "setter" ? "set" : "value", l = !e && t ? s.static ? t : t.prototype : null, u = e || (l ? Object.getOwnPropertyDescriptor(l, s.name) : {}), h, p = !1, y = r.length - 1; y >= 0; y--) {
    var b = {};
    for (var g in s) b[g] = g === "access" ? {} : s[g];
    for (var g in s.access) b.access[g] = s.access[g];
    b.addInitializer = function(I) {
      if (p) throw new TypeError("Cannot add initializers after decoration has completed");
      i.push(o(I || null));
    };
    var x = (0, r[y])(a === "accessor" ? { get: u.get, set: u.set } : u[c], b);
    if (a === "accessor") {
      if (x === void 0) continue;
      if (x === null || typeof x != "object") throw new TypeError("Object expected");
      (h = o(x.get)) && (u.get = h), (h = o(x.set)) && (u.set = h), (h = o(x.init)) && n.unshift(h);
    } else (h = o(x)) && (a === "field" ? n.unshift(h) : u[c] = h);
  }
  l && Object.defineProperty(l, s.name, u), p = !0;
}
function kE(t, e, r) {
  for (var s = arguments.length > 2, n = 0; n < e.length; n++)
    r = s ? e[n].call(t, r) : e[n].call(t);
  return s ? r : void 0;
}
function CE(t) {
  return typeof t == "symbol" ? t : "".concat(t);
}
function SE(t, e, r) {
  return typeof e == "symbol" && (e = e.description ? "[".concat(e.description, "]") : ""), Object.defineProperty(t, "name", { configurable: !0, value: r ? "".concat(r, " ", e) : e });
}
function IE(t, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(t, e);
}
function AE(t, e, r, s) {
  function n(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function a(u) {
      try {
        l(s.next(u));
      } catch (h) {
        o(h);
      }
    }
    function c(u) {
      try {
        l(s.throw(u));
      } catch (h) {
        o(h);
      }
    }
    function l(u) {
      u.done ? i(u.value) : n(u.value).then(a, c);
    }
    l((s = s.apply(t, e || [])).next());
  });
}
function _E(t, e) {
  var r = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, s, n, i, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = a(0), o.throw = a(1), o.return = a(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (s) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, l[0] && (r = 0)), r; ) try {
      if (s = 1, n && (i = l[0] & 2 ? n.return : l[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, l[1])).done) return i;
      switch (n = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return r.label++, { value: l[1], done: !1 };
        case 5:
          r.label++, n = l[1], l = [0];
          continue;
        case 7:
          l = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (i = r.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            r = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            r.label = l[1];
            break;
          }
          if (l[0] === 6 && r.label < i[1]) {
            r.label = i[1], i = l;
            break;
          }
          if (i && r.label < i[2]) {
            r.label = i[2], r.ops.push(l);
            break;
          }
          i[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      l = e.call(t, r);
    } catch (u) {
      l = [6, u], n = 0;
    } finally {
      s = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
var Kl = Object.create ? function(t, e, r, s) {
  s === void 0 && (s = r);
  var n = Object.getOwnPropertyDescriptor(e, r);
  (!n || ("get" in n ? !e.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
    return e[r];
  } }), Object.defineProperty(t, s, n);
} : function(t, e, r, s) {
  s === void 0 && (s = r), t[s] = e[r];
};
function TE(t, e) {
  for (var r in t) r !== "default" && !Object.prototype.hasOwnProperty.call(e, r) && Kl(e, t, r);
}
function ml(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], s = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && s >= t.length && (t = void 0), { value: t && t[s++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Hp(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var s = r.call(t), n, i = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(n = s.next()).done; ) i.push(n.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      n && !n.done && (r = s.return) && r.call(s);
    } finally {
      if (o) throw o.error;
    }
  }
  return i;
}
function UE() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t = t.concat(Hp(arguments[e]));
  return t;
}
function $E() {
  for (var t = 0, e = 0, r = arguments.length; e < r; e++) t += arguments[e].length;
  for (var s = Array(t), n = 0, e = 0; e < r; e++)
    for (var i = arguments[e], o = 0, a = i.length; o < a; o++, n++)
      s[n] = i[o];
  return s;
}
function BE(t, e, r) {
  if (r || arguments.length === 2) for (var s = 0, n = e.length, i; s < n; s++)
    (i || !(s in e)) && (i || (i = Array.prototype.slice.call(e, 0, s)), i[s] = e[s]);
  return t.concat(i || Array.prototype.slice.call(e));
}
function mi(t) {
  return this instanceof mi ? (this.v = t, this) : new mi(t);
}
function DE(t, e, r) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var s = r.apply(t, e || []), n, i = [];
  return n = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), a("next"), a("throw"), a("return", o), n[Symbol.asyncIterator] = function() {
    return this;
  }, n;
  function o(y) {
    return function(b) {
      return Promise.resolve(b).then(y, h);
    };
  }
  function a(y, b) {
    s[y] && (n[y] = function(g) {
      return new Promise(function(x, I) {
        i.push([y, g, x, I]) > 1 || c(y, g);
      });
    }, b && (n[y] = b(n[y])));
  }
  function c(y, b) {
    try {
      l(s[y](b));
    } catch (g) {
      p(i[0][3], g);
    }
  }
  function l(y) {
    y.value instanceof mi ? Promise.resolve(y.value.v).then(u, h) : p(i[0][2], y);
  }
  function u(y) {
    c("next", y);
  }
  function h(y) {
    c("throw", y);
  }
  function p(y, b) {
    y(b), i.shift(), i.length && c(i[0][0], i[0][1]);
  }
}
function OE(t) {
  var e, r;
  return e = {}, s("next"), s("throw", function(n) {
    throw n;
  }), s("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function s(n, i) {
    e[n] = t[n] ? function(o) {
      return (r = !r) ? { value: mi(t[n](o)), done: !1 } : i ? i(o) : o;
    } : i;
  }
}
function PE(t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], r;
  return e ? e.call(t) : (t = typeof ml == "function" ? ml(t) : t[Symbol.iterator](), r = {}, s("next"), s("throw"), s("return"), r[Symbol.asyncIterator] = function() {
    return this;
  }, r);
  function s(i) {
    r[i] = t[i] && function(o) {
      return new Promise(function(a, c) {
        o = t[i](o), n(a, c, o.done, o.value);
      });
    };
  }
  function n(i, o, a, c) {
    Promise.resolve(c).then(function(l) {
      i({ value: l, done: a });
    }, o);
  }
}
function RE(t, e) {
  return Object.defineProperty ? Object.defineProperty(t, "raw", { value: e }) : t.raw = e, t;
}
var XX = Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}, Pd = function(t) {
  return Pd = Object.getOwnPropertyNames || function(e) {
    var r = [];
    for (var s in e) Object.prototype.hasOwnProperty.call(e, s) && (r[r.length] = s);
    return r;
  }, Pd(t);
};
function NE(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (t != null)
    for (var r = Pd(t), s = 0; s < r.length; s++) r[s] !== "default" && Kl(e, t, r[s]);
  return XX(e, t), e;
}
function LE(t) {
  return t && t.__esModule ? t : { default: t };
}
function ME(t, e, r, s) {
  if (r === "a" && !s) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !s : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? s : r === "a" ? s.call(t) : s ? s.value : e.get(t);
}
function FE(t, e, r, s, n) {
  if (s === "m") throw new TypeError("Private method is not writable");
  if (s === "a" && !n) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !n : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return s === "a" ? n.call(t, r) : n ? n.value = r : e.set(t, r), r;
}
function zE(t, e) {
  if (e === null || typeof e != "object" && typeof e != "function") throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof t == "function" ? e === t : t.has(e);
}
function jE(t, e, r) {
  if (e != null) {
    if (typeof e != "object" && typeof e != "function") throw new TypeError("Object expected.");
    var s, n;
    if (r) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      s = e[Symbol.asyncDispose];
    }
    if (s === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      s = e[Symbol.dispose], r && (n = s);
    }
    if (typeof s != "function") throw new TypeError("Object not disposable.");
    n && (s = function() {
      try {
        n.call(this);
      } catch (i) {
        return Promise.reject(i);
      }
    }), t.stack.push({ value: e, dispose: s, async: r });
  } else r && t.stack.push({ async: !0 });
  return e;
}
var YX = typeof SuppressedError == "function" ? SuppressedError : function(t, e, r) {
  var s = new Error(r);
  return s.name = "SuppressedError", s.error = t, s.suppressed = e, s;
};
function HE(t) {
  function e(i) {
    t.error = t.hasError ? new YX(i, t.error, "An error was suppressed during disposal.") : i, t.hasError = !0;
  }
  var r, s = 0;
  function n() {
    for (; r = t.stack.pop(); )
      try {
        if (!r.async && s === 1) return s = 0, t.stack.push(r), Promise.resolve().then(n);
        if (r.dispose) {
          var i = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(i).then(n, function(o) {
            return e(o), n();
          });
        } else s |= 1;
      } catch (o) {
        e(o);
      }
    if (s === 1) return t.hasError ? Promise.reject(t.error) : Promise.resolve();
    if (t.hasError) throw t.error;
  }
  return n();
}
function qE(t, e) {
  return typeof t == "string" && /^\.\.?\//.test(t) ? t.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(r, s, n, i, o) {
    return s ? e ? ".jsx" : ".js" : n && (!i || !o) ? r : n + i + "." + o.toLowerCase() + "js";
  }) : t;
}
const QX = {
  __extends: gE,
  __assign: fl,
  __rest: wE,
  __decorate: EE,
  __param: xE,
  __esDecorate: vE,
  __runInitializers: kE,
  __propKey: CE,
  __setFunctionName: SE,
  __metadata: IE,
  __awaiter: AE,
  __generator: _E,
  __createBinding: Kl,
  __exportStar: TE,
  __values: ml,
  __read: Hp,
  __spread: UE,
  __spreadArrays: $E,
  __spreadArray: BE,
  __await: mi,
  __asyncGenerator: DE,
  __asyncDelegator: OE,
  __asyncValues: PE,
  __makeTemplateObject: RE,
  __importStar: NE,
  __importDefault: LE,
  __classPrivateFieldGet: ME,
  __classPrivateFieldSet: FE,
  __classPrivateFieldIn: zE,
  __addDisposableResource: jE,
  __disposeResources: HE,
  __rewriteRelativeImportExtension: qE
}, eY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource: jE,
  get __assign() {
    return fl;
  },
  __asyncDelegator: OE,
  __asyncGenerator: DE,
  __asyncValues: PE,
  __await: mi,
  __awaiter: AE,
  __classPrivateFieldGet: ME,
  __classPrivateFieldIn: zE,
  __classPrivateFieldSet: FE,
  __createBinding: Kl,
  __decorate: EE,
  __disposeResources: HE,
  __esDecorate: vE,
  __exportStar: TE,
  __extends: gE,
  __generator: _E,
  __importDefault: LE,
  __importStar: NE,
  __makeTemplateObject: RE,
  __metadata: IE,
  __param: xE,
  __propKey: CE,
  __read: Hp,
  __rest: wE,
  __rewriteRelativeImportExtension: qE,
  __runInitializers: kE,
  __setFunctionName: SE,
  __spread: UE,
  __spreadArray: BE,
  __spreadArrays: $E,
  __values: ml,
  default: QX
}, Symbol.toStringTag, { value: "Module" })), Vl = /* @__PURE__ */ m0(eY);
var rh = {}, W1;
function qp() {
  return W1 || (W1 = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.STANDARD_ERROR_MAP = t.SERVER_ERROR_CODE_RANGE = t.RESERVED_ERROR_CODES = t.SERVER_ERROR = t.INTERNAL_ERROR = t.INVALID_PARAMS = t.METHOD_NOT_FOUND = t.INVALID_REQUEST = t.PARSE_ERROR = void 0, t.PARSE_ERROR = "PARSE_ERROR", t.INVALID_REQUEST = "INVALID_REQUEST", t.METHOD_NOT_FOUND = "METHOD_NOT_FOUND", t.INVALID_PARAMS = "INVALID_PARAMS", t.INTERNAL_ERROR = "INTERNAL_ERROR", t.SERVER_ERROR = "SERVER_ERROR", t.RESERVED_ERROR_CODES = [-32700, -32600, -32601, -32602, -32603], t.SERVER_ERROR_CODE_RANGE = [-32e3, -32099], t.STANDARD_ERROR_MAP = {
      [t.PARSE_ERROR]: { code: -32700, message: "Parse error" },
      [t.INVALID_REQUEST]: { code: -32600, message: "Invalid Request" },
      [t.METHOD_NOT_FOUND]: { code: -32601, message: "Method not found" },
      [t.INVALID_PARAMS]: { code: -32602, message: "Invalid params" },
      [t.INTERNAL_ERROR]: { code: -32603, message: "Internal error" },
      [t.SERVER_ERROR]: { code: -32e3, message: "Server error" }
    };
  }(rh)), rh;
}
var _t = {}, Z1;
function KE() {
  if (Z1) return _t;
  Z1 = 1, Object.defineProperty(_t, "__esModule", { value: !0 }), _t.validateJsonRpcError = _t.getErrorByCode = _t.getError = _t.isValidErrorCode = _t.isReservedErrorCode = _t.isServerErrorCode = void 0;
  const t = qp();
  function e(a) {
    return a <= t.SERVER_ERROR_CODE_RANGE[0] && a >= t.SERVER_ERROR_CODE_RANGE[1];
  }
  _t.isServerErrorCode = e;
  function r(a) {
    return t.RESERVED_ERROR_CODES.includes(a);
  }
  _t.isReservedErrorCode = r;
  function s(a) {
    return typeof a == "number";
  }
  _t.isValidErrorCode = s;
  function n(a) {
    return Object.keys(t.STANDARD_ERROR_MAP).includes(a) ? t.STANDARD_ERROR_MAP[a] : t.STANDARD_ERROR_MAP[t.INTERNAL_ERROR];
  }
  _t.getError = n;
  function i(a) {
    const c = Object.values(t.STANDARD_ERROR_MAP).find((l) => l.code === a);
    return c || t.STANDARD_ERROR_MAP[t.INTERNAL_ERROR];
  }
  _t.getErrorByCode = i;
  function o(a) {
    if (typeof a.error.code > "u")
      return { valid: !1, error: "Missing code for JSON-RPC error" };
    if (typeof a.error.message > "u")
      return { valid: !1, error: "Missing message for JSON-RPC error" };
    if (!s(a.error.code))
      return {
        valid: !1,
        error: `Invalid error code type for JSON-RPC: ${a.error.code}`
      };
    if (r(a.error.code)) {
      const c = i(a.error.code);
      if (c.message !== t.STANDARD_ERROR_MAP[t.INTERNAL_ERROR].message && a.error.message === c.message)
        return {
          valid: !1,
          error: `Invalid error code message for JSON-RPC: ${a.error.code}`
        };
    }
    return { valid: !0 };
  }
  return _t.validateJsonRpcError = o, _t;
}
var sh = {}, nh = {}, us = {}, J1;
function tY() {
  if (J1) return us;
  J1 = 1, Object.defineProperty(us, "__esModule", { value: !0 }), us.isBrowserCryptoAvailable = us.getSubtleCrypto = us.getBrowerCrypto = void 0;
  function t() {
    return (globalThis == null ? void 0 : globalThis.crypto) || (globalThis == null ? void 0 : globalThis.msCrypto) || {};
  }
  us.getBrowerCrypto = t;
  function e() {
    const s = t();
    return s.subtle || s.webkitSubtle;
  }
  us.getSubtleCrypto = e;
  function r() {
    return !!t() && !!e();
  }
  return us.isBrowserCryptoAvailable = r, us;
}
var hs = {}, X1;
function rY() {
  if (X1) return hs;
  X1 = 1, Object.defineProperty(hs, "__esModule", { value: !0 }), hs.isBrowser = hs.isNode = hs.isReactNative = void 0;
  function t() {
    return typeof document > "u" && typeof navigator < "u" && navigator.product === "ReactNative";
  }
  hs.isReactNative = t;
  function e() {
    return typeof process < "u" && typeof process.versions < "u" && typeof process.versions.node < "u";
  }
  hs.isNode = e;
  function r() {
    return !t() && !e();
  }
  return hs.isBrowser = r, hs;
}
var Y1;
function Q1() {
  return Y1 || (Y1 = 1, function(t) {
    var e = Ba && Ba.__createBinding || (Object.create ? function(s, n, i, o) {
      o === void 0 && (o = i), Object.defineProperty(s, o, { enumerable: !0, get: function() {
        return n[i];
      } });
    } : function(s, n, i, o) {
      o === void 0 && (o = i), s[o] = n[i];
    }), r = Ba && Ba.__exportStar || function(s, n) {
      for (var i in s) i !== "default" && !n.hasOwnProperty(i) && e(n, s, i);
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), r(tY(), t), r(rY(), t);
  }(nh)), nh;
}
var e0;
function sY() {
  return e0 || (e0 = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.isNodeJs = void 0;
    const e = Vl, r = Q1();
    t.isNodeJs = r.isNode, e.__exportStar(Q1(), t);
  }(sh)), sh;
}
var Xt = {}, t0;
function nY() {
  if (t0) return Xt;
  t0 = 1, Object.defineProperty(Xt, "__esModule", { value: !0 }), Xt.formatErrorMessage = Xt.formatJsonRpcError = Xt.formatJsonRpcResult = Xt.formatJsonRpcRequest = Xt.payloadId = void 0;
  const t = KE(), e = qp();
  function r() {
    const a = Date.now() * Math.pow(10, 3), c = Math.floor(Math.random() * Math.pow(10, 3));
    return a + c;
  }
  Xt.payloadId = r;
  function s(a, c, l) {
    return {
      id: l || r(),
      jsonrpc: "2.0",
      method: a,
      params: c
    };
  }
  Xt.formatJsonRpcRequest = s;
  function n(a, c) {
    return {
      id: a,
      jsonrpc: "2.0",
      result: c
    };
  }
  Xt.formatJsonRpcResult = n;
  function i(a, c) {
    return {
      id: a,
      jsonrpc: "2.0",
      error: o(c)
    };
  }
  Xt.formatJsonRpcError = i;
  function o(a) {
    if (typeof a > "u")
      return t.getError(e.INTERNAL_ERROR);
    if (typeof a == "string" && (a = Object.assign(Object.assign({}, t.getError(e.SERVER_ERROR)), { message: a })), t.isReservedErrorCode(a.code) && (a = t.getErrorByCode(a.code)), !t.isServerErrorCode(a.code))
      throw new Error("Error code is not in server code range");
    return a;
  }
  return Xt.formatErrorMessage = o, Xt;
}
var Yt = {}, r0;
function iY() {
  if (r0) return Yt;
  r0 = 1, Object.defineProperty(Yt, "__esModule", { value: !0 }), Yt.isValidTrailingWildcardRoute = Yt.isValidLeadingWildcardRoute = Yt.isValidWildcardRoute = Yt.isValidDefaultRoute = Yt.isValidRoute = void 0;
  function t(i) {
    return i.includes("*") ? r(i) : !/\W/g.test(i);
  }
  Yt.isValidRoute = t;
  function e(i) {
    return i === "*";
  }
  Yt.isValidDefaultRoute = e;
  function r(i) {
    return e(i) ? !0 : !(!i.includes("*") || i.split("*").length !== 2 || i.split("*").filter((o) => o.trim() === "").length !== 1);
  }
  Yt.isValidWildcardRoute = r;
  function s(i) {
    return !e(i) && r(i) && !i.split("*")[0].trim();
  }
  Yt.isValidLeadingWildcardRoute = s;
  function n(i) {
    return !e(i) && r(i) && !i.split("*")[1].trim();
  }
  return Yt.isValidTrailingWildcardRoute = n, Yt;
}
var ih = {}, oh = {}, ds = {}, mo = {}, s0;
function Kp() {
  if (s0) return mo;
  s0 = 1, Object.defineProperty(mo, "__esModule", { value: !0 }), mo.IEvents = void 0;
  class t {
  }
  return mo.IEvents = t, mo;
}
var ps = {}, n0;
function Vp() {
  if (n0) return ps;
  n0 = 1, Object.defineProperty(ps, "__esModule", { value: !0 }), ps.IJsonRpcProvider = ps.IBaseJsonRpcProvider = ps.IJsonRpcConnection = void 0;
  const t = Kp();
  class e extends t.IEvents {
    constructor(i) {
      super();
    }
  }
  ps.IJsonRpcConnection = e;
  class r extends t.IEvents {
    constructor() {
      super();
    }
  }
  ps.IBaseJsonRpcProvider = r;
  class s extends r {
    constructor(i) {
      super();
    }
  }
  return ps.IJsonRpcProvider = s, ps;
}
var i0;
function oY() {
  if (i0) return ds;
  i0 = 1, Object.defineProperty(ds, "__esModule", { value: !0 }), ds.IBlockchainProvider = ds.IBlockchainAuthenticator = ds.IPendingRequests = void 0;
  const t = Kp(), e = Vp();
  class r {
    constructor(o) {
      this.storage = o;
    }
  }
  ds.IPendingRequests = r;
  class s extends t.IEvents {
    constructor(o) {
      super(), this.config = o;
    }
  }
  ds.IBlockchainAuthenticator = s;
  class n extends e.IJsonRpcProvider {
    constructor(o, a) {
      super(o);
    }
  }
  return ds.IBlockchainProvider = n, ds;
}
var ah = {}, o0;
function aY() {
  return o0 || (o0 = 1, Object.defineProperty(ah, "__esModule", { value: !0 })), ah;
}
var bo = {}, a0;
function cY() {
  if (a0) return bo;
  a0 = 1, Object.defineProperty(bo, "__esModule", { value: !0 }), bo.IMultiServiceProvider = void 0;
  const t = Vp();
  class e extends t.IBaseJsonRpcProvider {
    constructor(s) {
      super(), this.config = s;
    }
  }
  return bo.IMultiServiceProvider = e, bo;
}
var yo = {}, c0;
function lY() {
  if (c0) return yo;
  c0 = 1, Object.defineProperty(yo, "__esModule", { value: !0 }), yo.IJsonRpcRouter = void 0;
  class t {
    constructor(r) {
      this.routes = r;
    }
  }
  return yo.IJsonRpcRouter = t, yo;
}
var ch = {}, l0;
function uY() {
  return l0 || (l0 = 1, Object.defineProperty(ch, "__esModule", { value: !0 })), ch;
}
var go = {}, u0;
function hY() {
  if (u0) return go;
  u0 = 1, Object.defineProperty(go, "__esModule", { value: !0 }), go.IJsonRpcValidator = void 0;
  class t {
    constructor(r) {
      this.schemas = r;
    }
  }
  return go.IJsonRpcValidator = t, go;
}
var h0;
function dY() {
  return h0 || (h0 = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    const e = Vl;
    e.__exportStar(oY(), t), e.__exportStar(aY(), t), e.__exportStar(Kp(), t), e.__exportStar(cY(), t), e.__exportStar(Vp(), t), e.__exportStar(lY(), t), e.__exportStar(uY(), t), e.__exportStar(hY(), t);
  }(oh)), oh;
}
var d0;
function pY() {
  return d0 || (d0 = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), Vl.__exportStar(dY(), t);
  }(ih)), ih;
}
var Tt = {}, p0;
function fY() {
  if (p0) return Tt;
  p0 = 1, Object.defineProperty(Tt, "__esModule", { value: !0 }), Tt.isJsonRpcValidationInvalid = Tt.isJsonRpcError = Tt.isJsonRpcResult = Tt.isJsonRpcResponse = Tt.isJsonRpcRequest = Tt.isJsonRpcPayload = void 0;
  function t(o) {
    return "id" in o && "jsonrpc" in o && o.jsonrpc === "2.0";
  }
  Tt.isJsonRpcPayload = t;
  function e(o) {
    return t(o) && "method" in o;
  }
  Tt.isJsonRpcRequest = e;
  function r(o) {
    return t(o) && (s(o) || n(o));
  }
  Tt.isJsonRpcResponse = r;
  function s(o) {
    return "result" in o;
  }
  Tt.isJsonRpcResult = s;
  function n(o) {
    return "error" in o;
  }
  Tt.isJsonRpcError = n;
  function i(o) {
    return "error" in o && o.valid === !1;
  }
  return Tt.isJsonRpcValidationInvalid = i, Tt;
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  const e = Vl;
  e.__exportStar(qp(), t), e.__exportStar(KE(), t), e.__exportStar(sY(), t), e.__exportStar(nY(), t), e.__exportStar(iY(), t), e.__exportStar(pY(), t), e.__exportStar(fY(), t);
})(Dd);
const mY = {
  UPDATE_EMAIL: "reown_updateEmail"
}, lh = "@reown/web-wallet/session-users";
class bY {
  constructor(e, r, s, n) {
    st(this, "sessionUsers");
    this.walletKit = e, this.namespaceController = r, this.getProvider = s, this.appKit = n, this.sessionUsers = this.loadSessionUsers();
  }
  loadSessionUsers() {
    if (typeof window > "u") return /* @__PURE__ */ new Map();
    try {
      const e = window.localStorage.getItem(lh);
      if (!e) return /* @__PURE__ */ new Map();
      const r = JSON.parse(e);
      return new Map(Object.entries(r));
    } catch (e) {
      return console.error(
        "[SessionController] LoadSessionUsers. Failed to load session users from storage:",
        e
      ), /* @__PURE__ */ new Map();
    }
  }
  saveSessionUsers() {
    if (!(typeof window > "u"))
      try {
        const e = window.localStorage.getItem(lh), r = e ? JSON.parse(e) : {}, s = Object.fromEntries(this.sessionUsers), n = {};
        Object.entries(s).forEach(([i, o]) => {
          n[i] = { ...o };
        }), Object.entries(r).forEach(([i, o]) => {
          n[i] && o.loginProvider && !n[i].loginProvider ? n[i].loginProvider = o.loginProvider : n[i] || (n[i] = o);
        }), window.localStorage.setItem(lh, JSON.stringify(n));
      } catch (e) {
        console.error(
          "[SessionController] SaveSessionUsers. Failed to save session users to storage:",
          e
        );
      }
  }
  async getUserInfo() {
    var n, i;
    if (!this.appKit) throw new Error("AppKit not initialized");
    const e = this.appKit.getAccount(), r = (n = e == null ? void 0 : e.embeddedWalletInfo) == null ? void 0 : n.user, s = (i = e == null ? void 0 : e.embeddedWalletInfo) == null ? void 0 : i.authProvider;
    if (!r)
      throw new Error("User info not found");
    if (!r.email && !r.username)
      throw new Error("User is missing email and username");
    return {
      email: r.email,
      username: r.username,
      loginProvider: s
    };
  }
  async connect({ uri: e, loginProvider: r }) {
    if (!this.walletKit) throw new Error("WalletKit not initialized");
    const s = new Promise((n) => {
      this.walletKit.once("session_proposal", (i) => {
        n({
          proposal: i,
          approve: async () => {
            var b, g, x, I;
            const a = await this.getProvider(), c = ((g = (b = i.params.optionalNamespaces) == null ? void 0 : b.eip155) == null ? void 0 : g.chains) || [], l = ((I = (x = i.params.requiredNamespaces) == null ? void 0 : x.eip155) == null ? void 0 : I.chains) || [], u = [.../* @__PURE__ */ new Set([...c, ...l])];
            await this.namespaceController.buildNamespaces(a, u);
            const h = this.namespaceController.getNamespaces();
            if (!h)
              throw new Error("Failed to build namespaces");
            const p = await this.getUserInfo();
            if (!p)
              throw new Error("Failed to get user info");
            p.loginProvider || (p.loginProvider = r);
            const y = await this.walletKit.approveSession({
              id: i.id,
              namespaces: h,
              sessionProperties: {
                smartAccounts: JSON.stringify(this.namespaceController.getSmartAccounts()),
                ...this.getSessionUserProperties(p)
              }
            });
            return this.sessionUsers.set(y.topic, p), this.saveSessionUsers(), y;
          },
          reject: async () => {
            await this.walletKit.rejectSession({
              id: i.id,
              reason: {
                code: 4001,
                message: "User rejected"
              }
            });
          }
        });
      });
    });
    return await this.walletKit.pair({ uri: e }), s;
  }
  async getPendingRequests() {
    if (!this.walletKit) throw new Error("WalletKit not initialized");
    return this.walletKit.getPendingSessionRequests().filter((r) => this.sessionUsers.has(r.topic)).map((r) => ({
      ...r,
      user: this.sessionUsers.get(r.topic)
    }));
  }
  async getCurrentUser() {
    return this.getUserInfo();
  }
  async respondToRequest(e, { result: r, error: s }) {
    s ? await this.walletKit.respondSessionRequest({
      topic: e.topic,
      response: Dd.formatJsonRpcError(
        e.id,
        s instanceof Error ? s.message : "User rejected"
      )
    }) : await this.walletKit.respondSessionRequest({
      topic: e.topic,
      response: Dd.formatJsonRpcResult(e.id, r)
    });
  }
  subscribeToSessionRequests(e) {
    if (!this.walletKit) throw new Error("WalletKit not initialized");
    const r = (s) => {
      const n = this.sessionUsers.get(s.topic);
      n && e({ ...s, user: n });
    };
    return this.walletKit.on("session_request", r), () => {
      this.walletKit.off("session_request", r);
    };
  }
  getUserForSession(e) {
    return this.sessionUsers.get(e);
  }
  saveUserForSession(e, r) {
    this.sessionUsers.set(e, r), this.saveSessionUsers();
  }
  getSessionUserProperties(e) {
    const r = {}, s = this.namespaceController.getEmail();
    return s && (r.email = s), e.username && (r.username = e.username), e.loginProvider && (r.provider = e.loginProvider), r;
  }
  async updateUserEmail(e, r, s) {
    var c;
    if (!this.walletKit) throw new Error("WalletKit not initialized");
    const n = this.walletKit.getActiveSessions();
    if (!n) return;
    let i = (c = this.appKit) == null ? void 0 : c.getChainId();
    typeof i == "number" && (i = `eip155:${i}`);
    const o = [];
    let a = !1;
    for (const [l, u] of Object.entries(n)) {
      const h = u.sessionProperties || {};
      if (!(h.provider !== "email" || h.email !== e)) {
        if (l !== s) {
          o.push(l);
          continue;
        }
        a = !0;
        try {
          if (await this.walletKit.emitSessionEvent({
            topic: s,
            event: {
              name: mY.UPDATE_EMAIL,
              data: { email: r }
            },
            chainId: i
          }), this.sessionUsers.has(s)) {
            const p = this.sessionUsers.get(s);
            this.sessionUsers.set(s, {
              ...p,
              email: r
            }), this.saveSessionUsers();
          }
        } catch (p) {
          console.error(
            `[SessionController] Failed to emit event or update user data for ${s}:`,
            p
          );
        }
      }
    }
    if (a || console.warn(
      `[SessionController] Target session ${s} not found among active sessions with email ${e}.`
    ), o.length !== 0) {
      for (const l of o)
        try {
          await this.walletKit.disconnectSession({
            topic: l,
            reason: { code: 4001, message: "User changed email address" }
          }), this.sessionUsers.delete(l);
        } catch (u) {
          console.error(`[SessionController] Failed to disconnect session ${l}:`, u), this.sessionUsers.has(l) && this.sessionUsers.delete(l);
        }
      this.saveSessionUsers();
    }
  }
}
class yY {
  constructor() {
    st(this, "state", "UNINITIALIZED");
    st(this, "stateListeners", /* @__PURE__ */ new Set());
  }
  getState() {
    return this.state;
  }
  subscribeState(e) {
    return this.stateListeners.add(e), e(this.state), () => {
      this.stateListeners.delete(e);
    };
  }
  setState(e) {
    this.state = e, this.stateListeners.forEach((r) => r(e));
  }
}
const gY = (t, e) => {
  var n, i;
  if (typeof window > "u") return;
  let r;
  if (t)
    r = (n = t.redirect) == null ? void 0 : n.native;
  else if (e) {
    const o = e.getActiveSessions();
    if (!o) return;
    const a = Object.keys(o)[0];
    if (!a) return;
    r = (i = o[a].peer.metadata.redirect) == null ? void 0 : i.native;
  }
  if (/iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent) && r) {
    document.addEventListener("visibilitychange", () => {
      document.visibilityState === "hidden" && window.close();
    }), window.location.assign(r);
    return;
  }
  window.close();
};
globalThis.Buffer = pw.Buffer;
const Br = class Br {
  constructor() {
    st(this, "walletKit");
    st(this, "appKit");
    st(this, "appKitWalletButton");
    st(this, "appKitUpdateEmail");
    // Controllers
    st(this, "stateController");
    st(this, "accountController");
    st(this, "namespaceController");
    st(this, "sessionController");
    this.stateController = new yY();
  }
  // --------------------- Initialization ---------------------
  static async getWallet(e) {
    if (Br.instance || (Br.instance = new Br()), !(e != null && e.wagmiConfig))
      throw new Error("WagmiConfig is required to initialize wallet");
    if (!e.appKitWalletButton)
      throw new Error("AppKit wallet button is required to initialize wallet");
    const r = Br.instance;
    if (!(e != null && e.appkit))
      throw new Error("AppKit is required to initialize wallet");
    return r.getState() === "UNINITIALIZED" && (Br.initPromise || (Br.initPromise = r.init(e)), await Br.initPromise), r;
  }
  // --------------------- State Management ---------------------
  getState() {
    return this.stateController.getState();
  }
  subscribeState(e) {
    return this.stateController.subscribeState(e);
  }
  // --------------------- Core Initialization ---------------------
  async init({
    appkit: e,
    appKitWalletButton: r,
    appKitUpdateEmail: s,
    redirectUrl: n,
    wagmiConfig: i
  }) {
    if (this.getState() !== "UNINITIALIZED")
      throw new Error("WebWalletCore already initialized");
    this.appKit = e, this.appKitWalletButton = r, this.appKitUpdateEmail = s, this.accountController = new WX(e, i), this.namespaceController = new JX(e);
    const o = e.options, a = new Z_({
      projectId: o.projectId,
      customStoragePrefix: "web-wallet"
    });
    this.walletKit = await dL.init({
      core: a,
      metadata: {
        name: "Reown Web Wallet",
        description: "Reown Web Wallet",
        url: "https://reown.com/",
        icons: ["https://avatars.githubusercontent.com/u/179229932"],
        ...n && {
          redirect: {
            native: n
          }
        }
      },
      signConfig: {
        disableRequestQueue: !0
      }
    }), this.sessionController = new bY(
      this.walletKit,
      this.namespaceController,
      () => this.accountController.getProvider(),
      this.appKit
    ), await this.ensureReady(), await this.accountController.waitForAccountStatus() === "connected" ? this.stateController.setState("READY") : this.stateController.setState("IDLE");
  }
  // --------------------- Provider & Account Management ---------------------
  async ensureReady() {
    var r;
    (r = this.appKit) != null && r.getState().loading && await new Promise((s) => {
      var n;
      (n = this.appKit) == null || n.subscribeState((i) => {
        i.loading || s();
      });
    });
    let e = this.accountController.getWagmiAccount();
    e.status === "disconnected" && (await this.accountController.reconnectWagmi(), e = this.accountController.getWagmiAccount()), (e.status === "connecting" || e.status === "reconnecting") && (await this.accountController.waitForAccountStatus(this.appKit) === "connected" && this.stateController.setState("READY"), e = this.accountController.getWagmiAccount()), this.getState() === "IDLE" && e.status === "connected" && this.stateController.setState("READY");
  }
  async openUpdateEmailModal(e) {
    var o, a, c;
    if (!this.appKitUpdateEmail)
      throw new Error("AppKit updateEmail is not set");
    ((c = (a = (o = this.appKit) == null ? void 0 : o.getAccount()) == null ? void 0 : a.embeddedWalletInfo) == null ? void 0 : c.authProvider) !== "email" && await this.login("email");
    const s = await this.getCurrentUser(), n = s == null ? void 0 : s.email, i = await this.appKitUpdateEmail();
    return n && this.sessionController && await this.sessionController.updateUserEmail(n, i.email, e), i;
  }
  // --------------------- Session Management ---------------------
  async prepareConnection({
    uri: e,
    loginProvider: r
  }) {
    if (this.getState() === "UNINITIALIZED")
      throw new Error("WebWalletCore not initialized");
    if (!this.walletKit) throw new Error("WalletKit not initialized");
    if (!this.sessionController) throw new Error("SessionController not initialized");
    try {
      const s = new Promise(
        (a, c) => {
          const l = setTimeout(() => {
            c(new Error("Timed out waiting for session proposal"));
          }, 3e4);
          this.walletKit.once("session_proposal", (u) => {
            clearTimeout(l), a(u);
          });
        }
      );
      try {
        await this.walletKit.pair({ uri: e });
      } catch (a) {
        throw new Error(
          `Failed to pair with WalletConnect: ${a instanceof Error ? a.message : String(a)}`
        );
      }
      const n = await s, i = async () => {
        var a, c, l, u;
        try {
          this.accountController.getWagmiAccount().status !== "connected" && await this.login(r);
          const p = await this.accountController.getProvider(), y = ((c = (a = n.params.optionalNamespaces) == null ? void 0 : a.eip155) == null ? void 0 : c.chains) || [], b = ((u = (l = n.params.requiredNamespaces) == null ? void 0 : l.eip155) == null ? void 0 : u.chains) || [], g = [.../* @__PURE__ */ new Set([...y, ...b])];
          await this.namespaceController.buildNamespaces(p, g);
          const x = this.namespaceController.getNamespaces();
          if (!x)
            throw new Error("Failed to build namespaces");
          const I = await this.sessionController.getCurrentUser();
          if (!I)
            throw new Error("Failed to get user info");
          if (I.loginProvider || (I.loginProvider = r), !this.sessionController || !this.walletKit)
            throw new Error("Session controller or wallet kit not initialized");
          const U = await this.walletKit.approveSession({
            id: n.id,
            namespaces: x,
            sessionProperties: {
              smartAccounts: JSON.stringify(this.namespaceController.getSmartAccounts()),
              ...this.sessionController.getSessionUserProperties(I)
            }
          });
          return this.sessionController.saveUserForSession(U.topic, I), U;
        } catch (h) {
          throw h;
        }
      }, o = async () => {
        await this.walletKit.rejectSession({
          id: n.id,
          reason: {
            code: 4001,
            message: "User rejected"
          }
        });
      };
      return {
        proposal: n,
        proposerMetadata: n.params.proposer.metadata,
        verifyContext: n.verifyContext,
        approve: i,
        reject: o
      };
    } catch (s) {
      throw s;
    }
  }
  async connect({ uri: e, loginProvider: r }) {
    if (this.getState() === "UNINITIALIZED")
      throw new Error("WebWalletCore not initialized");
    if (this.accountController.getWagmiAccount().status !== "connected" && await this.login(r), !this.sessionController) throw new Error("SessionController not initialized");
    return this.sessionController.connect({ uri: e, loginProvider: r });
  }
  async login(e) {
    if (!this.appKit) throw new Error("AppKit not initialized");
    try {
      if (await this.logout(), e && this.appKitWalletButton)
        try {
          await this.appKitWalletButton(e);
        } catch (r) {
          throw r;
        }
      else
        await this.appKit.open();
      await this.accountController.waitForAccountConnected(), this.stateController.setState("READY");
    } catch (r) {
      throw r;
    }
  }
  async logout() {
    if (!this.appKit) throw new Error("AppKit not initialized");
    await this.appKit.disconnect(), this.stateController.setState("IDLE");
  }
  // --------------------- Request Handling ---------------------
  async getPendingRequests() {
    if (!this.sessionController) throw new Error("SessionController not initialized");
    return this.sessionController.getPendingRequests();
  }
  async getCurrentUser() {
    if (!this.sessionController) throw new Error("SessionController not initialized");
    return this.sessionController.getCurrentUser();
  }
  async processRequest(e, r) {
    var s;
    if (!this.sessionController) throw new Error("SessionController not initialized");
    try {
      await this.accountController.ensureCorrectNetwork(e.params.chainId), await this.accountController.ensureCorrectAccount(e);
      const n = await this.accountController.getProvider(), i = GX(e), o = await n.request(i);
      await this.sessionController.respondToRequest(e, { result: o });
    } catch (n) {
      await this.sessionController.respondToRequest(e, { error: n });
    }
    if (r && typeof window < "u") {
      const n = (s = this.walletKit) == null ? void 0 : s.getActiveSessions();
      n && e.topic && gY(n[e.topic].peer.metadata, this.walletKit);
    }
  }
  subscribeToSessionRequests(e) {
    if (!this.sessionController) throw new Error("SessionController not initialized");
    if (!this.walletKit) throw new Error("WalletKit not initialized");
    const r = this.sessionController.subscribeToSessionRequests(e), s = this.walletKit.getPendingSessionRequests();
    if (s.length > 0) {
      const n = s[0], i = this.sessionController.getUserForSession(n.topic);
      i && e({ ...n, user: i });
    }
    return r;
  }
};
st(Br, "instance", null), st(Br, "initPromise", null);
let Rd = Br;
function eee(t, e) {
  const r = e.email ? t.email === e.email : t.username === e.username, s = t.loginProvider === e.loginProvider || t.loginProvider === "email" && (e.loginProvider === "google" || e.loginProvider === "x") && e.email === t.email;
  return r && s;
}
const tee = (t) => Rd.getWallet(t);
export {
  gy as H,
  mY as S,
  YY as a,
  Qc as b,
  Zo as c,
  ii as d,
  Yc as e,
  QY as f,
  tee as g,
  eee as i,
  eQ as r,
  sk as s,
  Xd as t
};
